function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefa41"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefa41"] = parcelRequire;
}
parcelRequire.register("iluxG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3jrMy"));

});
parcelRequire.register("3jrMy", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $2698b2681b5fd5ae$export$dca3b0875bd9a954; }, function (v) { return $2698b2681b5fd5ae$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $2698b2681b5fd5ae$export$16fa2f45be04daa8; }, function (v) { return $2698b2681b5fd5ae$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2698b2681b5fd5ae$export$ffb0004e005737fa; }, function (v) { return $2698b2681b5fd5ae$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $2698b2681b5fd5ae$export$e2c29f18771995cb; }, function (v) { return $2698b2681b5fd5ae$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $2698b2681b5fd5ae$export$221d75b3f55bb0bd; }, function (v) { return $2698b2681b5fd5ae$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2698b2681b5fd5ae$export$5f8d39834fd61797; }, function (v) { return $2698b2681b5fd5ae$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2698b2681b5fd5ae$export$74bf444e3cd11ea5; }, function (v) { return $2698b2681b5fd5ae$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $2698b2681b5fd5ae$export$ae55be85d98224ed; }, function (v) { return $2698b2681b5fd5ae$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $2698b2681b5fd5ae$export$e530037191fcd5d7; }, function (v) { return $2698b2681b5fd5ae$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $2698b2681b5fd5ae$export$fd42f52fd3ae1109; }, function (v) { return $2698b2681b5fd5ae$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $2698b2681b5fd5ae$export$c8a8987d4410bf2d; }, function (v) { return $2698b2681b5fd5ae$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $2698b2681b5fd5ae$export$d38cd72104c1f0e9; }, function (v) { return $2698b2681b5fd5ae$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $2698b2681b5fd5ae$export$7d1e3a5e95ceca43; }, function (v) { return $2698b2681b5fd5ae$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $2698b2681b5fd5ae$export$257a8862b851cb5b; }, function (v) { return $2698b2681b5fd5ae$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $2698b2681b5fd5ae$export$a8257692ac88316c; }, function (v) { return $2698b2681b5fd5ae$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $2698b2681b5fd5ae$export$488013bae63b21da; }, function (v) { return $2698b2681b5fd5ae$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $2698b2681b5fd5ae$export$7c73462e0d25e514; }, function (v) { return $2698b2681b5fd5ae$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $2698b2681b5fd5ae$export$35808ee640e87ca7; }, function (v) { return $2698b2681b5fd5ae$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $2698b2681b5fd5ae$export$fae74005e78b1a27; }, function (v) { return $2698b2681b5fd5ae$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $2698b2681b5fd5ae$export$dc8fbce3eb94dc1e; }, function (v) { return $2698b2681b5fd5ae$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $2698b2681b5fd5ae$export$6d9c69b0de29b591; }, function (v) { return $2698b2681b5fd5ae$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $2698b2681b5fd5ae$export$d5a552a76deda3c2; }, function (v) { return $2698b2681b5fd5ae$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $2698b2681b5fd5ae$export$e5c5a5f917a5871c; }, function (v) { return $2698b2681b5fd5ae$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $2698b2681b5fd5ae$export$1538c33de8887b59; }, function (v) { return $2698b2681b5fd5ae$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $2698b2681b5fd5ae$export$13e3392192263954; }, function (v) { return $2698b2681b5fd5ae$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $2698b2681b5fd5ae$export$b8f5890fc79d6aca; }, function (v) { return $2698b2681b5fd5ae$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $2698b2681b5fd5ae$export$60241385465d0a34; }, function (v) { return $2698b2681b5fd5ae$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $2698b2681b5fd5ae$export$83d89fbfd8236492; }, function (v) { return $2698b2681b5fd5ae$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2698b2681b5fd5ae$export$dca3b0875bd9a954;
var $2698b2681b5fd5ae$export$16fa2f45be04daa8;
var $2698b2681b5fd5ae$export$ffb0004e005737fa;
var $2698b2681b5fd5ae$export$e2c29f18771995cb;
var $2698b2681b5fd5ae$export$221d75b3f55bb0bd;
var $2698b2681b5fd5ae$export$5f8d39834fd61797;
var $2698b2681b5fd5ae$export$74bf444e3cd11ea5;
var $2698b2681b5fd5ae$export$ae55be85d98224ed;
var $2698b2681b5fd5ae$export$e530037191fcd5d7;
var $2698b2681b5fd5ae$export$fd42f52fd3ae1109;
var $2698b2681b5fd5ae$export$c8a8987d4410bf2d;
var $2698b2681b5fd5ae$export$d38cd72104c1f0e9;
var $2698b2681b5fd5ae$export$7d1e3a5e95ceca43;
var $2698b2681b5fd5ae$export$257a8862b851cb5b;
var $2698b2681b5fd5ae$export$a8257692ac88316c;
var $2698b2681b5fd5ae$export$488013bae63b21da;
var $2698b2681b5fd5ae$export$7c73462e0d25e514;
var $2698b2681b5fd5ae$export$35808ee640e87ca7;
var $2698b2681b5fd5ae$export$fae74005e78b1a27;
var $2698b2681b5fd5ae$export$dc8fbce3eb94dc1e;
var $2698b2681b5fd5ae$export$6d9c69b0de29b591;
var $2698b2681b5fd5ae$export$d5a552a76deda3c2;
var $2698b2681b5fd5ae$export$e5c5a5f917a5871c;
var $2698b2681b5fd5ae$export$1538c33de8887b59;
var $2698b2681b5fd5ae$export$13e3392192263954;
var $2698b2681b5fd5ae$export$b8f5890fc79d6aca;
var $2698b2681b5fd5ae$export$60241385465d0a34;
var $2698b2681b5fd5ae$export$83d89fbfd8236492;
"use strict";

var $dY3rW = parcelRequire("dY3rW");
var $2698b2681b5fd5ae$var$n = "function" === typeof Symbol && Symbol.for, $2698b2681b5fd5ae$var$p = $2698b2681b5fd5ae$var$n ? Symbol.for("react.element") : 60103, $2698b2681b5fd5ae$var$q = $2698b2681b5fd5ae$var$n ? Symbol.for("react.portal") : 60106, $2698b2681b5fd5ae$var$r = $2698b2681b5fd5ae$var$n ? Symbol.for("react.fragment") : 60107, $2698b2681b5fd5ae$var$t = $2698b2681b5fd5ae$var$n ? Symbol.for("react.strict_mode") : 60108, $2698b2681b5fd5ae$var$u = $2698b2681b5fd5ae$var$n ? Symbol.for("react.profiler") : 60114, $2698b2681b5fd5ae$var$v = $2698b2681b5fd5ae$var$n ? Symbol.for("react.provider") : 60109, $2698b2681b5fd5ae$var$w = $2698b2681b5fd5ae$var$n ? Symbol.for("react.context") : 60110, $2698b2681b5fd5ae$var$x = $2698b2681b5fd5ae$var$n ? Symbol.for("react.forward_ref") : 60112, $2698b2681b5fd5ae$var$y = $2698b2681b5fd5ae$var$n ? Symbol.for("react.suspense") : 60113, $2698b2681b5fd5ae$var$z = $2698b2681b5fd5ae$var$n ? Symbol.for("react.memo") : 60115, $2698b2681b5fd5ae$var$A = $2698b2681b5fd5ae$var$n ? Symbol.for("react.lazy") : 60116, $2698b2681b5fd5ae$var$B = "function" === typeof Symbol && Symbol.iterator;
function $2698b2681b5fd5ae$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $2698b2681b5fd5ae$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2698b2681b5fd5ae$var$E = {};
function $2698b2681b5fd5ae$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $2698b2681b5fd5ae$var$E;
    this.updater = c || $2698b2681b5fd5ae$var$D;
}
$2698b2681b5fd5ae$var$F.prototype.isReactComponent = {};
$2698b2681b5fd5ae$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($2698b2681b5fd5ae$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$2698b2681b5fd5ae$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $2698b2681b5fd5ae$var$G() {}
$2698b2681b5fd5ae$var$G.prototype = $2698b2681b5fd5ae$var$F.prototype;
function $2698b2681b5fd5ae$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $2698b2681b5fd5ae$var$E;
    this.updater = c || $2698b2681b5fd5ae$var$D;
}
var $2698b2681b5fd5ae$var$I = $2698b2681b5fd5ae$var$H.prototype = new $2698b2681b5fd5ae$var$G;
$2698b2681b5fd5ae$var$I.constructor = $2698b2681b5fd5ae$var$H;
$dY3rW($2698b2681b5fd5ae$var$I, $2698b2681b5fd5ae$var$F.prototype);
$2698b2681b5fd5ae$var$I.isPureReactComponent = !0;
var $2698b2681b5fd5ae$var$J = {
    current: null
}, $2698b2681b5fd5ae$var$K = Object.prototype.hasOwnProperty, $2698b2681b5fd5ae$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2698b2681b5fd5ae$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$2698b2681b5fd5ae$var$K.call(b, e) && !$2698b2681b5fd5ae$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $2698b2681b5fd5ae$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $2698b2681b5fd5ae$var$J.current
    };
}
function $2698b2681b5fd5ae$var$N(a, b) {
    return {
        $$typeof: $2698b2681b5fd5ae$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $2698b2681b5fd5ae$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2698b2681b5fd5ae$var$p;
}
function $2698b2681b5fd5ae$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $2698b2681b5fd5ae$var$P = /\/+/g, $2698b2681b5fd5ae$var$Q = [];
function $2698b2681b5fd5ae$var$R(a, b, c, e) {
    if ($2698b2681b5fd5ae$var$Q.length) {
        var d = $2698b2681b5fd5ae$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $2698b2681b5fd5ae$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $2698b2681b5fd5ae$var$Q.length && $2698b2681b5fd5ae$var$Q.push(a);
}
function $2698b2681b5fd5ae$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $2698b2681b5fd5ae$var$p:
                case $2698b2681b5fd5ae$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $2698b2681b5fd5ae$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $2698b2681b5fd5ae$var$U(d, k);
        g += $2698b2681b5fd5ae$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $2698b2681b5fd5ae$var$B && a[$2698b2681b5fd5ae$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $2698b2681b5fd5ae$var$U(d, k++), g += $2698b2681b5fd5ae$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($2698b2681b5fd5ae$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $2698b2681b5fd5ae$var$V(a, b, c) {
    return null == a ? 0 : $2698b2681b5fd5ae$var$T(a, "", b, c);
}
function $2698b2681b5fd5ae$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $2698b2681b5fd5ae$var$escape(a.key) : b.toString(36);
}
function $2698b2681b5fd5ae$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $2698b2681b5fd5ae$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $2698b2681b5fd5ae$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($2698b2681b5fd5ae$var$O(a) && (a = $2698b2681b5fd5ae$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($2698b2681b5fd5ae$var$P, "$&/") + "/") + c)), e.push(a));
}
function $2698b2681b5fd5ae$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($2698b2681b5fd5ae$var$P, "$&/") + "/");
    b = $2698b2681b5fd5ae$var$R(b, g, e, d);
    $2698b2681b5fd5ae$var$V(a, $2698b2681b5fd5ae$var$aa, b);
    $2698b2681b5fd5ae$var$S(b);
}
var $2698b2681b5fd5ae$var$Y = {
    current: null
};
function $2698b2681b5fd5ae$var$Z() {
    var a = $2698b2681b5fd5ae$var$Y.current;
    if (null === a) throw Error($2698b2681b5fd5ae$var$C(321));
    return a;
}
var $2698b2681b5fd5ae$var$ba = {
    ReactCurrentDispatcher: $2698b2681b5fd5ae$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $2698b2681b5fd5ae$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $dY3rW
};
$2698b2681b5fd5ae$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $2698b2681b5fd5ae$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $2698b2681b5fd5ae$var$R(null, null, b, c);
        $2698b2681b5fd5ae$var$V(a, $2698b2681b5fd5ae$var$W, b);
        $2698b2681b5fd5ae$var$S(b);
    },
    count: function(a) {
        return $2698b2681b5fd5ae$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $2698b2681b5fd5ae$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$2698b2681b5fd5ae$var$O(a)) throw Error($2698b2681b5fd5ae$var$C(143));
        return a;
    }
};
$2698b2681b5fd5ae$export$16fa2f45be04daa8 = $2698b2681b5fd5ae$var$F;
$2698b2681b5fd5ae$export$ffb0004e005737fa = $2698b2681b5fd5ae$var$r;
$2698b2681b5fd5ae$export$e2c29f18771995cb = $2698b2681b5fd5ae$var$u;
$2698b2681b5fd5ae$export$221d75b3f55bb0bd = $2698b2681b5fd5ae$var$H;
$2698b2681b5fd5ae$export$5f8d39834fd61797 = $2698b2681b5fd5ae$var$t;
$2698b2681b5fd5ae$export$74bf444e3cd11ea5 = $2698b2681b5fd5ae$var$y;
$2698b2681b5fd5ae$export$ae55be85d98224ed = $2698b2681b5fd5ae$var$ba;
$2698b2681b5fd5ae$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($2698b2681b5fd5ae$var$C(267, a));
    var e = $dY3rW({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $2698b2681b5fd5ae$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$2698b2681b5fd5ae$var$K.call(b, h) && !$2698b2681b5fd5ae$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $2698b2681b5fd5ae$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$2698b2681b5fd5ae$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $2698b2681b5fd5ae$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $2698b2681b5fd5ae$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$2698b2681b5fd5ae$export$c8a8987d4410bf2d = $2698b2681b5fd5ae$var$M;
$2698b2681b5fd5ae$export$d38cd72104c1f0e9 = function(a) {
    var b = $2698b2681b5fd5ae$var$M.bind(null, a);
    b.type = a;
    return b;
};
$2698b2681b5fd5ae$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2698b2681b5fd5ae$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $2698b2681b5fd5ae$var$x,
        render: a
    };
};
$2698b2681b5fd5ae$export$a8257692ac88316c = $2698b2681b5fd5ae$var$O;
$2698b2681b5fd5ae$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $2698b2681b5fd5ae$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$2698b2681b5fd5ae$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $2698b2681b5fd5ae$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$2698b2681b5fd5ae$export$35808ee640e87ca7 = function(a, b) {
    return $2698b2681b5fd5ae$var$Z().useCallback(a, b);
};
$2698b2681b5fd5ae$export$fae74005e78b1a27 = function(a, b) {
    return $2698b2681b5fd5ae$var$Z().useContext(a, b);
};
$2698b2681b5fd5ae$export$dc8fbce3eb94dc1e = function() {};
$2698b2681b5fd5ae$export$6d9c69b0de29b591 = function(a, b) {
    return $2698b2681b5fd5ae$var$Z().useEffect(a, b);
};
$2698b2681b5fd5ae$export$d5a552a76deda3c2 = function(a, b, c) {
    return $2698b2681b5fd5ae$var$Z().useImperativeHandle(a, b, c);
};
$2698b2681b5fd5ae$export$e5c5a5f917a5871c = function(a, b) {
    return $2698b2681b5fd5ae$var$Z().useLayoutEffect(a, b);
};
$2698b2681b5fd5ae$export$1538c33de8887b59 = function(a, b) {
    return $2698b2681b5fd5ae$var$Z().useMemo(a, b);
};
$2698b2681b5fd5ae$export$13e3392192263954 = function(a, b, c) {
    return $2698b2681b5fd5ae$var$Z().useReducer(a, b, c);
};
$2698b2681b5fd5ae$export$b8f5890fc79d6aca = function(a) {
    return $2698b2681b5fd5ae$var$Z().useRef(a);
};
$2698b2681b5fd5ae$export$60241385465d0a34 = function(a) {
    return $2698b2681b5fd5ae$var$Z().useState(a);
};
$2698b2681b5fd5ae$export$83d89fbfd8236492 = "16.13.1";

});
parcelRequire.register("dY3rW", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $a2b38e040a83ff02$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $a2b38e040a83ff02$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $a2b38e040a83ff02$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $a2b38e040a83ff02$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $a2b38e040a83ff02$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $a2b38e040a83ff02$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $a2b38e040a83ff02$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($a2b38e040a83ff02$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($a2b38e040a83ff02$var$getOwnPropertySymbols) {
            symbols = $a2b38e040a83ff02$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($a2b38e040a83ff02$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("7W6LZ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5c73342f5ab2cfdc$export$ae55be85d98224ed; }, function (v) { return $5c73342f5ab2cfdc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5c73342f5ab2cfdc$export$d39a5bbd09211389; }, function (v) { return $5c73342f5ab2cfdc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5c73342f5ab2cfdc$export$466bfc07425424d5; }, function (v) { return $5c73342f5ab2cfdc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5c73342f5ab2cfdc$export$cd75ccfd720a3cd4; }, function (v) { return $5c73342f5ab2cfdc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5c73342f5ab2cfdc$export$fa8d919ba61d84db; }, function (v) { return $5c73342f5ab2cfdc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $5c73342f5ab2cfdc$export$b3890eb0ae9dca99; }, function (v) { return $5c73342f5ab2cfdc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5c73342f5ab2cfdc$export$502457920280e6be; }, function (v) { return $5c73342f5ab2cfdc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5c73342f5ab2cfdc$export$c78a37762a8d58e1; }, function (v) { return $5c73342f5ab2cfdc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $5c73342f5ab2cfdc$export$2577ef5d2565d52f; }, function (v) { return $5c73342f5ab2cfdc$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5c73342f5ab2cfdc$export$dc54d992c10e8a18; }, function (v) { return $5c73342f5ab2cfdc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5c73342f5ab2cfdc$export$83d89fbfd8236492; }, function (v) { return $5c73342f5ab2cfdc$export$83d89fbfd8236492 = v; });
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5c73342f5ab2cfdc$export$ae55be85d98224ed;
var $5c73342f5ab2cfdc$export$d39a5bbd09211389;
var $5c73342f5ab2cfdc$export$466bfc07425424d5;
var $5c73342f5ab2cfdc$export$cd75ccfd720a3cd4;
var $5c73342f5ab2cfdc$export$fa8d919ba61d84db;
var $5c73342f5ab2cfdc$export$b3890eb0ae9dca99;
var $5c73342f5ab2cfdc$export$502457920280e6be;
var $5c73342f5ab2cfdc$export$c78a37762a8d58e1;
var $5c73342f5ab2cfdc$export$2577ef5d2565d52f;
var $5c73342f5ab2cfdc$export$dc54d992c10e8a18;
var $5c73342f5ab2cfdc$export$83d89fbfd8236492;
"use strict";

var $iluxG = parcelRequire("iluxG");

var $dY3rW = parcelRequire("dY3rW");

var $ayULB = parcelRequire("ayULB");
function $5c73342f5ab2cfdc$var$u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$iluxG) throw Error($5c73342f5ab2cfdc$var$u(227));
function $5c73342f5ab2cfdc$var$ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5c73342f5ab2cfdc$var$da = !1, $5c73342f5ab2cfdc$var$ea = null, $5c73342f5ab2cfdc$var$fa = !1, $5c73342f5ab2cfdc$var$ha = null, $5c73342f5ab2cfdc$var$ia = {
    onError: function(a) {
        $5c73342f5ab2cfdc$var$da = !0;
        $5c73342f5ab2cfdc$var$ea = a;
    }
};
function $5c73342f5ab2cfdc$var$ja(a, b, c, d, e, f, g, h, k) {
    $5c73342f5ab2cfdc$var$da = !1;
    $5c73342f5ab2cfdc$var$ea = null;
    $5c73342f5ab2cfdc$var$ba.apply($5c73342f5ab2cfdc$var$ia, arguments);
}
function $5c73342f5ab2cfdc$var$ka(a, b, c, d, e, f, g, h, k) {
    $5c73342f5ab2cfdc$var$ja.apply(this, arguments);
    if ($5c73342f5ab2cfdc$var$da) {
        if ($5c73342f5ab2cfdc$var$da) {
            var l = $5c73342f5ab2cfdc$var$ea;
            $5c73342f5ab2cfdc$var$da = !1;
            $5c73342f5ab2cfdc$var$ea = null;
        } else throw Error($5c73342f5ab2cfdc$var$u(198));
        $5c73342f5ab2cfdc$var$fa || ($5c73342f5ab2cfdc$var$fa = !0, $5c73342f5ab2cfdc$var$ha = l);
    }
}
var $5c73342f5ab2cfdc$var$la = null, $5c73342f5ab2cfdc$var$ma = null, $5c73342f5ab2cfdc$var$na = null;
function $5c73342f5ab2cfdc$var$oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $5c73342f5ab2cfdc$var$na(c);
    $5c73342f5ab2cfdc$var$ka(d, b, void 0, a);
    a.currentTarget = null;
}
var $5c73342f5ab2cfdc$var$pa = null, $5c73342f5ab2cfdc$var$qa = {};
function $5c73342f5ab2cfdc$var$ra() {
    if ($5c73342f5ab2cfdc$var$pa) for(var a in $5c73342f5ab2cfdc$var$qa){
        var b = $5c73342f5ab2cfdc$var$qa[a], c = $5c73342f5ab2cfdc$var$pa.indexOf(a);
        if (!(-1 < c)) throw Error($5c73342f5ab2cfdc$var$u(96, a));
        if (!$5c73342f5ab2cfdc$var$sa[c]) {
            if (!b.extractEvents) throw Error($5c73342f5ab2cfdc$var$u(97, a));
            $5c73342f5ab2cfdc$var$sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if ($5c73342f5ab2cfdc$var$ta.hasOwnProperty(h)) throw Error($5c73342f5ab2cfdc$var$u(99, h));
                $5c73342f5ab2cfdc$var$ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $5c73342f5ab2cfdc$var$ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? ($5c73342f5ab2cfdc$var$ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error($5c73342f5ab2cfdc$var$u(98, d, a));
            }
        }
    }
}
function $5c73342f5ab2cfdc$var$ua(a, b, c) {
    if ($5c73342f5ab2cfdc$var$va[a]) throw Error($5c73342f5ab2cfdc$var$u(100, a));
    $5c73342f5ab2cfdc$var$va[a] = b;
    $5c73342f5ab2cfdc$var$wa[a] = b.eventTypes[c].dependencies;
}
var $5c73342f5ab2cfdc$var$sa = [], $5c73342f5ab2cfdc$var$ta = {}, $5c73342f5ab2cfdc$var$va = {}, $5c73342f5ab2cfdc$var$wa = {};
function $5c73342f5ab2cfdc$var$xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!$5c73342f5ab2cfdc$var$qa.hasOwnProperty(c) || $5c73342f5ab2cfdc$var$qa[c] !== d) {
            if ($5c73342f5ab2cfdc$var$qa[c]) throw Error($5c73342f5ab2cfdc$var$u(102, c));
            $5c73342f5ab2cfdc$var$qa[c] = d;
            b = !0;
        }
    }
    b && $5c73342f5ab2cfdc$var$ra();
}
var $5c73342f5ab2cfdc$var$ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5c73342f5ab2cfdc$var$za = null, $5c73342f5ab2cfdc$var$Aa = null, $5c73342f5ab2cfdc$var$Ba = null;
function $5c73342f5ab2cfdc$var$Ca(a) {
    if (a = $5c73342f5ab2cfdc$var$ma(a)) {
        if ("function" !== typeof $5c73342f5ab2cfdc$var$za) throw Error($5c73342f5ab2cfdc$var$u(280));
        var b = a.stateNode;
        b && (b = $5c73342f5ab2cfdc$var$la(b), $5c73342f5ab2cfdc$var$za(a.stateNode, a.type, b));
    }
}
function $5c73342f5ab2cfdc$var$Da(a) {
    $5c73342f5ab2cfdc$var$Aa ? $5c73342f5ab2cfdc$var$Ba ? $5c73342f5ab2cfdc$var$Ba.push(a) : $5c73342f5ab2cfdc$var$Ba = [
        a
    ] : $5c73342f5ab2cfdc$var$Aa = a;
}
function $5c73342f5ab2cfdc$var$Ea() {
    if ($5c73342f5ab2cfdc$var$Aa) {
        var a = $5c73342f5ab2cfdc$var$Aa, b = $5c73342f5ab2cfdc$var$Ba;
        $5c73342f5ab2cfdc$var$Ba = $5c73342f5ab2cfdc$var$Aa = null;
        $5c73342f5ab2cfdc$var$Ca(a);
        if (b) for(a = 0; a < b.length; a++)$5c73342f5ab2cfdc$var$Ca(b[a]);
    }
}
function $5c73342f5ab2cfdc$var$Fa(a, b) {
    return a(b);
}
function $5c73342f5ab2cfdc$var$Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $5c73342f5ab2cfdc$var$Ha() {}
var $5c73342f5ab2cfdc$var$Ia = $5c73342f5ab2cfdc$var$Fa, $5c73342f5ab2cfdc$var$Ja = !1, $5c73342f5ab2cfdc$var$Ka = !1;
function $5c73342f5ab2cfdc$var$La() {
    if (null !== $5c73342f5ab2cfdc$var$Aa || null !== $5c73342f5ab2cfdc$var$Ba) $5c73342f5ab2cfdc$var$Ha(), $5c73342f5ab2cfdc$var$Ea();
}
function $5c73342f5ab2cfdc$var$Ma(a, b, c) {
    if ($5c73342f5ab2cfdc$var$Ka) return a(b, c);
    $5c73342f5ab2cfdc$var$Ka = !0;
    try {
        return $5c73342f5ab2cfdc$var$Ia(a, b, c);
    } finally{
        $5c73342f5ab2cfdc$var$Ka = !1, $5c73342f5ab2cfdc$var$La();
    }
}
var $5c73342f5ab2cfdc$var$Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5c73342f5ab2cfdc$var$Oa = Object.prototype.hasOwnProperty, $5c73342f5ab2cfdc$var$Pa = {}, $5c73342f5ab2cfdc$var$Qa = {};
function $5c73342f5ab2cfdc$var$Ra(a) {
    if ($5c73342f5ab2cfdc$var$Oa.call($5c73342f5ab2cfdc$var$Qa, a)) return !0;
    if ($5c73342f5ab2cfdc$var$Oa.call($5c73342f5ab2cfdc$var$Pa, a)) return !1;
    if ($5c73342f5ab2cfdc$var$Na.test(a)) return $5c73342f5ab2cfdc$var$Qa[a] = !0;
    $5c73342f5ab2cfdc$var$Pa[a] = !0;
    return !1;
}
function $5c73342f5ab2cfdc$var$Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5c73342f5ab2cfdc$var$Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5c73342f5ab2cfdc$var$Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5c73342f5ab2cfdc$var$v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $5c73342f5ab2cfdc$var$C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5c73342f5ab2cfdc$var$C[b] = new $5c73342f5ab2cfdc$var$v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 5, !1, a.toLowerCase(), null, !1);
});
var $5c73342f5ab2cfdc$var$Ua = /[\-:]([a-z])/g;
function $5c73342f5ab2cfdc$var$Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5c73342f5ab2cfdc$var$Ua, $5c73342f5ab2cfdc$var$Va);
    $5c73342f5ab2cfdc$var$C[b] = new $5c73342f5ab2cfdc$var$v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5c73342f5ab2cfdc$var$Ua, $5c73342f5ab2cfdc$var$Va);
    $5c73342f5ab2cfdc$var$C[b] = new $5c73342f5ab2cfdc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5c73342f5ab2cfdc$var$Ua, $5c73342f5ab2cfdc$var$Va);
    $5c73342f5ab2cfdc$var$C[b] = new $5c73342f5ab2cfdc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 1, !1, a.toLowerCase(), null, !1);
});
$5c73342f5ab2cfdc$var$C.xlinkHref = new $5c73342f5ab2cfdc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5c73342f5ab2cfdc$var$C[a] = new $5c73342f5ab2cfdc$var$v(a, 1, !1, a.toLowerCase(), null, !0);
});
var $5c73342f5ab2cfdc$var$Wa = $iluxG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$5c73342f5ab2cfdc$var$Wa.hasOwnProperty("ReactCurrentDispatcher") || ($5c73342f5ab2cfdc$var$Wa.ReactCurrentDispatcher = {
    current: null
});
$5c73342f5ab2cfdc$var$Wa.hasOwnProperty("ReactCurrentBatchConfig") || ($5c73342f5ab2cfdc$var$Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function $5c73342f5ab2cfdc$var$Xa(a, b, c, d) {
    var e = $5c73342f5ab2cfdc$var$C.hasOwnProperty(b) ? $5c73342f5ab2cfdc$var$C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($5c73342f5ab2cfdc$var$Ta(b, c, e, d) && (c = null), d || null === e ? $5c73342f5ab2cfdc$var$Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $5c73342f5ab2cfdc$var$Ya = /^(.*)[\\\/]/, $5c73342f5ab2cfdc$var$E = "function" === typeof Symbol && Symbol.for, $5c73342f5ab2cfdc$var$Za = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.element") : 60103, $5c73342f5ab2cfdc$var$$a = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.portal") : 60106, $5c73342f5ab2cfdc$var$ab = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.fragment") : 60107, $5c73342f5ab2cfdc$var$bb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.strict_mode") : 60108, $5c73342f5ab2cfdc$var$cb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.profiler") : 60114, $5c73342f5ab2cfdc$var$db = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.provider") : 60109, $5c73342f5ab2cfdc$var$eb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.context") : 60110, $5c73342f5ab2cfdc$var$fb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.concurrent_mode") : 60111, $5c73342f5ab2cfdc$var$gb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.forward_ref") : 60112, $5c73342f5ab2cfdc$var$hb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.suspense") : 60113, $5c73342f5ab2cfdc$var$ib = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.suspense_list") : 60120, $5c73342f5ab2cfdc$var$jb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.memo") : 60115, $5c73342f5ab2cfdc$var$kb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.lazy") : 60116, $5c73342f5ab2cfdc$var$lb = $5c73342f5ab2cfdc$var$E ? Symbol.for("react.block") : 60121, $5c73342f5ab2cfdc$var$mb = "function" === typeof Symbol && Symbol.iterator;
function $5c73342f5ab2cfdc$var$nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5c73342f5ab2cfdc$var$mb && a[$5c73342f5ab2cfdc$var$mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $5c73342f5ab2cfdc$var$ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function $5c73342f5ab2cfdc$var$pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5c73342f5ab2cfdc$var$ab:
            return "Fragment";
        case $5c73342f5ab2cfdc$var$$a:
            return "Portal";
        case $5c73342f5ab2cfdc$var$cb:
            return "Profiler";
        case $5c73342f5ab2cfdc$var$bb:
            return "StrictMode";
        case $5c73342f5ab2cfdc$var$hb:
            return "Suspense";
        case $5c73342f5ab2cfdc$var$ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5c73342f5ab2cfdc$var$eb:
            return "Context.Consumer";
        case $5c73342f5ab2cfdc$var$db:
            return "Context.Provider";
        case $5c73342f5ab2cfdc$var$gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $5c73342f5ab2cfdc$var$jb:
            return $5c73342f5ab2cfdc$var$pb(a.type);
        case $5c73342f5ab2cfdc$var$lb:
            return $5c73342f5ab2cfdc$var$pb(a.render);
        case $5c73342f5ab2cfdc$var$kb:
            if (a = 1 === a._status ? a._result : null) return $5c73342f5ab2cfdc$var$pb(a);
    }
    return null;
}
function $5c73342f5ab2cfdc$var$qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $5c73342f5ab2cfdc$var$pb(a.type);
                c = null;
                d && (c = $5c73342f5ab2cfdc$var$pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($5c73342f5ab2cfdc$var$Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function $5c73342f5ab2cfdc$var$rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $5c73342f5ab2cfdc$var$sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5c73342f5ab2cfdc$var$tb(a) {
    var b = $5c73342f5ab2cfdc$var$sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5c73342f5ab2cfdc$var$xb(a) {
    a._valueTracker || (a._valueTracker = $5c73342f5ab2cfdc$var$tb(a));
}
function $5c73342f5ab2cfdc$var$yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5c73342f5ab2cfdc$var$sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5c73342f5ab2cfdc$var$zb(a, b) {
    var c = b.checked;
    return $dY3rW({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5c73342f5ab2cfdc$var$Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5c73342f5ab2cfdc$var$rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5c73342f5ab2cfdc$var$Bb(a, b) {
    b = b.checked;
    null != b && $5c73342f5ab2cfdc$var$Xa(a, "checked", b, !1);
}
function $5c73342f5ab2cfdc$var$Cb(a, b) {
    $5c73342f5ab2cfdc$var$Bb(a, b);
    var c = $5c73342f5ab2cfdc$var$rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5c73342f5ab2cfdc$var$Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5c73342f5ab2cfdc$var$Db(a, b.type, $5c73342f5ab2cfdc$var$rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5c73342f5ab2cfdc$var$Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5c73342f5ab2cfdc$var$Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $5c73342f5ab2cfdc$var$Fb(a) {
    var b = "";
    $iluxG.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $5c73342f5ab2cfdc$var$Gb(a, b) {
    a = $dY3rW({
        children: void 0
    }, b);
    if (b = $5c73342f5ab2cfdc$var$Fb(b.children)) a.children = b;
    return a;
}
function $5c73342f5ab2cfdc$var$Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5c73342f5ab2cfdc$var$rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5c73342f5ab2cfdc$var$Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5c73342f5ab2cfdc$var$u(91));
    return $dY3rW({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5c73342f5ab2cfdc$var$Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5c73342f5ab2cfdc$var$u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($5c73342f5ab2cfdc$var$u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5c73342f5ab2cfdc$var$rb(c)
    };
}
function $5c73342f5ab2cfdc$var$Kb(a, b) {
    var c = $5c73342f5ab2cfdc$var$rb(b.value), d = $5c73342f5ab2cfdc$var$rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5c73342f5ab2cfdc$var$Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $5c73342f5ab2cfdc$var$Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $5c73342f5ab2cfdc$var$Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5c73342f5ab2cfdc$var$Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5c73342f5ab2cfdc$var$Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5c73342f5ab2cfdc$var$Pb, $5c73342f5ab2cfdc$var$Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $5c73342f5ab2cfdc$var$Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $5c73342f5ab2cfdc$var$Pb = $5c73342f5ab2cfdc$var$Pb || document.createElement("div");
        $5c73342f5ab2cfdc$var$Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5c73342f5ab2cfdc$var$Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5c73342f5ab2cfdc$var$Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function $5c73342f5ab2cfdc$var$Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5c73342f5ab2cfdc$var$Tb = {
    animationend: $5c73342f5ab2cfdc$var$Sb("Animation", "AnimationEnd"),
    animationiteration: $5c73342f5ab2cfdc$var$Sb("Animation", "AnimationIteration"),
    animationstart: $5c73342f5ab2cfdc$var$Sb("Animation", "AnimationStart"),
    transitionend: $5c73342f5ab2cfdc$var$Sb("Transition", "TransitionEnd")
}, $5c73342f5ab2cfdc$var$Ub = {}, $5c73342f5ab2cfdc$var$Vb = {};
$5c73342f5ab2cfdc$var$ya && ($5c73342f5ab2cfdc$var$Vb = document.createElement("div").style, "AnimationEvent" in window || (delete $5c73342f5ab2cfdc$var$Tb.animationend.animation, delete $5c73342f5ab2cfdc$var$Tb.animationiteration.animation, delete $5c73342f5ab2cfdc$var$Tb.animationstart.animation), "TransitionEvent" in window || delete $5c73342f5ab2cfdc$var$Tb.transitionend.transition);
function $5c73342f5ab2cfdc$var$Wb(a) {
    if ($5c73342f5ab2cfdc$var$Ub[a]) return $5c73342f5ab2cfdc$var$Ub[a];
    if (!$5c73342f5ab2cfdc$var$Tb[a]) return a;
    var b = $5c73342f5ab2cfdc$var$Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5c73342f5ab2cfdc$var$Vb) return $5c73342f5ab2cfdc$var$Ub[a] = b[c];
    return a;
}
var $5c73342f5ab2cfdc$var$Xb = $5c73342f5ab2cfdc$var$Wb("animationend"), $5c73342f5ab2cfdc$var$Yb = $5c73342f5ab2cfdc$var$Wb("animationiteration"), $5c73342f5ab2cfdc$var$Zb = $5c73342f5ab2cfdc$var$Wb("animationstart"), $5c73342f5ab2cfdc$var$$b = $5c73342f5ab2cfdc$var$Wb("transitionend"), $5c73342f5ab2cfdc$var$ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5c73342f5ab2cfdc$var$bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function $5c73342f5ab2cfdc$var$cc(a) {
    var b = $5c73342f5ab2cfdc$var$bc.get(a);
    void 0 === b && (b = new Map, $5c73342f5ab2cfdc$var$bc.set(a, b));
    return b;
}
function $5c73342f5ab2cfdc$var$dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5c73342f5ab2cfdc$var$ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5c73342f5ab2cfdc$var$fc(a) {
    if ($5c73342f5ab2cfdc$var$dc(a) !== a) throw Error($5c73342f5ab2cfdc$var$u(188));
}
function $5c73342f5ab2cfdc$var$gc(a) {
    var b = a.alternate;
    if (!b) {
        b = $5c73342f5ab2cfdc$var$dc(a);
        if (null === b) throw Error($5c73342f5ab2cfdc$var$u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5c73342f5ab2cfdc$var$fc(e), a;
                if (f === d) return $5c73342f5ab2cfdc$var$fc(e), b;
                f = f.sibling;
            }
            throw Error($5c73342f5ab2cfdc$var$u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5c73342f5ab2cfdc$var$u(189));
            }
        }
        if (c.alternate !== d) throw Error($5c73342f5ab2cfdc$var$u(190));
    }
    if (3 !== c.tag) throw Error($5c73342f5ab2cfdc$var$u(188));
    return c.stateNode.current === c ? a : b;
}
function $5c73342f5ab2cfdc$var$hc(a) {
    a = $5c73342f5ab2cfdc$var$gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $5c73342f5ab2cfdc$var$ic(a, b) {
    if (null == b) throw Error($5c73342f5ab2cfdc$var$u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $5c73342f5ab2cfdc$var$jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $5c73342f5ab2cfdc$var$kc = null;
function $5c73342f5ab2cfdc$var$lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$5c73342f5ab2cfdc$var$oa(a, b[d], c[d]);
        else b && $5c73342f5ab2cfdc$var$oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $5c73342f5ab2cfdc$var$mc(a) {
    null !== a && ($5c73342f5ab2cfdc$var$kc = $5c73342f5ab2cfdc$var$ic($5c73342f5ab2cfdc$var$kc, a));
    a = $5c73342f5ab2cfdc$var$kc;
    $5c73342f5ab2cfdc$var$kc = null;
    if (a) {
        $5c73342f5ab2cfdc$var$jc(a, $5c73342f5ab2cfdc$var$lc);
        if ($5c73342f5ab2cfdc$var$kc) throw Error($5c73342f5ab2cfdc$var$u(95));
        if ($5c73342f5ab2cfdc$var$fa) throw a = $5c73342f5ab2cfdc$var$ha, $5c73342f5ab2cfdc$var$fa = !1, $5c73342f5ab2cfdc$var$ha = null, a;
    }
}
function $5c73342f5ab2cfdc$var$nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $5c73342f5ab2cfdc$var$oc(a) {
    if (!$5c73342f5ab2cfdc$var$ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var $5c73342f5ab2cfdc$var$pc = [];
function $5c73342f5ab2cfdc$var$qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > $5c73342f5ab2cfdc$var$pc.length && $5c73342f5ab2cfdc$var$pc.push(a);
}
function $5c73342f5ab2cfdc$var$rc(a, b, c, d) {
    if ($5c73342f5ab2cfdc$var$pc.length) {
        var e = $5c73342f5ab2cfdc$var$pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function $5c73342f5ab2cfdc$var$sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = $5c73342f5ab2cfdc$var$tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $5c73342f5ab2cfdc$var$nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < $5c73342f5ab2cfdc$var$sa.length; k++){
            var l = $5c73342f5ab2cfdc$var$sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = $5c73342f5ab2cfdc$var$ic(h, l));
        }
        $5c73342f5ab2cfdc$var$mc(h);
    }
}
function $5c73342f5ab2cfdc$var$uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                $5c73342f5ab2cfdc$var$vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                $5c73342f5ab2cfdc$var$vc(b, "focus", !0);
                $5c73342f5ab2cfdc$var$vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                $5c73342f5ab2cfdc$var$oc(a) && $5c73342f5ab2cfdc$var$vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === $5c73342f5ab2cfdc$var$ac.indexOf(a) && $5c73342f5ab2cfdc$var$F(a, b);
        }
        c.set(a, null);
    }
}
var $5c73342f5ab2cfdc$var$wc, $5c73342f5ab2cfdc$var$xc, $5c73342f5ab2cfdc$var$yc, $5c73342f5ab2cfdc$var$zc = !1, $5c73342f5ab2cfdc$var$Ac = [], $5c73342f5ab2cfdc$var$Bc = null, $5c73342f5ab2cfdc$var$Cc = null, $5c73342f5ab2cfdc$var$Dc = null, $5c73342f5ab2cfdc$var$Ec = new Map, $5c73342f5ab2cfdc$var$Fc = new Map, $5c73342f5ab2cfdc$var$Gc = [], $5c73342f5ab2cfdc$var$Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), $5c73342f5ab2cfdc$var$Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function $5c73342f5ab2cfdc$var$Jc(a, b) {
    var c = $5c73342f5ab2cfdc$var$cc(b);
    $5c73342f5ab2cfdc$var$Hc.forEach(function(a) {
        $5c73342f5ab2cfdc$var$uc(a, b, c);
    });
    $5c73342f5ab2cfdc$var$Ic.forEach(function(a) {
        $5c73342f5ab2cfdc$var$uc(a, b, c);
    });
}
function $5c73342f5ab2cfdc$var$Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function $5c73342f5ab2cfdc$var$Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            $5c73342f5ab2cfdc$var$Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5c73342f5ab2cfdc$var$Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5c73342f5ab2cfdc$var$Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5c73342f5ab2cfdc$var$Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5c73342f5ab2cfdc$var$Fc.delete(b.pointerId);
    }
}
function $5c73342f5ab2cfdc$var$Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $5c73342f5ab2cfdc$var$Kc(b, c, d, e, f), null !== b && (b = $5c73342f5ab2cfdc$var$Nc(b), null !== b && $5c73342f5ab2cfdc$var$xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function $5c73342f5ab2cfdc$var$Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return $5c73342f5ab2cfdc$var$Bc = $5c73342f5ab2cfdc$var$Mc($5c73342f5ab2cfdc$var$Bc, a, b, c, d, e), !0;
        case "dragenter":
            return $5c73342f5ab2cfdc$var$Cc = $5c73342f5ab2cfdc$var$Mc($5c73342f5ab2cfdc$var$Cc, a, b, c, d, e), !0;
        case "mouseover":
            return $5c73342f5ab2cfdc$var$Dc = $5c73342f5ab2cfdc$var$Mc($5c73342f5ab2cfdc$var$Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5c73342f5ab2cfdc$var$Ec.set(f, $5c73342f5ab2cfdc$var$Mc($5c73342f5ab2cfdc$var$Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5c73342f5ab2cfdc$var$Fc.set(f, $5c73342f5ab2cfdc$var$Mc($5c73342f5ab2cfdc$var$Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5c73342f5ab2cfdc$var$Pc(a) {
    var b = $5c73342f5ab2cfdc$var$tc(a.target);
    if (null !== b) {
        var c = $5c73342f5ab2cfdc$var$dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5c73342f5ab2cfdc$var$ec(c), null !== b) {
                    a.blockedOn = b;
                    $ayULB.unstable_runWithPriority(a.priority, function() {
                        $5c73342f5ab2cfdc$var$yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5c73342f5ab2cfdc$var$Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = $5c73342f5ab2cfdc$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = $5c73342f5ab2cfdc$var$Nc(b);
        null !== c && $5c73342f5ab2cfdc$var$xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function $5c73342f5ab2cfdc$var$Sc(a, b, c) {
    $5c73342f5ab2cfdc$var$Qc(a) && c.delete(b);
}
function $5c73342f5ab2cfdc$var$Tc() {
    for($5c73342f5ab2cfdc$var$zc = !1; 0 < $5c73342f5ab2cfdc$var$Ac.length;){
        var a = $5c73342f5ab2cfdc$var$Ac[0];
        if (null !== a.blockedOn) {
            a = $5c73342f5ab2cfdc$var$Nc(a.blockedOn);
            null !== a && $5c73342f5ab2cfdc$var$wc(a);
            break;
        }
        var b = $5c73342f5ab2cfdc$var$Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : $5c73342f5ab2cfdc$var$Ac.shift();
    }
    null !== $5c73342f5ab2cfdc$var$Bc && $5c73342f5ab2cfdc$var$Qc($5c73342f5ab2cfdc$var$Bc) && ($5c73342f5ab2cfdc$var$Bc = null);
    null !== $5c73342f5ab2cfdc$var$Cc && $5c73342f5ab2cfdc$var$Qc($5c73342f5ab2cfdc$var$Cc) && ($5c73342f5ab2cfdc$var$Cc = null);
    null !== $5c73342f5ab2cfdc$var$Dc && $5c73342f5ab2cfdc$var$Qc($5c73342f5ab2cfdc$var$Dc) && ($5c73342f5ab2cfdc$var$Dc = null);
    $5c73342f5ab2cfdc$var$Ec.forEach($5c73342f5ab2cfdc$var$Sc);
    $5c73342f5ab2cfdc$var$Fc.forEach($5c73342f5ab2cfdc$var$Sc);
}
function $5c73342f5ab2cfdc$var$Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5c73342f5ab2cfdc$var$zc || ($5c73342f5ab2cfdc$var$zc = !0, $ayULB.unstable_scheduleCallback($ayULB.unstable_NormalPriority, $5c73342f5ab2cfdc$var$Tc)));
}
function $5c73342f5ab2cfdc$var$Vc(a) {
    function b(b) {
        return $5c73342f5ab2cfdc$var$Uc(b, a);
    }
    if (0 < $5c73342f5ab2cfdc$var$Ac.length) {
        $5c73342f5ab2cfdc$var$Uc($5c73342f5ab2cfdc$var$Ac[0], a);
        for(var c = 1; c < $5c73342f5ab2cfdc$var$Ac.length; c++){
            var d = $5c73342f5ab2cfdc$var$Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5c73342f5ab2cfdc$var$Bc && $5c73342f5ab2cfdc$var$Uc($5c73342f5ab2cfdc$var$Bc, a);
    null !== $5c73342f5ab2cfdc$var$Cc && $5c73342f5ab2cfdc$var$Uc($5c73342f5ab2cfdc$var$Cc, a);
    null !== $5c73342f5ab2cfdc$var$Dc && $5c73342f5ab2cfdc$var$Uc($5c73342f5ab2cfdc$var$Dc, a);
    $5c73342f5ab2cfdc$var$Ec.forEach(b);
    $5c73342f5ab2cfdc$var$Fc.forEach(b);
    for(c = 0; c < $5c73342f5ab2cfdc$var$Gc.length; c++)d = $5c73342f5ab2cfdc$var$Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5c73342f5ab2cfdc$var$Gc.length && (c = $5c73342f5ab2cfdc$var$Gc[0], null === c.blockedOn);)$5c73342f5ab2cfdc$var$Pc(c), null === c.blockedOn && $5c73342f5ab2cfdc$var$Gc.shift();
}
var $5c73342f5ab2cfdc$var$Wc = {}, $5c73342f5ab2cfdc$var$Yc = new Map, $5c73342f5ab2cfdc$var$Zc = new Map, $5c73342f5ab2cfdc$var$$c = [
    "abort",
    "abort",
    $5c73342f5ab2cfdc$var$Xb,
    "animationEnd",
    $5c73342f5ab2cfdc$var$Yb,
    "animationIteration",
    $5c73342f5ab2cfdc$var$Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $5c73342f5ab2cfdc$var$$b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $5c73342f5ab2cfdc$var$ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        $5c73342f5ab2cfdc$var$Zc.set(d, b);
        $5c73342f5ab2cfdc$var$Yc.set(d, f);
        $5c73342f5ab2cfdc$var$Wc[e] = f;
    }
}
$5c73342f5ab2cfdc$var$ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$5c73342f5ab2cfdc$var$ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$5c73342f5ab2cfdc$var$ad($5c73342f5ab2cfdc$var$$c, 2);
for(var $5c73342f5ab2cfdc$var$bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $5c73342f5ab2cfdc$var$cd = 0; $5c73342f5ab2cfdc$var$cd < $5c73342f5ab2cfdc$var$bd.length; $5c73342f5ab2cfdc$var$cd++)$5c73342f5ab2cfdc$var$Zc.set($5c73342f5ab2cfdc$var$bd[$5c73342f5ab2cfdc$var$cd], 0);
var $5c73342f5ab2cfdc$var$dd = $ayULB.unstable_UserBlockingPriority, $5c73342f5ab2cfdc$var$ed = $ayULB.unstable_runWithPriority, $5c73342f5ab2cfdc$var$fd = !0;
function $5c73342f5ab2cfdc$var$F(a, b) {
    $5c73342f5ab2cfdc$var$vc(b, a, !1);
}
function $5c73342f5ab2cfdc$var$vc(a, b, c) {
    var d = $5c73342f5ab2cfdc$var$Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = $5c73342f5ab2cfdc$var$gd.bind(null, b, 1, a);
            break;
        case 1:
            d = $5c73342f5ab2cfdc$var$hd.bind(null, b, 1, a);
            break;
        default:
            d = $5c73342f5ab2cfdc$var$id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $5c73342f5ab2cfdc$var$gd(a, b, c, d) {
    $5c73342f5ab2cfdc$var$Ja || $5c73342f5ab2cfdc$var$Ha();
    var e = $5c73342f5ab2cfdc$var$id, f = $5c73342f5ab2cfdc$var$Ja;
    $5c73342f5ab2cfdc$var$Ja = !0;
    try {
        $5c73342f5ab2cfdc$var$Ga(e, a, b, c, d);
    } finally{
        ($5c73342f5ab2cfdc$var$Ja = f) || $5c73342f5ab2cfdc$var$La();
    }
}
function $5c73342f5ab2cfdc$var$hd(a, b, c, d) {
    $5c73342f5ab2cfdc$var$ed($5c73342f5ab2cfdc$var$dd, $5c73342f5ab2cfdc$var$id.bind(null, a, b, c, d));
}
function $5c73342f5ab2cfdc$var$id(a, b, c, d) {
    if ($5c73342f5ab2cfdc$var$fd) {
        if (0 < $5c73342f5ab2cfdc$var$Ac.length && -1 < $5c73342f5ab2cfdc$var$Hc.indexOf(a)) a = $5c73342f5ab2cfdc$var$Kc(null, a, b, c, d), $5c73342f5ab2cfdc$var$Ac.push(a);
        else {
            var e = $5c73342f5ab2cfdc$var$Rc(a, b, c, d);
            if (null === e) $5c73342f5ab2cfdc$var$Lc(a, d);
            else if (-1 < $5c73342f5ab2cfdc$var$Hc.indexOf(a)) a = $5c73342f5ab2cfdc$var$Kc(e, a, b, c, d), $5c73342f5ab2cfdc$var$Ac.push(a);
            else if (!$5c73342f5ab2cfdc$var$Oc(e, a, b, c, d)) {
                $5c73342f5ab2cfdc$var$Lc(a, d);
                a = $5c73342f5ab2cfdc$var$rc(a, d, null, b);
                try {
                    $5c73342f5ab2cfdc$var$Ma($5c73342f5ab2cfdc$var$sc, a);
                } finally{
                    $5c73342f5ab2cfdc$var$qc(a);
                }
            }
        }
    }
}
function $5c73342f5ab2cfdc$var$Rc(a, b, c, d) {
    c = $5c73342f5ab2cfdc$var$nc(d);
    c = $5c73342f5ab2cfdc$var$tc(c);
    if (null !== c) {
        var e = $5c73342f5ab2cfdc$var$dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = $5c73342f5ab2cfdc$var$ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = $5c73342f5ab2cfdc$var$rc(a, d, c, b);
    try {
        $5c73342f5ab2cfdc$var$Ma($5c73342f5ab2cfdc$var$sc, a);
    } finally{
        $5c73342f5ab2cfdc$var$qc(a);
    }
    return null;
}
var $5c73342f5ab2cfdc$var$jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5c73342f5ab2cfdc$var$kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5c73342f5ab2cfdc$var$jd).forEach(function(a) {
    $5c73342f5ab2cfdc$var$kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5c73342f5ab2cfdc$var$jd[b] = $5c73342f5ab2cfdc$var$jd[a];
    });
});
function $5c73342f5ab2cfdc$var$ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5c73342f5ab2cfdc$var$jd.hasOwnProperty(a) && $5c73342f5ab2cfdc$var$jd[a] ? ("" + b).trim() : b + "px";
}
function $5c73342f5ab2cfdc$var$md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5c73342f5ab2cfdc$var$ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5c73342f5ab2cfdc$var$nd = $dY3rW({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5c73342f5ab2cfdc$var$od(a, b) {
    if (b) {
        if ($5c73342f5ab2cfdc$var$nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5c73342f5ab2cfdc$var$u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5c73342f5ab2cfdc$var$u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($5c73342f5ab2cfdc$var$u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5c73342f5ab2cfdc$var$u(62, ""));
    }
}
function $5c73342f5ab2cfdc$var$pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5c73342f5ab2cfdc$var$qd = $5c73342f5ab2cfdc$var$Mb.html;
function $5c73342f5ab2cfdc$var$rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $5c73342f5ab2cfdc$var$cc(a);
    b = $5c73342f5ab2cfdc$var$wa[b];
    for(var d = 0; d < b.length; d++)$5c73342f5ab2cfdc$var$uc(b[d], a, c);
}
function $5c73342f5ab2cfdc$var$sd() {}
function $5c73342f5ab2cfdc$var$td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5c73342f5ab2cfdc$var$ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5c73342f5ab2cfdc$var$vd(a, b) {
    var c = $5c73342f5ab2cfdc$var$ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5c73342f5ab2cfdc$var$ud(c);
    }
}
function $5c73342f5ab2cfdc$var$wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5c73342f5ab2cfdc$var$wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5c73342f5ab2cfdc$var$xd() {
    for(var a = window, b = $5c73342f5ab2cfdc$var$td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5c73342f5ab2cfdc$var$td(a.document);
    }
    return b;
}
function $5c73342f5ab2cfdc$var$yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $5c73342f5ab2cfdc$var$zd = "$", $5c73342f5ab2cfdc$var$Ad = "/$", $5c73342f5ab2cfdc$var$Bd = "$?", $5c73342f5ab2cfdc$var$Cd = "$!", $5c73342f5ab2cfdc$var$Dd = null, $5c73342f5ab2cfdc$var$Ed = null;
function $5c73342f5ab2cfdc$var$Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $5c73342f5ab2cfdc$var$Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5c73342f5ab2cfdc$var$Hd = "function" === typeof setTimeout ? setTimeout : void 0, $5c73342f5ab2cfdc$var$Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $5c73342f5ab2cfdc$var$Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $5c73342f5ab2cfdc$var$Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === $5c73342f5ab2cfdc$var$zd || c === $5c73342f5ab2cfdc$var$Cd || c === $5c73342f5ab2cfdc$var$Bd) {
                if (0 === b) return a;
                b--;
            } else c === $5c73342f5ab2cfdc$var$Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5c73342f5ab2cfdc$var$Ld = Math.random().toString(36).slice(2), $5c73342f5ab2cfdc$var$Md = "__reactInternalInstance$" + $5c73342f5ab2cfdc$var$Ld, $5c73342f5ab2cfdc$var$Nd = "__reactEventHandlers$" + $5c73342f5ab2cfdc$var$Ld, $5c73342f5ab2cfdc$var$Od = "__reactContainere$" + $5c73342f5ab2cfdc$var$Ld;
function $5c73342f5ab2cfdc$var$tc(a) {
    var b = a[$5c73342f5ab2cfdc$var$Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5c73342f5ab2cfdc$var$Od] || c[$5c73342f5ab2cfdc$var$Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5c73342f5ab2cfdc$var$Kd(a); null !== a;){
                if (c = a[$5c73342f5ab2cfdc$var$Md]) return c;
                a = $5c73342f5ab2cfdc$var$Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5c73342f5ab2cfdc$var$Nc(a) {
    a = a[$5c73342f5ab2cfdc$var$Md] || a[$5c73342f5ab2cfdc$var$Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5c73342f5ab2cfdc$var$Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5c73342f5ab2cfdc$var$u(33));
}
function $5c73342f5ab2cfdc$var$Qd(a) {
    return a[$5c73342f5ab2cfdc$var$Nd] || null;
}
function $5c73342f5ab2cfdc$var$Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5c73342f5ab2cfdc$var$Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $5c73342f5ab2cfdc$var$la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5c73342f5ab2cfdc$var$u(231, b, typeof c));
    return c;
}
function $5c73342f5ab2cfdc$var$Td(a, b, c) {
    if (b = $5c73342f5ab2cfdc$var$Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $5c73342f5ab2cfdc$var$ic(c._dispatchListeners, b), c._dispatchInstances = $5c73342f5ab2cfdc$var$ic(c._dispatchInstances, a);
}
function $5c73342f5ab2cfdc$var$Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $5c73342f5ab2cfdc$var$Rd(b);
        for(b = c.length; 0 < b--;)$5c73342f5ab2cfdc$var$Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$5c73342f5ab2cfdc$var$Td(c[b], "bubbled", a);
    }
}
function $5c73342f5ab2cfdc$var$Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $5c73342f5ab2cfdc$var$Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $5c73342f5ab2cfdc$var$ic(c._dispatchListeners, b), c._dispatchInstances = $5c73342f5ab2cfdc$var$ic(c._dispatchInstances, a));
}
function $5c73342f5ab2cfdc$var$Wd(a) {
    a && a.dispatchConfig.registrationName && $5c73342f5ab2cfdc$var$Vd(a._targetInst, null, a);
}
function $5c73342f5ab2cfdc$var$Xd(a) {
    $5c73342f5ab2cfdc$var$jc(a, $5c73342f5ab2cfdc$var$Ud);
}
var $5c73342f5ab2cfdc$var$Yd = null, $5c73342f5ab2cfdc$var$Zd = null, $5c73342f5ab2cfdc$var$$d = null;
function $5c73342f5ab2cfdc$var$ae() {
    if ($5c73342f5ab2cfdc$var$$d) return $5c73342f5ab2cfdc$var$$d;
    var a, b = $5c73342f5ab2cfdc$var$Zd, c = b.length, d, e = "value" in $5c73342f5ab2cfdc$var$Yd ? $5c73342f5ab2cfdc$var$Yd.value : $5c73342f5ab2cfdc$var$Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5c73342f5ab2cfdc$var$$d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5c73342f5ab2cfdc$var$be() {
    return !0;
}
function $5c73342f5ab2cfdc$var$ce() {
    return !1;
}
function $5c73342f5ab2cfdc$var$G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $5c73342f5ab2cfdc$var$be : $5c73342f5ab2cfdc$var$ce;
    this.isPropagationStopped = $5c73342f5ab2cfdc$var$ce;
    return this;
}
$dY3rW($5c73342f5ab2cfdc$var$G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5c73342f5ab2cfdc$var$be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5c73342f5ab2cfdc$var$be);
    },
    persist: function() {
        this.isPersistent = $5c73342f5ab2cfdc$var$be;
    },
    isPersistent: $5c73342f5ab2cfdc$var$ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $5c73342f5ab2cfdc$var$ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$5c73342f5ab2cfdc$var$G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$5c73342f5ab2cfdc$var$G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $dY3rW(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $dY3rW({}, d.Interface, a);
    c.extend = d.extend;
    $5c73342f5ab2cfdc$var$de(c);
    return c;
};
$5c73342f5ab2cfdc$var$de($5c73342f5ab2cfdc$var$G);
function $5c73342f5ab2cfdc$var$ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $5c73342f5ab2cfdc$var$fe(a) {
    if (!(a instanceof this)) throw Error($5c73342f5ab2cfdc$var$u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $5c73342f5ab2cfdc$var$de(a) {
    a.eventPool = [];
    a.getPooled = $5c73342f5ab2cfdc$var$ee;
    a.release = $5c73342f5ab2cfdc$var$fe;
}
var $5c73342f5ab2cfdc$var$ge = $5c73342f5ab2cfdc$var$G.extend({
    data: null
}), $5c73342f5ab2cfdc$var$he = $5c73342f5ab2cfdc$var$G.extend({
    data: null
}), $5c73342f5ab2cfdc$var$ie = [
    9,
    13,
    27,
    32
], $5c73342f5ab2cfdc$var$je = $5c73342f5ab2cfdc$var$ya && "CompositionEvent" in window, $5c73342f5ab2cfdc$var$ke = null;
$5c73342f5ab2cfdc$var$ya && "documentMode" in document && ($5c73342f5ab2cfdc$var$ke = document.documentMode);
var $5c73342f5ab2cfdc$var$le = $5c73342f5ab2cfdc$var$ya && "TextEvent" in window && !$5c73342f5ab2cfdc$var$ke, $5c73342f5ab2cfdc$var$me = $5c73342f5ab2cfdc$var$ya && (!$5c73342f5ab2cfdc$var$je || $5c73342f5ab2cfdc$var$ke && 8 < $5c73342f5ab2cfdc$var$ke && 11 >= $5c73342f5ab2cfdc$var$ke), $5c73342f5ab2cfdc$var$ne = String.fromCharCode(32), $5c73342f5ab2cfdc$var$oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $5c73342f5ab2cfdc$var$pe = !1;
function $5c73342f5ab2cfdc$var$qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5c73342f5ab2cfdc$var$ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $5c73342f5ab2cfdc$var$re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5c73342f5ab2cfdc$var$se = !1;
function $5c73342f5ab2cfdc$var$te(a, b) {
    switch(a){
        case "compositionend":
            return $5c73342f5ab2cfdc$var$re(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5c73342f5ab2cfdc$var$pe = !0;
            return $5c73342f5ab2cfdc$var$ne;
        case "textInput":
            return a = b.data, a === $5c73342f5ab2cfdc$var$ne && $5c73342f5ab2cfdc$var$pe ? null : a;
        default:
            return null;
    }
}
function $5c73342f5ab2cfdc$var$ue(a, b) {
    if ($5c73342f5ab2cfdc$var$se) return "compositionend" === a || !$5c73342f5ab2cfdc$var$je && $5c73342f5ab2cfdc$var$qe(a, b) ? (a = $5c73342f5ab2cfdc$var$ae(), $5c73342f5ab2cfdc$var$$d = $5c73342f5ab2cfdc$var$Zd = $5c73342f5ab2cfdc$var$Yd = null, $5c73342f5ab2cfdc$var$se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5c73342f5ab2cfdc$var$me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5c73342f5ab2cfdc$var$ve = {
    eventTypes: $5c73342f5ab2cfdc$var$oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if ($5c73342f5ab2cfdc$var$je) b: {
            switch(a){
                case "compositionstart":
                    var f = $5c73342f5ab2cfdc$var$oe.compositionStart;
                    break b;
                case "compositionend":
                    f = $5c73342f5ab2cfdc$var$oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = $5c73342f5ab2cfdc$var$oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else $5c73342f5ab2cfdc$var$se ? $5c73342f5ab2cfdc$var$qe(a, c) && (f = $5c73342f5ab2cfdc$var$oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = $5c73342f5ab2cfdc$var$oe.compositionStart);
        f ? ($5c73342f5ab2cfdc$var$me && "ko" !== c.locale && ($5c73342f5ab2cfdc$var$se || f !== $5c73342f5ab2cfdc$var$oe.compositionStart ? f === $5c73342f5ab2cfdc$var$oe.compositionEnd && $5c73342f5ab2cfdc$var$se && (e = $5c73342f5ab2cfdc$var$ae()) : ($5c73342f5ab2cfdc$var$Yd = d, $5c73342f5ab2cfdc$var$Zd = "value" in $5c73342f5ab2cfdc$var$Yd ? $5c73342f5ab2cfdc$var$Yd.value : $5c73342f5ab2cfdc$var$Yd.textContent, $5c73342f5ab2cfdc$var$se = !0)), f = $5c73342f5ab2cfdc$var$ge.getPooled(f, b, c, d), e ? f.data = e : (e = $5c73342f5ab2cfdc$var$re(c), null !== e && (f.data = e)), $5c73342f5ab2cfdc$var$Xd(f), e = f) : e = null;
        (a = $5c73342f5ab2cfdc$var$le ? $5c73342f5ab2cfdc$var$te(a, c) : $5c73342f5ab2cfdc$var$ue(a, c)) ? (b = $5c73342f5ab2cfdc$var$he.getPooled($5c73342f5ab2cfdc$var$oe.beforeInput, b, c, d), b.data = a, $5c73342f5ab2cfdc$var$Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, $5c73342f5ab2cfdc$var$we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5c73342f5ab2cfdc$var$xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5c73342f5ab2cfdc$var$we[a.type] : "textarea" === b ? !0 : !1;
}
var $5c73342f5ab2cfdc$var$ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $5c73342f5ab2cfdc$var$ze(a, b, c) {
    a = $5c73342f5ab2cfdc$var$G.getPooled($5c73342f5ab2cfdc$var$ye.change, a, b, c);
    a.type = "change";
    $5c73342f5ab2cfdc$var$Da(c);
    $5c73342f5ab2cfdc$var$Xd(a);
    return a;
}
var $5c73342f5ab2cfdc$var$Ae = null, $5c73342f5ab2cfdc$var$Be = null;
function $5c73342f5ab2cfdc$var$Ce(a) {
    $5c73342f5ab2cfdc$var$mc(a);
}
function $5c73342f5ab2cfdc$var$De(a) {
    var b = $5c73342f5ab2cfdc$var$Pd(a);
    if ($5c73342f5ab2cfdc$var$yb(b)) return a;
}
function $5c73342f5ab2cfdc$var$Ee(a, b) {
    if ("change" === a) return b;
}
var $5c73342f5ab2cfdc$var$Fe = !1;
$5c73342f5ab2cfdc$var$ya && ($5c73342f5ab2cfdc$var$Fe = $5c73342f5ab2cfdc$var$oc("input") && (!document.documentMode || 9 < document.documentMode));
function $5c73342f5ab2cfdc$var$Ge() {
    $5c73342f5ab2cfdc$var$Ae && ($5c73342f5ab2cfdc$var$Ae.detachEvent("onpropertychange", $5c73342f5ab2cfdc$var$He), $5c73342f5ab2cfdc$var$Be = $5c73342f5ab2cfdc$var$Ae = null);
}
function $5c73342f5ab2cfdc$var$He(a) {
    if ("value" === a.propertyName && $5c73342f5ab2cfdc$var$De($5c73342f5ab2cfdc$var$Be)) {
        if (a = $5c73342f5ab2cfdc$var$ze($5c73342f5ab2cfdc$var$Be, a, $5c73342f5ab2cfdc$var$nc(a)), $5c73342f5ab2cfdc$var$Ja) $5c73342f5ab2cfdc$var$mc(a);
        else {
            $5c73342f5ab2cfdc$var$Ja = !0;
            try {
                $5c73342f5ab2cfdc$var$Fa($5c73342f5ab2cfdc$var$Ce, a);
            } finally{
                $5c73342f5ab2cfdc$var$Ja = !1, $5c73342f5ab2cfdc$var$La();
            }
        }
    }
}
function $5c73342f5ab2cfdc$var$Ie(a, b, c) {
    "focus" === a ? ($5c73342f5ab2cfdc$var$Ge(), $5c73342f5ab2cfdc$var$Ae = b, $5c73342f5ab2cfdc$var$Be = c, $5c73342f5ab2cfdc$var$Ae.attachEvent("onpropertychange", $5c73342f5ab2cfdc$var$He)) : "blur" === a && $5c73342f5ab2cfdc$var$Ge();
}
function $5c73342f5ab2cfdc$var$Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5c73342f5ab2cfdc$var$De($5c73342f5ab2cfdc$var$Be);
}
function $5c73342f5ab2cfdc$var$Ke(a, b) {
    if ("click" === a) return $5c73342f5ab2cfdc$var$De(b);
}
function $5c73342f5ab2cfdc$var$Le(a, b) {
    if ("input" === a || "change" === a) return $5c73342f5ab2cfdc$var$De(b);
}
var $5c73342f5ab2cfdc$var$Me = {
    eventTypes: $5c73342f5ab2cfdc$var$ye,
    _isInputEventSupported: $5c73342f5ab2cfdc$var$Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? $5c73342f5ab2cfdc$var$Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = $5c73342f5ab2cfdc$var$Ee;
        else if ($5c73342f5ab2cfdc$var$xe(e)) {
            if ($5c73342f5ab2cfdc$var$Fe) g = $5c73342f5ab2cfdc$var$Le;
            else {
                g = $5c73342f5ab2cfdc$var$Je;
                var h = $5c73342f5ab2cfdc$var$Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = $5c73342f5ab2cfdc$var$Ke);
        if (g && (g = g(a, b))) return $5c73342f5ab2cfdc$var$ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $5c73342f5ab2cfdc$var$Db(e, "number", e.value);
    }
}, $5c73342f5ab2cfdc$var$Ne = $5c73342f5ab2cfdc$var$G.extend({
    view: null,
    detail: null
}), $5c73342f5ab2cfdc$var$Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5c73342f5ab2cfdc$var$Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5c73342f5ab2cfdc$var$Oe[a]) ? !!b[a] : !1;
}
function $5c73342f5ab2cfdc$var$Qe() {
    return $5c73342f5ab2cfdc$var$Pe;
}
var $5c73342f5ab2cfdc$var$Re = 0, $5c73342f5ab2cfdc$var$Se = 0, $5c73342f5ab2cfdc$var$Te = !1, $5c73342f5ab2cfdc$var$Ue = !1, $5c73342f5ab2cfdc$var$Ve = $5c73342f5ab2cfdc$var$Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $5c73342f5ab2cfdc$var$Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $5c73342f5ab2cfdc$var$Re;
        $5c73342f5ab2cfdc$var$Re = a.screenX;
        return $5c73342f5ab2cfdc$var$Te ? "mousemove" === a.type ? a.screenX - b : 0 : ($5c73342f5ab2cfdc$var$Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $5c73342f5ab2cfdc$var$Se;
        $5c73342f5ab2cfdc$var$Se = a.screenY;
        return $5c73342f5ab2cfdc$var$Ue ? "mousemove" === a.type ? a.screenY - b : 0 : ($5c73342f5ab2cfdc$var$Ue = !0, 0);
    }
}), $5c73342f5ab2cfdc$var$We = $5c73342f5ab2cfdc$var$Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $5c73342f5ab2cfdc$var$Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $5c73342f5ab2cfdc$var$Ye = {
    eventTypes: $5c73342f5ab2cfdc$var$Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? $5c73342f5ab2cfdc$var$tc(b) : null, null !== b) {
                var h = $5c73342f5ab2cfdc$var$dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = $5c73342f5ab2cfdc$var$Ve;
            var l = $5c73342f5ab2cfdc$var$Xe.mouseLeave;
            var m = $5c73342f5ab2cfdc$var$Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = $5c73342f5ab2cfdc$var$We, l = $5c73342f5ab2cfdc$var$Xe.pointerLeave, m = $5c73342f5ab2cfdc$var$Xe.pointerEnter, p = "pointer";
        a = null == g ? f : $5c73342f5ab2cfdc$var$Pd(g);
        f = null == b ? f : $5c73342f5ab2cfdc$var$Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = $5c73342f5ab2cfdc$var$Rd(a))g++;
            a = 0;
            for(b = m; b; b = $5c73342f5ab2cfdc$var$Rd(b))a++;
            for(; 0 < g - a;)k = $5c73342f5ab2cfdc$var$Rd(k), g--;
            for(; 0 < a - g;)m = $5c73342f5ab2cfdc$var$Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = $5c73342f5ab2cfdc$var$Rd(k);
                m = $5c73342f5ab2cfdc$var$Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = $5c73342f5ab2cfdc$var$Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = $5c73342f5ab2cfdc$var$Rd(p);
        }
        for(p = 0; p < k.length; p++)$5c73342f5ab2cfdc$var$Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)$5c73342f5ab2cfdc$var$Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function $5c73342f5ab2cfdc$var$Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5c73342f5ab2cfdc$var$$e = "function" === typeof Object.is ? Object.is : $5c73342f5ab2cfdc$var$Ze, $5c73342f5ab2cfdc$var$af = Object.prototype.hasOwnProperty;
function $5c73342f5ab2cfdc$var$bf(a, b) {
    if ($5c73342f5ab2cfdc$var$$e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$5c73342f5ab2cfdc$var$af.call(b, c[d]) || !$5c73342f5ab2cfdc$var$$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var $5c73342f5ab2cfdc$var$cf = $5c73342f5ab2cfdc$var$ya && "documentMode" in document && 11 >= document.documentMode, $5c73342f5ab2cfdc$var$df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $5c73342f5ab2cfdc$var$ef = null, $5c73342f5ab2cfdc$var$ff = null, $5c73342f5ab2cfdc$var$gf = null, $5c73342f5ab2cfdc$var$hf = !1;
function $5c73342f5ab2cfdc$var$jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($5c73342f5ab2cfdc$var$hf || null == $5c73342f5ab2cfdc$var$ef || $5c73342f5ab2cfdc$var$ef !== $5c73342f5ab2cfdc$var$td(c)) return null;
    c = $5c73342f5ab2cfdc$var$ef;
    "selectionStart" in c && $5c73342f5ab2cfdc$var$yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $5c73342f5ab2cfdc$var$gf && $5c73342f5ab2cfdc$var$bf($5c73342f5ab2cfdc$var$gf, c) ? null : ($5c73342f5ab2cfdc$var$gf = c, a = $5c73342f5ab2cfdc$var$G.getPooled($5c73342f5ab2cfdc$var$df.select, $5c73342f5ab2cfdc$var$ff, a, b), a.type = "select", a.target = $5c73342f5ab2cfdc$var$ef, $5c73342f5ab2cfdc$var$Xd(a), a);
}
var $5c73342f5ab2cfdc$var$kf = {
    eventTypes: $5c73342f5ab2cfdc$var$df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = $5c73342f5ab2cfdc$var$cc(e);
                f = $5c73342f5ab2cfdc$var$wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $5c73342f5ab2cfdc$var$Pd(b) : window;
        switch(a){
            case "focus":
                if ($5c73342f5ab2cfdc$var$xe(e) || "true" === e.contentEditable) $5c73342f5ab2cfdc$var$ef = e, $5c73342f5ab2cfdc$var$ff = b, $5c73342f5ab2cfdc$var$gf = null;
                break;
            case "blur":
                $5c73342f5ab2cfdc$var$gf = $5c73342f5ab2cfdc$var$ff = $5c73342f5ab2cfdc$var$ef = null;
                break;
            case "mousedown":
                $5c73342f5ab2cfdc$var$hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $5c73342f5ab2cfdc$var$hf = !1, $5c73342f5ab2cfdc$var$jf(c, d);
            case "selectionchange":
                if ($5c73342f5ab2cfdc$var$cf) break;
            case "keydown":
            case "keyup":
                return $5c73342f5ab2cfdc$var$jf(c, d);
        }
        return null;
    }
}, $5c73342f5ab2cfdc$var$lf = $5c73342f5ab2cfdc$var$G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $5c73342f5ab2cfdc$var$mf = $5c73342f5ab2cfdc$var$G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5c73342f5ab2cfdc$var$nf = $5c73342f5ab2cfdc$var$Ne.extend({
    relatedTarget: null
});
function $5c73342f5ab2cfdc$var$of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $5c73342f5ab2cfdc$var$pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5c73342f5ab2cfdc$var$qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5c73342f5ab2cfdc$var$rf = $5c73342f5ab2cfdc$var$Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = $5c73342f5ab2cfdc$var$pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5c73342f5ab2cfdc$var$of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5c73342f5ab2cfdc$var$qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $5c73342f5ab2cfdc$var$Qe,
    charCode: function(a) {
        return "keypress" === a.type ? $5c73342f5ab2cfdc$var$of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5c73342f5ab2cfdc$var$of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5c73342f5ab2cfdc$var$sf = $5c73342f5ab2cfdc$var$Ve.extend({
    dataTransfer: null
}), $5c73342f5ab2cfdc$var$tf = $5c73342f5ab2cfdc$var$Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $5c73342f5ab2cfdc$var$Qe
}), $5c73342f5ab2cfdc$var$uf = $5c73342f5ab2cfdc$var$G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $5c73342f5ab2cfdc$var$vf = $5c73342f5ab2cfdc$var$Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $5c73342f5ab2cfdc$var$wf = {
    eventTypes: $5c73342f5ab2cfdc$var$Wc,
    extractEvents: function(a, b, c, d) {
        var e = $5c73342f5ab2cfdc$var$Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $5c73342f5ab2cfdc$var$of(c)) return null;
            case "keydown":
            case "keyup":
                a = $5c73342f5ab2cfdc$var$rf;
                break;
            case "blur":
            case "focus":
                a = $5c73342f5ab2cfdc$var$nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $5c73342f5ab2cfdc$var$Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $5c73342f5ab2cfdc$var$sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $5c73342f5ab2cfdc$var$tf;
                break;
            case $5c73342f5ab2cfdc$var$Xb:
            case $5c73342f5ab2cfdc$var$Yb:
            case $5c73342f5ab2cfdc$var$Zb:
                a = $5c73342f5ab2cfdc$var$lf;
                break;
            case $5c73342f5ab2cfdc$var$$b:
                a = $5c73342f5ab2cfdc$var$uf;
                break;
            case "scroll":
                a = $5c73342f5ab2cfdc$var$Ne;
                break;
            case "wheel":
                a = $5c73342f5ab2cfdc$var$vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $5c73342f5ab2cfdc$var$mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $5c73342f5ab2cfdc$var$We;
                break;
            default:
                a = $5c73342f5ab2cfdc$var$G;
        }
        b = a.getPooled(e, b, c, d);
        $5c73342f5ab2cfdc$var$Xd(b);
        return b;
    }
};
if ($5c73342f5ab2cfdc$var$pa) throw Error($5c73342f5ab2cfdc$var$u(101));
$5c73342f5ab2cfdc$var$pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$5c73342f5ab2cfdc$var$ra();
var $5c73342f5ab2cfdc$var$xf = $5c73342f5ab2cfdc$var$Nc;
$5c73342f5ab2cfdc$var$la = $5c73342f5ab2cfdc$var$Qd;
$5c73342f5ab2cfdc$var$ma = $5c73342f5ab2cfdc$var$xf;
$5c73342f5ab2cfdc$var$na = $5c73342f5ab2cfdc$var$Pd;
$5c73342f5ab2cfdc$var$xa({
    SimpleEventPlugin: $5c73342f5ab2cfdc$var$wf,
    EnterLeaveEventPlugin: $5c73342f5ab2cfdc$var$Ye,
    ChangeEventPlugin: $5c73342f5ab2cfdc$var$Me,
    SelectEventPlugin: $5c73342f5ab2cfdc$var$kf,
    BeforeInputEventPlugin: $5c73342f5ab2cfdc$var$ve
});
var $5c73342f5ab2cfdc$var$yf = [], $5c73342f5ab2cfdc$var$zf = -1;
function $5c73342f5ab2cfdc$var$H(a) {
    0 > $5c73342f5ab2cfdc$var$zf || (a.current = $5c73342f5ab2cfdc$var$yf[$5c73342f5ab2cfdc$var$zf], $5c73342f5ab2cfdc$var$yf[$5c73342f5ab2cfdc$var$zf] = null, $5c73342f5ab2cfdc$var$zf--);
}
function $5c73342f5ab2cfdc$var$I(a, b) {
    $5c73342f5ab2cfdc$var$zf++;
    $5c73342f5ab2cfdc$var$yf[$5c73342f5ab2cfdc$var$zf] = a.current;
    a.current = b;
}
var $5c73342f5ab2cfdc$var$Af = {}, $5c73342f5ab2cfdc$var$J = {
    current: $5c73342f5ab2cfdc$var$Af
}, $5c73342f5ab2cfdc$var$K = {
    current: !1
}, $5c73342f5ab2cfdc$var$Bf = $5c73342f5ab2cfdc$var$Af;
function $5c73342f5ab2cfdc$var$Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5c73342f5ab2cfdc$var$Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5c73342f5ab2cfdc$var$L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5c73342f5ab2cfdc$var$Df() {
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K);
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$J);
}
function $5c73342f5ab2cfdc$var$Ef(a, b, c) {
    if ($5c73342f5ab2cfdc$var$J.current !== $5c73342f5ab2cfdc$var$Af) throw Error($5c73342f5ab2cfdc$var$u(168));
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$J, b);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$K, c);
}
function $5c73342f5ab2cfdc$var$Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($5c73342f5ab2cfdc$var$u(108, $5c73342f5ab2cfdc$var$pb(b) || "Unknown", e));
    return $dY3rW({}, c, {}, d);
}
function $5c73342f5ab2cfdc$var$Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5c73342f5ab2cfdc$var$Af;
    $5c73342f5ab2cfdc$var$Bf = $5c73342f5ab2cfdc$var$J.current;
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$J, a);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$K, $5c73342f5ab2cfdc$var$K.current);
    return !0;
}
function $5c73342f5ab2cfdc$var$Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5c73342f5ab2cfdc$var$u(169));
    c ? (a = $5c73342f5ab2cfdc$var$Ff(a, b, $5c73342f5ab2cfdc$var$Bf), d.__reactInternalMemoizedMergedChildContext = a, $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K), $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$J), $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$J, a)) : $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$K, c);
}
var $5c73342f5ab2cfdc$var$If = $ayULB.unstable_runWithPriority, $5c73342f5ab2cfdc$var$Jf = $ayULB.unstable_scheduleCallback, $5c73342f5ab2cfdc$var$Kf = $ayULB.unstable_cancelCallback, $5c73342f5ab2cfdc$var$Lf = $ayULB.unstable_requestPaint, $5c73342f5ab2cfdc$var$Mf = $ayULB.unstable_now, $5c73342f5ab2cfdc$var$Nf = $ayULB.unstable_getCurrentPriorityLevel, $5c73342f5ab2cfdc$var$Of = $ayULB.unstable_ImmediatePriority, $5c73342f5ab2cfdc$var$Pf = $ayULB.unstable_UserBlockingPriority, $5c73342f5ab2cfdc$var$Qf = $ayULB.unstable_NormalPriority, $5c73342f5ab2cfdc$var$Rf = $ayULB.unstable_LowPriority, $5c73342f5ab2cfdc$var$Sf = $ayULB.unstable_IdlePriority, $5c73342f5ab2cfdc$var$Tf = {}, $5c73342f5ab2cfdc$var$Uf = $ayULB.unstable_shouldYield, $5c73342f5ab2cfdc$var$Vf = void 0 !== $5c73342f5ab2cfdc$var$Lf ? $5c73342f5ab2cfdc$var$Lf : function() {}, $5c73342f5ab2cfdc$var$Wf = null, $5c73342f5ab2cfdc$var$Xf = null, $5c73342f5ab2cfdc$var$Yf = !1, $5c73342f5ab2cfdc$var$Zf = $5c73342f5ab2cfdc$var$Mf(), $5c73342f5ab2cfdc$var$$f = 1E4 > $5c73342f5ab2cfdc$var$Zf ? $5c73342f5ab2cfdc$var$Mf : function() {
    return $5c73342f5ab2cfdc$var$Mf() - $5c73342f5ab2cfdc$var$Zf;
};
function $5c73342f5ab2cfdc$var$ag() {
    switch($5c73342f5ab2cfdc$var$Nf()){
        case $5c73342f5ab2cfdc$var$Of:
            return 99;
        case $5c73342f5ab2cfdc$var$Pf:
            return 98;
        case $5c73342f5ab2cfdc$var$Qf:
            return 97;
        case $5c73342f5ab2cfdc$var$Rf:
            return 96;
        case $5c73342f5ab2cfdc$var$Sf:
            return 95;
        default:
            throw Error($5c73342f5ab2cfdc$var$u(332));
    }
}
function $5c73342f5ab2cfdc$var$bg(a) {
    switch(a){
        case 99:
            return $5c73342f5ab2cfdc$var$Of;
        case 98:
            return $5c73342f5ab2cfdc$var$Pf;
        case 97:
            return $5c73342f5ab2cfdc$var$Qf;
        case 96:
            return $5c73342f5ab2cfdc$var$Rf;
        case 95:
            return $5c73342f5ab2cfdc$var$Sf;
        default:
            throw Error($5c73342f5ab2cfdc$var$u(332));
    }
}
function $5c73342f5ab2cfdc$var$cg(a, b) {
    a = $5c73342f5ab2cfdc$var$bg(a);
    return $5c73342f5ab2cfdc$var$If(a, b);
}
function $5c73342f5ab2cfdc$var$dg(a, b, c) {
    a = $5c73342f5ab2cfdc$var$bg(a);
    return $5c73342f5ab2cfdc$var$Jf(a, b, c);
}
function $5c73342f5ab2cfdc$var$eg(a) {
    null === $5c73342f5ab2cfdc$var$Wf ? ($5c73342f5ab2cfdc$var$Wf = [
        a
    ], $5c73342f5ab2cfdc$var$Xf = $5c73342f5ab2cfdc$var$Jf($5c73342f5ab2cfdc$var$Of, $5c73342f5ab2cfdc$var$fg)) : $5c73342f5ab2cfdc$var$Wf.push(a);
    return $5c73342f5ab2cfdc$var$Tf;
}
function $5c73342f5ab2cfdc$var$gg() {
    if (null !== $5c73342f5ab2cfdc$var$Xf) {
        var a = $5c73342f5ab2cfdc$var$Xf;
        $5c73342f5ab2cfdc$var$Xf = null;
        $5c73342f5ab2cfdc$var$Kf(a);
    }
    $5c73342f5ab2cfdc$var$fg();
}
function $5c73342f5ab2cfdc$var$fg() {
    if (!$5c73342f5ab2cfdc$var$Yf && null !== $5c73342f5ab2cfdc$var$Wf) {
        $5c73342f5ab2cfdc$var$Yf = !0;
        var a = 0;
        try {
            var b = $5c73342f5ab2cfdc$var$Wf;
            $5c73342f5ab2cfdc$var$cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $5c73342f5ab2cfdc$var$Wf = null;
        } catch (c) {
            throw null !== $5c73342f5ab2cfdc$var$Wf && ($5c73342f5ab2cfdc$var$Wf = $5c73342f5ab2cfdc$var$Wf.slice(a + 1)), $5c73342f5ab2cfdc$var$Jf($5c73342f5ab2cfdc$var$Of, $5c73342f5ab2cfdc$var$gg), c;
        } finally{
            $5c73342f5ab2cfdc$var$Yf = !1;
        }
    }
}
function $5c73342f5ab2cfdc$var$hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function $5c73342f5ab2cfdc$var$ig(a, b) {
    if (a && a.defaultProps) {
        b = $dY3rW({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var $5c73342f5ab2cfdc$var$jg = {
    current: null
}, $5c73342f5ab2cfdc$var$kg = null, $5c73342f5ab2cfdc$var$lg = null, $5c73342f5ab2cfdc$var$mg = null;
function $5c73342f5ab2cfdc$var$ng() {
    $5c73342f5ab2cfdc$var$mg = $5c73342f5ab2cfdc$var$lg = $5c73342f5ab2cfdc$var$kg = null;
}
function $5c73342f5ab2cfdc$var$og(a) {
    var b = $5c73342f5ab2cfdc$var$jg.current;
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$jg);
    a.type._context._currentValue = b;
}
function $5c73342f5ab2cfdc$var$pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $5c73342f5ab2cfdc$var$qg(a, b) {
    $5c73342f5ab2cfdc$var$kg = a;
    $5c73342f5ab2cfdc$var$mg = $5c73342f5ab2cfdc$var$lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($5c73342f5ab2cfdc$var$rg = !0), a.firstContext = null);
}
function $5c73342f5ab2cfdc$var$sg(a, b) {
    if ($5c73342f5ab2cfdc$var$mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $5c73342f5ab2cfdc$var$mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $5c73342f5ab2cfdc$var$lg) {
            if (null === $5c73342f5ab2cfdc$var$kg) throw Error($5c73342f5ab2cfdc$var$u(308));
            $5c73342f5ab2cfdc$var$lg = b;
            $5c73342f5ab2cfdc$var$kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $5c73342f5ab2cfdc$var$lg = $5c73342f5ab2cfdc$var$lg.next = b;
    }
    return a._currentValue;
}
var $5c73342f5ab2cfdc$var$tg = !1;
function $5c73342f5ab2cfdc$var$ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $5c73342f5ab2cfdc$var$vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function $5c73342f5ab2cfdc$var$wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function $5c73342f5ab2cfdc$var$xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $5c73342f5ab2cfdc$var$yg(a, b) {
    var c = a.alternate;
    null !== c && $5c73342f5ab2cfdc$var$vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function $5c73342f5ab2cfdc$var$zg(a, b, c, d) {
    var e = a.updateQueue;
    $5c73342f5ab2cfdc$var$tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    $5c73342f5ab2cfdc$var$Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $dY3rW({}, k, g);
                                break a;
                            case 2:
                                $5c73342f5ab2cfdc$var$tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        $5c73342f5ab2cfdc$var$Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function $5c73342f5ab2cfdc$var$Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error($5c73342f5ab2cfdc$var$u(191, d));
            d.call(e);
        }
    }
}
var $5c73342f5ab2cfdc$var$Dg = $5c73342f5ab2cfdc$var$Wa.ReactCurrentBatchConfig, $5c73342f5ab2cfdc$var$Eg = (new $iluxG.Component).refs;
function $5c73342f5ab2cfdc$var$Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $dY3rW({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var $5c73342f5ab2cfdc$var$Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? $5c73342f5ab2cfdc$var$dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $5c73342f5ab2cfdc$var$Gg(), e = $5c73342f5ab2cfdc$var$Dg.suspense;
        d = $5c73342f5ab2cfdc$var$Hg(d, a, e);
        e = $5c73342f5ab2cfdc$var$wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $5c73342f5ab2cfdc$var$xg(a, e);
        $5c73342f5ab2cfdc$var$Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $5c73342f5ab2cfdc$var$Gg(), e = $5c73342f5ab2cfdc$var$Dg.suspense;
        d = $5c73342f5ab2cfdc$var$Hg(d, a, e);
        e = $5c73342f5ab2cfdc$var$wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $5c73342f5ab2cfdc$var$xg(a, e);
        $5c73342f5ab2cfdc$var$Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $5c73342f5ab2cfdc$var$Gg(), d = $5c73342f5ab2cfdc$var$Dg.suspense;
        c = $5c73342f5ab2cfdc$var$Hg(c, a, d);
        d = $5c73342f5ab2cfdc$var$wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $5c73342f5ab2cfdc$var$xg(a, d);
        $5c73342f5ab2cfdc$var$Ig(a, c);
    }
};
function $5c73342f5ab2cfdc$var$Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5c73342f5ab2cfdc$var$bf(c, d) || !$5c73342f5ab2cfdc$var$bf(e, f) : !0;
}
function $5c73342f5ab2cfdc$var$Lg(a, b, c) {
    var d = !1, e = $5c73342f5ab2cfdc$var$Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5c73342f5ab2cfdc$var$sg(f) : (e = $5c73342f5ab2cfdc$var$L(b) ? $5c73342f5ab2cfdc$var$Bf : $5c73342f5ab2cfdc$var$J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5c73342f5ab2cfdc$var$Cf(a, e) : $5c73342f5ab2cfdc$var$Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5c73342f5ab2cfdc$var$Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5c73342f5ab2cfdc$var$Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5c73342f5ab2cfdc$var$Jg.enqueueReplaceState(b, b.state, null);
}
function $5c73342f5ab2cfdc$var$Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $5c73342f5ab2cfdc$var$Eg;
    $5c73342f5ab2cfdc$var$ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5c73342f5ab2cfdc$var$sg(f) : (f = $5c73342f5ab2cfdc$var$L(b) ? $5c73342f5ab2cfdc$var$Bf : $5c73342f5ab2cfdc$var$J.current, e.context = $5c73342f5ab2cfdc$var$Cf(a, f));
    $5c73342f5ab2cfdc$var$zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5c73342f5ab2cfdc$var$Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5c73342f5ab2cfdc$var$Jg.enqueueReplaceState(e, e.state, null), $5c73342f5ab2cfdc$var$zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $5c73342f5ab2cfdc$var$Og = Array.isArray;
function $5c73342f5ab2cfdc$var$Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5c73342f5ab2cfdc$var$u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5c73342f5ab2cfdc$var$u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $5c73342f5ab2cfdc$var$Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($5c73342f5ab2cfdc$var$u(284));
        if (!c._owner) throw Error($5c73342f5ab2cfdc$var$u(290, a));
    }
    return a;
}
function $5c73342f5ab2cfdc$var$Qg(a, b) {
    if ("textarea" !== a.type) throw Error($5c73342f5ab2cfdc$var$u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function $5c73342f5ab2cfdc$var$Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5c73342f5ab2cfdc$var$Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5c73342f5ab2cfdc$var$Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $5c73342f5ab2cfdc$var$Pg(a, b, c), d.return = a, d;
        d = $5c73342f5ab2cfdc$var$Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5c73342f5ab2cfdc$var$Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5c73342f5ab2cfdc$var$Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5c73342f5ab2cfdc$var$Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $5c73342f5ab2cfdc$var$Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5c73342f5ab2cfdc$var$Za:
                    return c = $5c73342f5ab2cfdc$var$Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = $5c73342f5ab2cfdc$var$Pg(a, null, b), c.return = a, c;
                case $5c73342f5ab2cfdc$var$$a:
                    return b = $5c73342f5ab2cfdc$var$Vg(b, a.mode, c), b.return = a, b;
            }
            if ($5c73342f5ab2cfdc$var$Og(b) || $5c73342f5ab2cfdc$var$nb(b)) return b = $5c73342f5ab2cfdc$var$Wg(b, a.mode, c, null), b.return = a, b;
            $5c73342f5ab2cfdc$var$Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5c73342f5ab2cfdc$var$Za:
                    return c.key === e ? c.type === $5c73342f5ab2cfdc$var$ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $5c73342f5ab2cfdc$var$$a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($5c73342f5ab2cfdc$var$Og(c) || $5c73342f5ab2cfdc$var$nb(c)) return null !== e ? null : m(a, b, c, d, null);
            $5c73342f5ab2cfdc$var$Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5c73342f5ab2cfdc$var$Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $5c73342f5ab2cfdc$var$ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $5c73342f5ab2cfdc$var$$a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($5c73342f5ab2cfdc$var$Og(d) || $5c73342f5ab2cfdc$var$nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5c73342f5ab2cfdc$var$Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = $5c73342f5ab2cfdc$var$nb(h);
        if ("function" !== typeof k) throw Error($5c73342f5ab2cfdc$var$u(150));
        h = k.call(h);
        if (null == h) throw Error($5c73342f5ab2cfdc$var$u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $5c73342f5ab2cfdc$var$ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $5c73342f5ab2cfdc$var$Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $5c73342f5ab2cfdc$var$ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $5c73342f5ab2cfdc$var$Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $5c73342f5ab2cfdc$var$ab ? (d = $5c73342f5ab2cfdc$var$Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5c73342f5ab2cfdc$var$Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = $5c73342f5ab2cfdc$var$Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $5c73342f5ab2cfdc$var$$a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $5c73342f5ab2cfdc$var$Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5c73342f5ab2cfdc$var$Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if ($5c73342f5ab2cfdc$var$Og(f)) return ca(a, d, f, h);
        if ($5c73342f5ab2cfdc$var$nb(f)) return D(a, d, f, h);
        l && $5c73342f5ab2cfdc$var$Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error($5c73342f5ab2cfdc$var$u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var $5c73342f5ab2cfdc$var$Xg = $5c73342f5ab2cfdc$var$Rg(!0), $5c73342f5ab2cfdc$var$Yg = $5c73342f5ab2cfdc$var$Rg(!1), $5c73342f5ab2cfdc$var$Zg = {}, $5c73342f5ab2cfdc$var$$g = {
    current: $5c73342f5ab2cfdc$var$Zg
}, $5c73342f5ab2cfdc$var$ah = {
    current: $5c73342f5ab2cfdc$var$Zg
}, $5c73342f5ab2cfdc$var$bh = {
    current: $5c73342f5ab2cfdc$var$Zg
};
function $5c73342f5ab2cfdc$var$ch(a) {
    if (a === $5c73342f5ab2cfdc$var$Zg) throw Error($5c73342f5ab2cfdc$var$u(174));
    return a;
}
function $5c73342f5ab2cfdc$var$dh(a, b) {
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$bh, b);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$ah, a);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$$g, $5c73342f5ab2cfdc$var$Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5c73342f5ab2cfdc$var$Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5c73342f5ab2cfdc$var$Ob(b, a);
    }
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$$g);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$$g, b);
}
function $5c73342f5ab2cfdc$var$eh() {
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$$g);
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$ah);
    $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$bh);
}
function $5c73342f5ab2cfdc$var$fh(a) {
    $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$bh.current);
    var b = $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$$g.current);
    var c = $5c73342f5ab2cfdc$var$Ob(b, a.type);
    b !== c && ($5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$ah, a), $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$$g, c));
}
function $5c73342f5ab2cfdc$var$gh(a) {
    $5c73342f5ab2cfdc$var$ah.current === a && ($5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$$g), $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$ah));
}
var $5c73342f5ab2cfdc$var$M = {
    current: 0
};
function $5c73342f5ab2cfdc$var$hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === $5c73342f5ab2cfdc$var$Bd || c.data === $5c73342f5ab2cfdc$var$Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function $5c73342f5ab2cfdc$var$ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var $5c73342f5ab2cfdc$var$jh = $5c73342f5ab2cfdc$var$Wa.ReactCurrentDispatcher, $5c73342f5ab2cfdc$var$kh = $5c73342f5ab2cfdc$var$Wa.ReactCurrentBatchConfig, $5c73342f5ab2cfdc$var$lh = 0, $5c73342f5ab2cfdc$var$N = null, $5c73342f5ab2cfdc$var$O = null, $5c73342f5ab2cfdc$var$P = null, $5c73342f5ab2cfdc$var$mh = !1;
function $5c73342f5ab2cfdc$var$Q() {
    throw Error($5c73342f5ab2cfdc$var$u(321));
}
function $5c73342f5ab2cfdc$var$nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5c73342f5ab2cfdc$var$$e(a[c], b[c])) return !1;
    return !0;
}
function $5c73342f5ab2cfdc$var$oh(a, b, c, d, e, f) {
    $5c73342f5ab2cfdc$var$lh = f;
    $5c73342f5ab2cfdc$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    $5c73342f5ab2cfdc$var$jh.current = null === a || null === a.memoizedState ? $5c73342f5ab2cfdc$var$ph : $5c73342f5ab2cfdc$var$qh;
    a = c(d, e);
    if (b.expirationTime === $5c73342f5ab2cfdc$var$lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error($5c73342f5ab2cfdc$var$u(301));
            f += 1;
            $5c73342f5ab2cfdc$var$P = $5c73342f5ab2cfdc$var$O = null;
            b.updateQueue = null;
            $5c73342f5ab2cfdc$var$jh.current = $5c73342f5ab2cfdc$var$rh;
            a = c(d, e);
        }while (b.expirationTime === $5c73342f5ab2cfdc$var$lh);
    }
    $5c73342f5ab2cfdc$var$jh.current = $5c73342f5ab2cfdc$var$sh;
    b = null !== $5c73342f5ab2cfdc$var$O && null !== $5c73342f5ab2cfdc$var$O.next;
    $5c73342f5ab2cfdc$var$lh = 0;
    $5c73342f5ab2cfdc$var$P = $5c73342f5ab2cfdc$var$O = $5c73342f5ab2cfdc$var$N = null;
    $5c73342f5ab2cfdc$var$mh = !1;
    if (b) throw Error($5c73342f5ab2cfdc$var$u(300));
    return a;
}
function $5c73342f5ab2cfdc$var$th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5c73342f5ab2cfdc$var$P ? $5c73342f5ab2cfdc$var$N.memoizedState = $5c73342f5ab2cfdc$var$P = a : $5c73342f5ab2cfdc$var$P = $5c73342f5ab2cfdc$var$P.next = a;
    return $5c73342f5ab2cfdc$var$P;
}
function $5c73342f5ab2cfdc$var$uh() {
    if (null === $5c73342f5ab2cfdc$var$O) {
        var a = $5c73342f5ab2cfdc$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5c73342f5ab2cfdc$var$O.next;
    var b = null === $5c73342f5ab2cfdc$var$P ? $5c73342f5ab2cfdc$var$N.memoizedState : $5c73342f5ab2cfdc$var$P.next;
    if (null !== b) $5c73342f5ab2cfdc$var$P = b, $5c73342f5ab2cfdc$var$O = a;
    else {
        if (null === a) throw Error($5c73342f5ab2cfdc$var$u(310));
        $5c73342f5ab2cfdc$var$O = a;
        a = {
            memoizedState: $5c73342f5ab2cfdc$var$O.memoizedState,
            baseState: $5c73342f5ab2cfdc$var$O.baseState,
            baseQueue: $5c73342f5ab2cfdc$var$O.baseQueue,
            queue: $5c73342f5ab2cfdc$var$O.queue,
            next: null
        };
        null === $5c73342f5ab2cfdc$var$P ? $5c73342f5ab2cfdc$var$N.memoizedState = $5c73342f5ab2cfdc$var$P = a : $5c73342f5ab2cfdc$var$P = $5c73342f5ab2cfdc$var$P.next = a;
    }
    return $5c73342f5ab2cfdc$var$P;
}
function $5c73342f5ab2cfdc$var$vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5c73342f5ab2cfdc$var$wh(a) {
    var b = $5c73342f5ab2cfdc$var$uh(), c = b.queue;
    if (null === c) throw Error($5c73342f5ab2cfdc$var$u(311));
    c.lastRenderedReducer = a;
    var d = $5c73342f5ab2cfdc$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < $5c73342f5ab2cfdc$var$lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > $5c73342f5ab2cfdc$var$N.expirationTime && ($5c73342f5ab2cfdc$var$N.expirationTime = l, $5c73342f5ab2cfdc$var$Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), $5c73342f5ab2cfdc$var$Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $5c73342f5ab2cfdc$var$$e(d, b.memoizedState) || ($5c73342f5ab2cfdc$var$rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5c73342f5ab2cfdc$var$xh(a) {
    var b = $5c73342f5ab2cfdc$var$uh(), c = b.queue;
    if (null === c) throw Error($5c73342f5ab2cfdc$var$u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5c73342f5ab2cfdc$var$$e(f, b.memoizedState) || ($5c73342f5ab2cfdc$var$rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5c73342f5ab2cfdc$var$yh(a) {
    var b = $5c73342f5ab2cfdc$var$th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $5c73342f5ab2cfdc$var$vh,
        lastRenderedState: a
    };
    a = a.dispatch = $5c73342f5ab2cfdc$var$zh.bind(null, $5c73342f5ab2cfdc$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5c73342f5ab2cfdc$var$Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5c73342f5ab2cfdc$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $5c73342f5ab2cfdc$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5c73342f5ab2cfdc$var$Bh() {
    return $5c73342f5ab2cfdc$var$uh().memoizedState;
}
function $5c73342f5ab2cfdc$var$Ch(a, b, c, d) {
    var e = $5c73342f5ab2cfdc$var$th();
    $5c73342f5ab2cfdc$var$N.effectTag |= a;
    e.memoizedState = $5c73342f5ab2cfdc$var$Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5c73342f5ab2cfdc$var$Dh(a, b, c, d) {
    var e = $5c73342f5ab2cfdc$var$uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5c73342f5ab2cfdc$var$O) {
        var g = $5c73342f5ab2cfdc$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $5c73342f5ab2cfdc$var$nh(d, g.deps)) {
            $5c73342f5ab2cfdc$var$Ah(b, c, f, d);
            return;
        }
    }
    $5c73342f5ab2cfdc$var$N.effectTag |= a;
    e.memoizedState = $5c73342f5ab2cfdc$var$Ah(1 | b, c, f, d);
}
function $5c73342f5ab2cfdc$var$Eh(a, b) {
    return $5c73342f5ab2cfdc$var$Ch(516, 4, a, b);
}
function $5c73342f5ab2cfdc$var$Fh(a, b) {
    return $5c73342f5ab2cfdc$var$Dh(516, 4, a, b);
}
function $5c73342f5ab2cfdc$var$Gh(a, b) {
    return $5c73342f5ab2cfdc$var$Dh(4, 2, a, b);
}
function $5c73342f5ab2cfdc$var$Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5c73342f5ab2cfdc$var$Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5c73342f5ab2cfdc$var$Dh(4, 2, $5c73342f5ab2cfdc$var$Hh.bind(null, b, a), c);
}
function $5c73342f5ab2cfdc$var$Jh() {}
function $5c73342f5ab2cfdc$var$Kh(a, b) {
    $5c73342f5ab2cfdc$var$th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function $5c73342f5ab2cfdc$var$Lh(a, b) {
    var c = $5c73342f5ab2cfdc$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5c73342f5ab2cfdc$var$nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5c73342f5ab2cfdc$var$Mh(a, b) {
    var c = $5c73342f5ab2cfdc$var$uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5c73342f5ab2cfdc$var$nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5c73342f5ab2cfdc$var$Nh(a, b, c) {
    var d = $5c73342f5ab2cfdc$var$ag();
    $5c73342f5ab2cfdc$var$cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    $5c73342f5ab2cfdc$var$cg(97 < d ? 97 : d, function() {
        var d = $5c73342f5ab2cfdc$var$kh.suspense;
        $5c73342f5ab2cfdc$var$kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            $5c73342f5ab2cfdc$var$kh.suspense = d;
        }
    });
}
function $5c73342f5ab2cfdc$var$zh(a, b, c) {
    var d = $5c73342f5ab2cfdc$var$Gg(), e = $5c73342f5ab2cfdc$var$Dg.suspense;
    d = $5c73342f5ab2cfdc$var$Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === $5c73342f5ab2cfdc$var$N || null !== f && f === $5c73342f5ab2cfdc$var$N) $5c73342f5ab2cfdc$var$mh = !0, e.expirationTime = $5c73342f5ab2cfdc$var$lh, $5c73342f5ab2cfdc$var$N.expirationTime = $5c73342f5ab2cfdc$var$lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($5c73342f5ab2cfdc$var$$e(h, g)) return;
        } catch (k) {} finally{}
        $5c73342f5ab2cfdc$var$Ig(a, d);
    }
}
var $5c73342f5ab2cfdc$var$sh = {
    readContext: $5c73342f5ab2cfdc$var$sg,
    useCallback: $5c73342f5ab2cfdc$var$Q,
    useContext: $5c73342f5ab2cfdc$var$Q,
    useEffect: $5c73342f5ab2cfdc$var$Q,
    useImperativeHandle: $5c73342f5ab2cfdc$var$Q,
    useLayoutEffect: $5c73342f5ab2cfdc$var$Q,
    useMemo: $5c73342f5ab2cfdc$var$Q,
    useReducer: $5c73342f5ab2cfdc$var$Q,
    useRef: $5c73342f5ab2cfdc$var$Q,
    useState: $5c73342f5ab2cfdc$var$Q,
    useDebugValue: $5c73342f5ab2cfdc$var$Q,
    useResponder: $5c73342f5ab2cfdc$var$Q,
    useDeferredValue: $5c73342f5ab2cfdc$var$Q,
    useTransition: $5c73342f5ab2cfdc$var$Q
}, $5c73342f5ab2cfdc$var$ph = {
    readContext: $5c73342f5ab2cfdc$var$sg,
    useCallback: $5c73342f5ab2cfdc$var$Kh,
    useContext: $5c73342f5ab2cfdc$var$sg,
    useEffect: $5c73342f5ab2cfdc$var$Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5c73342f5ab2cfdc$var$Ch(4, 2, $5c73342f5ab2cfdc$var$Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5c73342f5ab2cfdc$var$Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5c73342f5ab2cfdc$var$th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5c73342f5ab2cfdc$var$th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $5c73342f5ab2cfdc$var$zh.bind(null, $5c73342f5ab2cfdc$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5c73342f5ab2cfdc$var$th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5c73342f5ab2cfdc$var$yh,
    useDebugValue: $5c73342f5ab2cfdc$var$Jh,
    useResponder: $5c73342f5ab2cfdc$var$ih,
    useDeferredValue: function(a, b) {
        var c = $5c73342f5ab2cfdc$var$yh(a), d = c[0], e = c[1];
        $5c73342f5ab2cfdc$var$Eh(function() {
            var c = $5c73342f5ab2cfdc$var$kh.suspense;
            $5c73342f5ab2cfdc$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $5c73342f5ab2cfdc$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $5c73342f5ab2cfdc$var$yh(!1), c = b[0];
        b = b[1];
        return [
            $5c73342f5ab2cfdc$var$Kh($5c73342f5ab2cfdc$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $5c73342f5ab2cfdc$var$qh = {
    readContext: $5c73342f5ab2cfdc$var$sg,
    useCallback: $5c73342f5ab2cfdc$var$Lh,
    useContext: $5c73342f5ab2cfdc$var$sg,
    useEffect: $5c73342f5ab2cfdc$var$Fh,
    useImperativeHandle: $5c73342f5ab2cfdc$var$Ih,
    useLayoutEffect: $5c73342f5ab2cfdc$var$Gh,
    useMemo: $5c73342f5ab2cfdc$var$Mh,
    useReducer: $5c73342f5ab2cfdc$var$wh,
    useRef: $5c73342f5ab2cfdc$var$Bh,
    useState: function() {
        return $5c73342f5ab2cfdc$var$wh($5c73342f5ab2cfdc$var$vh);
    },
    useDebugValue: $5c73342f5ab2cfdc$var$Jh,
    useResponder: $5c73342f5ab2cfdc$var$ih,
    useDeferredValue: function(a, b) {
        var c = $5c73342f5ab2cfdc$var$wh($5c73342f5ab2cfdc$var$vh), d = c[0], e = c[1];
        $5c73342f5ab2cfdc$var$Fh(function() {
            var c = $5c73342f5ab2cfdc$var$kh.suspense;
            $5c73342f5ab2cfdc$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $5c73342f5ab2cfdc$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $5c73342f5ab2cfdc$var$wh($5c73342f5ab2cfdc$var$vh), c = b[0];
        b = b[1];
        return [
            $5c73342f5ab2cfdc$var$Lh($5c73342f5ab2cfdc$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $5c73342f5ab2cfdc$var$rh = {
    readContext: $5c73342f5ab2cfdc$var$sg,
    useCallback: $5c73342f5ab2cfdc$var$Lh,
    useContext: $5c73342f5ab2cfdc$var$sg,
    useEffect: $5c73342f5ab2cfdc$var$Fh,
    useImperativeHandle: $5c73342f5ab2cfdc$var$Ih,
    useLayoutEffect: $5c73342f5ab2cfdc$var$Gh,
    useMemo: $5c73342f5ab2cfdc$var$Mh,
    useReducer: $5c73342f5ab2cfdc$var$xh,
    useRef: $5c73342f5ab2cfdc$var$Bh,
    useState: function() {
        return $5c73342f5ab2cfdc$var$xh($5c73342f5ab2cfdc$var$vh);
    },
    useDebugValue: $5c73342f5ab2cfdc$var$Jh,
    useResponder: $5c73342f5ab2cfdc$var$ih,
    useDeferredValue: function(a, b) {
        var c = $5c73342f5ab2cfdc$var$xh($5c73342f5ab2cfdc$var$vh), d = c[0], e = c[1];
        $5c73342f5ab2cfdc$var$Fh(function() {
            var c = $5c73342f5ab2cfdc$var$kh.suspense;
            $5c73342f5ab2cfdc$var$kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                $5c73342f5ab2cfdc$var$kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = $5c73342f5ab2cfdc$var$xh($5c73342f5ab2cfdc$var$vh), c = b[0];
        b = b[1];
        return [
            $5c73342f5ab2cfdc$var$Lh($5c73342f5ab2cfdc$var$Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, $5c73342f5ab2cfdc$var$Oh = null, $5c73342f5ab2cfdc$var$Ph = null, $5c73342f5ab2cfdc$var$Qh = !1;
function $5c73342f5ab2cfdc$var$Rh(a, b) {
    var c = $5c73342f5ab2cfdc$var$Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $5c73342f5ab2cfdc$var$Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $5c73342f5ab2cfdc$var$Uh(a) {
    if ($5c73342f5ab2cfdc$var$Qh) {
        var b = $5c73342f5ab2cfdc$var$Ph;
        if (b) {
            var c = b;
            if (!$5c73342f5ab2cfdc$var$Th(a, b)) {
                b = $5c73342f5ab2cfdc$var$Jd(c.nextSibling);
                if (!b || !$5c73342f5ab2cfdc$var$Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    $5c73342f5ab2cfdc$var$Qh = !1;
                    $5c73342f5ab2cfdc$var$Oh = a;
                    return;
                }
                $5c73342f5ab2cfdc$var$Rh($5c73342f5ab2cfdc$var$Oh, c);
            }
            $5c73342f5ab2cfdc$var$Oh = a;
            $5c73342f5ab2cfdc$var$Ph = $5c73342f5ab2cfdc$var$Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, $5c73342f5ab2cfdc$var$Qh = !1, $5c73342f5ab2cfdc$var$Oh = a;
    }
}
function $5c73342f5ab2cfdc$var$Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5c73342f5ab2cfdc$var$Oh = a;
}
function $5c73342f5ab2cfdc$var$Wh(a) {
    if (a !== $5c73342f5ab2cfdc$var$Oh) return !1;
    if (!$5c73342f5ab2cfdc$var$Qh) return $5c73342f5ab2cfdc$var$Vh(a), $5c73342f5ab2cfdc$var$Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$5c73342f5ab2cfdc$var$Gd(b, a.memoizedProps)) for(b = $5c73342f5ab2cfdc$var$Ph; b;)$5c73342f5ab2cfdc$var$Rh(a, b), b = $5c73342f5ab2cfdc$var$Jd(b.nextSibling);
    $5c73342f5ab2cfdc$var$Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5c73342f5ab2cfdc$var$u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === $5c73342f5ab2cfdc$var$Ad) {
                        if (0 === b) {
                            $5c73342f5ab2cfdc$var$Ph = $5c73342f5ab2cfdc$var$Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== $5c73342f5ab2cfdc$var$zd && c !== $5c73342f5ab2cfdc$var$Cd && c !== $5c73342f5ab2cfdc$var$Bd || b++;
                }
                a = a.nextSibling;
            }
            $5c73342f5ab2cfdc$var$Ph = null;
        }
    } else $5c73342f5ab2cfdc$var$Ph = $5c73342f5ab2cfdc$var$Oh ? $5c73342f5ab2cfdc$var$Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function $5c73342f5ab2cfdc$var$Xh() {
    $5c73342f5ab2cfdc$var$Ph = $5c73342f5ab2cfdc$var$Oh = null;
    $5c73342f5ab2cfdc$var$Qh = !1;
}
var $5c73342f5ab2cfdc$var$Yh = $5c73342f5ab2cfdc$var$Wa.ReactCurrentOwner, $5c73342f5ab2cfdc$var$rg = !1;
function $5c73342f5ab2cfdc$var$R(a, b, c, d) {
    b.child = null === a ? $5c73342f5ab2cfdc$var$Yg(b, null, c, d) : $5c73342f5ab2cfdc$var$Xg(b, a.child, c, d);
}
function $5c73342f5ab2cfdc$var$Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5c73342f5ab2cfdc$var$qg(b, e);
    d = $5c73342f5ab2cfdc$var$oh(a, b, c, d, f, e);
    if (null !== a && !$5c73342f5ab2cfdc$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $5c73342f5ab2cfdc$var$$h(a, b, e);
    b.effectTag |= 1;
    $5c73342f5ab2cfdc$var$R(a, b, d, e);
    return b.child;
}
function $5c73342f5ab2cfdc$var$ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$5c73342f5ab2cfdc$var$bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $5c73342f5ab2cfdc$var$ci(a, b, g, d, e, f);
        a = $5c73342f5ab2cfdc$var$Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $5c73342f5ab2cfdc$var$bf, c(e, d) && a.ref === b.ref)) return $5c73342f5ab2cfdc$var$$h(a, b, f);
    b.effectTag |= 1;
    a = $5c73342f5ab2cfdc$var$Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5c73342f5ab2cfdc$var$ci(a, b, c, d, e, f) {
    return null !== a && $5c73342f5ab2cfdc$var$bf(a.memoizedProps, d) && a.ref === b.ref && ($5c73342f5ab2cfdc$var$rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $5c73342f5ab2cfdc$var$$h(a, b, f)) : $5c73342f5ab2cfdc$var$di(a, b, c, d, f);
}
function $5c73342f5ab2cfdc$var$ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $5c73342f5ab2cfdc$var$di(a, b, c, d, e) {
    var f = $5c73342f5ab2cfdc$var$L(c) ? $5c73342f5ab2cfdc$var$Bf : $5c73342f5ab2cfdc$var$J.current;
    f = $5c73342f5ab2cfdc$var$Cf(b, f);
    $5c73342f5ab2cfdc$var$qg(b, e);
    c = $5c73342f5ab2cfdc$var$oh(a, b, c, d, f, e);
    if (null !== a && !$5c73342f5ab2cfdc$var$rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $5c73342f5ab2cfdc$var$$h(a, b, e);
    b.effectTag |= 1;
    $5c73342f5ab2cfdc$var$R(a, b, c, e);
    return b.child;
}
function $5c73342f5ab2cfdc$var$fi(a, b, c, d, e) {
    if ($5c73342f5ab2cfdc$var$L(c)) {
        var f = !0;
        $5c73342f5ab2cfdc$var$Gf(b);
    } else f = !1;
    $5c73342f5ab2cfdc$var$qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $5c73342f5ab2cfdc$var$Lg(b, c, d), $5c73342f5ab2cfdc$var$Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5c73342f5ab2cfdc$var$sg(l) : (l = $5c73342f5ab2cfdc$var$L(c) ? $5c73342f5ab2cfdc$var$Bf : $5c73342f5ab2cfdc$var$J.current, l = $5c73342f5ab2cfdc$var$Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5c73342f5ab2cfdc$var$Mg(b, g, d, l);
        $5c73342f5ab2cfdc$var$tg = !1;
        var x = b.memoizedState;
        g.state = x;
        $5c73342f5ab2cfdc$var$zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || $5c73342f5ab2cfdc$var$K.current || $5c73342f5ab2cfdc$var$tg ? ("function" === typeof m && ($5c73342f5ab2cfdc$var$Fg(b, c, m, d), k = b.memoizedState), (h = $5c73342f5ab2cfdc$var$tg || $5c73342f5ab2cfdc$var$Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, $5c73342f5ab2cfdc$var$vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : $5c73342f5ab2cfdc$var$ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = $5c73342f5ab2cfdc$var$sg(l) : (l = $5c73342f5ab2cfdc$var$L(c) ? $5c73342f5ab2cfdc$var$Bf : $5c73342f5ab2cfdc$var$J.current, l = $5c73342f5ab2cfdc$var$Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5c73342f5ab2cfdc$var$Mg(b, g, d, l), $5c73342f5ab2cfdc$var$tg = !1, k = b.memoizedState, g.state = k, $5c73342f5ab2cfdc$var$zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || $5c73342f5ab2cfdc$var$K.current || $5c73342f5ab2cfdc$var$tg ? ("function" === typeof m && ($5c73342f5ab2cfdc$var$Fg(b, c, m, d), x = b.memoizedState), (m = $5c73342f5ab2cfdc$var$tg || $5c73342f5ab2cfdc$var$Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $5c73342f5ab2cfdc$var$gi(a, b, c, d, f, e);
}
function $5c73342f5ab2cfdc$var$gi(a, b, c, d, e, f) {
    $5c73342f5ab2cfdc$var$ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && $5c73342f5ab2cfdc$var$Hf(b, c, !1), $5c73342f5ab2cfdc$var$$h(a, b, f);
    d = b.stateNode;
    $5c73342f5ab2cfdc$var$Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = $5c73342f5ab2cfdc$var$Xg(b, a.child, null, f), b.child = $5c73342f5ab2cfdc$var$Xg(b, null, h, f)) : $5c73342f5ab2cfdc$var$R(a, b, h, f);
    b.memoizedState = d.state;
    e && $5c73342f5ab2cfdc$var$Hf(b, c, !0);
    return b.child;
}
function $5c73342f5ab2cfdc$var$hi(a) {
    var b = a.stateNode;
    b.pendingContext ? $5c73342f5ab2cfdc$var$Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5c73342f5ab2cfdc$var$Ef(a, b.context, !1);
    $5c73342f5ab2cfdc$var$dh(a, b.containerInfo);
}
var $5c73342f5ab2cfdc$var$ii = {
    dehydrated: null,
    retryTime: 0
};
function $5c73342f5ab2cfdc$var$ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $5c73342f5ab2cfdc$var$M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && $5c73342f5ab2cfdc$var$Uh(b);
        if (g) {
            g = e.fallback;
            e = $5c73342f5ab2cfdc$var$Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = $5c73342f5ab2cfdc$var$Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = $5c73342f5ab2cfdc$var$ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = $5c73342f5ab2cfdc$var$Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = $5c73342f5ab2cfdc$var$Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = $5c73342f5ab2cfdc$var$Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = $5c73342f5ab2cfdc$var$ii;
            b.child = c;
            return d;
        }
        c = $5c73342f5ab2cfdc$var$Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = $5c73342f5ab2cfdc$var$Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = $5c73342f5ab2cfdc$var$Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = $5c73342f5ab2cfdc$var$ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = $5c73342f5ab2cfdc$var$Xg(b, a, e.children, c);
}
function $5c73342f5ab2cfdc$var$ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    $5c73342f5ab2cfdc$var$pg(a.return, b);
}
function $5c73342f5ab2cfdc$var$li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function $5c73342f5ab2cfdc$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5c73342f5ab2cfdc$var$R(a, b, d.children, c);
    d = $5c73342f5ab2cfdc$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5c73342f5ab2cfdc$var$ki(a, c);
            else if (19 === a.tag) $5c73342f5ab2cfdc$var$ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5c73342f5ab2cfdc$var$hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5c73342f5ab2cfdc$var$li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5c73342f5ab2cfdc$var$hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5c73342f5ab2cfdc$var$li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $5c73342f5ab2cfdc$var$li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5c73342f5ab2cfdc$var$$h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && $5c73342f5ab2cfdc$var$Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error($5c73342f5ab2cfdc$var$u(153));
    if (null !== b.child) {
        a = b.child;
        c = $5c73342f5ab2cfdc$var$Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5c73342f5ab2cfdc$var$Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var $5c73342f5ab2cfdc$var$ni, $5c73342f5ab2cfdc$var$oi, $5c73342f5ab2cfdc$var$pi, $5c73342f5ab2cfdc$var$qi;
$5c73342f5ab2cfdc$var$ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5c73342f5ab2cfdc$var$oi = function() {};
$5c73342f5ab2cfdc$var$pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$$g.current);
        a = null;
        switch(c){
            case "input":
                f = $5c73342f5ab2cfdc$var$zb(g, f);
                d = $5c73342f5ab2cfdc$var$zb(g, d);
                a = [];
                break;
            case "option":
                f = $5c73342f5ab2cfdc$var$Gb(g, f);
                d = $5c73342f5ab2cfdc$var$Gb(g, d);
                a = [];
                break;
            case "select":
                f = $dY3rW({}, f, {
                    value: void 0
                });
                d = $dY3rW({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $5c73342f5ab2cfdc$var$Ib(g, f);
                d = $5c73342f5ab2cfdc$var$Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = $5c73342f5ab2cfdc$var$sd);
        }
        $5c73342f5ab2cfdc$var$od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && ($5c73342f5ab2cfdc$var$va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && ($5c73342f5ab2cfdc$var$va.hasOwnProperty(h) ? (null != l && $5c73342f5ab2cfdc$var$rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
$5c73342f5ab2cfdc$var$qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function $5c73342f5ab2cfdc$var$ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5c73342f5ab2cfdc$var$si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $5c73342f5ab2cfdc$var$L(b.type) && $5c73342f5ab2cfdc$var$Df(), null;
        case 3:
            return $5c73342f5ab2cfdc$var$eh(), $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K), $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !$5c73342f5ab2cfdc$var$Wh(b) || (b.effectTag |= 4), $5c73342f5ab2cfdc$var$oi(b), null;
        case 5:
            $5c73342f5ab2cfdc$var$gh(b);
            c = $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) $5c73342f5ab2cfdc$var$pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5c73342f5ab2cfdc$var$u(166));
                    return null;
                }
                a = $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$$g.current);
                if ($5c73342f5ab2cfdc$var$Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[$5c73342f5ab2cfdc$var$Md] = b;
                    d[$5c73342f5ab2cfdc$var$Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $5c73342f5ab2cfdc$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $5c73342f5ab2cfdc$var$ac.length; a++)$5c73342f5ab2cfdc$var$F($5c73342f5ab2cfdc$var$ac[a], d);
                            break;
                        case "source":
                            $5c73342f5ab2cfdc$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5c73342f5ab2cfdc$var$F("error", d);
                            $5c73342f5ab2cfdc$var$F("load", d);
                            break;
                        case "form":
                            $5c73342f5ab2cfdc$var$F("reset", d);
                            $5c73342f5ab2cfdc$var$F("submit", d);
                            break;
                        case "details":
                            $5c73342f5ab2cfdc$var$F("toggle", d);
                            break;
                        case "input":
                            $5c73342f5ab2cfdc$var$Ab(d, f);
                            $5c73342f5ab2cfdc$var$F("invalid", d);
                            $5c73342f5ab2cfdc$var$rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5c73342f5ab2cfdc$var$F("invalid", d);
                            $5c73342f5ab2cfdc$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $5c73342f5ab2cfdc$var$Jb(d, f), $5c73342f5ab2cfdc$var$F("invalid", d), $5c73342f5ab2cfdc$var$rd(c, "onChange");
                    }
                    $5c73342f5ab2cfdc$var$od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : $5c73342f5ab2cfdc$var$va.hasOwnProperty(g) && null != h && $5c73342f5ab2cfdc$var$rd(c, g);
                    }
                    switch(e){
                        case "input":
                            $5c73342f5ab2cfdc$var$xb(d);
                            $5c73342f5ab2cfdc$var$Eb(d, f, !0);
                            break;
                        case "textarea":
                            $5c73342f5ab2cfdc$var$xb(d);
                            $5c73342f5ab2cfdc$var$Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5c73342f5ab2cfdc$var$sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === $5c73342f5ab2cfdc$var$qd && (a = $5c73342f5ab2cfdc$var$Nb(e));
                    a === $5c73342f5ab2cfdc$var$qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[$5c73342f5ab2cfdc$var$Md] = b;
                    a[$5c73342f5ab2cfdc$var$Nd] = d;
                    $5c73342f5ab2cfdc$var$ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = $5c73342f5ab2cfdc$var$pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            $5c73342f5ab2cfdc$var$F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < $5c73342f5ab2cfdc$var$ac.length; h++)$5c73342f5ab2cfdc$var$F($5c73342f5ab2cfdc$var$ac[h], a);
                            h = d;
                            break;
                        case "source":
                            $5c73342f5ab2cfdc$var$F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5c73342f5ab2cfdc$var$F("error", a);
                            $5c73342f5ab2cfdc$var$F("load", a);
                            h = d;
                            break;
                        case "form":
                            $5c73342f5ab2cfdc$var$F("reset", a);
                            $5c73342f5ab2cfdc$var$F("submit", a);
                            h = d;
                            break;
                        case "details":
                            $5c73342f5ab2cfdc$var$F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            $5c73342f5ab2cfdc$var$Ab(a, d);
                            h = $5c73342f5ab2cfdc$var$zb(a, d);
                            $5c73342f5ab2cfdc$var$F("invalid", a);
                            $5c73342f5ab2cfdc$var$rd(c, "onChange");
                            break;
                        case "option":
                            h = $5c73342f5ab2cfdc$var$Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $dY3rW({}, d, {
                                value: void 0
                            });
                            $5c73342f5ab2cfdc$var$F("invalid", a);
                            $5c73342f5ab2cfdc$var$rd(c, "onChange");
                            break;
                        case "textarea":
                            $5c73342f5ab2cfdc$var$Jb(a, d);
                            h = $5c73342f5ab2cfdc$var$Ib(a, d);
                            $5c73342f5ab2cfdc$var$F("invalid", a);
                            $5c73342f5ab2cfdc$var$rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    $5c73342f5ab2cfdc$var$od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? $5c73342f5ab2cfdc$var$md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && $5c73342f5ab2cfdc$var$Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && $5c73342f5ab2cfdc$var$Rb(a, l) : "number" === typeof l && $5c73342f5ab2cfdc$var$Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5c73342f5ab2cfdc$var$va.hasOwnProperty(f) ? null != l && $5c73342f5ab2cfdc$var$rd(c, f) : null != l && $5c73342f5ab2cfdc$var$Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            $5c73342f5ab2cfdc$var$xb(a);
                            $5c73342f5ab2cfdc$var$Eb(a, d, !1);
                            break;
                        case "textarea":
                            $5c73342f5ab2cfdc$var$xb(a);
                            $5c73342f5ab2cfdc$var$Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $5c73342f5ab2cfdc$var$rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? $5c73342f5ab2cfdc$var$Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && $5c73342f5ab2cfdc$var$Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = $5c73342f5ab2cfdc$var$sd);
                    }
                    $5c73342f5ab2cfdc$var$Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $5c73342f5ab2cfdc$var$qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5c73342f5ab2cfdc$var$u(166));
                c = $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$bh.current);
                $5c73342f5ab2cfdc$var$ch($5c73342f5ab2cfdc$var$$g.current);
                $5c73342f5ab2cfdc$var$Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[$5c73342f5ab2cfdc$var$Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[$5c73342f5ab2cfdc$var$Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $5c73342f5ab2cfdc$var$Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($5c73342f5ab2cfdc$var$M.current & 1)) $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$ti && ($5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$ui);
                else {
                    if ($5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$ti || $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$ui) $5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$vi;
                    0 !== $5c73342f5ab2cfdc$var$wi && null !== $5c73342f5ab2cfdc$var$T && ($5c73342f5ab2cfdc$var$xi($5c73342f5ab2cfdc$var$T, $5c73342f5ab2cfdc$var$U), $5c73342f5ab2cfdc$var$yi($5c73342f5ab2cfdc$var$T, $5c73342f5ab2cfdc$var$wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return $5c73342f5ab2cfdc$var$eh(), $5c73342f5ab2cfdc$var$oi(b), null;
        case 10:
            return $5c73342f5ab2cfdc$var$og(b), null;
        case 17:
            return $5c73342f5ab2cfdc$var$L(b.type) && $5c73342f5ab2cfdc$var$Df(), null;
        case 19:
            $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) $5c73342f5ab2cfdc$var$ri(d, !1);
                else {
                    if ($5c73342f5ab2cfdc$var$S !== $5c73342f5ab2cfdc$var$ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = $5c73342f5ab2cfdc$var$hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            $5c73342f5ab2cfdc$var$ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, $5c73342f5ab2cfdc$var$M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = $5c73342f5ab2cfdc$var$hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), $5c73342f5ab2cfdc$var$ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $5c73342f5ab2cfdc$var$$f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, $5c73342f5ab2cfdc$var$ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $5c73342f5ab2cfdc$var$$f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $5c73342f5ab2cfdc$var$$f(), c.sibling = null, b = $5c73342f5ab2cfdc$var$M.current, $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error($5c73342f5ab2cfdc$var$u(156, b.tag));
}
function $5c73342f5ab2cfdc$var$zi(a) {
    switch(a.tag){
        case 1:
            $5c73342f5ab2cfdc$var$L(a.type) && $5c73342f5ab2cfdc$var$Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            $5c73342f5ab2cfdc$var$eh();
            $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K);
            $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error($5c73342f5ab2cfdc$var$u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return $5c73342f5ab2cfdc$var$gh(a), null;
        case 13:
            return $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M), null;
        case 4:
            return $5c73342f5ab2cfdc$var$eh(), null;
        case 10:
            return $5c73342f5ab2cfdc$var$og(a), null;
        default:
            return null;
    }
}
function $5c73342f5ab2cfdc$var$Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: $5c73342f5ab2cfdc$var$qb(b)
    };
}
var $5c73342f5ab2cfdc$var$Bi = "function" === typeof WeakSet ? WeakSet : Set;
function $5c73342f5ab2cfdc$var$Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $5c73342f5ab2cfdc$var$qb(c));
    null !== c && $5c73342f5ab2cfdc$var$pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $5c73342f5ab2cfdc$var$pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $5c73342f5ab2cfdc$var$Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $5c73342f5ab2cfdc$var$Ei(a, c);
    }
}
function $5c73342f5ab2cfdc$var$Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $5c73342f5ab2cfdc$var$Ei(a, c);
        }
        else b.current = null;
    }
}
function $5c73342f5ab2cfdc$var$Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $5c73342f5ab2cfdc$var$ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($5c73342f5ab2cfdc$var$u(163));
}
function $5c73342f5ab2cfdc$var$Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5c73342f5ab2cfdc$var$Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5c73342f5ab2cfdc$var$Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            $5c73342f5ab2cfdc$var$Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : $5c73342f5ab2cfdc$var$ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && $5c73342f5ab2cfdc$var$Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $5c73342f5ab2cfdc$var$Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && $5c73342f5ab2cfdc$var$Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $5c73342f5ab2cfdc$var$Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error($5c73342f5ab2cfdc$var$u(163));
}
function $5c73342f5ab2cfdc$var$Ki(a, b, c) {
    "function" === typeof $5c73342f5ab2cfdc$var$Li && $5c73342f5ab2cfdc$var$Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                $5c73342f5ab2cfdc$var$cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                $5c73342f5ab2cfdc$var$Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            $5c73342f5ab2cfdc$var$Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && $5c73342f5ab2cfdc$var$Di(b, c);
            break;
        case 5:
            $5c73342f5ab2cfdc$var$Fi(b);
            break;
        case 4:
            $5c73342f5ab2cfdc$var$Mi(a, b, c);
    }
}
function $5c73342f5ab2cfdc$var$Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && $5c73342f5ab2cfdc$var$Ni(b);
}
function $5c73342f5ab2cfdc$var$Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5c73342f5ab2cfdc$var$Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($5c73342f5ab2cfdc$var$Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error($5c73342f5ab2cfdc$var$u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($5c73342f5ab2cfdc$var$u(161));
    }
    c.effectTag & 16 && ($5c73342f5ab2cfdc$var$Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $5c73342f5ab2cfdc$var$Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $5c73342f5ab2cfdc$var$Qi(a, c, b) : $5c73342f5ab2cfdc$var$Ri(a, c, b);
}
function $5c73342f5ab2cfdc$var$Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5c73342f5ab2cfdc$var$sd));
    else if (4 !== d && (a = a.child, null !== a)) for($5c73342f5ab2cfdc$var$Qi(a, b, c), a = a.sibling; null !== a;)$5c73342f5ab2cfdc$var$Qi(a, b, c), a = a.sibling;
}
function $5c73342f5ab2cfdc$var$Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5c73342f5ab2cfdc$var$Ri(a, b, c), a = a.sibling; null !== a;)$5c73342f5ab2cfdc$var$Ri(a, b, c), a = a.sibling;
}
function $5c73342f5ab2cfdc$var$Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error($5c73342f5ab2cfdc$var$u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if ($5c73342f5ab2cfdc$var$Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if ($5c73342f5ab2cfdc$var$Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function $5c73342f5ab2cfdc$var$Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            $5c73342f5ab2cfdc$var$Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$5c73342f5ab2cfdc$var$Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && $5c73342f5ab2cfdc$var$Bb(c, d);
                    $5c73342f5ab2cfdc$var$pd(a, e);
                    b = $5c73342f5ab2cfdc$var$pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $5c73342f5ab2cfdc$var$md(c, h) : "dangerouslySetInnerHTML" === g ? $5c73342f5ab2cfdc$var$Qb(c, h) : "children" === g ? $5c73342f5ab2cfdc$var$Rb(c, h) : $5c73342f5ab2cfdc$var$Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $5c73342f5ab2cfdc$var$Cb(c, d);
                            break;
                        case "textarea":
                            $5c73342f5ab2cfdc$var$Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $5c73342f5ab2cfdc$var$Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $5c73342f5ab2cfdc$var$Hb(c, !!d.multiple, d.defaultValue, !0) : $5c73342f5ab2cfdc$var$Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($5c73342f5ab2cfdc$var$u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, $5c73342f5ab2cfdc$var$Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $5c73342f5ab2cfdc$var$Ti = $5c73342f5ab2cfdc$var$$f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $5c73342f5ab2cfdc$var$ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $5c73342f5ab2cfdc$var$Ui(b);
            return;
        case 19:
            $5c73342f5ab2cfdc$var$Ui(b);
            return;
        case 17:
            return;
    }
    throw Error($5c73342f5ab2cfdc$var$u(163));
}
function $5c73342f5ab2cfdc$var$Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5c73342f5ab2cfdc$var$Bi);
        b.forEach(function(b) {
            var d = $5c73342f5ab2cfdc$var$Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $5c73342f5ab2cfdc$var$Wi = "function" === typeof WeakMap ? WeakMap : Map;
function $5c73342f5ab2cfdc$var$Xi(a, b, c) {
    c = $5c73342f5ab2cfdc$var$wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5c73342f5ab2cfdc$var$Yi || ($5c73342f5ab2cfdc$var$Yi = !0, $5c73342f5ab2cfdc$var$Zi = d);
        $5c73342f5ab2cfdc$var$Ci(a, b);
    };
    return c;
}
function $5c73342f5ab2cfdc$var$$i(a, b, c) {
    c = $5c73342f5ab2cfdc$var$wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $5c73342f5ab2cfdc$var$Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $5c73342f5ab2cfdc$var$aj ? $5c73342f5ab2cfdc$var$aj = new Set([
            this
        ]) : $5c73342f5ab2cfdc$var$aj.add(this), $5c73342f5ab2cfdc$var$Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $5c73342f5ab2cfdc$var$bj = Math.ceil, $5c73342f5ab2cfdc$var$cj = $5c73342f5ab2cfdc$var$Wa.ReactCurrentDispatcher, $5c73342f5ab2cfdc$var$dj = $5c73342f5ab2cfdc$var$Wa.ReactCurrentOwner, $5c73342f5ab2cfdc$var$V = 0, $5c73342f5ab2cfdc$var$ej = 8, $5c73342f5ab2cfdc$var$fj = 16, $5c73342f5ab2cfdc$var$gj = 32, $5c73342f5ab2cfdc$var$ti = 0, $5c73342f5ab2cfdc$var$hj = 1, $5c73342f5ab2cfdc$var$ij = 2, $5c73342f5ab2cfdc$var$ui = 3, $5c73342f5ab2cfdc$var$vi = 4, $5c73342f5ab2cfdc$var$jj = 5, $5c73342f5ab2cfdc$var$W = $5c73342f5ab2cfdc$var$V, $5c73342f5ab2cfdc$var$T = null, $5c73342f5ab2cfdc$var$X = null, $5c73342f5ab2cfdc$var$U = 0, $5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$ti, $5c73342f5ab2cfdc$var$kj = null, $5c73342f5ab2cfdc$var$lj = 1073741823, $5c73342f5ab2cfdc$var$mj = 1073741823, $5c73342f5ab2cfdc$var$nj = null, $5c73342f5ab2cfdc$var$wi = 0, $5c73342f5ab2cfdc$var$oj = !1, $5c73342f5ab2cfdc$var$Ti = 0, $5c73342f5ab2cfdc$var$pj = 500, $5c73342f5ab2cfdc$var$Y = null, $5c73342f5ab2cfdc$var$Yi = !1, $5c73342f5ab2cfdc$var$Zi = null, $5c73342f5ab2cfdc$var$aj = null, $5c73342f5ab2cfdc$var$qj = !1, $5c73342f5ab2cfdc$var$rj = null, $5c73342f5ab2cfdc$var$sj = 90, $5c73342f5ab2cfdc$var$tj = null, $5c73342f5ab2cfdc$var$uj = 0, $5c73342f5ab2cfdc$var$vj = null, $5c73342f5ab2cfdc$var$wj = 0;
function $5c73342f5ab2cfdc$var$Gg() {
    return ($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V ? 1073741821 - ($5c73342f5ab2cfdc$var$$f() / 10 | 0) : 0 !== $5c73342f5ab2cfdc$var$wj ? $5c73342f5ab2cfdc$var$wj : $5c73342f5ab2cfdc$var$wj = 1073741821 - ($5c73342f5ab2cfdc$var$$f() / 10 | 0);
}
function $5c73342f5ab2cfdc$var$Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $5c73342f5ab2cfdc$var$ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($5c73342f5ab2cfdc$var$W & $5c73342f5ab2cfdc$var$fj) !== $5c73342f5ab2cfdc$var$V) return $5c73342f5ab2cfdc$var$U;
    if (null !== c) a = $5c73342f5ab2cfdc$var$hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = $5c73342f5ab2cfdc$var$hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = $5c73342f5ab2cfdc$var$hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error($5c73342f5ab2cfdc$var$u(326));
    }
    null !== $5c73342f5ab2cfdc$var$T && a === $5c73342f5ab2cfdc$var$U && --a;
    return a;
}
function $5c73342f5ab2cfdc$var$Ig(a, b) {
    if (50 < $5c73342f5ab2cfdc$var$uj) throw $5c73342f5ab2cfdc$var$uj = 0, $5c73342f5ab2cfdc$var$vj = null, Error($5c73342f5ab2cfdc$var$u(185));
    a = $5c73342f5ab2cfdc$var$xj(a, b);
    if (null !== a) {
        var c = $5c73342f5ab2cfdc$var$ag();
        1073741823 === b ? ($5c73342f5ab2cfdc$var$W & $5c73342f5ab2cfdc$var$ej) !== $5c73342f5ab2cfdc$var$V && ($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) === $5c73342f5ab2cfdc$var$V ? $5c73342f5ab2cfdc$var$yj(a) : ($5c73342f5ab2cfdc$var$Z(a), $5c73342f5ab2cfdc$var$W === $5c73342f5ab2cfdc$var$V && $5c73342f5ab2cfdc$var$gg()) : $5c73342f5ab2cfdc$var$Z(a);
        ($5c73342f5ab2cfdc$var$W & 4) === $5c73342f5ab2cfdc$var$V || 98 !== c && 99 !== c || (null === $5c73342f5ab2cfdc$var$tj ? $5c73342f5ab2cfdc$var$tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = $5c73342f5ab2cfdc$var$tj.get(a), (void 0 === c || c > b) && $5c73342f5ab2cfdc$var$tj.set(a, b)));
    }
}
function $5c73342f5ab2cfdc$var$xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && ($5c73342f5ab2cfdc$var$T === e && ($5c73342f5ab2cfdc$var$Bg(b), $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$vi && $5c73342f5ab2cfdc$var$xi(e, $5c73342f5ab2cfdc$var$U)), $5c73342f5ab2cfdc$var$yi(e, b));
    return e;
}
function $5c73342f5ab2cfdc$var$zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!$5c73342f5ab2cfdc$var$Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function $5c73342f5ab2cfdc$var$Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = $5c73342f5ab2cfdc$var$eg($5c73342f5ab2cfdc$var$yj.bind(null, a));
    else {
        var b = $5c73342f5ab2cfdc$var$zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = $5c73342f5ab2cfdc$var$Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== $5c73342f5ab2cfdc$var$Tf && $5c73342f5ab2cfdc$var$Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? $5c73342f5ab2cfdc$var$eg($5c73342f5ab2cfdc$var$yj.bind(null, a)) : $5c73342f5ab2cfdc$var$dg(d, $5c73342f5ab2cfdc$var$Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $5c73342f5ab2cfdc$var$$f()
            });
            a.callbackNode = b;
        }
    }
}
function $5c73342f5ab2cfdc$var$Bj(a, b) {
    $5c73342f5ab2cfdc$var$wj = 0;
    if (b) return b = $5c73342f5ab2cfdc$var$Gg(), $5c73342f5ab2cfdc$var$Cj(a, b), $5c73342f5ab2cfdc$var$Z(a), null;
    var c = $5c73342f5ab2cfdc$var$zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if (($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V) throw Error($5c73342f5ab2cfdc$var$u(327));
        $5c73342f5ab2cfdc$var$Dj();
        a === $5c73342f5ab2cfdc$var$T && c === $5c73342f5ab2cfdc$var$U || $5c73342f5ab2cfdc$var$Ej(a, c);
        if (null !== $5c73342f5ab2cfdc$var$X) {
            var d = $5c73342f5ab2cfdc$var$W;
            $5c73342f5ab2cfdc$var$W |= $5c73342f5ab2cfdc$var$fj;
            var e = $5c73342f5ab2cfdc$var$Fj();
            for(;;)try {
                $5c73342f5ab2cfdc$var$Gj();
                break;
            } catch (h) {
                $5c73342f5ab2cfdc$var$Hj(a, h);
            }
            $5c73342f5ab2cfdc$var$ng();
            $5c73342f5ab2cfdc$var$W = d;
            $5c73342f5ab2cfdc$var$cj.current = e;
            if ($5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$hj) throw b = $5c73342f5ab2cfdc$var$kj, $5c73342f5ab2cfdc$var$Ej(a, c), $5c73342f5ab2cfdc$var$xi(a, c), $5c73342f5ab2cfdc$var$Z(a), b;
            if (null === $5c73342f5ab2cfdc$var$X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = $5c73342f5ab2cfdc$var$S, $5c73342f5ab2cfdc$var$T = null, d){
                case $5c73342f5ab2cfdc$var$ti:
                case $5c73342f5ab2cfdc$var$hj:
                    throw Error($5c73342f5ab2cfdc$var$u(345));
                case $5c73342f5ab2cfdc$var$ij:
                    $5c73342f5ab2cfdc$var$Cj(a, 2 < c ? 2 : c);
                    break;
                case $5c73342f5ab2cfdc$var$ui:
                    $5c73342f5ab2cfdc$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $5c73342f5ab2cfdc$var$Ij(e));
                    if (1073741823 === $5c73342f5ab2cfdc$var$lj && (e = $5c73342f5ab2cfdc$var$Ti + $5c73342f5ab2cfdc$var$pj - $5c73342f5ab2cfdc$var$$f(), 10 < e)) {
                        if ($5c73342f5ab2cfdc$var$oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                $5c73342f5ab2cfdc$var$Ej(a, c);
                                break;
                            }
                        }
                        f = $5c73342f5ab2cfdc$var$zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = $5c73342f5ab2cfdc$var$Hd($5c73342f5ab2cfdc$var$Jj.bind(null, a), e);
                        break;
                    }
                    $5c73342f5ab2cfdc$var$Jj(a);
                    break;
                case $5c73342f5ab2cfdc$var$vi:
                    $5c73342f5ab2cfdc$var$xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = $5c73342f5ab2cfdc$var$Ij(e));
                    if ($5c73342f5ab2cfdc$var$oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        $5c73342f5ab2cfdc$var$Ej(a, c);
                        break;
                    }
                    e = $5c73342f5ab2cfdc$var$zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== $5c73342f5ab2cfdc$var$mj ? d = 10 * (1073741821 - $5c73342f5ab2cfdc$var$mj) - $5c73342f5ab2cfdc$var$$f() : 1073741823 === $5c73342f5ab2cfdc$var$lj ? d = 0 : (d = 10 * (1073741821 - $5c73342f5ab2cfdc$var$lj) - 5E3, e = $5c73342f5ab2cfdc$var$$f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5c73342f5ab2cfdc$var$bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = $5c73342f5ab2cfdc$var$Hd($5c73342f5ab2cfdc$var$Jj.bind(null, a), d);
                        break;
                    }
                    $5c73342f5ab2cfdc$var$Jj(a);
                    break;
                case $5c73342f5ab2cfdc$var$jj:
                    if (1073741823 !== $5c73342f5ab2cfdc$var$lj && null !== $5c73342f5ab2cfdc$var$nj) {
                        f = $5c73342f5ab2cfdc$var$lj;
                        var g = $5c73342f5ab2cfdc$var$nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $5c73342f5ab2cfdc$var$$f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            $5c73342f5ab2cfdc$var$xi(a, c);
                            a.timeoutHandle = $5c73342f5ab2cfdc$var$Hd($5c73342f5ab2cfdc$var$Jj.bind(null, a), d);
                            break;
                        }
                    }
                    $5c73342f5ab2cfdc$var$Jj(a);
                    break;
                default:
                    throw Error($5c73342f5ab2cfdc$var$u(329));
            }
            $5c73342f5ab2cfdc$var$Z(a);
            if (a.callbackNode === b) return $5c73342f5ab2cfdc$var$Bj.bind(null, a);
        }
    }
    return null;
}
function $5c73342f5ab2cfdc$var$yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if (($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V) throw Error($5c73342f5ab2cfdc$var$u(327));
    $5c73342f5ab2cfdc$var$Dj();
    a === $5c73342f5ab2cfdc$var$T && b === $5c73342f5ab2cfdc$var$U || $5c73342f5ab2cfdc$var$Ej(a, b);
    if (null !== $5c73342f5ab2cfdc$var$X) {
        var c = $5c73342f5ab2cfdc$var$W;
        $5c73342f5ab2cfdc$var$W |= $5c73342f5ab2cfdc$var$fj;
        var d = $5c73342f5ab2cfdc$var$Fj();
        for(;;)try {
            $5c73342f5ab2cfdc$var$Kj();
            break;
        } catch (e) {
            $5c73342f5ab2cfdc$var$Hj(a, e);
        }
        $5c73342f5ab2cfdc$var$ng();
        $5c73342f5ab2cfdc$var$W = c;
        $5c73342f5ab2cfdc$var$cj.current = d;
        if ($5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$hj) throw c = $5c73342f5ab2cfdc$var$kj, $5c73342f5ab2cfdc$var$Ej(a, b), $5c73342f5ab2cfdc$var$xi(a, b), $5c73342f5ab2cfdc$var$Z(a), c;
        if (null !== $5c73342f5ab2cfdc$var$X) throw Error($5c73342f5ab2cfdc$var$u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        $5c73342f5ab2cfdc$var$T = null;
        $5c73342f5ab2cfdc$var$Jj(a);
        $5c73342f5ab2cfdc$var$Z(a);
    }
    return null;
}
function $5c73342f5ab2cfdc$var$Lj() {
    if (null !== $5c73342f5ab2cfdc$var$tj) {
        var a = $5c73342f5ab2cfdc$var$tj;
        $5c73342f5ab2cfdc$var$tj = null;
        a.forEach(function(a, c) {
            $5c73342f5ab2cfdc$var$Cj(c, a);
            $5c73342f5ab2cfdc$var$Z(c);
        });
        $5c73342f5ab2cfdc$var$gg();
    }
}
function $5c73342f5ab2cfdc$var$Mj(a, b) {
    var c = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W |= 1;
    try {
        return a(b);
    } finally{
        $5c73342f5ab2cfdc$var$W = c, $5c73342f5ab2cfdc$var$W === $5c73342f5ab2cfdc$var$V && $5c73342f5ab2cfdc$var$gg();
    }
}
function $5c73342f5ab2cfdc$var$Nj(a, b) {
    var c = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W &= -2;
    $5c73342f5ab2cfdc$var$W |= $5c73342f5ab2cfdc$var$ej;
    try {
        return a(b);
    } finally{
        $5c73342f5ab2cfdc$var$W = c, $5c73342f5ab2cfdc$var$W === $5c73342f5ab2cfdc$var$V && $5c73342f5ab2cfdc$var$gg();
    }
}
function $5c73342f5ab2cfdc$var$Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5c73342f5ab2cfdc$var$Id(c));
    if (null !== $5c73342f5ab2cfdc$var$X) for(c = $5c73342f5ab2cfdc$var$X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5c73342f5ab2cfdc$var$Df();
                break;
            case 3:
                $5c73342f5ab2cfdc$var$eh();
                $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$K);
                $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$J);
                break;
            case 5:
                $5c73342f5ab2cfdc$var$gh(d);
                break;
            case 4:
                $5c73342f5ab2cfdc$var$eh();
                break;
            case 13:
                $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M);
                break;
            case 19:
                $5c73342f5ab2cfdc$var$H($5c73342f5ab2cfdc$var$M);
                break;
            case 10:
                $5c73342f5ab2cfdc$var$og(d);
        }
        c = c.return;
    }
    $5c73342f5ab2cfdc$var$T = a;
    $5c73342f5ab2cfdc$var$X = $5c73342f5ab2cfdc$var$Sg(a.current, null);
    $5c73342f5ab2cfdc$var$U = b;
    $5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$ti;
    $5c73342f5ab2cfdc$var$kj = null;
    $5c73342f5ab2cfdc$var$mj = $5c73342f5ab2cfdc$var$lj = 1073741823;
    $5c73342f5ab2cfdc$var$nj = null;
    $5c73342f5ab2cfdc$var$wi = 0;
    $5c73342f5ab2cfdc$var$oj = !1;
}
function $5c73342f5ab2cfdc$var$Hj(a, b) {
    do {
        try {
            $5c73342f5ab2cfdc$var$ng();
            $5c73342f5ab2cfdc$var$jh.current = $5c73342f5ab2cfdc$var$sh;
            if ($5c73342f5ab2cfdc$var$mh) for(var c = $5c73342f5ab2cfdc$var$N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            $5c73342f5ab2cfdc$var$lh = 0;
            $5c73342f5ab2cfdc$var$P = $5c73342f5ab2cfdc$var$O = $5c73342f5ab2cfdc$var$N = null;
            $5c73342f5ab2cfdc$var$mh = !1;
            if (null === $5c73342f5ab2cfdc$var$X || null === $5c73342f5ab2cfdc$var$X.return) return $5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$hj, $5c73342f5ab2cfdc$var$kj = b, $5c73342f5ab2cfdc$var$X = null;
            a: {
                var e = a, f = $5c73342f5ab2cfdc$var$X.return, g = $5c73342f5ab2cfdc$var$X, h = b;
                b = $5c73342f5ab2cfdc$var$U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== ($5c73342f5ab2cfdc$var$M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = $5c73342f5ab2cfdc$var$wg(1073741823, null);
                                        y.tag = 2;
                                        $5c73342f5ab2cfdc$var$xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new $5c73342f5ab2cfdc$var$Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = $5c73342f5ab2cfdc$var$Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error(($5c73342f5ab2cfdc$var$pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $5c73342f5ab2cfdc$var$qb(g));
                }
                $5c73342f5ab2cfdc$var$S !== $5c73342f5ab2cfdc$var$jj && ($5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$ij);
                h = $5c73342f5ab2cfdc$var$Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = $5c73342f5ab2cfdc$var$Xi(p, k, b);
                            $5c73342f5ab2cfdc$var$yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === $5c73342f5ab2cfdc$var$aj || !$5c73342f5ab2cfdc$var$aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $5c73342f5ab2cfdc$var$$i(p, k, b);
                                $5c73342f5ab2cfdc$var$yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $5c73342f5ab2cfdc$var$X = $5c73342f5ab2cfdc$var$Pj($5c73342f5ab2cfdc$var$X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function $5c73342f5ab2cfdc$var$Fj() {
    var a = $5c73342f5ab2cfdc$var$cj.current;
    $5c73342f5ab2cfdc$var$cj.current = $5c73342f5ab2cfdc$var$sh;
    return null === a ? $5c73342f5ab2cfdc$var$sh : a;
}
function $5c73342f5ab2cfdc$var$Ag(a, b) {
    a < $5c73342f5ab2cfdc$var$lj && 2 < a && ($5c73342f5ab2cfdc$var$lj = a);
    null !== b && a < $5c73342f5ab2cfdc$var$mj && 2 < a && ($5c73342f5ab2cfdc$var$mj = a, $5c73342f5ab2cfdc$var$nj = b);
}
function $5c73342f5ab2cfdc$var$Bg(a) {
    a > $5c73342f5ab2cfdc$var$wi && ($5c73342f5ab2cfdc$var$wi = a);
}
function $5c73342f5ab2cfdc$var$Kj() {
    for(; null !== $5c73342f5ab2cfdc$var$X;)$5c73342f5ab2cfdc$var$X = $5c73342f5ab2cfdc$var$Qj($5c73342f5ab2cfdc$var$X);
}
function $5c73342f5ab2cfdc$var$Gj() {
    for(; null !== $5c73342f5ab2cfdc$var$X && !$5c73342f5ab2cfdc$var$Uf();)$5c73342f5ab2cfdc$var$X = $5c73342f5ab2cfdc$var$Qj($5c73342f5ab2cfdc$var$X);
}
function $5c73342f5ab2cfdc$var$Qj(a) {
    var b = $5c73342f5ab2cfdc$var$Rj(a.alternate, a, $5c73342f5ab2cfdc$var$U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $5c73342f5ab2cfdc$var$Pj(a));
    $5c73342f5ab2cfdc$var$dj.current = null;
    return b;
}
function $5c73342f5ab2cfdc$var$Pj(a) {
    $5c73342f5ab2cfdc$var$X = a;
    do {
        var b = $5c73342f5ab2cfdc$var$X.alternate;
        a = $5c73342f5ab2cfdc$var$X.return;
        if (0 === ($5c73342f5ab2cfdc$var$X.effectTag & 2048)) {
            b = $5c73342f5ab2cfdc$var$si(b, $5c73342f5ab2cfdc$var$X, $5c73342f5ab2cfdc$var$U);
            if (1 === $5c73342f5ab2cfdc$var$U || 1 !== $5c73342f5ab2cfdc$var$X.childExpirationTime) {
                for(var c = 0, d = $5c73342f5ab2cfdc$var$X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                $5c73342f5ab2cfdc$var$X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = $5c73342f5ab2cfdc$var$X.firstEffect), null !== $5c73342f5ab2cfdc$var$X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $5c73342f5ab2cfdc$var$X.firstEffect), a.lastEffect = $5c73342f5ab2cfdc$var$X.lastEffect), 1 < $5c73342f5ab2cfdc$var$X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $5c73342f5ab2cfdc$var$X : a.firstEffect = $5c73342f5ab2cfdc$var$X, a.lastEffect = $5c73342f5ab2cfdc$var$X));
        } else {
            b = $5c73342f5ab2cfdc$var$zi($5c73342f5ab2cfdc$var$X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = $5c73342f5ab2cfdc$var$X.sibling;
        if (null !== b) return b;
        $5c73342f5ab2cfdc$var$X = a;
    }while (null !== $5c73342f5ab2cfdc$var$X);
    $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$ti && ($5c73342f5ab2cfdc$var$S = $5c73342f5ab2cfdc$var$jj);
    return null;
}
function $5c73342f5ab2cfdc$var$Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function $5c73342f5ab2cfdc$var$Jj(a) {
    var b = $5c73342f5ab2cfdc$var$ag();
    $5c73342f5ab2cfdc$var$cg(99, $5c73342f5ab2cfdc$var$Sj.bind(null, a, b));
    return null;
}
function $5c73342f5ab2cfdc$var$Sj(a, b) {
    do $5c73342f5ab2cfdc$var$Dj();
    while (null !== $5c73342f5ab2cfdc$var$rj);
    if (($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V) throw Error($5c73342f5ab2cfdc$var$u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error($5c73342f5ab2cfdc$var$u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = $5c73342f5ab2cfdc$var$Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === $5c73342f5ab2cfdc$var$T && ($5c73342f5ab2cfdc$var$X = $5c73342f5ab2cfdc$var$T = null, $5c73342f5ab2cfdc$var$U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = $5c73342f5ab2cfdc$var$W;
        $5c73342f5ab2cfdc$var$W |= $5c73342f5ab2cfdc$var$gj;
        $5c73342f5ab2cfdc$var$dj.current = null;
        $5c73342f5ab2cfdc$var$Dd = $5c73342f5ab2cfdc$var$fd;
        var g = $5c73342f5ab2cfdc$var$xd();
        if ($5c73342f5ab2cfdc$var$yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $5c73342f5ab2cfdc$var$Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        $5c73342f5ab2cfdc$var$fd = !1;
        $5c73342f5ab2cfdc$var$Y = e;
        do try {
            $5c73342f5ab2cfdc$var$Tj();
        } catch (wb) {
            if (null === $5c73342f5ab2cfdc$var$Y) throw Error($5c73342f5ab2cfdc$var$u(330));
            $5c73342f5ab2cfdc$var$Ei($5c73342f5ab2cfdc$var$Y, wb);
            $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
        }
        while (null !== $5c73342f5ab2cfdc$var$Y);
        $5c73342f5ab2cfdc$var$Y = e;
        do try {
            for(g = a, h = b; null !== $5c73342f5ab2cfdc$var$Y;){
                var q = $5c73342f5ab2cfdc$var$Y.effectTag;
                q & 16 && $5c73342f5ab2cfdc$var$Rb($5c73342f5ab2cfdc$var$Y.stateNode, "");
                if (q & 128) {
                    var B = $5c73342f5ab2cfdc$var$Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        $5c73342f5ab2cfdc$var$Pi($5c73342f5ab2cfdc$var$Y);
                        $5c73342f5ab2cfdc$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $5c73342f5ab2cfdc$var$Pi($5c73342f5ab2cfdc$var$Y);
                        $5c73342f5ab2cfdc$var$Y.effectTag &= -3;
                        $5c73342f5ab2cfdc$var$Si($5c73342f5ab2cfdc$var$Y.alternate, $5c73342f5ab2cfdc$var$Y);
                        break;
                    case 1024:
                        $5c73342f5ab2cfdc$var$Y.effectTag &= -1025;
                        break;
                    case 1028:
                        $5c73342f5ab2cfdc$var$Y.effectTag &= -1025;
                        $5c73342f5ab2cfdc$var$Si($5c73342f5ab2cfdc$var$Y.alternate, $5c73342f5ab2cfdc$var$Y);
                        break;
                    case 4:
                        $5c73342f5ab2cfdc$var$Si($5c73342f5ab2cfdc$var$Y.alternate, $5c73342f5ab2cfdc$var$Y);
                        break;
                    case 8:
                        l = $5c73342f5ab2cfdc$var$Y, $5c73342f5ab2cfdc$var$Mi(g, l, h), $5c73342f5ab2cfdc$var$Ni(l);
                }
                $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $5c73342f5ab2cfdc$var$Y) throw Error($5c73342f5ab2cfdc$var$u(330));
            $5c73342f5ab2cfdc$var$Ei($5c73342f5ab2cfdc$var$Y, wb);
            $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
        }
        while (null !== $5c73342f5ab2cfdc$var$Y);
        w = $5c73342f5ab2cfdc$var$Ed;
        B = $5c73342f5ab2cfdc$var$xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && $5c73342f5ab2cfdc$var$wd(q.ownerDocument.documentElement, q)) {
            null !== h && $5c73342f5ab2cfdc$var$yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = $5c73342f5ab2cfdc$var$vd(q, g), m = $5c73342f5ab2cfdc$var$vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        $5c73342f5ab2cfdc$var$fd = !!$5c73342f5ab2cfdc$var$Dd;
        $5c73342f5ab2cfdc$var$Ed = $5c73342f5ab2cfdc$var$Dd = null;
        a.current = c;
        $5c73342f5ab2cfdc$var$Y = e;
        do try {
            for(q = a; null !== $5c73342f5ab2cfdc$var$Y;){
                var ub = $5c73342f5ab2cfdc$var$Y.effectTag;
                ub & 36 && $5c73342f5ab2cfdc$var$Ji(q, $5c73342f5ab2cfdc$var$Y.alternate, $5c73342f5ab2cfdc$var$Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = $5c73342f5ab2cfdc$var$Y.ref;
                    if (null !== vb) {
                        var Xc = $5c73342f5ab2cfdc$var$Y.stateNode;
                        switch($5c73342f5ab2cfdc$var$Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
            }
        } catch (wb) {
            if (null === $5c73342f5ab2cfdc$var$Y) throw Error($5c73342f5ab2cfdc$var$u(330));
            $5c73342f5ab2cfdc$var$Ei($5c73342f5ab2cfdc$var$Y, wb);
            $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
        }
        while (null !== $5c73342f5ab2cfdc$var$Y);
        $5c73342f5ab2cfdc$var$Y = null;
        $5c73342f5ab2cfdc$var$Vf();
        $5c73342f5ab2cfdc$var$W = f;
    } else a.current = c;
    if ($5c73342f5ab2cfdc$var$qj) $5c73342f5ab2cfdc$var$qj = !1, $5c73342f5ab2cfdc$var$rj = a, $5c73342f5ab2cfdc$var$sj = b;
    else for($5c73342f5ab2cfdc$var$Y = e; null !== $5c73342f5ab2cfdc$var$Y;)b = $5c73342f5ab2cfdc$var$Y.nextEffect, $5c73342f5ab2cfdc$var$Y.nextEffect = null, $5c73342f5ab2cfdc$var$Y = b;
    b = a.firstPendingTime;
    0 === b && ($5c73342f5ab2cfdc$var$aj = null);
    1073741823 === b ? a === $5c73342f5ab2cfdc$var$vj ? $5c73342f5ab2cfdc$var$uj++ : ($5c73342f5ab2cfdc$var$uj = 0, $5c73342f5ab2cfdc$var$vj = a) : $5c73342f5ab2cfdc$var$uj = 0;
    "function" === typeof $5c73342f5ab2cfdc$var$Uj && $5c73342f5ab2cfdc$var$Uj(c.stateNode, d);
    $5c73342f5ab2cfdc$var$Z(a);
    if ($5c73342f5ab2cfdc$var$Yi) throw $5c73342f5ab2cfdc$var$Yi = !1, a = $5c73342f5ab2cfdc$var$Zi, $5c73342f5ab2cfdc$var$Zi = null, a;
    if (($5c73342f5ab2cfdc$var$W & $5c73342f5ab2cfdc$var$ej) !== $5c73342f5ab2cfdc$var$V) return null;
    $5c73342f5ab2cfdc$var$gg();
    return null;
}
function $5c73342f5ab2cfdc$var$Tj() {
    for(; null !== $5c73342f5ab2cfdc$var$Y;){
        var a = $5c73342f5ab2cfdc$var$Y.effectTag;
        0 !== (a & 256) && $5c73342f5ab2cfdc$var$Gi($5c73342f5ab2cfdc$var$Y.alternate, $5c73342f5ab2cfdc$var$Y);
        0 === (a & 512) || $5c73342f5ab2cfdc$var$qj || ($5c73342f5ab2cfdc$var$qj = !0, $5c73342f5ab2cfdc$var$dg(97, function() {
            $5c73342f5ab2cfdc$var$Dj();
            return null;
        }));
        $5c73342f5ab2cfdc$var$Y = $5c73342f5ab2cfdc$var$Y.nextEffect;
    }
}
function $5c73342f5ab2cfdc$var$Dj() {
    if (90 !== $5c73342f5ab2cfdc$var$sj) {
        var a = 97 < $5c73342f5ab2cfdc$var$sj ? 97 : $5c73342f5ab2cfdc$var$sj;
        $5c73342f5ab2cfdc$var$sj = 90;
        return $5c73342f5ab2cfdc$var$cg(a, $5c73342f5ab2cfdc$var$Vj);
    }
}
function $5c73342f5ab2cfdc$var$Vj() {
    if (null === $5c73342f5ab2cfdc$var$rj) return !1;
    var a = $5c73342f5ab2cfdc$var$rj;
    $5c73342f5ab2cfdc$var$rj = null;
    if (($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V) throw Error($5c73342f5ab2cfdc$var$u(331));
    var b = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W |= $5c73342f5ab2cfdc$var$gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    $5c73342f5ab2cfdc$var$Hi(5, c), $5c73342f5ab2cfdc$var$Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error($5c73342f5ab2cfdc$var$u(330));
            $5c73342f5ab2cfdc$var$Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $5c73342f5ab2cfdc$var$W = b;
    $5c73342f5ab2cfdc$var$gg();
    return !0;
}
function $5c73342f5ab2cfdc$var$Wj(a, b, c) {
    b = $5c73342f5ab2cfdc$var$Ai(c, b);
    b = $5c73342f5ab2cfdc$var$Xi(a, b, 1073741823);
    $5c73342f5ab2cfdc$var$xg(a, b);
    a = $5c73342f5ab2cfdc$var$xj(a, 1073741823);
    null !== a && $5c73342f5ab2cfdc$var$Z(a);
}
function $5c73342f5ab2cfdc$var$Ei(a, b) {
    if (3 === a.tag) $5c73342f5ab2cfdc$var$Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $5c73342f5ab2cfdc$var$Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5c73342f5ab2cfdc$var$aj || !$5c73342f5ab2cfdc$var$aj.has(d))) {
                a = $5c73342f5ab2cfdc$var$Ai(b, a);
                a = $5c73342f5ab2cfdc$var$$i(c, a, 1073741823);
                $5c73342f5ab2cfdc$var$xg(c, a);
                c = $5c73342f5ab2cfdc$var$xj(c, 1073741823);
                null !== c && $5c73342f5ab2cfdc$var$Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function $5c73342f5ab2cfdc$var$Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $5c73342f5ab2cfdc$var$T === a && $5c73342f5ab2cfdc$var$U === c ? $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$vi || $5c73342f5ab2cfdc$var$S === $5c73342f5ab2cfdc$var$ui && 1073741823 === $5c73342f5ab2cfdc$var$lj && $5c73342f5ab2cfdc$var$$f() - $5c73342f5ab2cfdc$var$Ti < $5c73342f5ab2cfdc$var$pj ? $5c73342f5ab2cfdc$var$Ej(a, $5c73342f5ab2cfdc$var$U) : $5c73342f5ab2cfdc$var$oj = !0 : $5c73342f5ab2cfdc$var$Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, $5c73342f5ab2cfdc$var$Z(a)));
}
function $5c73342f5ab2cfdc$var$Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = $5c73342f5ab2cfdc$var$Gg(), b = $5c73342f5ab2cfdc$var$Hg(b, a, null));
    a = $5c73342f5ab2cfdc$var$xj(a, b);
    null !== a && $5c73342f5ab2cfdc$var$Z(a);
}
var $5c73342f5ab2cfdc$var$Rj;
$5c73342f5ab2cfdc$var$Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $5c73342f5ab2cfdc$var$K.current) $5c73342f5ab2cfdc$var$rg = !0;
        else {
            if (d < c) {
                $5c73342f5ab2cfdc$var$rg = !1;
                switch(b.tag){
                    case 3:
                        $5c73342f5ab2cfdc$var$hi(b);
                        $5c73342f5ab2cfdc$var$Xh();
                        break;
                    case 5:
                        $5c73342f5ab2cfdc$var$fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        $5c73342f5ab2cfdc$var$L(b.type) && $5c73342f5ab2cfdc$var$Gf(b);
                        break;
                    case 4:
                        $5c73342f5ab2cfdc$var$dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return $5c73342f5ab2cfdc$var$ji(a, b, c);
                            $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, $5c73342f5ab2cfdc$var$M.current & 1);
                            b = $5c73342f5ab2cfdc$var$$h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, $5c73342f5ab2cfdc$var$M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return $5c73342f5ab2cfdc$var$mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$M, $5c73342f5ab2cfdc$var$M.current);
                        if (!d) return null;
                }
                return $5c73342f5ab2cfdc$var$$h(a, b, c);
            }
            $5c73342f5ab2cfdc$var$rg = !1;
        }
    } else $5c73342f5ab2cfdc$var$rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $5c73342f5ab2cfdc$var$Cf(b, $5c73342f5ab2cfdc$var$J.current);
            $5c73342f5ab2cfdc$var$qg(b, c);
            e = $5c73342f5ab2cfdc$var$oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($5c73342f5ab2cfdc$var$L(d)) {
                    var f = !0;
                    $5c73342f5ab2cfdc$var$Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $5c73342f5ab2cfdc$var$ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $5c73342f5ab2cfdc$var$Fg(b, d, g, a);
                e.updater = $5c73342f5ab2cfdc$var$Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $5c73342f5ab2cfdc$var$Ng(b, d, a, c);
                b = $5c73342f5ab2cfdc$var$gi(null, b, d, !0, f, c);
            } else b.tag = 0, $5c73342f5ab2cfdc$var$R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                $5c73342f5ab2cfdc$var$ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = $5c73342f5ab2cfdc$var$Xj(e);
                a = $5c73342f5ab2cfdc$var$ig(e, a);
                switch(f){
                    case 0:
                        b = $5c73342f5ab2cfdc$var$di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $5c73342f5ab2cfdc$var$fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $5c73342f5ab2cfdc$var$Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $5c73342f5ab2cfdc$var$ai(null, b, e, $5c73342f5ab2cfdc$var$ig(e.type, a), d, c);
                        break a;
                }
                throw Error($5c73342f5ab2cfdc$var$u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5c73342f5ab2cfdc$var$ig(d, e), $5c73342f5ab2cfdc$var$di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5c73342f5ab2cfdc$var$ig(d, e), $5c73342f5ab2cfdc$var$fi(a, b, d, e, c);
        case 3:
            $5c73342f5ab2cfdc$var$hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($5c73342f5ab2cfdc$var$u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $5c73342f5ab2cfdc$var$vg(a, b);
            $5c73342f5ab2cfdc$var$zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $5c73342f5ab2cfdc$var$Xh(), b = $5c73342f5ab2cfdc$var$$h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) $5c73342f5ab2cfdc$var$Ph = $5c73342f5ab2cfdc$var$Jd(b.stateNode.containerInfo.firstChild), $5c73342f5ab2cfdc$var$Oh = b, e = $5c73342f5ab2cfdc$var$Qh = !0;
                if (e) for(c = $5c73342f5ab2cfdc$var$Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else $5c73342f5ab2cfdc$var$R(a, b, d, c), $5c73342f5ab2cfdc$var$Xh();
                b = b.child;
            }
            return b;
        case 5:
            return $5c73342f5ab2cfdc$var$fh(b), null === a && $5c73342f5ab2cfdc$var$Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5c73342f5ab2cfdc$var$Gd(d, e) ? g = null : null !== f && $5c73342f5ab2cfdc$var$Gd(d, f) && (b.effectTag |= 16), $5c73342f5ab2cfdc$var$ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($5c73342f5ab2cfdc$var$R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && $5c73342f5ab2cfdc$var$Uh(b), null;
        case 13:
            return $5c73342f5ab2cfdc$var$ji(a, b, c);
        case 4:
            return $5c73342f5ab2cfdc$var$dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5c73342f5ab2cfdc$var$Xg(b, null, d, c) : $5c73342f5ab2cfdc$var$R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5c73342f5ab2cfdc$var$ig(d, e), $5c73342f5ab2cfdc$var$Zh(a, b, d, e, c);
        case 7:
            return $5c73342f5ab2cfdc$var$R(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5c73342f5ab2cfdc$var$R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5c73342f5ab2cfdc$var$R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $5c73342f5ab2cfdc$var$I($5c73342f5ab2cfdc$var$jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $5c73342f5ab2cfdc$var$$e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$5c73342f5ab2cfdc$var$K.current) {
                            b = $5c73342f5ab2cfdc$var$$h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $5c73342f5ab2cfdc$var$wg(c, null), l.tag = 2, $5c73342f5ab2cfdc$var$xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $5c73342f5ab2cfdc$var$pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $5c73342f5ab2cfdc$var$R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $5c73342f5ab2cfdc$var$qg(b, c), e = $5c73342f5ab2cfdc$var$sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $5c73342f5ab2cfdc$var$R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $5c73342f5ab2cfdc$var$ig(e, b.pendingProps), f = $5c73342f5ab2cfdc$var$ig(e.type, f), $5c73342f5ab2cfdc$var$ai(a, b, e, f, d, c);
        case 15:
            return $5c73342f5ab2cfdc$var$ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5c73342f5ab2cfdc$var$ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $5c73342f5ab2cfdc$var$L(d) ? (a = !0, $5c73342f5ab2cfdc$var$Gf(b)) : a = !1, $5c73342f5ab2cfdc$var$qg(b, c), $5c73342f5ab2cfdc$var$Lg(b, d, e), $5c73342f5ab2cfdc$var$Ng(b, d, e, c), $5c73342f5ab2cfdc$var$gi(null, b, d, !0, a, c);
        case 19:
            return $5c73342f5ab2cfdc$var$mi(a, b, c);
    }
    throw Error($5c73342f5ab2cfdc$var$u(156, b.tag));
};
var $5c73342f5ab2cfdc$var$Uj = null, $5c73342f5ab2cfdc$var$Li = null;
function $5c73342f5ab2cfdc$var$Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $5c73342f5ab2cfdc$var$Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $5c73342f5ab2cfdc$var$Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $5c73342f5ab2cfdc$var$Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $5c73342f5ab2cfdc$var$Sh(a, b, c, d) {
    return new $5c73342f5ab2cfdc$var$Zj(a, b, c, d);
}
function $5c73342f5ab2cfdc$var$bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5c73342f5ab2cfdc$var$Xj(a) {
    if ("function" === typeof a) return $5c73342f5ab2cfdc$var$bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5c73342f5ab2cfdc$var$gb) return 11;
        if (a === $5c73342f5ab2cfdc$var$jb) return 14;
    }
    return 2;
}
function $5c73342f5ab2cfdc$var$Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = $5c73342f5ab2cfdc$var$Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5c73342f5ab2cfdc$var$Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5c73342f5ab2cfdc$var$bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5c73342f5ab2cfdc$var$ab:
            return $5c73342f5ab2cfdc$var$Wg(c.children, e, f, b);
        case $5c73342f5ab2cfdc$var$fb:
            g = 8;
            e |= 7;
            break;
        case $5c73342f5ab2cfdc$var$bb:
            g = 8;
            e |= 1;
            break;
        case $5c73342f5ab2cfdc$var$cb:
            return a = $5c73342f5ab2cfdc$var$Sh(12, c, b, e | 8), a.elementType = $5c73342f5ab2cfdc$var$cb, a.type = $5c73342f5ab2cfdc$var$cb, a.expirationTime = f, a;
        case $5c73342f5ab2cfdc$var$hb:
            return a = $5c73342f5ab2cfdc$var$Sh(13, c, b, e), a.type = $5c73342f5ab2cfdc$var$hb, a.elementType = $5c73342f5ab2cfdc$var$hb, a.expirationTime = f, a;
        case $5c73342f5ab2cfdc$var$ib:
            return a = $5c73342f5ab2cfdc$var$Sh(19, c, b, e), a.elementType = $5c73342f5ab2cfdc$var$ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5c73342f5ab2cfdc$var$db:
                    g = 10;
                    break a;
                case $5c73342f5ab2cfdc$var$eb:
                    g = 9;
                    break a;
                case $5c73342f5ab2cfdc$var$gb:
                    g = 11;
                    break a;
                case $5c73342f5ab2cfdc$var$jb:
                    g = 14;
                    break a;
                case $5c73342f5ab2cfdc$var$kb:
                    g = 16;
                    d = null;
                    break a;
                case $5c73342f5ab2cfdc$var$lb:
                    g = 22;
                    break a;
            }
            throw Error($5c73342f5ab2cfdc$var$u(130, null == a ? a : typeof a, ""));
    }
    b = $5c73342f5ab2cfdc$var$Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $5c73342f5ab2cfdc$var$Wg(a, b, c, d) {
    a = $5c73342f5ab2cfdc$var$Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $5c73342f5ab2cfdc$var$Tg(a, b, c) {
    a = $5c73342f5ab2cfdc$var$Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $5c73342f5ab2cfdc$var$Vg(a, b, c) {
    b = $5c73342f5ab2cfdc$var$Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5c73342f5ab2cfdc$var$ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function $5c73342f5ab2cfdc$var$Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function $5c73342f5ab2cfdc$var$xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function $5c73342f5ab2cfdc$var$yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function $5c73342f5ab2cfdc$var$Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function $5c73342f5ab2cfdc$var$bk(a, b, c, d) {
    var e = b.current, f = $5c73342f5ab2cfdc$var$Gg(), g = $5c73342f5ab2cfdc$var$Dg.suspense;
    f = $5c73342f5ab2cfdc$var$Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if ($5c73342f5ab2cfdc$var$dc(c) !== c || 1 !== c.tag) throw Error($5c73342f5ab2cfdc$var$u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($5c73342f5ab2cfdc$var$L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($5c73342f5ab2cfdc$var$u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($5c73342f5ab2cfdc$var$L(k)) {
                c = $5c73342f5ab2cfdc$var$Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $5c73342f5ab2cfdc$var$Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5c73342f5ab2cfdc$var$wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $5c73342f5ab2cfdc$var$xg(e, b);
    $5c73342f5ab2cfdc$var$Ig(e, f);
    return f;
}
function $5c73342f5ab2cfdc$var$ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5c73342f5ab2cfdc$var$dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function $5c73342f5ab2cfdc$var$ek(a, b) {
    $5c73342f5ab2cfdc$var$dk(a, b);
    (a = a.alternate) && $5c73342f5ab2cfdc$var$dk(a, b);
}
function $5c73342f5ab2cfdc$var$fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new $5c73342f5ab2cfdc$var$ak(a, b, c), e = $5c73342f5ab2cfdc$var$Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    $5c73342f5ab2cfdc$var$ug(e);
    a[$5c73342f5ab2cfdc$var$Od] = d.current;
    c && 0 !== b && $5c73342f5ab2cfdc$var$Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
$5c73342f5ab2cfdc$var$fk.prototype.render = function(a) {
    $5c73342f5ab2cfdc$var$bk(a, this._internalRoot, null, null);
};
$5c73342f5ab2cfdc$var$fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $5c73342f5ab2cfdc$var$bk(null, a, null, function() {
        b[$5c73342f5ab2cfdc$var$Od] = null;
    });
};
function $5c73342f5ab2cfdc$var$gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5c73342f5ab2cfdc$var$hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $5c73342f5ab2cfdc$var$fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $5c73342f5ab2cfdc$var$ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5c73342f5ab2cfdc$var$ck(g);
                h.call(a);
            };
        }
        $5c73342f5ab2cfdc$var$bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $5c73342f5ab2cfdc$var$hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $5c73342f5ab2cfdc$var$ck(g);
                k.call(a);
            };
        }
        $5c73342f5ab2cfdc$var$Nj(function() {
            $5c73342f5ab2cfdc$var$bk(b, g, a, e);
        });
    }
    return $5c73342f5ab2cfdc$var$ck(g);
}
function $5c73342f5ab2cfdc$var$jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5c73342f5ab2cfdc$var$$a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$5c73342f5ab2cfdc$var$wc = function(a) {
    if (13 === a.tag) {
        var b = $5c73342f5ab2cfdc$var$hg($5c73342f5ab2cfdc$var$Gg(), 150, 100);
        $5c73342f5ab2cfdc$var$Ig(a, b);
        $5c73342f5ab2cfdc$var$ek(a, b);
    }
};
$5c73342f5ab2cfdc$var$xc = function(a) {
    13 === a.tag && ($5c73342f5ab2cfdc$var$Ig(a, 3), $5c73342f5ab2cfdc$var$ek(a, 3));
};
$5c73342f5ab2cfdc$var$yc = function(a) {
    if (13 === a.tag) {
        var b = $5c73342f5ab2cfdc$var$Gg();
        b = $5c73342f5ab2cfdc$var$Hg(b, a, null);
        $5c73342f5ab2cfdc$var$Ig(a, b);
        $5c73342f5ab2cfdc$var$ek(a, b);
    }
};
$5c73342f5ab2cfdc$var$za = function(a, b, c) {
    switch(b){
        case "input":
            $5c73342f5ab2cfdc$var$Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5c73342f5ab2cfdc$var$Qd(d);
                        if (!e) throw Error($5c73342f5ab2cfdc$var$u(90));
                        $5c73342f5ab2cfdc$var$yb(d);
                        $5c73342f5ab2cfdc$var$Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5c73342f5ab2cfdc$var$Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && $5c73342f5ab2cfdc$var$Hb(a, !!c.multiple, b, !1);
    }
};
$5c73342f5ab2cfdc$var$Fa = $5c73342f5ab2cfdc$var$Mj;
$5c73342f5ab2cfdc$var$Ga = function(a, b, c, d, e) {
    var f = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W |= 4;
    try {
        return $5c73342f5ab2cfdc$var$cg(98, a.bind(null, b, c, d, e));
    } finally{
        $5c73342f5ab2cfdc$var$W = f, $5c73342f5ab2cfdc$var$W === $5c73342f5ab2cfdc$var$V && $5c73342f5ab2cfdc$var$gg();
    }
};
$5c73342f5ab2cfdc$var$Ha = function() {
    ($5c73342f5ab2cfdc$var$W & (1 | $5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) === $5c73342f5ab2cfdc$var$V && ($5c73342f5ab2cfdc$var$Lj(), $5c73342f5ab2cfdc$var$Dj());
};
$5c73342f5ab2cfdc$var$Ia = function(a, b) {
    var c = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W |= 2;
    try {
        return a(b);
    } finally{
        $5c73342f5ab2cfdc$var$W = c, $5c73342f5ab2cfdc$var$W === $5c73342f5ab2cfdc$var$V && $5c73342f5ab2cfdc$var$gg();
    }
};
function $5c73342f5ab2cfdc$var$kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5c73342f5ab2cfdc$var$gk(b)) throw Error($5c73342f5ab2cfdc$var$u(200));
    return $5c73342f5ab2cfdc$var$jk(a, b, null, c);
}
var $5c73342f5ab2cfdc$var$lk = {
    Events: [
        $5c73342f5ab2cfdc$var$Nc,
        $5c73342f5ab2cfdc$var$Pd,
        $5c73342f5ab2cfdc$var$Qd,
        $5c73342f5ab2cfdc$var$xa,
        $5c73342f5ab2cfdc$var$ta,
        $5c73342f5ab2cfdc$var$Xd,
        function(a) {
            $5c73342f5ab2cfdc$var$jc(a, $5c73342f5ab2cfdc$var$Wd);
        },
        $5c73342f5ab2cfdc$var$Da,
        $5c73342f5ab2cfdc$var$Ea,
        $5c73342f5ab2cfdc$var$id,
        $5c73342f5ab2cfdc$var$mc,
        $5c73342f5ab2cfdc$var$Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return $5c73342f5ab2cfdc$var$Yj($dY3rW({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $5c73342f5ab2cfdc$var$Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $5c73342f5ab2cfdc$var$hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $5c73342f5ab2cfdc$var$tc,
    bundleType: 0,
    version: "16.13.1",
    rendererPackageName: "react-dom"
});
$5c73342f5ab2cfdc$export$ae55be85d98224ed = $5c73342f5ab2cfdc$var$lk;
$5c73342f5ab2cfdc$export$d39a5bbd09211389 = $5c73342f5ab2cfdc$var$kk;
$5c73342f5ab2cfdc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5c73342f5ab2cfdc$var$u(188));
        throw Error($5c73342f5ab2cfdc$var$u(268, Object.keys(a)));
    }
    a = $5c73342f5ab2cfdc$var$hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5c73342f5ab2cfdc$export$cd75ccfd720a3cd4 = function(a, b) {
    if (($5c73342f5ab2cfdc$var$W & ($5c73342f5ab2cfdc$var$fj | $5c73342f5ab2cfdc$var$gj)) !== $5c73342f5ab2cfdc$var$V) throw Error($5c73342f5ab2cfdc$var$u(187));
    var c = $5c73342f5ab2cfdc$var$W;
    $5c73342f5ab2cfdc$var$W |= 1;
    try {
        return $5c73342f5ab2cfdc$var$cg(99, a.bind(null, b));
    } finally{
        $5c73342f5ab2cfdc$var$W = c, $5c73342f5ab2cfdc$var$gg();
    }
};
$5c73342f5ab2cfdc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5c73342f5ab2cfdc$var$gk(b)) throw Error($5c73342f5ab2cfdc$var$u(200));
    return $5c73342f5ab2cfdc$var$ik(null, a, b, !0, c);
};
$5c73342f5ab2cfdc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5c73342f5ab2cfdc$var$gk(b)) throw Error($5c73342f5ab2cfdc$var$u(200));
    return $5c73342f5ab2cfdc$var$ik(null, a, b, !1, c);
};
$5c73342f5ab2cfdc$export$502457920280e6be = function(a) {
    if (!$5c73342f5ab2cfdc$var$gk(a)) throw Error($5c73342f5ab2cfdc$var$u(40));
    return a._reactRootContainer ? ($5c73342f5ab2cfdc$var$Nj(function() {
        $5c73342f5ab2cfdc$var$ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5c73342f5ab2cfdc$var$Od] = null;
        });
    }), !0) : !1;
};
$5c73342f5ab2cfdc$export$c78a37762a8d58e1 = $5c73342f5ab2cfdc$var$Mj;
$5c73342f5ab2cfdc$export$2577ef5d2565d52f = function(a, b) {
    return $5c73342f5ab2cfdc$var$kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$5c73342f5ab2cfdc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5c73342f5ab2cfdc$var$gk(c)) throw Error($5c73342f5ab2cfdc$var$u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error($5c73342f5ab2cfdc$var$u(38));
    return $5c73342f5ab2cfdc$var$ik(a, b, c, !1, d);
};
$5c73342f5ab2cfdc$export$83d89fbfd8236492 = "16.13.1";

});
parcelRequire.register("ayULB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gGmIA"));

});
parcelRequire.register("gGmIA", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c25230f1fa8f2112$export$c4744153514ff05d; }, function (v) { return $c25230f1fa8f2112$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c25230f1fa8f2112$export$d66a1c1c77bd778b; }, function (v) { return $c25230f1fa8f2112$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c25230f1fa8f2112$export$3e506c1ccc9cc1a7; }, function (v) { return $c25230f1fa8f2112$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c25230f1fa8f2112$export$e26fe2ed2fa76875; }, function (v) { return $c25230f1fa8f2112$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c25230f1fa8f2112$export$502329bbf4b505b1; }, function (v) { return $c25230f1fa8f2112$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c25230f1fa8f2112$export$6e3807111c4874c4; }, function (v) { return $c25230f1fa8f2112$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c25230f1fa8f2112$export$c27134553091fb3a; }, function (v) { return $c25230f1fa8f2112$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c25230f1fa8f2112$export$33ee1acdc04fd2a2; }, function (v) { return $c25230f1fa8f2112$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c25230f1fa8f2112$export$b00a404bbd5edef2; }, function (v) { return $c25230f1fa8f2112$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c25230f1fa8f2112$export$8352ce38b91d0c62; }, function (v) { return $c25230f1fa8f2112$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c25230f1fa8f2112$export$d3dfb8e4810cb555; }, function (v) { return $c25230f1fa8f2112$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c25230f1fa8f2112$export$839f9183b0465a69; }, function (v) { return $c25230f1fa8f2112$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c25230f1fa8f2112$export$72fdf0e06517287b; }, function (v) { return $c25230f1fa8f2112$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c25230f1fa8f2112$export$4b844e58a3e414b4; }, function (v) { return $c25230f1fa8f2112$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c25230f1fa8f2112$export$816d2913ae6b83b1; }, function (v) { return $c25230f1fa8f2112$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c25230f1fa8f2112$export$61bcfe829111a1d0; }, function (v) { return $c25230f1fa8f2112$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c25230f1fa8f2112$export$7ee8c9beb337bc3f; }, function (v) { return $c25230f1fa8f2112$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c25230f1fa8f2112$export$b5836b71941fa3ed; }, function (v) { return $c25230f1fa8f2112$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c25230f1fa8f2112$export$cf845f2c119da08a; }, function (v) { return $c25230f1fa8f2112$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c25230f1fa8f2112$export$c4744153514ff05d;
var $c25230f1fa8f2112$export$d66a1c1c77bd778b;
var $c25230f1fa8f2112$export$3e506c1ccc9cc1a7;
var $c25230f1fa8f2112$export$e26fe2ed2fa76875;
var $c25230f1fa8f2112$export$502329bbf4b505b1;
var $c25230f1fa8f2112$export$6e3807111c4874c4;
var $c25230f1fa8f2112$export$c27134553091fb3a;
var $c25230f1fa8f2112$export$33ee1acdc04fd2a2;
var $c25230f1fa8f2112$export$b00a404bbd5edef2;
var $c25230f1fa8f2112$export$8352ce38b91d0c62;
var $c25230f1fa8f2112$export$d3dfb8e4810cb555;
var $c25230f1fa8f2112$export$839f9183b0465a69;
var $c25230f1fa8f2112$export$72fdf0e06517287b;
var $c25230f1fa8f2112$export$4b844e58a3e414b4;
var $c25230f1fa8f2112$export$816d2913ae6b83b1;
var $c25230f1fa8f2112$export$61bcfe829111a1d0;
var $c25230f1fa8f2112$export$7ee8c9beb337bc3f;
var $c25230f1fa8f2112$export$b5836b71941fa3ed;
var $c25230f1fa8f2112$export$cf845f2c119da08a;
"use strict";
var $c25230f1fa8f2112$var$f, $c25230f1fa8f2112$var$g, $c25230f1fa8f2112$var$h, $c25230f1fa8f2112$var$k, $c25230f1fa8f2112$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $c25230f1fa8f2112$var$p = null, $c25230f1fa8f2112$var$q = null, $c25230f1fa8f2112$var$t = function() {
        if (null !== $c25230f1fa8f2112$var$p) try {
            var a = $c25230f1fa8f2112$export$c4744153514ff05d();
            $c25230f1fa8f2112$var$p(!0, a);
            $c25230f1fa8f2112$var$p = null;
        } catch (b) {
            throw setTimeout($c25230f1fa8f2112$var$t, 0), b;
        }
    }, $c25230f1fa8f2112$var$u = Date.now();
    $c25230f1fa8f2112$export$c4744153514ff05d = function() {
        return Date.now() - $c25230f1fa8f2112$var$u;
    };
    $c25230f1fa8f2112$var$f = function(a) {
        null !== $c25230f1fa8f2112$var$p ? setTimeout($c25230f1fa8f2112$var$f, 0, a) : ($c25230f1fa8f2112$var$p = a, setTimeout($c25230f1fa8f2112$var$t, 0));
    };
    $c25230f1fa8f2112$var$g = function(a, b) {
        $c25230f1fa8f2112$var$q = setTimeout(a, b);
    };
    $c25230f1fa8f2112$var$h = function() {
        clearTimeout($c25230f1fa8f2112$var$q);
    };
    $c25230f1fa8f2112$var$k = function() {
        return !1;
    };
    $c25230f1fa8f2112$var$l = $c25230f1fa8f2112$export$d66a1c1c77bd778b = function() {};
} else {
    var $c25230f1fa8f2112$var$w = window.performance, $c25230f1fa8f2112$var$x = window.Date, $c25230f1fa8f2112$var$y = window.setTimeout, $c25230f1fa8f2112$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $c25230f1fa8f2112$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $c25230f1fa8f2112$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $c25230f1fa8f2112$var$w && "function" === typeof $c25230f1fa8f2112$var$w.now) $c25230f1fa8f2112$export$c4744153514ff05d = function() {
        return $c25230f1fa8f2112$var$w.now();
    };
    else {
        var $c25230f1fa8f2112$var$B = $c25230f1fa8f2112$var$x.now();
        $c25230f1fa8f2112$export$c4744153514ff05d = function() {
            return $c25230f1fa8f2112$var$x.now() - $c25230f1fa8f2112$var$B;
        };
    }
    var $c25230f1fa8f2112$var$C = !1, $c25230f1fa8f2112$var$D = null, $c25230f1fa8f2112$var$E = -1, $c25230f1fa8f2112$var$F = 5, $c25230f1fa8f2112$var$G = 0;
    $c25230f1fa8f2112$var$k = function() {
        return $c25230f1fa8f2112$export$c4744153514ff05d() >= $c25230f1fa8f2112$var$G;
    };
    $c25230f1fa8f2112$var$l = function() {};
    $c25230f1fa8f2112$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $c25230f1fa8f2112$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $c25230f1fa8f2112$var$H = new MessageChannel, $c25230f1fa8f2112$var$I = $c25230f1fa8f2112$var$H.port2;
    $c25230f1fa8f2112$var$H.port1.onmessage = function() {
        if (null !== $c25230f1fa8f2112$var$D) {
            var a = $c25230f1fa8f2112$export$c4744153514ff05d();
            $c25230f1fa8f2112$var$G = a + $c25230f1fa8f2112$var$F;
            try {
                $c25230f1fa8f2112$var$D(!0, a) ? $c25230f1fa8f2112$var$I.postMessage(null) : ($c25230f1fa8f2112$var$C = !1, $c25230f1fa8f2112$var$D = null);
            } catch (b) {
                throw $c25230f1fa8f2112$var$I.postMessage(null), b;
            }
        } else $c25230f1fa8f2112$var$C = !1;
    };
    $c25230f1fa8f2112$var$f = function(a) {
        $c25230f1fa8f2112$var$D = a;
        $c25230f1fa8f2112$var$C || ($c25230f1fa8f2112$var$C = !0, $c25230f1fa8f2112$var$I.postMessage(null));
    };
    $c25230f1fa8f2112$var$g = function(a, b) {
        $c25230f1fa8f2112$var$E = $c25230f1fa8f2112$var$y(function() {
            a($c25230f1fa8f2112$export$c4744153514ff05d());
        }, b);
    };
    $c25230f1fa8f2112$var$h = function() {
        $c25230f1fa8f2112$var$z($c25230f1fa8f2112$var$E);
        $c25230f1fa8f2112$var$E = -1;
    };
}
function $c25230f1fa8f2112$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $c25230f1fa8f2112$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c25230f1fa8f2112$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $c25230f1fa8f2112$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $c25230f1fa8f2112$var$K(n, c)) void 0 !== r && 0 > $c25230f1fa8f2112$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $c25230f1fa8f2112$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $c25230f1fa8f2112$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $c25230f1fa8f2112$var$N = [], $c25230f1fa8f2112$var$O = [], $c25230f1fa8f2112$var$P = 1, $c25230f1fa8f2112$var$Q = null, $c25230f1fa8f2112$var$R = 3, $c25230f1fa8f2112$var$S = !1, $c25230f1fa8f2112$var$T = !1, $c25230f1fa8f2112$var$U = !1;
function $c25230f1fa8f2112$var$V(a) {
    for(var b = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$O); null !== b;){
        if (null === b.callback) $c25230f1fa8f2112$var$M($c25230f1fa8f2112$var$O);
        else if (b.startTime <= a) $c25230f1fa8f2112$var$M($c25230f1fa8f2112$var$O), b.sortIndex = b.expirationTime, $c25230f1fa8f2112$var$J($c25230f1fa8f2112$var$N, b);
        else break;
        b = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$O);
    }
}
function $c25230f1fa8f2112$var$W(a) {
    $c25230f1fa8f2112$var$U = !1;
    $c25230f1fa8f2112$var$V(a);
    if (!$c25230f1fa8f2112$var$T) {
        if (null !== $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N)) $c25230f1fa8f2112$var$T = !0, $c25230f1fa8f2112$var$f($c25230f1fa8f2112$var$X);
        else {
            var b = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$O);
            null !== b && $c25230f1fa8f2112$var$g($c25230f1fa8f2112$var$W, b.startTime - a);
        }
    }
}
function $c25230f1fa8f2112$var$X(a, b) {
    $c25230f1fa8f2112$var$T = !1;
    $c25230f1fa8f2112$var$U && ($c25230f1fa8f2112$var$U = !1, $c25230f1fa8f2112$var$h());
    $c25230f1fa8f2112$var$S = !0;
    var c = $c25230f1fa8f2112$var$R;
    try {
        $c25230f1fa8f2112$var$V(b);
        for($c25230f1fa8f2112$var$Q = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N); null !== $c25230f1fa8f2112$var$Q && (!($c25230f1fa8f2112$var$Q.expirationTime > b) || a && !$c25230f1fa8f2112$var$k());){
            var d = $c25230f1fa8f2112$var$Q.callback;
            if (null !== d) {
                $c25230f1fa8f2112$var$Q.callback = null;
                $c25230f1fa8f2112$var$R = $c25230f1fa8f2112$var$Q.priorityLevel;
                var e = d($c25230f1fa8f2112$var$Q.expirationTime <= b);
                b = $c25230f1fa8f2112$export$c4744153514ff05d();
                "function" === typeof e ? $c25230f1fa8f2112$var$Q.callback = e : $c25230f1fa8f2112$var$Q === $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N) && $c25230f1fa8f2112$var$M($c25230f1fa8f2112$var$N);
                $c25230f1fa8f2112$var$V(b);
            } else $c25230f1fa8f2112$var$M($c25230f1fa8f2112$var$N);
            $c25230f1fa8f2112$var$Q = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N);
        }
        if (null !== $c25230f1fa8f2112$var$Q) var m = !0;
        else {
            var n = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$O);
            null !== n && $c25230f1fa8f2112$var$g($c25230f1fa8f2112$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $c25230f1fa8f2112$var$Q = null, $c25230f1fa8f2112$var$R = c, $c25230f1fa8f2112$var$S = !1;
    }
}
function $c25230f1fa8f2112$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $c25230f1fa8f2112$var$Z = $c25230f1fa8f2112$var$l;
$c25230f1fa8f2112$export$3e506c1ccc9cc1a7 = 5;
$c25230f1fa8f2112$export$e26fe2ed2fa76875 = 1;
$c25230f1fa8f2112$export$502329bbf4b505b1 = 4;
$c25230f1fa8f2112$export$6e3807111c4874c4 = 3;
$c25230f1fa8f2112$export$c27134553091fb3a = null;
$c25230f1fa8f2112$export$33ee1acdc04fd2a2 = 2;
$c25230f1fa8f2112$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c25230f1fa8f2112$export$8352ce38b91d0c62 = function() {
    $c25230f1fa8f2112$var$T || $c25230f1fa8f2112$var$S || ($c25230f1fa8f2112$var$T = !0, $c25230f1fa8f2112$var$f($c25230f1fa8f2112$var$X));
};
$c25230f1fa8f2112$export$d3dfb8e4810cb555 = function() {
    return $c25230f1fa8f2112$var$R;
};
$c25230f1fa8f2112$export$839f9183b0465a69 = function() {
    return $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N);
};
$c25230f1fa8f2112$export$72fdf0e06517287b = function(a) {
    switch($c25230f1fa8f2112$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c25230f1fa8f2112$var$R;
    }
    var c = $c25230f1fa8f2112$var$R;
    $c25230f1fa8f2112$var$R = b;
    try {
        return a();
    } finally{
        $c25230f1fa8f2112$var$R = c;
    }
};
$c25230f1fa8f2112$export$4b844e58a3e414b4 = function() {};
$c25230f1fa8f2112$export$816d2913ae6b83b1 = $c25230f1fa8f2112$var$Z;
$c25230f1fa8f2112$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c25230f1fa8f2112$var$R;
    $c25230f1fa8f2112$var$R = a;
    try {
        return b();
    } finally{
        $c25230f1fa8f2112$var$R = c;
    }
};
$c25230f1fa8f2112$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c25230f1fa8f2112$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $c25230f1fa8f2112$var$Y(a);
    } else c = $c25230f1fa8f2112$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $c25230f1fa8f2112$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $c25230f1fa8f2112$var$J($c25230f1fa8f2112$var$O, a), null === $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N) && a === $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$O) && ($c25230f1fa8f2112$var$U ? $c25230f1fa8f2112$var$h() : $c25230f1fa8f2112$var$U = !0, $c25230f1fa8f2112$var$g($c25230f1fa8f2112$var$W, e - d))) : (a.sortIndex = c, $c25230f1fa8f2112$var$J($c25230f1fa8f2112$var$N, a), $c25230f1fa8f2112$var$T || $c25230f1fa8f2112$var$S || ($c25230f1fa8f2112$var$T = !0, $c25230f1fa8f2112$var$f($c25230f1fa8f2112$var$X)));
    return a;
};
$c25230f1fa8f2112$export$b5836b71941fa3ed = function() {
    var a = $c25230f1fa8f2112$export$c4744153514ff05d();
    $c25230f1fa8f2112$var$V(a);
    var b = $c25230f1fa8f2112$var$L($c25230f1fa8f2112$var$N);
    return b !== $c25230f1fa8f2112$var$Q && null !== $c25230f1fa8f2112$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $c25230f1fa8f2112$var$Q.expirationTime || $c25230f1fa8f2112$var$k();
};
$c25230f1fa8f2112$export$cf845f2c119da08a = function(a) {
    var b = $c25230f1fa8f2112$var$R;
    return function() {
        var c = $c25230f1fa8f2112$var$R;
        $c25230f1fa8f2112$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c25230f1fa8f2112$var$R = c;
        }
    };
};

});



parcelRequire.register("lar0q", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f68f7af05e7bf929$var$ReactIs, $f68f7af05e7bf929$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("aLayK"))();

});
parcelRequire.register("aLayK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $e9p0l = parcelRequire("e9p0l");
function $7d567c09797c7f89$var$emptyFunction() {}
function $7d567c09797c7f89$var$emptyFunctionWithReset() {}
$7d567c09797c7f89$var$emptyFunctionWithReset.resetWarningCache = $7d567c09797c7f89$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $e9p0l) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $7d567c09797c7f89$var$emptyFunctionWithReset,
        resetWarningCache: $7d567c09797c7f89$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("e9p0l", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $a4d54d5756ac7789$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $a4d54d5756ac7789$var$ReactPropTypesSecret;

});



parcelRequire.register("71HPt", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $51da9ff49396aa95$export$2b8d127b894957b9; }, function (v) { return $51da9ff49396aa95$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $51da9ff49396aa95$export$cea3a54a6425200c; }, function (v) { return $51da9ff49396aa95$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $51da9ff49396aa95$export$a7c73072b1a182ae; }, function (v) { return $51da9ff49396aa95$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $51da9ff49396aa95$export$9f27bc3417b4524d; }, function (v) { return $51da9ff49396aa95$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $51da9ff49396aa95$export$db77ccec0bb4ccac; }, function (v) { return $51da9ff49396aa95$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $51da9ff49396aa95$export$8392c0c9d3dcbd35; }, function (v) { return $51da9ff49396aa95$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $51da9ff49396aa95$export$ffb0004e005737fa; }, function (v) { return $51da9ff49396aa95$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $51da9ff49396aa95$export$b624eff549462981; }, function (v) { return $51da9ff49396aa95$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $51da9ff49396aa95$export$7897aa7841a5380c; }, function (v) { return $51da9ff49396aa95$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $51da9ff49396aa95$export$602eac185826482c; }, function (v) { return $51da9ff49396aa95$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $51da9ff49396aa95$export$e2c29f18771995cb; }, function (v) { return $51da9ff49396aa95$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $51da9ff49396aa95$export$5f8d39834fd61797; }, function (v) { return $51da9ff49396aa95$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $51da9ff49396aa95$export$74bf444e3cd11ea5; }, function (v) { return $51da9ff49396aa95$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $51da9ff49396aa95$export$92387174baf9b227; }, function (v) { return $51da9ff49396aa95$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $51da9ff49396aa95$export$ec112efeb987d9c6; }, function (v) { return $51da9ff49396aa95$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $51da9ff49396aa95$export$b706b080d889d2c9; }, function (v) { return $51da9ff49396aa95$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $51da9ff49396aa95$export$5be5a87408f70ddc; }, function (v) { return $51da9ff49396aa95$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $51da9ff49396aa95$export$45a5e7f76e0caa8d; }, function (v) { return $51da9ff49396aa95$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $51da9ff49396aa95$export$455c2e768291efa6; }, function (v) { return $51da9ff49396aa95$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $51da9ff49396aa95$export$9522e17588c12572; }, function (v) { return $51da9ff49396aa95$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $51da9ff49396aa95$export$2110ac352bb060b9; }, function (v) { return $51da9ff49396aa95$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $51da9ff49396aa95$export$56885ab8b9c456ab; }, function (v) { return $51da9ff49396aa95$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $51da9ff49396aa95$export$d927fcb6adf8f9de; }, function (v) { return $51da9ff49396aa95$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $51da9ff49396aa95$export$b82d16f27459e05a; }, function (v) { return $51da9ff49396aa95$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $51da9ff49396aa95$export$522c17b4f5e123e8; }, function (v) { return $51da9ff49396aa95$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $51da9ff49396aa95$export$1aabd8a0274ecfd6; }, function (v) { return $51da9ff49396aa95$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $51da9ff49396aa95$export$9b621391a187a31a; }, function (v) { return $51da9ff49396aa95$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $51da9ff49396aa95$export$f5bbd400c2f4426f; }, function (v) { return $51da9ff49396aa95$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $51da9ff49396aa95$export$2b8d127b894957b9;
var $51da9ff49396aa95$export$cea3a54a6425200c;
var $51da9ff49396aa95$export$a7c73072b1a182ae;
var $51da9ff49396aa95$export$9f27bc3417b4524d;
var $51da9ff49396aa95$export$db77ccec0bb4ccac;
var $51da9ff49396aa95$export$8392c0c9d3dcbd35;
var $51da9ff49396aa95$export$ffb0004e005737fa;
var $51da9ff49396aa95$export$b624eff549462981;
var $51da9ff49396aa95$export$7897aa7841a5380c;
var $51da9ff49396aa95$export$602eac185826482c;
var $51da9ff49396aa95$export$e2c29f18771995cb;
var $51da9ff49396aa95$export$5f8d39834fd61797;
var $51da9ff49396aa95$export$74bf444e3cd11ea5;
var $51da9ff49396aa95$export$92387174baf9b227;
var $51da9ff49396aa95$export$ec112efeb987d9c6;
var $51da9ff49396aa95$export$b706b080d889d2c9;
var $51da9ff49396aa95$export$5be5a87408f70ddc;
var $51da9ff49396aa95$export$45a5e7f76e0caa8d;
var $51da9ff49396aa95$export$455c2e768291efa6;
var $51da9ff49396aa95$export$9522e17588c12572;
var $51da9ff49396aa95$export$2110ac352bb060b9;
var $51da9ff49396aa95$export$56885ab8b9c456ab;
var $51da9ff49396aa95$export$d927fcb6adf8f9de;
var $51da9ff49396aa95$export$b82d16f27459e05a;
var $51da9ff49396aa95$export$522c17b4f5e123e8;
var $51da9ff49396aa95$export$1aabd8a0274ecfd6;
var $51da9ff49396aa95$export$9b621391a187a31a;
var $51da9ff49396aa95$export$f5bbd400c2f4426f;
"use strict";
var $51da9ff49396aa95$var$b = "function" === typeof Symbol && Symbol.for, $51da9ff49396aa95$var$c = $51da9ff49396aa95$var$b ? Symbol.for("react.element") : 60103, $51da9ff49396aa95$var$d = $51da9ff49396aa95$var$b ? Symbol.for("react.portal") : 60106, $51da9ff49396aa95$var$e = $51da9ff49396aa95$var$b ? Symbol.for("react.fragment") : 60107, $51da9ff49396aa95$var$f = $51da9ff49396aa95$var$b ? Symbol.for("react.strict_mode") : 60108, $51da9ff49396aa95$var$g = $51da9ff49396aa95$var$b ? Symbol.for("react.profiler") : 60114, $51da9ff49396aa95$var$h = $51da9ff49396aa95$var$b ? Symbol.for("react.provider") : 60109, $51da9ff49396aa95$var$k = $51da9ff49396aa95$var$b ? Symbol.for("react.context") : 60110, $51da9ff49396aa95$var$l = $51da9ff49396aa95$var$b ? Symbol.for("react.async_mode") : 60111, $51da9ff49396aa95$var$m = $51da9ff49396aa95$var$b ? Symbol.for("react.concurrent_mode") : 60111, $51da9ff49396aa95$var$n = $51da9ff49396aa95$var$b ? Symbol.for("react.forward_ref") : 60112, $51da9ff49396aa95$var$p = $51da9ff49396aa95$var$b ? Symbol.for("react.suspense") : 60113, $51da9ff49396aa95$var$q = $51da9ff49396aa95$var$b ? Symbol.for("react.suspense_list") : 60120, $51da9ff49396aa95$var$r = $51da9ff49396aa95$var$b ? Symbol.for("react.memo") : 60115, $51da9ff49396aa95$var$t = $51da9ff49396aa95$var$b ? Symbol.for("react.lazy") : 60116, $51da9ff49396aa95$var$v = $51da9ff49396aa95$var$b ? Symbol.for("react.block") : 60121, $51da9ff49396aa95$var$w = $51da9ff49396aa95$var$b ? Symbol.for("react.fundamental") : 60117, $51da9ff49396aa95$var$x = $51da9ff49396aa95$var$b ? Symbol.for("react.responder") : 60118, $51da9ff49396aa95$var$y = $51da9ff49396aa95$var$b ? Symbol.for("react.scope") : 60119;
function $51da9ff49396aa95$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $51da9ff49396aa95$var$c:
                switch(a = a.type, a){
                    case $51da9ff49396aa95$var$l:
                    case $51da9ff49396aa95$var$m:
                    case $51da9ff49396aa95$var$e:
                    case $51da9ff49396aa95$var$g:
                    case $51da9ff49396aa95$var$f:
                    case $51da9ff49396aa95$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $51da9ff49396aa95$var$k:
                            case $51da9ff49396aa95$var$n:
                            case $51da9ff49396aa95$var$t:
                            case $51da9ff49396aa95$var$r:
                            case $51da9ff49396aa95$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $51da9ff49396aa95$var$d:
                return u;
        }
    }
}
function $51da9ff49396aa95$var$A(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$m;
}
$51da9ff49396aa95$export$2b8d127b894957b9 = $51da9ff49396aa95$var$l;
$51da9ff49396aa95$export$cea3a54a6425200c = $51da9ff49396aa95$var$m;
$51da9ff49396aa95$export$a7c73072b1a182ae = $51da9ff49396aa95$var$k;
$51da9ff49396aa95$export$9f27bc3417b4524d = $51da9ff49396aa95$var$h;
$51da9ff49396aa95$export$db77ccec0bb4ccac = $51da9ff49396aa95$var$c;
$51da9ff49396aa95$export$8392c0c9d3dcbd35 = $51da9ff49396aa95$var$n;
$51da9ff49396aa95$export$ffb0004e005737fa = $51da9ff49396aa95$var$e;
$51da9ff49396aa95$export$b624eff549462981 = $51da9ff49396aa95$var$t;
$51da9ff49396aa95$export$7897aa7841a5380c = $51da9ff49396aa95$var$r;
$51da9ff49396aa95$export$602eac185826482c = $51da9ff49396aa95$var$d;
$51da9ff49396aa95$export$e2c29f18771995cb = $51da9ff49396aa95$var$g;
$51da9ff49396aa95$export$5f8d39834fd61797 = $51da9ff49396aa95$var$f;
$51da9ff49396aa95$export$74bf444e3cd11ea5 = $51da9ff49396aa95$var$p;
$51da9ff49396aa95$export$92387174baf9b227 = function(a) {
    return $51da9ff49396aa95$var$A(a) || $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$l;
};
$51da9ff49396aa95$export$ec112efeb987d9c6 = $51da9ff49396aa95$var$A;
$51da9ff49396aa95$export$b706b080d889d2c9 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$k;
};
$51da9ff49396aa95$export$5be5a87408f70ddc = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$h;
};
$51da9ff49396aa95$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $51da9ff49396aa95$var$c;
};
$51da9ff49396aa95$export$455c2e768291efa6 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$n;
};
$51da9ff49396aa95$export$9522e17588c12572 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$e;
};
$51da9ff49396aa95$export$2110ac352bb060b9 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$t;
};
$51da9ff49396aa95$export$56885ab8b9c456ab = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$r;
};
$51da9ff49396aa95$export$d927fcb6adf8f9de = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$d;
};
$51da9ff49396aa95$export$b82d16f27459e05a = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$g;
};
$51da9ff49396aa95$export$522c17b4f5e123e8 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$f;
};
$51da9ff49396aa95$export$1aabd8a0274ecfd6 = function(a) {
    return $51da9ff49396aa95$var$z(a) === $51da9ff49396aa95$var$p;
};
$51da9ff49396aa95$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $51da9ff49396aa95$var$e || a === $51da9ff49396aa95$var$m || a === $51da9ff49396aa95$var$g || a === $51da9ff49396aa95$var$f || a === $51da9ff49396aa95$var$p || a === $51da9ff49396aa95$var$q || "object" === typeof a && null !== a && (a.$$typeof === $51da9ff49396aa95$var$t || a.$$typeof === $51da9ff49396aa95$var$r || a.$$typeof === $51da9ff49396aa95$var$h || a.$$typeof === $51da9ff49396aa95$var$k || a.$$typeof === $51da9ff49396aa95$var$n || a.$$typeof === $51da9ff49396aa95$var$w || a.$$typeof === $51da9ff49396aa95$var$x || a.$$typeof === $51da9ff49396aa95$var$y || a.$$typeof === $51da9ff49396aa95$var$v);
};
$51da9ff49396aa95$export$f5bbd400c2f4426f = $51da9ff49396aa95$var$z;

});

parcelRequire.register("bON8d", function(module, exports) {
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $89aa79b972fea966$var$createSvgIcon;

var $89aa79b972fea966$var$_extends2 = $h59lg((parcelRequire("52Xx3")));

var $89aa79b972fea966$var$_react = $h59lg((parcelRequire("iluxG")));

var $89aa79b972fea966$var$_SvgIcon = $h59lg((parcelRequire("dXEbI")));
function $89aa79b972fea966$var$createSvgIcon(path, displayName) {
    var Component = $89aa79b972fea966$var$_react.default.memo($89aa79b972fea966$var$_react.default.forwardRef(function(props, ref) {
        return $89aa79b972fea966$var$_react.default.createElement($89aa79b972fea966$var$_SvgIcon.default, (0, $89aa79b972fea966$var$_extends2.default)({
            ref: ref
        }, props), path);
    }));
    Component.muiName = $89aa79b972fea966$var$_SvgIcon.default.muiName;
    return Component;
}

});
parcelRequire.register("h59lg", function(module, exports) {
function $03359543d6a155b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $03359543d6a155b5$var$_interopRequireDefault;

});

parcelRequire.register("52Xx3", function(module, exports) {
function $3acb518263adce08$var$_extends() {
    module.exports = $3acb518263adce08$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3acb518263adce08$var$_extends.apply(this, arguments);
}
module.exports = $3acb518263adce08$var$_extends;

});

parcelRequire.register("dXEbI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("eVYnJ")).default; });

var $eVYnJ = parcelRequire("eVYnJ");

});
parcelRequire.register("eVYnJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adf53a205df3042f$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $9iccj = parcelRequire("9iccj");
var $adf53a205df3042f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create("fill", {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: "inherit"
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $adf53a205df3042f$var$SvgIcon = /*#__PURE__*/ $iluxG.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "default" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $9iccj.default)(color))], fontSize !== "default" && classes["fontSize".concat((0, $9iccj.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $iluxG.createElement("title", null, titleAccess) : null);
});
$adf53a205df3042f$var$SvgIcon.muiName = "SvgIcon";
var $adf53a205df3042f$export$2e2bcd8739ae039 = (0, $kmV9n.default)($adf53a205df3042f$export$9dd6ff9ea0189349, {
    name: "MuiSvgIcon"
})($adf53a205df3042f$var$SvgIcon);

});
parcelRequire.register("7ZPk1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d260a5ba441b0ff$export$2e2bcd8739ae039; });
function $5d260a5ba441b0ff$export$2e2bcd8739ae039() {
    $5d260a5ba441b0ff$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d260a5ba441b0ff$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("anj8u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78dae55a478a16e4$export$2e2bcd8739ae039; });

var $eVoFv = parcelRequire("eVoFv");
function $78dae55a478a16e4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $eVoFv.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("eVoFv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $add986326cfe2c16$export$2e2bcd8739ae039; });
function $add986326cfe2c16$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("ao43X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78ff4c0de3e84f80$export$2e2bcd8739ae039; });
function $78ff4c0de3e84f80$var$toVal(mix) {
    var k, y, str = "";
    if (typeof mix === "string" || typeof mix === "number") str += mix;
    else if (typeof mix === "object") {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $78ff4c0de3e84f80$var$toVal(mix[k])) {
                    str && (str += " ");
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += " ");
                str += k;
            }
        }
    }
    return str;
}
function $78ff4c0de3e84f80$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = "";
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $78ff4c0de3e84f80$var$toVal(tmp)) {
                str && (str += " ");
                str += x;
            }
        }
    }
    return str;
}

});

parcelRequire.register("kmV9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed423191b3492355$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $gCTCT = parcelRequire("gCTCT");

var $66ydJ = parcelRequire("66ydJ");
function $ed423191b3492355$var$withStyles(stylesOrCreator, options) {
    return (0, $gCTCT.default)(stylesOrCreator, (0, $7ZPk1.default)({
        defaultTheme: (0, $66ydJ.default)
    }, options));
}
var $ed423191b3492355$export$2e2bcd8739ae039 = $ed423191b3492355$var$withStyles;

});
parcelRequire.register("gCTCT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1ab583365bbb4f4$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $bsPyj = parcelRequire("bsPyj");


var $5Lf8f = parcelRequire("5Lf8f");

var $aCszJ = parcelRequire("aCszJ");

var $cbfOl = parcelRequire("cbfOl");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $c1ab583365bbb4f4$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $anj8u.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $5Lf8f.default)(stylesOrCreator, (0, $7ZPk1.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $anj8u.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $7ZPk1.default)((0, $7ZPk1.default)({}, Component.defaultProps), props));
            var theme;
            var more = other;
            if (typeof name === "string" || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $cbfOl.default)() || defaultTheme;
                if (name) more = (0, $aCszJ.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement(Component, (0, $7ZPk1.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bsPyj)))(WithStyles, Component);
        return WithStyles;
    };
};
var $c1ab583365bbb4f4$export$2e2bcd8739ae039 = $c1ab583365bbb4f4$var$withStyles;

});
parcelRequire.register("bsPyj", function(module, exports) {
"use strict";

var $ebf3Z = parcelRequire("ebf3Z");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $858a4c744f763d43$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $858a4c744f763d43$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $858a4c744f763d43$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $858a4c744f763d43$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $858a4c744f763d43$var$TYPE_STATICS = {};
$858a4c744f763d43$var$TYPE_STATICS[$ebf3Z.ForwardRef] = $858a4c744f763d43$var$FORWARD_REF_STATICS;
$858a4c744f763d43$var$TYPE_STATICS[$ebf3Z.Memo] = $858a4c744f763d43$var$MEMO_STATICS;
function $858a4c744f763d43$var$getStatics(component) {
    // React v16.11 and below
    if ($ebf3Z.isMemo(component)) return $858a4c744f763d43$var$MEMO_STATICS;
     // React v16.12 and above
    return $858a4c744f763d43$var$TYPE_STATICS[component["$$typeof"]] || $858a4c744f763d43$var$REACT_STATICS;
}
var $858a4c744f763d43$var$defineProperty = Object.defineProperty;
var $858a4c744f763d43$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $858a4c744f763d43$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $858a4c744f763d43$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $858a4c744f763d43$var$getPrototypeOf = Object.getPrototypeOf;
var $858a4c744f763d43$var$objectPrototype = Object.prototype;
function $858a4c744f763d43$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($858a4c744f763d43$var$objectPrototype) {
            var inheritedComponent = $858a4c744f763d43$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $858a4c744f763d43$var$objectPrototype) $858a4c744f763d43$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $858a4c744f763d43$var$getOwnPropertyNames(sourceComponent);
        if ($858a4c744f763d43$var$getOwnPropertySymbols) keys = keys.concat($858a4c744f763d43$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $858a4c744f763d43$var$getStatics(targetComponent);
        var sourceStatics = $858a4c744f763d43$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$858a4c744f763d43$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $858a4c744f763d43$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $858a4c744f763d43$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $858a4c744f763d43$var$hoistNonReactStatics;

});
parcelRequire.register("ebf3Z", function(module, exports) {
"use strict";

module.exports = (parcelRequire("71HPt"));

});


parcelRequire.register("5Lf8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $431d146b3ad37542$export$2e2bcd8739ae039; });

var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");

var $j4Mj9 = parcelRequire("j4Mj9");

var $jNHyY = parcelRequire("jNHyY");

var $3qipv = parcelRequire("3qipv");

var $cbfOl = parcelRequire("cbfOl");

var $hv6uD = parcelRequire("hv6uD");

var $eVxqu = parcelRequire("eVxqu");

var $9Ytwm = parcelRequire("9Ytwm");

var $jqoXd = parcelRequire("jqoXd");
function $431d146b3ad37542$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $jNHyY.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $431d146b3ad37542$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3qipv.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $3qipv.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $7ZPk1.default)((0, $7ZPk1.default)((0, $7ZPk1.default)({}, stylesCreator.options), stylesOptions), {}, {
        theme: theme,
        flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $3qipv.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $7ZPk1.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $3qipv.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $j4Mj9.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $7ZPk1.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $jNHyY.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $431d146b3ad37542$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $431d146b3ad37542$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $3qipv.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $3qipv.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $431d146b3ad37542$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $431d146b3ad37542$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $jqoXd.default) : _options$defaultTheme, stylesOptions2 = (0, $anj8u.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $9Ytwm.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || "makeStyles";
    stylesCreator.options = {
        index: (0, $eVxqu.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $cbfOl.default)() || defaultTheme;
        var stylesOptions = (0, $7ZPk1.default)((0, $7ZPk1.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useContext((0, $hv6uD.StylesContext))), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef();
        $431d146b3ad37542$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $431d146b3ad37542$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $431d146b3ad37542$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useEffect(function() {
            if (shouldUpdate.current) $431d146b3ad37542$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $431d146b3ad37542$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRequire.register("j4Mj9", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return $de33dcfcb8a15c93$export$56e87122f905fac0; });
$parcel$export(module.exports, "toCssValue", function () { return $de33dcfcb8a15c93$export$5ac341d5e3cf9273; });
$parcel$export(module.exports, "RuleList", function () { return $de33dcfcb8a15c93$export$d9da2a13178d3d68; });
$parcel$export(module.exports, "getDynamicStyles", function () { return $de33dcfcb8a15c93$export$8558f2aefa046992; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return $de33dcfcb8a15c93$export$2305122a7d881dec; });
$parcel$export(module.exports, "create", function () { return $de33dcfcb8a15c93$export$185802fd694ee1f5; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $axBJp = parcelRequire("axBJp");

var $hvpPt = parcelRequire("hvpPt");

var $bC7Ef = parcelRequire("bC7Ef");

var $b2hvp = parcelRequire("b2hvp");

var $gvsJC = parcelRequire("gvsJC");

var $eVoFv = parcelRequire("eVoFv");
var $de33dcfcb8a15c93$var$plainObjectConstrurctor = {}.constructor;
function $de33dcfcb8a15c93$var$cloneStyle(style) {
    if (style == null || typeof style !== "object") return style;
    if (Array.isArray(style)) return style.map($de33dcfcb8a15c93$var$cloneStyle);
    if (style.constructor !== $de33dcfcb8a15c93$var$plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = $de33dcfcb8a15c93$var$cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function $de33dcfcb8a15c93$export$56e87122f905fac0(name, decl, options) {
    if (name === void 0) name = "unnamed";
    var jss = options.jss;
    var declCopy = $de33dcfcb8a15c93$var$cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var $de33dcfcb8a15c93$var$join = function join(value, by) {
    var result = "";
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === "!important") break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ function $de33dcfcb8a15c93$export$5ac341d5e3cf9273(value, ignoreImportant) {
    if (ignoreImportant === void 0) ignoreImportant = false;
    if (!Array.isArray(value)) return value;
    var cssValue = ""; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === "!important") break;
        if (cssValue) cssValue += ", ";
        cssValue += $de33dcfcb8a15c93$var$join(value[i], " ");
    }
    else cssValue = $de33dcfcb8a15c93$var$join(value, ", "); // Add !important, because it was ignored.
    if (!ignoreImportant && value[value.length - 1] === "!important") cssValue += " !important";
    return cssValue;
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function $de33dcfcb8a15c93$var$indentStr(str, indent) {
    var result = "";
    for(var index = 0; index < indent; index++)result += "  ";
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function $de33dcfcb8a15c93$var$toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = "";
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += "\n";
                    result += "" + $de33dcfcb8a15c93$var$indentStr(prop + ": " + $de33dcfcb8a15c93$export$5ac341d5e3cf9273(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += "\n";
                result += "" + $de33dcfcb8a15c93$var$indentStr(_prop + ": " + $de33dcfcb8a15c93$export$5ac341d5e3cf9273(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== "fallbacks") {
            if (result) result += "\n";
            result += "" + $de33dcfcb8a15c93$var$indentStr(_prop2 + ": " + $de33dcfcb8a15c93$export$5ac341d5e3cf9273(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "\n" + result + "\n";
    return $de33dcfcb8a15c93$var$indentStr(selector + " {" + result, indent) + $de33dcfcb8a15c93$var$indentStr("}", indent);
}
var $de33dcfcb8a15c93$var$escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var $de33dcfcb8a15c93$var$nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var $de33dcfcb8a15c93$var$escape = function(str) {
    return $de33dcfcb8a15c93$var$nativeEscape ? $de33dcfcb8a15c93$var$nativeEscape(str) : str.replace($de33dcfcb8a15c93$var$escapeRegex, "\\$1");
};
var $de33dcfcb8a15c93$var$BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = "style";
        this.key = void 0;
        this.isProcessed = false;
        this.style = void 0;
        this.renderer = void 0;
        this.renderable = void 0;
        this.options = void 0;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var $de33dcfcb8a15c93$var$StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $b2hvp.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        _this.selectorText = void 0;
        _this.id = void 0;
        _this.renderable = void 0;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $gvsJC.default)((0, $gvsJC.default)(_this)), sheet);
            _this.selectorText = "." + $de33dcfcb8a15c93$var$escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== "object") json[prop] = value;
            else if (Array.isArray(value)) json[prop] = $de33dcfcb8a15c93$export$5ac341d5e3cf9273(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7ZPk1.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $de33dcfcb8a15c93$var$toCss(this.selectorText, this.style, opts);
    };
    (0, $bC7Ef.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}($de33dcfcb8a15c93$var$BaseStyleRule);
var $de33dcfcb8a15c93$var$pluginStyleRule = {
    onCreateRule: function onCreateRule(name, style, options) {
        if (name[0] === "@" || options.parent && options.parent.type === "keyframes") return null;
        return new $de33dcfcb8a15c93$var$StyleRule(name, style, options);
    }
};
var $de33dcfcb8a15c93$var$defaultToStringOptions = {
    indent: 1,
    children: true
};
var $de33dcfcb8a15c93$var$atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var $de33dcfcb8a15c93$var$ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = "conditional";
        this.at = void 0;
        this.key = void 0;
        this.query = void 0;
        this.rules = void 0;
        this.options = void 0;
        this.isProcessed = false;
        this.renderable = void 0;
        this.key = key; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name;
        var atMatch = key.match($de33dcfcb8a15c93$var$atRegExp);
        this.at = atMatch ? atMatch[1] : "unknown";
        this.options = options;
        this.rules = new $de33dcfcb8a15c93$export$d9da2a13178d3d68((0, $7ZPk1.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $de33dcfcb8a15c93$var$defaultToStringOptions;
        if (options.indent == null) options.indent = $de33dcfcb8a15c93$var$defaultToStringOptions.indent;
        if (options.children == null) options.children = $de33dcfcb8a15c93$var$defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {\n" + children + "\n}" : "";
    };
    return ConditionalRule;
}();
var $de33dcfcb8a15c93$var$keyRegExp = /@media|@supports\s+/;
var $de33dcfcb8a15c93$var$pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return $de33dcfcb8a15c93$var$keyRegExp.test(key) ? new $de33dcfcb8a15c93$var$ConditionalRule(key, styles, options) : null;
    }
};
var $de33dcfcb8a15c93$var$defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var $de33dcfcb8a15c93$var$nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var $de33dcfcb8a15c93$var$KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = "keyframes";
        this.at = "@keyframes";
        this.key = void 0;
        this.name = void 0;
        this.id = void 0;
        this.rules = void 0;
        this.options = void 0;
        this.isProcessed = false;
        this.renderable = void 0;
        var nameMatch = key.match($de33dcfcb8a15c93$var$nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = "noname";
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : $de33dcfcb8a15c93$var$escape(generateId(this, sheet));
        this.rules = new $de33dcfcb8a15c93$export$d9da2a13178d3d68((0, $7ZPk1.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $7ZPk1.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = $de33dcfcb8a15c93$var$defaultToStringOptions$1;
        if (options.indent == null) options.indent = $de33dcfcb8a15c93$var$defaultToStringOptions$1.indent;
        if (options.children == null) options.children = $de33dcfcb8a15c93$var$defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "\n" + children + "\n";
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var $de33dcfcb8a15c93$var$keyRegExp$1 = /@keyframes\s+/;
var $de33dcfcb8a15c93$var$refRegExp = /\$([\w-]+)/g;
var $de33dcfcb8a15c93$var$findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === "string") return val.replace($de33dcfcb8a15c93$var$refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var $de33dcfcb8a15c93$var$replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = $de33dcfcb8a15c93$var$findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var $de33dcfcb8a15c93$var$plugin = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === "string" && $de33dcfcb8a15c93$var$keyRegExp$1.test(key) ? new $de33dcfcb8a15c93$var$KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style" || !sheet) return style;
        if ("animation-name" in style) $de33dcfcb8a15c93$var$replaceRef(style, "animation-name", sheet.keyframes);
        if ("animation" in style) $de33dcfcb8a15c93$var$replaceRef(style, "animation", sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case "animation":
                return $de33dcfcb8a15c93$var$findReferencedKeyframe(val, sheet.keyframes);
            case "animation-name":
                return $de33dcfcb8a15c93$var$findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var $de33dcfcb8a15c93$var$KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $b2hvp.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _BaseStyleRule.call.apply(_BaseStyleRule, [
            this
        ].concat(args)) || this;
        _this.renderable = void 0;
        return _this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7ZPk1.default)({}, options, {
            allowEmpty: true
        }) : options;
        return $de33dcfcb8a15c93$var$toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}($de33dcfcb8a15c93$var$BaseStyleRule);
var $de33dcfcb8a15c93$var$pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === "keyframes") return new $de33dcfcb8a15c93$var$KeyframeRule(key, style, options);
        return null;
    }
};
var $de33dcfcb8a15c93$var$FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = "font-face";
        this.at = "@font-face";
        this.key = void 0;
        this.style = void 0;
        this.options = void 0;
        this.isProcessed = false;
        this.renderable = void 0;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.style)) {
            var str = "";
            for(var index = 0; index < this.style.length; index++){
                str += $de33dcfcb8a15c93$var$toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += "\n";
            }
            return str;
        }
        return $de33dcfcb8a15c93$var$toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var $de33dcfcb8a15c93$var$keyRegExp$2 = /@font-face/;
var $de33dcfcb8a15c93$var$pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return $de33dcfcb8a15c93$var$keyRegExp$2.test(key) ? new $de33dcfcb8a15c93$var$FontFaceRule(key, style, options) : null;
    }
};
var $de33dcfcb8a15c93$var$ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = "viewport";
        this.at = "@viewport";
        this.key = void 0;
        this.style = void 0;
        this.options = void 0;
        this.isProcessed = false;
        this.renderable = void 0;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return $de33dcfcb8a15c93$var$toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var $de33dcfcb8a15c93$var$pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === "@viewport" || key === "@-ms-viewport" ? new $de33dcfcb8a15c93$var$ViewportRule(key, style, options) : null;
    }
};
var $de33dcfcb8a15c93$var$SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = "simple";
        this.key = void 0;
        this.value = void 0;
        this.options = void 0;
        this.isProcessed = false;
        this.renderable = void 0;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = "";
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += "\n";
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var $de33dcfcb8a15c93$var$keysMap = {
    "@charset": true,
    "@import": true,
    "@namespace": true
};
var $de33dcfcb8a15c93$var$pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in $de33dcfcb8a15c93$var$keysMap ? new $de33dcfcb8a15c93$var$SimpleRule(key, value, options) : null;
    }
};
var $de33dcfcb8a15c93$var$plugins = [
    $de33dcfcb8a15c93$var$pluginStyleRule,
    $de33dcfcb8a15c93$var$pluginConditionalRule,
    $de33dcfcb8a15c93$var$plugin,
    $de33dcfcb8a15c93$var$pluginKeyframeRule,
    $de33dcfcb8a15c93$var$pluginFontFaceRule,
    $de33dcfcb8a15c93$var$pluginViewportRule,
    $de33dcfcb8a15c93$var$pluginSimpleRule
];
var $de33dcfcb8a15c93$var$defaultUpdateOptions = {
    process: true
};
var $de33dcfcb8a15c93$var$forceUpdateOptions = {
    force: true,
    process: true
};
var $de33dcfcb8a15c93$export$d9da2a13178d3d68 = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = void 0;
        this.classes = void 0;
        this.keyframes = void 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $7ZPk1.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + $de33dcfcb8a15c93$var$escape(this.classes[key]);
        var rule = $de33dcfcb8a15c93$export$56e87122f905fac0(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Get a rule.
   */ ;
    _proto.get = function get(name) {
        return this.map[name];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof $de33dcfcb8a15c93$var$StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof $de33dcfcb8a15c93$var$KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof $de33dcfcb8a15c93$var$StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof $de33dcfcb8a15c93$var$KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === "string") {
            name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
            data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.map[name], data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = $de33dcfcb8a15c93$var$defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var styleRule = rule;
        var style = styleRule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== styleRule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
            for(var prop in styleRule.style){
                var nextValue = styleRule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) styleRule.prop(prop, nextValue, $de33dcfcb8a15c93$var$forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = styleRule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) styleRule.prop(_prop, null, $de33dcfcb8a15c93$var$forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = "";
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += "\n";
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var $de33dcfcb8a15c93$var$StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.options = void 0;
        this.deployed = void 0;
        this.attached = void 0;
        this.rules = void 0;
        this.renderer = void 0;
        this.classes = void 0;
        this.keyframes = void 0;
        this.queue = void 0;
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $7ZPk1.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new $de33dcfcb8a15c93$export$d9da2a13178d3d68(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name.
   */ ;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === "object" ? name : this.rules.get(name);
        if (!rule) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var $de33dcfcb8a15c93$var$PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = void 0;
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)// $FlowFixMe
        rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: "external"
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access them all at one place.
 */ var $de33dcfcb8a15c93$export$bcb2f1d96ff51db3 = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $eVoFv.default)(_ref, [
            "attached"
        ]);
        var css = "";
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += "\n";
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $bC7Ef.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af = new $de33dcfcb8a15c93$export$bcb2f1d96ff51db3();
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $de33dcfcb8a15c93$var$globalThis = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
var $de33dcfcb8a15c93$var$ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if ($de33dcfcb8a15c93$var$globalThis[$de33dcfcb8a15c93$var$ns] == null) $de33dcfcb8a15c93$var$globalThis[$de33dcfcb8a15c93$var$ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var $de33dcfcb8a15c93$var$moduleId = $de33dcfcb8a15c93$var$globalThis[$de33dcfcb8a15c93$var$ns]++;
var $de33dcfcb8a15c93$var$maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var $de33dcfcb8a15c93$export$ddff9cce7c732c82 = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    return function(rule, sheet) {
        ruleCounter += 1;
        var jssId = "";
        var prefix = "";
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || "c") + $de33dcfcb8a15c93$var$moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + $de33dcfcb8a15c93$var$moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
    };
};
/**
 * Cache the value from the first time a function is called.
 */ var $de33dcfcb8a15c93$var$memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ function $de33dcfcb8a15c93$var$getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return "";
    }
}
/**
 * Set a style property.
 */ function $de33dcfcb8a15c93$var$setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) {
            cssValue = $de33dcfcb8a15c93$export$5ac341d5e3cf9273(value, true);
            if (value[value.length - 1] === "!important") {
                cssRule.style.setProperty(prop, cssValue, "important");
                return true;
            }
        } // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
}
/**
 * Remove a style property.
 */ function $de33dcfcb8a15c93$var$removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
}
/**
 * Set the selector.
 */ function $de33dcfcb8a15c93$var$setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
}
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var $de33dcfcb8a15c93$var$getHead = $de33dcfcb8a15c93$var$memoize(function() {
    return document.querySelector("head");
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function $de33dcfcb8a15c93$var$findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function $de33dcfcb8a15c93$var$findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function $de33dcfcb8a15c93$var$findCommentNode(text) {
    var head = $de33dcfcb8a15c93$var$getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function $de33dcfcb8a15c93$var$findPrevNode(options) {
    var registry = $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = $de33dcfcb8a15c93$var$findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = $de33dcfcb8a15c93$var$findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === "string") {
        var comment = $de33dcfcb8a15c93$var$findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function $de33dcfcb8a15c93$var$insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = $de33dcfcb8a15c93$var$findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === "number") {
        // https://stackoverflow.com/questions/41328728/force-casting-in-flow
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    $de33dcfcb8a15c93$var$getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var $de33dcfcb8a15c93$var$getNonce = $de33dcfcb8a15c93$var$memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute("content") : null;
});
var $de33dcfcb8a15c93$var$_insertRule = function insertRule(container, rule, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    index = maxIndex;
    try {
        if ("insertRule" in container) {
            var c = container;
            c.insertRule(rule, index);
        } else if ("appendRule" in container) {
            var _c = container;
            _c.appendRule(rule);
        }
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var $de33dcfcb8a15c93$var$createStyle = function createStyle() {
    var el = document.createElement("style"); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = "\n";
    return el;
};
var $de33dcfcb8a15c93$var$DomRenderer = /*#__PURE__*/ function() {
    // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
    function DomRenderer(sheet) {
        this.getPropertyValue = $de33dcfcb8a15c93$var$getPropertyValue;
        this.setProperty = $de33dcfcb8a15c93$var$setProperty;
        this.removeProperty = $de33dcfcb8a15c93$var$removeProperty;
        this.setSelector = $de33dcfcb8a15c93$var$setSelector;
        this.element = void 0;
        this.sheet = void 0;
        this.hasInsertedRules = false;
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || $de33dcfcb8a15c93$var$createStyle();
        this.element.setAttribute("data-jss", "");
        if (media) this.element.setAttribute("media", media);
        if (meta) this.element.setAttribute("data-meta", meta);
        var nonce = $de33dcfcb8a15c93$var$getNonce();
        if (nonce) this.element.setAttribute("nonce", nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        $de33dcfcb8a15c93$var$insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element);
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === "conditional" || rule.type === "keyframes") {
                // We need to render the container without children first.
                latestNativeParent = $de33dcfcb8a15c93$var$_insertRule(nativeParent, parent.toString({
                    children: false
                }), index);
                if (latestNativeParent === false) return false;
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        } // IE keeps the CSSStyleSheet after style node has been reattached,
        // so we need to check if the `renderable` reference the right style sheet and not
        // rerender those rules.
        if (rule.renderable && rule.renderable.parentStyleSheet === this.element.sheet) return rule.renderable;
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var nativeRule = $de33dcfcb8a15c93$var$_insertRule(nativeParent, ruleStr, index);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        rule.renderable = nativeRule;
        return nativeRule;
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        var cssRules = this.element.sheet.cssRules;
        for(var index = 0; index < cssRules.length; index++){
            if (cssRule === cssRules[index]) return index;
        }
        return -1;
    } /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var $de33dcfcb8a15c93$var$instanceCounter = 0;
var $de33dcfcb8a15c93$var$Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = $de33dcfcb8a15c93$var$instanceCounter++;
        this.version = "10.3.0";
        this.plugins = new $de33dcfcb8a15c93$var$PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: $de33dcfcb8a15c93$export$ddff9cce7c732c82,
            Renderer: (0, $axBJp.default) ? $de33dcfcb8a15c93$var$DomRenderer : null,
            plugins: []
        };
        this.generateId = $de33dcfcb8a15c93$export$ddff9cce7c732c82({
            minify: false
        });
        for(var i = 0; i < $de33dcfcb8a15c93$var$plugins.length; i++)this.plugins.use($de33dcfcb8a15c93$var$plugins[i], {
            queue: "internal"
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $7ZPk1.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ("Renderer" in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== "number") index = $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af.index === 0 ? 0 : $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af.index + 1;
        var sheet = new $de33dcfcb8a15c93$var$StyleSheet(styles, (0, $7ZPk1.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        $de33dcfcb8a15c93$export$d1f2fc3a3d47c5af.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === "object") return this.createRule(undefined, name, style);
        var ruleOptions = (0, $7ZPk1.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = $de33dcfcb8a15c93$export$56e87122f905fac0(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
/**
 * Extracts a styles object with only props that contain function values.
 */ function $de33dcfcb8a15c93$export$8558f2aefa046992(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === "function") {
            if (!to) to = {};
            to[key] = value;
        } else if (type === "object" && value !== null && !Array.isArray(value)) {
            var extracted = $de33dcfcb8a15c93$export$8558f2aefa046992(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */ var $de33dcfcb8a15c93$export$c72bb5031d779271 = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $hvpPt.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $hvpPt.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $bC7Ef.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ /**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */ var $de33dcfcb8a15c93$export$2305122a7d881dec = typeof CSS !== "undefined" && CSS && "number" in CSS;
/**
 * Creates a new instance of Jss.
 */ var $de33dcfcb8a15c93$export$185802fd694ee1f5 = function create(options) {
    return new $de33dcfcb8a15c93$var$Jss(options);
};
/**
 * A global Jss instance.
 */ var $de33dcfcb8a15c93$var$index = $de33dcfcb8a15c93$export$185802fd694ee1f5();
var $de33dcfcb8a15c93$export$2e2bcd8739ae039 = $de33dcfcb8a15c93$var$index;

});
parcelRequire.register("axBJp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aca4124f9c9cdc7$export$2e2bcd8739ae039; });
var $7aca4124f9c9cdc7$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7aca4124f9c9cdc7$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $7aca4124f9c9cdc7$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $7aca4124f9c9cdc7$var$_typeof(document)) === "object" && document.nodeType === 9;
var $7aca4124f9c9cdc7$export$2e2bcd8739ae039 = $7aca4124f9c9cdc7$export$4e09c449d6c407f7;

});

parcelRequire.register("hvpPt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe95e14fbfbddf4$export$2e2bcd8739ae039; });
var $cbe95e14fbfbddf4$var$isProduction = true;
function $cbe95e14fbfbddf4$var$warning(condition, message) {
    if (!$cbe95e14fbfbddf4$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $cbe95e14fbfbddf4$export$2e2bcd8739ae039 = $cbe95e14fbfbddf4$var$warning;

});

parcelRequire.register("bC7Ef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87492d0f3cce467c$export$2e2bcd8739ae039; });
function $87492d0f3cce467c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87492d0f3cce467c$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $87492d0f3cce467c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87492d0f3cce467c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("b2hvp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $808d75dcc8c4ef66$export$2e2bcd8739ae039; });
function $808d75dcc8c4ef66$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}

});

parcelRequire.register("gvsJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c045d4b7e6a7ae2b$export$2e2bcd8739ae039; });
function $c045d4b7e6a7ae2b$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRequire.register("jNHyY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6a462a0f71daccc$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

function $e6a462a0f71daccc$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $7ZPk1.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRequire.register("3qipv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27e214bee6cbf793$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $27e214bee6cbf793$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $27e214bee6cbf793$export$2e2bcd8739ae039 = $27e214bee6cbf793$var$multiKeyStore;

});

parcelRequire.register("cbfOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de2c6db69472e42$export$2e2bcd8739ae039; });

var $iluxG = parcelRequire("iluxG");

var $gLWGL = parcelRequire("gLWGL");
function $8de2c6db69472e42$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useContext((0, $gLWGL.default));
    return theme;
}

});
parcelRequire.register("gLWGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c35e8f78532d73dd$export$2e2bcd8739ae039; });

var $iluxG = parcelRequire("iluxG");
var $c35e8f78532d73dd$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createContext(null);
var $c35e8f78532d73dd$export$2e2bcd8739ae039 = $c35e8f78532d73dd$var$ThemeContext;

});


parcelRequire.register("hv6uD", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $cbda5e4d549c5a53$export$f4de434b269fe487; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");



var $laGFy = parcelRequire("laGFy");

var $j4Mj9 = parcelRequire("j4Mj9");

var $7kXcU = parcelRequire("7kXcU");
var $cbda5e4d549c5a53$var$jss = (0, $j4Mj9.create)((0, $7kXcU.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $cbda5e4d549c5a53$var$generateClassName = (0, $laGFy.default)(); // Exported for test purposes
var $cbda5e4d549c5a53$export$70a8aea9ff58d1cd = new Map();
var $cbda5e4d549c5a53$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $cbda5e4d549c5a53$var$generateClassName,
    jss: $cbda5e4d549c5a53$var$jss,
    sheetsCache: null,
    sheetsManager: $cbda5e4d549c5a53$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $cbda5e4d549c5a53$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createContext($cbda5e4d549c5a53$var$defaultOptions);
var $cbda5e4d549c5a53$var$injectFirstNode;
function $cbda5e4d549c5a53$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $anj8u.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useContext($cbda5e4d549c5a53$export$f4de434b269fe487);
    var context = (0, $7ZPk1.default)((0, $7ZPk1.default)({}, outerOptions), {}, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
        if (!$cbda5e4d549c5a53$var$injectFirstNode) {
            var head = document.head;
            $cbda5e4d549c5a53$var$injectFirstNode = document.createComment("mui-inject-first");
            head.insertBefore($cbda5e4d549c5a53$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $j4Mj9.create)({
            plugins: (0, $7kXcU.default)().plugins,
            insertionPoint: $cbda5e4d549c5a53$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($cbda5e4d549c5a53$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRequire.register("laGFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69ba1641164f856$export$2e2bcd8739ae039; });

var $i5X2k = parcelRequire("i5X2k");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $f69ba1641164f856$var$pseudoClasses = [
    "checked",
    "disabled",
    "error",
    "focused",
    "focusVisible",
    "required",
    "expanded",
    "selected"
]; // Returns a function which generates unique class names based on counters.
function $f69ba1641164f856$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
    var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($f69ba1641164f856$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $i5X2k.default] || seed !== "") return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRequire.register("i5X2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2c67d0a9773499f$export$2e2bcd8739ae039; });
var $d2c67d0a9773499f$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $d2c67d0a9773499f$export$2e2bcd8739ae039 = $d2c67d0a9773499f$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRequire.register("7kXcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $557853fa18909a81$export$2e2bcd8739ae039; });

var $4VLE9 = parcelRequire("4VLE9");

var $jqdVw = parcelRequire("jqdVw");

var $94koO = parcelRequire("94koO");

var $w1Mr4 = parcelRequire("w1Mr4");

var $zd4e9 = parcelRequire("zd4e9");

var $kuRqh = parcelRequire("kuRqh");

var $f4u3I = parcelRequire("f4u3I");
function $557853fa18909a81$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $4VLE9.default)(),
            (0, $jqdVw.default)(),
            (0, $94koO.default)(),
            (0, $w1Mr4.default)(),
            (0, $zd4e9.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === "undefined" ? null : (0, $kuRqh.default)(),
            (0, $f4u3I.default)()
        ]
    };
}

});
parcelRequire.register("4VLE9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $397171e521e0cf83$export$2e2bcd8739ae039; });


var $j4Mj9 = parcelRequire("j4Mj9");
var $397171e521e0cf83$var$now = Date.now();
var $397171e521e0cf83$var$fnValuesNs = "fnValues" + $397171e521e0cf83$var$now;
var $397171e521e0cf83$var$fnRuleNs = "fnStyle" + ++$397171e521e0cf83$var$now;
function $397171e521e0cf83$var$functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== "function") return null;
            var rule = (0, $j4Mj9.createRule)(name, {}, options);
            rule[$397171e521e0cf83$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($397171e521e0cf83$var$fnValuesNs in rule || $397171e521e0cf83$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== "function") continue;
                delete style[prop];
                fnValues[prop] = value;
            } // $FlowFixMe
            rule[$397171e521e0cf83$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$397171e521e0cf83$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$397171e521e0cf83$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
}
var $397171e521e0cf83$export$2e2bcd8739ae039 = $397171e521e0cf83$var$functionPlugin;

});

parcelRequire.register("jqdVw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e23b3f975012ad7b$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $j4Mj9 = parcelRequire("j4Mj9");
var $e23b3f975012ad7b$var$at = "@global";
var $e23b3f975012ad7b$var$atPrefix = "@global ";
var $e23b3f975012ad7b$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = "global";
        this.at = $e23b3f975012ad7b$var$at;
        this.rules = void 0;
        this.options = void 0;
        this.key = void 0;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $j4Mj9.RuleList)((0, $7ZPk1.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString() {
        return this.rules.toString();
    };
    return GlobalContainerRule;
}();
var $e23b3f975012ad7b$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = "global";
        this.at = $e23b3f975012ad7b$var$at;
        this.options = void 0;
        this.rule = void 0;
        this.isProcessed = false;
        this.key = void 0;
        this.key = key;
        this.options = options;
        var selector = key.substr($e23b3f975012ad7b$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $7ZPk1.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : "";
    };
    return GlobalPrefixedRule;
}();
var $e23b3f975012ad7b$var$separatorRegExp = /\s*,\s*/g;
function $e23b3f975012ad7b$var$addScope(selector, scope) {
    var parts = selector.split($e23b3f975012ad7b$var$separatorRegExp);
    var scoped = "";
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ", ";
    }
    return scoped;
}
function $e23b3f975012ad7b$var$handleNestedGlobalContainerRule(rule) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$e23b3f975012ad7b$var$at] : null;
    if (!rules) return;
    for(var name in rules)options.sheet.addRule(name, rules[name], (0, $7ZPk1.default)({}, options, {
        selector: $e23b3f975012ad7b$var$addScope(name, rule.selector)
    }));
    delete style[$e23b3f975012ad7b$var$at];
}
function $e23b3f975012ad7b$var$handlePrefixedGlobalRule(rule) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== "@" || prop.substr(0, $e23b3f975012ad7b$var$at.length) !== $e23b3f975012ad7b$var$at) continue;
        var selector = $e23b3f975012ad7b$var$addScope(prop.substr($e23b3f975012ad7b$var$at.length), rule.selector);
        options.sheet.addRule(selector, style[prop], (0, $7ZPk1.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */ function $e23b3f975012ad7b$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $e23b3f975012ad7b$var$at) return new $e23b3f975012ad7b$var$GlobalContainerRule(name, styles, options);
        if (name[0] === "@" && name.substr(0, $e23b3f975012ad7b$var$atPrefix.length) === $e23b3f975012ad7b$var$atPrefix) return new $e23b3f975012ad7b$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") options.scoped = false;
        }
        if (options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule) {
        if (rule.type !== "style") return;
        $e23b3f975012ad7b$var$handleNestedGlobalContainerRule(rule);
        $e23b3f975012ad7b$var$handlePrefixedGlobalRule(rule);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $e23b3f975012ad7b$export$2e2bcd8739ae039 = $e23b3f975012ad7b$var$jssGlobal;

});

parcelRequire.register("94koO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69a44fa456e17062$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $69a44fa456e17062$var$separatorRegExp = /\s*,\s*/g;
var $69a44fa456e17062$var$parentRegExp = /&/g;
var $69a44fa456e17062$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */ function $69a44fa456e17062$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) {
                rule;
                return rule.selector;
            }
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($69a44fa456e17062$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($69a44fa456e17062$var$separatorRegExp);
        var result = "";
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ", "; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf("&") !== -1 ? nested.replace($69a44fa456e17062$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $7ZPk1.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $7ZPk1.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== "style") return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf("&") !== -1;
            var isNestedConditional = prop[0] === "@";
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($69a44fa456e17062$var$refRegExp, replaceRef);
                container.addRule(selector, style[prop], (0, $7ZPk1.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options) // Flow expects more options but they aren't required
            // And flow doesn't know this will always be a StyleRule which has the addRule method
            // $FlowFixMe
            .addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $69a44fa456e17062$export$2e2bcd8739ae039 = $69a44fa456e17062$var$jssNested;

});

parcelRequire.register("w1Mr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06045ec9de0f6df6$export$2e2bcd8739ae039; });

var $diKJY = parcelRequire("diKJY");
/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */ function $06045ec9de0f6df6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf("--") === 0 ? prop : (0, $diKJY.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($06045ec9de0f6df6$var$convertCase);
        else converted.fallbacks = $06045ec9de0f6df6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */ function $06045ec9de0f6df6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $06045ec9de0f6df6$var$convertCase(style[index]);
            return style;
        }
        return $06045ec9de0f6df6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf("--") === 0) return value;
        var hyphenatedProp = (0, $diKJY.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $06045ec9de0f6df6$export$2e2bcd8739ae039 = $06045ec9de0f6df6$var$camelCase;

});
parcelRequire.register("diKJY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af1367d0e14344b$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $9af1367d0e14344b$var$uppercasePattern = /[A-Z]/g;
var $9af1367d0e14344b$var$msPattern = /^ms-/;
var $9af1367d0e14344b$var$cache = {};
function $9af1367d0e14344b$var$toHyphenLower(match) {
    return "-" + match.toLowerCase();
}
function $9af1367d0e14344b$var$hyphenateStyleName(name) {
    if ($9af1367d0e14344b$var$cache.hasOwnProperty(name)) return $9af1367d0e14344b$var$cache[name];
    var hName = name.replace($9af1367d0e14344b$var$uppercasePattern, $9af1367d0e14344b$var$toHyphenLower);
    return $9af1367d0e14344b$var$cache[name] = $9af1367d0e14344b$var$msPattern.test(hName) ? "-" + hName : hName;
}
var $9af1367d0e14344b$export$2e2bcd8739ae039 = $9af1367d0e14344b$var$hyphenateStyleName;

});


parcelRequire.register("zd4e9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $069d67de8dcb149c$export$2e2bcd8739ae039; });

var $j4Mj9 = parcelRequire("j4Mj9");
var $069d67de8dcb149c$var$px = (0, $j4Mj9.hasCSSTOMSupport) && CSS ? CSS.px : "px";
var $069d67de8dcb149c$var$ms = (0, $j4Mj9.hasCSSTOMSupport) && CSS ? CSS.ms : "ms";
var $069d67de8dcb149c$var$percent = (0, $j4Mj9.hasCSSTOMSupport) && CSS ? CSS.percent : "%";
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */ var $069d67de8dcb149c$var$defaultUnits = {
    // Animation properties
    "animation-delay": $069d67de8dcb149c$var$ms,
    "animation-duration": $069d67de8dcb149c$var$ms,
    // Background properties
    "background-position": $069d67de8dcb149c$var$px,
    "background-position-x": $069d67de8dcb149c$var$px,
    "background-position-y": $069d67de8dcb149c$var$px,
    "background-size": $069d67de8dcb149c$var$px,
    // Border Properties
    border: $069d67de8dcb149c$var$px,
    "border-bottom": $069d67de8dcb149c$var$px,
    "border-bottom-left-radius": $069d67de8dcb149c$var$px,
    "border-bottom-right-radius": $069d67de8dcb149c$var$px,
    "border-bottom-width": $069d67de8dcb149c$var$px,
    "border-left": $069d67de8dcb149c$var$px,
    "border-left-width": $069d67de8dcb149c$var$px,
    "border-radius": $069d67de8dcb149c$var$px,
    "border-right": $069d67de8dcb149c$var$px,
    "border-right-width": $069d67de8dcb149c$var$px,
    "border-top": $069d67de8dcb149c$var$px,
    "border-top-left-radius": $069d67de8dcb149c$var$px,
    "border-top-right-radius": $069d67de8dcb149c$var$px,
    "border-top-width": $069d67de8dcb149c$var$px,
    "border-width": $069d67de8dcb149c$var$px,
    // Margin properties
    margin: $069d67de8dcb149c$var$px,
    "margin-bottom": $069d67de8dcb149c$var$px,
    "margin-left": $069d67de8dcb149c$var$px,
    "margin-right": $069d67de8dcb149c$var$px,
    "margin-top": $069d67de8dcb149c$var$px,
    // Padding properties
    padding: $069d67de8dcb149c$var$px,
    "padding-bottom": $069d67de8dcb149c$var$px,
    "padding-left": $069d67de8dcb149c$var$px,
    "padding-right": $069d67de8dcb149c$var$px,
    "padding-top": $069d67de8dcb149c$var$px,
    // Mask properties
    "mask-position-x": $069d67de8dcb149c$var$px,
    "mask-position-y": $069d67de8dcb149c$var$px,
    "mask-size": $069d67de8dcb149c$var$px,
    // Width and height properties
    height: $069d67de8dcb149c$var$px,
    width: $069d67de8dcb149c$var$px,
    "min-height": $069d67de8dcb149c$var$px,
    "max-height": $069d67de8dcb149c$var$px,
    "min-width": $069d67de8dcb149c$var$px,
    "max-width": $069d67de8dcb149c$var$px,
    // Position properties
    bottom: $069d67de8dcb149c$var$px,
    left: $069d67de8dcb149c$var$px,
    top: $069d67de8dcb149c$var$px,
    right: $069d67de8dcb149c$var$px,
    // Shadow properties
    "box-shadow": $069d67de8dcb149c$var$px,
    "text-shadow": $069d67de8dcb149c$var$px,
    // Column properties
    "column-gap": $069d67de8dcb149c$var$px,
    "column-rule": $069d67de8dcb149c$var$px,
    "column-rule-width": $069d67de8dcb149c$var$px,
    "column-width": $069d67de8dcb149c$var$px,
    // Font and text properties
    "font-size": $069d67de8dcb149c$var$px,
    "font-size-delta": $069d67de8dcb149c$var$px,
    "letter-spacing": $069d67de8dcb149c$var$px,
    "text-indent": $069d67de8dcb149c$var$px,
    "text-stroke": $069d67de8dcb149c$var$px,
    "text-stroke-width": $069d67de8dcb149c$var$px,
    "word-spacing": $069d67de8dcb149c$var$px,
    // Motion properties
    motion: $069d67de8dcb149c$var$px,
    "motion-offset": $069d67de8dcb149c$var$px,
    // Outline properties
    outline: $069d67de8dcb149c$var$px,
    "outline-offset": $069d67de8dcb149c$var$px,
    "outline-width": $069d67de8dcb149c$var$px,
    // Perspective properties
    perspective: $069d67de8dcb149c$var$px,
    "perspective-origin-x": $069d67de8dcb149c$var$percent,
    "perspective-origin-y": $069d67de8dcb149c$var$percent,
    // Transform properties
    "transform-origin": $069d67de8dcb149c$var$percent,
    "transform-origin-x": $069d67de8dcb149c$var$percent,
    "transform-origin-y": $069d67de8dcb149c$var$percent,
    "transform-origin-z": $069d67de8dcb149c$var$percent,
    // Transition properties
    "transition-delay": $069d67de8dcb149c$var$ms,
    "transition-duration": $069d67de8dcb149c$var$ms,
    // Alignment properties
    "vertical-align": $069d67de8dcb149c$var$px,
    "flex-basis": $069d67de8dcb149c$var$px,
    // Some random properties
    "shape-margin": $069d67de8dcb149c$var$px,
    size: $069d67de8dcb149c$var$px,
    // Grid properties
    grid: $069d67de8dcb149c$var$px,
    "grid-gap": $069d67de8dcb149c$var$px,
    "grid-row-gap": $069d67de8dcb149c$var$px,
    "grid-column-gap": $069d67de8dcb149c$var$px,
    "grid-template-rows": $069d67de8dcb149c$var$px,
    "grid-template-columns": $069d67de8dcb149c$var$px,
    "grid-auto-rows": $069d67de8dcb149c$var$px,
    "grid-auto-columns": $069d67de8dcb149c$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    "box-shadow-x": $069d67de8dcb149c$var$px,
    "box-shadow-y": $069d67de8dcb149c$var$px,
    "box-shadow-blur": $069d67de8dcb149c$var$px,
    "box-shadow-spread": $069d67de8dcb149c$var$px,
    "font-line-height": $069d67de8dcb149c$var$px,
    "text-shadow-x": $069d67de8dcb149c$var$px,
    "text-shadow-y": $069d67de8dcb149c$var$px,
    "text-shadow-blur": $069d67de8dcb149c$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $069d67de8dcb149c$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var _key in obj){
        newObj[_key] = obj[_key];
        newObj[_key.replace(regExp, replace)] = obj[_key];
    }
    return newObj;
}
var $069d67de8dcb149c$var$units = $069d67de8dcb149c$var$addCamelCasedVersion($069d67de8dcb149c$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $069d67de8dcb149c$var$iterate(prop, value, options) {
    if (!value) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $069d67de8dcb149c$var$iterate(prop, value[i], options);
    else if (typeof value === "object") {
        if (prop === "fallbacks") for(var innerProp in value)value[innerProp] = $069d67de8dcb149c$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $069d67de8dcb149c$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
    } else if (typeof value === "number") {
        var unit = options[prop] || $069d67de8dcb149c$var$units[prop];
        if (unit) return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $069d67de8dcb149c$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $069d67de8dcb149c$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        for(var prop in style)style[prop] = $069d67de8dcb149c$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $069d67de8dcb149c$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $069d67de8dcb149c$export$2e2bcd8739ae039 = $069d67de8dcb149c$var$defaultUnit;

});

parcelRequire.register("kuRqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eec00caa893f7761$export$2e2bcd8739ae039; });

var $e1yeB = parcelRequire("e1yeB");

var $j4Mj9 = parcelRequire("j4Mj9");
/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */ function $eec00caa893f7761$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === "keyframes") {
            var atRule = rule;
            atRule.at = (0, $e1yeB.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === "fallbacks" && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $e1yeB.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $e1yeB.supportedValue)(supportedProp, (0, $j4Mj9.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== "style") return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $e1yeB.supportedValue)(prop, (0, $j4Mj9.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $eec00caa893f7761$export$2e2bcd8739ae039 = $eec00caa893f7761$var$jssVendorPrefixer;

});
parcelRequire.register("e1yeB", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $a35bb6f54c177590$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $a35bb6f54c177590$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $a35bb6f54c177590$export$511766124059c277; });

var $axBJp = parcelRequire("axBJp");

var $cLm8E = parcelRequire("cLm8E");
// Export javascript style and css style vendor prefixes.
var $a35bb6f54c177590$var$js = "";
var $a35bb6f54c177590$var$css = "";
var $a35bb6f54c177590$var$vendor = "";
var $a35bb6f54c177590$var$browser = "";
var $a35bb6f54c177590$var$isTouch = (0, $axBJp.default) && "ontouchstart" in document.documentElement; // We should not do anything if required serverside.
if (0, $axBJp.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $a35bb6f54c177590$var$jsCssMap = {
        Moz: "-moz-",
        ms: "-ms-",
        O: "-o-",
        Webkit: "-webkit-"
    };
    var $a35bb6f54c177590$var$_document$createEleme = document.createElement("p"), $a35bb6f54c177590$var$style = $a35bb6f54c177590$var$_document$createEleme.style;
    var $a35bb6f54c177590$var$testProp = "Transform";
    for(var $a35bb6f54c177590$var$key in $a35bb6f54c177590$var$jsCssMap)if ($a35bb6f54c177590$var$key + $a35bb6f54c177590$var$testProp in $a35bb6f54c177590$var$style) {
        $a35bb6f54c177590$var$js = $a35bb6f54c177590$var$key;
        $a35bb6f54c177590$var$css = $a35bb6f54c177590$var$jsCssMap[$a35bb6f54c177590$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($a35bb6f54c177590$var$js === "Webkit" && "msHyphens" in $a35bb6f54c177590$var$style) {
        $a35bb6f54c177590$var$js = "ms";
        $a35bb6f54c177590$var$css = $a35bb6f54c177590$var$jsCssMap.ms;
        $a35bb6f54c177590$var$browser = "edge";
    } // Correctly detect the Safari browser.
    if ($a35bb6f54c177590$var$js === "Webkit" && "-apple-trailing-word" in $a35bb6f54c177590$var$style) $a35bb6f54c177590$var$vendor = "apple";
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $a35bb6f54c177590$export$82e9f45cca5ba907 = {
    js: $a35bb6f54c177590$var$js,
    css: $a35bb6f54c177590$var$css,
    vendor: $a35bb6f54c177590$var$vendor,
    browser: $a35bb6f54c177590$var$browser,
    isTouch: $a35bb6f54c177590$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $a35bb6f54c177590$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === "-") return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms") return key;
    return "@" + $a35bb6f54c177590$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $a35bb6f54c177590$var$appearence = {
    noPrefill: [
        "appearance"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "appearance") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms") return "-webkit-" + prop;
        return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $a35bb6f54c177590$var$colorAdjust = {
    noPrefill: [
        "color-adjust"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "color-adjust") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Webkit") return $a35bb6f54c177590$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $a35bb6f54c177590$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $a35bb6f54c177590$var$toUpper(match, c) {
    return c ? c.toUpperCase() : "";
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $a35bb6f54c177590$var$camelize(str) {
    return str.replace($a35bb6f54c177590$var$regExp, $a35bb6f54c177590$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $a35bb6f54c177590$var$pascalize(str) {
    return $a35bb6f54c177590$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $a35bb6f54c177590$var$mask = {
    noPrefill: [
        "mask"
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Webkit") {
            var longhand = "mask-image";
            if ($a35bb6f54c177590$var$camelize(longhand) in style) return prop;
            if ($a35bb6f54c177590$export$82e9f45cca5ba907.js + $a35bb6f54c177590$var$pascalize(longhand) in style) return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $a35bb6f54c177590$var$textOrientation = {
    noPrefill: [
        "text-orientation"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "text-orientation") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.vendor === "apple" && !$a35bb6f54c177590$export$82e9f45cca5ba907.isTouch) return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $a35bb6f54c177590$var$transform = {
    noPrefill: [
        "transform"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transform") return false;
        if (options.transform) return prop;
        return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $a35bb6f54c177590$var$transition = {
    noPrefill: [
        "transition"
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== "transition") return false;
        if (options.transition) return prop;
        return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $a35bb6f54c177590$var$writingMode = {
    noPrefill: [
        "writing-mode"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "writing-mode") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Webkit" || $a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms" && $a35bb6f54c177590$export$82e9f45cca5ba907.browser !== "edge") return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $a35bb6f54c177590$var$userSelect = {
    noPrefill: [
        "user-select"
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "user-select") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Moz" || $a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms" || $a35bb6f54c177590$export$82e9f45cca5ba907.vendor === "apple") return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $a35bb6f54c177590$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Webkit") {
            var jsProp = "WebkitColumn" + $a35bb6f54c177590$var$pascalize(prop);
            return jsProp in style ? $a35bb6f54c177590$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Moz") {
            var _jsProp = "page" + $a35bb6f54c177590$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $a35bb6f54c177590$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "Moz") return prop;
        var newProp = prop.replace("-inline", "");
        return $a35bb6f54c177590$export$82e9f45cca5ba907.js + $a35bb6f54c177590$var$pascalize(newProp) in style ? $a35bb6f54c177590$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $a35bb6f54c177590$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $a35bb6f54c177590$var$camelize(prop) in style ? prop : false;
    }
};
var $a35bb6f54c177590$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $a35bb6f54c177590$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === "-") return prop; // Return already prefixed value without prefixing.
        if (prop[0] === "-" && prop[1] === "-") return prop;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js + pascalized in style) return $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js !== "Webkit" && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $a35bb6f54c177590$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== "scroll-snap") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms") return "" + $a35bb6f54c177590$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $a35bb6f54c177590$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== "overscroll-behavior") return false;
        if ($a35bb6f54c177590$export$82e9f45cca5ba907.js === "ms") return $a35bb6f54c177590$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $a35bb6f54c177590$var$propMap = {
    "flex-grow": "flex-positive",
    "flex-shrink": "flex-negative",
    "flex-basis": "flex-preferred-size",
    "justify-content": "flex-pack",
    order: "flex-order",
    "align-items": "flex-align",
    "align-content": "flex-line-pack" // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $a35bb6f54c177590$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $a35bb6f54c177590$var$propMap[prop];
        if (!newProp) return false;
        return $a35bb6f54c177590$export$82e9f45cca5ba907.js + $a35bb6f54c177590$var$pascalize(newProp) in style ? $a35bb6f54c177590$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $a35bb6f54c177590$var$propMap$1 = {
    flex: "box-flex",
    "flex-grow": "box-flex",
    "flex-direction": [
        "box-orient",
        "box-direction"
    ],
    order: "box-ordinal-group",
    "align-items": "box-align",
    "flex-flow": [
        "box-orient",
        "box-direction"
    ],
    "justify-content": "box-pack"
};
var $a35bb6f54c177590$var$propKeys = Object.keys($a35bb6f54c177590$var$propMap$1);
var $a35bb6f54c177590$var$prefixCss = function prefixCss(p) {
    return $a35bb6f54c177590$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $a35bb6f54c177590$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($a35bb6f54c177590$var$propKeys.indexOf(prop) > -1) {
            var newProp = $a35bb6f54c177590$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $a35bb6f54c177590$export$82e9f45cca5ba907.js + $a35bb6f54c177590$var$pascalize(newProp) in style ? $a35bb6f54c177590$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($a35bb6f54c177590$export$82e9f45cca5ba907.js + $a35bb6f54c177590$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($a35bb6f54c177590$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $a35bb6f54c177590$var$plugins = [
    $a35bb6f54c177590$var$appearence,
    $a35bb6f54c177590$var$colorAdjust,
    $a35bb6f54c177590$var$mask,
    $a35bb6f54c177590$var$textOrientation,
    $a35bb6f54c177590$var$transform,
    $a35bb6f54c177590$var$transition,
    $a35bb6f54c177590$var$writingMode,
    $a35bb6f54c177590$var$userSelect,
    $a35bb6f54c177590$var$breakPropsOld,
    $a35bb6f54c177590$var$inlineLogicalOld,
    $a35bb6f54c177590$var$unprefixed,
    $a35bb6f54c177590$var$prefixed,
    $a35bb6f54c177590$var$scrollSnap,
    $a35bb6f54c177590$var$overscrollBehavior,
    $a35bb6f54c177590$var$flex2012,
    $a35bb6f54c177590$var$flex2009
];
var $a35bb6f54c177590$var$propertyDetectors = $a35bb6f54c177590$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $a35bb6f54c177590$var$noPrefill = $a35bb6f54c177590$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $cLm8E.default)(p.noPrefill));
    return a;
}, []);
var $a35bb6f54c177590$var$el;
var $a35bb6f54c177590$var$cache = {};
if (0, $axBJp.default) {
    $a35bb6f54c177590$var$el = document.createElement("p"); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $a35bb6f54c177590$var$computed = window.getComputedStyle(document.documentElement, "");
    for(var $a35bb6f54c177590$var$key$1 in $a35bb6f54c177590$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($a35bb6f54c177590$var$key$1)) $a35bb6f54c177590$var$cache[$a35bb6f54c177590$var$computed[$a35bb6f54c177590$var$key$1]] = $a35bb6f54c177590$var$computed[$a35bb6f54c177590$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $a35bb6f54c177590$var$noPrefill.forEach(function(x) {
        return delete $a35bb6f54c177590$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $a35bb6f54c177590$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$a35bb6f54c177590$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($a35bb6f54c177590$var$cache[prop] != null) return $a35bb6f54c177590$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === "transition" || prop === "transform") options[prop] = prop in $a35bb6f54c177590$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $a35bb6f54c177590$var$propertyDetectors.length; i++){
        $a35bb6f54c177590$var$cache[prop] = $a35bb6f54c177590$var$propertyDetectors[i](prop, $a35bb6f54c177590$var$el.style, options); // Break loop, if value found.
        if ($a35bb6f54c177590$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $a35bb6f54c177590$var$el.style[prop] = "";
    } catch (err) {
        return false;
    }
    return $a35bb6f54c177590$var$cache[prop];
}
var $a35bb6f54c177590$var$cache$1 = {};
var $a35bb6f54c177590$var$transitionProperties = {
    transition: 1,
    "transition-property": 1,
    "-webkit-transition": 1,
    "-webkit-transition-property": 1
};
var $a35bb6f54c177590$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $a35bb6f54c177590$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $a35bb6f54c177590$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === "var") return "var";
    if (p1 === "all") return "all";
    if (p2 === "all") return ", all";
    var prefixedValue = p1 ? $a35bb6f54c177590$export$ce097f82c2e4551a(p1) : ", " + $a35bb6f54c177590$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $axBJp.default) $a35bb6f54c177590$var$el$1 = document.createElement("p");
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $a35bb6f54c177590$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$a35bb6f54c177590$var$el$1 || property === "content") return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($a35bb6f54c177590$var$cache$1[cacheKey] != null) return $a35bb6f54c177590$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $a35bb6f54c177590$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $a35bb6f54c177590$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($a35bb6f54c177590$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($a35bb6f54c177590$var$transPropsRegExp, $a35bb6f54c177590$var$prefixTransitionCallback);
    else if ($a35bb6f54c177590$var$el$1.style[property] === "") {
        // Value with a vendor prefix.
        prefixedValue = $a35bb6f54c177590$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === "-ms-flex") $a35bb6f54c177590$var$el$1.style[property] = "-ms-flexbox"; // Test prefixed value.
        $a35bb6f54c177590$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($a35bb6f54c177590$var$el$1.style[property] === "") {
            $a35bb6f54c177590$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $a35bb6f54c177590$var$el$1.style[property] = ""; // Write current value to cache.
    $a35bb6f54c177590$var$cache$1[cacheKey] = prefixedValue;
    return $a35bb6f54c177590$var$cache$1[cacheKey];
}

});
parcelRequire.register("cLm8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94ab0c1951743850$export$2e2bcd8739ae039; });

var $iZqRK = parcelRequire("iZqRK");

var $gpWel = parcelRequire("gpWel");

var $iDCiE = parcelRequire("iDCiE");

var $3AZHH = parcelRequire("3AZHH");
function $94ab0c1951743850$export$2e2bcd8739ae039(arr) {
    return (0, $iZqRK.default)(arr) || (0, $gpWel.default)(arr) || (0, $iDCiE.default)(arr) || (0, $3AZHH.default)();
}

});
parcelRequire.register("iZqRK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd32c3832cb7a683$export$2e2bcd8739ae039; });

var $7HPvS = parcelRequire("7HPvS");
function $dd32c3832cb7a683$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $7HPvS.default)(arr);
}

});
parcelRequire.register("7HPvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c481fd3973b0f0$export$2e2bcd8739ae039; });
function $59c481fd3973b0f0$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("gpWel", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf3c2676e64d035c$export$2e2bcd8739ae039; });
function $bf3c2676e64d035c$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

});

parcelRequire.register("iDCiE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d919940ec3160560$export$2e2bcd8739ae039; });

var $7HPvS = parcelRequire("7HPvS");
function $d919940ec3160560$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7HPvS.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7HPvS.default)(o, minLen);
}

});

parcelRequire.register("3AZHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29e498f70925a460$export$2e2bcd8739ae039; });
function $29e498f70925a460$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRequire.register("f4u3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af8e8bce800418b8$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $af8e8bce800418b8$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== "style") return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $af8e8bce800418b8$export$2e2bcd8739ae039 = $af8e8bce800418b8$var$jssPropsSort;

});



parcelRequire.register("eVxqu", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $ade05154b62cf6c5$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $ade05154b62cf6c5$var$indexCounter = -1000000000;
function $ade05154b62cf6c5$export$a2647aa13413c947() {
    $ade05154b62cf6c5$var$indexCounter += 1;
    return $ade05154b62cf6c5$var$indexCounter;
}

});

parcelRequire.register("9Ytwm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74309de8752b5bca$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");
parcelRequire("2dcCx");

var $aiIhl = parcelRequire("aiIhl");

function $74309de8752b5bca$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === "function";
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $7ZPk1.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $aiIhl.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRequire.register("2dcCx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c695d858563f26$export$2e2bcd8739ae039; });
function $19c695d858563f26$var$_typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $19c695d858563f26$var$_typeof2 = function _typeof2(obj) {
        return typeof obj;
    };
    else $19c695d858563f26$var$_typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $19c695d858563f26$var$_typeof2(obj);
}
function $19c695d858563f26$export$2e2bcd8739ae039(obj) {
    if (typeof Symbol === "function" && $19c695d858563f26$var$_typeof2(Symbol.iterator) === "symbol") $19c695d858563f26$export$2e2bcd8739ae039 = function _typeof(obj) {
        return $19c695d858563f26$var$_typeof2(obj);
    };
    else $19c695d858563f26$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : $19c695d858563f26$var$_typeof2(obj);
    };
    return $19c695d858563f26$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("aiIhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77fdeeacd1e75464$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $2dcCx = parcelRequire("2dcCx");
function $77fdeeacd1e75464$export$53b83ca8eaab0383(item) {
    return item && (0, $2dcCx.default)(item) === "object" && item.constructor === Object;
}
function $77fdeeacd1e75464$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $7ZPk1.default)({}, target) : target;
    if ($77fdeeacd1e75464$export$53b83ca8eaab0383(target) && $77fdeeacd1e75464$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($77fdeeacd1e75464$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $77fdeeacd1e75464$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRequire.register("jqoXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e243cd688997692d$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $e243cd688997692d$var$noopTheme = {};
var $e243cd688997692d$export$2e2bcd8739ae039 = $e243cd688997692d$var$noopTheme;

});


parcelRequire.register("aCszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb39e782e59f7ef$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $7bb39e782e59f7ef$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRequire.register("66ydJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $471dd91ad507bf64$export$2e2bcd8739ae039; });

var $3LuJG = parcelRequire("3LuJG");
var $471dd91ad507bf64$var$defaultTheme = (0, $3LuJG.default)();
var $471dd91ad507bf64$export$2e2bcd8739ae039 = $471dd91ad507bf64$var$defaultTheme;

});
parcelRequire.register("3LuJG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bdd9a5b3ca413da$export$2e2bcd8739ae039; });
parcelRequire("8xhwK");

var $anj8u = parcelRequire("anj8u");

var $aiIhl = parcelRequire("aiIhl");

var $lg5EI = parcelRequire("lg5EI");

var $1ePax = parcelRequire("1ePax");

var $gSqNg = parcelRequire("gSqNg");

var $9kROI = parcelRequire("9kROI");

var $hQR9b = parcelRequire("hQR9b");

var $1zjTe = parcelRequire("1zjTe");

var $j54UI = parcelRequire("j54UI");

var $2swYA = parcelRequire("2swYA");

var $il614 = parcelRequire("il614");
function $2bdd9a5b3ca413da$var$createMuiTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $anj8u.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $gSqNg.default)(paletteInput);
    var breakpoints = (0, $lg5EI.default)(breakpointsInput);
    var spacing = (0, $j54UI.default)(spacingInput);
    var muiTheme = (0, $aiIhl.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        mixins: (0, $1ePax.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $hQR9b.default),
        typography: (0, $9kROI.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $1zjTe.default),
        transitions: (0, $2swYA.default),
        zIndex: (0, $il614.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $aiIhl.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $2bdd9a5b3ca413da$export$2e2bcd8739ae039 = $2bdd9a5b3ca413da$var$createMuiTheme;

});
parcelRequire.register("8xhwK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $636f0052a076db52$export$2e2bcd8739ae039; });
function $636f0052a076db52$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("lg5EI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f79f7ab16e765cd8$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");
var $f79f7ab16e765cd8$export$ed97f33186d4b816 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
]; // Keep in mind that @media is inclusive by the CSS specification.
function $f79f7ab16e765cd8$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $anj8u.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === "number" ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $f79f7ab16e765cd8$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$f79f7ab16e765cd8$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $f79f7ab16e765cd8$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up("xs");
        var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $f79f7ab16e765cd8$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $f79f7ab16e765cd8$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$f79f7ab16e765cd8$export$ed97f33186d4b816[endIndex + 1]] === "number" ? values[$f79f7ab16e765cd8$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    function width(key) {
        return values[key];
    }
    return (0, $7ZPk1.default)({
        keys: $f79f7ab16e765cd8$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRequire.register("1ePax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e6eca5d1d4111fd$export$2e2bcd8739ae039; });

var $8xhwK = parcelRequire("8xhwK");

var $7ZPk1 = parcelRequire("7ZPk1");
function $0e6eca5d1d4111fd$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $7ZPk1.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            // To deprecate in v4.1
            //       warning(
            //         false,
            //         [
            //           'Material-UI: Theme.mixins.gutters() is deprecated.',
            //           'You can use the source of the mixin directly:',
            //           `
            // paddingLeft: theme.spacing(2),
            // paddingRight: theme.spacing(2),
            // [theme.breakpoints.up('sm')]: {
            //   paddingLeft: theme.spacing(3),
            //   paddingRight: theme.spacing(3),
            // },
            // `,
            //         ].join('\n'),
            //       );
            return (0, $7ZPk1.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $8xhwK.default)({}, breakpoints.up("sm"), (0, $7ZPk1.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up("sm")])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $8xhwK.default)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $8xhwK.default)(_toolbar, breakpoints.up("sm"), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRequire.register("gSqNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c49679206178d6bc$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $aiIhl = parcelRequire("aiIhl");
var $7Y3Oe = parcelRequire("7Y3Oe");

var $7gmin = parcelRequire("7gmin");

var $6LbNR = parcelRequire("6LbNR");

var $gkXS7 = parcelRequire("gkXS7");

var $9zbkJ = parcelRequire("9zbkJ");

var $gHeUf = parcelRequire("gHeUf");

var $jXLcz = parcelRequire("jXLcz");

var $bGx0O = parcelRequire("bGx0O");

var $jHbKX = parcelRequire("jHbKX");

var $8UIkY = parcelRequire("8UIkY");
var $c49679206178d6bc$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.54)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)",
        // Text hints.
        hint: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $7gmin.default).white,
        default: (0, $6LbNR.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c49679206178d6bc$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $7gmin.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        hint: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: (0, $6LbNR.default)[800],
        default: "#303030"
    },
    action: {
        active: (0, $7gmin.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c49679206178d6bc$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $8UIkY.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $8UIkY.darken)(intent.main, tonalOffsetDark);
    }
}
function $c49679206178d6bc$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $gkXS7.default)[300],
        main: (0, $gkXS7.default)[500],
        dark: (0, $gkXS7.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $9zbkJ.default).A200,
        main: (0, $9zbkJ.default).A400,
        dark: (0, $9zbkJ.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $gHeUf.default)[300],
        main: (0, $gHeUf.default)[500],
        dark: (0, $gHeUf.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $jXLcz.default)[300],
        main: (0, $jXLcz.default)[500],
        dark: (0, $jXLcz.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $bGx0O.default)[300],
        main: (0, $bGx0O.default)[500],
        dark: (0, $bGx0O.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $jHbKX.default)[300],
        main: (0, $jHbKX.default)[500],
        dark: (0, $jHbKX.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $anj8u.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $8UIkY.getContrastRatio)(background, $c49679206178d6bc$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c49679206178d6bc$export$55ce6f3a06c59543.text.primary : $c49679206178d6bc$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $7ZPk1.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $7Y3Oe.default)(4, mainShade));
        if (typeof color.main !== "string") throw new Error((0, $7Y3Oe.default)(5, JSON.stringify(color.main)));
        $c49679206178d6bc$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $c49679206178d6bc$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c49679206178d6bc$export$55ce6f3a06c59543,
        light: $c49679206178d6bc$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $aiIhl.default)((0, $7ZPk1.default)({
        // A collection of common colors.
        common: (0, $7gmin.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, "A400", "A200", "A700"),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $6LbNR.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRequire.register("7Y3Oe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cd1176e6800545e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $5cd1176e6800545e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = "https://material-ui.com/production-error/?code=" + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRequire.register("7gmin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $549b526f79378053$export$2e2bcd8739ae039; });
var $549b526f79378053$var$common = {
    black: "#000",
    white: "#fff"
};
var $549b526f79378053$export$2e2bcd8739ae039 = $549b526f79378053$var$common;

});

parcelRequire.register("6LbNR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ec049b700cd1c72$export$2e2bcd8739ae039; });
var $4ec049b700cd1c72$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#d5d5d5",
    A200: "#aaaaaa",
    A400: "#303030",
    A700: "#616161"
};
var $4ec049b700cd1c72$export$2e2bcd8739ae039 = $4ec049b700cd1c72$var$grey;

});

parcelRequire.register("gkXS7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be4cf4e7c31e950d$export$2e2bcd8739ae039; });
var $be4cf4e7c31e950d$var$indigo = {
    50: "#e8eaf6",
    100: "#c5cae9",
    200: "#9fa8da",
    300: "#7986cb",
    400: "#5c6bc0",
    500: "#3f51b5",
    600: "#3949ab",
    700: "#303f9f",
    800: "#283593",
    900: "#1a237e",
    A100: "#8c9eff",
    A200: "#536dfe",
    A400: "#3d5afe",
    A700: "#304ffe"
};
var $be4cf4e7c31e950d$export$2e2bcd8739ae039 = $be4cf4e7c31e950d$var$indigo;

});

parcelRequire.register("9zbkJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f702c8145f312dd$export$2e2bcd8739ae039; });
var $6f702c8145f312dd$var$pink = {
    50: "#fce4ec",
    100: "#f8bbd0",
    200: "#f48fb1",
    300: "#f06292",
    400: "#ec407a",
    500: "#e91e63",
    600: "#d81b60",
    700: "#c2185b",
    800: "#ad1457",
    900: "#880e4f",
    A100: "#ff80ab",
    A200: "#ff4081",
    A400: "#f50057",
    A700: "#c51162"
};
var $6f702c8145f312dd$export$2e2bcd8739ae039 = $6f702c8145f312dd$var$pink;

});

parcelRequire.register("gHeUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c27c398f38829209$export$2e2bcd8739ae039; });
var $c27c398f38829209$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $c27c398f38829209$export$2e2bcd8739ae039 = $c27c398f38829209$var$red;

});

parcelRequire.register("jXLcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8882444b30dbda6$export$2e2bcd8739ae039; });
var $e8882444b30dbda6$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $e8882444b30dbda6$export$2e2bcd8739ae039 = $e8882444b30dbda6$var$orange;

});

parcelRequire.register("bGx0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $881d397995af9d64$export$2e2bcd8739ae039; });
var $881d397995af9d64$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $881d397995af9d64$export$2e2bcd8739ae039 = $881d397995af9d64$var$blue;

});

parcelRequire.register("jHbKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e56b270e821d9926$export$2e2bcd8739ae039; });
var $e56b270e821d9926$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $e56b270e821d9926$export$2e2bcd8739ae039 = $e56b270e821d9926$var$green;

});

parcelRequire.register("8UIkY", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $67d5f2258e0c4d2e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "darken", function () { return $67d5f2258e0c4d2e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $67d5f2258e0c4d2e$export$c0816ed86df316af; });
$parcel$export(module.exports, "fade", function () { return $67d5f2258e0c4d2e$export$cbea29d068a2e18f; });

var $7Y3Oe = parcelRequire("7Y3Oe");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $67d5f2258e0c4d2e$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $67d5f2258e0c4d2e$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", "), ")") : "";
}
function $67d5f2258e0c4d2e$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $67d5f2258e0c4d2e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    var _decomposeColor = $67d5f2258e0c4d2e$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $67d5f2258e0c4d2e$var$intToHex(n);
    }).join(""));
}
function $67d5f2258e0c4d2e$export$29fb7152bd3f781a(color) {
    color = $67d5f2258e0c4d2e$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = "rgb";
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $67d5f2258e0c4d2e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $67d5f2258e0c4d2e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $67d5f2258e0c4d2e$export$677b39864803984e($67d5f2258e0c4d2e$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf("(");
    var type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla"
    ].indexOf(type) === -1) throw new Error((0, $7Y3Oe.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(",");
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $67d5f2258e0c4d2e$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf("hsl") !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(", "), ")");
}
function $67d5f2258e0c4d2e$export$d061e26956a60b0a(foreground, background) {
    var lumA = $67d5f2258e0c4d2e$export$c852d90bf7403b62(foreground);
    var lumB = $67d5f2258e0c4d2e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $67d5f2258e0c4d2e$export$c852d90bf7403b62(color) {
    color = $67d5f2258e0c4d2e$export$677b39864803984e(color);
    var rgb = color.type === "hsl" ? $67d5f2258e0c4d2e$export$677b39864803984e($67d5f2258e0c4d2e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $67d5f2258e0c4d2e$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $67d5f2258e0c4d2e$export$c852d90bf7403b62(color) > 0.5 ? $67d5f2258e0c4d2e$export$4b073707ff63303(color, coefficient) : $67d5f2258e0c4d2e$export$c0816ed86df316af(color, coefficient);
}
function $67d5f2258e0c4d2e$export$cbea29d068a2e18f(color, value) {
    color = $67d5f2258e0c4d2e$export$677b39864803984e(color);
    value = $67d5f2258e0c4d2e$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    color.values[3] = value;
    return $67d5f2258e0c4d2e$export$211a73f2b8c10ce4(color);
}
function $67d5f2258e0c4d2e$export$4b073707ff63303(color, coefficient) {
    color = $67d5f2258e0c4d2e$export$677b39864803984e(color);
    coefficient = $67d5f2258e0c4d2e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $67d5f2258e0c4d2e$export$211a73f2b8c10ce4(color);
}
function $67d5f2258e0c4d2e$export$c0816ed86df316af(color, coefficient) {
    color = $67d5f2258e0c4d2e$export$677b39864803984e(color);
    coefficient = $67d5f2258e0c4d2e$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $67d5f2258e0c4d2e$export$211a73f2b8c10ce4(color);
}

});


parcelRequire.register("9kROI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cbfba3f6c1957a0$export$2e2bcd8739ae039; });

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $aiIhl = parcelRequire("aiIhl");
function $6cbfba3f6c1957a0$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $6cbfba3f6c1957a0$var$caseAllCaps = {
    textTransform: "uppercase"
};
var $6cbfba3f6c1957a0$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $6cbfba3f6c1957a0$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $6cbfba3f6c1957a0$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $anj8u.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $7ZPk1.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $6cbfba3f6c1957a0$var$defaultFontFamily ? {
            letterSpacing: "".concat($6cbfba3f6c1957a0$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $6cbfba3f6c1957a0$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $6cbfba3f6c1957a0$var$caseAllCaps)
    };
    return (0, $aiIhl.default)((0, $7ZPk1.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $6cbfba3f6c1957a0$var$round,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("hQR9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cff084ecc2e33698$export$2e2bcd8739ae039; });
var $cff084ecc2e33698$var$shadowKeyUmbraOpacity = 0.2;
var $cff084ecc2e33698$var$shadowKeyPenumbraOpacity = 0.14;
var $cff084ecc2e33698$var$shadowAmbientShadowOpacity = 0.12;
function $cff084ecc2e33698$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($cff084ecc2e33698$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($cff084ecc2e33698$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($cff084ecc2e33698$var$shadowAmbientShadowOpacity, ")")
    ].join(",");
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $cff084ecc2e33698$var$shadows = [
    "none",
    $cff084ecc2e33698$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $cff084ecc2e33698$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $cff084ecc2e33698$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $cff084ecc2e33698$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $cff084ecc2e33698$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $cff084ecc2e33698$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $cff084ecc2e33698$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $cff084ecc2e33698$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $cff084ecc2e33698$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $cff084ecc2e33698$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $cff084ecc2e33698$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $cff084ecc2e33698$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $cff084ecc2e33698$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $cff084ecc2e33698$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $cff084ecc2e33698$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $cff084ecc2e33698$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $cff084ecc2e33698$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $cff084ecc2e33698$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $cff084ecc2e33698$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $cff084ecc2e33698$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $cff084ecc2e33698$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $cff084ecc2e33698$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $cff084ecc2e33698$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $cff084ecc2e33698$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $cff084ecc2e33698$export$2e2bcd8739ae039 = $cff084ecc2e33698$var$shadows;

});

parcelRequire.register("1zjTe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12487d02c061f2af$export$2e2bcd8739ae039; });
var $12487d02c061f2af$var$shape = {
    borderRadius: 4
};
var $12487d02c061f2af$export$2e2bcd8739ae039 = $12487d02c061f2af$var$shape;

});

parcelRequire.register("j54UI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de424bbf7fcb1dad$export$2e2bcd8739ae039; });

var $5OfXA = parcelRequire("5OfXA");
var $de424bbf7fcb1dad$var$warnOnce;
function $de424bbf7fcb1dad$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $5OfXA.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === "string") return argument;
            var output = transform(argument);
            return typeof output === "number" ? "".concat(output, "px") : output;
        }).join(" ");
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, "unit", {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("5OfXA", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $43ae0097b95e3254$export$1def6f833384e3d1; });

var $1s4Pi = parcelRequire("1s4Pi");


var $DoOCR = parcelRequire("DoOCR");

var $dYTgS = parcelRequire("dYTgS");

var $4bQxN = parcelRequire("4bQxN");
var $43ae0097b95e3254$var$properties = {
    m: "margin",
    p: "padding"
};
var $43ae0097b95e3254$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
var $43ae0097b95e3254$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $43ae0097b95e3254$var$getCssProperties = (0, $4bQxN.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($43ae0097b95e3254$var$aliases[prop]) prop = $43ae0097b95e3254$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(""), _prop$split2 = (0, $1s4Pi.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $43ae0097b95e3254$var$properties[a];
    var direction = $43ae0097b95e3254$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $43ae0097b95e3254$var$spacingKeys = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY"
];
function $43ae0097b95e3254$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === "number") return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return function() {
        return undefined;
    };
}
function $43ae0097b95e3254$var$getValue(transformer, propValue) {
    if (typeof propValue === "string") return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return "-".concat(transformed);
}
function $43ae0097b95e3254$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $43ae0097b95e3254$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $43ae0097b95e3254$var$spacing(props) {
    var theme = props.theme;
    var transformer = $43ae0097b95e3254$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($43ae0097b95e3254$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $43ae0097b95e3254$var$getCssProperties(prop);
        var styleFromPropValue = $43ae0097b95e3254$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $DoOCR.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $dYTgS.default), {});
}
$43ae0097b95e3254$var$spacing.propTypes = {};
$43ae0097b95e3254$var$spacing.filterProps = $43ae0097b95e3254$var$spacingKeys;
var $43ae0097b95e3254$export$2e2bcd8739ae039 = $43ae0097b95e3254$var$spacing;

});
parcelRequire.register("1s4Pi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ec26682c89053b$export$2e2bcd8739ae039; });

var $kTR3L = parcelRequire("kTR3L");

var $atR9G = parcelRequire("atR9G");

var $2u9Z2 = parcelRequire("2u9Z2");
function $10ec26682c89053b$export$2e2bcd8739ae039(arr, i) {
    return (0, $kTR3L.default)(arr) || (0, $atR9G.default)(arr, i) || (0, $2u9Z2.default)();
}

});
parcelRequire.register("kTR3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3721a4693bbea37$export$2e2bcd8739ae039; });
function $f3721a4693bbea37$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("atR9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a15d84f4e3299d4$export$2e2bcd8739ae039; });
function $7a15d84f4e3299d4$export$2e2bcd8739ae039(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("2u9Z2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cf6209acb6c9ab3$export$2e2bcd8739ae039; });
function $1cf6209acb6c9ab3$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

});


parcelRequire.register("DoOCR", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $0766e47bd72af1d8$export$88347efdb2e19abd; });

var $8LAGA = parcelRequire("8LAGA");

var $7ZPk1 = parcelRequire("7ZPk1");

var $2dcCx = parcelRequire("2dcCx");


var $dYTgS = parcelRequire("dYTgS");
// For instance with the first breakpoint xs: [xs, sm[.
var $0766e47bd72af1d8$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $0766e47bd72af1d8$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: function up(key) {
        return "@media (min-width:".concat($0766e47bd72af1d8$var$values[key], "px)");
    }
};
function $0766e47bd72af1d8$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $0766e47bd72af1d8$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $2dcCx.default)(propValue) === "object") {
        var _themeBreakpoints = props.theme.breakpoints || $0766e47bd72af1d8$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $0766e47bd72af1d8$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $0766e47bd72af1d8$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $7ZPk1.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $dYTgS.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].concat((0, $8LAGA.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $0766e47bd72af1d8$export$2e2bcd8739ae039 = $0766e47bd72af1d8$var$breakpoints;

});
parcelRequire.register("8LAGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $661f2b97602a33b2$export$2e2bcd8739ae039; });

var $36Ex6 = parcelRequire("36Ex6");

var $fY9w5 = parcelRequire("fY9w5");

var $kfMsx = parcelRequire("kfMsx");
function $661f2b97602a33b2$export$2e2bcd8739ae039(arr) {
    return (0, $36Ex6.default)(arr) || (0, $fY9w5.default)(arr) || (0, $kfMsx.default)();
}

});
parcelRequire.register("36Ex6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24315f9a9e9a07ae$export$2e2bcd8739ae039; });
function $24315f9a9e9a07ae$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}

});

parcelRequire.register("fY9w5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba03d765920e7bdf$export$2e2bcd8739ae039; });
function $ba03d765920e7bdf$export$2e2bcd8739ae039(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

});

parcelRequire.register("kfMsx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebeacc5fb5abaf85$export$2e2bcd8739ae039; });
function $ebeacc5fb5abaf85$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}

});


parcelRequire.register("dYTgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2dbc0afa4a22c16$export$2e2bcd8739ae039; });

var $aiIhl = parcelRequire("aiIhl");
function $a2dbc0afa4a22c16$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $aiIhl.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $a2dbc0afa4a22c16$export$2e2bcd8739ae039 = $a2dbc0afa4a22c16$var$merge;

});


parcelRequire.register("4bQxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30d0f2ad8c9275c8$export$2e2bcd8739ae039; });
function $30d0f2ad8c9275c8$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("2swYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca7c6b30f25e1b6$export$2e2bcd8739ae039; });

var $anj8u = parcelRequire("anj8u");
var $1ca7c6b30f25e1b6$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $1ca7c6b30f25e1b6$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $1ca7c6b30f25e1b6$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $1ca7c6b30f25e1b6$export$2e2bcd8739ae039 = {
    easing: $1ca7c6b30f25e1b6$export$24c5ac7c37452e7d,
    duration: $1ca7c6b30f25e1b6$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            "all"
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $1ca7c6b30f25e1b6$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $1ca7c6b30f25e1b6$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $anj8u.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : $1ca7c6b30f25e1b6$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : $1ca7c6b30f25e1b6$var$formatMs(delay));
        }).join(",");
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRequire.register("il614", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59edaddc925e2fa$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $d59edaddc925e2fa$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $d59edaddc925e2fa$export$2e2bcd8739ae039 = $d59edaddc925e2fa$var$zIndex;

});




parcelRequire.register("9iccj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c3f41a9f8cf55f9$export$2e2bcd8739ae039; });

var $7Y3Oe = parcelRequire("7Y3Oe");
function $6c3f41a9f8cf55f9$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $7Y3Oe.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRequire.register("lktyy", function(module, exports) {
"use strict";
var $f872647f0ca0cc19$var$isArray = Array.isArray;
var $f872647f0ca0cc19$var$keyList = Object.keys;
var $f872647f0ca0cc19$var$hasProp = Object.prototype.hasOwnProperty;
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $f872647f0ca0cc19$var$isArray(a), arrB = $f872647f0ca0cc19$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $f872647f0ca0cc19$var$keyList(a);
        length = keys.length;
        if (length !== $f872647f0ca0cc19$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$f872647f0ca0cc19$var$hasProp.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
};

});

parcelRequire.register("53hri", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3adac2a49a1cca98$export$2e2bcd8739ae039; }, function (v) { return $3adac2a49a1cca98$export$2e2bcd8739ae039 = v; });
var $3adac2a49a1cca98$export$1e511d4a378977f5;
var $3adac2a49a1cca98$export$2e2bcd8739ae039;
"use strict";
$3adac2a49a1cca98$export$1e511d4a378977f5 = true;
$3adac2a49a1cca98$export$2e2bcd8739ae039 = $3adac2a49a1cca98$var$linkifyHtml;

var $8K0ka = parcelRequire("8K0ka");
var $3adac2a49a1cca98$var$_simpleHtmlTokenizer2 = $3adac2a49a1cca98$var$_interopRequireDefault($8K0ka);

var $hyJuA = parcelRequire("hyJuA");
var $3adac2a49a1cca98$var$linkify = $3adac2a49a1cca98$var$_interopRequireWildcard($hyJuA);
function $3adac2a49a1cca98$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $3adac2a49a1cca98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3adac2a49a1cca98$var$options = $3adac2a49a1cca98$var$linkify.options;
var $3adac2a49a1cca98$var$Options = $3adac2a49a1cca98$var$options.Options;
var $3adac2a49a1cca98$var$StartTag = "StartTag";
var $3adac2a49a1cca98$var$EndTag = "EndTag";
var $3adac2a49a1cca98$var$Chars = "Chars";
var $3adac2a49a1cca98$var$Comment = "Comment";
/**
	`tokens` and `token` in this section refer to tokens generated by the HTML
	parser.
*/ function $3adac2a49a1cca98$var$linkifyHtml(str) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tokens = $3adac2a49a1cca98$var$_simpleHtmlTokenizer2.default.tokenize(str);
    var linkifiedTokens = [];
    var linkified = [];
    var i;
    opts = new $3adac2a49a1cca98$var$Options(opts);
    // Linkify the tokens given by the parser
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (token.type === $3adac2a49a1cca98$var$StartTag) {
            linkifiedTokens.push(token);
            // Ignore all the contents of ignored tags
            var tagName = token.tagName.toUpperCase();
            var isIgnored = tagName === "A" || $3adac2a49a1cca98$var$options.contains(opts.ignoreTags, tagName);
            if (!isIgnored) continue;
            var preskipLen = linkifiedTokens.length;
            $3adac2a49a1cca98$var$skipTagTokens(tagName, tokens, ++i, linkifiedTokens);
            i += linkifiedTokens.length - preskipLen - 1;
            continue;
        } else if (token.type !== $3adac2a49a1cca98$var$Chars) {
            // Skip this token, it's not important
            linkifiedTokens.push(token);
            continue;
        }
        // Valid text token, linkify it!
        var linkifedChars = $3adac2a49a1cca98$var$linkifyChars(token.chars, opts);
        linkifiedTokens.push.apply(linkifiedTokens, linkifedChars);
    }
    // Convert the tokens back into a string
    for(i = 0; i < linkifiedTokens.length; i++){
        var _token = linkifiedTokens[i];
        switch(_token.type){
            case $3adac2a49a1cca98$var$StartTag:
                var link = "<" + _token.tagName;
                if (_token.attributes.length > 0) {
                    var attrs = $3adac2a49a1cca98$var$attrsToStrings(_token.attributes);
                    link += " " + attrs.join(" ");
                }
                link += ">";
                linkified.push(link);
                break;
            case $3adac2a49a1cca98$var$EndTag:
                linkified.push("</" + _token.tagName + ">");
                break;
            case $3adac2a49a1cca98$var$Chars:
                linkified.push($3adac2a49a1cca98$var$escapeText(_token.chars));
                break;
            case $3adac2a49a1cca98$var$Comment:
                linkified.push("<!--" + $3adac2a49a1cca98$var$escapeText(_token.chars) + "-->");
                break;
        }
    }
    return linkified.join("");
}
/**
	`tokens` and `token` in this section referes to tokens returned by
	`linkify.tokenize`. `linkified` will contain HTML Parser-style tokens
*/ function $3adac2a49a1cca98$var$linkifyChars(str, opts) {
    var tokens = $3adac2a49a1cca98$var$linkify.tokenize(str);
    var result = [];
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (token.type === "nl" && opts.nl2br) {
            result.push({
                type: $3adac2a49a1cca98$var$StartTag,
                tagName: "br",
                attributes: [],
                selfClosing: true
            });
            continue;
        } else if (!token.isLink || !opts.check(token)) {
            result.push({
                type: $3adac2a49a1cca98$var$Chars,
                chars: token.toString()
            });
            continue;
        }
        var _opts$resolve = opts.resolve(token), formatted = _opts$resolve.formatted, formattedHref = _opts$resolve.formattedHref, tagName = _opts$resolve.tagName, className = _opts$resolve.className, target = _opts$resolve.target, attributes = _opts$resolve.attributes;
        // Build up attributes
        var attributeArray = [
            [
                "href",
                formattedHref
            ]
        ];
        if (className) attributeArray.push([
            "class",
            className
        ]);
        if (target) attributeArray.push([
            "target",
            target
        ]);
        for(var attr in attributes)attributeArray.push([
            attr,
            attributes[attr]
        ]);
        // Add the required tokens
        result.push({
            type: $3adac2a49a1cca98$var$StartTag,
            tagName: tagName,
            attributes: attributeArray,
            selfClosing: false
        });
        result.push({
            type: $3adac2a49a1cca98$var$Chars,
            chars: formatted
        });
        result.push({
            type: $3adac2a49a1cca98$var$EndTag,
            tagName: tagName
        });
    }
    return result;
}
/**
	Returns a list of tokens skipped until the closing tag of tagName.

	* `tagName` is the closing tag which will prompt us to stop skipping
	* `tokens` is the array of tokens generated by HTML5Tokenizer which
	* `i` is the index immediately after the opening tag to skip
	* `skippedTokens` is an array which skipped tokens are being pushed into

	Caveats

	* Assumes that i is the first token after the given opening tagName
	* The closing tag will be skipped, but nothing after it
	* Will track whether there is a nested tag of the same type
*/ function $3adac2a49a1cca98$var$skipTagTokens(tagName, tokens, i, skippedTokens) {
    // number of tokens of this type on the [fictional] stack
    var stackCount = 1;
    while(i < tokens.length && stackCount > 0){
        var token = tokens[i];
        if (token.type === $3adac2a49a1cca98$var$StartTag && token.tagName.toUpperCase() === tagName) // Nested tag of the same type, "add to stack"
        stackCount++;
        else if (token.type === $3adac2a49a1cca98$var$EndTag && token.tagName.toUpperCase() === tagName) // Closing tag
        stackCount--;
        skippedTokens.push(token);
        i++;
    }
    // Note that if stackCount > 0 here, the HTML is probably invalid
    return skippedTokens;
}
function $3adac2a49a1cca98$var$escapeText(text) {
    // Not required, HTML tokenizer ensures this occurs properly
    return text;
}
function $3adac2a49a1cca98$var$escapeAttr(attr) {
    return attr.replace(/"/g, "&quot;");
}
function $3adac2a49a1cca98$var$attrsToStrings(attrs) {
    var attrStrs = [];
    for(var i = 0; i < attrs.length; i++){
        var _attrs$i = attrs[i], name = _attrs$i[0], value = _attrs$i[1];
        attrStrs.push(name + '="' + $3adac2a49a1cca98$var$escapeAttr(value) + '"');
    }
    return attrStrs;
}

});
parcelRequire.register("8K0ka", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $65d2deff4963ac66$export$1e511d4a378977f5; }, function (v) { return $65d2deff4963ac66$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $65d2deff4963ac66$export$2e2bcd8739ae039; }, function (v) { return $65d2deff4963ac66$export$2e2bcd8739ae039 = v; });
var $65d2deff4963ac66$export$1e511d4a378977f5;
var $65d2deff4963ac66$export$2e2bcd8739ae039;
"use strict";
$65d2deff4963ac66$export$1e511d4a378977f5 = true;

var $jgenH = parcelRequire("jgenH");
var $65d2deff4963ac66$var$_html5NamedCharRefs2 = $65d2deff4963ac66$var$_interopRequireDefault($jgenH);

var $HoDAu = parcelRequire("HoDAu");
var $65d2deff4963ac66$var$_entityParser2 = $65d2deff4963ac66$var$_interopRequireDefault($HoDAu);

var $cGdod = parcelRequire("cGdod");
var $65d2deff4963ac66$var$_eventedTokenizer2 = $65d2deff4963ac66$var$_interopRequireDefault($cGdod);

var $cPmUq = parcelRequire("cPmUq");
var $65d2deff4963ac66$var$_tokenizer2 = $65d2deff4963ac66$var$_interopRequireDefault($cPmUq);

var $hh9lz = parcelRequire("hh9lz");
var $65d2deff4963ac66$var$_tokenize2 = $65d2deff4963ac66$var$_interopRequireDefault($hh9lz);
function $65d2deff4963ac66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $65d2deff4963ac66$var$HTML5Tokenizer = {
    HTML5NamedCharRefs: $65d2deff4963ac66$var$_html5NamedCharRefs2.default,
    EntityParser: $65d2deff4963ac66$var$_entityParser2.default,
    EventedTokenizer: $65d2deff4963ac66$var$_eventedTokenizer2.default,
    Tokenizer: $65d2deff4963ac66$var$_tokenizer2.default,
    tokenize: $65d2deff4963ac66$var$_tokenize2.default
};
$65d2deff4963ac66$export$2e2bcd8739ae039 = $65d2deff4963ac66$var$HTML5Tokenizer;

});
parcelRequire.register("jgenH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $e05aaac61860ab96$export$1e511d4a378977f5; }, function (v) { return $e05aaac61860ab96$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $e05aaac61860ab96$export$2e2bcd8739ae039; }, function (v) { return $e05aaac61860ab96$export$2e2bcd8739ae039 = v; });
var $e05aaac61860ab96$export$1e511d4a378977f5;
var $e05aaac61860ab96$export$2e2bcd8739ae039;
"use strict";
$e05aaac61860ab96$export$1e511d4a378977f5 = true;
var $e05aaac61860ab96$var$HTML5NamedCharRefs = {
    // We don't need the complete named character reference because linkifyHtml
    // does not modify the escape sequences. We do need &nbsp; so that
    // whitespace is parsed properly. Other types of whitespace should already
    // be accounted for
    nbsp: "\xa0"
};
$e05aaac61860ab96$export$2e2bcd8739ae039 = $e05aaac61860ab96$var$HTML5NamedCharRefs;

});

parcelRequire.register("HoDAu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $082720c3409dce5c$export$1e511d4a378977f5; }, function (v) { return $082720c3409dce5c$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $082720c3409dce5c$export$2e2bcd8739ae039; }, function (v) { return $082720c3409dce5c$export$2e2bcd8739ae039 = v; });
var $082720c3409dce5c$export$1e511d4a378977f5;
var $082720c3409dce5c$export$2e2bcd8739ae039;
"use strict";
$082720c3409dce5c$export$1e511d4a378977f5 = true;
function $082720c3409dce5c$var$EntityParser(named) {
    this.named = named;
}
var $082720c3409dce5c$var$HEXCHARCODE = /^#[xX]([A-Fa-f0-9]+)$/;
var $082720c3409dce5c$var$CHARCODE = /^#([0-9]+)$/;
var $082720c3409dce5c$var$NAMED = /^([A-Za-z0-9]+)$/;
$082720c3409dce5c$var$EntityParser.prototype.parse = function(entity) {
    if (!entity) return;
    var matches = entity.match($082720c3409dce5c$var$HEXCHARCODE);
    if (matches) return "&#x" + matches[1] + ";";
    matches = entity.match($082720c3409dce5c$var$CHARCODE);
    if (matches) return "&#" + matches[1] + ";";
    matches = entity.match($082720c3409dce5c$var$NAMED);
    if (matches) return this.named[matches[1]] || "&" + matches[1] + ";";
};
$082720c3409dce5c$export$2e2bcd8739ae039 = $082720c3409dce5c$var$EntityParser;

});

parcelRequire.register("cGdod", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $93b3cb251e137893$export$1e511d4a378977f5; }, function (v) { return $93b3cb251e137893$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $93b3cb251e137893$export$2e2bcd8739ae039; }, function (v) { return $93b3cb251e137893$export$2e2bcd8739ae039 = v; });
var $93b3cb251e137893$export$1e511d4a378977f5;
var $93b3cb251e137893$export$2e2bcd8739ae039;
"use strict";
$93b3cb251e137893$export$1e511d4a378977f5 = true;

var $6O4jo = parcelRequire("6O4jo");
function $93b3cb251e137893$var$EventedTokenizer(delegate, entityParser) {
    this.delegate = delegate;
    this.entityParser = entityParser;
    this.state = null;
    this.input = null;
    this.index = -1;
    this.line = -1;
    this.column = -1;
    this.tagLine = -1;
    this.tagColumn = -1;
    this.reset();
}
$93b3cb251e137893$var$EventedTokenizer.prototype = {
    reset: function reset() {
        this.state = "beforeData";
        this.input = "";
        this.index = 0;
        this.line = 1;
        this.column = 0;
        this.tagLine = -1;
        this.tagColumn = -1;
        this.delegate.reset();
    },
    tokenize: function tokenize(input) {
        this.reset();
        this.tokenizePart(input);
        this.tokenizeEOF();
    },
    tokenizePart: function tokenizePart(input) {
        this.input += (0, $6O4jo.preprocessInput)(input);
        while(this.index < this.input.length)this.states[this.state].call(this);
    },
    tokenizeEOF: function tokenizeEOF() {
        this.flushData();
    },
    flushData: function flushData() {
        if (this.state === "data") {
            this.delegate.finishData();
            this.state = "beforeData";
        }
    },
    peek: function peek() {
        return this.input.charAt(this.index);
    },
    consume: function consume() {
        var char = this.peek();
        this.index++;
        if (char === "\n") {
            this.line++;
            this.column = 0;
        } else this.column++;
        return char;
    },
    consumeCharRef: function consumeCharRef() {
        var endIndex = this.input.indexOf(";", this.index);
        if (endIndex === -1) return;
        var entity = this.input.slice(this.index, endIndex);
        var chars = this.entityParser.parse(entity);
        if (chars) {
            var count = entity.length;
            // consume the entity chars
            while(count){
                this.consume();
                count--;
            }
            // consume the `;`
            this.consume();
            return chars;
        }
    },
    markTagStart: function markTagStart() {
        // these properties to be removed in next major bump
        this.tagLine = this.line;
        this.tagColumn = this.column;
        if (this.delegate.tagOpen) this.delegate.tagOpen();
    },
    states: {
        beforeData: function beforeData() {
            var char = this.peek();
            if (char === "<") {
                this.state = "tagOpen";
                this.markTagStart();
                this.consume();
            } else {
                this.state = "data";
                this.delegate.beginData();
            }
        },
        data: function data() {
            var char = this.peek();
            if (char === "<") {
                this.delegate.finishData();
                this.state = "tagOpen";
                this.markTagStart();
                this.consume();
            } else if (char === "&") {
                this.consume();
                this.delegate.appendToData(this.consumeCharRef() || "&");
            } else {
                this.consume();
                this.delegate.appendToData(char);
            }
        },
        tagOpen: function tagOpen() {
            var char = this.consume();
            if (char === "!") this.state = "markupDeclaration";
            else if (char === "/") this.state = "endTagOpen";
            else if ((0, $6O4jo.isAlpha)(char)) {
                this.state = "tagName";
                this.delegate.beginStartTag();
                this.delegate.appendToTagName(char.toLowerCase());
            }
        },
        markupDeclaration: function markupDeclaration() {
            var char = this.consume();
            if (char === "-" && this.input.charAt(this.index) === "-") {
                this.consume();
                this.state = "commentStart";
                this.delegate.beginComment();
            }
        },
        commentStart: function commentStart() {
            var char = this.consume();
            if (char === "-") this.state = "commentStartDash";
            else if (char === ">") {
                this.delegate.finishComment();
                this.state = "beforeData";
            } else {
                this.delegate.appendToCommentData(char);
                this.state = "comment";
            }
        },
        commentStartDash: function commentStartDash() {
            var char = this.consume();
            if (char === "-") this.state = "commentEnd";
            else if (char === ">") {
                this.delegate.finishComment();
                this.state = "beforeData";
            } else {
                this.delegate.appendToCommentData("-");
                this.state = "comment";
            }
        },
        comment: function comment() {
            var char = this.consume();
            if (char === "-") this.state = "commentEndDash";
            else this.delegate.appendToCommentData(char);
        },
        commentEndDash: function commentEndDash() {
            var char = this.consume();
            if (char === "-") this.state = "commentEnd";
            else {
                this.delegate.appendToCommentData("-" + char);
                this.state = "comment";
            }
        },
        commentEnd: function commentEnd() {
            var char = this.consume();
            if (char === ">") {
                this.delegate.finishComment();
                this.state = "beforeData";
            } else {
                this.delegate.appendToCommentData("--" + char);
                this.state = "comment";
            }
        },
        tagName: function tagName() {
            var char = this.consume();
            if ((0, $6O4jo.isSpace)(char)) this.state = "beforeAttributeName";
            else if (char === "/") this.state = "selfClosingStartTag";
            else if (char === ">") {
                this.delegate.finishTag();
                this.state = "beforeData";
            } else this.delegate.appendToTagName(char);
        },
        beforeAttributeName: function beforeAttributeName() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) {
                this.consume();
                return;
            } else if (char === "/") {
                this.state = "selfClosingStartTag";
                this.consume();
            } else if (char === ">") {
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else {
                this.state = "attributeName";
                this.delegate.beginAttribute();
                this.consume();
                this.delegate.appendToAttributeName(char);
            }
        },
        attributeName: function attributeName() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) {
                this.state = "afterAttributeName";
                this.consume();
            } else if (char === "/") {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.state = "selfClosingStartTag";
            } else if (char === "=") {
                this.state = "beforeAttributeValue";
                this.consume();
            } else if (char === ">") {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else {
                this.consume();
                this.delegate.appendToAttributeName(char);
            }
        },
        afterAttributeName: function afterAttributeName() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) {
                this.consume();
                return;
            } else if (char === "/") {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.state = "selfClosingStartTag";
            } else if (char === "=") {
                this.consume();
                this.state = "beforeAttributeValue";
            } else if (char === ">") {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.state = "attributeName";
                this.delegate.beginAttribute();
                this.delegate.appendToAttributeName(char);
            }
        },
        beforeAttributeValue: function beforeAttributeValue() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) this.consume();
            else if (char === '"') {
                this.state = "attributeValueDoubleQuoted";
                this.delegate.beginAttributeValue(true);
                this.consume();
            } else if (char === "'") {
                this.state = "attributeValueSingleQuoted";
                this.delegate.beginAttributeValue(true);
                this.consume();
            } else if (char === ">") {
                this.delegate.beginAttributeValue(false);
                this.delegate.finishAttributeValue();
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else {
                this.state = "attributeValueUnquoted";
                this.delegate.beginAttributeValue(false);
                this.consume();
                this.delegate.appendToAttributeValue(char);
            }
        },
        attributeValueDoubleQuoted: function attributeValueDoubleQuoted() {
            var char = this.consume();
            if (char === '"') {
                this.delegate.finishAttributeValue();
                this.state = "afterAttributeValueQuoted";
            } else if (char === "&") this.delegate.appendToAttributeValue(this.consumeCharRef('"') || "&");
            else this.delegate.appendToAttributeValue(char);
        },
        attributeValueSingleQuoted: function attributeValueSingleQuoted() {
            var char = this.consume();
            if (char === "'") {
                this.delegate.finishAttributeValue();
                this.state = "afterAttributeValueQuoted";
            } else if (char === "&") this.delegate.appendToAttributeValue(this.consumeCharRef("'") || "&");
            else this.delegate.appendToAttributeValue(char);
        },
        attributeValueUnquoted: function attributeValueUnquoted() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) {
                this.delegate.finishAttributeValue();
                this.consume();
                this.state = "beforeAttributeName";
            } else if (char === "&") {
                this.consume();
                this.delegate.appendToAttributeValue(this.consumeCharRef(">") || "&");
            } else if (char === ">") {
                this.delegate.finishAttributeValue();
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else {
                this.consume();
                this.delegate.appendToAttributeValue(char);
            }
        },
        afterAttributeValueQuoted: function afterAttributeValueQuoted() {
            var char = this.peek();
            if ((0, $6O4jo.isSpace)(char)) {
                this.consume();
                this.state = "beforeAttributeName";
            } else if (char === "/") {
                this.consume();
                this.state = "selfClosingStartTag";
            } else if (char === ">") {
                this.consume();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else this.state = "beforeAttributeName";
        },
        selfClosingStartTag: function selfClosingStartTag() {
            var char = this.peek();
            if (char === ">") {
                this.consume();
                this.delegate.markTagAsSelfClosing();
                this.delegate.finishTag();
                this.state = "beforeData";
            } else this.state = "beforeAttributeName";
        },
        endTagOpen: function endTagOpen() {
            var char = this.consume();
            if ((0, $6O4jo.isAlpha)(char)) {
                this.state = "tagName";
                this.delegate.beginEndTag();
                this.delegate.appendToTagName(char.toLowerCase());
            }
        }
    }
};
$93b3cb251e137893$export$2e2bcd8739ae039 = $93b3cb251e137893$var$EventedTokenizer;

});
parcelRequire.register("6O4jo", function(module, exports) {

$parcel$export(module.exports, "isSpace", function () { return $4f4ac1d097423a6c$export$1d5ccafae59b4926; }, function (v) { return $4f4ac1d097423a6c$export$1d5ccafae59b4926 = v; });
$parcel$export(module.exports, "isAlpha", function () { return $4f4ac1d097423a6c$export$4f1b4fd0a80ed3b5; }, function (v) { return $4f4ac1d097423a6c$export$4f1b4fd0a80ed3b5 = v; });
$parcel$export(module.exports, "preprocessInput", function () { return $4f4ac1d097423a6c$export$e8058993f8a991b1; }, function (v) { return $4f4ac1d097423a6c$export$e8058993f8a991b1 = v; });
var $4f4ac1d097423a6c$export$1e511d4a378977f5;
var $4f4ac1d097423a6c$export$1d5ccafae59b4926;
var $4f4ac1d097423a6c$export$4f1b4fd0a80ed3b5;
var $4f4ac1d097423a6c$export$e8058993f8a991b1;
"use strict";
$4f4ac1d097423a6c$export$1e511d4a378977f5 = true;
$4f4ac1d097423a6c$export$1d5ccafae59b4926 = $4f4ac1d097423a6c$var$isSpace;
$4f4ac1d097423a6c$export$4f1b4fd0a80ed3b5 = $4f4ac1d097423a6c$var$isAlpha;
$4f4ac1d097423a6c$export$e8058993f8a991b1 = $4f4ac1d097423a6c$var$preprocessInput;
var $4f4ac1d097423a6c$var$WSP = /[\t\n\f ]/;
var $4f4ac1d097423a6c$var$ALPHA = /[A-Za-z]/;
var $4f4ac1d097423a6c$var$CRLF = /\r\n?/g;
function $4f4ac1d097423a6c$var$isSpace(char) {
    return $4f4ac1d097423a6c$var$WSP.test(char);
}
function $4f4ac1d097423a6c$var$isAlpha(char) {
    return $4f4ac1d097423a6c$var$ALPHA.test(char);
}
function $4f4ac1d097423a6c$var$preprocessInput(input) {
    return input.replace($4f4ac1d097423a6c$var$CRLF, "\n");
}

});


parcelRequire.register("cPmUq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $956c04bba2d1f256$export$1e511d4a378977f5; }, function (v) { return $956c04bba2d1f256$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $956c04bba2d1f256$export$2e2bcd8739ae039; }, function (v) { return $956c04bba2d1f256$export$2e2bcd8739ae039 = v; });
var $956c04bba2d1f256$export$1e511d4a378977f5;
var $956c04bba2d1f256$export$2e2bcd8739ae039;
"use strict";
$956c04bba2d1f256$export$1e511d4a378977f5 = true;

var $cGdod = parcelRequire("cGdod");
var $956c04bba2d1f256$var$_eventedTokenizer2 = $956c04bba2d1f256$var$_interopRequireDefault($cGdod);
function $956c04bba2d1f256$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $956c04bba2d1f256$var$Tokenizer(entityParser, options) {
    this.token = null;
    this.startLine = 1;
    this.startColumn = 0;
    this.options = options || {};
    this.tokenizer = new $956c04bba2d1f256$var$_eventedTokenizer2.default(this, entityParser);
}
$956c04bba2d1f256$var$Tokenizer.prototype = {
    tokenize: function tokenize(input) {
        this.tokens = [];
        this.tokenizer.tokenize(input);
        return this.tokens;
    },
    tokenizePart: function tokenizePart(input) {
        this.tokens = [];
        this.tokenizer.tokenizePart(input);
        return this.tokens;
    },
    tokenizeEOF: function tokenizeEOF() {
        this.tokens = [];
        this.tokenizer.tokenizeEOF();
        return this.tokens[0];
    },
    reset: function reset() {
        this.token = null;
        this.startLine = 1;
        this.startColumn = 0;
    },
    addLocInfo: function addLocInfo() {
        if (this.options.loc) this.token.loc = {
            start: {
                line: this.startLine,
                column: this.startColumn
            },
            end: {
                line: this.tokenizer.line,
                column: this.tokenizer.column
            }
        };
        this.startLine = this.tokenizer.line;
        this.startColumn = this.tokenizer.column;
    },
    // Data
    beginData: function beginData() {
        this.token = {
            type: "Chars",
            chars: ""
        };
        this.tokens.push(this.token);
    },
    appendToData: function appendToData(char) {
        this.token.chars += char;
    },
    finishData: function finishData() {
        this.addLocInfo();
    },
    // Comment
    beginComment: function beginComment() {
        this.token = {
            type: "Comment",
            chars: ""
        };
        this.tokens.push(this.token);
    },
    appendToCommentData: function appendToCommentData(char) {
        this.token.chars += char;
    },
    finishComment: function finishComment() {
        this.addLocInfo();
    },
    // Tags - basic
    beginStartTag: function beginStartTag() {
        this.token = {
            type: "StartTag",
            tagName: "",
            attributes: [],
            selfClosing: false
        };
        this.tokens.push(this.token);
    },
    beginEndTag: function beginEndTag() {
        this.token = {
            type: "EndTag",
            tagName: ""
        };
        this.tokens.push(this.token);
    },
    finishTag: function finishTag() {
        this.addLocInfo();
    },
    markTagAsSelfClosing: function markTagAsSelfClosing() {
        this.token.selfClosing = true;
    },
    // Tags - name
    appendToTagName: function appendToTagName(char) {
        this.token.tagName += char;
    },
    // Tags - attributes
    beginAttribute: function beginAttribute() {
        this._currentAttribute = [
            "",
            "",
            null
        ];
        this.token.attributes.push(this._currentAttribute);
    },
    appendToAttributeName: function appendToAttributeName(char) {
        this._currentAttribute[0] += char;
    },
    beginAttributeValue: function beginAttributeValue(isQuoted) {
        this._currentAttribute[2] = isQuoted;
    },
    appendToAttributeValue: function appendToAttributeValue(char) {
        this._currentAttribute[1] = this._currentAttribute[1] || "";
        this._currentAttribute[1] += char;
    },
    finishAttributeValue: function finishAttributeValue() {}
};
$956c04bba2d1f256$export$2e2bcd8739ae039 = $956c04bba2d1f256$var$Tokenizer;

});

parcelRequire.register("hh9lz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $c93b465382767e39$export$1e511d4a378977f5; }, function (v) { return $c93b465382767e39$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $c93b465382767e39$export$2e2bcd8739ae039; }, function (v) { return $c93b465382767e39$export$2e2bcd8739ae039 = v; });
var $c93b465382767e39$export$1e511d4a378977f5;
var $c93b465382767e39$export$2e2bcd8739ae039;
"use strict";
$c93b465382767e39$export$1e511d4a378977f5 = true;
$c93b465382767e39$export$2e2bcd8739ae039 = $c93b465382767e39$var$tokenize;

var $cPmUq = parcelRequire("cPmUq");
var $c93b465382767e39$var$_tokenizer2 = $c93b465382767e39$var$_interopRequireDefault($cPmUq);

var $HoDAu = parcelRequire("HoDAu");
var $c93b465382767e39$var$_entityParser2 = $c93b465382767e39$var$_interopRequireDefault($HoDAu);

var $jgenH = parcelRequire("jgenH");
var $c93b465382767e39$var$_html5NamedCharRefs2 = $c93b465382767e39$var$_interopRequireDefault($jgenH);
function $c93b465382767e39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c93b465382767e39$var$tokenize(input, options) {
    var tokenizer = new $c93b465382767e39$var$_tokenizer2.default(new $c93b465382767e39$var$_entityParser2.default($c93b465382767e39$var$_html5NamedCharRefs2.default), options);
    return tokenizer.tokenize(input);
}

});


parcelRequire.register("hyJuA", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $cc88e67f8be9f0d4$export$1e511d4a378977f5; }, function (v) { return $cc88e67f8be9f0d4$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "tokenize", function () { return $cc88e67f8be9f0d4$export$660b2ee2d4fb4eff; }, function (v) { return $cc88e67f8be9f0d4$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "test", function () { return $cc88e67f8be9f0d4$export$e0969da9b8fb378d; }, function (v) { return $cc88e67f8be9f0d4$export$e0969da9b8fb378d = v; });
$parcel$export(module.exports, "scanner", function () { return $cc88e67f8be9f0d4$export$d8d3db7cd9d1a570; }, function (v) { return $cc88e67f8be9f0d4$export$d8d3db7cd9d1a570 = v; });
$parcel$export(module.exports, "parser", function () { return $cc88e67f8be9f0d4$export$8f49e4af10703ce3; }, function (v) { return $cc88e67f8be9f0d4$export$8f49e4af10703ce3 = v; });
$parcel$export(module.exports, "options", function () { return $cc88e67f8be9f0d4$export$41c562ebe57d11e2; }, function (v) { return $cc88e67f8be9f0d4$export$41c562ebe57d11e2 = v; });
$parcel$export(module.exports, "inherits", function () { return $cc88e67f8be9f0d4$export$69f1b2dcda23c5f8; }, function (v) { return $cc88e67f8be9f0d4$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "find", function () { return $cc88e67f8be9f0d4$export$71aa6c912b956294; }, function (v) { return $cc88e67f8be9f0d4$export$71aa6c912b956294 = v; });
var $cc88e67f8be9f0d4$export$1e511d4a378977f5;
var $cc88e67f8be9f0d4$export$660b2ee2d4fb4eff;
var $cc88e67f8be9f0d4$export$e0969da9b8fb378d;
var $cc88e67f8be9f0d4$export$d8d3db7cd9d1a570;
var $cc88e67f8be9f0d4$export$8f49e4af10703ce3;
var $cc88e67f8be9f0d4$export$41c562ebe57d11e2;
var $cc88e67f8be9f0d4$export$69f1b2dcda23c5f8;
var $cc88e67f8be9f0d4$export$71aa6c912b956294;
"use strict";
$cc88e67f8be9f0d4$export$1e511d4a378977f5 = true;
$cc88e67f8be9f0d4$export$660b2ee2d4fb4eff = $cc88e67f8be9f0d4$export$e0969da9b8fb378d = $cc88e67f8be9f0d4$export$d8d3db7cd9d1a570 = $cc88e67f8be9f0d4$export$8f49e4af10703ce3 = $cc88e67f8be9f0d4$export$41c562ebe57d11e2 = $cc88e67f8be9f0d4$export$69f1b2dcda23c5f8 = $cc88e67f8be9f0d4$export$71aa6c912b956294 = undefined;

var $eP7f2 = parcelRequire("eP7f2");

var $gcZdD = parcelRequire("gcZdD");
var $cc88e67f8be9f0d4$var$options = $cc88e67f8be9f0d4$var$_interopRequireWildcard($gcZdD);

var $7u8pq = parcelRequire("7u8pq");
var $cc88e67f8be9f0d4$var$scanner = $cc88e67f8be9f0d4$var$_interopRequireWildcard($7u8pq);

var $c1hAf = parcelRequire("c1hAf");
var $cc88e67f8be9f0d4$var$parser = $cc88e67f8be9f0d4$var$_interopRequireWildcard($c1hAf);
function $cc88e67f8be9f0d4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
if (!Array.isArray) Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
};
/**
	Converts a string into tokens that represent linkable and non-linkable bits
	@method tokenize
	@param {String} str
	@return {Array} tokens
*/ var $cc88e67f8be9f0d4$var$tokenize = function tokenize(str) {
    return $cc88e67f8be9f0d4$var$parser.run($cc88e67f8be9f0d4$var$scanner.run(str));
};
/**
	Returns a list of linkable items in the given string.
*/ var $cc88e67f8be9f0d4$var$find = function find(str) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var tokens = $cc88e67f8be9f0d4$var$tokenize(str);
    var filtered = [];
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (token.isLink && (!type || token.type === type)) filtered.push(token.toObject());
    }
    return filtered;
};
/**
	Is the given string valid linkable text of some sort
	Note that this does not trim the text for you.

	Optionally pass in a second `type` param, which is the type of link to test
	for.

	For example,

		test(str, 'email');

	Will return `true` if str is a valid email.
*/ var $cc88e67f8be9f0d4$var$test = function test(str) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var tokens = $cc88e67f8be9f0d4$var$tokenize(str);
    return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
};
// Scanner and parser provide states and tokens for the lexicographic stage
// (will be used to add additional link types)
$cc88e67f8be9f0d4$export$71aa6c912b956294 = $cc88e67f8be9f0d4$var$find;
$cc88e67f8be9f0d4$export$69f1b2dcda23c5f8 = $eP7f2.inherits;
$cc88e67f8be9f0d4$export$41c562ebe57d11e2 = $cc88e67f8be9f0d4$var$options;
$cc88e67f8be9f0d4$export$8f49e4af10703ce3 = $cc88e67f8be9f0d4$var$parser;
$cc88e67f8be9f0d4$export$d8d3db7cd9d1a570 = $cc88e67f8be9f0d4$var$scanner;
$cc88e67f8be9f0d4$export$e0969da9b8fb378d = $cc88e67f8be9f0d4$var$test;
$cc88e67f8be9f0d4$export$660b2ee2d4fb4eff = $cc88e67f8be9f0d4$var$tokenize;

});
parcelRequire.register("eP7f2", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $acab721d01063299$export$69f1b2dcda23c5f8; }, function (v) { return $acab721d01063299$export$69f1b2dcda23c5f8 = v; });
var $acab721d01063299$export$1e511d4a378977f5;
var $acab721d01063299$export$69f1b2dcda23c5f8;
"use strict";
$acab721d01063299$export$1e511d4a378977f5 = true;
$acab721d01063299$export$69f1b2dcda23c5f8 = $acab721d01063299$var$inherits;
function $acab721d01063299$var$inherits(parent, child) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var extended = Object.create(parent.prototype);
    for(var p in props)extended[p] = props[p];
    extended.constructor = child;
    child.prototype = extended;
    return child;
}

});

parcelRequire.register("gcZdD", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $bccd411fcd96baea$export$1e511d4a378977f5; }, function (v) { return $bccd411fcd96baea$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "defaults", function () { return $bccd411fcd96baea$export$ebe90cb607ad99e; }, function (v) { return $bccd411fcd96baea$export$ebe90cb607ad99e = v; });
$parcel$export(module.exports, "Options", function () { return $bccd411fcd96baea$export$c019608e5b5bb4cb; }, function (v) { return $bccd411fcd96baea$export$c019608e5b5bb4cb = v; });
$parcel$export(module.exports, "contains", function () { return $bccd411fcd96baea$export$2344b14b097df817; }, function (v) { return $bccd411fcd96baea$export$2344b14b097df817 = v; });
var $bccd411fcd96baea$export$1e511d4a378977f5;
var $bccd411fcd96baea$export$ebe90cb607ad99e;
var $bccd411fcd96baea$export$c019608e5b5bb4cb;
var $bccd411fcd96baea$export$2344b14b097df817;
"use strict";
$bccd411fcd96baea$export$1e511d4a378977f5 = true;
var $bccd411fcd96baea$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $bccd411fcd96baea$var$defaults = {
    defaultProtocol: "http",
    events: null,
    format: $bccd411fcd96baea$var$noop,
    formatHref: $bccd411fcd96baea$var$noop,
    nl2br: false,
    tagName: "a",
    target: $bccd411fcd96baea$var$typeToTarget,
    validate: true,
    ignoreTags: [],
    attributes: null,
    className: "linkified" // Deprecated value - no default class will be provided in the future
};
$bccd411fcd96baea$export$ebe90cb607ad99e = $bccd411fcd96baea$var$defaults;
$bccd411fcd96baea$export$c019608e5b5bb4cb = $bccd411fcd96baea$var$Options;
$bccd411fcd96baea$export$2344b14b097df817 = $bccd411fcd96baea$var$contains;
function $bccd411fcd96baea$var$Options(opts) {
    opts = opts || {};
    this.defaultProtocol = opts.hasOwnProperty("defaultProtocol") ? opts.defaultProtocol : $bccd411fcd96baea$var$defaults.defaultProtocol;
    this.events = opts.hasOwnProperty("events") ? opts.events : $bccd411fcd96baea$var$defaults.events;
    this.format = opts.hasOwnProperty("format") ? opts.format : $bccd411fcd96baea$var$defaults.format;
    this.formatHref = opts.hasOwnProperty("formatHref") ? opts.formatHref : $bccd411fcd96baea$var$defaults.formatHref;
    this.nl2br = opts.hasOwnProperty("nl2br") ? opts.nl2br : $bccd411fcd96baea$var$defaults.nl2br;
    this.tagName = opts.hasOwnProperty("tagName") ? opts.tagName : $bccd411fcd96baea$var$defaults.tagName;
    this.target = opts.hasOwnProperty("target") ? opts.target : $bccd411fcd96baea$var$defaults.target;
    this.validate = opts.hasOwnProperty("validate") ? opts.validate : $bccd411fcd96baea$var$defaults.validate;
    this.ignoreTags = [];
    // linkAttributes and linkClass is deprecated
    this.attributes = opts.attributes || opts.linkAttributes || $bccd411fcd96baea$var$defaults.attributes;
    this.className = opts.hasOwnProperty("className") ? opts.className : opts.linkClass || $bccd411fcd96baea$var$defaults.className;
    // Make all tags names upper case
    var ignoredTags = opts.hasOwnProperty("ignoreTags") ? opts.ignoreTags : $bccd411fcd96baea$var$defaults.ignoreTags;
    for(var i = 0; i < ignoredTags.length; i++)this.ignoreTags.push(ignoredTags[i].toUpperCase());
}
$bccd411fcd96baea$var$Options.prototype = {
    /**
  * Given the token, return all options for how it should be displayed
  */ resolve: function resolve(token) {
        var href = token.toHref(this.defaultProtocol);
        return {
            formatted: this.get("format", token.toString(), token),
            formattedHref: this.get("formatHref", href, token),
            tagName: this.get("tagName", href, token),
            className: this.get("className", href, token),
            target: this.get("target", href, token),
            events: this.getObject("events", href, token),
            attributes: this.getObject("attributes", href, token)
        };
    },
    /**
  * Returns true or false based on whether a token should be displayed as a
  * link based on the user options. By default,
  */ check: function check(token) {
        return this.get("validate", token.toString(), token);
    },
    // Private methods
    /**
  * Resolve an option's value based on the value of the option and the given
  * params.
  * @param {String} key Name of option to use
  * @param operator will be passed to the target option if it's method
  * @param {MultiToken} token The token from linkify.tokenize
  */ get: function get(key, operator, token) {
        var optionValue = void 0, option = this[key];
        if (!option) return option;
        switch(typeof option === "undefined" ? "undefined" : $bccd411fcd96baea$var$_typeof(option)){
            case "function":
                return option(operator, token.type);
            case "object":
                optionValue = option.hasOwnProperty(token.type) ? option[token.type] : $bccd411fcd96baea$var$defaults[key];
                return typeof optionValue === "function" ? optionValue(operator, token.type) : optionValue;
        }
        return option;
    },
    getObject: function getObject(key, operator, token) {
        var option = this[key];
        return typeof option === "function" ? option(operator, token.type) : option;
    }
};
/**
 * Quick indexOf replacement for checking the ignoreTags option
 */ function $bccd411fcd96baea$var$contains(arr, value) {
    for(var i = 0; i < arr.length; i++){
        if (arr[i] === value) return true;
    }
    return false;
}
function $bccd411fcd96baea$var$noop(val) {
    return val;
}
function $bccd411fcd96baea$var$typeToTarget(href, type) {
    return type === "url" ? "_blank" : null;
}

});

parcelRequire.register("7u8pq", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $5731db9fe536e3bf$export$1e511d4a378977f5; }, function (v) { return $5731db9fe536e3bf$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "start", function () { return $5731db9fe536e3bf$export$b3571188c770cc5a; }, function (v) { return $5731db9fe536e3bf$export$b3571188c770cc5a = v; });
$parcel$export(module.exports, "run", function () { return $5731db9fe536e3bf$export$889ea624f2cb2c57; }, function (v) { return $5731db9fe536e3bf$export$889ea624f2cb2c57 = v; });
$parcel$export(module.exports, "TOKENS", function () { return $5731db9fe536e3bf$export$d5f8e91b6f2b49e0; }, function (v) { return $5731db9fe536e3bf$export$d5f8e91b6f2b49e0 = v; });
$parcel$export(module.exports, "State", function () { return $5731db9fe536e3bf$export$7254cc27399e90bd; }, function (v) { return $5731db9fe536e3bf$export$7254cc27399e90bd = v; });
var $5731db9fe536e3bf$export$1e511d4a378977f5;
var $5731db9fe536e3bf$export$b3571188c770cc5a;
var $5731db9fe536e3bf$export$889ea624f2cb2c57;
var $5731db9fe536e3bf$export$d5f8e91b6f2b49e0;
var $5731db9fe536e3bf$export$7254cc27399e90bd;
"use strict";
$5731db9fe536e3bf$export$1e511d4a378977f5 = true;
$5731db9fe536e3bf$export$b3571188c770cc5a = $5731db9fe536e3bf$export$889ea624f2cb2c57 = $5731db9fe536e3bf$export$d5f8e91b6f2b49e0 = $5731db9fe536e3bf$export$7254cc27399e90bd = undefined;

var $8P0us = parcelRequire("8P0us");

var $9aGoL = parcelRequire("9aGoL");
var $5731db9fe536e3bf$var$TOKENS = $5731db9fe536e3bf$var$_interopRequireWildcard($9aGoL);
function $5731db9fe536e3bf$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $5731db9fe536e3bf$var$tlds = "aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|aetna|af|afamilycompany|afl|africa|ag|agakhan|agency|ai|aig|aigo|airbus|airforce|airtel|akdn|al|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|am|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|ao|aol|apartments|app|apple|aq|aquarelle|ar|arab|aramco|archi|army|arpa|art|arte|as|asda|asia|associates|at|athleta|attorney|au|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aw|aws|ax|axa|az|azure|ba|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bb|bbc|bbt|bbva|bcg|bcn|bd|be|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|cat|catering|catholic|cba|cbn|cbre|cbs|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|ci|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|de|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dj|dk|dm|dnp|do|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dz|earth|eat|ec|eco|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|er|ericsson|erni|es|esq|estate|esurance|et|etisalat|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fi|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|flir|florist|flowers|fly|fm|fo|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|fr|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|ga|gal|gallery|gallo|gallup|game|games|gap|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|george|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glade|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|grocery|group|gs|gt|gu|guardian|gucci|guge|guide|guitars|guru|gw|gy|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hk|hkt|hm|hn|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hr|hsbc|ht|htc|hu|hughes|hyatt|hyundai|ibm|icbc|ice|icu|id|ie|ieee|ifm|ikano|il|im|imamat|imdb|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|intel|international|intuit|investments|io|ipiranga|iq|ir|irish|is|iselect|ismaili|ist|istanbul|it|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|je|jeep|jetzt|jewelry|jio|jlc|jll|jm|jmp|jnj|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|juniper|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kindle|kitchen|kiwi|km|kn|koeln|komatsu|kosher|kp|kpmg|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|lk|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|lr|ls|lt|ltd|ltda|lu|lundbeck|lupin|luxe|luxury|lv|ly|ma|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mc|mckinsey|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|mg|mh|miami|microsoft|mil|mini|mint|mit|mitsubishi|mk|ml|mlb|mls|mm|mma|mn|mo|mobi|mobile|mobily|moda|moe|moi|mom|monash|money|monster|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|mp|mq|mr|ms|msd|mt|mtn|mtr|mu|museum|mutual|mv|mw|mx|my|mz|na|nab|nadex|nagoya|name|nationwide|natura|navy|nba|nc|ne|nec|net|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nf|nfl|ng|ngo|nhk|ni|nico|nike|nikon|ninja|nissan|nissay|nl|no|nokia|northwesternmutual|norton|now|nowruz|nowtv|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|om|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|org|organic|origins|osaka|otsuka|ott|ovh|pa|page|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pe|pet|pf|pfizer|pg|ph|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pnc|pohl|poker|politie|porn|post|pr|pramerica|praxi|press|prime|pro|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|qvc|racing|radio|raid|re|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|ro|rocher|rocks|rodeo|rogers|room|rs|rsvp|ru|rugby|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sb|sbi|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|sd|se|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|sg|sh|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|si|silk|sina|singles|site|sj|sk|ski|skin|sky|skype|sl|sling|sm|smart|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|srt|st|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiftcover|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|tdk|team|tech|technology|tel|telecity|telefonica|temasek|tennis|teva|tf|tg|th|thd|theater|theatre|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tj|tjmaxx|tjx|tk|tkmaxx|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tr|trade|trading|training|travel|travelchannel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubank|ubs|uconnect|ug|uk|unicom|university|uno|uol|ups|us|uy|uz|va|vacations|vana|vanguard|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vn|vodka|volkswagen|volvo|vote|voting|voto|voyage|vu|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|ws|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--30rr7y|xn--3bst00m|xn--3ds443g|xn--3e0b707e|xn--3hcrj9c|xn--3oq18vl8pn36a|xn--3pxu8k|xn--42c2d9a|xn--45br5cyl|xn--45brj9c|xn--45q11c|xn--4gbrim|xn--54b7fta0cc|xn--55qw42g|xn--55qx5d|xn--5su34j936bgsg|xn--5tzm5g|xn--6frz82g|xn--6qq986b3xl|xn--80adxhks|xn--80ao21a|xn--80aqecdr1a|xn--80asehdb|xn--80aswg|xn--8y0a063a|xn--90a3ac|xn--90ae|xn--90ais|xn--9dbq2a|xn--9et52u|xn--9krt00a|xn--b4w605ferd|xn--bck1b9a5dre4c|xn--c1avg|xn--c2br7g|xn--cck2b3b|xn--cg4bki|xn--clchc0ea0b2g2a9gcd|xn--czr694b|xn--czrs0t|xn--czru2d|xn--d1acj3b|xn--d1alf|xn--e1a4c|xn--eckvdtc9d|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fhbei|xn--fiq228c5hs|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--fjq720a|xn--flw351e|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--fzys8d69uvgm|xn--g2xx48c|xn--gckr3f0f|xn--gecrj9c|xn--gk3at1e|xn--h2breg3eve|xn--h2brj9c|xn--h2brj9c8c|xn--hxt814e|xn--i1b6b1a6a2e|xn--imr513n|xn--io0a7i|xn--j1aef|xn--j1amh|xn--j6w193g|xn--jlq61u9w7b|xn--jvr189m|xn--kcrx77d1x4a|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--kput3i|xn--l1acc|xn--lgbbat1ad8j|xn--mgb9awbf|xn--mgba3a3ejt|xn--mgba3a4f16a|xn--mgba7c0bbn0a|xn--mgbaakc7dvf|xn--mgbaam7a8h|xn--mgbab2bd|xn--mgbai9azgqp6j|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a|xn--mgbbh1a71e|xn--mgbc0a9azcg|xn--mgbca7dzdo|xn--mgberp4a5d4ar|xn--mgbgu82a|xn--mgbi4ecexp|xn--mgbpl2fh|xn--mgbt3dhd|xn--mgbtx2b|xn--mgbx4cd0ab|xn--mix891f|xn--mk1bu44c|xn--mxtq1m|xn--ngbc5azd|xn--ngbe9e0a|xn--ngbrx|xn--node|xn--nqv7f|xn--nqv7fs00ema|xn--nyqy26a|xn--o3cw4h|xn--ogbpf8fl|xn--p1acf|xn--p1ai|xn--pbt977c|xn--pgbs0dh|xn--pssy2u|xn--q9jyb4c|xn--qcka1pmc|xn--qxam|xn--rhqv96g|xn--rovu88b|xn--rvc1e0am3e|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--tckwe|xn--tiq49xqyj|xn--unup4y|xn--vermgensberater-ctb|xn--vermgensberatung-pwb|xn--vhquv|xn--vuq861b|xn--w4r85el8fhu5dnra|xn--w4rs40l|xn--wgbh1c|xn--wgbl6a|xn--xhq521b|xn--xkc2al3hye2a|xn--xkc2dl3a5ee0h|xn--y9a3aq|xn--yfro4i67o|xn--ygbi2ammx|xn--zfr164b|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|you|youtube|yt|yun|za|zappos|zara|zero|zip|zippo|zm|zone|zuerich|zw".split("|"); // macro, see gulpfile.js
/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/ var $5731db9fe536e3bf$var$NUMBERS = "0123456789".split("");
var $5731db9fe536e3bf$var$ALPHANUM = "0123456789abcdefghijklmnopqrstuvwxyz".split("");
var $5731db9fe536e3bf$var$WHITESPACE = [
    " ",
    "\f",
    "\r",
    "	",
    "\v",
    "\xa0",
    " ",
    "᠎"
]; // excluding line breaks
var $5731db9fe536e3bf$var$domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
var $5731db9fe536e3bf$var$makeState = function makeState(tokenClass) {
    return new $8P0us.CharacterState(tokenClass);
};
// Frequently used states
var $5731db9fe536e3bf$var$S_START = $5731db9fe536e3bf$var$makeState();
var $5731db9fe536e3bf$var$S_NUM = $5731db9fe536e3bf$var$makeState($9aGoL.NUM);
var $5731db9fe536e3bf$var$S_DOMAIN = $5731db9fe536e3bf$var$makeState($9aGoL.DOMAIN);
var $5731db9fe536e3bf$var$S_DOMAIN_HYPHEN = $5731db9fe536e3bf$var$makeState(); // domain followed by 1 or more hyphen characters
var $5731db9fe536e3bf$var$S_WS = $5731db9fe536e3bf$var$makeState($9aGoL.WS);
// States for special URL symbols
$5731db9fe536e3bf$var$S_START.on("@", $5731db9fe536e3bf$var$makeState($9aGoL.AT)).on(".", $5731db9fe536e3bf$var$makeState($9aGoL.DOT)).on("+", $5731db9fe536e3bf$var$makeState($9aGoL.PLUS)).on("#", $5731db9fe536e3bf$var$makeState($9aGoL.POUND)).on("?", $5731db9fe536e3bf$var$makeState($9aGoL.QUERY)).on("/", $5731db9fe536e3bf$var$makeState($9aGoL.SLASH)).on("_", $5731db9fe536e3bf$var$makeState($9aGoL.UNDERSCORE)).on(":", $5731db9fe536e3bf$var$makeState($9aGoL.COLON)).on("{", $5731db9fe536e3bf$var$makeState($9aGoL.OPENBRACE)).on("[", $5731db9fe536e3bf$var$makeState($9aGoL.OPENBRACKET)).on("<", $5731db9fe536e3bf$var$makeState($9aGoL.OPENANGLEBRACKET)).on("(", $5731db9fe536e3bf$var$makeState($9aGoL.OPENPAREN)).on("}", $5731db9fe536e3bf$var$makeState($9aGoL.CLOSEBRACE)).on("]", $5731db9fe536e3bf$var$makeState($9aGoL.CLOSEBRACKET)).on(">", $5731db9fe536e3bf$var$makeState($9aGoL.CLOSEANGLEBRACKET)).on(")", $5731db9fe536e3bf$var$makeState($9aGoL.CLOSEPAREN)).on("&", $5731db9fe536e3bf$var$makeState($9aGoL.AMPERSAND)).on([
    ",",
    ";",
    "!",
    '"',
    "'"
], $5731db9fe536e3bf$var$makeState($9aGoL.PUNCTUATION));
// Whitespace jumps
// Tokens of only non-newline whitespace are arbitrarily long
$5731db9fe536e3bf$var$S_START.on("\n", $5731db9fe536e3bf$var$makeState($9aGoL.NL)).on($5731db9fe536e3bf$var$WHITESPACE, $5731db9fe536e3bf$var$S_WS);
// If any whitespace except newline, more whitespace!
$5731db9fe536e3bf$var$S_WS.on($5731db9fe536e3bf$var$WHITESPACE, $5731db9fe536e3bf$var$S_WS);
// Generates states for top-level domains
// Note that this is most accurate when tlds are in alphabetical order
for(var $5731db9fe536e3bf$var$i = 0; $5731db9fe536e3bf$var$i < $5731db9fe536e3bf$var$tlds.length; $5731db9fe536e3bf$var$i++){
    var $5731db9fe536e3bf$var$newStates = (0, $8P0us.stateify)($5731db9fe536e3bf$var$tlds[$5731db9fe536e3bf$var$i], $5731db9fe536e3bf$var$S_START, $9aGoL.TLD, $9aGoL.DOMAIN);
    $5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$newStates);
}
// Collect the states generated by different protocls
var $5731db9fe536e3bf$var$partialProtocolFileStates = (0, $8P0us.stateify)("file", $5731db9fe536e3bf$var$S_START, $9aGoL.DOMAIN, $9aGoL.DOMAIN);
var $5731db9fe536e3bf$var$partialProtocolFtpStates = (0, $8P0us.stateify)("ftp", $5731db9fe536e3bf$var$S_START, $9aGoL.DOMAIN, $9aGoL.DOMAIN);
var $5731db9fe536e3bf$var$partialProtocolHttpStates = (0, $8P0us.stateify)("http", $5731db9fe536e3bf$var$S_START, $9aGoL.DOMAIN, $9aGoL.DOMAIN);
var $5731db9fe536e3bf$var$partialProtocolMailtoStates = (0, $8P0us.stateify)("mailto", $5731db9fe536e3bf$var$S_START, $9aGoL.DOMAIN, $9aGoL.DOMAIN);
// Add the states to the array of DOMAINeric states
$5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$partialProtocolFileStates);
$5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$partialProtocolFtpStates);
$5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$partialProtocolHttpStates);
$5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$partialProtocolMailtoStates);
// Protocol states
var $5731db9fe536e3bf$var$S_PROTOCOL_FILE = $5731db9fe536e3bf$var$partialProtocolFileStates.pop();
var $5731db9fe536e3bf$var$S_PROTOCOL_FTP = $5731db9fe536e3bf$var$partialProtocolFtpStates.pop();
var $5731db9fe536e3bf$var$S_PROTOCOL_HTTP = $5731db9fe536e3bf$var$partialProtocolHttpStates.pop();
var $5731db9fe536e3bf$var$S_MAILTO = $5731db9fe536e3bf$var$partialProtocolMailtoStates.pop();
var $5731db9fe536e3bf$var$S_PROTOCOL_SECURE = $5731db9fe536e3bf$var$makeState($9aGoL.DOMAIN);
var $5731db9fe536e3bf$var$S_FULL_PROTOCOL = $5731db9fe536e3bf$var$makeState($9aGoL.PROTOCOL); // Full protocol ends with COLON
var $5731db9fe536e3bf$var$S_FULL_MAILTO = $5731db9fe536e3bf$var$makeState($9aGoL.MAILTO); // Mailto ends with COLON
// Secure protocols (end with 's')
$5731db9fe536e3bf$var$S_PROTOCOL_FTP.on("s", $5731db9fe536e3bf$var$S_PROTOCOL_SECURE).on(":", $5731db9fe536e3bf$var$S_FULL_PROTOCOL);
$5731db9fe536e3bf$var$S_PROTOCOL_HTTP.on("s", $5731db9fe536e3bf$var$S_PROTOCOL_SECURE).on(":", $5731db9fe536e3bf$var$S_FULL_PROTOCOL);
$5731db9fe536e3bf$var$domainStates.push($5731db9fe536e3bf$var$S_PROTOCOL_SECURE);
// Become protocol tokens after a COLON
$5731db9fe536e3bf$var$S_PROTOCOL_FILE.on(":", $5731db9fe536e3bf$var$S_FULL_PROTOCOL);
$5731db9fe536e3bf$var$S_PROTOCOL_SECURE.on(":", $5731db9fe536e3bf$var$S_FULL_PROTOCOL);
$5731db9fe536e3bf$var$S_MAILTO.on(":", $5731db9fe536e3bf$var$S_FULL_MAILTO);
// Localhost
var $5731db9fe536e3bf$var$partialLocalhostStates = (0, $8P0us.stateify)("localhost", $5731db9fe536e3bf$var$S_START, $9aGoL.LOCALHOST, $9aGoL.DOMAIN);
$5731db9fe536e3bf$var$domainStates.push.apply($5731db9fe536e3bf$var$domainStates, $5731db9fe536e3bf$var$partialLocalhostStates);
// Everything else
// DOMAINs make more DOMAINs
// Number and character transitions
$5731db9fe536e3bf$var$S_START.on($5731db9fe536e3bf$var$NUMBERS, $5731db9fe536e3bf$var$S_NUM);
$5731db9fe536e3bf$var$S_NUM.on("-", $5731db9fe536e3bf$var$S_DOMAIN_HYPHEN).on($5731db9fe536e3bf$var$NUMBERS, $5731db9fe536e3bf$var$S_NUM).on($5731db9fe536e3bf$var$ALPHANUM, $5731db9fe536e3bf$var$S_DOMAIN); // number becomes DOMAIN
$5731db9fe536e3bf$var$S_DOMAIN.on("-", $5731db9fe536e3bf$var$S_DOMAIN_HYPHEN).on($5731db9fe536e3bf$var$ALPHANUM, $5731db9fe536e3bf$var$S_DOMAIN);
// All the generated states should have a jump to DOMAIN
for(var $5731db9fe536e3bf$var$_i = 0; $5731db9fe536e3bf$var$_i < $5731db9fe536e3bf$var$domainStates.length; $5731db9fe536e3bf$var$_i++)$5731db9fe536e3bf$var$domainStates[$5731db9fe536e3bf$var$_i].on("-", $5731db9fe536e3bf$var$S_DOMAIN_HYPHEN).on($5731db9fe536e3bf$var$ALPHANUM, $5731db9fe536e3bf$var$S_DOMAIN);
$5731db9fe536e3bf$var$S_DOMAIN_HYPHEN.on("-", $5731db9fe536e3bf$var$S_DOMAIN_HYPHEN).on($5731db9fe536e3bf$var$NUMBERS, $5731db9fe536e3bf$var$S_DOMAIN).on($5731db9fe536e3bf$var$ALPHANUM, $5731db9fe536e3bf$var$S_DOMAIN);
// Set default transition
$5731db9fe536e3bf$var$S_START.defaultTransition = $5731db9fe536e3bf$var$makeState($9aGoL.SYM);
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {String} str Input string to scan
	@return {Array} Array of TOKEN instances
*/ var $5731db9fe536e3bf$var$run = function run(str) {
    // The state machine only looks at lowercase strings.
    // This selective `toLowerCase` is used because lowercasing the entire
    // string causes the length and character position to vary in some in some
    // non-English strings. This happens only on V8-based runtimes.
    var lowerStr = str.replace(/[A-Z]/g, function(c) {
        return c.toLowerCase();
    });
    var len = str.length;
    var tokens = []; // return value
    var cursor = 0;
    // Tokenize the string
    while(cursor < len){
        var state = $5731db9fe536e3bf$var$S_START;
        var nextState = null;
        var tokenLength = 0;
        var latestAccepting = null;
        var sinceAccepts = -1;
        while(cursor < len && (nextState = state.next(lowerStr[cursor]))){
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            tokenLength++;
            cursor++;
        }
        if (sinceAccepts < 0) continue;
         // Should never happen
        // Roll back to the latest accepting state
        cursor -= sinceAccepts;
        tokenLength -= sinceAccepts;
        // Get the class for the new token
        var TOKEN = latestAccepting.emit(); // Current token class
        // No more jumps, just make a new token
        tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
    }
    return tokens;
};
var $5731db9fe536e3bf$var$start = $5731db9fe536e3bf$var$S_START;
$5731db9fe536e3bf$export$7254cc27399e90bd = $8P0us.CharacterState;
$5731db9fe536e3bf$export$d5f8e91b6f2b49e0 = $5731db9fe536e3bf$var$TOKENS;
$5731db9fe536e3bf$export$889ea624f2cb2c57 = $5731db9fe536e3bf$var$run;
$5731db9fe536e3bf$export$b3571188c770cc5a = $5731db9fe536e3bf$var$start;

});
parcelRequire.register("8P0us", function(module, exports) {

$parcel$export(module.exports, "stateify", function () { return $66c37785d65db4d8$export$f82ca6c677a3b794; }, function (v) { return $66c37785d65db4d8$export$f82ca6c677a3b794 = v; });
$parcel$export(module.exports, "TokenState", function () { return $66c37785d65db4d8$export$d05098264b0703d6; }, function (v) { return $66c37785d65db4d8$export$d05098264b0703d6 = v; });
$parcel$export(module.exports, "CharacterState", function () { return $66c37785d65db4d8$export$f2e6b371e93925c7; }, function (v) { return $66c37785d65db4d8$export$f2e6b371e93925c7 = v; });
var $66c37785d65db4d8$export$1e511d4a378977f5;
var $66c37785d65db4d8$export$f82ca6c677a3b794;
var $66c37785d65db4d8$export$d05098264b0703d6;
var $66c37785d65db4d8$export$f2e6b371e93925c7;
"use strict";
$66c37785d65db4d8$export$1e511d4a378977f5 = true;
$66c37785d65db4d8$export$f82ca6c677a3b794 = $66c37785d65db4d8$export$d05098264b0703d6 = $66c37785d65db4d8$export$f2e6b371e93925c7 = undefined;

var $eP7f2 = parcelRequire("eP7f2");
function $66c37785d65db4d8$var$createStateClass() {
    return function(tClass) {
        this.j = [];
        this.T = tClass || null;
    };
}
/**
	A simple state machine that can emit token classes

	The `j` property in this class refers to state jumps. It's a
	multidimensional array where for each element:

	* index [0] is a symbol or class of symbols to transition to.
	* index [1] is a State instance which matches

	The type of symbol will depend on the target implementation for this class.
	In Linkify, we have a two-stage scanner. Each stage uses this state machine
	but with a slighly different (polymorphic) implementation.

	The `T` property refers to the token class.

	TODO: Can the `on` and `next` methods be combined?

	@class BaseState
*/ var $66c37785d65db4d8$var$BaseState = $66c37785d65db4d8$var$createStateClass();
$66c37785d65db4d8$var$BaseState.prototype = {
    defaultTransition: false,
    /**
 	@method constructor
 	@param {Class} tClass Pass in the kind of token to emit if there are
 		no jumps after this state and the state is accepting.
 */ /**
 	On the given symbol(s), this machine should go to the given state
 		@method on
 	@param {Array|Mixed} symbol
 	@param {BaseState} state Note that the type of this state should be the
 		same as the current instance (i.e., don't pass in a different
 		subclass)
 */ on: function on(symbol, state) {
        if (symbol instanceof Array) {
            for(var i = 0; i < symbol.length; i++)this.j.push([
                symbol[i],
                state
            ]);
            return this;
        }
        this.j.push([
            symbol,
            state
        ]);
        return this;
    },
    /**
 	Given the next item, returns next state for that item
 	@method next
 	@param {Mixed} item Should be an instance of the symbols handled by
 		this particular machine.
 	@return {State} state Returns false if no jumps are available
 */ next: function next(item) {
        for(var i = 0; i < this.j.length; i++){
            var jump = this.j[i];
            var symbol = jump[0]; // Next item to check for
            var state = jump[1]; // State to jump to if items match
            // compare item with symbol
            if (this.test(item, symbol)) return state;
        }
        // Nowhere left to jump!
        return this.defaultTransition;
    },
    /**
 	Does this state accept?
 	`true` only of `this.T` exists
 		@method accepts
 	@return {Boolean}
 */ accepts: function accepts() {
        return !!this.T;
    },
    /**
 	Determine whether a given item "symbolizes" the symbol, where symbol is
 	a class of items handled by this state machine.
 		This method should be overriden in extended classes.
 		@method test
 	@param {Mixed} item Does this item match the given symbol?
 	@param {Mixed} symbol
 	@return {Boolean}
 */ test: function test(item, symbol) {
        return item === symbol;
    },
    /**
 	Emit the token for this State (just return it in this case)
 	If this emits a token, this instance is an accepting state
 	@method emit
 	@return {Class} T
 */ emit: function emit() {
        return this.T;
    }
};
/**
	State machine for string-based input

	@class CharacterState
	@extends BaseState
*/ var $66c37785d65db4d8$var$CharacterState = (0, $eP7f2.inherits)($66c37785d65db4d8$var$BaseState, $66c37785d65db4d8$var$createStateClass(), {
    /**
 	Does the given character match the given character or regular
 	expression?
 		@method test
 	@param {String} char
 	@param {String|RegExp} charOrRegExp
 	@return {Boolean}
 */ test: function test(character, charOrRegExp) {
        return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
    }
});
/**
	State machine for input in the form of TextTokens

	@class TokenState
	@extends BaseState
*/ var $66c37785d65db4d8$var$TokenState = (0, $eP7f2.inherits)($66c37785d65db4d8$var$BaseState, $66c37785d65db4d8$var$createStateClass(), {
    /**
  * Similar to `on`, but returns the state the results in the transition from
  * the given item
  * @method jump
  * @param {Mixed} item
  * @param {Token} [token]
  * @return state
  */ jump: function jump(token) {
        var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var state = this.next(new token("")); // dummy temp token
        if (state === this.defaultTransition) {
            // Make a new state!
            state = new this.constructor(tClass);
            this.on(token, state);
        } else if (tClass) state.T = tClass;
        return state;
    },
    /**
 	Is the given token an instance of the given token class?
 		@method test
 	@param {TextToken} token
 	@param {Class} tokenClass
 	@return {Boolean}
 */ test: function test(token, tokenClass) {
        return token instanceof tokenClass;
    }
});
/**
	Given a non-empty target string, generates states (if required) for each
	consecutive substring of characters in str starting from the beginning of
	the string. The final state will have a special value, as specified in
	options. All other "in between" substrings will have a default end state.

	This turns the state machine into a Trie-like data structure (rather than a
	intelligently-designed DFA).

	Note that I haven't really tried these with any strings other than
	DOMAIN.

	@param {String} str
	@param {CharacterState} start State to jump from the first character
	@param {Class} endToken Token class to emit when the given string has been
		matched and no more jumps exist.
	@param {Class} defaultToken "Filler token", or which token type to emit when
		we don't have a full match
	@return {Array} list of newly-created states
*/ function $66c37785d65db4d8$var$stateify(str, start, endToken, defaultToken) {
    var i = 0, len = str.length, state = start, newStates = [], nextState = void 0;
    // Find the next state without a jump to the next character
    while(i < len && (nextState = state.next(str[i]))){
        state = nextState;
        i++;
    }
    if (i >= len) return [];
     // no new tokens were added
    while(i < len - 1){
        nextState = new $66c37785d65db4d8$var$CharacterState(defaultToken);
        newStates.push(nextState);
        state.on(str[i], nextState);
        state = nextState;
        i++;
    }
    nextState = new $66c37785d65db4d8$var$CharacterState(endToken);
    newStates.push(nextState);
    state.on(str[len - 1], nextState);
    return newStates;
}
$66c37785d65db4d8$export$f2e6b371e93925c7 = $66c37785d65db4d8$var$CharacterState;
$66c37785d65db4d8$export$d05098264b0703d6 = $66c37785d65db4d8$var$TokenState;
$66c37785d65db4d8$export$f82ca6c677a3b794 = $66c37785d65db4d8$var$stateify;

});

parcelRequire.register("9aGoL", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $6ad5efa57f9b428c$export$1e511d4a378977f5; }, function (v) { return $6ad5efa57f9b428c$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "AMPERSAND", function () { return $6ad5efa57f9b428c$export$26ab15420354a452; }, function (v) { return $6ad5efa57f9b428c$export$26ab15420354a452 = v; });
$parcel$export(module.exports, "CLOSEPAREN", function () { return $6ad5efa57f9b428c$export$65a2819f3d8a8d98; }, function (v) { return $6ad5efa57f9b428c$export$65a2819f3d8a8d98 = v; });
$parcel$export(module.exports, "CLOSEANGLEBRACKET", function () { return $6ad5efa57f9b428c$export$f22c15cf4fd5953c; }, function (v) { return $6ad5efa57f9b428c$export$f22c15cf4fd5953c = v; });
$parcel$export(module.exports, "CLOSEBRACKET", function () { return $6ad5efa57f9b428c$export$bc579c210613036c; }, function (v) { return $6ad5efa57f9b428c$export$bc579c210613036c = v; });
$parcel$export(module.exports, "CLOSEBRACE", function () { return $6ad5efa57f9b428c$export$be663160fd93e3; }, function (v) { return $6ad5efa57f9b428c$export$be663160fd93e3 = v; });
$parcel$export(module.exports, "OPENPAREN", function () { return $6ad5efa57f9b428c$export$85c5428f8330e7c2; }, function (v) { return $6ad5efa57f9b428c$export$85c5428f8330e7c2 = v; });
$parcel$export(module.exports, "OPENANGLEBRACKET", function () { return $6ad5efa57f9b428c$export$e367d973f08bcd24; }, function (v) { return $6ad5efa57f9b428c$export$e367d973f08bcd24 = v; });
$parcel$export(module.exports, "OPENBRACKET", function () { return $6ad5efa57f9b428c$export$5d2455f4e905cc58; }, function (v) { return $6ad5efa57f9b428c$export$5d2455f4e905cc58 = v; });
$parcel$export(module.exports, "OPENBRACE", function () { return $6ad5efa57f9b428c$export$9adfcd534d38bbb; }, function (v) { return $6ad5efa57f9b428c$export$9adfcd534d38bbb = v; });
$parcel$export(module.exports, "WS", function () { return $6ad5efa57f9b428c$export$911baa0677ac404c; }, function (v) { return $6ad5efa57f9b428c$export$911baa0677ac404c = v; });
$parcel$export(module.exports, "TLD", function () { return $6ad5efa57f9b428c$export$253817505f0f4dba; }, function (v) { return $6ad5efa57f9b428c$export$253817505f0f4dba = v; });
$parcel$export(module.exports, "SYM", function () { return $6ad5efa57f9b428c$export$4d01b6560c172de; }, function (v) { return $6ad5efa57f9b428c$export$4d01b6560c172de = v; });
$parcel$export(module.exports, "UNDERSCORE", function () { return $6ad5efa57f9b428c$export$4fe27d0a6a9d65d3; }, function (v) { return $6ad5efa57f9b428c$export$4fe27d0a6a9d65d3 = v; });
$parcel$export(module.exports, "SLASH", function () { return $6ad5efa57f9b428c$export$98238152dfccf046; }, function (v) { return $6ad5efa57f9b428c$export$98238152dfccf046 = v; });
$parcel$export(module.exports, "MAILTO", function () { return $6ad5efa57f9b428c$export$43edd5eb767df5a3; }, function (v) { return $6ad5efa57f9b428c$export$43edd5eb767df5a3 = v; });
$parcel$export(module.exports, "PROTOCOL", function () { return $6ad5efa57f9b428c$export$c8c3a54f48bee1ad; }, function (v) { return $6ad5efa57f9b428c$export$c8c3a54f48bee1ad = v; });
$parcel$export(module.exports, "QUERY", function () { return $6ad5efa57f9b428c$export$2b91517d6d5b4365; }, function (v) { return $6ad5efa57f9b428c$export$2b91517d6d5b4365 = v; });
$parcel$export(module.exports, "POUND", function () { return $6ad5efa57f9b428c$export$82bea2f8ae85f03f; }, function (v) { return $6ad5efa57f9b428c$export$82bea2f8ae85f03f = v; });
$parcel$export(module.exports, "PLUS", function () { return $6ad5efa57f9b428c$export$898f613ed2bbf29a; }, function (v) { return $6ad5efa57f9b428c$export$898f613ed2bbf29a = v; });
$parcel$export(module.exports, "NUM", function () { return $6ad5efa57f9b428c$export$c03f7f5a174192b4; }, function (v) { return $6ad5efa57f9b428c$export$c03f7f5a174192b4 = v; });
$parcel$export(module.exports, "NL", function () { return $6ad5efa57f9b428c$export$e51d3c675bb0140d; }, function (v) { return $6ad5efa57f9b428c$export$e51d3c675bb0140d = v; });
$parcel$export(module.exports, "LOCALHOST", function () { return $6ad5efa57f9b428c$export$5ca4de98860013a7; }, function (v) { return $6ad5efa57f9b428c$export$5ca4de98860013a7 = v; });
$parcel$export(module.exports, "PUNCTUATION", function () { return $6ad5efa57f9b428c$export$d1b7b2e62fe6473b; }, function (v) { return $6ad5efa57f9b428c$export$d1b7b2e62fe6473b = v; });
$parcel$export(module.exports, "DOT", function () { return $6ad5efa57f9b428c$export$4061f92b6da4a345; }, function (v) { return $6ad5efa57f9b428c$export$4061f92b6da4a345 = v; });
$parcel$export(module.exports, "COLON", function () { return $6ad5efa57f9b428c$export$96c3628b3b9d2079; }, function (v) { return $6ad5efa57f9b428c$export$96c3628b3b9d2079 = v; });
$parcel$export(module.exports, "AT", function () { return $6ad5efa57f9b428c$export$537de78b98ba1ef0; }, function (v) { return $6ad5efa57f9b428c$export$537de78b98ba1ef0 = v; });
$parcel$export(module.exports, "DOMAIN", function () { return $6ad5efa57f9b428c$export$517466abcb8fcf10; }, function (v) { return $6ad5efa57f9b428c$export$517466abcb8fcf10 = v; });
$parcel$export(module.exports, "Base", function () { return $6ad5efa57f9b428c$export$ef88aa0d34c34520; }, function (v) { return $6ad5efa57f9b428c$export$ef88aa0d34c34520 = v; });
var $6ad5efa57f9b428c$export$1e511d4a378977f5;
var $6ad5efa57f9b428c$export$26ab15420354a452;
var $6ad5efa57f9b428c$export$65a2819f3d8a8d98;
var $6ad5efa57f9b428c$export$f22c15cf4fd5953c;
var $6ad5efa57f9b428c$export$bc579c210613036c;
var $6ad5efa57f9b428c$export$be663160fd93e3;
var $6ad5efa57f9b428c$export$85c5428f8330e7c2;
var $6ad5efa57f9b428c$export$e367d973f08bcd24;
var $6ad5efa57f9b428c$export$5d2455f4e905cc58;
var $6ad5efa57f9b428c$export$9adfcd534d38bbb;
var $6ad5efa57f9b428c$export$911baa0677ac404c;
var $6ad5efa57f9b428c$export$253817505f0f4dba;
var $6ad5efa57f9b428c$export$4d01b6560c172de;
var $6ad5efa57f9b428c$export$4fe27d0a6a9d65d3;
var $6ad5efa57f9b428c$export$98238152dfccf046;
var $6ad5efa57f9b428c$export$43edd5eb767df5a3;
var $6ad5efa57f9b428c$export$c8c3a54f48bee1ad;
var $6ad5efa57f9b428c$export$2b91517d6d5b4365;
var $6ad5efa57f9b428c$export$82bea2f8ae85f03f;
var $6ad5efa57f9b428c$export$898f613ed2bbf29a;
var $6ad5efa57f9b428c$export$c03f7f5a174192b4;
var $6ad5efa57f9b428c$export$e51d3c675bb0140d;
var $6ad5efa57f9b428c$export$5ca4de98860013a7;
var $6ad5efa57f9b428c$export$d1b7b2e62fe6473b;
var $6ad5efa57f9b428c$export$4061f92b6da4a345;
var $6ad5efa57f9b428c$export$96c3628b3b9d2079;
var $6ad5efa57f9b428c$export$537de78b98ba1ef0;
var $6ad5efa57f9b428c$export$517466abcb8fcf10;
var $6ad5efa57f9b428c$export$ef88aa0d34c34520;
"use strict";
$6ad5efa57f9b428c$export$1e511d4a378977f5 = true;
$6ad5efa57f9b428c$export$26ab15420354a452 = $6ad5efa57f9b428c$export$65a2819f3d8a8d98 = $6ad5efa57f9b428c$export$f22c15cf4fd5953c = $6ad5efa57f9b428c$export$bc579c210613036c = $6ad5efa57f9b428c$export$be663160fd93e3 = $6ad5efa57f9b428c$export$85c5428f8330e7c2 = $6ad5efa57f9b428c$export$e367d973f08bcd24 = $6ad5efa57f9b428c$export$5d2455f4e905cc58 = $6ad5efa57f9b428c$export$9adfcd534d38bbb = $6ad5efa57f9b428c$export$911baa0677ac404c = $6ad5efa57f9b428c$export$253817505f0f4dba = $6ad5efa57f9b428c$export$4d01b6560c172de = $6ad5efa57f9b428c$export$4fe27d0a6a9d65d3 = $6ad5efa57f9b428c$export$98238152dfccf046 = $6ad5efa57f9b428c$export$43edd5eb767df5a3 = $6ad5efa57f9b428c$export$c8c3a54f48bee1ad = $6ad5efa57f9b428c$export$2b91517d6d5b4365 = $6ad5efa57f9b428c$export$82bea2f8ae85f03f = $6ad5efa57f9b428c$export$898f613ed2bbf29a = $6ad5efa57f9b428c$export$c03f7f5a174192b4 = $6ad5efa57f9b428c$export$e51d3c675bb0140d = $6ad5efa57f9b428c$export$5ca4de98860013a7 = $6ad5efa57f9b428c$export$d1b7b2e62fe6473b = $6ad5efa57f9b428c$export$4061f92b6da4a345 = $6ad5efa57f9b428c$export$96c3628b3b9d2079 = $6ad5efa57f9b428c$export$537de78b98ba1ef0 = $6ad5efa57f9b428c$export$517466abcb8fcf10 = $6ad5efa57f9b428c$export$ef88aa0d34c34520 = undefined;

var $hW8Br = parcelRequire("hW8Br");

var $eP7f2 = parcelRequire("eP7f2");
/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/ /**
	Abstract class used for manufacturing text tokens.
	Pass in the value this token represents

	@class TextToken
	@abstract
*/ var $6ad5efa57f9b428c$var$TextToken = (0, $hW8Br.createTokenClass)();
$6ad5efa57f9b428c$var$TextToken.prototype = {
    toString: function toString() {
        return this.v + "";
    }
};
function $6ad5efa57f9b428c$var$inheritsToken(value) {
    var props = value ? {
        v: value
    } : {};
    return (0, $eP7f2.inherits)($6ad5efa57f9b428c$var$TextToken, (0, $hW8Br.createTokenClass)(), props);
}
/**
	A valid domain token
	@class DOMAIN
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$DOMAIN = $6ad5efa57f9b428c$var$inheritsToken();
/**
	@class AT
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$AT = $6ad5efa57f9b428c$var$inheritsToken("@");
/**
	Represents a single colon `:` character

	@class COLON
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$COLON = $6ad5efa57f9b428c$var$inheritsToken(":");
/**
	@class DOT
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$DOT = $6ad5efa57f9b428c$var$inheritsToken(".");
/**
	A character class that can surround the URL, but which the URL cannot begin
	or end with. Does not include certain English punctuation like parentheses.

	@class PUNCTUATION
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$PUNCTUATION = $6ad5efa57f9b428c$var$inheritsToken();
/**
	The word localhost (by itself)
	@class LOCALHOST
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$LOCALHOST = $6ad5efa57f9b428c$var$inheritsToken();
/**
	Newline token
	@class NL
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$NL = $6ad5efa57f9b428c$var$inheritsToken("\n");
/**
	@class NUM
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$NUM = $6ad5efa57f9b428c$var$inheritsToken();
/**
	@class PLUS
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$PLUS = $6ad5efa57f9b428c$var$inheritsToken("+");
/**
	@class POUND
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$POUND = $6ad5efa57f9b428c$var$inheritsToken("#");
/**
	Represents a web URL protocol. Supported types include

	* `http:`
	* `https:`
	* `ftp:`
	* `ftps:`

	@class PROTOCOL
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$PROTOCOL = $6ad5efa57f9b428c$var$inheritsToken();
/**
	Represents the start of the email URI protocol

	@class MAILTO
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$MAILTO = $6ad5efa57f9b428c$var$inheritsToken("mailto:");
/**
	@class QUERY
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$QUERY = $6ad5efa57f9b428c$var$inheritsToken("?");
/**
	@class SLASH
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$SLASH = $6ad5efa57f9b428c$var$inheritsToken("/");
/**
	@class UNDERSCORE
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$UNDERSCORE = $6ad5efa57f9b428c$var$inheritsToken("_");
/**
	One ore more non-whitespace symbol.
	@class SYM
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$SYM = $6ad5efa57f9b428c$var$inheritsToken();
/**
	@class TLD
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$TLD = $6ad5efa57f9b428c$var$inheritsToken();
/**
	Represents a string of consecutive whitespace characters

	@class WS
	@extends TextToken
*/ var $6ad5efa57f9b428c$var$WS = $6ad5efa57f9b428c$var$inheritsToken();
/**
	Opening/closing bracket classes
*/ var $6ad5efa57f9b428c$var$OPENBRACE = $6ad5efa57f9b428c$var$inheritsToken("{");
var $6ad5efa57f9b428c$var$OPENBRACKET = $6ad5efa57f9b428c$var$inheritsToken("[");
var $6ad5efa57f9b428c$var$OPENANGLEBRACKET = $6ad5efa57f9b428c$var$inheritsToken("<");
var $6ad5efa57f9b428c$var$OPENPAREN = $6ad5efa57f9b428c$var$inheritsToken("(");
var $6ad5efa57f9b428c$var$CLOSEBRACE = $6ad5efa57f9b428c$var$inheritsToken("}");
var $6ad5efa57f9b428c$var$CLOSEBRACKET = $6ad5efa57f9b428c$var$inheritsToken("]");
var $6ad5efa57f9b428c$var$CLOSEANGLEBRACKET = $6ad5efa57f9b428c$var$inheritsToken(">");
var $6ad5efa57f9b428c$var$CLOSEPAREN = $6ad5efa57f9b428c$var$inheritsToken(")");
var $6ad5efa57f9b428c$var$AMPERSAND = $6ad5efa57f9b428c$var$inheritsToken("&");
$6ad5efa57f9b428c$export$ef88aa0d34c34520 = $6ad5efa57f9b428c$var$TextToken;
$6ad5efa57f9b428c$export$517466abcb8fcf10 = $6ad5efa57f9b428c$var$DOMAIN;
$6ad5efa57f9b428c$export$537de78b98ba1ef0 = $6ad5efa57f9b428c$var$AT;
$6ad5efa57f9b428c$export$96c3628b3b9d2079 = $6ad5efa57f9b428c$var$COLON;
$6ad5efa57f9b428c$export$4061f92b6da4a345 = $6ad5efa57f9b428c$var$DOT;
$6ad5efa57f9b428c$export$d1b7b2e62fe6473b = $6ad5efa57f9b428c$var$PUNCTUATION;
$6ad5efa57f9b428c$export$5ca4de98860013a7 = $6ad5efa57f9b428c$var$LOCALHOST;
$6ad5efa57f9b428c$export$e51d3c675bb0140d = $6ad5efa57f9b428c$var$NL;
$6ad5efa57f9b428c$export$c03f7f5a174192b4 = $6ad5efa57f9b428c$var$NUM;
$6ad5efa57f9b428c$export$898f613ed2bbf29a = $6ad5efa57f9b428c$var$PLUS;
$6ad5efa57f9b428c$export$82bea2f8ae85f03f = $6ad5efa57f9b428c$var$POUND;
$6ad5efa57f9b428c$export$2b91517d6d5b4365 = $6ad5efa57f9b428c$var$QUERY;
$6ad5efa57f9b428c$export$c8c3a54f48bee1ad = $6ad5efa57f9b428c$var$PROTOCOL;
$6ad5efa57f9b428c$export$43edd5eb767df5a3 = $6ad5efa57f9b428c$var$MAILTO;
$6ad5efa57f9b428c$export$98238152dfccf046 = $6ad5efa57f9b428c$var$SLASH;
$6ad5efa57f9b428c$export$4fe27d0a6a9d65d3 = $6ad5efa57f9b428c$var$UNDERSCORE;
$6ad5efa57f9b428c$export$4d01b6560c172de = $6ad5efa57f9b428c$var$SYM;
$6ad5efa57f9b428c$export$253817505f0f4dba = $6ad5efa57f9b428c$var$TLD;
$6ad5efa57f9b428c$export$911baa0677ac404c = $6ad5efa57f9b428c$var$WS;
$6ad5efa57f9b428c$export$9adfcd534d38bbb = $6ad5efa57f9b428c$var$OPENBRACE;
$6ad5efa57f9b428c$export$5d2455f4e905cc58 = $6ad5efa57f9b428c$var$OPENBRACKET;
$6ad5efa57f9b428c$export$e367d973f08bcd24 = $6ad5efa57f9b428c$var$OPENANGLEBRACKET;
$6ad5efa57f9b428c$export$85c5428f8330e7c2 = $6ad5efa57f9b428c$var$OPENPAREN;
$6ad5efa57f9b428c$export$be663160fd93e3 = $6ad5efa57f9b428c$var$CLOSEBRACE;
$6ad5efa57f9b428c$export$bc579c210613036c = $6ad5efa57f9b428c$var$CLOSEBRACKET;
$6ad5efa57f9b428c$export$f22c15cf4fd5953c = $6ad5efa57f9b428c$var$CLOSEANGLEBRACKET;
$6ad5efa57f9b428c$export$65a2819f3d8a8d98 = $6ad5efa57f9b428c$var$CLOSEPAREN;
$6ad5efa57f9b428c$export$26ab15420354a452 = $6ad5efa57f9b428c$var$AMPERSAND;

});
parcelRequire.register("hW8Br", function(module, exports) {

$parcel$export(module.exports, "createTokenClass", function () { return $d0ee86cec5a0d03b$export$21042e7280c1baba; }, function (v) { return $d0ee86cec5a0d03b$export$21042e7280c1baba = v; });
var $d0ee86cec5a0d03b$export$1e511d4a378977f5;
var $d0ee86cec5a0d03b$export$21042e7280c1baba;
"use strict";
$d0ee86cec5a0d03b$export$1e511d4a378977f5 = true;
function $d0ee86cec5a0d03b$var$createTokenClass() {
    return function(value) {
        if (value) this.v = value;
    };
}
$d0ee86cec5a0d03b$export$21042e7280c1baba = $d0ee86cec5a0d03b$var$createTokenClass;

});



parcelRequire.register("c1hAf", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $8c0337c81b96a601$export$1e511d4a378977f5; }, function (v) { return $8c0337c81b96a601$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "start", function () { return $8c0337c81b96a601$export$b3571188c770cc5a; }, function (v) { return $8c0337c81b96a601$export$b3571188c770cc5a = v; });
$parcel$export(module.exports, "run", function () { return $8c0337c81b96a601$export$889ea624f2cb2c57; }, function (v) { return $8c0337c81b96a601$export$889ea624f2cb2c57 = v; });
$parcel$export(module.exports, "TOKENS", function () { return $8c0337c81b96a601$export$d5f8e91b6f2b49e0; }, function (v) { return $8c0337c81b96a601$export$d5f8e91b6f2b49e0 = v; });
$parcel$export(module.exports, "State", function () { return $8c0337c81b96a601$export$7254cc27399e90bd; }, function (v) { return $8c0337c81b96a601$export$7254cc27399e90bd = v; });
var $8c0337c81b96a601$export$1e511d4a378977f5;
var $8c0337c81b96a601$export$b3571188c770cc5a;
var $8c0337c81b96a601$export$889ea624f2cb2c57;
var $8c0337c81b96a601$export$d5f8e91b6f2b49e0;
var $8c0337c81b96a601$export$7254cc27399e90bd;
"use strict";
$8c0337c81b96a601$export$1e511d4a378977f5 = true;
$8c0337c81b96a601$export$b3571188c770cc5a = $8c0337c81b96a601$export$889ea624f2cb2c57 = $8c0337c81b96a601$export$d5f8e91b6f2b49e0 = $8c0337c81b96a601$export$7254cc27399e90bd = undefined;

var $8P0us = parcelRequire("8P0us");

var $6Am2D = parcelRequire("6Am2D");
var $8c0337c81b96a601$var$MULTI_TOKENS = $8c0337c81b96a601$var$_interopRequireWildcard($6Am2D);

var $9aGoL = parcelRequire("9aGoL");
function $8c0337c81b96a601$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main parser
*/ var $8c0337c81b96a601$var$makeState = function makeState(tokenClass) {
    return new $8P0us.TokenState(tokenClass);
};
// The universal starting state.
var $8c0337c81b96a601$var$S_START = $8c0337c81b96a601$var$makeState();
// Intermediate states for URLs. Note that domains that begin with a protocol
// are treated slighly differently from those that don't.
var $8c0337c81b96a601$var$S_PROTOCOL = $8c0337c81b96a601$var$makeState(); // e.g., 'http:'
var $8c0337c81b96a601$var$S_MAILTO = $8c0337c81b96a601$var$makeState(); // 'mailto:'
var $8c0337c81b96a601$var$S_PROTOCOL_SLASH = $8c0337c81b96a601$var$makeState(); // e.g., '/', 'http:/''
var $8c0337c81b96a601$var$S_PROTOCOL_SLASH_SLASH = $8c0337c81b96a601$var$makeState(); // e.g., '//', 'http://'
var $8c0337c81b96a601$var$S_DOMAIN = $8c0337c81b96a601$var$makeState(); // parsed string ends with a potential domain name (A)
var $8c0337c81b96a601$var$S_DOMAIN_DOT = $8c0337c81b96a601$var$makeState(); // (A) domain followed by DOT
var $8c0337c81b96a601$var$S_TLD = $8c0337c81b96a601$var$makeState($6Am2D.URL); // (A) Simplest possible URL with no query string
var $8c0337c81b96a601$var$S_TLD_COLON = $8c0337c81b96a601$var$makeState(); // (A) URL followed by colon (potential port number here)
var $8c0337c81b96a601$var$S_TLD_PORT = $8c0337c81b96a601$var$makeState($6Am2D.URL); // TLD followed by a port number
var $8c0337c81b96a601$var$S_URL = $8c0337c81b96a601$var$makeState($6Am2D.URL); // Long URL with optional port and maybe query string
var $8c0337c81b96a601$var$S_URL_NON_ACCEPTING = $8c0337c81b96a601$var$makeState(); // URL followed by some symbols (will not be part of the final URL)
var $8c0337c81b96a601$var$S_URL_OPENBRACE = $8c0337c81b96a601$var$makeState(); // URL followed by {
var $8c0337c81b96a601$var$S_URL_OPENBRACKET = $8c0337c81b96a601$var$makeState(); // URL followed by [
var $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET = $8c0337c81b96a601$var$makeState(); // URL followed by <
var $8c0337c81b96a601$var$S_URL_OPENPAREN = $8c0337c81b96a601$var$makeState(); // URL followed by (
var $8c0337c81b96a601$var$S_URL_OPENBRACE_Q = $8c0337c81b96a601$var$makeState($6Am2D.URL); // URL followed by { and some symbols that the URL can end it
var $8c0337c81b96a601$var$S_URL_OPENBRACKET_Q = $8c0337c81b96a601$var$makeState($6Am2D.URL); // URL followed by [ and some symbols that the URL can end it
var $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q = $8c0337c81b96a601$var$makeState($6Am2D.URL); // URL followed by < and some symbols that the URL can end it
var $8c0337c81b96a601$var$S_URL_OPENPAREN_Q = $8c0337c81b96a601$var$makeState($6Am2D.URL); // URL followed by ( and some symbols that the URL can end it
var $8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS = $8c0337c81b96a601$var$makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
var $8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS = $8c0337c81b96a601$var$makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
var $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS = $8c0337c81b96a601$var$makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
var $8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS = $8c0337c81b96a601$var$makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
var $8c0337c81b96a601$var$S_EMAIL_DOMAIN = $8c0337c81b96a601$var$makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
var $8c0337c81b96a601$var$S_EMAIL_DOMAIN_DOT = $8c0337c81b96a601$var$makeState(); // (C) domain followed by DOT
var $8c0337c81b96a601$var$S_EMAIL = $8c0337c81b96a601$var$makeState($6Am2D.EMAIL); // (C) Possible email address (could have more tlds)
var $8c0337c81b96a601$var$S_EMAIL_COLON = $8c0337c81b96a601$var$makeState(); // (C) URL followed by colon (potential port number here)
var $8c0337c81b96a601$var$S_EMAIL_PORT = $8c0337c81b96a601$var$makeState($6Am2D.EMAIL); // (C) Email address with a port
var $8c0337c81b96a601$var$S_MAILTO_EMAIL = $8c0337c81b96a601$var$makeState($6Am2D.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
var $8c0337c81b96a601$var$S_MAILTO_EMAIL_NON_ACCEPTING = $8c0337c81b96a601$var$makeState(); // (D) Followed by some non-query string chars
var $8c0337c81b96a601$var$S_LOCALPART = $8c0337c81b96a601$var$makeState(); // Local part of the email address
var $8c0337c81b96a601$var$S_LOCALPART_AT = $8c0337c81b96a601$var$makeState(); // Local part of the email address plus @
var $8c0337c81b96a601$var$S_LOCALPART_DOT = $8c0337c81b96a601$var$makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
var $8c0337c81b96a601$var$S_NL = $8c0337c81b96a601$var$makeState($6Am2D.NL); // single new line
// Make path from start to protocol (with '//')
$8c0337c81b96a601$var$S_START.on($9aGoL.NL, $8c0337c81b96a601$var$S_NL).on($9aGoL.PROTOCOL, $8c0337c81b96a601$var$S_PROTOCOL).on($9aGoL.MAILTO, $8c0337c81b96a601$var$S_MAILTO).on($9aGoL.SLASH, $8c0337c81b96a601$var$S_PROTOCOL_SLASH);
$8c0337c81b96a601$var$S_PROTOCOL.on($9aGoL.SLASH, $8c0337c81b96a601$var$S_PROTOCOL_SLASH);
$8c0337c81b96a601$var$S_PROTOCOL_SLASH.on($9aGoL.SLASH, $8c0337c81b96a601$var$S_PROTOCOL_SLASH_SLASH);
// The very first potential domain name
$8c0337c81b96a601$var$S_START.on($9aGoL.TLD, $8c0337c81b96a601$var$S_DOMAIN).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_DOMAIN).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_TLD).on($9aGoL.NUM, $8c0337c81b96a601$var$S_DOMAIN);
// Force URL for protocol followed by anything sane
$8c0337c81b96a601$var$S_PROTOCOL_SLASH_SLASH.on($9aGoL.TLD, $8c0337c81b96a601$var$S_URL).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_URL).on($9aGoL.NUM, $8c0337c81b96a601$var$S_URL).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_URL);
// Account for dots and hyphens
// hyphens are usually parts of domain names
$8c0337c81b96a601$var$S_DOMAIN.on($9aGoL.DOT, $8c0337c81b96a601$var$S_DOMAIN_DOT);
$8c0337c81b96a601$var$S_EMAIL_DOMAIN.on($9aGoL.DOT, $8c0337c81b96a601$var$S_EMAIL_DOMAIN_DOT);
// Hyphen can jump back to a domain name
// After the first domain and a dot, we can find either a URL or another domain
$8c0337c81b96a601$var$S_DOMAIN_DOT.on($9aGoL.TLD, $8c0337c81b96a601$var$S_TLD).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_DOMAIN).on($9aGoL.NUM, $8c0337c81b96a601$var$S_DOMAIN).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_DOMAIN);
$8c0337c81b96a601$var$S_EMAIL_DOMAIN_DOT.on($9aGoL.TLD, $8c0337c81b96a601$var$S_EMAIL).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_EMAIL_DOMAIN).on($9aGoL.NUM, $8c0337c81b96a601$var$S_EMAIL_DOMAIN).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_EMAIL_DOMAIN);
// S_TLD accepts! But the URL could be longer, try to find a match greedily
// The `run` function should be able to "rollback" to the accepting state
$8c0337c81b96a601$var$S_TLD.on($9aGoL.DOT, $8c0337c81b96a601$var$S_DOMAIN_DOT);
$8c0337c81b96a601$var$S_EMAIL.on($9aGoL.DOT, $8c0337c81b96a601$var$S_EMAIL_DOMAIN_DOT);
// Become real URLs after `SLASH` or `COLON NUM SLASH`
// Here PSS and non-PSS converge
$8c0337c81b96a601$var$S_TLD.on($9aGoL.COLON, $8c0337c81b96a601$var$S_TLD_COLON).on($9aGoL.SLASH, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_TLD_COLON.on($9aGoL.NUM, $8c0337c81b96a601$var$S_TLD_PORT);
$8c0337c81b96a601$var$S_TLD_PORT.on($9aGoL.SLASH, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_EMAIL.on($9aGoL.COLON, $8c0337c81b96a601$var$S_EMAIL_COLON);
$8c0337c81b96a601$var$S_EMAIL_COLON.on($9aGoL.NUM, $8c0337c81b96a601$var$S_EMAIL_PORT);
// Types of characters the URL can definitely end in
var $8c0337c81b96a601$var$qsAccepting = [
    $9aGoL.DOMAIN,
    $9aGoL.AT,
    $9aGoL.LOCALHOST,
    $9aGoL.NUM,
    $9aGoL.PLUS,
    $9aGoL.POUND,
    $9aGoL.PROTOCOL,
    $9aGoL.SLASH,
    $9aGoL.TLD,
    $9aGoL.UNDERSCORE,
    $9aGoL.SYM,
    $9aGoL.AMPERSAND
];
// Types of tokens that can follow a URL and be part of the query string
// but cannot be the very last characters
// Characters that cannot appear in the URL at all should be excluded
var $8c0337c81b96a601$var$qsNonAccepting = [
    $9aGoL.COLON,
    $9aGoL.DOT,
    $9aGoL.QUERY,
    $9aGoL.PUNCTUATION,
    $9aGoL.CLOSEBRACE,
    $9aGoL.CLOSEBRACKET,
    $9aGoL.CLOSEANGLEBRACKET,
    $9aGoL.CLOSEPAREN,
    $9aGoL.OPENBRACE,
    $9aGoL.OPENBRACKET,
    $9aGoL.OPENANGLEBRACKET,
    $9aGoL.OPENPAREN
];
// These states are responsible primarily for determining whether or not to
// include the final round bracket.
// URL, followed by an opening bracket
$8c0337c81b96a601$var$S_URL.on($9aGoL.OPENBRACE, $8c0337c81b96a601$var$S_URL_OPENBRACE).on($9aGoL.OPENBRACKET, $8c0337c81b96a601$var$S_URL_OPENBRACKET).on($9aGoL.OPENANGLEBRACKET, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET).on($9aGoL.OPENPAREN, $8c0337c81b96a601$var$S_URL_OPENPAREN);
// URL with extra symbols at the end, followed by an opening bracket
$8c0337c81b96a601$var$S_URL_NON_ACCEPTING.on($9aGoL.OPENBRACE, $8c0337c81b96a601$var$S_URL_OPENBRACE).on($9aGoL.OPENBRACKET, $8c0337c81b96a601$var$S_URL_OPENBRACKET).on($9aGoL.OPENANGLEBRACKET, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET).on($9aGoL.OPENPAREN, $8c0337c81b96a601$var$S_URL_OPENPAREN);
// Closing bracket component. This character WILL be included in the URL
$8c0337c81b96a601$var$S_URL_OPENBRACE.on($9aGoL.CLOSEBRACE, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENBRACKET.on($9aGoL.CLOSEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET.on($9aGoL.CLOSEANGLEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENPAREN.on($9aGoL.CLOSEPAREN, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENBRACE_Q.on($9aGoL.CLOSEBRACE, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_Q.on($9aGoL.CLOSEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q.on($9aGoL.CLOSEANGLEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENPAREN_Q.on($9aGoL.CLOSEPAREN, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS.on($9aGoL.CLOSEBRACE, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS.on($9aGoL.CLOSEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS.on($9aGoL.CLOSEANGLEBRACKET, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS.on($9aGoL.CLOSEPAREN, $8c0337c81b96a601$var$S_URL);
// URL that beings with an opening bracket, followed by a symbols.
// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
// has a single opening bracket for some reason).
$8c0337c81b96a601$var$S_URL_OPENBRACE.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACKET.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENPAREN.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACE.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS);
$8c0337c81b96a601$var$S_URL_OPENBRACKET.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS);
$8c0337c81b96a601$var$S_URL_OPENPAREN.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS);
// URL that begins with an opening bracket, followed by some symbols
$8c0337c81b96a601$var$S_URL_OPENBRACE_Q.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_Q.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENPAREN_Q.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACE_Q.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_Q.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENPAREN_Q.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_Q);
$8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_Q);
$8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACE_SYMS);
$8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENBRACKET_SYMS);
$8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENANGLEBRACKET_SYMS);
$8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_OPENPAREN_SYMS);
// Account for the query string
$8c0337c81b96a601$var$S_URL.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL_NON_ACCEPTING.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_URL);
$8c0337c81b96a601$var$S_URL.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_NON_ACCEPTING);
$8c0337c81b96a601$var$S_URL_NON_ACCEPTING.on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_URL_NON_ACCEPTING);
// Email address-specific state definitions
// Note: We are not allowing '/' in email addresses since this would interfere
// with real URLs
// For addresses with the mailto prefix
// 'mailto:' followed by anything sane is a valid email
$8c0337c81b96a601$var$S_MAILTO.on($9aGoL.TLD, $8c0337c81b96a601$var$S_MAILTO_EMAIL).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_MAILTO_EMAIL).on($9aGoL.NUM, $8c0337c81b96a601$var$S_MAILTO_EMAIL).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_MAILTO_EMAIL);
// Greedily get more potential valid email values
$8c0337c81b96a601$var$S_MAILTO_EMAIL.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_MAILTO_EMAIL).on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_MAILTO_EMAIL_NON_ACCEPTING);
$8c0337c81b96a601$var$S_MAILTO_EMAIL_NON_ACCEPTING.on($8c0337c81b96a601$var$qsAccepting, $8c0337c81b96a601$var$S_MAILTO_EMAIL).on($8c0337c81b96a601$var$qsNonAccepting, $8c0337c81b96a601$var$S_MAILTO_EMAIL_NON_ACCEPTING);
// For addresses without the mailto prefix
// Tokens allowed in the localpart of the email
var $8c0337c81b96a601$var$localpartAccepting = [
    $9aGoL.DOMAIN,
    $9aGoL.NUM,
    $9aGoL.PLUS,
    $9aGoL.POUND,
    $9aGoL.QUERY,
    $9aGoL.UNDERSCORE,
    $9aGoL.SYM,
    $9aGoL.AMPERSAND,
    $9aGoL.TLD
];
// Some of the tokens in `localpartAccepting` are already accounted for here and
// will not be overwritten (don't worry)
$8c0337c81b96a601$var$S_DOMAIN.on($8c0337c81b96a601$var$localpartAccepting, $8c0337c81b96a601$var$S_LOCALPART).on($9aGoL.AT, $8c0337c81b96a601$var$S_LOCALPART_AT);
$8c0337c81b96a601$var$S_TLD.on($8c0337c81b96a601$var$localpartAccepting, $8c0337c81b96a601$var$S_LOCALPART).on($9aGoL.AT, $8c0337c81b96a601$var$S_LOCALPART_AT);
$8c0337c81b96a601$var$S_DOMAIN_DOT.on($8c0337c81b96a601$var$localpartAccepting, $8c0337c81b96a601$var$S_LOCALPART);
// Okay we're on a localpart. Now what?
// TODO: IP addresses and what if the email starts with numbers?
$8c0337c81b96a601$var$S_LOCALPART.on($8c0337c81b96a601$var$localpartAccepting, $8c0337c81b96a601$var$S_LOCALPART).on($9aGoL.AT, $8c0337c81b96a601$var$S_LOCALPART_AT) // close to an email address now
.on($9aGoL.DOT, $8c0337c81b96a601$var$S_LOCALPART_DOT);
$8c0337c81b96a601$var$S_LOCALPART_DOT.on($8c0337c81b96a601$var$localpartAccepting, $8c0337c81b96a601$var$S_LOCALPART);
$8c0337c81b96a601$var$S_LOCALPART_AT.on($9aGoL.TLD, $8c0337c81b96a601$var$S_EMAIL_DOMAIN).on($9aGoL.DOMAIN, $8c0337c81b96a601$var$S_EMAIL_DOMAIN).on($9aGoL.LOCALHOST, $8c0337c81b96a601$var$S_EMAIL);
// States following `@` defined above
var $8c0337c81b96a601$var$run = function run(tokens) {
    var len = tokens.length;
    var cursor = 0;
    var multis = [];
    var textTokens = [];
    while(cursor < len){
        var state = $8c0337c81b96a601$var$S_START;
        var secondState = null;
        var nextState = null;
        var multiLength = 0;
        var latestAccepting = null;
        var sinceAccepts = -1;
        while(cursor < len && !(secondState = state.next(tokens[cursor])))// Starting tokens with nowhere to jump to.
        // Consider these to be just plain text
        textTokens.push(tokens[cursor++]);
        while(cursor < len && (nextState = secondState || state.next(tokens[cursor]))){
            // Get the next state
            secondState = null;
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            cursor++;
            multiLength++;
        }
        if (sinceAccepts < 0) // No accepting state was found, part of a regular text token
        // Add all the tokens we looked at to the text tokens array
        for(var i = cursor - multiLength; i < cursor; i++)textTokens.push(tokens[i]);
        else {
            // Accepting state!
            // First close off the textTokens (if available)
            if (textTokens.length > 0) {
                multis.push(new $6Am2D.TEXT(textTokens));
                textTokens = [];
            }
            // Roll back to the latest accepting state
            cursor -= sinceAccepts;
            multiLength -= sinceAccepts;
            // Create a new multitoken
            var MULTI = latestAccepting.emit();
            multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
        }
    }
    // Finally close off the textTokens (if available)
    if (textTokens.length > 0) multis.push(new $6Am2D.TEXT(textTokens));
    return multis;
};
$8c0337c81b96a601$export$7254cc27399e90bd = $8P0us.TokenState;
$8c0337c81b96a601$export$d5f8e91b6f2b49e0 = $8c0337c81b96a601$var$MULTI_TOKENS;
$8c0337c81b96a601$export$889ea624f2cb2c57 = $8c0337c81b96a601$var$run;
$8c0337c81b96a601$export$b3571188c770cc5a = $8c0337c81b96a601$var$S_START;

});
parcelRequire.register("6Am2D", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $4cb733d6ee218098$export$1e511d4a378977f5; }, function (v) { return $4cb733d6ee218098$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "URL", function () { return $4cb733d6ee218098$export$61abde59b50deb8e; }, function (v) { return $4cb733d6ee218098$export$61abde59b50deb8e = v; });
$parcel$export(module.exports, "TEXT", function () { return $4cb733d6ee218098$export$d597759d33be802e; }, function (v) { return $4cb733d6ee218098$export$d597759d33be802e = v; });
$parcel$export(module.exports, "NL", function () { return $4cb733d6ee218098$export$e51d3c675bb0140d; }, function (v) { return $4cb733d6ee218098$export$e51d3c675bb0140d = v; });
$parcel$export(module.exports, "EMAIL", function () { return $4cb733d6ee218098$export$61171c632678b12e; }, function (v) { return $4cb733d6ee218098$export$61171c632678b12e = v; });
$parcel$export(module.exports, "MAILTOEMAIL", function () { return $4cb733d6ee218098$export$be911dffb9e4cf68; }, function (v) { return $4cb733d6ee218098$export$be911dffb9e4cf68 = v; });
$parcel$export(module.exports, "Base", function () { return $4cb733d6ee218098$export$ef88aa0d34c34520; }, function (v) { return $4cb733d6ee218098$export$ef88aa0d34c34520 = v; });
var $4cb733d6ee218098$export$1e511d4a378977f5;
var $4cb733d6ee218098$export$61abde59b50deb8e;
var $4cb733d6ee218098$export$d597759d33be802e;
var $4cb733d6ee218098$export$e51d3c675bb0140d;
var $4cb733d6ee218098$export$61171c632678b12e;
var $4cb733d6ee218098$export$be911dffb9e4cf68;
var $4cb733d6ee218098$export$ef88aa0d34c34520;
"use strict";
$4cb733d6ee218098$export$1e511d4a378977f5 = true;
$4cb733d6ee218098$export$61abde59b50deb8e = $4cb733d6ee218098$export$d597759d33be802e = $4cb733d6ee218098$export$e51d3c675bb0140d = $4cb733d6ee218098$export$61171c632678b12e = $4cb733d6ee218098$export$be911dffb9e4cf68 = $4cb733d6ee218098$export$ef88aa0d34c34520 = undefined;

var $hW8Br = parcelRequire("hW8Br");

var $eP7f2 = parcelRequire("eP7f2");

var $9aGoL = parcelRequire("9aGoL");
/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/ // Is the given token a valid domain token?
// Should nums be included here?
function $4cb733d6ee218098$var$isDomainToken(token) {
    return token instanceof $9aGoL.DOMAIN || token instanceof $9aGoL.TLD;
}
/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@abstract
*/ var $4cb733d6ee218098$var$MultiToken = (0, $hW8Br.createTokenClass)();
$4cb733d6ee218098$var$MultiToken.prototype = {
    /**
 	String representing the type for this token
 	@property type
 	@default 'TOKEN'
 */ type: "token",
    /**
 	Is this multitoken a link?
 	@property isLink
 	@default false
 */ isLink: false,
    /**
 	Return the string this token represents.
 	@method toString
 	@return {String}
 */ toString: function toString() {
        var result = [];
        for(var i = 0; i < this.v.length; i++)result.push(this.v[i].toString());
        return result.join("");
    },
    /**
 	What should the value for this token be in the `href` HTML attribute?
 	Returns the `.toString` value by default.
 		@method toHref
 	@return {String}
 */ toHref: function toHref() {
        return this.toString();
    },
    /**
 	Returns a hash of relevant values for this token, which includes keys
 	* type - Kind of token ('url', 'email', etc.)
 	* value - Original text
 	* href - The value that should be added to the anchor tag's href
 		attribute
 		@method toObject
 	@param {String} [protocol] `'http'` by default
 	@return {Object}
 */ toObject: function toObject() {
        var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "http";
        return {
            type: this.type,
            value: this.toString(),
            href: this.toHref(protocol)
        };
    }
};
/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MAILTO
	@extends MultiToken
*/ var $4cb733d6ee218098$var$MAILTOEMAIL = (0, $eP7f2.inherits)($4cb733d6ee218098$var$MultiToken, (0, $hW8Br.createTokenClass)(), {
    type: "email",
    isLink: true
});
/**
	Represents a list of tokens making up a valid email address
	@class EMAIL
	@extends MultiToken
*/ var $4cb733d6ee218098$var$EMAIL = (0, $eP7f2.inherits)($4cb733d6ee218098$var$MultiToken, (0, $hW8Br.createTokenClass)(), {
    type: "email",
    isLink: true,
    toHref: function toHref() {
        return "mailto:" + this.toString();
    }
});
/**
	Represents some plain text
	@class TEXT
	@extends MultiToken
*/ var $4cb733d6ee218098$var$TEXT = (0, $eP7f2.inherits)($4cb733d6ee218098$var$MultiToken, (0, $hW8Br.createTokenClass)(), {
    type: "text"
});
/**
	Multi-linebreak token - represents a line break
	@class NL
	@extends MultiToken
*/ var $4cb733d6ee218098$var$NL = (0, $eP7f2.inherits)($4cb733d6ee218098$var$MultiToken, (0, $hW8Br.createTokenClass)(), {
    type: "nl"
});
/**
	Represents a list of tokens making up a valid URL
	@class URL
	@extends MultiToken
*/ var $4cb733d6ee218098$var$URL = (0, $eP7f2.inherits)($4cb733d6ee218098$var$MultiToken, (0, $hW8Br.createTokenClass)(), {
    type: "url",
    isLink: true,
    /**
 	Lowercases relevant parts of the domain and adds the protocol if
 	required. Note that this will not escape unsafe HTML characters in the
 	URL.
 		@method href
 	@param {String} protocol
 	@return {String}
 */ toHref: function toHref() {
        var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "http";
        var hasProtocol = false;
        var hasSlashSlash = false;
        var tokens = this.v;
        var result = [];
        var i = 0;
        // Make the first part of the domain lowercase
        // Lowercase protocol
        while(tokens[i] instanceof $9aGoL.PROTOCOL){
            hasProtocol = true;
            result.push(tokens[i].toString().toLowerCase());
            i++;
        }
        // Skip slash-slash
        while(tokens[i] instanceof $9aGoL.SLASH){
            hasSlashSlash = true;
            result.push(tokens[i].toString());
            i++;
        }
        // Lowercase all other characters in the domain
        while($4cb733d6ee218098$var$isDomainToken(tokens[i])){
            result.push(tokens[i].toString().toLowerCase());
            i++;
        }
        // Leave all other characters as they were written
        for(; i < tokens.length; i++)result.push(tokens[i].toString());
        result = result.join("");
        if (!(hasProtocol || hasSlashSlash)) result = protocol + "://" + result;
        return result;
    },
    hasProtocol: function hasProtocol() {
        return this.v[0] instanceof $9aGoL.PROTOCOL;
    }
});
$4cb733d6ee218098$export$ef88aa0d34c34520 = $4cb733d6ee218098$var$MultiToken;
$4cb733d6ee218098$export$be911dffb9e4cf68 = $4cb733d6ee218098$var$MAILTOEMAIL;
$4cb733d6ee218098$export$61171c632678b12e = $4cb733d6ee218098$var$EMAIL;
$4cb733d6ee218098$export$e51d3c675bb0140d = $4cb733d6ee218098$var$NL;
$4cb733d6ee218098$export$d597759d33be802e = $4cb733d6ee218098$var$TEXT;
$4cb733d6ee218098$export$61abde59b50deb8e = $4cb733d6ee218098$var$URL;

});




// import another component
var $7519480fe2c950b4$exports = {};
var $45031a284306f4dd$exports = {};
$45031a284306f4dd$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Thank's IE8 for his funny defineProperty
$7519480fe2c950b4$exports = !$45031a284306f4dd$exports(function() {
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var $9253e412c272ab07$export$2d1720544b23b823;

var $fdac2c4ac06c1bec$exports = {};


var $6f7b995b068e4342$exports = {};
var $fcfb858ad971d77a$exports = {};
var $fcfb858ad971d77a$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$fcfb858ad971d77a$exports = // eslint-disable-next-line no-undef
$fcfb858ad971d77a$var$check(typeof globalThis == "object" && globalThis) || $fcfb858ad971d77a$var$check(typeof window == "object" && window) || $fcfb858ad971d77a$var$check(typeof self == "object" && self) || $fcfb858ad971d77a$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func
Function("return this")();


var $60512f8ee2aed236$exports = {};
$60512f8ee2aed236$exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};


var $6f7b995b068e4342$var$document = $fcfb858ad971d77a$exports.document;
// typeof document.createElement is 'object' in old IE
var $6f7b995b068e4342$var$EXISTS = $60512f8ee2aed236$exports($6f7b995b068e4342$var$document) && $60512f8ee2aed236$exports($6f7b995b068e4342$var$document.createElement);
$6f7b995b068e4342$exports = function(it) {
    return $6f7b995b068e4342$var$EXISTS ? $6f7b995b068e4342$var$document.createElement(it) : {};
};


// Thank's IE8 for his funny defineProperty
$fdac2c4ac06c1bec$exports = !$7519480fe2c950b4$exports && !$45031a284306f4dd$exports(function() {
    return Object.defineProperty($6f7b995b068e4342$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


var $911d7ce12ac79470$exports = {};

$911d7ce12ac79470$exports = function(it) {
    if (!$60512f8ee2aed236$exports(it)) throw TypeError(String(it) + " is not an object");
    return it;
};


var $7a7f50313b504d3c$exports = {};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
$7a7f50313b504d3c$exports = function(input, PREFERRED_STRING) {
    if (!$60512f8ee2aed236$exports(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$60512f8ee2aed236$exports(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == "function" && !$60512f8ee2aed236$exports(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$60512f8ee2aed236$exports(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};


var $9253e412c272ab07$var$nativeDefineProperty = Object.defineProperty;
$9253e412c272ab07$export$2d1720544b23b823 = $7519480fe2c950b4$exports ? $9253e412c272ab07$var$nativeDefineProperty : function defineProperty(O, P, Attributes) {
    $911d7ce12ac79470$exports(O);
    P = $7a7f50313b504d3c$exports(P, true);
    $911d7ce12ac79470$exports(Attributes);
    if ($fdac2c4ac06c1bec$exports) try {
        return $9253e412c272ab07$var$nativeDefineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $d65bcf0a3591e3cd$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
$d65bcf0a3591e3cd$exports = function() {
    var that = $911d7ce12ac79470$exports(this);
    var result = "";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.sticky) result += "y";
    return result;
};


var $aa18a776eeca7376$export$b0fd0ca1c5a3f02d;
var $aa18a776eeca7376$export$98ecc64ba9a7065f;
"use strict";

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function $aa18a776eeca7376$var$RE(s, f) {
    return RegExp(s, f);
}
$aa18a776eeca7376$export$b0fd0ca1c5a3f02d = $45031a284306f4dd$exports(function() {
    // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
    var re = $aa18a776eeca7376$var$RE("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
$aa18a776eeca7376$export$98ecc64ba9a7065f = $45031a284306f4dd$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $aa18a776eeca7376$var$RE("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});


var $9d3a88072543856b$require$UNSUPPORTED_Y = $aa18a776eeca7376$export$b0fd0ca1c5a3f02d;
// `RegExp.prototype.flags` getter
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
if ($7519480fe2c950b4$exports && (/./g.flags != "g" || $9d3a88072543856b$require$UNSUPPORTED_Y)) $9253e412c272ab07$export$2d1720544b23b823(RegExp.prototype, "flags", {
    configurable: true,
    get: $d65bcf0a3591e3cd$exports
});


"use strict";

var $90aed03c3558aa78$exports = {};
var $9f297f98d4b1debe$exports = {};

var $6e2c87f08c31568e$exports = {};
var $9336f1bf2df4c284$exports = {};
$9336f1bf2df4c284$exports = false;


var $d424bd5c1166285a$exports = {};

var $c2b1a7bc34b38b84$exports = {};

var $6b29af14a125fbd4$exports = {};


var $5e671484d5b6c9a2$exports = {};
$5e671484d5b6c9a2$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$6b29af14a125fbd4$exports = $7519480fe2c950b4$exports ? function(object, key, value) {
    return $9253e412c272ab07$export$2d1720544b23b823(object, key, $5e671484d5b6c9a2$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


$c2b1a7bc34b38b84$exports = function(key, value) {
    try {
        $6b29af14a125fbd4$exports($fcfb858ad971d77a$exports, key, value);
    } catch (error) {
        $fcfb858ad971d77a$exports[key] = value;
    }
    return value;
};


var $d424bd5c1166285a$var$SHARED = "__core-js_shared__";
var $d424bd5c1166285a$var$store = $fcfb858ad971d77a$exports[$d424bd5c1166285a$var$SHARED] || $c2b1a7bc34b38b84$exports($d424bd5c1166285a$var$SHARED, {});
$d424bd5c1166285a$exports = $d424bd5c1166285a$var$store;


($6e2c87f08c31568e$exports = function(key, value) {
    return $d424bd5c1166285a$exports[key] || ($d424bd5c1166285a$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.6.5",
    mode: $9336f1bf2df4c284$exports ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});


var $156c78d04df80ed8$exports = {};
var $156c78d04df80ed8$var$hasOwnProperty = {}.hasOwnProperty;
$156c78d04df80ed8$exports = function(it, key) {
    return $156c78d04df80ed8$var$hasOwnProperty.call(it, key);
};


var $1ac1324fccb00652$exports = {};
var $1ac1324fccb00652$var$id = 0;
var $1ac1324fccb00652$var$postfix = Math.random();
$1ac1324fccb00652$exports = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$1ac1324fccb00652$var$id + $1ac1324fccb00652$var$postfix).toString(36);
};


var $1a844fd38c2ced1a$exports = {};

$1a844fd38c2ced1a$exports = !!Object.getOwnPropertySymbols && !$45031a284306f4dd$exports(function() {
    // Chrome 38 Symbol has incorrect toString conversion
    // eslint-disable-next-line no-undef
    return !String(Symbol());
});


var $465d57069efe8c85$exports = {};

$465d57069efe8c85$exports = $1a844fd38c2ced1a$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $9f297f98d4b1debe$var$WellKnownSymbolsStore = $6e2c87f08c31568e$exports("wks");
var $9f297f98d4b1debe$var$Symbol = $fcfb858ad971d77a$exports.Symbol;
var $9f297f98d4b1debe$var$createWellKnownSymbol = $465d57069efe8c85$exports ? $9f297f98d4b1debe$var$Symbol : $9f297f98d4b1debe$var$Symbol && $9f297f98d4b1debe$var$Symbol.withoutSetter || $1ac1324fccb00652$exports;
$9f297f98d4b1debe$exports = function(name) {
    if (!$156c78d04df80ed8$exports($9f297f98d4b1debe$var$WellKnownSymbolsStore, name)) {
        if ($1a844fd38c2ced1a$exports && $156c78d04df80ed8$exports($9f297f98d4b1debe$var$Symbol, name)) $9f297f98d4b1debe$var$WellKnownSymbolsStore[name] = $9f297f98d4b1debe$var$Symbol[name];
        else $9f297f98d4b1debe$var$WellKnownSymbolsStore[name] = $9f297f98d4b1debe$var$createWellKnownSymbol("Symbol." + name);
    }
    return $9f297f98d4b1debe$var$WellKnownSymbolsStore[name];
};


var $ec1a37079a933f9c$exports = {};

var $04a058475d34d8d8$exports = {};



var $b79357d1d83dabe8$exports = {};
var $d8c0dcba98027a72$exports = {};

var $8c4aa789eae195bf$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $9eb091c0a13ae894$exports = {};

var $cd3f29cb35223fe2$exports = {};
var $cd3f29cb35223fe2$var$toString = {}.toString;
$cd3f29cb35223fe2$exports = function(it) {
    return $cd3f29cb35223fe2$var$toString.call(it).slice(8, -1);
};


var $9eb091c0a13ae894$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$9eb091c0a13ae894$exports = $45031a284306f4dd$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $cd3f29cb35223fe2$exports(it) == "String" ? $9eb091c0a13ae894$var$split.call(it, "") : Object(it);
} : Object;


var $0dc8ce57e9444267$exports = {};
// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
$0dc8ce57e9444267$exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};


$8c4aa789eae195bf$exports = function(it) {
    return $9eb091c0a13ae894$exports($0dc8ce57e9444267$exports(it));
};


var $52e3dabda5956064$exports = {};

var $7090b0cc475f3af1$exports = {};
var $b7ab9a5bf45c4d37$exports = {};
var $b7ab9a5bf45c4d37$var$ceil = Math.ceil;
var $b7ab9a5bf45c4d37$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
$b7ab9a5bf45c4d37$exports = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $b7ab9a5bf45c4d37$var$floor : $b7ab9a5bf45c4d37$var$ceil)(argument);
};


var $7090b0cc475f3af1$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
$7090b0cc475f3af1$exports = function(argument) {
    return argument > 0 ? $7090b0cc475f3af1$var$min($b7ab9a5bf45c4d37$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


var $5f15923d24b6b73a$exports = {};

var $5f15923d24b6b73a$var$max = Math.max;
var $5f15923d24b6b73a$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$5f15923d24b6b73a$exports = function(index, length) {
    var integer = $b7ab9a5bf45c4d37$exports(index);
    return integer < 0 ? $5f15923d24b6b73a$var$max(integer + length, 0) : $5f15923d24b6b73a$var$min(integer, length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $52e3dabda5956064$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $8c4aa789eae195bf$exports($this);
        var length = $7090b0cc475f3af1$exports(O.length);
        var index = $5f15923d24b6b73a$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$52e3dabda5956064$exports = {
    // `Array.prototype.includes` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    includes: $52e3dabda5956064$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
    indexOf: $52e3dabda5956064$var$createMethod(false)
};


var $d8c0dcba98027a72$require$indexOf = $52e3dabda5956064$exports.indexOf;
var $cc6e63c05c0b92ba$exports = {};
$cc6e63c05c0b92ba$exports = {};


$d8c0dcba98027a72$exports = function(object, names) {
    var O = $8c4aa789eae195bf$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$156c78d04df80ed8$exports($cc6e63c05c0b92ba$exports, key) && $156c78d04df80ed8$exports(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($156c78d04df80ed8$exports(O, key = names[i++])) ~$d8c0dcba98027a72$require$indexOf(result, key) || result.push(key);
    return result;
};


var $79e7855f803f16d0$exports = {};
// IE8- don't enum bug keys
$79e7855f803f16d0$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$b79357d1d83dabe8$exports = Object.keys || function keys(O) {
    return $d8c0dcba98027a72$exports(O, $79e7855f803f16d0$exports);
};


// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
$04a058475d34d8d8$exports = $7519480fe2c950b4$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $911d7ce12ac79470$exports(O);
    var keys = $b79357d1d83dabe8$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$9253e412c272ab07$export$2d1720544b23b823(O, key = keys[index++], Properties[key]);
    return O;
};




var $4b0a648e1c03b4d7$exports = {};
var $3e89eba23641c645$exports = {};
var $83f6c01f1bbefd6c$exports = {};

$83f6c01f1bbefd6c$exports = $fcfb858ad971d77a$exports;



var $3e89eba23641c645$var$aFunction = function(variable) {
    return typeof variable == "function" ? variable : undefined;
};
$3e89eba23641c645$exports = function(namespace, method) {
    return arguments.length < 2 ? $3e89eba23641c645$var$aFunction($83f6c01f1bbefd6c$exports[namespace]) || $3e89eba23641c645$var$aFunction($fcfb858ad971d77a$exports[namespace]) : $83f6c01f1bbefd6c$exports[namespace] && $83f6c01f1bbefd6c$exports[namespace][method] || $fcfb858ad971d77a$exports[namespace] && $fcfb858ad971d77a$exports[namespace][method];
};


$4b0a648e1c03b4d7$exports = $3e89eba23641c645$exports("document", "documentElement");



var $c762cc8d389f9d9e$exports = {};


var $c762cc8d389f9d9e$var$keys = $6e2c87f08c31568e$exports("keys");
$c762cc8d389f9d9e$exports = function(key) {
    return $c762cc8d389f9d9e$var$keys[key] || ($c762cc8d389f9d9e$var$keys[key] = $1ac1324fccb00652$exports(key));
};


var $ec1a37079a933f9c$var$GT = ">";
var $ec1a37079a933f9c$var$LT = "<";
var $ec1a37079a933f9c$var$PROTOTYPE = "prototype";
var $ec1a37079a933f9c$var$SCRIPT = "script";
var $ec1a37079a933f9c$var$IE_PROTO = $c762cc8d389f9d9e$exports("IE_PROTO");
var $ec1a37079a933f9c$var$EmptyConstructor = function() {};
var $ec1a37079a933f9c$var$scriptTag = function(content) {
    return $ec1a37079a933f9c$var$LT + $ec1a37079a933f9c$var$SCRIPT + $ec1a37079a933f9c$var$GT + content + $ec1a37079a933f9c$var$LT + "/" + $ec1a37079a933f9c$var$SCRIPT + $ec1a37079a933f9c$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $ec1a37079a933f9c$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($ec1a37079a933f9c$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $ec1a37079a933f9c$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $6f7b995b068e4342$exports("iframe");
    var JS = "java" + $ec1a37079a933f9c$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $4b0a648e1c03b4d7$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($ec1a37079a933f9c$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $ec1a37079a933f9c$var$activeXDocument;
var $ec1a37079a933f9c$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject */ $ec1a37079a933f9c$var$activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (error) {}
    $ec1a37079a933f9c$var$NullProtoObject = $ec1a37079a933f9c$var$activeXDocument ? $ec1a37079a933f9c$var$NullProtoObjectViaActiveX($ec1a37079a933f9c$var$activeXDocument) : $ec1a37079a933f9c$var$NullProtoObjectViaIFrame();
    var length = $79e7855f803f16d0$exports.length;
    while(length--)delete $ec1a37079a933f9c$var$NullProtoObject[$ec1a37079a933f9c$var$PROTOTYPE][$79e7855f803f16d0$exports[length]];
    return $ec1a37079a933f9c$var$NullProtoObject();
};
$cc6e63c05c0b92ba$exports[$ec1a37079a933f9c$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
$ec1a37079a933f9c$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $ec1a37079a933f9c$var$EmptyConstructor[$ec1a37079a933f9c$var$PROTOTYPE] = $911d7ce12ac79470$exports(O);
        result = new $ec1a37079a933f9c$var$EmptyConstructor();
        $ec1a37079a933f9c$var$EmptyConstructor[$ec1a37079a933f9c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$ec1a37079a933f9c$var$IE_PROTO] = O;
    } else result = $ec1a37079a933f9c$var$NullProtoObject();
    return Properties === undefined ? result : $04a058475d34d8d8$exports(result, Properties);
};



var $90aed03c3558aa78$var$UNSCOPABLES = $9f297f98d4b1debe$exports("unscopables");
var $90aed03c3558aa78$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if ($90aed03c3558aa78$var$ArrayPrototype[$90aed03c3558aa78$var$UNSCOPABLES] == undefined) $9253e412c272ab07$export$2d1720544b23b823($90aed03c3558aa78$var$ArrayPrototype, $90aed03c3558aa78$var$UNSCOPABLES, {
    configurable: true,
    value: $ec1a37079a933f9c$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$90aed03c3558aa78$exports = function(key) {
    $90aed03c3558aa78$var$ArrayPrototype[$90aed03c3558aa78$var$UNSCOPABLES][key] = true;
};


var $7a1da432b99698d3$exports = {};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
$7a1da432b99698d3$exports = function(argument) {
    return Object($0dc8ce57e9444267$exports(argument));
};




var $7dfc659b262d5cc3$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;
// `Array.prototype.lastIndex` getter
// https://github.com/keithamus/proposal-array-last
if ($7519480fe2c950b4$exports && !("lastIndex" in [])) {
    $7dfc659b262d5cc3$require$defineProperty(Array.prototype, "lastIndex", {
        configurable: true,
        get: function lastIndex() {
            var O = $7a1da432b99698d3$exports(this);
            var len = $7090b0cc475f3af1$exports(O.length);
            return len == 0 ? 0 : len - 1;
        }
    });
    $90aed03c3558aa78$exports("lastIndex");
}


"use strict";





var $b3a73256182cd189$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;
// `Array.prototype.lastIndex` accessor
// https://github.com/keithamus/proposal-array-last
if ($7519480fe2c950b4$exports && !("lastItem" in [])) {
    $b3a73256182cd189$require$defineProperty(Array.prototype, "lastItem", {
        configurable: true,
        get: function lastItem() {
            var O = $7a1da432b99698d3$exports(this);
            var len = $7090b0cc475f3af1$exports(O.length);
            return len == 0 ? undefined : O[len - 1];
        },
        set: function lastItem(value) {
            var O = $7a1da432b99698d3$exports(this);
            var len = $7090b0cc475f3af1$exports(O.length);
            return O[len == 0 ? 0 : len - 1] = value;
        }
    });
    $90aed03c3558aa78$exports("lastItem");
}


var $77eaf16128740ba7$exports = {};

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var $283ca16714fe663a$export$2d1720544b23b823;

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var $fda52fb0e990619b$export$2d1720544b23b823;
"use strict";
var $fda52fb0e990619b$var$nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var $fda52fb0e990619b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $fda52fb0e990619b$var$NASHORN_BUG = $fda52fb0e990619b$var$getOwnPropertyDescriptor && !$fda52fb0e990619b$var$nativePropertyIsEnumerable.call({
    1: 2
}, 1);
$fda52fb0e990619b$export$2d1720544b23b823 = $fda52fb0e990619b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $fda52fb0e990619b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $fda52fb0e990619b$var$nativePropertyIsEnumerable;







var $283ca16714fe663a$var$nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$283ca16714fe663a$export$2d1720544b23b823 = $7519480fe2c950b4$exports ? $283ca16714fe663a$var$nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $8c4aa789eae195bf$exports(O);
    P = $7a7f50313b504d3c$exports(P, true);
    if ($fdac2c4ac06c1bec$exports) try {
        return $283ca16714fe663a$var$nativeGetOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($156c78d04df80ed8$exports(O, P)) return $5e671484d5b6c9a2$exports(!$fda52fb0e990619b$export$2d1720544b23b823.call(O, P), O[P]);
};


var $77eaf16128740ba7$require$getOwnPropertyDescriptor = $283ca16714fe663a$export$2d1720544b23b823;

var $84d48e39a958bdf8$exports = {};




var $2309466b814a2f11$exports = {};

var $2309466b814a2f11$var$functionToString = Function.toString;
// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $d424bd5c1166285a$exports.inspectSource != "function") $d424bd5c1166285a$exports.inspectSource = function(it) {
    return $2309466b814a2f11$var$functionToString.call(it);
};
$2309466b814a2f11$exports = $d424bd5c1166285a$exports.inspectSource;


var $45f18df0c62df8c7$exports = {};
var $64b3fa5579d8b319$exports = {};


var $64b3fa5579d8b319$var$WeakMap = $fcfb858ad971d77a$exports.WeakMap;
$64b3fa5579d8b319$exports = typeof $64b3fa5579d8b319$var$WeakMap === "function" && /native code/.test($2309466b814a2f11$exports($64b3fa5579d8b319$var$WeakMap));








var $45f18df0c62df8c7$var$WeakMap = $fcfb858ad971d77a$exports.WeakMap;
var $45f18df0c62df8c7$var$set, $45f18df0c62df8c7$var$get, $45f18df0c62df8c7$var$has;
var $45f18df0c62df8c7$var$enforce = function(it) {
    return $45f18df0c62df8c7$var$has(it) ? $45f18df0c62df8c7$var$get(it) : $45f18df0c62df8c7$var$set(it, {});
};
var $45f18df0c62df8c7$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$60512f8ee2aed236$exports(it) || (state = $45f18df0c62df8c7$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($64b3fa5579d8b319$exports) {
    var $45f18df0c62df8c7$var$store = new $45f18df0c62df8c7$var$WeakMap();
    var $45f18df0c62df8c7$var$wmget = $45f18df0c62df8c7$var$store.get;
    var $45f18df0c62df8c7$var$wmhas = $45f18df0c62df8c7$var$store.has;
    var $45f18df0c62df8c7$var$wmset = $45f18df0c62df8c7$var$store.set;
    $45f18df0c62df8c7$var$set = function(it, metadata) {
        $45f18df0c62df8c7$var$wmset.call($45f18df0c62df8c7$var$store, it, metadata);
        return metadata;
    };
    $45f18df0c62df8c7$var$get = function(it) {
        return $45f18df0c62df8c7$var$wmget.call($45f18df0c62df8c7$var$store, it) || {};
    };
    $45f18df0c62df8c7$var$has = function(it) {
        return $45f18df0c62df8c7$var$wmhas.call($45f18df0c62df8c7$var$store, it);
    };
} else {
    var $45f18df0c62df8c7$var$STATE = $c762cc8d389f9d9e$exports("state");
    $cc6e63c05c0b92ba$exports[$45f18df0c62df8c7$var$STATE] = true;
    $45f18df0c62df8c7$var$set = function(it, metadata) {
        $6b29af14a125fbd4$exports(it, $45f18df0c62df8c7$var$STATE, metadata);
        return metadata;
    };
    $45f18df0c62df8c7$var$get = function(it) {
        return $156c78d04df80ed8$exports(it, $45f18df0c62df8c7$var$STATE) ? it[$45f18df0c62df8c7$var$STATE] : {};
    };
    $45f18df0c62df8c7$var$has = function(it) {
        return $156c78d04df80ed8$exports(it, $45f18df0c62df8c7$var$STATE);
    };
}
$45f18df0c62df8c7$exports = {
    set: $45f18df0c62df8c7$var$set,
    get: $45f18df0c62df8c7$var$get,
    has: $45f18df0c62df8c7$var$has,
    enforce: $45f18df0c62df8c7$var$enforce,
    getterFor: $45f18df0c62df8c7$var$getterFor
};


var $84d48e39a958bdf8$var$getInternalState = $45f18df0c62df8c7$exports.get;
var $84d48e39a958bdf8$var$enforceInternalState = $45f18df0c62df8c7$exports.enforce;
var $84d48e39a958bdf8$var$TEMPLATE = String(String).split("String");
($84d48e39a958bdf8$exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    if (typeof value == "function") {
        if (typeof key == "string" && !$156c78d04df80ed8$exports(value, "name")) $6b29af14a125fbd4$exports(value, "name", key);
        $84d48e39a958bdf8$var$enforceInternalState(value).source = $84d48e39a958bdf8$var$TEMPLATE.join(typeof key == "string" ? key : "");
    }
    if (O === $fcfb858ad971d77a$exports) {
        if (simple) O[key] = value;
        else $c2b1a7bc34b38b84$exports(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $6b29af14a125fbd4$exports(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return typeof this == "function" && $84d48e39a958bdf8$var$getInternalState(this).source || $2309466b814a2f11$exports(this);
});



var $2bb647ff72de8ad7$exports = {};

var $57ae1cbbec0c95ff$exports = {};

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var $b16db7cd105f07be$export$2d1720544b23b823;


var $b16db7cd105f07be$var$hiddenKeys = $79e7855f803f16d0$exports.concat("length", "prototype");
$b16db7cd105f07be$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $d8c0dcba98027a72$exports(O, $b16db7cd105f07be$var$hiddenKeys);
};


var $7a5841c0a48a1d0c$export$2d1720544b23b823;
$7a5841c0a48a1d0c$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



// all object keys, includes non-enumerable and symbols
$57ae1cbbec0c95ff$exports = $3e89eba23641c645$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $b16db7cd105f07be$export$2d1720544b23b823($911d7ce12ac79470$exports(it));
    var getOwnPropertySymbols = $7a5841c0a48a1d0c$export$2d1720544b23b823;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};




$2bb647ff72de8ad7$exports = function(target, source) {
    var keys = $57ae1cbbec0c95ff$exports(source);
    var defineProperty = $9253e412c272ab07$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $283ca16714fe663a$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$156c78d04df80ed8$exports(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $912bfe868aa90a72$exports = {};

var $912bfe868aa90a72$var$replacement = /#|\.prototype\./;
var $912bfe868aa90a72$var$isForced = function(feature, detection) {
    var value = $912bfe868aa90a72$var$data[$912bfe868aa90a72$var$normalize(feature)];
    return value == $912bfe868aa90a72$var$POLYFILL ? true : value == $912bfe868aa90a72$var$NATIVE ? false : typeof detection == "function" ? $45031a284306f4dd$exports(detection) : !!detection;
};
var $912bfe868aa90a72$var$normalize = $912bfe868aa90a72$var$isForced.normalize = function(string) {
    return String(string).replace($912bfe868aa90a72$var$replacement, ".").toLowerCase();
};
var $912bfe868aa90a72$var$data = $912bfe868aa90a72$var$isForced.data = {};
var $912bfe868aa90a72$var$NATIVE = $912bfe868aa90a72$var$isForced.NATIVE = "N";
var $912bfe868aa90a72$var$POLYFILL = $912bfe868aa90a72$var$isForced.POLYFILL = "P";
$912bfe868aa90a72$exports = $912bfe868aa90a72$var$isForced;


/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ $77eaf16128740ba7$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $fcfb858ad971d77a$exports;
    else if (STATIC) target = $fcfb858ad971d77a$exports[TARGET] || $c2b1a7bc34b38b84$exports(TARGET, {});
    else target = ($fcfb858ad971d77a$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $77eaf16128740ba7$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $912bfe868aa90a72$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $2bb647ff72de8ad7$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $6b29af14a125fbd4$exports(sourceProperty, "sham", true);
        // extend global
        $84d48e39a958bdf8$exports(target, key, sourceProperty, options);
    }
};


var $c5499bff6f5f5854$exports = {};
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
var $63125b76bf05750a$exports = {};
"use strict";
var $b2212b09692d106a$exports = {};
"use strict";




var $dd60d9ae94fe36b6$exports = {};




var $dd60d9ae94fe36b6$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;

var $bf6445008619eec9$exports = {};

$bf6445008619eec9$exports = !$45031a284306f4dd$exports(function() {
    return Object.isExtensible(Object.preventExtensions({}));
});


var $dd60d9ae94fe36b6$var$METADATA = $1ac1324fccb00652$exports("meta");
var $dd60d9ae94fe36b6$var$id = 0;
var $dd60d9ae94fe36b6$var$isExtensible = Object.isExtensible || function() {
    return true;
};
var $dd60d9ae94fe36b6$var$setMetadata = function(it) {
    $dd60d9ae94fe36b6$require$defineProperty(it, $dd60d9ae94fe36b6$var$METADATA, {
        value: {
            objectID: "O" + ++$dd60d9ae94fe36b6$var$id,
            weakData: {} // weak collections IDs
        }
    });
};
var $dd60d9ae94fe36b6$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$60512f8ee2aed236$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$156c78d04df80ed8$exports(it, $dd60d9ae94fe36b6$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$dd60d9ae94fe36b6$var$isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $dd60d9ae94fe36b6$var$setMetadata(it);
    // return object ID
    }
    return it[$dd60d9ae94fe36b6$var$METADATA].objectID;
};
var $dd60d9ae94fe36b6$var$getWeakData = function(it, create) {
    if (!$156c78d04df80ed8$exports(it, $dd60d9ae94fe36b6$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$dd60d9ae94fe36b6$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $dd60d9ae94fe36b6$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$dd60d9ae94fe36b6$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $dd60d9ae94fe36b6$var$onFreeze = function(it) {
    if ($bf6445008619eec9$exports && $dd60d9ae94fe36b6$var$meta.REQUIRED && $dd60d9ae94fe36b6$var$isExtensible(it) && !$156c78d04df80ed8$exports(it, $dd60d9ae94fe36b6$var$METADATA)) $dd60d9ae94fe36b6$var$setMetadata(it);
    return it;
};
var $dd60d9ae94fe36b6$var$meta = $dd60d9ae94fe36b6$exports = {
    REQUIRED: false,
    fastKey: $dd60d9ae94fe36b6$var$fastKey,
    getWeakData: $dd60d9ae94fe36b6$var$getWeakData,
    onFreeze: $dd60d9ae94fe36b6$var$onFreeze
};
$cc6e63c05c0b92ba$exports[$dd60d9ae94fe36b6$var$METADATA] = true;


var $a790526642d29a5f$exports = {};

var $1497d93033cacb23$exports = {};

var $c64dc467911b6f42$exports = {};
$c64dc467911b6f42$exports = {};


var $1497d93033cacb23$var$ITERATOR = $9f297f98d4b1debe$exports("iterator");
var $1497d93033cacb23$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$1497d93033cacb23$exports = function(it) {
    return it !== undefined && ($c64dc467911b6f42$exports.Array === it || $1497d93033cacb23$var$ArrayPrototype[$1497d93033cacb23$var$ITERATOR] === it);
};



var $adf776c9a927fad6$exports = {};
var $ffcd68f98263199d$exports = {};
$ffcd68f98263199d$exports = function(it) {
    if (typeof it != "function") throw TypeError(String(it) + " is not a function");
    return it;
};


// optional / simple context binding
$adf776c9a927fad6$exports = function(fn, that, length) {
    $ffcd68f98263199d$exports(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};


var $7d188f1227ca7046$exports = {};
var $766287c8d8f1b3b3$exports = {};
var $0cf7c398743563b3$exports = {};

var $0cf7c398743563b3$var$TO_STRING_TAG = $9f297f98d4b1debe$exports("toStringTag");
var $0cf7c398743563b3$var$test = {};
$0cf7c398743563b3$var$test[$0cf7c398743563b3$var$TO_STRING_TAG] = "z";
$0cf7c398743563b3$exports = String($0cf7c398743563b3$var$test) === "[object z]";




var $766287c8d8f1b3b3$var$TO_STRING_TAG = $9f297f98d4b1debe$exports("toStringTag");
// ES3 wrong here
var $766287c8d8f1b3b3$var$CORRECT_ARGUMENTS = $cd3f29cb35223fe2$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $766287c8d8f1b3b3$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$766287c8d8f1b3b3$exports = $0cf7c398743563b3$exports ? $cd3f29cb35223fe2$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $766287c8d8f1b3b3$var$tryGet(O = Object(it), $766287c8d8f1b3b3$var$TO_STRING_TAG)) == "string" ? tag : $766287c8d8f1b3b3$var$CORRECT_ARGUMENTS ? $cd3f29cb35223fe2$exports(O) : (result = $cd3f29cb35223fe2$exports(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : result;
};




var $7d188f1227ca7046$var$ITERATOR = $9f297f98d4b1debe$exports("iterator");
$7d188f1227ca7046$exports = function(it) {
    if (it != undefined) return it[$7d188f1227ca7046$var$ITERATOR] || it["@@iterator"] || $c64dc467911b6f42$exports[$766287c8d8f1b3b3$exports(it)];
};


var $75034fe352b3f5bb$exports = {};

// call something on iterator step with safe closing on error
$75034fe352b3f5bb$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($911d7ce12ac79470$exports(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (error) {
        var returnMethod = iterator["return"];
        if (returnMethod !== undefined) $911d7ce12ac79470$exports(returnMethod.call(iterator));
        throw error;
    }
};


var $a790526642d29a5f$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a790526642d29a5f$var$iterate = $a790526642d29a5f$exports = function(iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
    var boundFunction = $adf776c9a927fad6$exports(fn, that, AS_ENTRIES ? 2 : 1);
    var iterator, iterFn, index, length, result, next, step;
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $7d188f1227ca7046$exports(iterable);
        if (typeof iterFn != "function") throw TypeError("Target is not iterable");
        // optimisation for array iterators
        if ($1497d93033cacb23$exports(iterFn)) {
            for(index = 0, length = $7090b0cc475f3af1$exports(iterable.length); length > index; index++){
                result = AS_ENTRIES ? boundFunction($911d7ce12ac79470$exports(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
                if (result && result instanceof $a790526642d29a5f$var$Result) return result;
            }
            return new $a790526642d29a5f$var$Result(false);
        }
        iterator = iterFn.call(iterable);
    }
    next = iterator.next;
    while(!(step = next.call(iterator)).done){
        result = $75034fe352b3f5bb$exports(iterator, boundFunction, step.value, AS_ENTRIES);
        if (typeof result == "object" && result && result instanceof $a790526642d29a5f$var$Result) return result;
    }
    return new $a790526642d29a5f$var$Result(false);
};
$a790526642d29a5f$var$iterate.stop = function(result) {
    return new $a790526642d29a5f$var$Result(true, result);
};


var $98f6648ab34f1cea$exports = {};
$98f6648ab34f1cea$exports = function(it, Constructor, name) {
    if (!(it instanceof Constructor)) throw TypeError("Incorrect " + (name ? name + " " : "") + "invocation");
    return it;
};




var $a3a305483465f75e$exports = {};

var $a3a305483465f75e$var$ITERATOR = $9f297f98d4b1debe$exports("iterator");
var $a3a305483465f75e$var$SAFE_CLOSING = false;
try {
    var $a3a305483465f75e$var$called = 0;
    var $a3a305483465f75e$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$a3a305483465f75e$var$called++
            };
        },
        "return": function() {
            $a3a305483465f75e$var$SAFE_CLOSING = true;
        }
    };
    $a3a305483465f75e$var$iteratorWithReturn[$a3a305483465f75e$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($a3a305483465f75e$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$a3a305483465f75e$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$a3a305483465f75e$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$a3a305483465f75e$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $a12aff13c6f88e8b$exports = {};

var $a12aff13c6f88e8b$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;


var $a12aff13c6f88e8b$var$TO_STRING_TAG = $9f297f98d4b1debe$exports("toStringTag");
$a12aff13c6f88e8b$exports = function(it, TAG, STATIC) {
    if (it && !$156c78d04df80ed8$exports(it = STATIC ? it : it.prototype, $a12aff13c6f88e8b$var$TO_STRING_TAG)) $a12aff13c6f88e8b$require$defineProperty(it, $a12aff13c6f88e8b$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $b48b62c53d4c8a72$exports = {};

var $60c23070f9ac840b$exports = {};

var $c3278d95cd57ba2a$exports = {};

$c3278d95cd57ba2a$exports = function(it) {
    if (!$60512f8ee2aed236$exports(it) && it !== null) throw TypeError("Can't set " + String(it) + " as a prototype");
    return it;
};


// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ $60c23070f9ac840b$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $911d7ce12ac79470$exports(O);
        $c3278d95cd57ba2a$exports(proto);
        if (CORRECT_SETTER) setter.call(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


// makes subclassing work correct for wrapped built-ins
$b48b62c53d4c8a72$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $60c23070f9ac840b$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == "function" && NewTarget !== Wrapper && $60512f8ee2aed236$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $60c23070f9ac840b$exports($this, NewTargetPrototype);
    return $this;
};


$b2212b09692d106a$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $fcfb858ad971d77a$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var nativeMethod = NativePrototype[KEY];
        $84d48e39a958bdf8$exports(NativePrototype, KEY, KEY == "add" ? function add(value) {
            nativeMethod.call(this, value === 0 ? 0 : value);
            return this;
        } : KEY == "delete" ? function(key) {
            return IS_WEAK && !$60512f8ee2aed236$exports(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
        } : KEY == "get" ? function get(key) {
            return IS_WEAK && !$60512f8ee2aed236$exports(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
        } : KEY == "has" ? function has(key) {
            return IS_WEAK && !$60512f8ee2aed236$exports(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            nativeMethod.call(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    // eslint-disable-next-line max-len
    if ($912bfe868aa90a72$exports(CONSTRUCTOR_NAME, typeof NativeConstructor != "function" || !(IS_WEAK || NativePrototype.forEach && !$45031a284306f4dd$exports(function() {
        new NativeConstructor().entries().next();
    })))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $dd60d9ae94fe36b6$exports.REQUIRED = true;
    } else if ($912bfe868aa90a72$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $45031a284306f4dd$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new
        var ACCEPT_ITERABLES = $a3a305483465f75e$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $45031a284306f4dd$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $98f6648ab34f1cea$exports(dummy, Constructor, CONSTRUCTOR_NAME);
                var that = $b48b62c53d4c8a72$exports(new NativeConstructor(), dummy, Constructor);
                if (iterable != undefined) $a790526642d29a5f$exports(iterable, that[ADDER], that, IS_MAP);
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $77eaf16128740ba7$exports({
        global: true,
        forced: Constructor != NativeConstructor
    }, exported);
    $a12aff13c6f88e8b$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $c7a1a4b72d81ea5c$exports = {};
"use strict";

var $c7a1a4b72d81ea5c$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;

var $62104e73f6cf7e71$exports = {};

$62104e73f6cf7e71$exports = function(target, src, options) {
    for(var key in src)$84d48e39a958bdf8$exports(target, key, src[key], options);
    return target;
};





var $f14b0b6a506a6a31$exports = {};
"use strict";

var $dbfd0c8aa0edc2d8$exports = {};
"use strict";
var $bd26dbc9e1d979e0$exports = {};
"use strict";
var $65e85bdd577fe5e0$exports = {};



var $0ac58f16c577c506$exports = {};

$0ac58f16c577c506$exports = !$45031a284306f4dd$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $65e85bdd577fe5e0$var$IE_PROTO = $c762cc8d389f9d9e$exports("IE_PROTO");
var $65e85bdd577fe5e0$var$ObjectPrototype = Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
$65e85bdd577fe5e0$exports = $0ac58f16c577c506$exports ? Object.getPrototypeOf : function(O) {
    O = $7a1da432b99698d3$exports(O);
    if ($156c78d04df80ed8$exports(O, $65e85bdd577fe5e0$var$IE_PROTO)) return O[$65e85bdd577fe5e0$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $65e85bdd577fe5e0$var$ObjectPrototype : null;
};






var $bd26dbc9e1d979e0$var$ITERATOR = $9f297f98d4b1debe$exports("iterator");
var $bd26dbc9e1d979e0$var$BUGGY_SAFARI_ITERATORS = false;
var $bd26dbc9e1d979e0$var$returnThis = function() {
    return this;
};
// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var $bd26dbc9e1d979e0$var$IteratorPrototype, $bd26dbc9e1d979e0$var$PrototypeOfArrayIteratorPrototype, $bd26dbc9e1d979e0$var$arrayIterator;
if ([].keys) {
    $bd26dbc9e1d979e0$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $bd26dbc9e1d979e0$var$arrayIterator)) $bd26dbc9e1d979e0$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $bd26dbc9e1d979e0$var$PrototypeOfArrayIteratorPrototype = $65e85bdd577fe5e0$exports($65e85bdd577fe5e0$exports($bd26dbc9e1d979e0$var$arrayIterator));
        if ($bd26dbc9e1d979e0$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $bd26dbc9e1d979e0$var$IteratorPrototype = $bd26dbc9e1d979e0$var$PrototypeOfArrayIteratorPrototype;
    }
}
if ($bd26dbc9e1d979e0$var$IteratorPrototype == undefined) $bd26dbc9e1d979e0$var$IteratorPrototype = {};
// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!$9336f1bf2df4c284$exports && !$156c78d04df80ed8$exports($bd26dbc9e1d979e0$var$IteratorPrototype, $bd26dbc9e1d979e0$var$ITERATOR)) $6b29af14a125fbd4$exports($bd26dbc9e1d979e0$var$IteratorPrototype, $bd26dbc9e1d979e0$var$ITERATOR, $bd26dbc9e1d979e0$var$returnThis);
$bd26dbc9e1d979e0$exports = {
    IteratorPrototype: $bd26dbc9e1d979e0$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $bd26dbc9e1d979e0$var$BUGGY_SAFARI_ITERATORS
};


var $dbfd0c8aa0edc2d8$require$IteratorPrototype = $bd26dbc9e1d979e0$exports.IteratorPrototype;




var $dbfd0c8aa0edc2d8$var$returnThis = function() {
    return this;
};
$dbfd0c8aa0edc2d8$exports = function(IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $ec1a37079a933f9c$exports($dbfd0c8aa0edc2d8$require$IteratorPrototype, {
        next: $5e671484d5b6c9a2$exports(1, next)
    });
    $a12aff13c6f88e8b$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $c64dc467911b6f42$exports[TO_STRING_TAG] = $dbfd0c8aa0edc2d8$var$returnThis;
    return IteratorConstructor;
};











var $f14b0b6a506a6a31$var$IteratorPrototype = $bd26dbc9e1d979e0$exports.IteratorPrototype;
var $f14b0b6a506a6a31$var$BUGGY_SAFARI_ITERATORS = $bd26dbc9e1d979e0$exports.BUGGY_SAFARI_ITERATORS;
var $f14b0b6a506a6a31$var$ITERATOR = $9f297f98d4b1debe$exports("iterator");
var $f14b0b6a506a6a31$var$KEYS = "keys";
var $f14b0b6a506a6a31$var$VALUES = "values";
var $f14b0b6a506a6a31$var$ENTRIES = "entries";
var $f14b0b6a506a6a31$var$returnThis = function() {
    return this;
};
$f14b0b6a506a6a31$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $dbfd0c8aa0edc2d8$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$f14b0b6a506a6a31$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $f14b0b6a506a6a31$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f14b0b6a506a6a31$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f14b0b6a506a6a31$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$f14b0b6a506a6a31$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$f14b0b6a506a6a31$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $65e85bdd577fe5e0$exports(anyNativeIterator.call(new Iterable()));
        if ($f14b0b6a506a6a31$var$IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$9336f1bf2df4c284$exports && $65e85bdd577fe5e0$exports(CurrentIteratorPrototype) !== $f14b0b6a506a6a31$var$IteratorPrototype) {
                if ($60c23070f9ac840b$exports) $60c23070f9ac840b$exports(CurrentIteratorPrototype, $f14b0b6a506a6a31$var$IteratorPrototype);
                else if (typeof CurrentIteratorPrototype[$f14b0b6a506a6a31$var$ITERATOR] != "function") $6b29af14a125fbd4$exports(CurrentIteratorPrototype, $f14b0b6a506a6a31$var$ITERATOR, $f14b0b6a506a6a31$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $a12aff13c6f88e8b$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($9336f1bf2df4c284$exports) $c64dc467911b6f42$exports[TO_STRING_TAG] = $f14b0b6a506a6a31$var$returnThis;
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEFAULT == $f14b0b6a506a6a31$var$VALUES && nativeIterator && nativeIterator.name !== $f14b0b6a506a6a31$var$VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
            return nativeIterator.call(this);
        };
    }
    // define iterator
    if ((!$9336f1bf2df4c284$exports || FORCED) && IterablePrototype[$f14b0b6a506a6a31$var$ITERATOR] !== defaultIterator) $6b29af14a125fbd4$exports(IterablePrototype, $f14b0b6a506a6a31$var$ITERATOR, defaultIterator);
    $c64dc467911b6f42$exports[NAME] = defaultIterator;
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($f14b0b6a506a6a31$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($f14b0b6a506a6a31$var$KEYS),
            entries: getIterationMethod($f14b0b6a506a6a31$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($f14b0b6a506a6a31$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $84d48e39a958bdf8$exports(IterablePrototype, KEY, methods[KEY]);
        } else $77eaf16128740ba7$exports({
            target: NAME,
            proto: true,
            forced: $f14b0b6a506a6a31$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    return methods;
};


var $bc0de146ae9484bd$exports = {};
"use strict";




var $bc0de146ae9484bd$var$SPECIES = $9f297f98d4b1debe$exports("species");
$bc0de146ae9484bd$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $3e89eba23641c645$exports(CONSTRUCTOR_NAME);
    var defineProperty = $9253e412c272ab07$export$2d1720544b23b823;
    if ($7519480fe2c950b4$exports && Constructor && !Constructor[$bc0de146ae9484bd$var$SPECIES]) defineProperty(Constructor, $bc0de146ae9484bd$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};




var $c7a1a4b72d81ea5c$require$fastKey = $dd60d9ae94fe36b6$exports.fastKey;

var $c7a1a4b72d81ea5c$var$setInternalState = $45f18df0c62df8c7$exports.set;
var $c7a1a4b72d81ea5c$var$internalStateGetterFor = $45f18df0c62df8c7$exports.getterFor;
$c7a1a4b72d81ea5c$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $98f6648ab34f1cea$exports(that, C, CONSTRUCTOR_NAME);
            $c7a1a4b72d81ea5c$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $ec1a37079a933f9c$exports(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$7519480fe2c950b4$exports) that.size = 0;
            if (iterable != undefined) $a790526642d29a5f$exports(iterable, that[ADDER], that, IS_MAP);
        });
        var getInternalState = $c7a1a4b72d81ea5c$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $c7a1a4b72d81ea5c$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($7519480fe2c950b4$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $c7a1a4b72d81ea5c$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        $62104e73f6cf7e71$exports(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($7519480fe2c950b4$exports) state.size = 0;
                else that.size = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if ($7519480fe2c950b4$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $62104e73f6cf7e71$exports(C.prototype, IS_MAP ? {
            // 23.1.3.6 Map.prototype.get(key)
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // 23.1.3.9 Map.prototype.set(key, value)
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // 23.2.3.1 Set.prototype.add(value)
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($7519480fe2c950b4$exports) $c7a1a4b72d81ea5c$require$defineProperty(C.prototype, "size", {
            get: function() {
                return getInternalState(this).size;
            }
        });
        return C;
    },
    setStrong: function(C, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $c7a1a4b72d81ea5c$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $c7a1a4b72d81ea5c$var$internalStateGetterFor(ITERATOR_NAME);
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $f14b0b6a506a6a31$exports(C, CONSTRUCTOR_NAME, function(iterated, kind) {
            $c7a1a4b72d81ea5c$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return {
                    value: undefined,
                    done: true
                };
            }
            // return step by kind
            if (kind == "keys") return {
                value: entry.key,
                done: false
            };
            if (kind == "values") return {
                value: entry.value,
                done: false
            };
            return {
                value: [
                    entry.key,
                    entry.value
                ],
                done: false
            };
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $bc0de146ae9484bd$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
$63125b76bf05750a$exports = $b2212b09692d106a$exports("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $c7a1a4b72d81ea5c$exports);


var $fcd5dc50b783a6d5$exports = {};
"use strict";




var $8b56e5e00479893f$exports = {};
"use strict";


var $8b56e5e00479893f$require$getWeakData = $dd60d9ae94fe36b6$exports.getWeakData;




var $e95cb330c4e36f01$exports = {};




var $8aa345f71afe6437$exports = {};

var $c50eb3baae37feb6$exports = {};

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
$c50eb3baae37feb6$exports = Array.isArray || function isArray(arg) {
    return $cd3f29cb35223fe2$exports(arg) == "Array";
};



var $8aa345f71afe6437$var$SPECIES = $9f297f98d4b1debe$exports("species");
// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
$8aa345f71afe6437$exports = function(originalArray, length) {
    var C;
    if ($c50eb3baae37feb6$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == "function" && (C === Array || $c50eb3baae37feb6$exports(C.prototype))) C = undefined;
        else if ($60512f8ee2aed236$exports(C)) {
            C = C[$8aa345f71afe6437$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


var $e95cb330c4e36f01$var$push = [].push;
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var $e95cb330c4e36f01$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $7a1da432b99698d3$exports($this);
        var self = $9eb091c0a13ae894$exports(O);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, that, 3);
        var length = $7090b0cc475f3af1$exports(self.length);
        var index = 0;
        var create = specificCreate || $8aa345f71afe6437$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $e95cb330c4e36f01$var$push.call(target, value); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$e95cb330c4e36f01$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    forEach: $e95cb330c4e36f01$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.map
    map: $e95cb330c4e36f01$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.filter
    filter: $e95cb330c4e36f01$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.some
    some: $e95cb330c4e36f01$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.every
    every: $e95cb330c4e36f01$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    find: $e95cb330c4e36f01$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
    findIndex: $e95cb330c4e36f01$var$createMethod(6)
};




var $8b56e5e00479893f$var$setInternalState = $45f18df0c62df8c7$exports.set;
var $8b56e5e00479893f$var$internalStateGetterFor = $45f18df0c62df8c7$exports.getterFor;
var $8b56e5e00479893f$var$find = $e95cb330c4e36f01$exports.find;
var $8b56e5e00479893f$var$findIndex = $e95cb330c4e36f01$exports.findIndex;
var $8b56e5e00479893f$var$id = 0;
// fallback for uncaught frozen keys
var $8b56e5e00479893f$var$uncaughtFrozenStore = function(store) {
    return store.frozen || (store.frozen = new $8b56e5e00479893f$var$UncaughtFrozenStore());
};
var $8b56e5e00479893f$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $8b56e5e00479893f$var$findUncaughtFrozen = function(store, key) {
    return $8b56e5e00479893f$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$8b56e5e00479893f$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $8b56e5e00479893f$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$8b56e5e00479893f$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $8b56e5e00479893f$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $8b56e5e00479893f$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) this.entries.splice(index, 1);
        return !!~index;
    }
};
$8b56e5e00479893f$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $98f6648ab34f1cea$exports(that, C, CONSTRUCTOR_NAME);
            $8b56e5e00479893f$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $8b56e5e00479893f$var$id++,
                frozen: undefined
            });
            if (iterable != undefined) $a790526642d29a5f$exports(iterable, that[ADDER], that, IS_MAP);
        });
        var getInternalState = $8b56e5e00479893f$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $8b56e5e00479893f$require$getWeakData($911d7ce12ac79470$exports(key), true);
            if (data === true) $8b56e5e00479893f$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $62104e73f6cf7e71$exports(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$60512f8ee2aed236$exports(key)) return false;
                var data = $8b56e5e00479893f$require$getWeakData(key);
                if (data === true) return $8b56e5e00479893f$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $156c78d04df80ed8$exports(data, state.id) && delete data[state.id];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                var state = getInternalState(this);
                if (!$60512f8ee2aed236$exports(key)) return false;
                var data = $8b56e5e00479893f$require$getWeakData(key);
                if (data === true) return $8b56e5e00479893f$var$uncaughtFrozenStore(state).has(key);
                return data && $156c78d04df80ed8$exports(data, state.id);
            }
        });
        $62104e73f6cf7e71$exports(C.prototype, IS_MAP ? {
            // 23.3.3.3 WeakMap.prototype.get(key)
            get: function get(key) {
                var state = getInternalState(this);
                if ($60512f8ee2aed236$exports(key)) {
                    var data = $8b56e5e00479893f$require$getWeakData(key);
                    if (data === true) return $8b56e5e00479893f$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // 23.3.3.5 WeakMap.prototype.set(key, value)
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // 23.4.3.1 WeakSet.prototype.add(value)
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return C;
    }
};




var $fcd5dc50b783a6d5$require$enforceIternalState = $45f18df0c62df8c7$exports.enforce;

var $fcd5dc50b783a6d5$var$IS_IE11 = !$fcfb858ad971d77a$exports.ActiveXObject && "ActiveXObject" in $fcfb858ad971d77a$exports;
var $fcd5dc50b783a6d5$var$isExtensible = Object.isExtensible;
var $fcd5dc50b783a6d5$var$InternalWeakMap;
var $fcd5dc50b783a6d5$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.github.io/ecma262/#sec-weakmap-constructor
var $fcd5dc50b783a6d5$var$$WeakMap = $fcd5dc50b783a6d5$exports = $b2212b09692d106a$exports("WeakMap", $fcd5dc50b783a6d5$var$wrapper, $8b56e5e00479893f$exports);
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($64b3fa5579d8b319$exports && $fcd5dc50b783a6d5$var$IS_IE11) {
    $fcd5dc50b783a6d5$var$InternalWeakMap = $8b56e5e00479893f$exports.getConstructor($fcd5dc50b783a6d5$var$wrapper, "WeakMap", true);
    $dd60d9ae94fe36b6$exports.REQUIRED = true;
    var $fcd5dc50b783a6d5$var$WeakMapPrototype = $fcd5dc50b783a6d5$var$$WeakMap.prototype;
    var $fcd5dc50b783a6d5$var$nativeDelete = $fcd5dc50b783a6d5$var$WeakMapPrototype["delete"];
    var $fcd5dc50b783a6d5$var$nativeHas = $fcd5dc50b783a6d5$var$WeakMapPrototype.has;
    var $fcd5dc50b783a6d5$var$nativeGet = $fcd5dc50b783a6d5$var$WeakMapPrototype.get;
    var $fcd5dc50b783a6d5$var$nativeSet = $fcd5dc50b783a6d5$var$WeakMapPrototype.set;
    $62104e73f6cf7e71$exports($fcd5dc50b783a6d5$var$WeakMapPrototype, {
        "delete": function(key) {
            if ($60512f8ee2aed236$exports(key) && !$fcd5dc50b783a6d5$var$isExtensible(key)) {
                var state = $fcd5dc50b783a6d5$require$enforceIternalState(this);
                if (!state.frozen) state.frozen = new $fcd5dc50b783a6d5$var$InternalWeakMap();
                return $fcd5dc50b783a6d5$var$nativeDelete.call(this, key) || state.frozen["delete"](key);
            }
            return $fcd5dc50b783a6d5$var$nativeDelete.call(this, key);
        },
        has: function has(key) {
            if ($60512f8ee2aed236$exports(key) && !$fcd5dc50b783a6d5$var$isExtensible(key)) {
                var state = $fcd5dc50b783a6d5$require$enforceIternalState(this);
                if (!state.frozen) state.frozen = new $fcd5dc50b783a6d5$var$InternalWeakMap();
                return $fcd5dc50b783a6d5$var$nativeHas.call(this, key) || state.frozen.has(key);
            }
            return $fcd5dc50b783a6d5$var$nativeHas.call(this, key);
        },
        get: function get(key) {
            if ($60512f8ee2aed236$exports(key) && !$fcd5dc50b783a6d5$var$isExtensible(key)) {
                var state = $fcd5dc50b783a6d5$require$enforceIternalState(this);
                if (!state.frozen) state.frozen = new $fcd5dc50b783a6d5$var$InternalWeakMap();
                return $fcd5dc50b783a6d5$var$nativeHas.call(this, key) ? $fcd5dc50b783a6d5$var$nativeGet.call(this, key) : state.frozen.get(key);
            }
            return $fcd5dc50b783a6d5$var$nativeGet.call(this, key);
        },
        set: function set(key, value) {
            if ($60512f8ee2aed236$exports(key) && !$fcd5dc50b783a6d5$var$isExtensible(key)) {
                var state = $fcd5dc50b783a6d5$require$enforceIternalState(this);
                if (!state.frozen) state.frozen = new $fcd5dc50b783a6d5$var$InternalWeakMap();
                $fcd5dc50b783a6d5$var$nativeHas.call(this, key) ? $fcd5dc50b783a6d5$var$nativeSet.call(this, key, value) : state.frozen.set(key, value);
            } else $fcd5dc50b783a6d5$var$nativeSet.call(this, key, value);
            return this;
        }
    });
}




var $c5499bff6f5f5854$var$Node = function() {
    // keys
    this.object = null;
    this.symbol = null;
    // child nodes
    this.primitives = null;
    this.objectsByIndex = $ec1a37079a933f9c$exports(null);
};
$c5499bff6f5f5854$var$Node.prototype.get = function(key, initializer) {
    return this[key] || (this[key] = initializer());
};
$c5499bff6f5f5854$var$Node.prototype.next = function(i, it, IS_OBJECT) {
    var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new $fcd5dc50b783a6d5$exports()) : this.primitives || (this.primitives = new $63125b76bf05750a$exports());
    var entry = store.get(it);
    if (!entry) store.set(it, entry = new $c5499bff6f5f5854$var$Node());
    return entry;
};
var $c5499bff6f5f5854$var$root = new $c5499bff6f5f5854$var$Node();
$c5499bff6f5f5854$exports = function() {
    var active = $c5499bff6f5f5854$var$root;
    var length = arguments.length;
    var i, it;
    // for prevent leaking, start from objects
    for(i = 0; i < length; i++)if ($60512f8ee2aed236$exports(it = arguments[i])) active = active.next(i, it, true);
    if (this === Object && active === $c5499bff6f5f5854$var$root) throw TypeError("Composite keys must contain a non-primitive component");
    for(i = 0; i < length; i++)if (!$60512f8ee2aed236$exports(it = arguments[i])) active = active.next(i, it, false);
    return active;
};




var $e940b4030116bc87$var$initializer = function() {
    var freeze = $3e89eba23641c645$exports("Object", "freeze");
    return freeze ? freeze($ec1a37079a933f9c$exports(null)) : $ec1a37079a933f9c$exports(null);
};
// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$77eaf16128740ba7$exports({
    global: true
}, {
    compositeKey: function compositeKey() {
        return $c5499bff6f5f5854$exports.apply(Object, arguments).get("object", $e940b4030116bc87$var$initializer);
    }
});





// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$77eaf16128740ba7$exports({
    global: true
}, {
    compositeSymbol: function compositeSymbol() {
        if (arguments.length === 1 && typeof arguments[0] === "string") return $3e89eba23641c645$exports("Symbol")["for"](arguments[0]);
        return $c5499bff6f5f5854$exports.apply(null, arguments).get("symbol", $3e89eba23641c645$exports("Symbol"));
    }
});


"use strict";


var $9ca897976f282dc7$exports = {};
"use strict";


// https://github.com/tc39/collection-methods
$9ca897976f282dc7$exports = function() {
    var collection = $911d7ce12ac79470$exports(this);
    var remover = $ffcd68f98263199d$exports(collection["delete"]);
    var allDeleted = true;
    var wasDeleted;
    for(var k = 0, len = arguments.length; k < len; k++){
        wasDeleted = remover.call(collection, arguments[k]);
        allDeleted = allDeleted && wasDeleted;
    }
    return !!allDeleted;
};


// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    deleteAll: function deleteAll() {
        return $9ca897976f282dc7$exports.apply(this, arguments);
    }
});


"use strict";




var $b6db296b52f5f1a0$exports = {};

var $f831d03794f9a9e4$exports = {};


$f831d03794f9a9e4$exports = function(it) {
    var iteratorMethod = $7d188f1227ca7046$exports(it);
    if (typeof iteratorMethod != "function") throw TypeError(String(it) + " is not iterable");
    return $911d7ce12ac79470$exports(iteratorMethod.call(it));
};


$b6db296b52f5f1a0$exports = $9336f1bf2df4c284$exports ? $f831d03794f9a9e4$exports : function(it) {
    // eslint-disable-next-line no-undef
    return Map.prototype.entries.call(it);
};



// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return !$a790526642d29a5f$exports(iterator, function(key, value) {
            if (!boundFunction(value, key, map)) return $a790526642d29a5f$exports.stop();
        }, undefined, true, true).stopped;
    }
});


"use strict";






var $234fbab875753c46$exports = {};



var $234fbab875753c46$var$SPECIES = $9f297f98d4b1debe$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
$234fbab875753c46$exports = function(O, defaultConstructor) {
    var C = $911d7ce12ac79470$exports(O).constructor;
    var S;
    return C === undefined || (S = $911d7ce12ac79470$exports(C)[$234fbab875753c46$var$SPECIES]) == undefined ? defaultConstructor : $ffcd68f98263199d$exports(S);
};




// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var newMap = new ($234fbab875753c46$exports(map, $3e89eba23641c645$exports("Map")))();
        var setter = $ffcd68f98263199d$exports(newMap.set);
        $a790526642d29a5f$exports(iterator, function(key, value) {
            if (boundFunction(value, key, map)) setter.call(newMap, key, value);
        }, undefined, true, true);
        return newMap;
    }
});


"use strict";






// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return $a790526642d29a5f$exports(iterator, function(key, value) {
            if (boundFunction(value, key, map)) return $a790526642d29a5f$exports.stop(value);
        }, undefined, true, true).result;
    }
});


"use strict";






// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return $a790526642d29a5f$exports(iterator, function(key, value) {
            if (boundFunction(value, key, map)) return $a790526642d29a5f$exports.stop(key);
        }, undefined, true, true).result;
    }
});



var $1e4bd79a952f7b50$exports = {};
"use strict";



$1e4bd79a952f7b50$exports = function from(source /* , mapFn, thisArg */ ) {
    var length = arguments.length;
    var mapFn = length > 1 ? arguments[1] : undefined;
    var mapping, A, n, boundFunction;
    $ffcd68f98263199d$exports(this);
    mapping = mapFn !== undefined;
    if (mapping) $ffcd68f98263199d$exports(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
        n = 0;
        boundFunction = $adf776c9a927fad6$exports(mapFn, length > 2 ? arguments[2] : undefined, 2);
        $a790526642d29a5f$exports(source, function(nextItem) {
            A.push(boundFunction(nextItem, n++));
        });
    } else $a790526642d29a5f$exports(source, A.push, A);
    return new this(A);
};


// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$77eaf16128740ba7$exports({
    target: "Map",
    stat: true
}, {
    from: $1e4bd79a952f7b50$exports
});


"use strict";



// `Map.groupBy` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    stat: true
}, {
    groupBy: function groupBy(iterable, keyDerivative) {
        var newMap = new this();
        $ffcd68f98263199d$exports(keyDerivative);
        var has = $ffcd68f98263199d$exports(newMap.has);
        var get = $ffcd68f98263199d$exports(newMap.get);
        var set = $ffcd68f98263199d$exports(newMap.set);
        $a790526642d29a5f$exports(iterable, function(element) {
            var derivedKey = keyDerivative(element);
            if (!has.call(newMap, derivedKey)) set.call(newMap, derivedKey, [
                element
            ]);
            else get.call(newMap, derivedKey).push(element);
        });
        return newMap;
    }
});


"use strict";




var $58a643fc3bba2362$exports = {};
// `SameValueZero` abstract operation
// https://tc39.github.io/ecma262/#sec-samevaluezero
$58a643fc3bba2362$exports = function(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y || x != x && y != y;
};



// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    includes: function includes(searchElement) {
        return $a790526642d29a5f$exports($b6db296b52f5f1a0$exports($911d7ce12ac79470$exports(this)), function(key, value) {
            if ($58a643fc3bba2362$exports(value, searchElement)) return $a790526642d29a5f$exports.stop();
        }, undefined, true, true).stopped;
    }
});


"use strict";



// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    stat: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var newMap = new this();
        $ffcd68f98263199d$exports(keyDerivative);
        var setter = $ffcd68f98263199d$exports(newMap.set);
        $a790526642d29a5f$exports(iterable, function(element) {
            setter.call(newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});


"use strict";





// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    keyOf: function keyOf(searchElement) {
        return $a790526642d29a5f$exports($b6db296b52f5f1a0$exports($911d7ce12ac79470$exports(this)), function(key, value) {
            if (value === searchElement) return $a790526642d29a5f$exports.stop(key);
        }, undefined, true, true).result;
    }
});


"use strict";









// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var newMap = new ($234fbab875753c46$exports(map, $3e89eba23641c645$exports("Map")))();
        var setter = $ffcd68f98263199d$exports(newMap.set);
        $a790526642d29a5f$exports(iterator, function(key, value) {
            setter.call(newMap, boundFunction(value, key, map), value);
        }, undefined, true, true);
        return newMap;
    }
});


"use strict";









// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var newMap = new ($234fbab875753c46$exports(map, $3e89eba23641c645$exports("Map")))();
        var setter = $ffcd68f98263199d$exports(newMap.set);
        $a790526642d29a5f$exports(iterator, function(key, value) {
            setter.call(newMap, key, boundFunction(value, key, map));
        }, undefined, true, true);
        return newMap;
    }
});


"use strict";





// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    // eslint-disable-next-line no-unused-vars
    merge: function merge(iterable /* ...iterbles */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var setter = $ffcd68f98263199d$exports(map.set);
        var i = 0;
        while(i < arguments.length)$a790526642d29a5f$exports(arguments[i++], setter, map, true);
        return map;
    }
});



var $9939047b25b929ac$exports = {};
"use strict";
// https://tc39.github.io/proposal-setmap-offrom/
$9939047b25b929ac$exports = function of() {
    var length = arguments.length;
    var A = new Array(length);
    while(length--)A[length] = arguments[length];
    return new this(A);
};


// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$77eaf16128740ba7$exports({
    target: "Map",
    stat: true
}, {
    of: $9939047b25b929ac$exports
});


"use strict";






// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ffcd68f98263199d$exports(callbackfn);
        $a790526642d29a5f$exports(iterator, function(key, value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        }, undefined, true, true);
        if (noInitial) throw TypeError("Reduce of empty map with no initial value");
        return accumulator;
    }
});


"use strict";






// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var iterator = $b6db296b52f5f1a0$exports(map);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return $a790526642d29a5f$exports(iterator, function(key, value) {
            if (boundFunction(value, key, map)) return $a790526642d29a5f$exports.stop();
        }, undefined, true, true).stopped;
    }
});


"use strict";




// `Set.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Map",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $911d7ce12ac79470$exports(this);
        var length = arguments.length;
        $ffcd68f98263199d$exports(callback);
        var isPresentInMap = map.has(key);
        if (!isPresentInMap && length < 3) throw TypeError("Updating absent value");
        var value = isPresentInMap ? map.get(key) : $ffcd68f98263199d$exports(length > 2 ? arguments[2] : undefined)(key, map);
        map.set(key, callback(value, key, map));
        return map;
    }
});



var $3e5fd2ed2d4737d7$var$min = Math.min;
var $3e5fd2ed2d4737d7$var$max = Math.max;
// `Math.clamp` method
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    clamp: function clamp(x, lower, upper) {
        return $3e5fd2ed2d4737d7$var$min(upper, $3e5fd2ed2d4737d7$var$max(lower, x));
    }
});



// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    DEG_PER_RAD: Math.PI / 180
});



var $bd358f916460508f$var$RAD_PER_DEG = 180 / Math.PI;
// `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    degrees: function degrees(radians) {
        return radians * $bd358f916460508f$var$RAD_PER_DEG;
    }
});



var $47194b9bce5515d3$exports = {};
// `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/
$47194b9bce5515d3$exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
    if (arguments.length === 0 || x != x || inLow != inLow || inHigh != inHigh || outLow != outLow || outHigh != outHigh) return NaN;
    if (x === Infinity || x === -Infinity) return x;
    return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


var $11e89c67c913168e$exports = {};
var $9c5bc0d8201b49a6$exports = {};
// `Math.sign` method implementation
// https://tc39.github.io/ecma262/#sec-math.sign
$9c5bc0d8201b49a6$exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


var $11e89c67c913168e$var$abs = Math.abs;
var $11e89c67c913168e$var$pow = Math.pow;
var $11e89c67c913168e$var$EPSILON = $11e89c67c913168e$var$pow(2, -52);
var $11e89c67c913168e$var$EPSILON32 = $11e89c67c913168e$var$pow(2, -23);
var $11e89c67c913168e$var$MAX32 = $11e89c67c913168e$var$pow(2, 127) * (2 - $11e89c67c913168e$var$EPSILON32);
var $11e89c67c913168e$var$MIN32 = $11e89c67c913168e$var$pow(2, -126);
var $11e89c67c913168e$var$roundTiesToEven = function(n) {
    return n + 1 / $11e89c67c913168e$var$EPSILON - 1 / $11e89c67c913168e$var$EPSILON;
};
// `Math.fround` method implementation
// https://tc39.github.io/ecma262/#sec-math.fround
$11e89c67c913168e$exports = Math.fround || function fround(x) {
    var $abs = $11e89c67c913168e$var$abs(x);
    var $sign = $9c5bc0d8201b49a6$exports(x);
    var a, result;
    if ($abs < $11e89c67c913168e$var$MIN32) return $sign * $11e89c67c913168e$var$roundTiesToEven($abs / $11e89c67c913168e$var$MIN32 / $11e89c67c913168e$var$EPSILON32) * $11e89c67c913168e$var$MIN32 * $11e89c67c913168e$var$EPSILON32;
    a = (1 + $11e89c67c913168e$var$EPSILON32 / $11e89c67c913168e$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $11e89c67c913168e$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};


// `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $11e89c67c913168e$exports($47194b9bce5515d3$exports(x, inLow, inHigh, outLow, outHigh));
    }
});



// `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});



// `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    imulh: function imulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});



// `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});



// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    RAD_PER_DEG: 180 / Math.PI
});



var $f7e1fc43196d83a4$var$DEG_PER_RAD = Math.PI / 180;
// `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    radians: function radians(degrees) {
        return degrees * $f7e1fc43196d83a4$var$DEG_PER_RAD;
    }
});




// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    scale: $47194b9bce5515d3$exports
});




var $4743d49a8c6ef4b9$exports = {};

var $4743d49a8c6ef4b9$var$globalIsFinite = $fcfb858ad971d77a$exports.isFinite;
// `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite
$4743d49a8c6ef4b9$exports = Number.isFinite || function isFinite(it) {
    return typeof it == "number" && $4743d49a8c6ef4b9$var$globalIsFinite(it);
};




var $a4f71546cf4447fa$var$SEEDED_RANDOM = "Seeded Random";
var $a4f71546cf4447fa$var$SEEDED_RANDOM_GENERATOR = $a4f71546cf4447fa$var$SEEDED_RANDOM + " Generator";
var $a4f71546cf4447fa$var$setInternalState = $45f18df0c62df8c7$exports.set;
var $a4f71546cf4447fa$var$getInternalState = $45f18df0c62df8c7$exports.getterFor($a4f71546cf4447fa$var$SEEDED_RANDOM_GENERATOR);
var $a4f71546cf4447fa$var$SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var $a4f71546cf4447fa$var$$SeededRandomGenerator = $dbfd0c8aa0edc2d8$exports(function SeededRandomGenerator(seed) {
    $a4f71546cf4447fa$var$setInternalState(this, {
        type: $a4f71546cf4447fa$var$SEEDED_RANDOM_GENERATOR,
        seed: seed % 2147483647
    });
}, $a4f71546cf4447fa$var$SEEDED_RANDOM, function next() {
    var state = $a4f71546cf4447fa$var$getInternalState(this);
    var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
    return {
        value: (seed & 1073741823) / 1073741823,
        done: false
    };
});
// `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true,
    forced: true
}, {
    seededPRNG: function seededPRNG(it) {
        var seed = $911d7ce12ac79470$exports(it).seed;
        if (!$4743d49a8c6ef4b9$exports(seed)) throw TypeError($a4f71546cf4447fa$var$SEED_TYPE_ERROR);
        return new $a4f71546cf4447fa$var$$SeededRandomGenerator(seed);
    }
});



// `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    signbit: function signbit(x) {
        return (x = +x) == x && x == 0 ? 1 / x == -Infinity : x < 0;
    }
});



// `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$77eaf16128740ba7$exports({
    target: "Math",
    stat: true
}, {
    umulh: function umulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


"use strict";


var $3add10bef5f4d4f6$exports = {};

var $f102de67d293df78$exports = {};

var $9f5e536c6b9dc985$exports = {};
// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
$9f5e536c6b9dc985$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $f102de67d293df78$var$whitespace = "[" + $9f5e536c6b9dc985$exports + "]";
var $f102de67d293df78$var$ltrim = RegExp("^" + $f102de67d293df78$var$whitespace + $f102de67d293df78$var$whitespace + "*");
var $f102de67d293df78$var$rtrim = RegExp($f102de67d293df78$var$whitespace + $f102de67d293df78$var$whitespace + "*$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $f102de67d293df78$var$createMethod = function(TYPE) {
    return function($this) {
        var string = String($0dc8ce57e9444267$exports($this));
        if (TYPE & 1) string = string.replace($f102de67d293df78$var$ltrim, "");
        if (TYPE & 2) string = string.replace($f102de67d293df78$var$rtrim, "");
        return string;
    };
};
$f102de67d293df78$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
    start: $f102de67d293df78$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
    end: $f102de67d293df78$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.trim
    trim: $f102de67d293df78$var$createMethod(3)
};


var $3add10bef5f4d4f6$require$trim = $f102de67d293df78$exports.trim;

var $3add10bef5f4d4f6$var$$parseInt = $fcfb858ad971d77a$exports.parseInt;
var $3add10bef5f4d4f6$var$hex = /^[+-]?0[Xx]/;
var $3add10bef5f4d4f6$var$FORCED = $3add10bef5f4d4f6$var$$parseInt($9f5e536c6b9dc985$exports + "08") !== 8 || $3add10bef5f4d4f6$var$$parseInt($9f5e536c6b9dc985$exports + "0x16") !== 22;
// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
$3add10bef5f4d4f6$exports = $3add10bef5f4d4f6$var$FORCED ? function parseInt(string, radix) {
    var S = $3add10bef5f4d4f6$require$trim(String(string));
    return $3add10bef5f4d4f6$var$$parseInt(S, radix >>> 0 || ($3add10bef5f4d4f6$var$hex.test(S) ? 16 : 10));
} : $3add10bef5f4d4f6$var$$parseInt;


var $fc5ea378f7408022$var$INVALID_NUMBER_REPRESENTATION = "Invalid number representation";
var $fc5ea378f7408022$var$INVALID_RADIX = "Invalid radix";
var $fc5ea378f7408022$var$valid = /^[\da-z]+$/;
// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$77eaf16128740ba7$exports({
    target: "Number",
    stat: true
}, {
    fromString: function fromString(string, radix) {
        var sign = 1;
        var R, mathNum;
        if (typeof string != "string") throw TypeError($fc5ea378f7408022$var$INVALID_NUMBER_REPRESENTATION);
        if (!string.length) throw SyntaxError($fc5ea378f7408022$var$INVALID_NUMBER_REPRESENTATION);
        if (string.charAt(0) == "-") {
            sign = -1;
            string = string.slice(1);
            if (!string.length) throw SyntaxError($fc5ea378f7408022$var$INVALID_NUMBER_REPRESENTATION);
        }
        R = radix === undefined ? 10 : $b7ab9a5bf45c4d37$exports(radix);
        if (R < 2 || R > 36) throw RangeError($fc5ea378f7408022$var$INVALID_RADIX);
        if (!$fc5ea378f7408022$var$valid.test(string) || (mathNum = $3add10bef5f4d4f6$exports(string, R)).toString(R) !== string) throw SyntaxError($fc5ea378f7408022$var$INVALID_NUMBER_REPRESENTATION);
        return sign * mathNum;
    }
});


"use strict";








var $fa5678d5fdbd08a4$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;




var $98edf707c0344591$exports = {};

$98edf707c0344591$exports = function(a, b) {
    var console = $fcfb858ad971d77a$exports.console;
    if (console && console.error) arguments.length === 1 ? console.error(a) : console.error(a, b);
};




var $fa5678d5fdbd08a4$var$OBSERVABLE = $9f297f98d4b1debe$exports("observable");
var $fa5678d5fdbd08a4$var$getInternalState = $45f18df0c62df8c7$exports.get;
var $fa5678d5fdbd08a4$var$setInternalState = $45f18df0c62df8c7$exports.set;
var $fa5678d5fdbd08a4$var$getMethod = function(fn) {
    return fn == null ? undefined : $ffcd68f98263199d$exports(fn);
};
var $fa5678d5fdbd08a4$var$cleanupSubscription = function(subscriptionState) {
    var cleanup = subscriptionState.cleanup;
    if (cleanup) {
        subscriptionState.cleanup = undefined;
        try {
            cleanup();
        } catch (error) {
            $98edf707c0344591$exports(error);
        }
    }
};
var $fa5678d5fdbd08a4$var$subscriptionClosed = function(subscriptionState) {
    return subscriptionState.observer === undefined;
};
var $fa5678d5fdbd08a4$var$close = function(subscription, subscriptionState) {
    if (!$7519480fe2c950b4$exports) {
        subscription.closed = true;
        var subscriptionObserver = subscriptionState.subscriptionObserver;
        if (subscriptionObserver) subscriptionObserver.closed = true;
    }
    subscriptionState.observer = undefined;
};
var $fa5678d5fdbd08a4$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $fa5678d5fdbd08a4$var$setInternalState(this, {
        cleanup: undefined,
        observer: $911d7ce12ac79470$exports(observer),
        subscriptionObserver: undefined
    });
    var start;
    if (!$7519480fe2c950b4$exports) this.closed = false;
    try {
        if (start = $fa5678d5fdbd08a4$var$getMethod(observer.start)) start.call(observer, this);
    } catch (error) {
        $98edf707c0344591$exports(error);
    }
    if ($fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $fa5678d5fdbd08a4$var$SubscriptionObserver(this);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (cleanup != null) subscriptionState.cleanup = typeof cleanup.unsubscribe === "function" ? function() {
            subscription.unsubscribe();
        } : $ffcd68f98263199d$exports(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if ($fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) $fa5678d5fdbd08a4$var$cleanupSubscription(subscriptionState);
};
$fa5678d5fdbd08a4$var$Subscription.prototype = $62104e73f6cf7e71$exports({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $fa5678d5fdbd08a4$var$getInternalState(this);
        if (!$fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) {
            $fa5678d5fdbd08a4$var$close(this, subscriptionState);
            $fa5678d5fdbd08a4$var$cleanupSubscription(subscriptionState);
        }
    }
});
if ($7519480fe2c950b4$exports) $fa5678d5fdbd08a4$require$defineProperty($fa5678d5fdbd08a4$var$Subscription.prototype, "closed", {
    configurable: true,
    get: function() {
        return $fa5678d5fdbd08a4$var$subscriptionClosed($fa5678d5fdbd08a4$var$getInternalState(this));
    }
});
var $fa5678d5fdbd08a4$var$SubscriptionObserver = function(subscription) {
    $fa5678d5fdbd08a4$var$setInternalState(this, {
        subscription: subscription
    });
    if (!$7519480fe2c950b4$exports) this.closed = false;
};
$fa5678d5fdbd08a4$var$SubscriptionObserver.prototype = $62104e73f6cf7e71$exports({}, {
    next: function next(value) {
        var subscriptionState = $fa5678d5fdbd08a4$var$getInternalState($fa5678d5fdbd08a4$var$getInternalState(this).subscription);
        if (!$fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $fa5678d5fdbd08a4$var$getMethod(observer.next);
                if (nextMethod) nextMethod.call(observer, value);
            } catch (error) {
                $98edf707c0344591$exports(error);
            }
        }
    },
    error: function error(value) {
        var subscription = $fa5678d5fdbd08a4$var$getInternalState(this).subscription;
        var subscriptionState = $fa5678d5fdbd08a4$var$getInternalState(subscription);
        if (!$fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) {
            var observer = subscriptionState.observer;
            $fa5678d5fdbd08a4$var$close(subscription, subscriptionState);
            try {
                var errorMethod = $fa5678d5fdbd08a4$var$getMethod(observer.error);
                if (errorMethod) errorMethod.call(observer, value);
                else $98edf707c0344591$exports(value);
            } catch (err) {
                $98edf707c0344591$exports(err);
            }
            $fa5678d5fdbd08a4$var$cleanupSubscription(subscriptionState);
        }
    },
    complete: function complete() {
        var subscription = $fa5678d5fdbd08a4$var$getInternalState(this).subscription;
        var subscriptionState = $fa5678d5fdbd08a4$var$getInternalState(subscription);
        if (!$fa5678d5fdbd08a4$var$subscriptionClosed(subscriptionState)) {
            var observer = subscriptionState.observer;
            $fa5678d5fdbd08a4$var$close(subscription, subscriptionState);
            try {
                var completeMethod = $fa5678d5fdbd08a4$var$getMethod(observer.complete);
                if (completeMethod) completeMethod.call(observer);
            } catch (error) {
                $98edf707c0344591$exports(error);
            }
            $fa5678d5fdbd08a4$var$cleanupSubscription(subscriptionState);
        }
    }
});
if ($7519480fe2c950b4$exports) $fa5678d5fdbd08a4$require$defineProperty($fa5678d5fdbd08a4$var$SubscriptionObserver.prototype, "closed", {
    configurable: true,
    get: function() {
        return $fa5678d5fdbd08a4$var$subscriptionClosed($fa5678d5fdbd08a4$var$getInternalState($fa5678d5fdbd08a4$var$getInternalState(this).subscription));
    }
});
var $fa5678d5fdbd08a4$var$$Observable = function Observable(subscriber) {
    $98f6648ab34f1cea$exports(this, $fa5678d5fdbd08a4$var$$Observable, "Observable");
    $fa5678d5fdbd08a4$var$setInternalState(this, {
        subscriber: $ffcd68f98263199d$exports(subscriber)
    });
};
$62104e73f6cf7e71$exports($fa5678d5fdbd08a4$var$$Observable.prototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $fa5678d5fdbd08a4$var$Subscription(typeof observer === "function" ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $60512f8ee2aed236$exports(observer) ? observer : {}, $fa5678d5fdbd08a4$var$getInternalState(this).subscriber);
    }
});
$62104e73f6cf7e71$exports($fa5678d5fdbd08a4$var$$Observable, {
    from: function from(x) {
        var C = typeof this === "function" ? this : $fa5678d5fdbd08a4$var$$Observable;
        var observableMethod = $fa5678d5fdbd08a4$var$getMethod($911d7ce12ac79470$exports(x)[$fa5678d5fdbd08a4$var$OBSERVABLE]);
        if (observableMethod) {
            var observable = $911d7ce12ac79470$exports(observableMethod.call(x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iterator = $f831d03794f9a9e4$exports(x);
        return new C(function(observer) {
            $a790526642d29a5f$exports(iterator, function(it) {
                observer.next(it);
                if (observer.closed) return $a790526642d29a5f$exports.stop();
            }, undefined, false, true);
            observer.complete();
        });
    },
    of: function of() {
        var C = typeof this === "function" ? this : $fa5678d5fdbd08a4$var$$Observable;
        var length = arguments.length;
        var items = new Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});
$6b29af14a125fbd4$exports($fa5678d5fdbd08a4$var$$Observable.prototype, $fa5678d5fdbd08a4$var$OBSERVABLE, function() {
    return this;
});
$77eaf16128740ba7$exports({
    global: true
}, {
    Observable: $fa5678d5fdbd08a4$var$$Observable
});
$bc0de146ae9484bd$exports("Observable");


"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var $d492cef002e9478b$export$2d1720544b23b823;
"use strict";

var $d492cef002e9478b$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ffcd68f98263199d$exports(resolve);
    this.reject = $ffcd68f98263199d$exports(reject);
};
$d492cef002e9478b$export$2d1720544b23b823 = function(C) {
    return new $d492cef002e9478b$var$PromiseCapability(C);
};


var $c810866cf184e816$exports = {};
$c810866cf184e816$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


// `Promise.try` method
// https://github.com/tc39/proposal-promise-try
$77eaf16128740ba7$exports({
    target: "Promise",
    stat: true
}, {
    "try": function(callbackfn) {
        var promiseCapability = $d492cef002e9478b$export$2d1720544b23b823(this);
        var result = $c810866cf184e816$exports(callbackfn);
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});



var $40fb39a7060d495a$exports = {};
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`



var $40fb39a7060d495a$var$metadata = $6e2c87f08c31568e$exports("metadata");
var $40fb39a7060d495a$var$store = $40fb39a7060d495a$var$metadata.store || ($40fb39a7060d495a$var$metadata.store = new $fcd5dc50b783a6d5$exports());
var $40fb39a7060d495a$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $40fb39a7060d495a$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return;
        $40fb39a7060d495a$var$store.set(target, targetMetadata = new $63125b76bf05750a$exports());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return;
        targetMetadata.set(targetKey, keyMetadata = new $63125b76bf05750a$exports());
    }
    return keyMetadata;
};
var $40fb39a7060d495a$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $40fb39a7060d495a$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $40fb39a7060d495a$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $40fb39a7060d495a$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $40fb39a7060d495a$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $40fb39a7060d495a$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $40fb39a7060d495a$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $40fb39a7060d495a$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        keys.push(key);
    });
    return keys;
};
var $40fb39a7060d495a$var$toMetadataKey = function(it) {
    return it === undefined || typeof it == "symbol" ? it : String(it);
};
$40fb39a7060d495a$exports = {
    store: $40fb39a7060d495a$var$store,
    getMap: $40fb39a7060d495a$var$getOrCreateMetadataMap,
    has: $40fb39a7060d495a$var$ordinaryHasOwnMetadata,
    get: $40fb39a7060d495a$var$ordinaryGetOwnMetadata,
    set: $40fb39a7060d495a$var$ordinaryDefineOwnMetadata,
    keys: $40fb39a7060d495a$var$ordinaryOwnMetadataKeys,
    toKey: $40fb39a7060d495a$var$toMetadataKey
};



var $562a0dd78d0c554a$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $562a0dd78d0c554a$var$ordinaryDefineOwnMetadata = $40fb39a7060d495a$exports.set;
// `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */ ) {
        var targetKey = arguments.length < 4 ? undefined : $562a0dd78d0c554a$var$toMetadataKey(arguments[3]);
        $562a0dd78d0c554a$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $911d7ce12ac79470$exports(target), targetKey);
    }
});





var $5e856ea92ecfc146$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $5e856ea92ecfc146$var$getOrCreateMetadataMap = $40fb39a7060d495a$exports.getMap;
var $5e856ea92ecfc146$var$store = $40fb39a7060d495a$exports.store;
// `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $5e856ea92ecfc146$var$toMetadataKey(arguments[2]);
        var metadataMap = $5e856ea92ecfc146$var$getOrCreateMetadataMap($911d7ce12ac79470$exports(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap["delete"](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $5e856ea92ecfc146$var$store.get(target);
        targetMetadata["delete"](targetKey);
        return !!targetMetadata.size || $5e856ea92ecfc146$var$store["delete"](target);
    }
});






var $1aefe4d73c9177da$var$ordinaryHasOwnMetadata = $40fb39a7060d495a$exports.has;
var $1aefe4d73c9177da$var$ordinaryGetOwnMetadata = $40fb39a7060d495a$exports.get;
var $1aefe4d73c9177da$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $1aefe4d73c9177da$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $1aefe4d73c9177da$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $1aefe4d73c9177da$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $65e85bdd577fe5e0$exports(O);
    return parent !== null ? $1aefe4d73c9177da$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
// `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $1aefe4d73c9177da$var$toMetadataKey(arguments[2]);
        return $1aefe4d73c9177da$var$ordinaryGetMetadata(metadataKey, $911d7ce12ac79470$exports(target), targetKey);
    }
});



var $6cbd1106ed23e42c$exports = {};
"use strict";


// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
$6cbd1106ed23e42c$exports = $b2212b09692d106a$exports("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $c7a1a4b72d81ea5c$exports);






var $7de29c557744daa0$var$ordinaryOwnMetadataKeys = $40fb39a7060d495a$exports.keys;
var $7de29c557744daa0$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $7de29c557744daa0$var$from = function(iter) {
    var result = [];
    $a790526642d29a5f$exports(iter, result.push, result);
    return result;
};
var $7de29c557744daa0$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $7de29c557744daa0$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $65e85bdd577fe5e0$exports(O);
    if (parent === null) return oKeys;
    var pKeys = $7de29c557744daa0$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $7de29c557744daa0$var$from(new $6cbd1106ed23e42c$exports(oKeys.concat(pKeys))) : pKeys : oKeys;
};
// `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $7de29c557744daa0$var$toMetadataKey(arguments[1]);
        return $7de29c557744daa0$var$ordinaryMetadataKeys($911d7ce12ac79470$exports(target), targetKey);
    }
});





var $ae2606bf680acd61$var$ordinaryGetOwnMetadata = $40fb39a7060d495a$exports.get;
var $ae2606bf680acd61$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
// `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $ae2606bf680acd61$var$toMetadataKey(arguments[2]);
        return $ae2606bf680acd61$var$ordinaryGetOwnMetadata(metadataKey, $911d7ce12ac79470$exports(target), targetKey);
    }
});





var $f9733de1c8ee08a9$var$ordinaryOwnMetadataKeys = $40fb39a7060d495a$exports.keys;
var $f9733de1c8ee08a9$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
// `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $f9733de1c8ee08a9$var$toMetadataKey(arguments[1]);
        return $f9733de1c8ee08a9$var$ordinaryOwnMetadataKeys($911d7ce12ac79470$exports(target), targetKey);
    }
});






var $6e9c2b35f5cec2a7$var$ordinaryHasOwnMetadata = $40fb39a7060d495a$exports.has;
var $6e9c2b35f5cec2a7$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $6e9c2b35f5cec2a7$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $6e9c2b35f5cec2a7$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $65e85bdd577fe5e0$exports(O);
    return parent !== null ? $6e9c2b35f5cec2a7$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
// `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $6e9c2b35f5cec2a7$var$toMetadataKey(arguments[2]);
        return $6e9c2b35f5cec2a7$var$ordinaryHasMetadata(metadataKey, $911d7ce12ac79470$exports(target), targetKey);
    }
});





var $1d1cfa17323c8c87$var$ordinaryHasOwnMetadata = $40fb39a7060d495a$exports.has;
var $1d1cfa17323c8c87$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
// `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $1d1cfa17323c8c87$var$toMetadataKey(arguments[2]);
        return $1d1cfa17323c8c87$var$ordinaryHasOwnMetadata(metadataKey, $911d7ce12ac79470$exports(target), targetKey);
    }
});





var $26744ea7e70afce4$var$toMetadataKey = $40fb39a7060d495a$exports.toKey;
var $26744ea7e70afce4$var$ordinaryDefineOwnMetadata = $40fb39a7060d495a$exports.set;
// `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata
$77eaf16128740ba7$exports({
    target: "Reflect",
    stat: true
}, {
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, key) {
            $26744ea7e70afce4$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $911d7ce12ac79470$exports(target), $26744ea7e70afce4$var$toMetadataKey(key));
        };
    }
});


"use strict";


var $ab656960db09986f$exports = {};
"use strict";


// https://github.com/tc39/collection-methods
$ab656960db09986f$exports = function() {
    var set = $911d7ce12ac79470$exports(this);
    var adder = $ffcd68f98263199d$exports(set.add);
    for(var k = 0, len = arguments.length; k < len; k++)adder.call(set, arguments[k]);
    return set;
};


// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    addAll: function addAll() {
        return $ab656960db09986f$exports.apply(this, arguments);
    }
});


"use strict";



// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    deleteAll: function deleteAll() {
        return $9ca897976f282dc7$exports.apply(this, arguments);
    }
});


"use strict";







// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    difference: function difference(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))(set);
        var remover = $ffcd68f98263199d$exports(newSet["delete"]);
        $a790526642d29a5f$exports(iterable, function(value) {
            remover.call(newSet, value);
        });
        return newSet;
    }
});


"use strict";




var $554f4509b21dc728$exports = {};


$554f4509b21dc728$exports = $9336f1bf2df4c284$exports ? $f831d03794f9a9e4$exports : function(it) {
    // eslint-disable-next-line no-undef
    return Set.prototype.values.call(it);
};



// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return !$a790526642d29a5f$exports(iterator, function(value) {
            if (!boundFunction(value, value, set)) return $a790526642d29a5f$exports.stop();
        }, undefined, false, true).stopped;
    }
});


"use strict";









// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))();
        var adder = $ffcd68f98263199d$exports(newSet.add);
        $a790526642d29a5f$exports(iterator, function(value) {
            if (boundFunction(value, value, set)) adder.call(newSet, value);
        }, undefined, false, true);
        return newSet;
    }
});


"use strict";






// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return $a790526642d29a5f$exports(iterator, function(value) {
            if (boundFunction(value, value, set)) return $a790526642d29a5f$exports.stop(value);
        }, undefined, false, true).result;
    }
});




// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
$77eaf16128740ba7$exports({
    target: "Set",
    stat: true
}, {
    from: $1e4bd79a952f7b50$exports
});


"use strict";







// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    intersection: function intersection(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))();
        var hasCheck = $ffcd68f98263199d$exports(set.has);
        var adder = $ffcd68f98263199d$exports(newSet.add);
        $a790526642d29a5f$exports(iterable, function(value) {
            if (hasCheck.call(set, value)) adder.call(newSet, value);
        });
        return newSet;
    }
});


"use strict";





// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    isDisjointFrom: function isDisjointFrom(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var hasCheck = $ffcd68f98263199d$exports(set.has);
        return !$a790526642d29a5f$exports(iterable, function(value) {
            if (hasCheck.call(set, value) === true) return $a790526642d29a5f$exports.stop();
        }).stopped;
    }
});


"use strict";







// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    isSubsetOf: function isSubsetOf(iterable) {
        var iterator = $f831d03794f9a9e4$exports(this);
        var otherSet = $911d7ce12ac79470$exports(iterable);
        var hasCheck = otherSet.has;
        if (typeof hasCheck != "function") {
            otherSet = new ($3e89eba23641c645$exports("Set"))(iterable);
            hasCheck = $ffcd68f98263199d$exports(otherSet.has);
        }
        return !$a790526642d29a5f$exports(iterator, function(value) {
            if (hasCheck.call(otherSet, value) === false) return $a790526642d29a5f$exports.stop();
        }, undefined, false, true).stopped;
    }
});


"use strict";





// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    isSupersetOf: function isSupersetOf(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var hasCheck = $ffcd68f98263199d$exports(set.has);
        return !$a790526642d29a5f$exports(iterable, function(value) {
            if (hasCheck.call(set, value) === false) return $a790526642d29a5f$exports.stop();
        }).stopped;
    }
});


"use strict";





// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    join: function join(separator) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var sep = separator === undefined ? "," : String(separator);
        var result = [];
        $a790526642d29a5f$exports(iterator, result.push, result, false, true);
        return result.join(sep);
    }
});


"use strict";









// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))();
        var adder = $ffcd68f98263199d$exports(newSet.add);
        $a790526642d29a5f$exports(iterator, function(value) {
            adder.call(newSet, boundFunction(value, value, set));
        }, undefined, false, true);
        return newSet;
    }
});




// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
$77eaf16128740ba7$exports({
    target: "Set",
    stat: true
}, {
    of: $9939047b25b929ac$exports
});


"use strict";






// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ffcd68f98263199d$exports(callbackfn);
        $a790526642d29a5f$exports(iterator, function(value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, value, set);
        }, undefined, false, true);
        if (noInitial) throw TypeError("Reduce of empty set with no initial value");
        return accumulator;
    }
});


"use strict";






// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var set = $911d7ce12ac79470$exports(this);
        var iterator = $554f4509b21dc728$exports(set);
        var boundFunction = $adf776c9a927fad6$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        return $a790526642d29a5f$exports(iterator, function(value) {
            if (boundFunction(value, value, set)) return $a790526642d29a5f$exports.stop();
        }, undefined, false, true).stopped;
    }
});


"use strict";







// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    symmetricDifference: function symmetricDifference(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))(set);
        var remover = $ffcd68f98263199d$exports(newSet["delete"]);
        var adder = $ffcd68f98263199d$exports(newSet.add);
        $a790526642d29a5f$exports(iterable, function(value) {
            remover.call(newSet, value) || adder.call(newSet, value);
        });
        return newSet;
    }
});


"use strict";







// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$77eaf16128740ba7$exports({
    target: "Set",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    union: function union(iterable) {
        var set = $911d7ce12ac79470$exports(this);
        var newSet = new ($234fbab875753c46$exports(set, $3e89eba23641c645$exports("Set")))(set);
        $a790526642d29a5f$exports(iterable, $ffcd68f98263199d$exports(newSet.add), newSet);
        return newSet;
    }
});


"use strict";

var $c322b63bdccd2288$exports = {};


// `String.prototype.{ codePointAt, at }` methods implementation
var $c322b63bdccd2288$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = String($0dc8ce57e9444267$exports($this));
        var position = $b7ab9a5bf45c4d37$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$c322b63bdccd2288$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
    codeAt: $c322b63bdccd2288$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $c322b63bdccd2288$var$createMethod(true)
};


var $3cdebe178979270d$require$charAt = $c322b63bdccd2288$exports.charAt;
// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$77eaf16128740ba7$exports({
    target: "String",
    proto: true
}, {
    at: function at(pos) {
        return $3cdebe178979270d$require$charAt(this, pos);
    }
});


"use strict";





var $fd97980f5eb542a9$var$codeAt = $c322b63bdccd2288$exports.codeAt;
var $fd97980f5eb542a9$var$charAt = $c322b63bdccd2288$exports.charAt;
var $fd97980f5eb542a9$var$STRING_ITERATOR = "String Iterator";
var $fd97980f5eb542a9$var$setInternalState = $45f18df0c62df8c7$exports.set;
var $fd97980f5eb542a9$var$getInternalState = $45f18df0c62df8c7$exports.getterFor($fd97980f5eb542a9$var$STRING_ITERATOR);
// TODO: unify with String#@@iterator
var $fd97980f5eb542a9$var$$StringIterator = $dbfd0c8aa0edc2d8$exports(function StringIterator(string) {
    $fd97980f5eb542a9$var$setInternalState(this, {
        type: $fd97980f5eb542a9$var$STRING_ITERATOR,
        string: string,
        index: 0
    });
}, "String", function next() {
    var state = $fd97980f5eb542a9$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $fd97980f5eb542a9$var$charAt(string, index);
    state.index += point.length;
    return {
        value: {
            codePoint: $fd97980f5eb542a9$var$codeAt(point, 0),
            position: index
        },
        done: false
    };
});
// `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints
$77eaf16128740ba7$exports({
    target: "String",
    proto: true
}, {
    codePoints: function codePoints() {
        return new $fd97980f5eb542a9$var$$StringIterator(String($0dc8ce57e9444267$exports(this)));
    }
});


var $707c6189ddda9d46$exports = {};


var $3ba8440676526860$export$2d1720544b23b823;

$3ba8440676526860$export$2d1720544b23b823 = $9f297f98d4b1debe$exports;



var $707c6189ddda9d46$require$defineProperty = $9253e412c272ab07$export$2d1720544b23b823;
$707c6189ddda9d46$exports = function(NAME) {
    var Symbol = $83f6c01f1bbefd6c$exports.Symbol || ($83f6c01f1bbefd6c$exports.Symbol = {});
    if (!$156c78d04df80ed8$exports(Symbol, NAME)) $707c6189ddda9d46$require$defineProperty(Symbol, NAME, {
        value: $3ba8440676526860$export$2d1720544b23b823(NAME)
    });
};


// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
$707c6189ddda9d46$exports("dispose");



// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$707c6189ddda9d46$exports("observable");



// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$707c6189ddda9d46$exports("patternMatch");


"use strict";



// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "WeakMap",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    deleteAll: function deleteAll() {
        return $9ca897976f282dc7$exports.apply(this, arguments);
    }
});




// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$77eaf16128740ba7$exports({
    target: "WeakMap",
    stat: true
}, {
    from: $1e4bd79a952f7b50$exports
});




// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$77eaf16128740ba7$exports({
    target: "WeakMap",
    stat: true
}, {
    of: $9939047b25b929ac$exports
});


"use strict";



// `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    addAll: function addAll() {
        return $ab656960db09986f$exports.apply(this, arguments);
    }
});


"use strict";



// `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$77eaf16128740ba7$exports({
    target: "WeakSet",
    proto: true,
    real: true,
    forced: $9336f1bf2df4c284$exports
}, {
    deleteAll: function deleteAll() {
        return $9ca897976f282dc7$exports.apply(this, arguments);
    }
});




// `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
$77eaf16128740ba7$exports({
    target: "WeakSet",
    stat: true
}, {
    from: $1e4bd79a952f7b50$exports
});




// `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
$77eaf16128740ba7$exports({
    target: "WeakSet",
    stat: true
}, {
    of: $9939047b25b929ac$exports
});




var $d26bcac217748e5a$exports = {};






var $44f083cd6e1efc2a$exports = {};
var $225ccfa26219a3f7$exports = {};

$225ccfa26219a3f7$exports = $3e89eba23641c645$exports("navigator", "userAgent") || "";


$44f083cd6e1efc2a$exports = /(iphone|ipod|ipad).*applewebkit/i.test($225ccfa26219a3f7$exports);


var $d26bcac217748e5a$var$location = $fcfb858ad971d77a$exports.location;
var $d26bcac217748e5a$var$set = $fcfb858ad971d77a$exports.setImmediate;
var $d26bcac217748e5a$var$clear = $fcfb858ad971d77a$exports.clearImmediate;
var $d26bcac217748e5a$var$process = $fcfb858ad971d77a$exports.process;
var $d26bcac217748e5a$var$MessageChannel = $fcfb858ad971d77a$exports.MessageChannel;
var $d26bcac217748e5a$var$Dispatch = $fcfb858ad971d77a$exports.Dispatch;
var $d26bcac217748e5a$var$counter = 0;
var $d26bcac217748e5a$var$queue = {};
var $d26bcac217748e5a$var$ONREADYSTATECHANGE = "onreadystatechange";
var $d26bcac217748e5a$var$defer, $d26bcac217748e5a$var$channel, $d26bcac217748e5a$var$port;
var $d26bcac217748e5a$var$run = function(id) {
    // eslint-disable-next-line no-prototype-builtins
    if ($d26bcac217748e5a$var$queue.hasOwnProperty(id)) {
        var fn = $d26bcac217748e5a$var$queue[id];
        delete $d26bcac217748e5a$var$queue[id];
        fn();
    }
};
var $d26bcac217748e5a$var$runner = function(id) {
    return function() {
        $d26bcac217748e5a$var$run(id);
    };
};
var $d26bcac217748e5a$var$listener = function(event) {
    $d26bcac217748e5a$var$run(event.data);
};
var $d26bcac217748e5a$var$post = function(id) {
    // old engines have not location.origin
    $fcfb858ad971d77a$exports.postMessage(id + "", $d26bcac217748e5a$var$location.protocol + "//" + $d26bcac217748e5a$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$d26bcac217748e5a$var$set || !$d26bcac217748e5a$var$clear) {
    $d26bcac217748e5a$var$set = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $d26bcac217748e5a$var$queue[++$d26bcac217748e5a$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == "function" ? fn : Function(fn)).apply(undefined, args);
        };
        $d26bcac217748e5a$var$defer($d26bcac217748e5a$var$counter);
        return $d26bcac217748e5a$var$counter;
    };
    $d26bcac217748e5a$var$clear = function clearImmediate(id) {
        delete $d26bcac217748e5a$var$queue[id];
    };
    // Node.js 0.8-
    if ($cd3f29cb35223fe2$exports($d26bcac217748e5a$var$process) == "process") $d26bcac217748e5a$var$defer = function(id) {
        $d26bcac217748e5a$var$process.nextTick($d26bcac217748e5a$var$runner(id));
    };
    else if ($d26bcac217748e5a$var$Dispatch && $d26bcac217748e5a$var$Dispatch.now) $d26bcac217748e5a$var$defer = function(id) {
        $d26bcac217748e5a$var$Dispatch.now($d26bcac217748e5a$var$runner(id));
    };
    else if ($d26bcac217748e5a$var$MessageChannel && !$44f083cd6e1efc2a$exports) {
        $d26bcac217748e5a$var$channel = new $d26bcac217748e5a$var$MessageChannel();
        $d26bcac217748e5a$var$port = $d26bcac217748e5a$var$channel.port2;
        $d26bcac217748e5a$var$channel.port1.onmessage = $d26bcac217748e5a$var$listener;
        $d26bcac217748e5a$var$defer = $adf776c9a927fad6$exports($d26bcac217748e5a$var$port.postMessage, $d26bcac217748e5a$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($fcfb858ad971d77a$exports.addEventListener && typeof postMessage == "function" && !$fcfb858ad971d77a$exports.importScripts && !$45031a284306f4dd$exports($d26bcac217748e5a$var$post) && $d26bcac217748e5a$var$location.protocol !== "file:") {
        $d26bcac217748e5a$var$defer = $d26bcac217748e5a$var$post;
        $fcfb858ad971d77a$exports.addEventListener("message", $d26bcac217748e5a$var$listener, false);
    // IE8-
    } else if ($d26bcac217748e5a$var$ONREADYSTATECHANGE in $6f7b995b068e4342$exports("script")) $d26bcac217748e5a$var$defer = function(id) {
        $4b0a648e1c03b4d7$exports.appendChild($6f7b995b068e4342$exports("script"))[$d26bcac217748e5a$var$ONREADYSTATECHANGE] = function() {
            $4b0a648e1c03b4d7$exports.removeChild(this);
            $d26bcac217748e5a$var$run(id);
        };
    };
    else $d26bcac217748e5a$var$defer = function(id) {
        setTimeout($d26bcac217748e5a$var$runner(id), 0);
    };
}
$d26bcac217748e5a$exports = {
    set: $d26bcac217748e5a$var$set,
    clear: $d26bcac217748e5a$var$clear
};


var $2be68f6a81096fd8$var$FORCED = !$fcfb858ad971d77a$exports.setImmediate || !$fcfb858ad971d77a$exports.clearImmediate;
// http://w3c.github.io/setImmediate/
$77eaf16128740ba7$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $2be68f6a81096fd8$var$FORCED
}, {
    // `setImmediate` method
    // http://w3c.github.io/setImmediate/#si-setImmediate
    setImmediate: $d26bcac217748e5a$exports.set,
    // `clearImmediate` method
    // http://w3c.github.io/setImmediate/#si-clearImmediate
    clearImmediate: $d26bcac217748e5a$exports.clear
});



var $iluxG = parcelRequire("iluxG");
var $9146dba4fa405fbb$exports = {};
"use strict";
function $9146dba4fa405fbb$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($9146dba4fa405fbb$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$9146dba4fa405fbb$var$checkDCE();

$9146dba4fa405fbb$exports = (parcelRequire("7W6LZ"));



// import * as Sentry from '@sentry/browser'
var $74ddcc225f04703a$exports = {};
!function(e, t) {
    $74ddcc225f04703a$exports = t();
}($74ddcc225f04703a$exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e) {
                    return this.isBrowser(e) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});


var $e2af0da5ccf1b3dc$exports = {};
// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.4 2019-09-21*/ /*global module:false, define:false*/ /*jshint latedef:false*/ /*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/ (function(define1, undefined) {
    define1(function() {
        "use strict";
        var impl = {};
        impl.mobileDetectRules = {
            "phones": {
                "iPhone": "\\biPhone\\b|\\biPod\\b",
                "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
                "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
                "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
                "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
                "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
                "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
                "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
                "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
                "Asus": "Asus.*Galaxy|PadFone.*Mobile",
                "NokiaLumia": "Lumia [0-9]{3,4}",
                "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
                "Palm": "PalmSource|Palm",
                "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
                "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
                "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
                "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
                "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
                "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
                "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
                "Alcatel": "Alcatel",
                "Nintendo": "Nintendo (3DS|Switch)",
                "Amoi": "Amoi",
                "INQ": "INQ",
                "OnePlus": "ONEPLUS",
                "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
            },
            "tablets": {
                "iPad": "iPad|iPad.*Mobile",
                "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
                "GoogleTablet": "Android.*Pixel C",
                "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V",
                "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk/[0-9.]+ like Chrome/[0-9.]+ (?!Mobile)",
                "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
                "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
                "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
                "BlackBerryTablet": "PlayBook|RIM Tablet",
                "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
                "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
                "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
                "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
                "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
                "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
                "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
                "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
                "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X",
                "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
                "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
                "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
                "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
                "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
                "IRUTablet": "M702pro",
                "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
                "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
                "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
                "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
                "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
                "NokiaLumiaTablet": "Lumia 2520",
                "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
                "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
                "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
                "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
                "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
                "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
                "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
                "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
                "FlyTablet": "IQ310|Fly Vision",
                "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
                "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
                "NecTablet": "\\bN-06D|\\bN-08D",
                "PantechTablet": "Pantech.*P4100",
                "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
                "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
                "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
                "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
                "NabiTablet": "Android.*\\bNabi",
                "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
                "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
                "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
                "PlaystationTablet": "Playstation.*(Portable|Vita)",
                "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
                "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
                "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
                "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
                "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
                "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
                "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
                "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
                "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
                "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
                "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
                "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
                "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
                "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
                "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
                "DPSTablet": "DPS Dream 9|DPS Dual 7",
                "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
                "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
                "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
                "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
                "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
                "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
                "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
                "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
                "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
                "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
                "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
                "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
                "iMobileTablet": "i-mobile i-note",
                "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
                "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
                "AMPETablet": "Android.* A78 ",
                "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
                "TecnoTablet": "TECNO P9|TECNO DP8D",
                "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
                "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
                "FX2Tablet": "FX2 PAD7|FX2 PAD10",
                "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
                "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
                "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
                "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
                "CaptivaTablet": "CAPTIVA PAD",
                "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
                "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
                "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
                "JaytechTablet": "TPC-PA762",
                "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
                "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
                "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
                "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
                "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
                "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
                "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
                "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
                "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
                "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
                "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
                "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
                "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
                "UbislateTablet": "UbiSlate[\\s]?7C",
                "PocketBookTablet": "Pocketbook",
                "KocasoTablet": "\\b(TB-1207)\\b",
                "HisenseTablet": "\\b(F5281|E2371)\\b",
                "Hudl": "Hudl HT7S3|Hudl 2",
                "TelstraTablet": "T-Hub2",
                "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
            },
            "oss": {
                "AndroidOS": "Android",
                "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
                "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
                "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
                "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
                "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
                "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
                "iPadOS": "CPU OS 13",
                "MeeGoOS": "MeeGo",
                "MaemoOS": "Maemo",
                "JavaOS": "J2ME/|\\bMIDP\\b|\\bCLDC\\b",
                "webOS": "webOS|hpwOS",
                "badaOS": "\\bBada\\b",
                "BREWOS": "BREW"
            },
            "uas": {
                "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome/[.0-9]* (Mobile)?",
                "Dolfin": "\\bDolfin\\b",
                "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR/[0-9.]+$|Coast/[0-9.]+",
                "Skyfire": "Skyfire",
                "Edge": "Mobile Safari/[.0-9]* Edge",
                "IE": "IEMobile|MSIEMobile",
                "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
                "Bolt": "bolt",
                "TeaShark": "teashark",
                "Blazer": "Blazer",
                "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
                "WeChat": "\\bMicroMessenger\\b",
                "UCBrowser": "UC.*Browser|UCWEB",
                "baiduboxapp": "baiduboxapp",
                "baidubrowser": "baidubrowser",
                "DiigoBrowser": "DiigoBrowser",
                "Mercury": "\\bMercury\\b",
                "ObigoBrowser": "Obigo",
                "NetFront": "NF-Browser",
                "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
                "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
            },
            "props": {
                "Mobile": "Mobile/[VER]",
                "Build": "Build/[VER]",
                "Version": "Version/[VER]",
                "VendorID": "VendorID/[VER]",
                "iPad": "iPad.*CPU[a-z ]+[VER]",
                "iPhone": "iPhone.*CPU[a-z ]+[VER]",
                "iPod": "iPod.*CPU[a-z ]+[VER]",
                "Kindle": "Kindle/[VER]",
                "Chrome": [
                    "Chrome/[VER]",
                    "CriOS/[VER]",
                    "CrMo/[VER]"
                ],
                "Coast": [
                    "Coast/[VER]"
                ],
                "Dolfin": "Dolfin/[VER]",
                "Firefox": [
                    "Firefox/[VER]",
                    "FxiOS/[VER]"
                ],
                "Fennec": "Fennec/[VER]",
                "Edge": "Edge/[VER]",
                "IE": [
                    "IEMobile/[VER];",
                    "IEMobile [VER]",
                    "MSIE [VER];",
                    "Trident/[0-9.]+;.*rv:[VER]"
                ],
                "NetFront": "NetFront/[VER]",
                "NokiaBrowser": "NokiaBrowser/[VER]",
                "Opera": [
                    " OPR/[VER]",
                    "Opera Mini/[VER]",
                    "Version/[VER]"
                ],
                "Opera Mini": "Opera Mini/[VER]",
                "Opera Mobi": "Version/[VER]",
                "UCBrowser": [
                    "UCWEB[VER]",
                    "UC.*Browser/[VER]"
                ],
                "MQQBrowser": "MQQBrowser/[VER]",
                "MicroMessenger": "MicroMessenger/[VER]",
                "baiduboxapp": "baiduboxapp/[VER]",
                "baidubrowser": "baidubrowser/[VER]",
                "SamsungBrowser": "SamsungBrowser/[VER]",
                "Iron": "Iron/[VER]",
                "Safari": [
                    "Version/[VER]",
                    "Safari/[VER]"
                ],
                "Skyfire": "Skyfire/[VER]",
                "Tizen": "Tizen/[VER]",
                "Webkit": "webkit[ /][VER]",
                "PaleMoon": "PaleMoon/[VER]",
                "Gecko": "Gecko/[VER]",
                "Trident": "Trident/[VER]",
                "Presto": "Presto/[VER]",
                "Goanna": "Goanna/[VER]",
                "iOS": " \\bi?OS\\b [VER][ ;]{1}",
                "Android": "Android [VER]",
                "BlackBerry": [
                    "BlackBerry[\\w]+/[VER]",
                    "BlackBerry.*Version/[VER]",
                    "Version/[VER]"
                ],
                "BREW": "BREW [VER]",
                "Java": "Java/[VER]",
                "Windows Phone OS": [
                    "Windows Phone OS [VER]",
                    "Windows Phone [VER]"
                ],
                "Windows Phone": "Windows Phone [VER]",
                "Windows CE": "Windows CE/[VER]",
                "Windows NT": "Windows NT [VER]",
                "Symbian": [
                    "SymbianOS/[VER]",
                    "Symbian/[VER]"
                ],
                "webOS": [
                    "webOS/[VER]",
                    "hpwOS/[VER];"
                ]
            },
            "utils": {
                "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp",
                "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker/M1A1-R2D2",
                "DesktopMode": "WPDesktop",
                "TV": "SonyDTV|HbbTV",
                "WebKit": "(webkit)[ /]([\\w.]+)",
                "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
                "Watch": "SM-V700"
            }
        };
        // following patterns come from http://detectmobilebrowsers.com/
        impl.detectMobileBrowsers = {
            fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            tabletPattern: /android|ipad|playbook|silk/i
        };
        var hasOwnProp = Object.prototype.hasOwnProperty, isArray;
        impl.FALLBACK_PHONE = "UnknownPhone";
        impl.FALLBACK_TABLET = "UnknownTablet";
        impl.FALLBACK_MOBILE = "UnknownMobile";
        isArray = "isArray" in Array ? Array.isArray : function(value) {
            return Object.prototype.toString.call(value) === "[object Array]";
        };
        function equalIC(a, b) {
            return a != null && b != null && a.toLowerCase() === b.toLowerCase();
        }
        function containsIC(array, value) {
            var valueLC, i, len = array.length;
            if (!len || !value) return false;
            valueLC = value.toLowerCase();
            for(i = 0; i < len; ++i){
                if (valueLC === array[i].toLowerCase()) return true;
            }
            return false;
        }
        function convertPropsToRegExp(object) {
            for(var key in object)if (hasOwnProp.call(object, key)) object[key] = new RegExp(object[key], "i");
        }
        function prepareUserAgent(userAgent) {
            return (userAgent || "").substr(0, 500); // mitigate vulnerable to ReDoS
        }
        (function init() {
            var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
            for(key in mobileDetectRules.props)if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) values = [
                    values
                ];
                len = values.length;
                for(i = 0; i < len; ++i){
                    value = values[i];
                    verPos = value.indexOf("[VER]");
                    if (verPos >= 0) value = value.substring(0, verPos) + "([\\w._\\+]+)" + value.substring(verPos + 5);
                    values[i] = new RegExp(value, "i");
                }
                mobileDetectRules.props[key] = values;
            }
            convertPropsToRegExp(mobileDetectRules.oss);
            convertPropsToRegExp(mobileDetectRules.phones);
            convertPropsToRegExp(mobileDetectRules.tablets);
            convertPropsToRegExp(mobileDetectRules.uas);
            convertPropsToRegExp(mobileDetectRules.utils);
            // copy some patterns to oss0 which are tested first (see issue#15)
            mobileDetectRules.oss0 = {
                WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
                WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
            };
        })();
        /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */ impl.findMatch = function(rules, userAgent) {
            for(var key in rules)if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) return key;
            }
            return null;
        };
        /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */ impl.findMatches = function(rules, userAgent) {
            var result = [];
            for(var key in rules){
                if (hasOwnProp.call(rules, key)) {
                    if (rules[key].test(userAgent)) result.push(key);
                }
            }
            return result;
        };
        /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */ impl.getVersionStr = function(propertyName, userAgent) {
            var props = impl.mobileDetectRules.props, patterns, i, len, match;
            if (hasOwnProp.call(props, propertyName)) {
                patterns = props[propertyName];
                len = patterns.length;
                for(i = 0; i < len; ++i){
                    match = patterns[i].exec(userAgent);
                    if (match !== null) return match[1];
                }
            }
            return null;
        };
        /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */ impl.getVersion = function(propertyName, userAgent) {
            var version = impl.getVersionStr(propertyName, userAgent);
            return version ? impl.prepareVersionNo(version) : NaN;
        };
        /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */ impl.prepareVersionNo = function(version) {
            var numbers;
            numbers = version.split(/[a-z._ \/\-]/i);
            if (numbers.length === 1) version = numbers[0];
            if (numbers.length > 1) {
                version = numbers[0] + ".";
                numbers.shift();
                version += numbers.join("");
            }
            return Number(version);
        };
        impl.isMobileFallback = function(userAgent) {
            return impl.detectMobileBrowsers.fullPattern.test(userAgent) || impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0, 4));
        };
        impl.isTabletFallback = function(userAgent) {
            return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
        };
        impl.prepareDetectionCache = function(cache, userAgent, maxPhoneWidth) {
            if (cache.mobile !== undefined) return;
            var phone, tablet, phoneSized;
            // first check for stronger tablet rules, then phone (see issue#5)
            tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
            if (tablet) {
                cache.mobile = cache.tablet = tablet;
                cache.phone = null;
                return; // unambiguously identified as tablet
            }
            phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
            if (phone) {
                cache.mobile = cache.phone = phone;
                cache.tablet = null;
                return; // unambiguously identified as phone
            }
            // our rules haven't found a match -> try more general fallback rules
            if (impl.isMobileFallback(userAgent)) {
                phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
                if (phoneSized === undefined) {
                    cache.mobile = impl.FALLBACK_MOBILE;
                    cache.tablet = cache.phone = null;
                } else if (phoneSized) {
                    cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                    cache.tablet = null;
                } else {
                    cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                    cache.phone = null;
                }
            } else if (impl.isTabletFallback(userAgent)) {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            } else // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        };
        // t is a reference to a MobileDetect instance
        impl.mobileGrade = function(t) {
            // impl note:
            // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
            // When changes are made in Mobile_Detect.php, copy this method and replace:
            //     $this-> / t.
            //     self::MOBILE_GRADE_(.) / '$1'
            //     , self::VERSION_TYPE_FLOAT / (nothing)
            //     isIOS() / os('iOS')
            //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
            var $isMobile = t.mobile() !== null;
            if (// Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os("iOS") && t.version("iPad") >= 4.3 || t.os("iOS") && t.version("iPhone") >= 3.1 || t.os("iOS") && t.version("iPod") >= 3.1 || // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            t.version("Android") > 2.1 && t.is("Webkit") || // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version("Windows Phone OS") >= 7.0 || // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is("BlackBerry") && t.version("BlackBerry") >= 6.0 || // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match("Playbook.*Tablet") || // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            t.version("webOS") >= 1.4 && t.match("Palm|Pre|Pixi") || // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match("hp.*TouchPad") || // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            t.is("Firefox") && t.version("Firefox") >= 12 || // Chrome for Android - Tested on Android 4.0, 4.1 device
            t.is("Chrome") && t.is("AndroidOS") && t.version("Android") >= 4.0 || // Skyfire 4.1 - Tested on Android 2.3 device
            t.is("Skyfire") && t.version("Skyfire") >= 4.1 && t.is("AndroidOS") && t.version("Android") >= 2.3 || // Opera Mobile 11.5-12: Tested on Android 2.3
            t.is("Opera") && t.version("Opera Mobi") > 11 && t.is("AndroidOS") || // Meego 1.2 - Tested on Nokia 950 and N9
            t.is("MeeGoOS") || // Tizen (pre-release) - Tested on early hardware
            t.is("Tizen") || // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is("Dolfin") && t.version("Bada") >= 2.0 || // UC Browser - Tested on Android 2.3 device
            (t.is("UC Browser") || t.is("Dolfin")) && t.version("Android") >= 2.3 || // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            t.match("Kindle Fire") || t.is("Kindle") && t.version("Kindle") >= 3.0 || // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is("AndroidOS") && t.is("NookTablet") || // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version("Chrome") >= 11 && !$isMobile || // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version("Safari") >= 5.0 && !$isMobile || // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version("Firefox") >= 4.0 && !$isMobile || // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version("MSIE") >= 7.0 && !$isMobile || // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version("Opera") >= 10 && !$isMobile) return "A";
            if (t.os("iOS") && t.version("iPad") < 4.3 || t.os("iOS") && t.version("iPhone") < 3.1 || t.os("iOS") && t.version("iPod") < 3.1 || // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is("Blackberry") && t.version("BlackBerry") >= 5 && t.version("BlackBerry") < 6 || //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            t.version("Opera Mini") >= 5.0 && t.version("Opera Mini") <= 6.5 && (t.version("Android") >= 2.3 || t.is("iOS")) || // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match("NokiaN8|NokiaC7|N97.*Series60|Symbian/3") || // @todo: report this (tested on Nokia N71)
            t.version("Opera Mobi") >= 11 && t.is("SymbianOS")) return "B";
            if (// Blackberry 4.x - Tested on the Curve 8330
            t.version("BlackBerry") < 5.0 || // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match("MSIEMobile|Windows CE.*Mobile") || t.version("Windows Mobile") <= 5.2) return "C";
            //All older smartphone platforms and featurephones - Any device that doesn't support media queries
            //will receive the basic, C grade experience.
            return "C";
        };
        impl.detectOS = function(ua) {
            return impl.findMatch(impl.mobileDetectRules.oss0, ua) || impl.findMatch(impl.mobileDetectRules.oss, ua);
        };
        impl.getDeviceSmallerSide = function() {
            return window.screen.width < window.screen.height ? window.screen.width : window.screen.height;
        };
        /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */ function MobileDetect(userAgent, maxPhoneWidth) {
            this.ua = prepareUserAgent(userAgent);
            this._cache = {};
            //600dp is typical 7" tablet minimum width
            this.maxPhoneWidth = maxPhoneWidth || 600;
        }
        MobileDetect.prototype = {
            constructor: MobileDetect,
            /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */ mobile: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.mobile;
            },
            /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */ phone: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.phone;
            },
            /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */ tablet: function() {
                impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
                return this._cache.tablet;
            },
            /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */ userAgent: function() {
                if (this._cache.userAgent === undefined) this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgent;
            },
            /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */ userAgents: function() {
                if (this._cache.userAgents === undefined) this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
                return this._cache.userAgents;
            },
            /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */ os: function() {
                if (this._cache.os === undefined) this._cache.os = impl.detectOS(this.ua);
                return this._cache.os;
            },
            /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */ version: function(key) {
                return impl.getVersion(key, this.ua);
            },
            /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */ versionStr: function(key) {
                return impl.getVersionStr(key, this.ua);
            },
            /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */ is: function(key) {
                return containsIC(this.userAgents(), key) || equalIC(key, this.os()) || equalIC(key, this.phone()) || equalIC(key, this.tablet()) || containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
            },
            /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */ match: function(pattern) {
                if (!(pattern instanceof RegExp)) pattern = new RegExp(pattern, "i");
                return pattern.test(this.ua);
            },
            /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */ isPhoneSized: function(maxPhoneWidth) {
                return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
            },
            /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */ mobileGrade: function() {
                if (this._cache.grade === undefined) this._cache.grade = impl.mobileGrade(this);
                return this._cache.grade;
            }
        };
        // environment-dependent
        if (typeof window !== "undefined" && window.screen) MobileDetect.isPhoneSized = function(maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
        else MobileDetect.isPhoneSized = function() {};
        // should not be replaced by a completely new object - just overwrite existing methods
        MobileDetect._impl = impl;
        MobileDetect.version = "1.4.4 2019-09-21";
        return MobileDetect;
    }); // end of call of define()
})(function(undefined) {
    if (0, $e2af0da5ccf1b3dc$exports) return function(factory) {
        $e2af0da5ccf1b3dc$exports = factory();
    };
    else if (typeof define === "function" && define.amd) return define;
    else if (typeof window !== "undefined") return function(factory) {
        window.MobileDetect = factory();
    };
    else // please file a bug if you get this error!
    throw new Error("unknown environment");
}());



var $iluxG = parcelRequire("iluxG");
var $e824f947a4d4ff44$exports = {};

(function(global, factory) {
    factory($e824f947a4d4ff44$exports, (parcelRequire("iluxG")));
})($e824f947a4d4ff44$exports, function(exports1, React) {
    "use strict";
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.updatedWithError = false;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.updatedWithError = false;
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidMount = function componentDidMount() {
            var error = this.state.error;
            if (error !== null) this.updatedWithError = true;
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && !this.updatedWithError) {
                this.updatedWithError = true;
                return;
            }
            if (error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === "function") return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $354b70bfd5057e6f$exports = {};
(function(global1) {
    /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */ var checkIfIteratorIsSupported = function() {
        try {
            return !!Symbol.iterator;
        } catch (error) {
            return false;
        }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
        if (iteratorSupported) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    };
    /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */ var serializeParam = function(value) {
        return encodeURIComponent(value).replace(/%20/g, "+");
    };
    var deserializeParam = function(value) {
        return decodeURIComponent(String(value).replace(/\+/g, " "));
    };
    var polyfillURLSearchParams = function() {
        var URLSearchParams = function(searchString) {
            Object.defineProperty(this, "_entries", {
                writable: true,
                value: {}
            });
            var typeofSearchString = typeof searchString;
            if (typeofSearchString === "undefined") ;
            else if (typeofSearchString === "string") {
                if (searchString !== "") this._fromString(searchString);
            } else if (searchString instanceof URLSearchParams) {
                var _this = this;
                searchString.forEach(function(value, name) {
                    _this.append(name, value);
                });
            } else if (searchString !== null && typeofSearchString === "object") {
                if (Object.prototype.toString.call(searchString) === "[object Array]") for(var i = 0; i < searchString.length; i++){
                    var entry = searchString[i];
                    if (Object.prototype.toString.call(entry) === "[object Array]" || entry.length !== 2) this.append(entry[0], entry[1]);
                    else throw new TypeError("Expected [string, any] as entry at index " + i + " of URLSearchParams's input");
                }
                else {
                    for(var key in searchString)if (searchString.hasOwnProperty(key)) this.append(key, searchString[key]);
                }
            } else throw new TypeError("Unsupported input's type for URLSearchParams");
        };
        var proto = URLSearchParams.prototype;
        proto.append = function(name, value) {
            if (name in this._entries) this._entries[name].push(String(value));
            else this._entries[name] = [
                String(value)
            ];
        };
        proto.delete = function(name) {
            delete this._entries[name];
        };
        proto.get = function(name) {
            return name in this._entries ? this._entries[name][0] : null;
        };
        proto.getAll = function(name) {
            return name in this._entries ? this._entries[name].slice(0) : [];
        };
        proto.has = function(name) {
            return name in this._entries;
        };
        proto.set = function(name, value) {
            this._entries[name] = [
                String(value)
            ];
        };
        proto.forEach = function(callback, thisArg) {
            var entries;
            for(var name in this._entries)if (this._entries.hasOwnProperty(name)) {
                entries = this._entries[name];
                for(var i = 0; i < entries.length; i++)callback.call(thisArg, entries[i], name, this);
            }
        };
        proto.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return createIterator(items);
        };
        proto.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return createIterator(items);
        };
        proto.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return createIterator(items);
        };
        if (iteratorSupported) proto[Symbol.iterator] = proto.entries;
        proto.toString = function() {
            var searchArray = [];
            this.forEach(function(value, name) {
                searchArray.push(serializeParam(name) + "=" + serializeParam(value));
            });
            return searchArray.join("&");
        };
        global1.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function() {
        try {
            var URLSearchParams = global1.URLSearchParams;
            return new URLSearchParams("?a=1").toString() === "a=1" && typeof URLSearchParams.prototype.set === "function" && typeof URLSearchParams.prototype.entries === "function";
        } catch (e) {
            return false;
        }
    };
    if (!checkIfURLSearchParamsSupported()) polyfillURLSearchParams();
    var proto = global1.URLSearchParams.prototype;
    if (typeof proto.sort !== "function") proto.sort = function() {
        var _this = this;
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
            if (!_this._entries) _this.delete(name);
        });
        items.sort(function(a, b) {
            if (a[0] < b[0]) return -1;
            else if (a[0] > b[0]) return 1;
            else return 0;
        });
        if (_this._entries) _this._entries = {};
        for(var i = 0; i < items.length; i++)this.append(items[i][0], items[i][1]);
    };
    if (typeof proto._fromString !== "function") Object.defineProperty(proto, "_fromString", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(searchString) {
            if (this._entries) this._entries = {};
            else {
                var keys = [];
                this.forEach(function(value, name) {
                    keys.push(name);
                });
                for(var i = 0; i < keys.length; i++)this.delete(keys[i]);
            }
            searchString = searchString.replace(/^\?/, "");
            var attributes = searchString.split("&");
            var attribute;
            for(var i = 0; i < attributes.length; i++){
                attribute = attributes[i].split("=");
                this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute[1]) : "");
            }
        }
    });
// HTMLAnchorElement
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : $354b70bfd5057e6f$exports);
(function(global1) {
    /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */ var checkIfURLIsSupported = function() {
        try {
            var u = new global1.URL("b", "http://a");
            u.pathname = "c d";
            return u.href === "http://a/c%20d" && u.searchParams;
        } catch (e) {
            return false;
        }
    };
    var polyfillURL = function() {
        var _URL = global1.URL;
        var URL = function(url, base) {
            if (typeof url !== "string") url = String(url);
            // Only create another document if the base is different from current location.
            var doc = document, baseElement;
            if (base && (global1.location === void 0 || base !== global1.location.href)) {
                doc = document.implementation.createHTMLDocument("");
                baseElement = doc.createElement("base");
                baseElement.href = base;
                doc.head.appendChild(baseElement);
                try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                } catch (err) {
                    throw new Error("URL unable to set base " + base + " due to " + err);
                }
            }
            var anchorElement = doc.createElement("a");
            anchorElement.href = url;
            if (baseElement) {
                doc.body.appendChild(anchorElement);
                anchorElement.href = anchorElement.href; // force href to refresh
            }
            var inputElement = doc.createElement("input");
            inputElement.type = "url";
            inputElement.value = url;
            if (anchorElement.protocol === ":" || !/:/.test(anchorElement.href) || !inputElement.checkValidity() && !base) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: anchorElement
            });
            // create a linked searchParams which reflect its changes on URL
            var searchParams = new global1.URLSearchParams(this.search);
            var enableSearchUpdate = true;
            var enableSearchParamsUpdate = true;
            var _this = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(methodName) {
                var method = searchParams[methodName];
                searchParams[methodName] = function() {
                    method.apply(searchParams, arguments);
                    if (enableSearchUpdate) {
                        enableSearchParamsUpdate = false;
                        _this.search = searchParams.toString();
                        enableSearchParamsUpdate = true;
                    }
                };
            });
            Object.defineProperty(this, "searchParams", {
                value: searchParams,
                enumerable: true
            });
            var search = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function() {
                    if (this.search !== search) {
                        search = this.search;
                        if (enableSearchParamsUpdate) {
                            enableSearchUpdate = false;
                            this.searchParams._fromString(this.search);
                            enableSearchUpdate = true;
                        }
                    }
                }
            });
        };
        var proto = URL.prototype;
        var linkURLWithAnchorAttribute = function(attributeName) {
            Object.defineProperty(proto, attributeName, {
                get: function() {
                    return this._anchorElement[attributeName];
                },
                set: function(value) {
                    this._anchorElement[attributeName] = value;
                },
                enumerable: true
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(attributeName) {
            linkURLWithAnchorAttribute(attributeName);
        });
        Object.defineProperty(proto, "search", {
            get: function() {
                return this._anchorElement["search"];
            },
            set: function(value) {
                this._anchorElement["search"] = value;
                this._updateSearchParams();
            },
            enumerable: true
        });
        Object.defineProperties(proto, {
            "toString": {
                get: function() {
                    var _this = this;
                    return function() {
                        return _this.href;
                    };
                }
            },
            "href": {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function(value) {
                    this._anchorElement.href = value;
                    this._updateSearchParams();
                },
                enumerable: true
            },
            "pathname": {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function(value) {
                    this._anchorElement.pathname = value;
                },
                enumerable: true
            },
            "origin": {
                get: function() {
                    // get expected port from protocol
                    var expectedPort = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol];
                    // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''
                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (addPortToOrigin ? ":" + this._anchorElement.port : "");
                },
                enumerable: true
            },
            "password": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            },
            "username": {
                get: function() {
                    return "";
                },
                set: function(value) {},
                enumerable: true
            }
        });
        URL.createObjectURL = function(blob) {
            return _URL.createObjectURL.apply(_URL, arguments);
        };
        URL.revokeObjectURL = function(url) {
            return _URL.revokeObjectURL.apply(_URL, arguments);
        };
        global1.URL = URL;
    };
    if (!checkIfURLIsSupported()) polyfillURL();
    if (global1.location !== void 0 && !("origin" in global1.location)) {
        var getOrigin = function() {
            return global1.location.protocol + "//" + global1.location.hostname + (global1.location.port ? ":" + global1.location.port : "");
        };
        try {
            Object.defineProperty(global1.location, "origin", {
                get: getOrigin,
                enumerable: true
            });
        } catch (e) {
            setInterval(function() {
                global1.location.origin = getOrigin();
            }, 100);
        }
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : $354b70bfd5057e6f$exports);


var $7713d7a73e00e438$exports = {};

$7713d7a73e00e438$exports = new URL((parcelRequire("16ViG")).resolve("aMeZU"), import.meta.url).toString();



var $iluxG = parcelRequire("iluxG");
function $b48bb517e724a338$var$ErrorHandler({ error: error, reserErrorBoundary: reserErrorBoundary }) {
    console.log(error.message);
    window.parent.postMessage({
        command: "resize",
        params: {
            x: 0,
            y: 0,
            minHeight: 0,
            maxWidth: 0,
            maxHeight: 0
        }
    }, "*");
    console.log("Resizing chat app");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
}
var $b48bb517e724a338$export$2e2bcd8739ae039 = $b48bb517e724a338$var$ErrorHandler;



var $iluxG = parcelRequire("iluxG");
const $20e2cef96e93dea6$export$2d00a038b309a8fa = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createContext(null);




var $iluxG = parcelRequire("iluxG");
const $77aa80f10cd3ab0a$var$initial = {
    token: null,
    chatServiceUrl: null,
    setToken: ()=>{},
    setChatURL: ()=>{}
};
/**
 * @typedef {Object} WelcomePacket
 * @property {string} chat_size
 * @property {string} primary_color
 * @property {string} contrast_color
 * @property {string} button_color
 * @property {string} send_type
 * @property {string} agent_name
 * @property {string} agent_avatar
 * @property {string} bot_name
 * @property {number} fallback_timer
 * @property {string} prompt_visibility
 * @property {number} prompt_icon_id
 * @property {string} prompt_icon_url
 * @property {number} bot_participant_id
 * @property {number} default_bot_profile_id
 * @property {boolean} online
 * @property {boolean} disable_new_conversation
 * @property {boolean} branding
 * @property {Object} agent_social_profiles
 */ /**
 * @typedef {Object} SessionContextValue
 * @property {WelcomePacket} welcomePacket
 * @property {string} token
 * @property {function(string): void} setToken
 * @property {number} activeConversationId
 * @property {function(number): void} setActiveConversationId
 * @property {string} chatServiceUrl
 * @property {function(string): void} setChatURL
 * @property {function(WelcomePacket): void} setWelcomePacket
 */ /** @type {React.Context<SessionContextValue>} */ const $77aa80f10cd3ab0a$export$3285420c698bc605 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createContext($77aa80f10cd3ab0a$var$initial);
function $77aa80f10cd3ab0a$export$d053b53cdff1ea07(props) {
    const [chatServiceUrl, setChatURL] = (0, $iluxG.useState)(null);
    const [token, setToken] = (0, $iluxG.useState)(null);
    const [activeConversationId, setActiveConversationId] = (0, $iluxG.useState)(null);
    const [welcomePacket, setWelcomePacket] = (0, $iluxG.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($77aa80f10cd3ab0a$export$3285420c698bc605.Provider, {
        value: {
            token: token,
            setToken: setToken,
            activeConversationId: activeConversationId,
            setActiveConversationId: setActiveConversationId,
            chatServiceUrl: chatServiceUrl,
            setChatURL: setChatURL,
            welcomePacket: welcomePacket,
            setWelcomePacket: setWelcomePacket
        }
    }, props.children);
}



var $3LuJG = parcelRequire("3LuJG");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");

var $aCszJ = parcelRequire("aCszJ");
var $cbfOl = parcelRequire("cbfOl");
function $eb2ef6c9897259b9$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $cbfOl.default)();
    var props = (0, $aCszJ.default)({
        theme: theme,
        name: "MuiUseMediaQuery",
        props: {}
    });
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    var _props$options = (0, $7ZPk1.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $iluxG.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $iluxG.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}



var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");



var $gLWGL = parcelRequire("gLWGL");

var $cbfOl = parcelRequire("cbfOl");

var $i5X2k = parcelRequire("i5X2k");
function $57f1b1ae77a561c1$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $7ZPk1.default)((0, $7ZPk1.default)({}, outerTheme), localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $57f1b1ae77a561c1$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $cbfOl.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $57f1b1ae77a561c1$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $i5X2k.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $gLWGL.default).Provider, {
        value: theme
    }, children);
}
var $57f1b1ae77a561c1$export$2e2bcd8739ae039 = $57f1b1ae77a561c1$var$ThemeProvider;


function $7248bd2b8d26d622$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}


function $0429f233ef04ec90$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


var $2e1451eb81732024$var$MILLISECONDS_IN_HOUR = 3600000;
var $2e1451eb81732024$var$MILLISECONDS_IN_MINUTE = 60000;
var $2e1451eb81732024$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $2e1451eb81732024$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $2e1451eb81732024$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $2e1451eb81732024$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $2e1451eb81732024$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $2e1451eb81732024$export$2e2bcd8739ae039(argument, dirtyOptions) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $2e1451eb81732024$var$DEFAULT_ADDITIONAL_DIGITS : (0, $7248bd2b8d26d622$export$2e2bcd8739ae039)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $2e1451eb81732024$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $2e1451eb81732024$var$parseYear(dateStrings.date, additionalDigits);
        date = $2e1451eb81732024$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (isNaN(date) || !date) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $2e1451eb81732024$var$parseTime(dateStrings.time);
        if (isNaN(time) || time === null) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $2e1451eb81732024$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        result.setFullYear(dirtyDate.getUTCFullYear());
        return result;
    }
    return new Date(timestamp + time + offset);
}
function $2e1451eb81732024$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($2e1451eb81732024$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) {
        dateStrings.date = null;
        timeString = array[0];
    } else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($2e1451eb81732024$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($2e1451eb81732024$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $2e1451eb81732024$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $2e1451eb81732024$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: null
    };
    var year = captures[1] && parseInt(captures[1]);
    var century = captures[2] && parseInt(captures[2]);
    return {
        year: century == null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $2e1451eb81732024$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var captures = dateString.match($2e1451eb81732024$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return null;
    var isWeekDate = !!captures[4];
    var dayOfYear = $2e1451eb81732024$var$parseDateUnit(captures[1]);
    var month = $2e1451eb81732024$var$parseDateUnit(captures[2]) - 1;
    var day = $2e1451eb81732024$var$parseDateUnit(captures[3]);
    var week = $2e1451eb81732024$var$parseDateUnit(captures[4]);
    var dayOfWeek = $2e1451eb81732024$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$2e1451eb81732024$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $2e1451eb81732024$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$2e1451eb81732024$var$validateDate(year, month, day) || !$2e1451eb81732024$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $2e1451eb81732024$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $2e1451eb81732024$var$parseTime(timeString) {
    var captures = timeString.match($2e1451eb81732024$var$timeRegex);
    if (!captures) return null; // Invalid ISO-formatted time
    var hours = $2e1451eb81732024$var$parseTimeUnit(captures[1]);
    var minutes = $2e1451eb81732024$var$parseTimeUnit(captures[2]);
    var seconds = $2e1451eb81732024$var$parseTimeUnit(captures[3]);
    if (!$2e1451eb81732024$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * $2e1451eb81732024$var$MILLISECONDS_IN_HOUR + minutes * $2e1451eb81732024$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
}
function $2e1451eb81732024$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $2e1451eb81732024$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($2e1451eb81732024$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$2e1451eb81732024$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * $2e1451eb81732024$var$MILLISECONDS_IN_HOUR + minutes * $2e1451eb81732024$var$MILLISECONDS_IN_MINUTE);
}
function $2e1451eb81732024$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $2e1451eb81732024$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $2e1451eb81732024$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100;
}
function $2e1451eb81732024$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($2e1451eb81732024$var$daysInMonths[month] || ($2e1451eb81732024$var$isLeapYearIndex(year) ? 29 : 28));
}
function $2e1451eb81732024$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($2e1451eb81732024$var$isLeapYearIndex(year) ? 366 : 365);
}
function $2e1451eb81732024$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $2e1451eb81732024$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $2e1451eb81732024$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


var $d1a00881c4a408e9$exports = {};
var $96df0d3cde975f6e$exports = {};
var $96df0d3cde975f6e$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
$96df0d3cde975f6e$exports = $96df0d3cde975f6e$var$camel2hyphen;


var $d1a00881c4a408e9$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $d1a00881c4a408e9$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $96df0d3cde975f6e$exports(feature);
        // Add px to dimension features
        if ($d1a00881c4a408e9$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $d1a00881c4a408e9$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $d1a00881c4a408e9$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $d1a00881c4a408e9$var$obj2mq(query);
};
$d1a00881c4a408e9$exports = $d1a00881c4a408e9$var$json2mq;




var $iluxG = parcelRequire("iluxG");
var $e6a6dd398dab2c16$exports = {};
"use strict";
Object.defineProperty($e6a6dd398dab2c16$exports, "__esModule", {
    value: true
});
var $63f2020f8c8dad3e$exports = {};
"use strict";
var $63f2020f8c8dad3e$var$__assign = $63f2020f8c8dad3e$exports && $63f2020f8c8dad3e$exports.__assign || function() {
    $63f2020f8c8dad3e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $63f2020f8c8dad3e$var$__assign.apply(this, arguments);
};
var $63f2020f8c8dad3e$var$__awaiter = $63f2020f8c8dad3e$exports && $63f2020f8c8dad3e$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $63f2020f8c8dad3e$var$__generator = $63f2020f8c8dad3e$exports && $63f2020f8c8dad3e$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($63f2020f8c8dad3e$exports, "__esModule", {
    value: true
});

var $iluxG = parcelRequire("iluxG");
var $ac34e16c5b7c3d54$exports = {};
"use strict";
Object.defineProperty($ac34e16c5b7c3d54$exports, "__esModule", {
    value: true
});
var $ac34e16c5b7c3d54$var$MILLISECONDS = 1;
var $ac34e16c5b7c3d54$var$SECONDS = 1000 * $ac34e16c5b7c3d54$var$MILLISECONDS;
$ac34e16c5b7c3d54$exports.DEFAULT_OPTIONS = {};
$ac34e16c5b7c3d54$exports.SOCKET_IO_PING_INTERVAL = 25 * $ac34e16c5b7c3d54$var$SECONDS;
$ac34e16c5b7c3d54$exports.SOCKET_IO_PATH = "/socket.io/?EIO=3&transport=websocket";
$ac34e16c5b7c3d54$exports.SOCKET_IO_PING_CODE = "2";
$ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_LIMIT = 20;
$ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_INTERVAL_MS = 5000;
$ac34e16c5b7c3d54$exports.UNPARSABLE_JSON_OBJECT = {};
var $ac34e16c5b7c3d54$var$ReadyState;
(function(ReadyState) {
    ReadyState[ReadyState["UNINSTANTIATED"] = -1] = "UNINSTANTIATED";
    ReadyState[ReadyState["CONNECTING"] = 0] = "CONNECTING";
    ReadyState[ReadyState["OPEN"] = 1] = "OPEN";
    ReadyState[ReadyState["CLOSING"] = 2] = "CLOSING";
    ReadyState[ReadyState["CLOSED"] = 3] = "CLOSED";
})($ac34e16c5b7c3d54$var$ReadyState = $ac34e16c5b7c3d54$exports.ReadyState || ($ac34e16c5b7c3d54$exports.ReadyState = {}));


var $936fd50604352b56$exports = {};
"use strict";
Object.defineProperty($936fd50604352b56$exports, "__esModule", {
    value: true
});
var $f51fcc50b2c465ec$exports = {};
"use strict";
Object.defineProperty($f51fcc50b2c465ec$exports, "__esModule", {
    value: true
});
$f51fcc50b2c465ec$exports.sharedWebSockets = {};



var $46f65ae58ffb4c9b$exports = {};
"use strict";
Object.defineProperty($46f65ae58ffb4c9b$exports, "__esModule", {
    value: true
});
var $b053dd6e916d43f3$exports = {};
"use strict";
Object.defineProperty($b053dd6e916d43f3$exports, "__esModule", {
    value: true
});

$b053dd6e916d43f3$exports.parseSocketIOUrl = function(url) {
    if (url) {
        var isSecure = /^https|wss/.test(url);
        var strippedProtocol = url.replace(/^(https?|wss?)(:\/\/)?/, "");
        var removedFinalBackSlack = strippedProtocol.replace(/\/$/, "");
        var protocol = isSecure ? "wss" : "ws";
        return protocol + "://" + removedFinalBackSlack + $ac34e16c5b7c3d54$exports.SOCKET_IO_PATH;
    } else if (url === "") {
        var isSecure = /^https/.test(window.location.protocol);
        var protocol = isSecure ? "wss" : "ws";
        var port = window.location.port ? ":" + window.location.port : "";
        return protocol + "://" + window.location.hostname + port + $ac34e16c5b7c3d54$exports.SOCKET_IO_PATH;
    }
    return url;
};
$b053dd6e916d43f3$exports.appendQueryParams = function(url, params, alreadyHasParams) {
    if (params === void 0) params = {};
    if (alreadyHasParams === void 0) alreadyHasParams = false;
    var stringified = "" + Object.entries(params).reduce(function(next, _a) {
        var key = _a[0], value = _a[1];
        return next + (key + "=" + value + "&");
    }, "").slice(0, -1);
    return "" + url + (alreadyHasParams ? "&" : "?") + stringified;
};
$b053dd6e916d43f3$exports.setUpSocketIOPing = function(socketInstance) {
    var ping = function() {
        return socketInstance.send($ac34e16c5b7c3d54$exports.SOCKET_IO_PING_CODE);
    };
    return setInterval(ping, $ac34e16c5b7c3d54$exports.SOCKET_IO_PING_INTERVAL);
};



$46f65ae58ffb4c9b$exports.attachListeners = function(webSocketInstance, setters, optionsRef, reconnect, reconnectCount) {
    var setLastMessage = setters.setLastMessage, setReadyState = setters.setReadyState;
    var interval;
    var reconnectTimeout;
    if (optionsRef.current.fromSocketIO) interval = $b053dd6e916d43f3$exports.setUpSocketIOPing(webSocketInstance);
    webSocketInstance.onmessage = function(message) {
        optionsRef.current.onMessage && optionsRef.current.onMessage(message);
        if (typeof optionsRef.current.filter === "function" && optionsRef.current.filter(message) !== true) return;
        setLastMessage(message);
    };
    webSocketInstance.onopen = function(event) {
        optionsRef.current.onOpen && optionsRef.current.onOpen(event);
        reconnectCount.current = 0;
        setReadyState($ac34e16c5b7c3d54$exports.ReadyState.OPEN);
    };
    webSocketInstance.onclose = function(event) {
        var _a, _b;
        optionsRef.current.onClose && optionsRef.current.onClose(event);
        setReadyState($ac34e16c5b7c3d54$exports.ReadyState.CLOSED);
        if (optionsRef.current.shouldReconnect && optionsRef.current.shouldReconnect(event)) {
            var reconnectAttempts = (_a = optionsRef.current.reconnectAttempts, _a !== null && _a !== void 0 ? _a : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_LIMIT);
            if (reconnectCount.current < reconnectAttempts) reconnectTimeout = setTimeout(function() {
                reconnectCount.current++;
                reconnect();
            }, (_b = optionsRef.current.reconnectInterval, _b !== null && _b !== void 0 ? _b : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_INTERVAL_MS));
            else console.error("Max reconnect attempts of " + reconnectAttempts + " exceeded");
        }
    };
    webSocketInstance.onerror = function(error) {
        var _a, _b;
        optionsRef.current.onError && optionsRef.current.onError(error);
        if (optionsRef.current.retryOnError) {
            if (reconnectCount.current < (_a = optionsRef.current.reconnectAttempts, _a !== null && _a !== void 0 ? _a : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_LIMIT)) reconnectTimeout = setTimeout(function() {
                reconnectCount.current++;
                reconnect();
            }, (_b = optionsRef.current.reconnectInterval, _b !== null && _b !== void 0 ? _b : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_INTERVAL_MS));
        }
    };
    return function() {
        setReadyState($ac34e16c5b7c3d54$exports.ReadyState.CLOSING);
        if (reconnectTimeout) clearTimeout(reconnectTimeout);
        webSocketInstance.close();
        if (interval) clearInterval(interval);
    };
};


var $13c6b31fa372d897$exports = {};
"use strict";
Object.defineProperty($13c6b31fa372d897$exports, "__esModule", {
    value: true
});


var $20aecf434d7716bd$exports = {};
"use strict";
Object.defineProperty($20aecf434d7716bd$exports, "__esModule", {
    value: true
});
var $20aecf434d7716bd$var$subscribers = {};
$20aecf434d7716bd$exports.getSubscribers = function(url) {
    return Array.from($20aecf434d7716bd$var$subscribers[url]);
};
$20aecf434d7716bd$exports.hasSubscribers = function(url) {
    return $20aecf434d7716bd$var$subscribers[url].size > 0;
};
$20aecf434d7716bd$exports.addSubscriber = function(url, subscriber) {
    $20aecf434d7716bd$var$subscribers[url] = $20aecf434d7716bd$var$subscribers[url] || new Set();
    $20aecf434d7716bd$var$subscribers[url].add(subscriber);
};
$20aecf434d7716bd$exports.removeSubscriber = function(url, subscriber) {
    $20aecf434d7716bd$var$subscribers[url].delete(subscriber);
};


$13c6b31fa372d897$exports.attachSharedListeners = function(webSocketInstance, url) {
    webSocketInstance.onmessage = function(message) {
        $20aecf434d7716bd$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onMessage) subscriber.optionsRef.current.onMessage(message);
            if (typeof subscriber.optionsRef.current.filter === "function" && subscriber.optionsRef.current.filter(message) !== true) return;
            subscriber.setLastMessage(message);
        });
    };
    webSocketInstance.onclose = function(event) {
        $20aecf434d7716bd$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onClose) subscriber.optionsRef.current.onClose(event);
            subscriber.setReadyState($ac34e16c5b7c3d54$exports.ReadyState.CLOSED);
        });
        $f51fcc50b2c465ec$exports.sharedWebSockets[url] = undefined;
        $20aecf434d7716bd$exports.getSubscribers(url).forEach(function(subscriber) {
            var _a, _b;
            if (subscriber.optionsRef.current.shouldReconnect && subscriber.optionsRef.current.shouldReconnect(event)) {
                var reconnectAttempts = (_a = subscriber.optionsRef.current.reconnectAttempts, _a !== null && _a !== void 0 ? _a : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_LIMIT);
                if (subscriber.reconnectCount.current < reconnectAttempts) {
                    if (subscriber.reconnectCount.current++ === 0) subscriber.reconnect.current();
                    else setTimeout(function() {
                        subscriber.reconnect.current();
                    }, (_b = subscriber.optionsRef.current.reconnectInterval, _b !== null && _b !== void 0 ? _b : $ac34e16c5b7c3d54$exports.DEFAULT_RECONNECT_INTERVAL_MS));
                } else console.error("Max reconnect attempts of " + reconnectAttempts + " exceeded");
            }
        });
    };
    webSocketInstance.onerror = function(error) {
        $20aecf434d7716bd$exports.getSubscribers(url).forEach(function(subscriber) {
            if (subscriber.optionsRef.current.onError) subscriber.optionsRef.current.onError(error);
        });
    };
    webSocketInstance.onopen = function(event) {
        $20aecf434d7716bd$exports.getSubscribers(url).forEach(function(subscriber) {
            subscriber.reconnectCount.current = 0;
            if (subscriber.optionsRef.current.onOpen) subscriber.optionsRef.current.onOpen(event);
            subscriber.setReadyState($ac34e16c5b7c3d54$exports.ReadyState.OPEN);
        });
    };
};



$936fd50604352b56$exports.createOrJoinSocket = function(webSocketRef, url, setReadyState, optionsRef, setLastMessage, startRef, reconnectCount) {
    if (optionsRef.current.share) {
        if ($f51fcc50b2c465ec$exports.sharedWebSockets[url] === undefined) {
            setReadyState($ac34e16c5b7c3d54$exports.ReadyState.CONNECTING);
            $f51fcc50b2c465ec$exports.sharedWebSockets[url] = new WebSocket(url, optionsRef.current.protocols);
            $13c6b31fa372d897$exports.attachSharedListeners($f51fcc50b2c465ec$exports.sharedWebSockets[url], url);
        } else setReadyState($f51fcc50b2c465ec$exports.sharedWebSockets[url].readyState);
        var subscriber_1 = {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState,
            optionsRef: optionsRef,
            reconnectCount: reconnectCount,
            reconnect: startRef
        };
        $20aecf434d7716bd$exports.addSubscriber(url, subscriber_1);
        webSocketRef.current = $f51fcc50b2c465ec$exports.sharedWebSockets[url];
        return function() {
            $20aecf434d7716bd$exports.removeSubscriber(url, subscriber_1);
            if (!$20aecf434d7716bd$exports.hasSubscribers(url)) {
                try {
                    $f51fcc50b2c465ec$exports.sharedWebSockets[url].onclose = function() {};
                    $f51fcc50b2c465ec$exports.sharedWebSockets[url].close();
                } catch (e) {}
                delete $f51fcc50b2c465ec$exports.sharedWebSockets[url];
            }
        };
    } else {
        setReadyState($ac34e16c5b7c3d54$exports.ReadyState.CONNECTING);
        webSocketRef.current = new WebSocket(url, optionsRef.current.protocols);
        return $46f65ae58ffb4c9b$exports.attachListeners(webSocketRef.current, {
            setLastMessage: setLastMessage,
            setReadyState: setReadyState
        }, optionsRef, startRef.current, reconnectCount);
    }
};


var $6dcd8c2613b531cc$exports = {};
"use strict";
var $6dcd8c2613b531cc$var$__awaiter = $6dcd8c2613b531cc$exports && $6dcd8c2613b531cc$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6dcd8c2613b531cc$var$__generator = $6dcd8c2613b531cc$exports && $6dcd8c2613b531cc$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($6dcd8c2613b531cc$exports, "__esModule", {
    value: true
});

$6dcd8c2613b531cc$exports.getUrl = function(url, optionsRef) {
    return $6dcd8c2613b531cc$var$__awaiter(void 0, void 0, void 0, function() {
        var convertedUrl, parsedUrl, parsedWithQueryParams;
        return $6dcd8c2613b531cc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!(typeof url === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        url()
                    ];
                case 1:
                    convertedUrl = _a.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    convertedUrl = url;
                    _a.label = 3;
                case 3:
                    parsedUrl = optionsRef.current.fromSocketIO ? $b053dd6e916d43f3$exports.parseSocketIOUrl(convertedUrl) : convertedUrl;
                    parsedWithQueryParams = optionsRef.current.queryParams ? $b053dd6e916d43f3$exports.appendQueryParams(parsedUrl, optionsRef.current.queryParams, optionsRef.current.fromSocketIO) : parsedUrl;
                    return [
                        2 /*return*/ ,
                        parsedWithQueryParams
                    ];
            }
        });
    });
};


var $39aec8f27da446c6$exports = {};
"use strict";
Object.defineProperty($39aec8f27da446c6$exports, "__esModule", {
    value: true
});
$39aec8f27da446c6$exports.websocketWrapper = function(webSocket, start) {
    return new Proxy(webSocket, {
        get: function(obj, key) {
            var val = obj[key];
            if (key === "reconnect") return start;
            if (typeof val === "function") {
                console.error("Calling methods directly on the websocket is not supported at this moment. You must use the methods returned by useWebSocket.");
                //Prevent error thrown by invoking a non-function
                return function() {};
            } else return val;
        },
        set: function(obj, key, val) {
            if (/^on/.test(key)) {
                console.warn("The websocket's event handlers should be defined through the options object passed into useWebSocket.");
                return false;
            } else {
                obj[key] = val;
                return true;
            }
        }
    });
};
$39aec8f27da446c6$exports.default = $39aec8f27da446c6$exports.websocketWrapper;


$63f2020f8c8dad3e$exports.useWebSocket = function(url, options, connect) {
    if (options === void 0) options = $ac34e16c5b7c3d54$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var _a = $iluxG.useState(null), lastMessage = _a[0], setLastMessage = _a[1];
    var _b = $iluxG.useState({}), readyState = _b[0], setReadyState = _b[1];
    var lastJsonMessage = $iluxG.useMemo(function() {
        if (lastMessage) try {
            return JSON.parse(lastMessage.data);
        } catch (e) {
            return $ac34e16c5b7c3d54$exports.UNPARSABLE_JSON_OBJECT;
        }
        return null;
    }, [
        lastMessage
    ]);
    var convertedUrl = $iluxG.useRef(null);
    var webSocketRef = $iluxG.useRef(null);
    var startRef = $iluxG.useRef(null);
    var reconnectCount = $iluxG.useRef(0);
    var messageQueue = $iluxG.useRef([]);
    var webSocketProxy = $iluxG.useRef(null);
    var optionsCache = $iluxG.useRef(null);
    optionsCache.current = options;
    var readyStateFromUrl = convertedUrl.current && readyState[convertedUrl.current] !== undefined ? readyState[convertedUrl.current] : url !== null && connect === true ? $ac34e16c5b7c3d54$exports.ReadyState.CONNECTING : $ac34e16c5b7c3d54$exports.ReadyState.UNINSTANTIATED;
    var stringifiedQueryParams = options.queryParams ? JSON.stringify(options.queryParams) : null;
    var sendMessage = $iluxG.useCallback(function(message) {
        if (webSocketRef.current && webSocketRef.current.readyState === $ac34e16c5b7c3d54$exports.ReadyState.OPEN) webSocketRef.current.send(message);
        else messageQueue.current.push(message);
    }, []);
    var sendJsonMessage = $iluxG.useCallback(function(message) {
        sendMessage(JSON.stringify(message));
    }, [
        sendMessage
    ]);
    var getWebSocket = $iluxG.useCallback(function() {
        if (optionsCache.current.share !== true) return webSocketRef.current;
        if (webSocketProxy.current === null) webSocketProxy.current = $39aec8f27da446c6$exports.default(webSocketRef.current, startRef);
        return webSocketProxy.current;
    }, [
        optionsCache
    ]);
    $iluxG.useEffect(function() {
        if (url !== null && connect === true) {
            var removeListeners_1;
            var expectClose_1 = false;
            var start_1 = function() {
                return $63f2020f8c8dad3e$var$__awaiter(void 0, void 0, void 0, function() {
                    var _a, protectedSetLastMessage, protectedSetReadyState;
                    return $63f2020f8c8dad3e$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                _a = convertedUrl;
                                return [
                                    4 /*yield*/ ,
                                    $6dcd8c2613b531cc$exports.getUrl(url, optionsCache)
                                ];
                            case 1:
                                _a.current = _b.sent();
                                protectedSetLastMessage = function(message) {
                                    if (!expectClose_1) setLastMessage(message);
                                };
                                protectedSetReadyState = function(state) {
                                    if (!expectClose_1) setReadyState(function(prev) {
                                        var _a;
                                        return $63f2020f8c8dad3e$var$__assign($63f2020f8c8dad3e$var$__assign({}, prev), (_a = {}, _a[convertedUrl.current] = state, _a));
                                    });
                                };
                                removeListeners_1 = $936fd50604352b56$exports.createOrJoinSocket(webSocketRef, convertedUrl.current, protectedSetReadyState, optionsCache, protectedSetLastMessage, startRef, reconnectCount);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            };
            startRef.current = function() {
                var _a;
                if (!expectClose_1) {
                    if (webSocketProxy.current) webSocketProxy.current = null;
                    (_a = removeListeners_1) === null || _a === void 0 || _a();
                    start_1();
                }
            };
            start_1();
            return function() {
                var _a;
                expectClose_1 = true;
                if (webSocketProxy.current) webSocketProxy.current = null;
                (_a = removeListeners_1) === null || _a === void 0 || _a();
                setLastMessage(null);
            };
        }
    }, [
        url,
        connect,
        stringifiedQueryParams,
        optionsCache,
        sendMessage
    ]);
    $iluxG.useEffect(function() {
        if (readyStateFromUrl === $ac34e16c5b7c3d54$exports.ReadyState.OPEN) messageQueue.current.splice(0).forEach(function(message) {
            sendMessage(message);
        });
    }, [
        readyStateFromUrl
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: lastMessage,
        lastJsonMessage: lastJsonMessage,
        readyState: readyStateFromUrl,
        getWebSocket: getWebSocket
    };
};


$e6a6dd398dab2c16$exports.default = $63f2020f8c8dad3e$exports.useWebSocket;
var $6895d72ef9699c52$exports = {};
"use strict";
var $6895d72ef9699c52$var$__assign = $6895d72ef9699c52$exports && $6895d72ef9699c52$exports.__assign || function() {
    $6895d72ef9699c52$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6895d72ef9699c52$var$__assign.apply(this, arguments);
};
Object.defineProperty($6895d72ef9699c52$exports, "__esModule", {
    value: true
});

var $iluxG = parcelRequire("iluxG");


var $6895d72ef9699c52$var$emptyEvent = {
    type: "empty",
    payload: null
};
var $6895d72ef9699c52$var$getSocketData = function(event) {
    if (!event || !event.data) return $6895d72ef9699c52$var$emptyEvent;
    var match = event.data.match(/\[.*]/);
    if (!match) return $6895d72ef9699c52$var$emptyEvent;
    var data = JSON.parse(match);
    if (!Array.isArray(data) || !data[1]) return $6895d72ef9699c52$var$emptyEvent;
    return {
        type: data[0],
        payload: data[1]
    };
};
$6895d72ef9699c52$exports.useSocketIO = function(url, options, connect) {
    if (options === void 0) options = $ac34e16c5b7c3d54$exports.DEFAULT_OPTIONS;
    if (connect === void 0) connect = true;
    var optionsWithSocketIO = $iluxG.useMemo(function() {
        return $6895d72ef9699c52$var$__assign($6895d72ef9699c52$var$__assign({}, options), {
            fromSocketIO: true
        });
    }, []);
    var _a = $63f2020f8c8dad3e$exports.useWebSocket(url, optionsWithSocketIO, connect), sendMessage = _a.sendMessage, sendJsonMessage = _a.sendJsonMessage, lastMessage = _a.lastMessage, readyState = _a.readyState, getWebSocket = _a.getWebSocket;
    var socketIOLastMessage = $iluxG.useMemo(function() {
        return $6895d72ef9699c52$var$getSocketData(lastMessage);
    }, [
        lastMessage
    ]);
    return {
        sendMessage: sendMessage,
        sendJsonMessage: sendJsonMessage,
        lastMessage: socketIOLastMessage,
        lastJsonMessage: socketIOLastMessage,
        readyState: readyState,
        getWebSocket: getWebSocket
    };
};


$e6a6dd398dab2c16$exports.useSocketIO = $6895d72ef9699c52$exports.useSocketIO;

$e6a6dd398dab2c16$exports.ReadyState = $ac34e16c5b7c3d54$exports.ReadyState;




var $iluxG = parcelRequire("iluxG");

var $iluxG = parcelRequire("iluxG");

var $iluxG = parcelRequire("iluxG");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $iluxG = parcelRequire("iluxG");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");

var $eVYnJ = parcelRequire("eVYnJ");
function $0104f75483b2827c$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $eVYnJ.default), (0, $7ZPk1.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $eVYnJ.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).forwardRef(Component));
}


var /**
 * @ignore - internal component.
 */ $1b841e4043dc7e62$export$2e2bcd8739ae039 = (0, $0104f75483b2827c$export$2e2bcd8739ae039)(/*#__PURE__*/ $iluxG.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");


var $02fb6ce5d349524a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: 40,
            height: 40,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(20),
            lineHeight: 1,
            borderRadius: "50%",
            overflow: "hidden",
            userSelect: "none"
        },
        /* Styles applied to the root element if not `src` or `srcSet`. */ colorDefault: {
            color: theme.palette.background.default,
            backgroundColor: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
        },
        /* Styles applied to the root element if `variant="circle"`. */ circle: {},
        /* Styles applied to the root element if `variant="rounded"`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="square"`. */ square: {
            borderRadius: 0
        },
        /* Styles applied to the img element if either `src` or `srcSet` is defined. */ img: {
            width: "100%",
            height: "100%",
            textAlign: "center",
            // Handle non-square image. The property isn't supported by IE 11.
            objectFit: "cover",
            // Hide alt text.
            color: "transparent",
            // Hide the image broken icon, only works on Chrome.
            textIndent: 10000
        },
        /* Styles applied to the fallback icon */ fallback: {
            width: "75%",
            height: "75%"
        }
    };
};
function $02fb6ce5d349524a$var$useLoaded(_ref) {
    var src = _ref.src, srcSet = _ref.srcSet;
    var _React$useState = $iluxG.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
    $iluxG.useEffect(function() {
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        var active = true;
        var image = new Image();
        image.src = src;
        image.srcSet = srcSet;
        image.onload = function() {
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = function() {
            if (!active) return;
            setLoaded("error");
        };
        return function() {
            active = false;
        };
    }, [
        src,
        srcSet
    ]);
    return loaded;
}
var $02fb6ce5d349524a$var$Avatar = /*#__PURE__*/ $iluxG.forwardRef(function Avatar(props, ref) {
    var alt = props.alt, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, imgProps = props.imgProps, sizes = props.sizes, src = props.src, srcSet = props.srcSet, _props$variant = props.variant, variant = _props$variant === void 0 ? "circle" : _props$variant, other = (0, $anj8u.default)(props, [
        "alt",
        "children",
        "classes",
        "className",
        "component",
        "imgProps",
        "sizes",
        "src",
        "srcSet",
        "variant"
    ]);
    var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
    var loaded = $02fb6ce5d349524a$var$useLoaded({
        src: src,
        srcSet: srcSet
    });
    var hasImg = src || srcSet;
    var hasImgNotFailing = hasImg && loaded !== "error";
    if (hasImgNotFailing) children = /*#__PURE__*/ $iluxG.createElement("img", (0, $7ZPk1.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ $iluxG.createElement((0, $1b841e4043dc7e62$export$2e2bcd8739ae039), {
        className: classes.fallback
    });
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
        ref: ref
    }, other), children);
});
var $02fb6ce5d349524a$export$2e2bcd8739ae039 = (0, $kmV9n.default)($02fb6ce5d349524a$export$9dd6ff9ea0189349, {
    name: "MuiAvatar"
})($02fb6ce5d349524a$var$Avatar);


var $6c4b6b9edcda2767$exports = {};

$6c4b6b9edcda2767$exports = new URL((parcelRequire("16ViG")).resolve("8pDC6"), import.meta.url).toString();


function $8e743497117b4ab9$var$AgentAvatar(props) {
    const avatarUrl = props.avatarUrl ? props.avatarUrl : (0, (/*@__PURE__*/$parcel$interopDefault($6c4b6b9edcda2767$exports)));
    const size = props.size ? props.size : 30;
    const avatarClasses = {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $02fb6ce5d349524a$export$2e2bcd8739ae039), {
        src: avatarUrl,
        style: {
            height: size,
            width: size
        },
        classes: avatarClasses
    });
}
var $8e743497117b4ab9$export$2e2bcd8739ae039 = $8e743497117b4ab9$var$AgentAvatar;



var $iluxG = parcelRequire("iluxG");

var $7ZPk1 = parcelRequire("7ZPk1");

var $5Lf8f = parcelRequire("5Lf8f");

var $66ydJ = parcelRequire("66ydJ");
function $a9dded08a9281cc0$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $5Lf8f.default)(stylesOrCreator, (0, $7ZPk1.default)({
        defaultTheme: (0, $66ydJ.default)
    }, options));
}
var $a9dded08a9281cc0$export$2e2bcd8739ae039 = $a9dded08a9281cc0$var$makeStyles;







const $4d404e6faf648081$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)(()=>({
        iconButton: {
            marginRight: 10,
            padding: 0
        },
        icon: {
            height: 18,
            width: 18
        },
        label: {
            fontSize: "16px",
            paddingBottom: 4
        },
        mobileLabel: {
            fontSize: "12px",
            paddingBottom: 3
        },
        mobileIcon: {
            height: 15,
            width: 15
        }
    }));
function $4d404e6faf648081$var$AgentName(props) {
    const conversationLabel = props.conversationLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            color: props.color
        }
    }, conversationLabel));
}
var $4d404e6faf648081$export$2e2bcd8739ae039 = $4d404e6faf648081$var$AgentName;


var $3a1075901e12691f$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($3a1075901e12691f$exports, "__esModule", {
    value: true
});
$3a1075901e12691f$exports.default = void 0;

var $3a1075901e12691f$var$_react = $h59lg((parcelRequire("iluxG")));

var $3a1075901e12691f$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $3a1075901e12691f$var$_default = (0, $3a1075901e12691f$var$_createSvgIcon.default)($3a1075901e12691f$var$_react.default.createElement("path", {
    d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
}), "FormatListBulleted");
$3a1075901e12691f$exports.default = $3a1075901e12691f$var$_default;



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");

var $8UIkY = parcelRequire("8UIkY");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");



var $ao43X = parcelRequire("ao43X");


var $iluxG = parcelRequire("iluxG");
// TODO v5: consider to make it private
function $ab21da758cd74461$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


function $609081843146ef3d$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $iluxG.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $ab21da758cd74461$export$2e2bcd8739ae039)(refA, refValue);
            (0, $ab21da758cd74461$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $iluxG = parcelRequire("iluxG");
var $5fc57e9807af8404$var$useEnhancedEffect = typeof window !== "undefined" ? $iluxG.useLayoutEffect : $iluxG.useEffect;
function $5fc57e9807af8404$export$2e2bcd8739ae039(fn) {
    var ref = $iluxG.useRef(fn);
    $5fc57e9807af8404$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $iluxG.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}



var $kmV9n = parcelRequire("kmV9n");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $iluxG = parcelRequire("iluxG");

var $55e79ef0851280da$var$hadKeyboardEvent = true;
var $55e79ef0851280da$var$hadFocusVisibleRecently = false;
var $55e79ef0851280da$var$hadFocusVisibleRecentlyTimeout = null;
var $55e79ef0851280da$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $55e79ef0851280da$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === "INPUT" && $55e79ef0851280da$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $55e79ef0851280da$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $55e79ef0851280da$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $55e79ef0851280da$var$handlePointerDown() {
    $55e79ef0851280da$var$hadKeyboardEvent = false;
}
function $55e79ef0851280da$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($55e79ef0851280da$var$hadFocusVisibleRecently) $55e79ef0851280da$var$hadKeyboardEvent = true;
    }
}
function $55e79ef0851280da$var$prepare(doc) {
    doc.addEventListener("keydown", $55e79ef0851280da$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $55e79ef0851280da$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $55e79ef0851280da$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $55e79ef0851280da$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $55e79ef0851280da$var$handleVisibilityChange, true);
}
function $55e79ef0851280da$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $55e79ef0851280da$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $55e79ef0851280da$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $55e79ef0851280da$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $55e79ef0851280da$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $55e79ef0851280da$var$handleVisibilityChange, true);
}
function $55e79ef0851280da$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    } // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $55e79ef0851280da$var$hadKeyboardEvent || $55e79ef0851280da$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $55e79ef0851280da$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $55e79ef0851280da$var$hadFocusVisibleRecently = true;
    window.clearTimeout($55e79ef0851280da$var$hadFocusVisibleRecentlyTimeout);
    $55e79ef0851280da$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $55e79ef0851280da$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $55e79ef0851280da$export$2e2bcd8739ae039() {
    var ref = $iluxG.useCallback(function(instance) {
        var node = $9146dba4fa405fbb$exports.findDOMNode(instance);
        if (node != null) $55e79ef0851280da$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $55e79ef0851280da$var$isFocusVisible,
        onBlurVisible: $55e79ef0851280da$var$handleBlurVisible,
        ref: ref
    };
}



var $7ZPk1 = parcelRequire("7ZPk1");

var $8LAGA = parcelRequire("8LAGA");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $eVoFv = parcelRequire("eVoFv");

var $7ZPk1 = parcelRequire("7ZPk1");

var $gvsJC = parcelRequire("gvsJC");

var $b2hvp = parcelRequire("b2hvp");


var $iluxG = parcelRequire("iluxG");

var $iluxG = parcelRequire("iluxG");
var $dbef8e2db4f9b84b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createContext(null);



var $iluxG = parcelRequire("iluxG");
function $f7f9c4c622c5187f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $iluxG.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $iluxG.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $f7f9c4c622c5187f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $f7f9c4c622c5187f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $f7f9c4c622c5187f$export$fa71e2345c31d7a2(props, onExited) {
    return $f7f9c4c622c5187f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $iluxG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $f7f9c4c622c5187f$var$getProp(child, "appear", props),
            enter: $f7f9c4c622c5187f$var$getProp(child, "enter", props),
            exit: $f7f9c4c622c5187f$var$getProp(child, "exit", props)
        });
    });
}
function $f7f9c4c622c5187f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $f7f9c4c622c5187f$export$bbc8a025727ea824(nextProps.children);
    var children = $f7f9c4c622c5187f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $iluxG.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $iluxG.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $iluxG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $f7f9c4c622c5187f$var$getProp(child, "exit", nextProps),
            enter: $f7f9c4c622c5187f$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $iluxG.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $iluxG.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $iluxG.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $f7f9c4c622c5187f$var$getProp(child, "exit", nextProps),
            enter: $f7f9c4c622c5187f$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $d82d94a85d4b94cc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $d82d94a85d4b94cc$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $d82d94a85d4b94cc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $b2hvp.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $gvsJC.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $f7f9c4c622c5187f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $f7f9c4c622c5187f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $f7f9c4c622c5187f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $7ZPk1.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $eVoFv.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $d82d94a85d4b94cc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $dbef8e2db4f9b84b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $dbef8e2db4f9b84b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Component);
$d82d94a85d4b94cc$var$TransitionGroup.propTypes = {};
$d82d94a85d4b94cc$var$TransitionGroup.defaultProps = $d82d94a85d4b94cc$var$defaultProps;
var $d82d94a85d4b94cc$export$2e2bcd8739ae039 = $d82d94a85d4b94cc$var$TransitionGroup;



var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $aea8cf571f861dea$var$useEnhancedEffect = typeof window === "undefined" ? $iluxG.useEffect : $iluxG.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $aea8cf571f861dea$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $iluxG.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $ao43X.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $ao43X.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $aea8cf571f861dea$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $iluxG.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $iluxG.createElement("span", {
        className: childClassName
    }));
}
var $aea8cf571f861dea$export$2e2bcd8739ae039 = $aea8cf571f861dea$var$Ripple;


var $1032673473f1bbfd$var$DURATION = 550;
var $1032673473f1bbfd$export$95d0c9356b2231a3 = 80;
var $1032673473f1bbfd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: "hidden",
            pointerEvents: "none",
            position: "absolute",
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: "inherit"
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: "absolute"
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: "scale(1)",
            animation: "$enter ".concat($1032673473f1bbfd$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: "block",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: "currentColor"
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($1032673473f1bbfd$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: "absolute",
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        "@keyframes enter": {
            "0%": {
                transform: "scale(0)",
                opacity: 0.1
            },
            "100%": {
                transform: "scale(1)",
                opacity: 0.3
            }
        },
        "@keyframes exit": {
            "0%": {
                opacity: 1
            },
            "100%": {
                opacity: 0
            }
        },
        "@keyframes pulsate": {
            "0%": {
                transform: "scale(1)"
            },
            "50%": {
                transform: "scale(0.92)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $1032673473f1bbfd$var$TouchRipple = /*#__PURE__*/ $iluxG.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $anj8u.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $iluxG.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $iluxG.useRef(0);
    var rippleCallback = $iluxG.useRef(null);
    $iluxG.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $iluxG.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $iluxG.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $iluxG.useRef(null);
    var container = $iluxG.useRef(null);
    $iluxG.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $iluxG.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $8LAGA.default)(oldRipples), [
                /*#__PURE__*/ $iluxG.createElement((0, $aea8cf571f861dea$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $1032673473f1bbfd$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $iluxG.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === "touchstart") ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $1032673473f1bbfd$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $iluxG.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $iluxG.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === "touchend" && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $iluxG.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $iluxG.createElement("span", (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $iluxG.createElement((0, $d82d94a85d4b94cc$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $1032673473f1bbfd$export$2e2bcd8739ae039 = (0, $kmV9n.default)($1032673473f1bbfd$export$9dd6ff9ea0189349, {
    flip: false,
    name: "MuiTouchRipple"
})(/*#__PURE__*/ $iluxG.memo($1032673473f1bbfd$var$TouchRipple));


var $1d7527e68bc34418$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        textDecoration: "none",
        // So we take precedent over the style of a native <a /> element.
        color: "inherit",
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$disabled": {
            pointerEvents: "none",
            // Disable link interactions
            cursor: "default"
        },
        "@media print": {
            colorAdjust: "exact"
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $1d7527e68bc34418$var$ButtonBase = /*#__PURE__*/ $iluxG.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0, $anj8u.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $iluxG.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $9146dba4fa405fbb$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $iluxG.useRef(null);
    var _React$useState = $iluxG.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $55e79ef0851280da$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $iluxG.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $iluxG.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler("start", onMouseDown);
    var handleDragLeave = useRippleHandler("stop", onDragLeave);
    var handleMouseUp = useRippleHandler("stop", onMouseUp);
    var handleMouseLeave = useRippleHandler("stop", function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler("start", onTouchStart);
    var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    var handleTouchMove = useRippleHandler("stop", onTouchMove);
    var handleBlur = useRippleHandler("stop", function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $iluxG.useRef(false);
    var handleKeyDown = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === "button" && other.href) ComponentProp = "a";
    var buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== "a" || !other.href) buttonProps.role = "button";
        buttonProps["aria-disabled"] = disabled;
    }
    var handleUserRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $iluxG.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $iluxG.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $iluxG.createElement(ComponentProp, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $iluxG.createElement((0, $1032673473f1bbfd$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $1d7527e68bc34418$export$2e2bcd8739ae039 = (0, $kmV9n.default)($1d7527e68bc34418$export$9dd6ff9ea0189349, {
    name: "MuiButtonBase"
})($1d7527e68bc34418$var$ButtonBase);



var $9iccj = parcelRequire("9iccj");
var $da7d31462064561f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: "center",
            flex: "0 0 auto",
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: "50%",
            overflow: "visible",
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                backgroundColor: (0, $8UIkY.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                backgroundColor: "transparent",
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            "$sizeSmall&": {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            "$sizeSmall&": {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $8UIkY.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $8UIkY.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: "100%",
            display: "flex",
            alignItems: "inherit",
            justifyContent: "inherit"
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $da7d31462064561f$var$IconButton = /*#__PURE__*/ $iluxG.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0, $anj8u.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $1d7527e68bc34418$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, color !== "default" && classes["color".concat((0, $9iccj.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $9iccj.default)(size))], {
            "start": classes.edgeStart,
            "end": classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $iluxG.createElement("span", {
        className: classes.label
    }, children));
});
var $da7d31462064561f$export$2e2bcd8739ae039 = (0, $kmV9n.default)($da7d31462064561f$export$9dd6ff9ea0189349, {
    name: "MuiIconButton"
})($da7d31462064561f$var$IconButton);



var $36d06990be6f9b9a$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($36d06990be6f9b9a$exports, "__esModule", {
    value: true
});
$36d06990be6f9b9a$exports.default = void 0;

var $36d06990be6f9b9a$var$_react = $h59lg((parcelRequire("iluxG")));

var $36d06990be6f9b9a$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $36d06990be6f9b9a$var$_default = (0, $36d06990be6f9b9a$var$_createSvgIcon.default)($36d06990be6f9b9a$var$_react.default.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
$36d06990be6f9b9a$exports.default = $36d06990be6f9b9a$var$_default;



const $6561d0442a30572e$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        normalHeader: {
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            display: "grid",
            gridTemplateColumns: "50px auto 48px",
            gridTemplateRows: "50px",
            gridGap: 20,
            alignItems: "center",
            padding: "15px 20px 15px 15px",
            fontSize: "20px"
        },
        fullScreenHeader: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            display: "grid",
            gridTemplateColumns: "50px 10px auto 48px 48px",
            gridTemplateRows: "50px",
            alignItems: "center",
            padding: "15px 10px 15px 15px",
            fontSize: "20px"
        },
        smallHeader: {
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            gridTemplateRows: "30px",
            display: "grid",
            gridTemplateColumns: "35px auto 48px",
            gridGap: 15,
            alignItems: "center",
            padding: "12px 20px 13px 15px",
            fontSize: "16px"
        },
        icon: {
            fill: theme.palette.primary.contrastText
        },
        badge: {
            color: "white",
            backgroundColor: "red"
        }
    }));
function $6561d0442a30572e$var$HistoryButton(props) {
    const classes = $6561d0442a30572e$var$useStyles();
    if (props.bigPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: props.toggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3a1075901e12691f$exports))), {
        className: classes.icon
    }));
}
function $6561d0442a30572e$var$FullScreenHeader(props) {
    const classes = $6561d0442a30572e$var$useStyles();
    const CloseButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: ()=>props.closeChat(),
        className: classes.button,
        classes: {
            root: classes.buttonRoot
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($36d06990be6f9b9a$exports))), {
        className: classes.icon
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.fullScreenHeader,
        style: {
            borderRadius: 0,
            backgroundColor: props.contentHeader && !props.mode.startsWith("modal") ? "white" : null,
            borderBottom: props.contentHeader ? "1px solid #ccc" : null
        }
    }, !props.mode.startsWith("modal") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        size: 50
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $4d404e6faf648081$export$2e2bcd8739ae039), {
        conversationLabel: props.conversationLabel,
        color: props.contentHeader ? "#4c4c4c" : null
    }), !props.contentHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($6561d0442a30572e$var$HistoryButton, {
        toggle: props.showConversationHistory,
        bigPrompt: false
    }), CloseButton)), props.mode.startsWith("modal") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), CloseButton));
}
function $6561d0442a30572e$var$ChatHeader(props) {
    const classes = $6561d0442a30572e$var$useStyles();
    let size = 50;
    let headerClass = classes.normalHeader;
    if (props.bigPrompt) {
        size = 35;
        headerClass = classes.smallHeader;
    } else if (props.fullScreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($6561d0442a30572e$var$FullScreenHeader, {
        mode: props.mode,
        closeChat: props.closeChat,
        avatarUrl: props.avatarUrl,
        conversationLabel: props.conversationLabel,
        showConversationHistory: props.showConversationHistory,
        contentHeader: props.contentHeader
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: headerClass,
        style: {
            borderRadius: props.fullScreen ? 0 : null
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $4d404e6faf648081$export$2e2bcd8739ae039), {
        conversationLabel: props.conversationLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($6561d0442a30572e$var$HistoryButton, {
        toggle: props.showConversationHistory,
        bigPrompt: props.bigPrompt
    }));
}
var $6561d0442a30572e$export$2e2bcd8739ae039 = $6561d0442a30572e$var$ChatHeader;


var $ef6eeefd9028b3c7$exports = {};
"use strict";
var $ef6eeefd9028b3c7$var$__extends = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ef6eeefd9028b3c7$var$__assign = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__assign || function() {
    $ef6eeefd9028b3c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef6eeefd9028b3c7$var$__assign.apply(this, arguments);
};
var $ef6eeefd9028b3c7$var$__createBinding = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef6eeefd9028b3c7$var$__setModuleDefault = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ef6eeefd9028b3c7$var$__importStar = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $ef6eeefd9028b3c7$var$__createBinding(result, mod, k);
    }
    $ef6eeefd9028b3c7$var$__setModuleDefault(result, mod);
    return result;
};
var $ef6eeefd9028b3c7$var$__rest = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ef6eeefd9028b3c7$var$__importDefault = $ef6eeefd9028b3c7$exports && $ef6eeefd9028b3c7$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ef6eeefd9028b3c7$exports, "__esModule", {
    value: true
});

var $ef6eeefd9028b3c7$var$React = $ef6eeefd9028b3c7$var$__importStar((parcelRequire("iluxG")));

var $ef6eeefd9028b3c7$var$fast_deep_equal_1 = $ef6eeefd9028b3c7$var$__importDefault((parcelRequire("lktyy")));

var $ef6eeefd9028b3c7$var$PropTypes = $ef6eeefd9028b3c7$var$__importStar((parcelRequire("lar0q")));
function $ef6eeefd9028b3c7$var$normalizeHtml(str) {
    return str && str.replace(/&nbsp;|\u202F|\u00A0/g, " ");
}
function $ef6eeefd9028b3c7$var$replaceCaret(el) {
    // Place the caret at the end of the element
    var target = document.createTextNode("");
    el.appendChild(target);
    // do not move caret if element was not focused
    var isTargetFocused = document.activeElement === el;
    if (target !== null && target.nodeValue !== null && isTargetFocused) {
        var sel = window.getSelection();
        if (sel !== null) {
            var range = document.createRange();
            range.setStart(target, target.nodeValue.length);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
        if (el instanceof HTMLElement) el.focus();
    }
}
/**
 * A simple component for an html element with editable contents.
 */ var $ef6eeefd9028b3c7$var$ContentEditable = /** @class */ function(_super) {
    $ef6eeefd9028b3c7$var$__extends(ContentEditable, _super);
    function ContentEditable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHtml = _this.props.html;
        _this.el = typeof _this.props.innerRef === "function" ? {
            current: null
        } : $ef6eeefd9028b3c7$var$React.createRef();
        _this.getEl = function() {
            return (_this.props.innerRef && typeof _this.props.innerRef !== "function" ? _this.props.innerRef : _this.el).current;
        };
        _this.emitChange = function(originalEvt) {
            var el = _this.getEl();
            if (!el) return;
            var html = el.innerHTML;
            if (_this.props.onChange && html !== _this.lastHtml) {
                // Clone event with Object.assign to avoid
                // "Cannot assign to read only property 'target' of object"
                var evt = Object.assign({}, originalEvt, {
                    target: {
                        value: html
                    }
                });
                _this.props.onChange(evt);
            }
            _this.lastHtml = html;
        };
        return _this;
    }
    ContentEditable.prototype.render = function() {
        var _this = this;
        var _a = this.props, tagName = _a.tagName, html = _a.html, innerRef = _a.innerRef, props = $ef6eeefd9028b3c7$var$__rest(_a, [
            "tagName",
            "html",
            "innerRef"
        ]);
        return $ef6eeefd9028b3c7$var$React.createElement(tagName || "div", $ef6eeefd9028b3c7$var$__assign($ef6eeefd9028b3c7$var$__assign({}, props), {
            ref: typeof innerRef === "function" ? function(current) {
                innerRef(current);
                _this.el.current = current;
            } : innerRef || this.el,
            onInput: this.emitChange,
            onBlur: this.props.onBlur || this.emitChange,
            onKeyUp: this.props.onKeyUp || this.emitChange,
            onKeyDown: this.props.onKeyDown || this.emitChange,
            contentEditable: !this.props.disabled,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }), this.props.children);
    };
    ContentEditable.prototype.shouldComponentUpdate = function(nextProps) {
        var props = this.props;
        var el = this.getEl();
        // We need not rerender if the change of props simply reflects the user's edits.
        // Rerendering in this case would make the cursor/caret jump
        // Rerender if there is no element yet... (somehow?)
        if (!el) return true;
        // ...or if html really changed... (programmatically, not by user edit)
        if ($ef6eeefd9028b3c7$var$normalizeHtml(nextProps.html) !== $ef6eeefd9028b3c7$var$normalizeHtml(el.innerHTML)) return true;
        // Handle additional properties
        return props.disabled !== nextProps.disabled || props.tagName !== nextProps.tagName || props.className !== nextProps.className || props.innerRef !== nextProps.innerRef || !$ef6eeefd9028b3c7$var$fast_deep_equal_1.default(props.style, nextProps.style);
    };
    ContentEditable.prototype.componentDidUpdate = function() {
        var el = this.getEl();
        if (!el) return;
        // Perhaps React (whose VDOM gets outdated because we often prevent
        // rerendering) did not update the DOM. So we update it manually now.
        if (this.props.html !== el.innerHTML) el.innerHTML = this.props.html;
        this.lastHtml = this.props.html;
        $ef6eeefd9028b3c7$var$replaceCaret(el);
    };
    ContentEditable.propTypes = {
        html: $ef6eeefd9028b3c7$var$PropTypes.string.isRequired,
        onChange: $ef6eeefd9028b3c7$var$PropTypes.func,
        disabled: $ef6eeefd9028b3c7$var$PropTypes.bool,
        tagName: $ef6eeefd9028b3c7$var$PropTypes.string,
        className: $ef6eeefd9028b3c7$var$PropTypes.string,
        style: $ef6eeefd9028b3c7$var$PropTypes.object,
        innerRef: $ef6eeefd9028b3c7$var$PropTypes.oneOfType([
            $ef6eeefd9028b3c7$var$PropTypes.object,
            $ef6eeefd9028b3c7$var$PropTypes.func
        ])
    };
    return ContentEditable;
}($ef6eeefd9028b3c7$var$React.Component);
$ef6eeefd9028b3c7$exports.default = $ef6eeefd9028b3c7$var$ContentEditable;



var $iluxG = parcelRequire("iluxG");
var $b3dbc7aea5cef5b8$exports = {};
/*! @license DOMPurify | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.2.2/LICENSE */ (function(global, factory) {
    $b3dbc7aea5cef5b8$exports = factory();
})($b3dbc7aea5cef5b8$exports, function() {
    "use strict";
    function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return new (Function.prototype.bind.apply(Func, [
            null
        ].concat(_toConsumableArray(args))))();
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array) {
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = stringToLowerCase(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property = void 0;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ])) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    var svg = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "feimage",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html$1 = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns"
    ]);
    var svg$1 = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl$1 = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function _toConsumableArray$1(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    }
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if ((typeof trustedTypes === "undefined" ? "undefined" : _typeof(trustedTypes)) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html$$1) {
                    return html$$1;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.2.7";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === undefined ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, Text = window1.Text, Comment = window1.Comment, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, getElementsByTagName = _document.getElementsByTagName, createDocumentFragment = _document.createDocumentFragment;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && typeof implementation.createHTMLDocument !== "undefined" && documentMode !== 9;
        var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR, ERB_EXPR$$1 = ERB_EXPR, DATA_ATTR$$1 = DATA_ATTR, ARIA_ATTR$$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
        var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify.
     *
     * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
     * might cause XSS from attacks hidden in closed shadowroots in case the browser
     * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
     */ var RETURN_DOM_IMPORT = true;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks? */ var SANITIZE_DOM = true;
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || (typeof cfg === "undefined" ? "undefined" : _typeof(cfg)) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html);
                    addToSet(ALLOWED_ATTR, html$1);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg);
                    addToSet(ALLOWED_ATTR, svg$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl);
                    addToSet(ALLOWED_ATTR, mathMl$1);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: HTML_NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // Certain elements are allowed in both SVG and HTML
                // namespace. We need to specify them explicitly
                // so that they don't get erronously deleted from
                // HTML namespace.
                var commonSvgAndHTMLElements = addToSet({}, [
                    "title",
                    "style",
                    "font",
                    "a",
                    "script"
                ]);
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG or MathML). Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc = void 0;
            var leadingWhitespace = void 0;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Use the DOMParser API by default, fallback later if needs be */ try {
                doc = new DOMParser().parseFromString(dirtyPayload, "text/html");
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createHTMLDocument("");
                var _doc = doc, body = _doc.body;
                body.parentNode.removeChild(body.parentNode.firstElementChild);
                body.outerHTML = dirtyPayload;
            }
            if (dirty && leadingWhitespace) doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
            /* Work on whole document or just its body */ return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function() {
                return NodeFilter.FILTER_ACCEPT;
            }, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            if (elm instanceof Text || elm instanceof Comment) return false;
            if (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function") return true;
            return false;
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return (typeof Node === "undefined" ? "undefined" : _typeof(Node)) === "object" ? object instanceof Node : object && (typeof object === "undefined" ? "undefined" : _typeof(object)) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content = void 0;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = stringToLowerCase(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode);
                    var childNodes = getChildNodes(currentNode);
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed") && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$$1, " ");
                content = stringReplace(content, ERB_EXPR$$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) return false;
            else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ""))) ;
            else if (!value) ;
            else return false;
            return true;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr = void 0;
            var value = void 0;
            var lcName = void 0;
            var l = void 0;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = stringTrim(attr.value);
                lcName = stringToLowerCase(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$$1, " ");
                    value = stringReplace(value, ERB_EXPR$$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = currentNode.nodeName.toLowerCase();
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode = void 0;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty, cfg) {
            var body = void 0;
            var importedNode = void 0;
            var currentNode = void 0;
            var oldNode = void 0;
            var returnNode = void 0;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ if (!dirty) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                // eslint-disable-next-line no-negated-condition
                if (typeof dirty.toString !== "function") throw typeErrorCreate("toString is not a function");
                else {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                }
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) ;
            else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : emptyHTML;
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (RETURN_DOM_IMPORT) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = stringToLowerCase(tag);
            var lcName = stringToLowerCase(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



var $iluxG = parcelRequire("iluxG");


var $iluxG = parcelRequire("iluxG");
var $9fb70454a74b8495$exports = {};

$parcel$export($9fb70454a74b8495$exports, "default", function () { return $9fb70454a74b8495$export$2e2bcd8739ae039; });
var $2cebfb351ff15596$exports = {};
// shim for using process in browser
var $2cebfb351ff15596$var$process = $2cebfb351ff15596$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2cebfb351ff15596$var$cachedSetTimeout;
var $2cebfb351ff15596$var$cachedClearTimeout;
function $2cebfb351ff15596$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $2cebfb351ff15596$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $2cebfb351ff15596$var$cachedSetTimeout = setTimeout;
        else $2cebfb351ff15596$var$cachedSetTimeout = $2cebfb351ff15596$var$defaultSetTimout;
    } catch (e) {
        $2cebfb351ff15596$var$cachedSetTimeout = $2cebfb351ff15596$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $2cebfb351ff15596$var$cachedClearTimeout = clearTimeout;
        else $2cebfb351ff15596$var$cachedClearTimeout = $2cebfb351ff15596$var$defaultClearTimeout;
    } catch (e) {
        $2cebfb351ff15596$var$cachedClearTimeout = $2cebfb351ff15596$var$defaultClearTimeout;
    }
})();
function $2cebfb351ff15596$var$runTimeout(fun) {
    if ($2cebfb351ff15596$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2cebfb351ff15596$var$cachedSetTimeout === $2cebfb351ff15596$var$defaultSetTimout || !$2cebfb351ff15596$var$cachedSetTimeout) && setTimeout) {
        $2cebfb351ff15596$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2cebfb351ff15596$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2cebfb351ff15596$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2cebfb351ff15596$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2cebfb351ff15596$var$runClearTimeout(marker) {
    if ($2cebfb351ff15596$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2cebfb351ff15596$var$cachedClearTimeout === $2cebfb351ff15596$var$defaultClearTimeout || !$2cebfb351ff15596$var$cachedClearTimeout) && clearTimeout) {
        $2cebfb351ff15596$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2cebfb351ff15596$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2cebfb351ff15596$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2cebfb351ff15596$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2cebfb351ff15596$var$queue = [];
var $2cebfb351ff15596$var$draining = false;
var $2cebfb351ff15596$var$currentQueue;
var $2cebfb351ff15596$var$queueIndex = -1;
function $2cebfb351ff15596$var$cleanUpNextTick() {
    if (!$2cebfb351ff15596$var$draining || !$2cebfb351ff15596$var$currentQueue) return;
    $2cebfb351ff15596$var$draining = false;
    if ($2cebfb351ff15596$var$currentQueue.length) $2cebfb351ff15596$var$queue = $2cebfb351ff15596$var$currentQueue.concat($2cebfb351ff15596$var$queue);
    else $2cebfb351ff15596$var$queueIndex = -1;
    if ($2cebfb351ff15596$var$queue.length) $2cebfb351ff15596$var$drainQueue();
}
function $2cebfb351ff15596$var$drainQueue() {
    if ($2cebfb351ff15596$var$draining) return;
    var timeout = $2cebfb351ff15596$var$runTimeout($2cebfb351ff15596$var$cleanUpNextTick);
    $2cebfb351ff15596$var$draining = true;
    var len = $2cebfb351ff15596$var$queue.length;
    while(len){
        $2cebfb351ff15596$var$currentQueue = $2cebfb351ff15596$var$queue;
        $2cebfb351ff15596$var$queue = [];
        while(++$2cebfb351ff15596$var$queueIndex < len)if ($2cebfb351ff15596$var$currentQueue) $2cebfb351ff15596$var$currentQueue[$2cebfb351ff15596$var$queueIndex].run();
        $2cebfb351ff15596$var$queueIndex = -1;
        len = $2cebfb351ff15596$var$queue.length;
    }
    $2cebfb351ff15596$var$currentQueue = null;
    $2cebfb351ff15596$var$draining = false;
    $2cebfb351ff15596$var$runClearTimeout(timeout);
}
$2cebfb351ff15596$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2cebfb351ff15596$var$queue.push(new $2cebfb351ff15596$var$Item(fun, args));
    if ($2cebfb351ff15596$var$queue.length === 1 && !$2cebfb351ff15596$var$draining) $2cebfb351ff15596$var$runTimeout($2cebfb351ff15596$var$drainQueue);
};
// v8 likes predictible objects
function $2cebfb351ff15596$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2cebfb351ff15596$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2cebfb351ff15596$var$process.title = "browser";
$2cebfb351ff15596$var$process.browser = true;
$2cebfb351ff15596$var$process.env = {};
$2cebfb351ff15596$var$process.argv = [];
$2cebfb351ff15596$var$process.version = ""; // empty string to avoid regexp issues
$2cebfb351ff15596$var$process.versions = {};
function $2cebfb351ff15596$var$noop() {}
$2cebfb351ff15596$var$process.on = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.addListener = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.once = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.off = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.removeListener = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.removeAllListeners = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.emit = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.prependListener = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.prependOnceListener = $2cebfb351ff15596$var$noop;
$2cebfb351ff15596$var$process.listeners = function(name) {
    return [];
};
$2cebfb351ff15596$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$2cebfb351ff15596$var$process.cwd = function() {
    return "/";
};
$2cebfb351ff15596$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$2cebfb351ff15596$var$process.umask = function() {
    return 0;
};


var $9fb70454a74b8495$var$NOW;
// Include a performance.now polyfill.
// In node.js, use process.hrtime.
// eslint-disable-next-line
// @ts-ignore
if (typeof self === "undefined" && typeof $2cebfb351ff15596$exports !== "undefined" && $2cebfb351ff15596$exports.hrtime) $9fb70454a74b8495$var$NOW = function() {
    // eslint-disable-next-line
    // @ts-ignore
    var time = $2cebfb351ff15596$exports.hrtime();
    // Convert [seconds, nanoseconds] to milliseconds.
    return time[0] * 1000 + time[1] / 1000000;
};
else if (typeof self !== "undefined" && self.performance !== undefined && self.performance.now !== undefined) // This must be bound, because directly assigning this function
// leads to an invocation exception in Chrome.
$9fb70454a74b8495$var$NOW = self.performance.now.bind(self.performance);
else if (Date.now !== undefined) $9fb70454a74b8495$var$NOW = Date.now;
else $9fb70454a74b8495$var$NOW = function() {
    return new Date().getTime();
};
var $9fb70454a74b8495$var$NOW$1 = $9fb70454a74b8495$var$NOW;
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $9fb70454a74b8495$var$Group = /** @class */ function() {
    function Group() {
        this._tweens = {};
        this._tweensAddedDuringUpdate = {};
    }
    Group.prototype.getAll = function() {
        var _this = this;
        return Object.keys(this._tweens).map(function(tweenId) {
            return _this._tweens[tweenId];
        });
    };
    Group.prototype.removeAll = function() {
        this._tweens = {};
    };
    Group.prototype.add = function(tween) {
        this._tweens[tween.getId()] = tween;
        this._tweensAddedDuringUpdate[tween.getId()] = tween;
    };
    Group.prototype.remove = function(tween) {
        delete this._tweens[tween.getId()];
        delete this._tweensAddedDuringUpdate[tween.getId()];
    };
    Group.prototype.update = function(time, preserve) {
        var tweenIds = Object.keys(this._tweens);
        if (tweenIds.length === 0) return false;
        time = time !== undefined ? time : $9fb70454a74b8495$var$NOW$1();
        // Tweens are updated in "batches". If you add a new tween during an
        // update, then the new tween will be updated in the next batch.
        // If you remove a tween during an update, it may or may not be updated.
        // However, if the removed tween was added during the current batch,
        // then it will not be updated.
        while(tweenIds.length > 0){
            this._tweensAddedDuringUpdate = {};
            for(var i = 0; i < tweenIds.length; i++){
                var tween = this._tweens[tweenIds[i]];
                if (tween && tween.update(time) === false && !preserve) delete this._tweens[tweenIds[i]];
            }
            tweenIds = Object.keys(this._tweensAddedDuringUpdate);
        }
        return true;
    };
    return Group;
}();
/**
 * The Ease class provides a collection of easing functions for use with tween.js.
 */ var $9fb70454a74b8495$var$Easing = {
    Linear: {
        None: function(amount) {
            return amount;
        }
    },
    Quadratic: {
        In: function(amount) {
            return amount * amount;
        },
        Out: function(amount) {
            return amount * (2 - amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount;
            return -0.5 * (--amount * (amount - 2) - 1);
        }
    },
    Cubic: {
        In: function(amount) {
            return amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount + 2);
        }
    },
    Quartic: {
        In: function(amount) {
            return amount * amount * amount * amount;
        },
        Out: function(amount) {
            return 1 - --amount * amount * amount * amount;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount;
            return -0.5 * ((amount -= 2) * amount * amount * amount - 2);
        }
    },
    Quintic: {
        In: function(amount) {
            return amount * amount * amount * amount * amount;
        },
        Out: function(amount) {
            return --amount * amount * amount * amount * amount + 1;
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return 0.5 * amount * amount * amount * amount * amount;
            return 0.5 * ((amount -= 2) * amount * amount * amount * amount + 2);
        }
    },
    Sinusoidal: {
        In: function(amount) {
            return 1 - Math.cos(amount * Math.PI / 2);
        },
        Out: function(amount) {
            return Math.sin(amount * Math.PI / 2);
        },
        InOut: function(amount) {
            return 0.5 * (1 - Math.cos(Math.PI * amount));
        }
    },
    Exponential: {
        In: function(amount) {
            return amount === 0 ? 0 : Math.pow(1024, amount - 1);
        },
        Out: function(amount) {
            return amount === 1 ? 1 : 1 - Math.pow(2, -10 * amount);
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            if ((amount *= 2) < 1) return 0.5 * Math.pow(1024, amount - 1);
            return 0.5 * (-Math.pow(2, -10 * (amount - 1)) + 2);
        }
    },
    Circular: {
        In: function(amount) {
            return 1 - Math.sqrt(1 - amount * amount);
        },
        Out: function(amount) {
            return Math.sqrt(1 - --amount * amount);
        },
        InOut: function(amount) {
            if ((amount *= 2) < 1) return -0.5 * (Math.sqrt(1 - amount * amount) - 1);
            return 0.5 * (Math.sqrt(1 - (amount -= 2) * amount) + 1);
        }
    },
    Elastic: {
        In: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return -Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
        },
        Out: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            return Math.pow(2, -10 * amount) * Math.sin((amount - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function(amount) {
            if (amount === 0) return 0;
            if (amount === 1) return 1;
            amount *= 2;
            if (amount < 1) return -0.5 * Math.pow(2, 10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI);
            return 0.5 * Math.pow(2, -10 * (amount - 1)) * Math.sin((amount - 1.1) * 5 * Math.PI) + 1;
        }
    },
    Back: {
        In: function(amount) {
            var s = 1.70158;
            return amount * amount * ((s + 1) * amount - s);
        },
        Out: function(amount) {
            var s = 1.70158;
            return --amount * amount * ((s + 1) * amount + s) + 1;
        },
        InOut: function(amount) {
            var s = 2.5949095;
            if ((amount *= 2) < 1) return 0.5 * (amount * amount * ((s + 1) * amount - s));
            return 0.5 * ((amount -= 2) * amount * ((s + 1) * amount + s) + 2);
        }
    },
    Bounce: {
        In: function(amount) {
            return 1 - $9fb70454a74b8495$var$Easing.Bounce.Out(1 - amount);
        },
        Out: function(amount) {
            if (amount < 1 / 2.75) return 7.5625 * amount * amount;
            else if (amount < 2 / 2.75) return 7.5625 * (amount -= 1.5 / 2.75) * amount + 0.75;
            else if (amount < 2.5 / 2.75) return 7.5625 * (amount -= 2.25 / 2.75) * amount + 0.9375;
            else return 7.5625 * (amount -= 2.625 / 2.75) * amount + 0.984375;
        },
        InOut: function(amount) {
            if (amount < 0.5) return $9fb70454a74b8495$var$Easing.Bounce.In(amount * 2) * 0.5;
            return $9fb70454a74b8495$var$Easing.Bounce.Out(amount * 2 - 1) * 0.5 + 0.5;
        }
    }
};
/**
 *
 */ var $9fb70454a74b8495$var$Interpolation = {
    Linear: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $9fb70454a74b8495$var$Interpolation.Utils.Linear;
        if (k < 0) return fn(v[0], v[1], f);
        if (k > 1) return fn(v[m], v[m - 1], m - f);
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function(v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = $9fb70454a74b8495$var$Interpolation.Utils.Bernstein;
        for(var i = 0; i <= n; i++)b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        return b;
    },
    CatmullRom: function(v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = $9fb70454a74b8495$var$Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) i = Math.floor(f = m * (1 + k));
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        } else {
            if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function(p0, p1, t) {
            return (p1 - p0) * t + p0;
        },
        Bernstein: function(n, i) {
            var fc = $9fb70454a74b8495$var$Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: function() {
            var a = [
                1
            ];
            return function(n) {
                var s = 1;
                if (a[n]) return a[n];
                for(var i = n; i > 1; i--)s *= i;
                a[n] = s;
                return s;
            };
        }(),
        CatmullRom: function(p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};
/**
 * Utils
 */ var $9fb70454a74b8495$var$Sequence = /** @class */ function() {
    function Sequence() {}
    Sequence.nextId = function() {
        return Sequence._nextId++;
    };
    Sequence._nextId = 0;
    return Sequence;
}();
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var $9fb70454a74b8495$var$Tween = /** @class */ function() {
    function Tween(_object, _group) {
        if (_group === void 0) _group = $9fb70454a74b8495$var$TWEEN;
        this._object = _object;
        this._group = _group;
        this._isPaused = false;
        this._pauseStart = 0;
        this._valuesStart = {};
        this._valuesEnd = {};
        this._valuesStartRepeat = {};
        this._duration = 1000;
        this._initialRepeat = 0;
        this._repeat = 0;
        this._yoyo = false;
        this._isPlaying = false;
        this._reversed = false;
        this._delayTime = 0;
        this._startTime = 0;
        this._easingFunction = $9fb70454a74b8495$var$TWEEN.Easing.Linear.None;
        this._interpolationFunction = $9fb70454a74b8495$var$TWEEN.Interpolation.Linear;
        this._chainedTweens = [];
        this._onStartCallbackFired = false;
        this._id = $9fb70454a74b8495$var$TWEEN.nextId();
        this._isChainStopped = false;
    }
    Tween.prototype.getId = function() {
        return this._id;
    };
    Tween.prototype.isPlaying = function() {
        return this._isPlaying;
    };
    Tween.prototype.isPaused = function() {
        return this._isPaused;
    };
    Tween.prototype.to = function(properties, duration) {
        for(var prop in properties)this._valuesEnd[prop] = properties[prop];
        if (duration !== undefined) this._duration = duration;
        return this;
    };
    Tween.prototype.duration = function(d) {
        this._duration = d;
        return this;
    };
    Tween.prototype.start = function(time) {
        if (this._isPlaying) return this;
        // eslint-disable-next-line
        // @ts-ignore FIXME?
        this._group.add(this);
        this._repeat = this._initialRepeat;
        if (this._reversed) {
            // If we were reversed (f.e. using the yoyo feature) then we need to
            // flip the tween direction back to forward.
            this._reversed = false;
            for(var property in this._valuesStartRepeat){
                this._swapEndStartRepeatValues(property);
                this._valuesStart[property] = this._valuesStartRepeat[property];
            }
        }
        this._isPlaying = true;
        this._isPaused = false;
        this._onStartCallbackFired = false;
        this._isChainStopped = false;
        this._startTime = time !== undefined ? typeof time === "string" ? $9fb70454a74b8495$var$TWEEN.now() + parseFloat(time) : time : $9fb70454a74b8495$var$TWEEN.now();
        this._startTime += this._delayTime;
        this._setupProperties(this._object, this._valuesStart, this._valuesEnd, this._valuesStartRepeat);
        return this;
    };
    Tween.prototype._setupProperties = function(_object, _valuesStart, _valuesEnd, _valuesStartRepeat) {
        for(var property in _valuesEnd){
            var startValue = _object[property];
            var startValueIsArray = Array.isArray(startValue);
            var propType = startValueIsArray ? "array" : typeof startValue;
            var isInterpolationList = !startValueIsArray && Array.isArray(_valuesEnd[property]);
            // If `to()` specifies a property that doesn't exist in the source object,
            // we should not set that property in the object
            if (propType === "undefined" || propType === "function") continue;
            // Check if an Array was provided as property value
            if (isInterpolationList) {
                var endValues = _valuesEnd[property];
                if (endValues.length === 0) continue;
                // handle an array of relative values
                endValues = endValues.map(this._handleRelativeValue.bind(this, startValue));
                // Create a local copy of the Array with the start value at the front
                _valuesEnd[property] = [
                    startValue
                ].concat(endValues);
            }
            // handle the deepness of the values
            if ((propType === "object" || startValueIsArray) && startValue && !isInterpolationList) {
                _valuesStart[property] = startValueIsArray ? [] : {};
                // eslint-disable-next-line
                for(var prop in startValue)// eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property][prop] = startValue[prop];
                _valuesStartRepeat[property] = startValueIsArray ? [] : {}; // TODO? repeat nested values? And yoyo? And array values?
                // eslint-disable-next-line
                // @ts-ignore FIXME?
                this._setupProperties(startValue, _valuesStart[property], _valuesEnd[property], _valuesStartRepeat[property]);
            } else {
                // Save the starting value, but only once.
                if (typeof _valuesStart[property] === "undefined") _valuesStart[property] = startValue;
                if (!startValueIsArray) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                if (isInterpolationList) // eslint-disable-next-line
                // @ts-ignore FIXME?
                _valuesStartRepeat[property] = _valuesEnd[property].slice().reverse();
                else _valuesStartRepeat[property] = _valuesStart[property] || 0;
            }
        }
    };
    Tween.prototype.stop = function() {
        if (!this._isChainStopped) {
            this._isChainStopped = true;
            this.stopChainedTweens();
        }
        if (!this._isPlaying) return this;
        // eslint-disable-next-line
        // @ts-ignore FIXME?
        this._group.remove(this);
        this._isPlaying = false;
        this._isPaused = false;
        if (this._onStopCallback) this._onStopCallback(this._object);
        return this;
    };
    Tween.prototype.end = function() {
        this.update(Infinity);
        return this;
    };
    Tween.prototype.pause = function(time) {
        if (this._isPaused || !this._isPlaying) return this;
        this._isPaused = true;
        this._pauseStart = time === undefined ? $9fb70454a74b8495$var$TWEEN.now() : time;
        // eslint-disable-next-line
        // @ts-ignore FIXME?
        this._group.remove(this);
        return this;
    };
    Tween.prototype.resume = function(time) {
        if (!this._isPaused || !this._isPlaying) return this;
        this._isPaused = false;
        this._startTime += (time === undefined ? $9fb70454a74b8495$var$TWEEN.now() : time) - this._pauseStart;
        this._pauseStart = 0;
        // eslint-disable-next-line
        // @ts-ignore FIXME?
        this._group.add(this);
        return this;
    };
    Tween.prototype.stopChainedTweens = function() {
        for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)this._chainedTweens[i].stop();
        return this;
    };
    Tween.prototype.group = function(group) {
        this._group = group;
        return this;
    };
    Tween.prototype.delay = function(amount) {
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function(times) {
        this._initialRepeat = times;
        this._repeat = times;
        return this;
    };
    Tween.prototype.repeatDelay = function(amount) {
        this._repeatDelayTime = amount;
        return this;
    };
    Tween.prototype.yoyo = function(yoyo) {
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function(easingFunction) {
        this._easingFunction = easingFunction;
        return this;
    };
    Tween.prototype.interpolation = function(interpolationFunction) {
        this._interpolationFunction = interpolationFunction;
        return this;
    };
    Tween.prototype.chain = function() {
        var tweens = [];
        for(var _i = 0; _i < arguments.length; _i++)tweens[_i] = arguments[_i];
        this._chainedTweens = tweens;
        return this;
    };
    Tween.prototype.onStart = function(callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function(callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function(callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function(callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function(callback) {
        this._onStopCallback = callback;
        return this;
    };
    Tween.prototype.update = function(time) {
        var property;
        var elapsed;
        var endTime = this._startTime + this._duration;
        if (time > endTime && !this._isPlaying) return false;
        // If the tween was already finished,
        if (!this.isPlaying) this.start(time);
        if (time < this._startTime) return true;
        if (this._onStartCallbackFired === false) {
            if (this._onStartCallback) this._onStartCallback(this._object);
            this._onStartCallbackFired = true;
        }
        elapsed = (time - this._startTime) / this._duration;
        elapsed = this._duration === 0 || elapsed > 1 ? 1 : elapsed;
        var value = this._easingFunction(elapsed);
        // properties transformations
        this._updateProperties(this._object, this._valuesStart, this._valuesEnd, value);
        if (this._onUpdateCallback) this._onUpdateCallback(this._object, elapsed);
        if (elapsed === 1) {
            if (this._repeat > 0) {
                if (isFinite(this._repeat)) this._repeat--;
                // Reassign starting values, restart by making startTime = now
                for(property in this._valuesStartRepeat){
                    if (!this._yoyo && typeof this._valuesEnd[property] === "string") this._valuesStartRepeat[property] = // eslint-disable-next-line
                    // @ts-ignore FIXME?
                    this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                    if (this._yoyo) this._swapEndStartRepeatValues(property);
                    this._valuesStart[property] = this._valuesStartRepeat[property];
                }
                if (this._yoyo) this._reversed = !this._reversed;
                if (this._repeatDelayTime !== undefined) this._startTime = time + this._repeatDelayTime;
                else this._startTime = time + this._delayTime;
                if (this._onRepeatCallback) this._onRepeatCallback(this._object);
                return true;
            } else {
                if (this._onCompleteCallback) this._onCompleteCallback(this._object);
                for(var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++)// Make the chained tweens start exactly at the time they should,
                // even if the `update()` method was called way past the duration of the tween
                this._chainedTweens[i].start(this._startTime + this._duration);
                this._isPlaying = false;
                return false;
            }
        }
        return true;
    };
    Tween.prototype._updateProperties = function(_object, _valuesStart, _valuesEnd, value) {
        for(var property in _valuesEnd){
            // Don't update properties that do not exist in the source object
            if (_valuesStart[property] === undefined) continue;
            var start = _valuesStart[property] || 0;
            var end = _valuesEnd[property];
            var startIsArray = Array.isArray(_object[property]);
            var endIsArray = Array.isArray(end);
            var isInterpolationList = !startIsArray && endIsArray;
            if (isInterpolationList) _object[property] = this._interpolationFunction(end, value);
            else if (typeof end === "object" && end) // eslint-disable-next-line
            // @ts-ignore FIXME?
            this._updateProperties(_object[property], start, end, value);
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                end = this._handleRelativeValue(start, end);
                // Protect against non numeric properties.
                if (typeof end === "number") // eslint-disable-next-line
                // @ts-ignore FIXME?
                _object[property] = start + (end - start) * value;
            }
        }
    };
    Tween.prototype._handleRelativeValue = function(start, end) {
        if (typeof end !== "string") return end;
        if (end.charAt(0) === "+" || end.charAt(0) === "-") return start + parseFloat(end);
        else return parseFloat(end);
    };
    Tween.prototype._swapEndStartRepeatValues = function(property) {
        var tmp = this._valuesStartRepeat[property];
        if (typeof this._valuesEnd[property] === "string") // eslint-disable-next-line
        // @ts-ignore FIXME?
        this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
        else this._valuesStartRepeat[property] = this._valuesEnd[property];
        this._valuesEnd[property] = tmp;
    };
    return Tween;
}();
var $9fb70454a74b8495$var$VERSION = "18.6.0";
/**
 * Tween.js - Licensed under the MIT license
 * https://github.com/tweenjs/tween.js
 * ----------------------------------------------
 *
 * See https://github.com/tweenjs/tween.js/graphs/contributors for the full list of contributors.
 * Thank you all, you're awesome!
 */ var $9fb70454a74b8495$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Controlling groups of tweens
 *
 * Using the TWEEN singleton to manage your tweens can cause issues in large apps with many components.
 * In these cases, you may want to create your own smaller groups of tween
 */ var $9fb70454a74b8495$var$Main = /** @class */ function(_super) {
    $9fb70454a74b8495$var$__extends(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.version = $9fb70454a74b8495$var$VERSION;
        _this.now = $9fb70454a74b8495$var$NOW$1;
        _this.Group = $9fb70454a74b8495$var$Group;
        _this.Easing = $9fb70454a74b8495$var$Easing;
        _this.Interpolation = $9fb70454a74b8495$var$Interpolation;
        _this.nextId = $9fb70454a74b8495$var$Sequence.nextId;
        _this.Tween = $9fb70454a74b8495$var$Tween;
        return _this;
    }
    return Main;
}($9fb70454a74b8495$var$Group);
var $9fb70454a74b8495$var$TWEEN = new $9fb70454a74b8495$var$Main();
var $9fb70454a74b8495$export$2e2bcd8739ae039 = $9fb70454a74b8495$var$TWEEN;


function $de822d0d3bcba3ad$var$TypingIndicator() {
    (0, $iluxG.useEffect)(()=>{
        setTween();
        return ()=>{
            tweenRef.current = null;
        };
    }, []);
    const ref1 = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef(null);
    const ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef(null);
    const ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef(null);
    const tweenRef = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).useRef(null);
    const values = {
        x: 0
    };
    function setTween() {
        tweenRef.current = new (0, $9fb70454a74b8495$exports.default).Tween(values).to({
            x: 460
        }, 1800).onUpdate(()=>{
            let x = values.x;
            if (!ref1.current) return;
            if (x <= 102) {
                const left = 204 - x;
                ref1.current.style.setProperty("fill", `rgb(${left},${left},${left})`);
                ref2.current.style.setProperty("fill", "rgb(204,204,204)");
                ref3.current.style.setProperty("fill", "rgb(204,204,204)");
            } else if (x <= 204) {
                x = x % 102;
                const left = 102 + x;
                const right = 204 - x;
                ref1.current.style.setProperty("fill", `rgb(${left},${left},${left})`);
                ref2.current.style.setProperty("fill", `rgb(${right},${right},${right})`);
                ref3.current.style.setProperty("fill", "rgb(204,204,204)");
            } else if (x <= 306) {
                x = x % 102;
                const left = 102 + x;
                const right = 204 - x;
                ref1.current.style.setProperty("fill", "rgb(204,204,204)");
                ref2.current.style.setProperty("fill", `rgb(${left},${left},${left})`);
                ref3.current.style.setProperty("fill", `rgb(${right},${right},${right})`);
            } else if (x <= 408) {
                x = x % 102;
                const left = 102 + x;
                ref1.current.style.setProperty("fill", "rgb(204,204,204)");
                ref2.current.style.setProperty("fill", "rgb(204,204,204)");
                ref3.current.style.setProperty("fill", `rgb(${left},${left},${left})`);
            } else {
                ref1.current.style.setProperty("fill", "rgb(204,204,204)");
                ref2.current.style.setProperty("fill", "rgb(204,204,204)");
                ref3.current.style.setProperty("fill", "rgb(204,204,204)");
            }
        }).start();
        tweenRef.current.repeat(Infinity);
        function animate(time) {
            requestAnimationFrame(animate);
            (0, $9fb70454a74b8495$exports.default).update(time);
        }
        requestAnimationFrame(animate);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("svg", {
        className: "typing-dots",
        id: "Layer_1",
        "data-name": "Layer 1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 51.29 39.95"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("title", null, "Chat_Bubble_Typing"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("path", {
        className: "cls_1",
        d: "M35.64,1H16.36a16,16,0,0,0-16,16V41l9.38-9.39v0A15.79,15.79,0,0,0,16.36,33H35.64a16,16,0,0,0,0-32Z",
        transform: "translate(-0.36 -1.02)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("circle", {
        cx: 16,
        cy: 15,
        r: 4,
        ref: ref1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("circle", {
        cx: 26,
        cy: 15,
        r: 4,
        ref: ref2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("circle", {
        cx: 36,
        cy: 15,
        r: 4,
        ref: ref3
    }));
}
var $de822d0d3bcba3ad$export$2e2bcd8739ae039 = $de822d0d3bcba3ad$var$TypingIndicator;




var $iluxG = parcelRequire("iluxG");

var $b95ebe0e8cd88c5f$exports = {};

$b95ebe0e8cd88c5f$exports = (parcelRequire("53hri")).default;


var $04b36bd765249d25$exports = {};
/**
 * marked v15.0.7 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($04b36bd765249d25$exports);
})($04b36bd765249d25$exports, function(exports1) {
    "use strict";
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    const noopTest = {
        exec: ()=>null
    };
    function edit(regex, opt = "") {
        let source = typeof regex === "string" ? regex : regex.source;
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === "string" ? val : val.source;
                valSource = valSource.replace(other.caret, "$1");
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    const other = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
        hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
        htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
    };
    /**
     * Block-Level Grammar
     */ const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
    const lheading = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/\|table/g, "") // table not in commonmark
    .getRegex();
    const lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/) // table can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        lheading: lheadingGfm,
        table: gfmTable,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setext headings don't interrupt commonmark paragraphs
        .replace("table", gfmTable) // interrupt paragraphs with table
        .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = /[\p{P}\p{S}]/u;
    const _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
    const punctuation = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, _punctuationOrSpace).getRegex();
    // GFM allows ~ inside strong and em for strikethrough
    const _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
    const _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
    const emStrongLDelim = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuation).getRegex();
    const emStrongLDelimGfm = edit(emStrongLDelimCore, "u").replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    const emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)"; // (6) a***a can be either Left or Right Delimiter
    const emStrongRDelimAst = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu") // (5) #___# can be either Left or Right Delimiter
    .replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\(punct)/, "gu").replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
    const reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape$1,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        emStrongRDelimAst: emStrongRDelimAstGfm,
        emStrongLDelim: emStrongLDelimGfm,
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace("{2,}", "*").getRegex(),
        text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Helpers
     */ const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (other.escapeTest.test(html)) return html.replace(other.escapeReplace, getEscapeReplacement);
        } else {
            if (other.escapeTestNoEncode.test(html)) return html.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(other.percentDecode, "%");
        } catch  {
            return null;
        }
        return href;
    }
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(other.findPipe, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(other.splitPipe);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(other.slashPipe, "|");
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && true) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function outputLink(cap, link, raw, lexer, rules) {
        const href = link.href;
        const title = link.title || null;
        const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            const token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: text
        };
    }
    function indentCodeCompensation(raw, text, rules) {
        const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(rules.other.beginningSpace);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "", this.rules);
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (this.rules.other.endingHash.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: rtrim(cap[0], "\n")
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], "\n").split("\n");
                let raw = "";
                let text = "";
                const tokens = [];
                while(lines.length > 0){
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for(i = 0; i < lines.length; i++){
                        // get lines up to a continuation
                        if (this.rules.other.blockquoteStart.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        } else if (!inBlockquote) currentLines.push(lines[i]);
                        else break;
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join("\n");
                    const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                    .replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) break;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "code") break;
                    else if (lastToken?.type === "blockquote") {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    } else if (lastToken?.type === "list") {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + "\n" + lines.join("\n");
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: raw,
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                const itemRegex = this.rules.other.listItemRegex(bull);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    let raw = "";
                    let itemContents = "";
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else if (blankLine) indent = cap[1].length + 1;
                    else {
                        indent = cap[2].search(this.rules.other.nonSpaceChar); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                        const hrRegex = this.rules.other.hrRegex(indent);
                        const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                        const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                        const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                                nextLineWithoutTabs = nextLine;
                            } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) break;
                            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = this.rules.other.listIsTask.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                const lastItem = list.items.at(-1);
                if (lastItem) {
                    lastItem.raw = lastItem.raw.trimEnd();
                    lastItem.text = lastItem.text.trimEnd();
                } else // not a list since there were no items
                return;
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
                const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!this.rules.other.tableDelimiter.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
            const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
            const item = {
                type: "table",
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
                else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
                else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
                else item.align.push(null);
            }
            for(let i = 0; i < headers.length; i++)item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: cap[1]
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = this.rules.other.pedanticHrefTitle.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (this.rules.other.startAngleBracket.test(href)) {
                    if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                }, cap[0], this.lexer, this.rules);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer, this.rules);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
                const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[1];
                    href = "mailto:" + text;
                } else {
                    text = cap[1];
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = cap[0];
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                    }while (prevCapZero !== cap[0]);
                    text = cap[0];
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                const escaped = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: cap[0],
                    text: cap[0],
                    escaped: escaped
                };
            }
        }
    }
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                other: other,
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(other.carriageReturn, "\n");
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) src = src.replace(other.tabCharGlobal, "    ").replace(other.spaceLine, "");
            while(src){
                let token;
                if (this.options.extensions?.block?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.raw.length === 1 && lastToken !== undefined) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    lastToken.raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    const lastToken = tokens.at(-1);
                    if (lastParagraphClipped && lastToken?.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match = null;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let keepPrevChar = false;
            let prevChar = "";
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                let token;
                // extensions
                if (this.options.extensions?.inline?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.type === "text" && lastToken?.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        parser;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(token) {
            return "";
        }
        code({ text: text, lang: lang, escaped: escaped }) {
            const langString = (lang || "").match(other.notSpaceStart)?.[0];
            const code = text.replace(other.endingNewline, "") + "\n";
            if (!langString) return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape(langString) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
        }
        blockquote({ tokens: tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text: text }) {
            return text;
        }
        heading({ tokens: tokens, depth: depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return "<hr>\n";
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = "";
            for(let j = 0; j < token.items.length; j++){
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? "ol" : "ul";
            const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
        }
        listitem(item) {
            let itemBody = "";
            if (item.task) {
                const checkbox = this.checkbox({
                    checked: !!item.checked
                });
                if (item.loose) {
                    if (item.tokens[0]?.type === "paragraph") {
                        item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                            item.tokens[0].tokens[0].text = checkbox + " " + escape(item.tokens[0].tokens[0].text);
                            item.tokens[0].tokens[0].escaped = true;
                        }
                    } else item.tokens.unshift({
                        type: "text",
                        raw: checkbox + " ",
                        text: checkbox + " ",
                        escaped: true
                    });
                } else itemBody += checkbox + " ";
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked: checked }) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = "";
            // header
            let cell = "";
            for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
            header += this.tablerow({
                text: cell
            });
            let body = "";
            for(let j = 0; j < token.rows.length; j++){
                const row = token.rows[j];
                cell = "";
                for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                body += this.tablerow({
                    text: cell
                });
            }
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow({ text: text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? "th" : "td";
            const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong({ tokens: tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens: tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text: text }) {
            return `<code>${escape(text, true)}</code>`;
        }
        br(token) {
            return "<br>";
        }
        del({ tokens: tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + escape(title) + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image({ href: href, title: title, text: text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return escape(text);
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${escape(title)}"`;
            out += ">";
            return out;
        }
        text(token) {
            return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : escape(token.text);
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong({ text: text }) {
            return text;
        }
        em({ text: text }) {
            return text;
        }
        codespan({ text: text }) {
            return text;
        }
        del({ text: text }) {
            return text;
        }
        html({ text: text }) {
            return text;
        }
        text({ text: text }) {
            return text;
        }
        link({ text: text }) {
            return "" + text;
        }
        image({ text: text }) {
            return "" + text;
        }
        br() {
            return "";
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "space":
                        out += this.renderer.space(token);
                        continue;
                    case "hr":
                        out += this.renderer.hr(token);
                        continue;
                    case "heading":
                        out += this.renderer.heading(token);
                        continue;
                    case "code":
                        out += this.renderer.code(token);
                        continue;
                    case "table":
                        out += this.renderer.table(token);
                        continue;
                    case "blockquote":
                        out += this.renderer.blockquote(token);
                        continue;
                    case "list":
                        out += this.renderer.list(token);
                        continue;
                    case "html":
                        out += this.renderer.html(token);
                        continue;
                    case "paragraph":
                        out += this.renderer.paragraph(token);
                        continue;
                    case "text":
                        {
                            let textToken = token;
                            let body = this.renderer.text(textToken);
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + this.renderer.text(textToken);
                            }
                            if (top) out += this.renderer.paragraph({
                                type: "paragraph",
                                raw: body,
                                text: body,
                                tokens: [
                                    {
                                        type: "text",
                                        raw: body,
                                        text: body,
                                        escaped: true
                                    }
                                ]
                            });
                            else out += body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer = this.renderer) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({
                        parser: this
                    }, anyToken);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(anyToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case "escape":
                        out += renderer.text(token);
                        break;
                    case "html":
                        out += renderer.html(token);
                        break;
                    case "link":
                        out += renderer.link(token);
                        break;
                    case "image":
                        out += renderer.image(token);
                        break;
                    case "strong":
                        out += renderer.strong(token);
                        break;
                    case "em":
                        out += renderer.em(token);
                        break;
                    case "codespan":
                        out += renderer.codespan(token);
                        break;
                    case "br":
                        out += renderer.br(token);
                        break;
                    case "del":
                        out += renderer.del(token);
                        break;
                    case "text":
                        out += renderer.text(token);
                        break;
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        block;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */ processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */ provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */ provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(prop)) continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(prop)) continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                // throw error in case of non string input
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                const parser = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});


function $c9c83073ae40583e$var$parseMarkdown(text) {
    return (0, $04b36bd765249d25$exports.marked)(text);
}
(0, (/*@__PURE__*/$parcel$interopDefault($b3dbc7aea5cef5b8$exports))).addHook("afterSanitizeAttributes", function(node) {
    if ("target" in node) node.setAttribute("target", "_blank");
});
function $c9c83073ae40583e$var$LinkPreview(props) {
    const [previewData, setPreviewData] = (0, $iluxG.useState)(null);
    var url;
    const candidates = props.text.split(" ").filter((t)=>t.includes("href"));
    if (candidates.length) {
        const lastCandidate = candidates[candidates.length - 1];
        url = lastCandidate.split('"')[1];
        if (!url.includes("http")) url = "https://" + url;
    }
    (0, $iluxG.useEffect)(()=>{
        if (!previewData) {
            const headers = {
                "Content-Type": "application/vnd.api+json",
                Pragma: "no-cache"
            };
            if (url) fetch(`https://${window.location.host}/api/link-preview-service/preview?` + new URLSearchParams({
                url: url
            }), {
                method: "GET",
                header: headers
            }).then((response)=>response.json()).then((response)=>{
                setPreviewData({
                    title: response.data.attributes.title,
                    description: response.data.attributes.description,
                    image: response.data.attributes.image
                });
            });
        }
    }, [
        previewData,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: props.className,
        style: {
            marginLeft: -5,
            maxWidth: "calc(100% - 20px)",
            paddingLeft: 10,
            paddingRight: 10
        },
        key: props.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        ref: props.divRef,
        dangerouslySetInnerHTML: {
            __html: props.text
        },
        style: {
            color: "inherit"
        }
    }), Boolean(previewData && previewData.description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            textDecoration: "none",
            color: "inherit"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginTop: 10,
            cursor: "pointer"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "flex"
        }
    }, previewData.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            maxHeight: 80,
            marginRight: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("img", {
        src: previewData.image,
        width: 80
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            fontSize: "14px",
            fontWeight: 600
        }
    }, previewData.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            fontSize: "13px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
        }
    }, previewData.description))));
}
function $c9c83073ae40583e$var$RenderEmoji(props) {
    const divRef = (0, $iluxG.useRef)();
    // AI response text can contain markdown, so we need to parse to HTML
    const textWithLinks = $c9c83073ae40583e$var$parseMarkdown(props.text);
    const linked = (0, (/*@__PURE__*/$parcel$interopDefault($b95ebe0e8cd88c5f$exports)))(textWithLinks, {
        defaultProtocol: "https"
    });
    if (linked.includes("<a href=") && !linked.includes("mailto")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($c9c83073ae40583e$var$LinkPreview, {
        className: props.className,
        text: (0, (/*@__PURE__*/$parcel$interopDefault($b3dbc7aea5cef5b8$exports))).sanitize(linked),
        divRef: divRef
    });
    if (props.rich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            whiteSpace: "pre-wrap"
        },
        className: props.className,
        ref: divRef,
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($b3dbc7aea5cef5b8$exports))).sanitize(props.text)
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: props.className,
        ref: divRef
    }, props.text);
}
var $c9c83073ae40583e$export$2e2bcd8739ae039 = $c9c83073ae40583e$var$RenderEmoji;


const $73060cd1fe3c445d$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)({
    agentMessageAvatar: {
        width: 30,
        gridColumnStart: 1,
        marginTop: 22,
        paddingLeft: 10
    },
    agentName: {
        fontFamily: "Open Sans, sans serif",
        fontSize: "12px",
        color: "#7C7C7C",
        marginLeft: -10,
        marginBottom: -5
    }
});
function $73060cd1fe3c445d$var$AgentMessageGroup(props) {
    const agent_name = props.agent_name;
    const rows = props.messages;
    const avatarUrl = props.avatarUrl;
    const typing = props.typing;
    const bot = props.bot ? props.bot : false;
    const classes = $73060cd1fe3c445d$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "agent-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.agentMessageAvatar,
        style: typing ? {
            marginBottom: 10
        } : {
            marginBottom: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: avatarUrl,
        bot: bot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "message-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.agentName
    }, agent_name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, rows.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c9c83073ae40583e$export$2e2bcd8739ae039), {
            rich: "true",
            key: row.id,
            className: "agent-message-text",
            text: row.attributes.body
        })), typing ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $de822d0d3bcba3ad$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null))));
}
var $73060cd1fe3c445d$export$2e2bcd8739ae039 = $73060cd1fe3c445d$var$AgentMessageGroup;




var $iluxG = parcelRequire("iluxG");


var $cbfOl = parcelRequire("cbfOl");
parcelRequire("iluxG");

var $66ydJ = parcelRequire("66ydJ");
function $8c848ed513484619$export$2e2bcd8739ae039() {
    var theme = (0, $cbfOl.default)() || (0, $66ydJ.default);
    return theme;
}




function $8f16b570b5a59cc6$export$2e2bcd8739ae039(argument) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $ed81e1fdfac1d5d3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $7248bd2b8d26d622$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $6333d91084e3d118$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $7248bd2b8d26d622$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



var $3c6def3e231f731a$var$MILLISECONDS_IN_MINUTE = 60000;
function $3c6def3e231f731a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $7248bd2b8d26d622$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $6333d91084e3d118$export$2e2bcd8739ae039)(dirtyDate, amount * $3c6def3e231f731a$var$MILLISECONDS_IN_MINUTE);
}



function $3c84b458a23260f0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $bd33711691f38d1c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(date);
}


function $c8053d15086f5454$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



function $2aa51094984e709a$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
    var originalDate = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $bd33711691f38d1c$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    var options = dirtyOptions || {};
    var fractionDigits = options.fractionDigits == null ? 0 : (0, $7248bd2b8d26d622$export$2e2bcd8739ae039)(options.fractionDigits); // Test if fractionDigits is between 0 and 3 _and_ is not NaN
    if (!(fractionDigits >= 0 && fractionDigits <= 3)) throw new RangeError("fractionDigits must be between 0 and 3 inclusively");
    var day = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
    var month = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
    var year = originalDate.getFullYear();
    var hour = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
    var minute = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
    var second = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
    var fractionalSecond = "";
    if (fractionDigits > 0) {
        var milliseconds = originalDate.getMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = "." + (0, $c8053d15086f5454$export$2e2bcd8739ae039)(fractionalSeconds, fractionDigits);
    }
    var offset = "";
    var tzOffset = originalDate.getTimezoneOffset();
    if (tzOffset !== 0) {
        var absoluteOffset = Math.abs(tzOffset);
        var hourOffset = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(absoluteOffset / 60, 2);
        var minuteOffset = (0, $c8053d15086f5454$export$2e2bcd8739ae039)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
        var sign = tzOffset < 0 ? "+" : "-";
        offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else offset = "Z";
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}



function $77965f5d8a935522$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0429f233ef04ec90$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $8f16b570b5a59cc6$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $7a467367e3b7e49f$exports = {};
/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */ (function(global) {
    "use strict";
    var dateFormat = function() {
        var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|"[^"]*"|'[^']*'/g;
        var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
        var timezoneClip = /[^-+\dA-Z]/g;
        // Regexes and supporting functions are cached through closure
        return function(date, mask, utc, gmt) {
            // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
            if (arguments.length === 1 && kindOf(date) === "string" && !/\d/.test(date)) {
                mask = date;
                date = undefined;
            }
            date = date || new Date;
            if (!(date instanceof Date)) date = new Date(date);
            if (isNaN(date)) throw TypeError("Invalid date");
            mask = String(dateFormat.masks[mask] || mask || dateFormat.masks["default"]);
            // Allow setting the utc/gmt argument via the mask
            var maskSlice = mask.slice(0, 4);
            if (maskSlice === "UTC:" || maskSlice === "GMT:") {
                mask = mask.slice(4);
                utc = true;
                if (maskSlice === "GMT:") gmt = true;
            }
            var _ = utc ? "getUTC" : "get";
            var d = date[_ + "Date"]();
            var D = date[_ + "Day"]();
            var m = date[_ + "Month"]();
            var y = date[_ + "FullYear"]();
            var H = date[_ + "Hours"]();
            var M = date[_ + "Minutes"]();
            var s = date[_ + "Seconds"]();
            var L = date[_ + "Milliseconds"]();
            var o = utc ? 0 : date.getTimezoneOffset();
            var W = getWeek(date);
            var N = getDayOfWeek(date);
            var flags = {
                d: d,
                dd: pad(d),
                ddd: dateFormat.i18n.dayNames[D],
                dddd: dateFormat.i18n.dayNames[D + 7],
                m: m + 1,
                mm: pad(m + 1),
                mmm: dateFormat.i18n.monthNames[m],
                mmmm: dateFormat.i18n.monthNames[m + 12],
                yy: String(y).slice(2),
                yyyy: y,
                h: H % 12 || 12,
                hh: pad(H % 12 || 12),
                H: H,
                HH: pad(H),
                M: M,
                MM: pad(M),
                s: s,
                ss: pad(s),
                l: pad(L, 3),
                L: pad(Math.round(L / 10)),
                t: H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
                tt: H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
                T: H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
                TT: H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
                Z: gmt ? "GMT" : utc ? "UTC" : (String(date).match(timezone) || [
                    ""
                ]).pop().replace(timezoneClip, ""),
                o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S: [
                    "th",
                    "st",
                    "nd",
                    "rd"
                ][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
                W: W,
                N: N
            };
            return mask.replace(token, function(match) {
                if (match in flags) return flags[match];
                return match.slice(1, match.length - 1);
            });
        };
    }();
    dateFormat.masks = {
        "default": "ddd mmm dd yyyy HH:MM:ss",
        "shortDate": "m/d/yy",
        "mediumDate": "mmm d, yyyy",
        "longDate": "mmmm d, yyyy",
        "fullDate": "dddd, mmmm d, yyyy",
        "shortTime": "h:MM TT",
        "mediumTime": "h:MM:ss TT",
        "longTime": "h:MM:ss TT Z",
        "isoDate": "yyyy-mm-dd",
        "isoTime": "HH:MM:ss",
        "isoDateTime": "yyyy-mm-dd'T'HH:MM:sso",
        "isoUtcDateTime": "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
        "expiresHeaderFormat": "ddd, dd mmm yyyy HH:MM:ss Z"
    };
    // Internationalization strings
    dateFormat.i18n = {
        dayNames: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        timeNames: [
            "a",
            "p",
            "am",
            "pm",
            "A",
            "P",
            "AM",
            "PM"
        ]
    };
    function pad(val, len) {
        val = String(val);
        len = len || 2;
        while(val.length < len)val = "0" + val;
        return val;
    }
    /**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */ function getWeek(date) {
        // Remove time components of date
        var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        // Change date to Thursday same week
        targetThursday.setDate(targetThursday.getDate() - (targetThursday.getDay() + 6) % 7 + 3);
        // Take January 4th as it is always in week 1 (see ISO 8601)
        var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
        // Change date to Thursday same week
        firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
        // Check if daylight-saving-time-switch occurred and correct for it
        var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
        targetThursday.setHours(targetThursday.getHours() - ds);
        // Number of weeks between target Thursday and first Thursday
        var weekDiff = (targetThursday - firstThursday) / 604800000;
        return 1 + Math.floor(weekDiff);
    }
    /**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */ function getDayOfWeek(date) {
        var dow = date.getDay();
        if (dow === 0) dow = 7;
        return dow;
    }
    /**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */ function kindOf(val) {
        if (val === null) return "null";
        if (val === undefined) return "undefined";
        if (typeof val !== "object") return typeof val;
        if (Array.isArray(val)) return "array";
        return ({}).toString.call(val).slice(8, -1).toLowerCase();
    }
    if (typeof define === "function" && define.amd) define(function() {
        return dateFormat;
    });
    else $7a467367e3b7e49f$exports = dateFormat;
})($7a467367e3b7e49f$exports);



const $e18d8b0ad08c4c06$var$dateHelper = {
    /**
   * Convert date string to date object
   * @param {string} dateStr the date with year, month, and day **ONLY** i.e. '2021-08-31'
   */ stringToDate: (dateStr)=>{
        const [year, month, day] = dateStr.split("-").map((num)=>parseInt(num, 10));
        const returnDate = new Date();
        returnDate.setFullYear(year, month - 1, day);
        return returnDate;
    },
    /**
   * Convert date to date string
   * @param {Date} dateObj the date to transform
   * @param {string} [format] the format (or mask) for the return string
   * @param {boolean} [format] convert local to UTC
   */ dateToString: (dateObj, format = "yyyy-mm-dd", utc = false)=>(0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(dateObj, format, utc)
};
function $e18d8b0ad08c4c06$export$5d193019201ef5c6(slots) {
    const dict = {};
    slots.forEach((s)=>{
        const start = new Date(s.start);
        const day = start.getFullYear() + "/" + (start.getMonth() + 1) + "/" + start.getDate();
        if (dict[day]) dict[day].push(start);
        else dict[day] = [
            start
        ];
    });
    return dict;
}
/**
 * Format start and end dates for use in cronofy api request
 * @param {{ start: Date; end: Date; }} param0
 */ function $e18d8b0ad08c4c06$var$formatAvailablePeriods({ start: start, end: end }) {
    return {
        start: (0, $2aa51094984e709a$export$2e2bcd8739ae039)(start),
        end: (0, $2aa51094984e709a$export$2e2bcd8739ae039)(end)
    };
}
/**
 * @param {any[]} ogOutOfOfficeInstances
 * @param {number} [leadTime]
 * @returns {{ start: Date; end: Date; }[]}
 */ function $e18d8b0ad08c4c06$var$getAvailablePeriods(ogOutOfOfficeInstances, leadTime = 0) {
    /** The maximum days away the end Date can be **Must Be less Than 35** */ const maxDaysOut = 14;
    const earliest = (0, $3c6def3e231f731a$export$2e2bcd8739ae039)(new Date(), leadTime);
    const latest = (0, $ed81e1fdfac1d5d3$export$2e2bcd8739ae039)(new Date(), maxDaysOut);
    if (!ogOutOfOfficeInstances.length) return [
        {
            start: earliest,
            end: latest
        }
    ];
    /** @type {{ start: Date; end: Date }[]} */ const availablePeriods = [];
    const outOfOfficeInstances = ogOutOfOfficeInstances.map(({ start_date: start_date, end_date: end_date })=>({
            start: (0, $77965f5d8a935522$export$2e2bcd8739ae039)($e18d8b0ad08c4c06$var$dateHelper.stringToDate(start_date)),
            end: (0, $3c84b458a23260f0$export$2e2bcd8739ae039)($e18d8b0ad08c4c06$var$dateHelper.stringToDate(end_date))
        })).filter(({ start: start })=>start < latest);
    if (!outOfOfficeInstances.length) return [
        {
            start: earliest,
            end: latest
        }
    ];
    if (outOfOfficeInstances[0].start < earliest) {
        availablePeriods.push({
            start: outOfOfficeInstances[0].end,
            end: new Date(latest)
        });
        outOfOfficeInstances.splice(0, 1);
    } else availablePeriods.push({
        start: new Date(earliest),
        end: new Date(latest)
    });
    for (const instance of outOfOfficeInstances){
        const lastIndex = availablePeriods.length - 1;
        if (instance.end < availablePeriods[lastIndex].start) continue;
        if (instance.start < availablePeriods[lastIndex].start) {
            availablePeriods[lastIndex].start = instance.end;
            continue;
        }
        availablePeriods[lastIndex].end = instance.start;
        availablePeriods.push({
            start: instance.end,
            end: new Date(latest)
        });
    }
    return availablePeriods;
}
function $e18d8b0ad08c4c06$export$47dfb797b70c39e3({ element_token: element_token, member_sub: member_sub, drop: drop }) {
    const url = "https://api.cronofy.com/v1/availability?et=" + element_token;
    const outOfOfficeInstances = drop.data.agent_out_of_office_instances.map(({ attributes: attributes })=>attributes);
    const available_periods = $e18d8b0ad08c4c06$var$getAvailablePeriods(outOfOfficeInstances, drop.data.lead_time).map((period)=>$e18d8b0ad08c4c06$var$formatAvailablePeriods(period));
    const headers = {
        "Content-Type": "application/json; charset=utf-8",
        "Cronofy-Element": "v1.9.1, SlotPicker"
    };
    const body = {
        participants: [
            {
                members: [
                    {
                        sub: member_sub,
                        managed_availability: true
                    }
                ],
                required: "all"
            }
        ],
        required_duration: {
            minutes: drop.data.duration
        },
        buffer: {
            before: {
                minutes: drop.data.buffer_time
            },
            after: {
                minutes: drop.data.buffer_time
            }
        },
        response_format: "overlapping_slots",
        available_periods: available_periods
    };
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(body),
        headers: headers
    }).then((response)=>response.json());
}
const $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8 = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        showMoreButton: {
            backgroundColor: "#FFF",
            border: "1px solid black",
            height: 40
        },
        showMoreDiv: {
            marginTop: 10
        },
        title: {
            display: "flex",
            alignItems: "center"
        },
        calendarDropOuter: {
            width: "90%",
            height: 360,
            margin: "25px auto 10px auto",
            boxShadow: "0px 0px 7px 0px rgba(0,0,0,0.68)",
            borderRadius: 12
        },
        calendarDropHeader: {
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: theme.palette.primary.contrastText,
            height: 45,
            alignItems: "center",
            padding: "0px 10px"
        },
        calendarDropBody: {
            height: 310,
            overflowY: "auto"
        },
        calendarDropLoading: {
            height: 310,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        calendarDropCompleteCard: {
            borderColor: theme.palette.primary.main,
            borderWidth: 2,
            borderStyle: "solid",
            borderRadius: 10,
            textAlign: "center",
            padding: "15px 10px"
        },
        agentNameDiv: {
            display: "flex",
            justifyContent: "center",
            marginTop: 10,
            marginBottom: 5,
            color: "rgba(0,0,0,0.7)"
        },
        agentAvatarDiv: {
            display: "flex",
            justifyContent: "center"
        },
        slotsDiv: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridGap: 10,
            margin: "10px 0px"
        },
        optionsText: {
            textAlign: "center",
            font: "normal normal 600 10px/14px Open Sans",
            letterSpacing: 0,
            color: "#2C2C2C",
            opacity: 1,
            marginTop: 5,
            marginBottom: 10,
            cursor: "pointer"
        },
        dateAndTimeSlotsDiv: {
            display: "grid",
            gridTemplateColumns: "1fr",
            gridGap: 5,
            margin: "10px 0px"
        },
        calendarPage: {
            padding: "0px 10px"
        },
        meetingTime: {
            border: "1px solid rgba(0,0,0,0.8)",
            padding: 8,
            display: "flex",
            justifyContent: "center",
            borderRadius: 5,
            color: "rgba(0,0,0,0.7)",
            marginBottom: 15,
            textAlign: "center"
        },
        emailConfirmDiv: {
            border: "1px solid rgba(0,0,0,0.8)",
            padding: 8,
            borderRadius: 5,
            color: "rgba(0,0,0,0.7)",
            marginBottom: 10,
            textAlign: "center"
        },
        buttonProgress: {
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: -12,
            marginLeft: -12
        },
        timeSelctionError: {
            color: "red",
            whiteSpace: "nowrap"
        },
        calendarDropComplete: {
            backgroundColor: "white",
            height: 255,
            margin: "15px 10px"
        },
        calendarDropCompleteAvatar: {
            width: 70,
            height: 70,
            marginLeft: "auto",
            marginRight: "auto"
        },
        calendarDropCompleteDate: {
            color: "rgba(0,0,0,0.6)",
            fontSize: "1.2em",
            marginTop: 5,
            marginBottom: 8
        },
        textReminderDate: {
            color: "rgba(0,0,0,0.8)",
            fontSize: "0.8em",
            marginTop: 4,
            marginBottom: 2
        },
        textReminderEmailMessage: {
            marginTop: 7,
            color: "rgba(0,0,0,0.6)",
            fontSize: "0.75em",
            whiteSpace: "nowrap",
            marginLeft: -10
        },
        textReminderPrompt: {
            border: "1px solid rgba(0,0,0,0.8)",
            padding: 10,
            borderRadius: 10,
            textAlign: "center",
            fontWeight: 600,
            lineHeight: "25px"
        },
        textReminderButtonDiv: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gridGap: 10,
            marginTop: 10
        },
        reminderMenuItem: {
            padding: "2px 15px",
            fontSize: "14px",
            minHeight: 36
        }
    }));



var $iluxG = parcelRequire("iluxG");



var $d8fb157a1849c528$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($d8fb157a1849c528$exports, "__esModule", {
    value: true
});
$d8fb157a1849c528$exports.default = void 0;

var $d8fb157a1849c528$var$_react = $h59lg((parcelRequire("iluxG")));

var $d8fb157a1849c528$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $d8fb157a1849c528$var$_default = (0, $d8fb157a1849c528$var$_createSvgIcon.default)($d8fb157a1849c528$var$_react.default.createElement("path", {
    d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
}), "EventAvailable");
$d8fb157a1849c528$exports.default = $d8fb157a1849c528$var$_default;





var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $8UIkY = parcelRequire("8UIkY");


var $9iccj = parcelRequire("9iccj");
var $f7ddf2a2c12dcd07$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minWidth: 64,
            padding: "6px 16px",
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: (0, $8UIkY.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                },
                "&$disabled": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // Ensure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: "6px 8px"
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: (0, $8UIkY.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: (0, $8UIkY.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: "5px 15px",
            border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $8UIkY.fade)(theme.palette.primary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $8UIkY.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $8UIkY.fade)(theme.palette.secondary.main, 0.5)),
            "&:hover": {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $8UIkY.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            "&$disabled": {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&:active": {
                boxShadow: theme.shadows[8]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: "none",
            "&:hover": {
                boxShadow: "none"
            },
            "&$focusVisible": {
                boxShadow: "none"
            },
            "&:active": {
                boxShadow: "none"
            },
            "&$disabled": {
                boxShadow: "none"
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit",
            borderColor: "currentColor"
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: "4px 5px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: "8px 11px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: "3px 9px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: "7px 21px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: "4px 10px",
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: "8px 22px",
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: "inherit",
            marginRight: 8,
            marginLeft: -4,
            "&$iconSizeSmall": {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: "inherit",
            marginRight: -4,
            marginLeft: 8,
            "&$iconSizeSmall": {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            "& > *:first-child": {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            "& > *:first-child": {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            "& > *:first-child": {
                fontSize: 22
            }
        }
    };
};
var $f7ddf2a2c12dcd07$var$Button = /*#__PURE__*/ $iluxG.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $iluxG.createElement("span", {
        className: (0, $ao43X.default)(classes.startIcon, classes["iconSize".concat((0, $9iccj.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $iluxG.createElement("span", {
        className: (0, $ao43X.default)(classes.endIcon, classes["iconSize".concat((0, $9iccj.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $iluxG.createElement((0, $1d7527e68bc34418$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0, $9iccj.default)(color))], size !== "medium" && [
            classes["".concat(variant, "Size").concat((0, $9iccj.default)(size))],
            classes["size".concat((0, $9iccj.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $ao43X.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $iluxG.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $f7ddf2a2c12dcd07$export$2e2bcd8739ae039 = (0, $kmV9n.default)($f7ddf2a2c12dcd07$export$9dd6ff9ea0189349, {
    name: "MuiButton"
})($f7ddf2a2c12dcd07$var$Button);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $7Y3Oe = parcelRequire("7Y3Oe");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");
function $53310f753aadf6a3$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $iluxG = parcelRequire("iluxG");
/**
 * @ignore - internal component.
 */ var $21e2894ac17af8a9$var$FormControlContext = /*#__PURE__*/ $iluxG.createContext();
function $21e2894ac17af8a9$export$62ecd8ad1bbe1a18() {
    return $iluxG.useContext($21e2894ac17af8a9$var$FormControlContext);
}
var $21e2894ac17af8a9$export$2e2bcd8739ae039 = $21e2894ac17af8a9$var$FormControlContext;



var $kmV9n = parcelRequire("kmV9n");

var $9iccj = parcelRequire("9iccj");


var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $4dcce56e381dbe76$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}



function $a9b9bd23855b4a24$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $a9b9bd23855b4a24$var$useEnhancedEffect = typeof window !== "undefined" ? $iluxG.useLayoutEffect : $iluxG.useEffect;
var $a9b9bd23855b4a24$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
var $a9b9bd23855b4a24$var$TextareaAutosize = /*#__PURE__*/ $iluxG.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, _props$rowsMin = props.rowsMin, rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin, style = props.style, value = props.value, other = (0, $anj8u.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "style",
        "value"
    ]);
    var rowsMin = rows || rowsMinProp;
    var _React$useRef = $iluxG.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $iluxG.useRef(null);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $iluxG.useRef(null);
    var renders = $iluxG.useRef(0);
    var _React$useState = $iluxG.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $iluxG.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        var boxSizing = computedStyle["box-sizing"];
        var padding = $a9b9bd23855b4a24$var$getStyleValue(computedStyle, "padding-bottom") + $a9b9bd23855b4a24$var$getStyleValue(computedStyle, "padding-top");
        var border = $a9b9bd23855b4a24$var$getStyleValue(computedStyle, "border-bottom-width") + $a9b9bd23855b4a24$var$getStyleValue(computedStyle, "border-top-width"); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = "x";
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (rowsMin) outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
        if (rowsMax) outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        rowsMax,
        rowsMin,
        props.placeholder
    ]);
    $iluxG.useEffect(function() {
        var handleResize = (0, $4dcce56e381dbe76$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        syncHeight
    ]);
    $a9b9bd23855b4a24$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $iluxG.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, /*#__PURE__*/ $iluxG.createElement("textarea", (0, $7ZPk1.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: rowsMin,
        style: (0, $7ZPk1.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? "hidden" : null
        }, style)
    }, other)), /*#__PURE__*/ $iluxG.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $7ZPk1.default)({}, $a9b9bd23855b4a24$var$styles.shadow, style)
    }));
});
var $a9b9bd23855b4a24$export$2e2bcd8739ae039 = $a9b9bd23855b4a24$var$TextareaAutosize;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $548ba7aaa29a8b7b$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $548ba7aaa29a8b7b$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($548ba7aaa29a8b7b$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $548ba7aaa29a8b7b$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
} // Determine if an Input is adorned on start.
function $548ba7aaa29a8b7b$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}


var $357ef43cd33489b6$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var placeholder = {
        color: "currentColor",
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: "0 !important"
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        "@global": {
            "@keyframes mui-auto-fill": {},
            "@keyframes mui-auto-fill-cancel": {}
        },
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: "1.1876em",
            // Reset (19px), match the native input line-height
            boxSizing: "border-box",
            // Prevent padding issue with fullWidth.
            position: "relative",
            cursor: "text",
            display: "inline-flex",
            alignItems: "center",
            "&$disabled": {
                color: theme.palette.text.disabled,
                cursor: "default"
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            "&$marginDense": {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: "100%"
        },
        /* Styles applied to the `input` element. */ input: {
            font: "inherit",
            letterSpacing: "inherit",
            color: "currentColor",
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: "content-box",
            background: "none",
            height: "1.1876em",
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: "transparent",
            display: "block",
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: "100%",
            // Fix IE 11 width issue
            animationName: "mui-auto-fill-cancel",
            animationDuration: "10ms",
            "&::-webkit-input-placeholder": placeholder,
            "&::-moz-placeholder": placeholder,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholder,
            // IE 11
            "&::-ms-input-placeholder": placeholder,
            // Edge
            "&:focus": {
                outline: 0
            },
            // Reset Firefox invalid required input style
            "&:invalid": {
                boxShadow: "none"
            },
            "&::-webkit-search-decoration": {
                // Remove the padding when type=search.
                "-webkit-appearance": "none"
            },
            // Show and hide the placeholder logic
            "label[data-shrink=false] + $formControl &": {
                "&::-webkit-input-placeholder": placeholderHidden,
                "&::-moz-placeholder": placeholderHidden,
                // Firefox 19+
                "&:-ms-input-placeholder": placeholderHidden,
                // IE 11
                "&::-ms-input-placeholder": placeholderHidden,
                // Edge
                "&:focus::-webkit-input-placeholder": placeholderVisible,
                "&:focus::-moz-placeholder": placeholderVisible,
                // Firefox 19+
                "&:focus:-ms-input-placeholder": placeholderVisible,
                // IE 11
                "&:focus::-ms-input-placeholder": placeholderVisible // Edge
            },
            "&$disabled": {
                opacity: 1 // Reset iOS opacity
            },
            "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: "auto",
            resize: "none",
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            "-moz-appearance": "textfield",
            "-webkit-appearance": "textfield"
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $357ef43cd33489b6$var$useEnhancedEffect = typeof window === "undefined" ? $iluxG.useEffect : $iluxG.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $357ef43cd33489b6$var$InputBase = /*#__PURE__*/ $iluxG.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0, $anj8u.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $iluxG.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $iluxG.useRef();
    var handleInputRefWarning = $iluxG.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $609081843146ef3d$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $609081843146ef3d$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $iluxG.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $21e2894ac17af8a9$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "margin",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $iluxG.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $iluxG.useCallback(function(obj) {
        if ((0, $548ba7aaa29a8b7b$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $357ef43cd33489b6$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7Y3Oe.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $iluxG.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $7ZPk1.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== "string") inputProps = (0, $7ZPk1.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !rowsMax && !rowsMin) InputComponent = "textarea";
        else {
            inputProps = (0, $7ZPk1.default)({
                rows: rows,
                rowsMax: rowsMax
            }, inputProps);
            InputComponent = (0, $a9b9bd23855b4a24$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $7ZPk1.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $iluxG.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $iluxG.createElement("div", (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes["color".concat((0, $9iccj.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $iluxG.createElement((0, $21e2894ac17af8a9$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $iluxG.createElement(InputComponent, (0, $7ZPk1.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $ao43X.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $7ZPk1.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $357ef43cd33489b6$export$2e2bcd8739ae039 = (0, $kmV9n.default)($357ef43cd33489b6$export$9dd6ff9ea0189349, {
    name: "MuiInputBase"
})($357ef43cd33489b6$var$InputBase);



var $kmV9n = parcelRequire("kmV9n");
var $280f7c50c49b73dd$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative"
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            "label + &": {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:not($disabled):before": {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $280f7c50c49b73dd$var$Input = /*#__PURE__*/ $iluxG.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $anj8u.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $357ef43cd33489b6$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        classes: (0, $7ZPk1.default)({}, classes, {
            root: (0, $ao43X.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$280f7c50c49b73dd$var$Input.muiName = "Input";
var $280f7c50c49b73dd$export$2e2bcd8739ae039 = (0, $kmV9n.default)($280f7c50c49b73dd$export$9dd6ff9ea0189349, {
    name: "MuiInput"
})($280f7c50c49b73dd$var$Input);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");



var $kmV9n = parcelRequire("kmV9n");
var $c8df2bb2bfe9221b$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === "light";
    var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            "&:hover": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: backgroundColor
                }
            },
            "&$focused": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
            },
            "&$disabled": {
                backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            "&$underline:after": {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            "&:after": {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            },
            "&$error:after": {
                borderBottomColor: theme.palette.error.main,
                transform: "scaleX(1)" // error is always underlined in red
            },
            "&:before": {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: theme.transitions.create("border-bottom-color", {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: "none" // Transparent to the hover style.
            },
            "&:hover:before": {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            "&$disabled:before": {
                borderBottomStyle: "dotted"
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "27px 12px 10px",
            "&$marginDense": {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "27px 12px 10px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            "&$inputMarginDense": {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $c8df2bb2bfe9221b$var$FilledInput = /*#__PURE__*/ $iluxG.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $anj8u.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $357ef43cd33489b6$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        classes: (0, $7ZPk1.default)({}, classes, {
            root: (0, $ao43X.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$c8df2bb2bfe9221b$var$FilledInput.muiName = "Input";
var $c8df2bb2bfe9221b$export$2e2bcd8739ae039 = (0, $kmV9n.default)($c8df2bb2bfe9221b$export$9dd6ff9ea0189349, {
    name: "MuiFilledInput"
})($c8df2bb2bfe9221b$var$FilledInput);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");



var $8xhwK = parcelRequire("8xhwK");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");


var $9iccj = parcelRequire("9iccj");
var $08d09564871721e8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "absolute",
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: "0 8px",
            pointerEvents: "none",
            borderRadius: "inherit",
            borderStyle: "solid",
            borderWidth: 1,
            overflow: "hidden"
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: "left",
            padding: 0,
            lineHeight: "11px",
            // sync with `height` in `legend` styles
            transition: theme.transitions.create("width", {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: "block",
            width: "auto",
            textAlign: "left",
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: "0.75em",
            visibility: "hidden",
            maxWidth: 0.01,
            transition: theme.transitions.create("max-width", {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            "& > span": {
                paddingLeft: 5,
                paddingRight: 5,
                display: "inline-block"
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create("max-width", {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $08d09564871721e8$var$NotchedOutline = /*#__PURE__*/ $iluxG.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $8c848ed513484619$export$2e2bcd8739ae039)();
    var align = theme.direction === "rtl" ? "right" : "left";
    if (label !== undefined) return /*#__PURE__*/ $iluxG.createElement("fieldset", (0, $7ZPk1.default)({
        "aria-hidden": true,
        className: (0, $ao43X.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $iluxG.createElement("legend", {
        className: (0, $ao43X.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $iluxG.createElement("span", null, label) : /*#__PURE__*/ $iluxG.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $iluxG.createElement("fieldset", (0, $7ZPk1.default)({
        "aria-hidden": true,
        style: (0, $7ZPk1.default)((0, $8xhwK.default)({}, "padding".concat((0, $9iccj.default)(align)), 8), style),
        className: (0, $ao43X.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $iluxG.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $iluxG.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    })));
});
var $08d09564871721e8$export$2e2bcd8739ae039 = (0, $kmV9n.default)($08d09564871721e8$export$9dd6ff9ea0189349, {
    name: "PrivateNotchedOutline"
})($08d09564871721e8$var$NotchedOutline);



var $kmV9n = parcelRequire("kmV9n");
var $f363f0c6d88684c0$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        /* Styles applied to the root element. */ root: {
            position: "relative",
            borderRadius: theme.shape.borderRadius,
            "&:hover $notchedOutline": {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                "&:hover $notchedOutline": {
                    borderColor: borderColor
                }
            },
            "&$focused $notchedOutline": {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            "&$error $notchedOutline": {
                borderColor: theme.palette.error.main
            },
            "&$disabled $notchedOutline": {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused $notchedOutline": {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "18.5px 14px",
            "&$marginDense": {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: "18.5px 14px",
            "&:-webkit-autofill": {
                WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
                caretColor: theme.palette.type === "light" ? null : "#fff",
                borderRadius: "inherit"
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $f363f0c6d88684c0$var$OutlinedInput = /*#__PURE__*/ $iluxG.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0, $anj8u.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $357ef43cd33489b6$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $iluxG.createElement((0, $08d09564871721e8$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $7ZPk1.default)({}, classes, {
            root: (0, $ao43X.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$f363f0c6d88684c0$var$OutlinedInput.muiName = "Input";
var $f363f0c6d88684c0$export$2e2bcd8739ae039 = (0, $kmV9n.default)($f363f0c6d88684c0$export$9dd6ff9ea0189349, {
    name: "MuiOutlinedInput"
})($f363f0c6d88684c0$var$OutlinedInput);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $iluxG = parcelRequire("iluxG");

function $d43abb9b45e8d4e3$export$2e2bcd8739ae039() {
    return $iluxG.useContext((0, $21e2894ac17af8a9$export$2e2bcd8739ae039));
}



var $kmV9n = parcelRequire("kmV9n");

var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");



var $9iccj = parcelRequire("9iccj");

var $kmV9n = parcelRequire("kmV9n");
var $b4c49e723e866fde$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            "&$focused": {
                color: theme.palette.primary.main
            },
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            "&$focused": {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            "&$error": {
                color: theme.palette.error.main
            }
        }
    };
};
var $b4c49e723e866fde$var$FormLabel = /*#__PURE__*/ $iluxG.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $d43abb9b45e8d4e3$export$2e2bcd8739ae039)();
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes["color".concat((0, $9iccj.default)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $iluxG.createElement("span", {
        "aria-hidden": true,
        className: (0, $ao43X.default)(classes.asterisk, fcs.error && classes.error)
    }, " ", "*"));
});
var $b4c49e723e866fde$export$2e2bcd8739ae039 = (0, $kmV9n.default)($b4c49e723e866fde$export$9dd6ff9ea0189349, {
    name: "MuiFormLabel"
})($b4c49e723e866fde$var$FormLabel);


var $0c4a9226448d172b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "block",
            transformOrigin: "top left"
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: "absolute",
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: "translate(0, 24px) scale(1)"
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: "translate(0, 21px) scale(1)"
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: "translate(0, 1.5px) scale(0.75)",
            transformOrigin: "top left"
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                "color",
                "transform"
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(12px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(12px, 17px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(12px, 10px) scale(0.75)",
                "&$marginDense": {
                    transform: "translate(12px, 7px) scale(0.75)"
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: "none",
            transform: "translate(14px, 20px) scale(1)",
            "&$marginDense": {
                transform: "translate(14px, 12px) scale(1)"
            },
            "&$shrink": {
                transform: "translate(14px, -6px) scale(0.75)"
            }
        }
    };
};
var $0c4a9226448d172b$var$InputLabel = /*#__PURE__*/ $iluxG.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $d43abb9b45e8d4e3$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "margin",
            "variant"
        ]
    });
    return /*#__PURE__*/ $iluxG.createElement((0, $b4c49e723e866fde$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        "data-shrink": shrink,
        className: (0, $ao43X.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
            "filled": classes.filled,
            "outlined": classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $0c4a9226448d172b$export$2e2bcd8739ae039 = (0, $kmV9n.default)($0c4a9226448d172b$export$9dd6ff9ea0189349, {
    name: "MuiInputLabel"
})($0c4a9226448d172b$var$InputLabel);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");

var $9iccj = parcelRequire("9iccj");

var $iluxG = parcelRequire("iluxG");
function $fcd01b7803bb1990$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $iluxG.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}



var $47dc32fe13c44ce9$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top" // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: "100%"
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $47dc32fe13c44ce9$var$FormControl = /*#__PURE__*/ $iluxG.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $iluxG.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $iluxG.Children.forEach(children, function(child) {
            if (!(0, $fcd01b7803bb1990$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            var input = (0, $fcd01b7803bb1990$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $548ba7aaa29a8b7b$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $iluxG.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $iluxG.Children.forEach(children, function(child) {
            if (!(0, $fcd01b7803bb1990$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $548ba7aaa29a8b7b$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $iluxG.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $iluxG.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $iluxG.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === "small" ? "dense" : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $iluxG.createElement((0, $21e2894ac17af8a9$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, margin !== "none" && classes["margin".concat((0, $9iccj.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $47dc32fe13c44ce9$export$2e2bcd8739ae039 = (0, $kmV9n.default)($47dc32fe13c44ce9$export$9dd6ff9ea0189349, {
    name: "MuiFormControl"
})($47dc32fe13c44ce9$var$FormControl);



var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");



var $kmV9n = parcelRequire("kmV9n");
var $2c260ad2ed261945$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: "left",
            marginTop: 3,
            margin: 0,
            "&$disabled": {
                color: theme.palette.text.disabled
            },
            "&$error": {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $2c260ad2ed261945$var$FormHelperText = /*#__PURE__*/ $iluxG.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $d43abb9b45e8d4e3$export$2e2bcd8739ae039)();
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "margin",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
        ref: ref
    }, other), children === " " ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $iluxG.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : children);
});
var $2c260ad2ed261945$export$2e2bcd8739ae039 = (0, $kmV9n.default)($2c260ad2ed261945$export$9dd6ff9ea0189349, {
    name: "MuiFormHelperText"
})($2c260ad2ed261945$var$FormHelperText);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $jNHyY = parcelRequire("jNHyY");

var $7ZPk1 = parcelRequire("7ZPk1");

var $1s4Pi = parcelRequire("1s4Pi");

var $anj8u = parcelRequire("anj8u");

var $2dcCx = parcelRequire("2dcCx");

var $7Y3Oe = parcelRequire("7Y3Oe");

var $iluxG = parcelRequire("iluxG");
parcelRequire("ebf3Z");


var $ao43X = parcelRequire("ao43X");
function $5ea799cebb9a96c8$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $9iccj = parcelRequire("9iccj");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");
parcelRequire("ebf3Z");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");





var $ao43X = parcelRequire("ao43X");


function $e0657fbe919ca022$export$2e2bcd8739ae039(node) {
    var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $914f752a494eea99$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}



var $kmV9n = parcelRequire("kmV9n");

var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");



var $aCszJ = parcelRequire("aCszJ");
var $cbfOl = parcelRequire("cbfOl");



var $iluxG = parcelRequire("iluxG");





function $f3cfb7f3832c3b64$var$getContainer(container) {
    container = typeof container === "function" ? container() : container; // #StrictMode ready
    return $9146dba4fa405fbb$exports.findDOMNode(container);
}
var $f3cfb7f3832c3b64$var$useEnhancedEffect = typeof window !== "undefined" ? $iluxG.useLayoutEffect : $iluxG.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $f3cfb7f3832c3b64$var$Portal = /*#__PURE__*/ $iluxG.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $iluxG.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(/*#__PURE__*/ $iluxG.isValidElement(children) ? children.ref : null, ref);
    $f3cfb7f3832c3b64$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($f3cfb7f3832c3b64$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $f3cfb7f3832c3b64$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $ab21da758cd74461$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $ab21da758cd74461$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $f3cfb7f3832c3b64$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $iluxG.isValidElement(children)) return /*#__PURE__*/ $iluxG.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $9146dba4fa405fbb$exports.createPortal(children, mountNode) : mountNode;
});
var $f3cfb7f3832c3b64$export$2e2bcd8739ae039 = $f3cfb7f3832c3b64$var$Portal;






var $il614 = parcelRequire("il614");
function $1d782f3b0254ba40$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $bC7Ef = parcelRequire("bC7Ef");

var $8LAGA = parcelRequire("8LAGA");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $b665d0371a5deb4e$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.width = "99px";
    scrollDiv.style.height = "99px";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $d0317ac920624933$var$isOverflowing(container) {
    var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $e0657fbe919ca022$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $d0317ac920624933$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute("aria-hidden", "true");
    else node.removeAttribute("aria-hidden");
}
function $d0317ac920624933$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function $d0317ac920624933$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $8LAGA.default)(nodesToExclude));
    var blacklistTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE"
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $d0317ac920624933$export$e1bd0c6150f13d96(node, show);
    });
}
function $d0317ac920624933$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $d0317ac920624933$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($d0317ac920624933$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $b665d0371a5deb4e$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: "padding-right",
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style["padding-right"] = "".concat($d0317ac920624933$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($d0317ac920624933$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: "overflow",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty("padding-right");
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $d0317ac920624933$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute("aria-hidden") === "true") hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $d0317ac920624933$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $1d782f3b0254ba40$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $bC7Ef.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $d0317ac920624933$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $d0317ac920624933$var$getHiddenSiblings(container);
                $d0317ac920624933$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $d0317ac920624933$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $d0317ac920624933$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $d0317ac920624933$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $d0317ac920624933$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $d0317ac920624933$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $d0317ac920624933$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $d0317ac920624933$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $iluxG = parcelRequire("iluxG");





/**
 * Utility component that locks focus inside the component.
 */ function $8de5389a6aa90dd1$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $iluxG.useRef();
    var sentinelStart = $iluxG.useRef(null);
    var sentinelEnd = $iluxG.useRef(null);
    var nodeToRestore = $iluxG.useRef();
    var rootRef = $iluxG.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $iluxG.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $iluxG.useRef();
    $iluxG.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== "undefined") // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $iluxG.useEffect(function() {
        if (!open) return;
        var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener("focus", contain, true);
        doc.addEventListener("keydown", loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener("focus", contain, true);
            doc.removeEventListener("keydown", loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, /*#__PURE__*/ $iluxG.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $iluxG.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $iluxG.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $8de5389a6aa90dd1$export$2e2bcd8739ae039 = $8de5389a6aa90dd1$var$Unstable_TrapFocus;



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");

var $68a8e18fd0e1a598$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: "fixed",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: "transparent"
    }
};
/**
 * @ignore - internal component.
 */ var $68a8e18fd0e1a598$var$SimpleBackdrop = /*#__PURE__*/ $iluxG.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $anj8u.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $iluxG.createElement("div", (0, $7ZPk1.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $7ZPk1.default)({}, $68a8e18fd0e1a598$export$9dd6ff9ea0189349.root, invisible ? $68a8e18fd0e1a598$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $68a8e18fd0e1a598$export$2e2bcd8739ae039 = $68a8e18fd0e1a598$var$SimpleBackdrop;


function $6be1e27626e593fd$var$getContainer(container) {
    container = typeof container === "function" ? container() : container;
    return $9146dba4fa405fbb$exports.findDOMNode(container);
}
function $6be1e27626e593fd$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty("in") : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $6be1e27626e593fd$var$defaultManager = new (0, $d0317ac920624933$export$2e2bcd8739ae039)();
var $6be1e27626e593fd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: "fixed",
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: "hidden"
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $6be1e27626e593fd$var$Modal = /*#__PURE__*/ $iluxG.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $cbfOl.default)();
    var props = (0, $aCszJ.default)({
        name: "MuiModal",
        props: (0, $7ZPk1.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $68a8e18fd0e1a598$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $6be1e27626e593fd$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $anj8u.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $iluxG.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $iluxG.useRef({});
    var mountNodeRef = $iluxG.useRef(null);
    var modalRef = $iluxG.useRef(null);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $6be1e27626e593fd$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $6be1e27626e593fd$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $iluxG.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $d0317ac920624933$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $iluxG.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $iluxG.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $iluxG.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, "backdropClick");
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    var inlineStyle = $6be1e27626e593fd$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $il614.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || "-1";
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $914f752a494eea99$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $914f752a494eea99$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $iluxG.createElement((0, $f3cfb7f3832c3b64$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $iluxG.createElement("div", (0, $7ZPk1.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $7ZPk1.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $iluxG.createElement(BackdropComponent, (0, $7ZPk1.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $iluxG.createElement((0, $8de5389a6aa90dd1$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $iluxG.cloneElement(children, childProps))));
});
var $6be1e27626e593fd$export$2e2bcd8739ae039 = $6be1e27626e593fd$var$Modal;



var $7ZPk1 = parcelRequire("7ZPk1");

var $1s4Pi = parcelRequire("1s4Pi");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $eVoFv = parcelRequire("eVoFv");

var $b2hvp = parcelRequire("b2hvp");


var $iluxG = parcelRequire("iluxG");

var $cfd5f63edc7dcdfc$export$2e2bcd8739ae039 = {
    disabled: false
};




var $53fb4a4dde39c2b8$export$bb38bb9a1161268 = "unmounted";
var $53fb4a4dde39c2b8$export$84cbff306f539230 = "exited";
var $53fb4a4dde39c2b8$export$df38205c966be359 = "entering";
var $53fb4a4dde39c2b8$export$78e9e6e3e014d60a = "entered";
var $53fb4a4dde39c2b8$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $53fb4a4dde39c2b8$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $b2hvp.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $53fb4a4dde39c2b8$export$84cbff306f539230;
                _this.appearStatus = $53fb4a4dde39c2b8$export$df38205c966be359;
            } else initialStatus = $53fb4a4dde39c2b8$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $53fb4a4dde39c2b8$export$bb38bb9a1161268;
        else initialStatus = $53fb4a4dde39c2b8$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $53fb4a4dde39c2b8$export$bb38bb9a1161268) return {
            status: $53fb4a4dde39c2b8$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $53fb4a4dde39c2b8$export$df38205c966be359 && status !== $53fb4a4dde39c2b8$export$78e9e6e3e014d60a) nextStatus = $53fb4a4dde39c2b8$export$df38205c966be359;
            } else if (status === $53fb4a4dde39c2b8$export$df38205c966be359 || status === $53fb4a4dde39c2b8$export$78e9e6e3e014d60a) nextStatus = $53fb4a4dde39c2b8$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $53fb4a4dde39c2b8$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $53fb4a4dde39c2b8$export$84cbff306f539230) this.setState({
            status: $53fb4a4dde39c2b8$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9146dba4fa405fbb$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $cfd5f63edc7dcdfc$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $53fb4a4dde39c2b8$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $53fb4a4dde39c2b8$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $53fb4a4dde39c2b8$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9146dba4fa405fbb$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $cfd5f63edc7dcdfc$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $53fb4a4dde39c2b8$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $53fb4a4dde39c2b8$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $53fb4a4dde39c2b8$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9146dba4fa405fbb$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $53fb4a4dde39c2b8$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $eVoFv.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $dbef8e2db4f9b84b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Component);
$53fb4a4dde39c2b8$var$Transition.contextType = (0, $dbef8e2db4f9b84b$export$2e2bcd8739ae039);
$53fb4a4dde39c2b8$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $53fb4a4dde39c2b8$var$noop() {}
$53fb4a4dde39c2b8$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $53fb4a4dde39c2b8$var$noop,
    onEntering: $53fb4a4dde39c2b8$var$noop,
    onEntered: $53fb4a4dde39c2b8$var$noop,
    onExit: $53fb4a4dde39c2b8$var$noop,
    onExiting: $53fb4a4dde39c2b8$var$noop,
    onExited: $53fb4a4dde39c2b8$var$noop
};
$53fb4a4dde39c2b8$var$Transition.UNMOUNTED = $53fb4a4dde39c2b8$export$bb38bb9a1161268;
$53fb4a4dde39c2b8$var$Transition.EXITED = $53fb4a4dde39c2b8$export$84cbff306f539230;
$53fb4a4dde39c2b8$var$Transition.ENTERING = $53fb4a4dde39c2b8$export$df38205c966be359;
$53fb4a4dde39c2b8$var$Transition.ENTERED = $53fb4a4dde39c2b8$export$78e9e6e3e014d60a;
$53fb4a4dde39c2b8$var$Transition.EXITING = $53fb4a4dde39c2b8$export$4aacc83d4d59139f;
var $53fb4a4dde39c2b8$export$2e2bcd8739ae039 = $53fb4a4dde39c2b8$var$Transition;



var $9ddf0162e19e0509$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $9ddf0162e19e0509$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $9dba273e33214bcc$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $9dba273e33214bcc$var$styles = {
    entering: {
        opacity: 1,
        transform: $9dba273e33214bcc$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $9dba273e33214bcc$var$Grow = /*#__PURE__*/ $iluxG.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $53fb4a4dde39c2b8$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $anj8u.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $iluxG.useRef();
    var autoTimeout = $iluxG.useRef();
    var theme = (0, $8c848ed513484619$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $iluxG.useRef(null);
    var foreignRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $1s4Pi.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $9ddf0162e19e0509$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $9ddf0162e19e0509$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $9ddf0162e19e0509$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(",");
        node.style.opacity = "0";
        node.style.transform = $9dba273e33214bcc$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $iluxG.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $iluxG.createElement(TransitionComponent, (0, $7ZPk1.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $iluxG.cloneElement(children, (0, $7ZPk1.default)({
            style: (0, $7ZPk1.default)({
                opacity: 0,
                transform: $9dba273e33214bcc$var$getScale(0.75),
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, $9dba273e33214bcc$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$9dba273e33214bcc$var$Grow.muiSupportAuto = true;
var $9dba273e33214bcc$export$2e2bcd8739ae039 = $9dba273e33214bcc$var$Grow;



var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");
var $aed7b6706a074dc5$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $7ZPk1.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create("box-shadow")
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $aed7b6706a074dc5$var$Paper = /*#__PURE__*/ $iluxG.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $aed7b6706a074dc5$export$2e2bcd8739ae039 = (0, $kmV9n.default)($aed7b6706a074dc5$export$9dd6ff9ea0189349, {
    name: "MuiPaper"
})($aed7b6706a074dc5$var$Paper);


function $304abd703bbe2c5b$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $304abd703bbe2c5b$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $304abd703bbe2c5b$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === "number" ? "".concat(n, "px") : n;
    }).join(" ");
} // Sum the scrollTop between two elements.
function $304abd703bbe2c5b$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $304abd703bbe2c5b$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var $304abd703bbe2c5b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: "absolute",
        overflowY: "auto",
        overflowX: "hidden",
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: "calc(100% - 32px)",
        maxHeight: "calc(100% - 32px)",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $304abd703bbe2c5b$var$Popover = /*#__PURE__*/ $iluxG.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: "top",
        horizontal: "left"
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $9dba273e33214bcc$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $anj8u.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $iluxG.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $iluxG.useCallback(function(contentAnchorOffset) {
        if (anchorReference === "anchorPosition") return anchorPosition;
        var resolvedAnchorEl = $304abd703bbe2c5b$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
        return {
            top: anchorRect.top + $304abd703bbe2c5b$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $304abd703bbe2c5b$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $iluxG.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === "anchorEl") {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $304abd703bbe2c5b$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $iluxG.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $304abd703bbe2c5b$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $304abd703bbe2c5b$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $iluxG.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $304abd703bbe2c5b$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $e0657fbe919ca022$export$2e2bcd8739ae039)($304abd703bbe2c5b$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $304abd703bbe2c5b$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $iluxG.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $iluxG.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
    }, []);
    $iluxG.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $iluxG.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $iluxG.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $4dcce56e381dbe76$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)($304abd703bbe2c5b$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $iluxG.createElement((0, $6be1e27626e593fd$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $ao43X.default)(classes.root, className)
    }, other), /*#__PURE__*/ $iluxG.createElement(TransitionComponent, (0, $7ZPk1.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $914f752a494eea99$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $iluxG.createElement((0, $aed7b6706a074dc5$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $ao43X.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $304abd703bbe2c5b$export$2e2bcd8739ae039 = (0, $kmV9n.default)($304abd703bbe2c5b$export$9dd6ff9ea0189349, {
    name: "MuiPopover"
})($304abd703bbe2c5b$var$Popover);



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");
parcelRequire("ebf3Z");




var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $iluxG = parcelRequire("iluxG");
/**
 * @ignore - internal component.
 */ var $38ab387ec0f9953f$var$ListContext = /*#__PURE__*/ $iluxG.createContext({});
var $38ab387ec0f9953f$export$2e2bcd8739ae039 = $38ab387ec0f9953f$var$ListContext;


var $9d632243177afe7a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $9d632243177afe7a$var$List = /*#__PURE__*/ $iluxG.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $iluxG.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $38ab387ec0f9953f$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $9d632243177afe7a$export$2e2bcd8739ae039 = (0, $kmV9n.default)($9d632243177afe7a$export$9dd6ff9ea0189349, {
    name: "MuiList"
})($9d632243177afe7a$var$List);




function $4128baca8b2c95bf$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $4128baca8b2c95bf$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $4128baca8b2c95bf$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $4128baca8b2c95bf$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$4128baca8b2c95bf$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $4128baca8b2c95bf$var$useEnhancedEffect = typeof window === "undefined" ? $iluxG.useEffect : $iluxG.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $4128baca8b2c95bf$var$MenuList = /*#__PURE__*/ $iluxG.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $anj8u.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $iluxG.useRef(null);
    var textCriteriaRef = $iluxG.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $4128baca8b2c95bf$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $iluxG.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $b665d0371a5deb4e$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $4128baca8b2c95bf$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4128baca8b2c95bf$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $4128baca8b2c95bf$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $4128baca8b2c95bf$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $4128baca8b2c95bf$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4128baca8b2c95bf$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $4128baca8b2c95bf$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $4128baca8b2c95bf$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $4128baca8b2c95bf$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $4128baca8b2c95bf$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $4128baca8b2c95bf$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $iluxG.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $iluxG.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $iluxG.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $iluxG.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $iluxG.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $iluxG.createElement((0, $9d632243177afe7a$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $4128baca8b2c95bf$export$2e2bcd8739ae039 = $4128baca8b2c95bf$var$MenuList;





var $259f081ccf1f0968$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
var $259f081ccf1f0968$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
var $259f081ccf1f0968$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: "calc(100% - 96px)",
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: "touch"
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $259f081ccf1f0968$var$Menu = /*#__PURE__*/ $iluxG.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEntering = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0, $anj8u.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "variant"
    ]);
    var theme = (0, $8c848ed513484619$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $iluxG.useRef(null);
    var contentAnchorRef = $iluxG.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $iluxG.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $iluxG.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $iluxG.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $iluxG.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
                (0, $ab21da758cd74461$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $iluxG.createElement((0, $304abd703bbe2c5b$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        onEntering: handleEntering,
        anchorOrigin: theme.direction === "rtl" ? $259f081ccf1f0968$var$RTL_ORIGIN : $259f081ccf1f0968$var$LTR_ORIGIN,
        transformOrigin: theme.direction === "rtl" ? $259f081ccf1f0968$var$RTL_ORIGIN : $259f081ccf1f0968$var$LTR_ORIGIN,
        PaperProps: (0, $7ZPk1.default)({}, PaperProps, {
            classes: (0, $7ZPk1.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $iluxG.createElement((0, $4128baca8b2c95bf$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $ao43X.default)(classes.list, MenuListProps.className)
    }), items));
});
var $259f081ccf1f0968$export$2e2bcd8739ae039 = (0, $kmV9n.default)($259f081ccf1f0968$export$9dd6ff9ea0189349, {
    name: "MuiMenu"
})($259f081ccf1f0968$var$Menu);




/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $iluxG = parcelRequire("iluxG");
function $98fac3b7e03226d4$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
    var _React$useRef = $iluxG.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $iluxG.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $iluxG.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


function $74b796bc091854f1$var$areEqualValues(a, b) {
    if ((0, $2dcCx.default)(b) === "object" && b !== null) return a === b;
    return String(a) === String(b);
}
function $74b796bc091854f1$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $74b796bc091854f1$var$SelectInput = /*#__PURE__*/ $iluxG.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $anj8u.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $98fac3b7e03226d4$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    }), _useControlled2 = (0, $1s4Pi.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $iluxG.useRef(null);
    var _React$useState = $iluxG.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $iluxG.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $iluxG.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $iluxG.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(ref, inputRefProp);
    $iluxG.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $iluxG.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $iluxG.useEffect(function() {
        if (displayNode) {
            var label = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener("click", handler);
                return function() {
                    label.removeEventListener("click", handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $iluxG.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, "target", {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $548ba7aaa29a8b7b$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $iluxG.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7Y3Oe.default)(2));
            selected = value.some(function(v) {
                return $74b796bc091854f1$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $74b796bc091854f1$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $iluxG.cloneElement(child, {
            "aria-selected": selected ? "true" : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(", ") : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, /*#__PURE__*/ $iluxG.createElement("div", (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? "true" : undefined,
        "aria-expanded": open ? "true" : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(" ") || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $74b796bc091854f1$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $iluxG.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: "&#8203;"
        }
    }) : display), /*#__PURE__*/ $iluxG.createElement("input", (0, $7ZPk1.default)({
        value: Array.isArray(value) ? value.join(",") : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $iluxG.createElement(IconComponent, {
        className: (0, $ao43X.default)(classes.icon, classes["icon".concat((0, $9iccj.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $iluxG.createElement((0, $259f081ccf1f0968$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        id: "menu-".concat(name || ""),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $7ZPk1.default)({
            "aria-labelledby": labelId,
            role: "listbox",
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $7ZPk1.default)({}, MenuProps.PaperProps, {
            style: (0, $7ZPk1.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $74b796bc091854f1$export$2e2bcd8739ae039 = $74b796bc091854f1$var$SelectInput;





var $kmV9n = parcelRequire("kmV9n");

var $iluxG = parcelRequire("iluxG");

var /**
 * @ignore - internal component.
 */ $9f4d32beb3ddf8b2$export$2e2bcd8739ae039 = (0, $0104f75483b2827c$export$2e2bcd8739ae039)(/*#__PURE__*/ $iluxG.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");




var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $9iccj = parcelRequire("9iccj");
/**
 * @ignore - internal component.
 */ var $f603d098b29744b4$var$NativeSelectInput = /*#__PURE__*/ $iluxG.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, /*#__PURE__*/ $iluxG.createElement("select", (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $iluxG.createElement(IconComponent, {
        className: (0, $ao43X.default)(classes.icon, classes["icon".concat((0, $9iccj.default)(variant))], disabled && classes.disabled)
    }));
});
var $f603d098b29744b4$export$2e2bcd8739ae039 = $f603d098b29744b4$var$NativeSelectInput;



var $kmV9n = parcelRequire("kmV9n");




var $baf6d33d31de383b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            "-moz-appearance": "none",
            // Reset
            "-webkit-appearance": "none",
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: "none",
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: "pointer",
            "&:focus": {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            "&::-ms-expand": {
                display: "none"
            },
            "&$disabled": {
                cursor: "default"
            },
            "&[multiple]": {
                height: "auto"
            },
            "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: theme.palette.background.paper
            },
            "&&": {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            "&&": {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: "auto",
            // Resets for multpile select with chips
            minHeight: "1.1876em",
            // Required for select\text-field height consistency
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: "absolute",
            right: 0,
            top: "calc(50% - 12px)",
            // Center vertically
            pointerEvents: "none",
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            "&$disabled": {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: "rotate(180deg)"
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: "100%"
        }
    };
};
var $baf6d33d31de383b$var$defaultInput = /*#__PURE__*/ $iluxG.createElement((0, $280f7c50c49b73dd$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $baf6d33d31de383b$var$NativeSelect = /*#__PURE__*/ $iluxG.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $9f4d32beb3ddf8b2$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $baf6d33d31de383b$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $d43abb9b45e8d4e3$export$2e2bcd8739ae039)();
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    return /*#__PURE__*/ $iluxG.cloneElement(input, (0, $7ZPk1.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $f603d098b29744b4$export$2e2bcd8739ae039),
        inputProps: (0, $7ZPk1.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$baf6d33d31de383b$var$NativeSelect.muiName = "Select";
var $baf6d33d31de383b$export$2e2bcd8739ae039 = (0, $kmV9n.default)($baf6d33d31de383b$export$9dd6ff9ea0189349, {
    name: "MuiNativeSelect"
})($baf6d33d31de383b$var$NativeSelect);





var $297a49f35af5a8fe$export$9dd6ff9ea0189349 = (0, $baf6d33d31de383b$export$9dd6ff9ea0189349);
var $297a49f35af5a8fe$var$_ref = /*#__PURE__*/ $iluxG.createElement((0, $280f7c50c49b73dd$export$2e2bcd8739ae039), null);
var $297a49f35af5a8fe$var$_ref2 = /*#__PURE__*/ $iluxG.createElement((0, $c8df2bb2bfe9221b$export$2e2bcd8739ae039), null);
var $297a49f35af5a8fe$var$Select = /*#__PURE__*/ $iluxG.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $9f4d32beb3ddf8b2$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $anj8u.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $f603d098b29744b4$export$2e2bcd8739ae039) : (0, $74b796bc091854f1$export$2e2bcd8739ae039);
    var muiFormControl = (0, $d43abb9b45e8d4e3$export$2e2bcd8739ae039)();
    var fcs = (0, $53310f753aadf6a3$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant"
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $297a49f35af5a8fe$var$_ref,
        outlined: /*#__PURE__*/ $iluxG.createElement((0, $f363f0c6d88684c0$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $297a49f35af5a8fe$var$_ref2
    })[variant];
    return /*#__PURE__*/ $iluxG.cloneElement(InputComponent, (0, $7ZPk1.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $7ZPk1.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $7ZPk1.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $jNHyY.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$297a49f35af5a8fe$var$Select.muiName = "Select";
var $297a49f35af5a8fe$export$2e2bcd8739ae039 = (0, $kmV9n.default)($297a49f35af5a8fe$export$9dd6ff9ea0189349, {
    name: "MuiSelect"
})($297a49f35af5a8fe$var$Select);



var $kmV9n = parcelRequire("kmV9n");
var $6ffc785cceff7e40$var$variantComponent = {
    standard: (0, $280f7c50c49b73dd$export$2e2bcd8739ae039),
    filled: (0, $c8df2bb2bfe9221b$export$2e2bcd8739ae039),
    outlined: (0, $f363f0c6d88684c0$export$2e2bcd8739ae039)
};
var $6ffc785cceff7e40$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $6ffc785cceff7e40$var$TextField = /*#__PURE__*/ $iluxG.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0, $anj8u.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, label, displayRequired && "\xa0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $6ffc785cceff7e40$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $iluxG.createElement(InputComponent, (0, $7ZPk1.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $iluxG.createElement((0, $47dc32fe13c44ce9$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $iluxG.createElement((0, $0c4a9226448d172b$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $iluxG.createElement((0, $297a49f35af5a8fe$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $iluxG.createElement((0, $2c260ad2ed261945$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $6ffc785cceff7e40$export$2e2bcd8739ae039 = (0, $kmV9n.default)($6ffc785cceff7e40$export$9dd6ff9ea0189349, {
    name: "MuiTextField"
})($6ffc785cceff7e40$var$TextField);




var $anj8u = parcelRequire("anj8u");

var $8xhwK = parcelRequire("8xhwK");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");





var $854a25b1bb400c71$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            textDecoration: "none",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "left",
            paddingTop: 8,
            paddingBottom: 8,
            "&$focusVisible": {
                backgroundColor: theme.palette.action.selected
            },
            "&$selected, &$selected:hover": {
                backgroundColor: theme.palette.action.selected
            },
            "&$disabled": {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: "relative"
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: "flex-start"
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: "padding-box"
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create("background-color", {
                duration: theme.transitions.duration.shortest
            }),
            "&:hover": {
                textDecoration: "none",
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $854a25b1bb400c71$var$useEnhancedEffect = typeof window === "undefined" ? $iluxG.useEffect : $iluxG.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $854a25b1bb400c71$var$ListItem = /*#__PURE__*/ $iluxG.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $anj8u.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $anj8u.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $iluxG.useContext((0, $38ab387ec0f9953f$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $iluxG.useRef(null);
    $854a25b1bb400c71$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $iluxG.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $fcd01b7803bb1990$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    var handleOwnRef = $iluxG.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $ao43X.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $1d7527e68bc34418$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component; // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ $iluxG.createElement((0, $38ab387ec0f9953f$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $iluxG.createElement(ContainerComponent, (0, $7ZPk1.default)({
            className: (0, $ao43X.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $iluxG.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $iluxG.createElement((0, $38ab387ec0f9953f$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        ref: handleRef
    }, componentProps), children));
});
var $854a25b1bb400c71$export$2e2bcd8739ae039 = (0, $kmV9n.default)($854a25b1bb400c71$export$9dd6ff9ea0189349, {
    name: "MuiListItem"
})($854a25b1bb400c71$var$ListItem);


var $5938ef59e716eb83$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({}, theme.typography.body1, (0, $8xhwK.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: "border-box",
            width: "auto",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }, theme.breakpoints.up("sm"), {
            minHeight: "auto"
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $7ZPk1.default)({}, theme.typography.body2, {
            minHeight: "auto"
        })
    };
};
var $5938ef59e716eb83$var$MenuItem = /*#__PURE__*/ $iluxG.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $iluxG.createElement((0, $854a25b1bb400c71$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $7ZPk1.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $ao43X.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $5938ef59e716eb83$export$2e2bcd8739ae039 = (0, $kmV9n.default)($5938ef59e716eb83$export$9dd6ff9ea0189349, {
    name: "MuiMenuItem"
})($5938ef59e716eb83$var$MenuItem);


var $daaeca3227173a2d$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($daaeca3227173a2d$exports, "__esModule", {
    value: true
});
$daaeca3227173a2d$exports.default = void 0;

var $daaeca3227173a2d$var$_react = $h59lg((parcelRequire("iluxG")));

var $daaeca3227173a2d$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $daaeca3227173a2d$var$_default = (0, $daaeca3227173a2d$var$_createSvgIcon.default)($daaeca3227173a2d$var$_react.default.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), "ArrowBack");
$daaeca3227173a2d$exports.default = $daaeca3227173a2d$var$_default;


const $8108230355f26483$var$doGet = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, raw: raw })=>{
    return $8108230355f26483$var$doFetch({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path,
        method: "GET",
        raw: raw
    });
};
const $8108230355f26483$export$872f4f09fb3b16a3 = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, body: body, raw: raw })=>{
    return $8108230355f26483$var$doFetch({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path,
        method: "POST",
        body: body,
        raw: raw
    });
};
const $8108230355f26483$var$doFetch = ({ chatServiceUrl: chatServiceUrl, token: token, path: path, method: method, body: body, raw: raw })=>{
    return fetch(`https://${chatServiceUrl}${path}`, {
        method: method,
        headers: {
            "Content-Type": "application/vnd.api+json",
            Authorization: `Bearer ${token}`,
            Pragma: "no-cache"
        },
        body: JSON.stringify(body)
    }).then((response)=>{
        if (raw) return response;
        return response.json();
    });
};
const $8108230355f26483$export$6efe264be9505de7 = (command, params)=>{
    window.parent.postMessage({
        command: command,
        params: params
    }, "*");
};
const $8108230355f26483$var$sendEvent = ({ conversationID: conversationID, event_attributes: event_attributes, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        path: `/conversations/${conversationID}/events`,
        token: token,
        chatServiceUrl: chatServiceUrl,
        body: {
            data: {
                type: "conversation_events",
                attributes: event_attributes
            }
        }
    });
};
const $8108230355f26483$export$a2ff1144002a6147 = ({ conversationID: conversationID, chatServiceUrl: chatServiceUrl, token: token })=>{
    return $8108230355f26483$var$doGet({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: `/conversations/${conversationID}?include=participants,tags`
    });
};
const $8108230355f26483$export$bade1af6f5e96e0c = ({ token: token, chatServiceUrl: chatServiceUrl, searchText: searchText, sortOrder: sortOrder, searchFilter: searchFilter, page: page, pageSize: pageSize, searchType: searchType })=>{
    const path = "/conversations?";
    const params = new URLSearchParams();
    if (searchText) params.set("filter[search]", searchText);
    if (searchType) params.set("filter[search_type]", searchType);
    switch(searchFilter){
        case "mine_open":
            params.set("filter[status]", "open");
            params.set("filter[participants]", "mine");
            break;
        case "mine":
            params.set("filter[participants]", "mine");
            break;
        case "all_open":
            params.set("filter[status]", "open");
            params.set("filter[participants]", "all");
            break;
        case "all":
            params.set("filter[participants]", "all");
            params.set("filter[status]", "not_prompt");
            break;
        case "unclaimed":
            params.set("filter[participants]", "unclaimed");
            params.set("filter[status]", "not_prompt");
            break;
        case "my_notes":
            params.set("filter[notes]", "mine");
            params.set("filter[participants]", "mine");
            break;
        case "my_unresolved_notes":
            params.set("filter[notes]", "unresolved");
            params.set("filter[participants]", "mine");
            break;
    }
    params.set("sort_order", sortOrder);
    params.set("include", "read_receipt");
    if (page && pageSize) {
        params.set("page[number]", page);
        params.set("page[size]", pageSize);
    }
    return $8108230355f26483$var$doGet({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: path + params.toString()
    });
};
const $8108230355f26483$export$26dce2c43b43b8bd = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$var$doGet({
        path: `/conversations/${conversationID}/events`,
        chatServiceUrl: chatServiceUrl,
        token: token
    });
};
const $8108230355f26483$export$c7ff47b8a892cacd = ({ first_message: first_message, prompt: prompt, chatServiceUrl: chatServiceUrl, token: token, url: url, referrer: referrer, route_to_user_id: route_to_user_id, page_title: page_title })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        path: "/conversations/visitor_initiated",
        chatServiceUrl: chatServiceUrl,
        token: token,
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: first_message,
                    kind: "chat",
                    prompt: prompt,
                    start_url: url,
                    referrer: referrer,
                    page_title: page_title,
                    route_to_user_id: route_to_user_id
                }
            }
        }
    });
};
const $8108230355f26483$export$3f208634044a8339 = ({ event_id: event_id, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        path: `/calendar_drops/${event_id}`,
        chatServiceUrl: chatServiceUrl,
        token: token
    });
};
const $8108230355f26483$export$a8856a0509e3da2f = ({ buttonID: buttonID, conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: "/conversations:button_push",
        body: {
            data: {
                attributes: {
                    button_id: buttonID,
                    conversation_id: conversationID
                }
            }
        }
    });
};
const $8108230355f26483$export$20a8a3976e8c41f = ({ token: token, agentID: agentID, chatServiceUrl: chatServiceUrl, direct: direct, variables: variables })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        chatServiceUrl: chatServiceUrl.split("/api/")[0],
        body: {
            data: {
                attributes: {
                    token: token,
                    agent_id: agentID,
                    direct: direct,
                    variables: variables
                }
            }
        },
        path: `/api/core/web_voice/${agentID}/call`
    });
};
const $8108230355f26483$export$97252688ea203707 = ({ event_id: event_id, start: start, end: end, startTimestamp: startTimestamp, endTimestamp: endTimestamp, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        raw: true,
        chatServiceUrl: chatServiceUrl,
        token: token,
        path: "/calendar_events",
        body: {
            data: {
                attributes: {
                    scheduled_start: start,
                    scheduled_end: end,
                    scheduled_start_timestamp: startTimestamp,
                    scheduled_end_timestamp: endTimestamp
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: event_id
                        }
                    }
                }
            }
        }
    }).then((response)=>{
        if (response.status >= 400 && response.status < 500) return false;
        else return response.json();
    });
};
const $8108230355f26483$export$9541b074d75dd2a8 = ({ calendarDropEventID: calendarDropEventID, phone: phone, reminderTime: reminderTime, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/calendar_events/text_reminder",
        body: {
            data: {
                attributes: {
                    phone: phone,
                    reminder_time: reminderTime
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: calendarDropEventID
                        }
                    }
                }
            }
        }
    });
};
const $8108230355f26483$export$aada62336c04439a = ({ calendarDropEventID: calendarDropEventID, email: email, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/calendar_events/email_reminder",
        body: {
            data: {
                attributes: {
                    email: email
                },
                relationships: {
                    calendar_drop: {
                        data: {
                            type: "conversation_events",
                            id: calendarDropEventID
                        }
                    }
                }
            }
        }
    });
};
const $8108230355f26483$export$22b2e2ebe09465e3 = ({ rating_event_id: rating_event_id, rating: rating, ratingType: ratingType, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/conversation_rating_events",
        body: {
            data: {
                attributes: {
                    ratingType: ratingType,
                    rating: rating
                },
                relationships: {
                    rating_drop: {
                        data: {
                            type: "conversation_events",
                            id: rating_event_id
                        }
                    }
                }
            }
        }
    });
};
const $8108230355f26483$export$f9dce390e0985015 = ({ flow_id: flow_id, token: token, chatServiceUrl: chatServiceUrl, page_url: page_url, referrer: referrer, page_title: page_title })=>{
    console.log("attempting to request bot flow: ", flow_id);
    return $8108230355f26483$export$872f4f09fb3b16a3({
        token: token,
        chatServiceUrl: chatServiceUrl,
        path: "/conversations",
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: "",
                    kind: "bot_trigger",
                    data: {
                        flow_id: flow_id
                    },
                    status: "prompt",
                    start_url: page_url,
                    referrer: referrer,
                    page_title: page_title
                }
            }
        }
    });
};
const $8108230355f26483$export$7a9befad52997cab = ({ botID: botID, token: token, chatServiceUrl: chatServiceUrl, page_url: page_url, page_title: page_title, referrer: referrer, preview: preview, submissionID: submissionID })=>{
    return $8108230355f26483$export$872f4f09fb3b16a3({
        path: "/conversations",
        token: token,
        chatServiceUrl: chatServiceUrl,
        body: {
            data: {
                type: "conversations",
                attributes: {
                    body: "",
                    kind: "bot_trigger",
                    data: {
                        bot_id: botID,
                        submission_id: submissionID
                    },
                    status: "prompt",
                    start_url: page_url,
                    page_title: page_title,
                    referrer: referrer,
                    preview: preview || false
                }
            }
        }
    });
};
const $8108230355f26483$export$6cd74db52a94a51f = ({ conversationID: conversationID, body: body, data: data, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: body,
            kind: "chat",
            data: data || {}
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $8108230355f26483$export$d27c9815c6b3753f = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: "",
            kind: "type"
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $8108230355f26483$export$2c28f69fbea80beb = ({ conversationID: conversationID, token: token, chatServiceUrl: chatServiceUrl })=>{
    return $8108230355f26483$var$sendEvent({
        conversationID: conversationID,
        event_attributes: {
            body: "",
            kind: "halt"
        },
        token: token,
        chatServiceUrl: chatServiceUrl
    });
};
const $8108230355f26483$export$21f305c035a18ae3 = ({ chatServiceUrl: chatServiceUrl, token: token, pageURL: pageURL, packetCode: packetCode, referrer: referrer })=>{
    const params = new URLSearchParams();
    params.append("filter[referrer]", referrer);
    params.append("filter[page_url]", pageURL);
    return $8108230355f26483$var$doGet({
        path: `/welcome_packet/${packetCode}?` + params.toString(),
        chatServiceUrl: chatServiceUrl,
        token: token,
        raw: true
    }).then((response)=>{
        if (response.status === 200) return response.json();
        console.log("non 200 returned:", response.status);
        return false;
    }).then((welcome_packet)=>{
        if (!welcome_packet) return false;
        return welcome_packet.data.attributes;
    });
};
const $8108230355f26483$var$setLocalItem = (k, v)=>{
    try {
        var item = {
            value: v,
            expires: Date.now() + 3600000
        };
        window.localStorage.setItem(k, JSON.stringify(item));
        $8108230355f26483$export$8a8216c44337cd5(k, v);
    } catch (e) {
    // pass
    }
};
const $8108230355f26483$export$8a8216c44337cd5 = (k, v)=>{
    try {
        window.sessionStorage.setItem(k, v);
    } catch (e) {
    // pass
    }
};
const $8108230355f26483$var$getLocalItem = (k)=>{
    try {
        var item = window.localStorage.getItem(k);
        if (!item) return null;
        var visitObj = JSON.parse(item);
        if (visitObj["expires"] < Date.now()) {
            window.localStorage.removeItem(k);
            return null;
        }
        if (!window.sessionStorage.getItem(k)) {
            window.localStorage.removeItem(k);
            $8108230355f26483$var$setLocalItem(k, visitObj["value"]);
            return visitObj["value"];
        }
        return visitObj["value"];
    } catch (e) {
    // pass
    }
    return null;
};
const $8108230355f26483$export$f92dfeb71e9bb569 = (k)=>{
    try {
        return window.sessionStorage.getItem(k);
    } catch (e) {
    // pass
    }
    return null;
};
const $8108230355f26483$export$fd98ba27f2ec095e = (k)=>{
    let i = $8108230355f26483$export$f92dfeb71e9bb569(k);
    if (i) return parseInt(i);
    return null;
};
const $8108230355f26483$export$fe2d9b4e03920b4c = (k)=>{
    try {
        window.sessionStorage.removeItem(k);
    } catch (e) {
    // pass
    }
};
const $8108230355f26483$var$crypto = window.crypto || window.msCrypto;
const $8108230355f26483$export$6473347ac50c95ee = (byte_count)=>{
    const array_values = new Uint8Array(byte_count);
    $8108230355f26483$var$crypto.getRandomValues(array_values);
    const hex = [];
    for(let j = 0; j < array_values.length; j++){
        const num = array_values[j];
        let i = num.toString(16) // use base 16 (hexadecimal)
        ;
        if (i.length < 2) i = "0" + i // ensure each byte is represented by two characters
        ;
        hex.push(i);
    }
    return hex.join("");
};
const $8108230355f26483$export$30c606e92a482586 = (packet_code)=>{
    if (!packet_code) return undefined;
    let visitID = $8108230355f26483$var$getLocalItem(`visit-id-${packet_code}`);
    if (!visitID) {
        visitID = $8108230355f26483$export$6473347ac50c95ee(16);
        $8108230355f26483$var$setLocalItem(`visit-id-${packet_code}`, visitID);
    }
    return visitID;
};
const $8108230355f26483$export$6853a7e3417d845d = ({ chatServiceUrl: chatServiceUrl, token: token })=>{
    if (!$8108230355f26483$export$f92dfeb71e9bb569("unwanted-emails")) $8108230355f26483$var$doGet({
        path: "/unwanted",
        chatServiceUrl: chatServiceUrl,
        token: token
    }).then((response)=>{
        $8108230355f26483$export$6efe264be9505de7("unwanted_emails", response.data.attributes);
    });
};
const $8108230355f26483$export$897f1ec3b6f3514a = ({ chatServiceUrl: chatServiceUrl, token: token, form_id: form_id, pageURL: pageURL, pageTitle: pageTitle, visitID: visitID })=>{
    const params = new URLSearchParams();
    params.append("page_url", pageURL);
    params.append("page_title", pageTitle);
    params.append("visit_id", visitID);
    $8108230355f26483$var$doGet({
        path: `/forms/${form_id}/fill?${params.toString()}`,
        chatServiceUrl: chatServiceUrl,
        token: token
    }).then((response)=>{
        $8108230355f26483$export$6efe264be9505de7("form_fill", {
            id: form_id,
            form_fill: response.data.attributes
        });
    });
};


function $057e6f58beb6839a$var$PhoneEntry(props) {
    const knownPhoneNumbers = [];
    const data = props.completeEvent.attributes.data;
    const visitorMobile = data.visitor_mobile_phone;
    const visitorPhone = data.visitor_phone;
    if (visitorPhone.replace(/\D/g, "").length >= 10) knownPhoneNumbers.push(visitorPhone);
    if (visitorMobile.replace(/\D/g, "").length >= 10) knownPhoneNumbers.push(visitorMobile);
    const [newPhone, setNewPhone] = (0, $iluxG.useState)(knownPhoneNumbers.length < 1);
    (0, $iluxG.useEffect)(()=>{
        if (knownPhoneNumbers.length) props.setPhone(knownPhoneNumbers[0]);
    }, []);
    function isValidInput(evt) {
        evt = evt || window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if ([
            40,
            41,
            43,
            45,
            32
        ].includes(charCode)) return true;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
            return false;
        }
        return true;
    }
    function switchMode() {
        props.setPhone("");
        setNewPhone(true);
    }
    if (newPhone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $6ffc785cceff7e40$export$2e2bcd8739ae039), {
        variant: "outlined",
        label: "Cell Phone Number",
        fullWidth: true,
        style: {
            marginTop: -5,
            marginBottom: 10
        },
        value: props.phone,
        onChange: props.handlePhone,
        onKeyPress: (e)=>isValidInput(e),
        autoFocus: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $297a49f35af5a8fe$export$2e2bcd8739ae039), {
        fullWidth: true,
        variant: "outlined",
        style: {
            marginBottom: 10,
            marginTop: -5
        },
        value: props.phone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
        value: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        onClick: switchMode
    }, "Enter a new number")), knownPhoneNumbers.map((number, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
            value: number,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            onClick: ()=>props.setPhone(number)
        }, "Text me at ****** " + number.replace(/\D/g, "").substr(number.length - 4)))));
}
function $057e6f58beb6839a$var$ReminderSettings(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const [phone, setPhone] = (0, $iluxG.useState)("");
    const [reminderTime, setReminderTime] = (0, $iluxG.useState)(15);
    const handleSelect = (event)=>{
        setReminderTime(event.target.value);
    };
    const handlePhone = (event)=>{
        setPhone(event.target.value);
    };
    const menuItemStyles = {
        padding: "2px 15px",
        fontSize: "14px",
        minHeight: 36
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($057e6f58beb6839a$var$PhoneEntry, {
        phone: phone,
        setPhone: setPhone,
        handlePhone: handlePhone,
        completeEvent: props.completeEvent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "3fr 1fr",
            gridGap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $297a49f35af5a8fe$export$2e2bcd8739ae039), {
        variant: "outlined",
        fullWidth: true,
        renderValue: (value)=>"Remind me " + value + " minutes prior",
        style: {
            fontSize: "12px"
        },
        value: reminderTime,
        onChange: handleSelect
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
        value: 5,
        style: menuItemStyles
    }, "Five Minutes Prior"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
        value: 10,
        style: menuItemStyles
    }, "Ten Minutes Prior"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
        value: 15,
        style: menuItemStyles
    }, "Fifteen Minutes Prior"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5938ef59e716eb83$export$2e2bcd8739ae039), {
        value: 30,
        style: menuItemStyles
    }, "Thirty Minutes Prior")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        variant: "outlined",
        disabled: phone.replace(/\D/g, "").length < 10,
        onClick: ()=>(0, $8108230355f26483$export$9541b074d75dd2a8)({
                calendarDropEventID: props.drop.event_id,
                reminderTime: reminderTime,
                phone: phone,
                token: token,
                chatServiceUrl: chatServiceUrl
            })
    }, "Done")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginTop: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        startIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daaeca3227173a2d$exports))), {
            style: {
                fontSize: 15
            }
        }),
        onClick: props.handleBack,
        style: {
            fontSize: "11px"
        }
    }, "Back")));
}
function $057e6f58beb6839a$var$ReminderPrompt(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const [preference, setPreference] = (0, $iluxG.useState)(null);
    if (preference === "yes") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($057e6f58beb6839a$var$ReminderSettings, {
        handleBack: ()=>setPreference(null),
        drop: props.drop,
        completeEvent: props.completeEvent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderPrompt
    }, "Would you like a text reminder prior to your meeting?"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderButtonDiv
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        variant: "outlined",
        style: {
            padding: "10px 0px",
            border: "1px solid rgba(0,0,0,0.8)"
        },
        onClick: ()=>setPreference("yes")
    }, "Yes, text me"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        variant: "outlined",
        style: {
            padding: "10px 0px",
            border: "1px solid rgba(0,0,0,0.8)"
        },
        onClick: ()=>(0, $8108230355f26483$export$9541b074d75dd2a8)({
                calendarDropEventID: props.drop.event_id,
                phone: null,
                reminderTime: null,
                token: token,
                chatServiceUrl: chatServiceUrl
            })
    }, "No thanks")));
}
function $057e6f58beb6839a$var$TextReminderSection({ firstName: firstName, completeDate: completeDate, startTime: startTime, endTime: endTime, avatarUrl: avatarUrl, drop: drop, completeEvent: completeEvent }) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropCompleteCard,
        style: {
            display: "flex",
            padding: 10,
            marginBottom: 15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginRight: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: avatarUrl,
        size: 65
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            margin: "auto"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            fontSize: "1.1em"
        }
    }, firstName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderDate
    }, completeDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            color: "rgba(0,0,0,0.8)",
            fontSize: "0.8em"
        }
    }, startTime, " - ", endTime), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderEmailMessage
    }, "We'll send an invite to your email!"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($057e6f58beb6839a$var$ReminderPrompt, {
        drop: drop,
        completeEvent: completeEvent
    }));
}
function $057e6f58beb6839a$var$DropComplete(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const completeEvent = props.completeEvent;
    const startDate = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(completeEvent.attributes.data.start);
    const endDate = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(completeEvent.attributes.data.end);
    const completeDate = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(startDate, "dddd, mmmm dS");
    const startTime = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(startDate, "shortTime");
    const endTime = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(endDate, "shortTime");
    const firstName = props.agentName.split(" ")[0];
    const noTextMessage = props.noTextMessage || false;
    // console.log(props.completedTextReminder)
    let message = "We'll send an invite to your email!";
    let fontSize = "1em";
    let marginTop = 15;
    if (props.completedTextReminder) {
        const reminderTime = props.completedTextReminder.attributes.data.reminder_time;
        if (reminderTime) {
            fontSize = ".9em";
            marginTop = 10;
            message = "We'll send an invite to your email and a reminder text " + reminderTime + " minutes prior to the meeting!";
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropHeader,
        style: {
            display: "grid",
            gridTemplateColumns: "30px auto 30px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8fb157a1849c528$exports))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("span", null, "Meeting Scheduled!")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropComplete
    }, props.completedTextReminder || noTextMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropCompleteCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropCompleteAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        size: 70
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            fontSize: "1.1em",
            marginTop: 8
        }
    }, "Meeting with ", firstName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropCompleteDate
    }, completeDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            color: "rgba(0,0,0,0.6)",
            fontSize: "1.1em"
        }
    }, startTime, " - ", endTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            textAlign: "center",
            marginTop: marginTop,
            fontSize: fontSize
        }
    }, message)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($057e6f58beb6839a$var$TextReminderSection, {
        firstName: props.agentName,
        completeDate: completeDate,
        startTime: startTime,
        endTime: endTime,
        avatarUrl: props.avatarUrl,
        drop: props.drop,
        completeEvent: props.completeEvent
    })));
}
var $057e6f58beb6839a$export$2e2bcd8739ae039 = $057e6f58beb6839a$var$DropComplete;



var $iluxG = parcelRequire("iluxG");





var $ce7ffb46144a7c51$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($ce7ffb46144a7c51$exports, "__esModule", {
    value: true
});
$ce7ffb46144a7c51$exports.default = void 0;

var $ce7ffb46144a7c51$var$_react = $h59lg((parcelRequire("iluxG")));

var $ce7ffb46144a7c51$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $ce7ffb46144a7c51$var$_default = (0, $ce7ffb46144a7c51$var$_createSvgIcon.default)($ce7ffb46144a7c51$var$_react.default.createElement("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
$ce7ffb46144a7c51$exports.default = $ce7ffb46144a7c51$var$_default;



var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");


var $kmV9n = parcelRequire("kmV9n");

var $9iccj = parcelRequire("9iccj");
var $5c97286c7ebd6ea8$var$SIZE = 44;
function $5c97286c7ebd6ea8$var$getRelativeValue(value, min, max) {
    return (Math.min(Math.max(min, value), max) - min) / (max - min);
}
function $5c97286c7ebd6ea8$var$easeOut(t) {
    t = $5c97286c7ebd6ea8$var$getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
    t = (t -= 1) * t * t + 1;
    return t;
}
function $5c97286c7ebd6ea8$var$easeIn(t) {
    return t * t;
}
var $5c97286c7ebd6ea8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "inline-block"
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create("transform")
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: "$circular-rotate 1.4s linear infinite"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: "block" // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: "currentColor" // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create("stroke-dashoffset")
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: "$circular-dash 1.4s ease-in-out infinite",
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: "80px, 200px",
            strokeDashoffset: "0px" // Add the unit to fix a Edge 16 and below bug.
        },
        "@keyframes circular-rotate": {
            "0%": {
                // Fix IE 11 wobbly
                transformOrigin: "50% 50%"
            },
            "100%": {
                transform: "rotate(360deg)"
            }
        },
        "@keyframes circular-dash": {
            "0%": {
                strokeDasharray: "1px, 200px",
                strokeDashoffset: "0px"
            },
            "50%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-15px"
            },
            "100%": {
                strokeDasharray: "100px, 200px",
                strokeDashoffset: "-125px"
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: "none"
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $5c97286c7ebd6ea8$var$CircularProgress = /*#__PURE__*/ $iluxG.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate" || variant === "static") {
        var circumference = 2 * Math.PI * (($5c97286c7ebd6ea8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        if (variant === "static") {
            circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
            rootStyle.transform = "rotate(-90deg)";
        } else {
            circleStyle.strokeDashoffset = "".concat(($5c97286c7ebd6ea8$var$easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
            rootStyle.transform = "rotate(".concat(($5c97286c7ebd6ea8$var$easeOut(value / 70) * 270).toFixed(3), "deg)");
        }
    }
    return /*#__PURE__*/ $iluxG.createElement("div", (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, color !== "inherit" && classes["color".concat((0, $9iccj.default)(color))], {
            "indeterminate": classes.indeterminate,
            "static": classes.static
        }[variant]),
        style: (0, $7ZPk1.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $iluxG.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($5c97286c7ebd6ea8$var$SIZE / 2, " ").concat($5c97286c7ebd6ea8$var$SIZE / 2, " ").concat($5c97286c7ebd6ea8$var$SIZE, " ").concat($5c97286c7ebd6ea8$var$SIZE)
    }, /*#__PURE__*/ $iluxG.createElement("circle", {
        className: (0, $ao43X.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            "indeterminate": classes.circleIndeterminate,
            "static": classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $5c97286c7ebd6ea8$var$SIZE,
        cy: $5c97286c7ebd6ea8$var$SIZE,
        r: ($5c97286c7ebd6ea8$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $5c97286c7ebd6ea8$export$2e2bcd8739ae039 = (0, $kmV9n.default)($5c97286c7ebd6ea8$export$9dd6ff9ea0189349, {
    name: "MuiCircularProgress",
    flip: false
})($5c97286c7ebd6ea8$var$CircularProgress);



var $73e81d2a5f6275c6$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($73e81d2a5f6275c6$exports, "__esModule", {
    value: true
});
$73e81d2a5f6275c6$exports.default = void 0;

var $73e81d2a5f6275c6$var$_react = $h59lg((parcelRequire("iluxG")));

var $73e81d2a5f6275c6$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $73e81d2a5f6275c6$var$_default = (0, $73e81d2a5f6275c6$var$_createSvgIcon.default)($73e81d2a5f6275c6$var$_react.default.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check");
$73e81d2a5f6275c6$exports.default = $73e81d2a5f6275c6$var$_default;




var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");

var $9iccj = parcelRequire("9iccj");
var $53bb0af5ec193243$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: "absolute",
            height: 1,
            width: 1,
            overflow: "hidden"
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: "left"
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: "center"
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: "right"
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: "justify"
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: "0.35em"
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: "inline"
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: "block"
        }
    };
};
var $53bb0af5ec193243$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p"
};
var $53bb0af5ec193243$var$Typography = /*#__PURE__*/ $iluxG.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $53bb0af5ec193243$var$defaultVariantMapping : _props$variantMapping, other = (0, $anj8u.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? "p" : variantMapping[variant] || $53bb0af5ec193243$var$defaultVariantMapping[variant]) || "span";
    return /*#__PURE__*/ $iluxG.createElement(Component, (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0, $9iccj.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0, $9iccj.default)(align))], display !== "initial" && classes["display".concat((0, $9iccj.default)(display))]),
        ref: ref
    }, other));
});
var $53bb0af5ec193243$export$2e2bcd8739ae039 = (0, $kmV9n.default)($53bb0af5ec193243$export$9dd6ff9ea0189349, {
    name: "MuiTypography"
})($53bb0af5ec193243$var$Typography);



var $iluxG = parcelRequire("iluxG");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");

var $eVYnJ = parcelRequire("eVYnJ");
function $5a585f2161be894b$export$2e2bcd8739ae039(path, displayName) {
    var Component = (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).memo((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).forwardRef(function(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $eVYnJ.default), (0, $7ZPk1.default)({
            ref: ref
        }, props), path);
    }));
    Component.muiName = (0, $eVYnJ.default).muiName;
    return Component;
}


var $a8299cc3c69793e5$export$2e2bcd8739ae039 = (0, $5a585f2161be894b$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");



function $e2b24a54586d6a01$var$createCalendarEventWrap({ event_id: event_id, start: start, end: end, startTimestamp: startTimestamp, endTimestamp: endTimestamp, token: token, chatServiceUrl: chatServiceUrl }) {
    return (0, $8108230355f26483$export$97252688ea203707)({
        event_id: event_id,
        start: start,
        end: end,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        token: token,
        chatServiceUrl: chatServiceUrl
    }).then((response)=>{
        if (response === false) return false;
        (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
            action: "Meeting Booked",
            label: "meeting"
        });
        return true;
    });
}
function $e2b24a54586d6a01$var$EmailReminderSection({ firstName: firstName, completeDate: completeDate, startTime: startTime, endTime: endTime, avatarUrl: avatarUrl }) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropCompleteCard,
        style: {
            display: "flex",
            padding: 10,
            marginBottom: 15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginRight: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: avatarUrl,
        size: 65
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            margin: "auto"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            fontSize: "1.1em"
        }
    }, firstName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderDate
    }, completeDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            color: "rgba(0,0,0,0.8)",
            fontSize: "0.8em"
        }
    }, startTime, " - ", endTime))));
}
function $e2b24a54586d6a01$var$ErrorBody(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            height: 100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "solid black 1pt",
            borderRadius: 5,
            flexDirection: "column"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $a8299cc3c69793e5$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $53bb0af5ec193243$export$2e2bcd8739ae039), {
        className: classes.timeSelctionError
    }, "That time slot is no longer available")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        style: {
            border: "1px solid black",
            marginTop: "10px"
        },
        onClick: ()=>props.fetchNewTimes()
    }, "Select a new time")));
}
function $e2b24a54586d6a01$var$CalendarHeader(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropHeader,
        style: {
            display: "flex",
            justifyContent: "space-between"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ce7ffb46144a7c51$exports))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("span", {
        style: {
            marginLeft: 8
        }
    }, "Meeting Scheduled!")));
}
function $e2b24a54586d6a01$var$EmailConfirmationBox(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const [loading, setLoading] = (0, $iluxG.useState)(false);
    const [timeSelectionError, setTimeSelectionError] = (0, $iluxG.useState)(false);
    const message = props.drop.data.visitor_email;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, timeSelectionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$ErrorBody, {
        fetchNewTimes: ()=>props.setFailedTimeRequest(true)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.emailConfirmDiv
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, "The email I have for you is"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, "Is this correct?")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.textReminderButtonDiv
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        className: classes.showMoreButton,
        onClick: ()=>{
            setLoading(true);
            $e2b24a54586d6a01$var$createCalendarEventWrap({
                event_id: props.drop.event_id,
                start: props.start,
                end: props.end,
                startTimestamp: props.startTimestamp,
                endTimestamp: props.endTimestamp,
                token: token,
                chatServiceUrl: chatServiceUrl
            }).then((resp)=>{
                if (resp === false) {
                    setLoading(false);
                    setTimeSelectionError(true);
                }
            });
        }
    }, "Yes", loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5c97286c7ebd6ea8$export$2e2bcd8739ae039), {
        size: 24,
        className: classes.buttonProgress
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        className: classes.showMoreButton,
        onClick: ()=>{
            props.emailKnownHandler(false);
        }
    }, "No"))));
}
function $e2b24a54586d6a01$var$EmailInput(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const [email, setEmail] = (0, $iluxG.useState)("");
    const [loading, setLoading] = (0, $iluxG.useState)(false);
    const [badEmail, setBadEmail] = (0, $iluxG.useState)(false);
    const [timeSelectionError, setTimeSelectionError] = (0, $iluxG.useState)(false);
    let message = "Which email would you like us to send your invite to?";
    if (props.switchEmail) message = "Enter your new email.";
    const handleEmail = (event)=>{
        setEmail(event.target.value);
    };
    function checkEmail() {
        if (email) {
            const emailString = email.split("@");
            if (emailString.length !== 2) return false;
            const leftSide = emailString[0].trim();
            const rightSide = emailString[1].trim();
            if (leftSide.length < 1) return false;
            if (rightSide.length < 3) return false;
            const rightSideList = rightSide.split(".");
            if (rightSideList.length < 2) return false;
            if (rightSideList[0].trim().length < 1) return false;
            if (rightSideList[1].trim().length < 1) return false;
            if (email[email.length - 1] === ".") return false;
            return true;
        }
        return false;
    }
    function handleClick() {
        if (checkEmail()) {
            setLoading(true);
            (0, $8108230355f26483$export$aada62336c04439a)({
                calendarDropEventID: props.drop.event_id,
                email: email,
                token: token,
                chatServiceUrl: chatServiceUrl
            }).then((response)=>{
                return $e2b24a54586d6a01$var$createCalendarEventWrap({
                    event_id: props.drop.event_id,
                    start: props.start,
                    end: props.end,
                    startTimestamp: props.startTimestamp,
                    endTimestamp: props.endTimestamp,
                    token: token,
                    chatServiceUrl: chatServiceUrl
                }).then((resp)=>{
                    if (resp === false) {
                        setLoading(false);
                        setTimeSelectionError(true);
                    }
                });
            });
        } else setBadEmail(true);
    }
    if (badEmail) message = "Please enter a valid email address.";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, timeSelectionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$ErrorBody, {
        fetchNewTimes: ()=>props.setFailedTimeRequest(true)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.meetingTime,
        style: {
            display: "flex",
            padding: 20,
            marginBottom: 15,
            textAlign: "center"
        }
    }, message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "6fr 1fr",
            gridGap: 10
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $6ffc785cceff7e40$export$2e2bcd8739ae039), {
        variant: "outlined",
        label: "Email",
        fullWidth: true,
        style: {
            marginTop: -5,
            marginBottom: 10,
            marginRight: 10
        },
        onChange: handleEmail,
        autoFocus: true,
        type: "email",
        pattern: ".+@"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("button", {
        type: "submit",
        variant: "outlined",
        style: {
            backgroundColor: "white",
            marginTop: -5,
            height: 55,
            cursor: "pointer"
        },
        onClick: ()=>{
            handleClick();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($73e81d2a5f6275c6$exports))), null), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5c97286c7ebd6ea8$export$2e2bcd8739ae039), {
        size: 24,
        className: classes.buttonProgress
    }))))));
}
function $e2b24a54586d6a01$var$BoxBody(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const startDate = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(props.start);
    const endDate = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(props.end);
    const completeDate = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(startDate, "dddd, mmmm dS");
    const startTime = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(startDate, "shortTime");
    const endTime = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(endDate, "shortTime");
    if (!props.slots) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5c97286c7ebd6ea8$export$2e2bcd8739ae039), {
        style: {
            height: 60,
            width: 60
        }
    }));
    if (!props.emailKnown) {
        const switchEmail = props.drop.data.visitor_email || props.drop.data.visitor_other_email;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            className: classes.calendarDropComplete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$EmailReminderSection, {
            firstName: props.agentName,
            completeDate: completeDate,
            startTime: startTime,
            endTime: endTime,
            avatarUrl: props.avatarUrl,
            drop: props.drop
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$EmailInput, {
            switchEmail: switchEmail,
            avatarUrl: props.avatarUrl,
            agentName: props.agentName,
            slots: props.slots,
            drop: props.drop,
            emailKnown: props.emailKnown,
            emailKnownHandler: props.emailKnownHandler,
            start: props.start,
            end: props.end,
            startTimestamp: props.startTimestamp,
            endTimestamp: props.endTimestamp,
            setFailedTimeRequest: props.setFailedTimeRequest
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$EmailReminderSection, {
        firstName: props.agentName,
        completeDate: completeDate,
        startTime: startTime,
        endTime: endTime,
        avatarUrl: props.avatarUrl,
        drop: props.drop
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$EmailConfirmationBox, {
        avatarUrl: props.avatarUrl,
        agentName: props.agentName,
        slots: props.slots,
        drop: props.drop,
        emailKnown: props.emailKnown,
        emailKnownHandler: props.emailKnownHandler,
        start: props.start,
        end: props.end,
        startTimestamp: props.startTimestamp,
        endTimestamp: props.endTimestamp,
        setFailedTimeRequest: props.setFailedTimeRequest
    }));
}
function $e2b24a54586d6a01$var$EmailConfirmation(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const [emailKnown, setEmailKnown] = (0, $iluxG.useState)(props.drop.data.visitor_email || props.drop.data.visitor_other_email);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$CalendarHeader, {
        drop: props.drop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e2b24a54586d6a01$var$BoxBody, {
        avatarUrl: props.avatarUrl,
        agentName: props.agentName,
        slots: true,
        drop: props.drop,
        emailKnown: emailKnown,
        emailKnownHandler: setEmailKnown,
        start: props.start,
        end: props.end,
        startTimestamp: props.startTimestamp,
        endTimestamp: props.endTimestamp,
        setFailedTimeRequest: props.setFailedTimeRequest
    }));
}
var $e2b24a54586d6a01$export$2e2bcd8739ae039 = $e2b24a54586d6a01$var$EmailConfirmation;



var $iluxG = parcelRequire("iluxG");







function $4092b8f82f8c7e13$var$CalendarHeader(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropHeader,
        style: {
            display: "flex",
            justifyContent: "space-between"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ce7ffb46144a7c51$exports))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("span", {
        style: {
            marginLeft: 8
        }
    }, props.drop.data.meeting_type)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, props.drop.data.duration, " min"));
}
function $4092b8f82f8c7e13$var$SlotButton(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        variant: "outlined",
        fullWidth: true,
        style: {
            border: "1px solid rgb(0,0,0)",
            minHeight: 40,
            fontSize: "13px",
            textTransform: "none",
            lineHeight: 1.3
        },
        onClick: props.onClick
    }, props.text);
}
function $4092b8f82f8c7e13$var$PageSubHeader(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "36px auto 36px",
            height: 36
        }
    }, props.back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: props.back,
        style: {
            padding: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daaeca3227173a2d$exports))), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
        }
    }, props.heading));
}
function $4092b8f82f8c7e13$var$DayPicker(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$PageSubHeader, {
        heading: "Select a day",
        back: ()=>props.setShowMore(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.slotsDiv
    }, props.days.map((d, index)=>{
        const text = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(new Date(d), "ddd, mmm dS");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$SlotButton, {
            key: index,
            onClick: ()=>props.setDay(d),
            text: text
        });
    })));
}
function $4092b8f82f8c7e13$var$DateTimePicker(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const allAvailability = Object.values(props.slots);
    const todaysAvailability = allAvailability[0];
    const tomorrowsAvailability = allAvailability[1];
    let times = [];
    if (todaysAvailability.length > 1) {
        times = todaysAvailability.slice(0, 2);
        times = times.concat(tomorrowsAvailability[0]);
    } else {
        times = todaysAvailability;
        if (tomorrowsAvailability.length > 1) times = times.concat(tomorrowsAvailability.slice(0, 2));
        else {
            times = times.concat(tomorrowsAvailability[0]);
            times = times.concat(allAvailability[1][0]);
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$PageSubHeader, {
        heading: "Select an appointment"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.dateAndTimeSlotsDiv
    }, times.map((t, index)=>{
        const text = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(t, "dddd, mmmm dS - h:MM TT Z");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$SlotButton, {
            key: index,
            text: text,
            onClick: ()=>props.setDateTime(t)
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.optionsText,
        onClick: ()=>props.setShowMore(true)
    }, "More options"));
}
function $4092b8f82f8c7e13$var$TimePicker(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const formattedDay = props.day ? (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(new Date(props.day), "dddd, mmmm, dS yyyy") : "";
    const times = props.slots[props.day];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$PageSubHeader, {
        back: props.back,
        heading: formattedDay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.slotsDiv
    }, times.map((t, index)=>{
        const text = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(t, "h:MM TT");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$SlotButton, {
            key: index,
            text: text,
            onClick: ()=>props.setDateTime(t)
        });
    })));
}
function $4092b8f82f8c7e13$var$ConfirmationPage(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    const endDateTime = new Date(props.startTime.getTime() + props.duration * 60000);
    const meetingTimeString = (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(props.startTime, "h:MM") + " - " + (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(endDateTime, "h:MM TT");
    const start = (0, $2aa51094984e709a$export$2e2bcd8739ae039)(props.startTime);
    const end = (0, $2aa51094984e709a$export$2e2bcd8739ae039)(endDateTime);
    (0, $iluxG.useEffect)(()=>{
        props.startHandler(start, props.startTime.getTime());
        props.endHandler(end, endDateTime.getTime());
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$PageSubHeader, {
        back: props.back,
        heading: props.formattedDay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            padding: "10px 20px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.meetingTime
    }, meetingTimeString), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginBottom: 10,
            position: "relative"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        fullWidth: true,
        color: "primary",
        variant: "contained",
        onClick: ()=>{
            props.statushandler("dateSelected");
        }
    }, "Schedule Meeting")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        fullWidth: true,
        variant: "outlined",
        onClick: props.back
    }, "Cancel")));
}
function $4092b8f82f8c7e13$var$SlotPicker(props) {
    const [showMore, setShowMore] = (0, $iluxG.useState)(false);
    const [day, setDay] = (0, $iluxG.useState)(null);
    const [dateTime, setDateTime] = (0, $iluxG.useState)(null);
    const days = Object.keys(props.slots);
    const formattedDay = dateTime ? (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(new Date(dateTime), "dddd, mmmm, dS yyyy") : "";
    if (dateTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$ConfirmationPage, {
        back: ()=>setDateTime(null),
        formattedDay: formattedDay,
        duration: props.drop.data.duration,
        startTime: dateTime,
        dropEventID: props.drop.event_id,
        statushandler: props.statushandler,
        startHandler: props.startHandler,
        endHandler: props.endHandler
    });
    if (!showMore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$DateTimePicker, {
        formattedDay: formattedDay,
        slots: props.slots,
        setDateTime: setDateTime,
        setShowMore: setShowMore
    });
    else if (day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$TimePicker, {
        day: day,
        slots: props.slots,
        back: ()=>setDay(null),
        setDateTime: setDateTime
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$DayPicker, {
        days: days,
        setDay: setDay,
        setShowMore: setShowMore
    });
}
function $4092b8f82f8c7e13$var$CalendarBody(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    if (!props.slots) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $5c97286c7ebd6ea8$export$2e2bcd8739ae039), {
        style: {
            height: 60,
            width: 60
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.agentNameDiv
    }, props.agentName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.agentAvatarDiv
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        size: 60
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$SlotPicker, {
        slots: props.slots,
        drop: props.drop,
        statushandler: props.statushandler,
        startHandler: props.startHandler,
        endHandler: props.endHandler
    }));
}
function $4092b8f82f8c7e13$var$DatePicker(props) {
    const classes = (0, $e18d8b0ad08c4c06$export$1bc08e2b8958ccf8)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.calendarDropOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$CalendarHeader, {
        drop: props.drop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($4092b8f82f8c7e13$var$CalendarBody, {
        avatarUrl: props.avatarUrl,
        agentName: props.agentName,
        slots: props.slots,
        drop: props.drop,
        statushandler: props.statushandler,
        startHandler: props.startHandler,
        endHandler: props.endHandler
    }));
}
var $4092b8f82f8c7e13$export$2e2bcd8739ae039 = $4092b8f82f8c7e13$var$DatePicker;



function $2822d2dfb27fd7b2$var$CalendarDrop(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const theme = (0, $8c848ed513484619$export$2e2bcd8739ae039)();
    const drop = props.event;
    const [slots, setSlots] = (0, $iluxG.useState)(null);
    const [status, setStatus] = (0, $iluxG.useState)("noDate");
    const [start, setStart] = (0, $iluxG.useState)(null);
    const [end, setEnd] = (0, $iluxG.useState)(null);
    const [startTimestamp, setStartTimestamp] = (0, $iluxG.useState)(null);
    const [endTimestamp, setEndTimestamp] = (0, $iluxG.useState)(null);
    const [failedTimeRequest, setFailedTimeRequest] = (0, $iluxG.useState)(false);
    const setStartTimes = (dt, ts)=>{
        setStart(dt);
        setStartTimestamp(ts);
    };
    const setEndTimes = (dt, ts)=>{
        setEnd(dt);
        setEndTimestamp(ts);
    };
    (0, $iluxG.useEffect)(()=>{
        if (drop && drop.data && !props.completedDrops[drop.event_id]) (0, $8108230355f26483$export$3f208634044a8339)({
            event_id: drop.event_id,
            token: token,
            chatServiceUrl: chatServiceUrl
        }).then((result)=>{
            const element_token = result.data.attributes.element_token;
            const member_sub = result.data.attributes.member_sub;
            (0, $e18d8b0ad08c4c06$export$47dfb797b70c39e3)({
                element_token: element_token,
                member_sub: member_sub,
                drop: drop
            }).then((response)=>{
                setSlots((0, $e18d8b0ad08c4c06$export$5d193019201ef5c6)(response.available_slots));
            });
        });
        if (failedTimeRequest === true) setStatus("noDate");
    }, [
        failedTimeRequest,
        chatServiceUrl,
        props.completedDrops,
        drop,
        token
    ]);
    if (!drop || !drop.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    if (props.completedDrops[drop.event_id]) {
        const completeEvent = props.completedDrops[drop.event_id];
        let noTextMessage = true;
        if (drop.data.text_message_reminders) noTextMessage = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $057e6f58beb6839a$export$2e2bcd8739ae039), {
            noTextMessage: noTextMessage,
            completeEvent: completeEvent,
            avatarUrl: drop.data.avatar_url,
            agentName: drop.data.agent_name,
            drop: drop,
            completedTextReminder: props.completedTextReminders[drop.event_id]
        });
    } else if (status === "dateSelected") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $e2b24a54586d6a01$export$2e2bcd8739ae039), {
        avatarUrl: drop.data.avatar_url,
        agentName: drop.data.agent_name,
        drop: drop,
        start: start,
        end: end,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        setFailedTimeRequest: setFailedTimeRequest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $4092b8f82f8c7e13$export$2e2bcd8739ae039), {
        drop: drop,
        avatarUrl: drop.data.avatar_url,
        agentName: drop.data.agent_name,
        slots: slots,
        theme: theme,
        status: status,
        statushandler: setStatus,
        startHandler: setStartTimes,
        endHandler: setEndTimes
    });
}
var $2822d2dfb27fd7b2$export$2e2bcd8739ae039 = $2822d2dfb27fd7b2$var$CalendarDrop;



var $iluxG = parcelRequire("iluxG");

var $16dd78c00cf8b7aa$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($16dd78c00cf8b7aa$exports, "__esModule", {
    value: true
});
$16dd78c00cf8b7aa$exports.default = void 0;

var $16dd78c00cf8b7aa$var$_react = $h59lg((parcelRequire("iluxG")));

var $16dd78c00cf8b7aa$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $16dd78c00cf8b7aa$var$_default = (0, $16dd78c00cf8b7aa$var$_createSvgIcon.default)($16dd78c00cf8b7aa$var$_react.default.createElement($16dd78c00cf8b7aa$var$_react.default.Fragment, null, $16dd78c00cf8b7aa$var$_react.default.createElement("circle", {
    cx: "15.5",
    cy: "9.5",
    r: "1.5"
}), $16dd78c00cf8b7aa$var$_react.default.createElement("circle", {
    cx: "8.5",
    cy: "9.5",
    r: "1.5"
}), $16dd78c00cf8b7aa$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7z"
})), "SentimentVerySatisfied");
$16dd78c00cf8b7aa$exports.default = $16dd78c00cf8b7aa$var$_default;


var $49a5c4e7f682e3cd$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($49a5c4e7f682e3cd$exports, "__esModule", {
    value: true
});
$49a5c4e7f682e3cd$exports.default = void 0;

var $49a5c4e7f682e3cd$var$_react = $h59lg((parcelRequire("iluxG")));

var $49a5c4e7f682e3cd$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $49a5c4e7f682e3cd$var$_default = (0, $49a5c4e7f682e3cd$var$_createSvgIcon.default)($49a5c4e7f682e3cd$var$_react.default.createElement($49a5c4e7f682e3cd$var$_react.default.Fragment, null, $49a5c4e7f682e3cd$var$_react.default.createElement("circle", {
    cx: "15.5",
    cy: "9.5",
    r: "1.5"
}), $49a5c4e7f682e3cd$var$_react.default.createElement("circle", {
    cx: "8.5",
    cy: "9.5",
    r: "1.5"
}), $49a5c4e7f682e3cd$var$_react.default.createElement("circle", {
    cx: "15.5",
    cy: "9.5",
    r: "1.5"
}), $49a5c4e7f682e3cd$var$_react.default.createElement("circle", {
    cx: "8.5",
    cy: "9.5",
    r: "1.5"
}), $49a5c4e7f682e3cd$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
})), "SentimentSatisfiedAlt");
$49a5c4e7f682e3cd$exports.default = $49a5c4e7f682e3cd$var$_default;


var $d9f100117f8b9be0$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($d9f100117f8b9be0$exports, "__esModule", {
    value: true
});
$d9f100117f8b9be0$exports.default = void 0;

var $d9f100117f8b9be0$var$_react = $h59lg((parcelRequire("iluxG")));

var $d9f100117f8b9be0$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $d9f100117f8b9be0$var$_default = (0, $d9f100117f8b9be0$var$_createSvgIcon.default)($d9f100117f8b9be0$var$_react.default.createElement($d9f100117f8b9be0$var$_react.default.Fragment, null, $d9f100117f8b9be0$var$_react.default.createElement("circle", {
    cx: "15.5",
    cy: "9.5",
    r: "1.5"
}), $d9f100117f8b9be0$var$_react.default.createElement("circle", {
    cx: "8.5",
    cy: "9.5",
    r: "1.5"
}), $d9f100117f8b9be0$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15.86.55 1.87.87 2.97.87 1.11 0 2.12-.33 2.98-.88-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z"
})), "SentimentSatisfied");
$d9f100117f8b9be0$exports.default = $d9f100117f8b9be0$var$_default;


var $4c8c9a73a301a7c9$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($4c8c9a73a301a7c9$exports, "__esModule", {
    value: true
});
$4c8c9a73a301a7c9$exports.default = void 0;

var $4c8c9a73a301a7c9$var$_react = $h59lg((parcelRequire("iluxG")));

var $4c8c9a73a301a7c9$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $4c8c9a73a301a7c9$var$_default = (0, $4c8c9a73a301a7c9$var$_createSvgIcon.default)($4c8c9a73a301a7c9$var$_react.default.createElement($4c8c9a73a301a7c9$var$_react.default.Fragment, null, $4c8c9a73a301a7c9$var$_react.default.createElement("circle", {
    cx: "15.5",
    cy: "9.5",
    r: "1.5"
}), $4c8c9a73a301a7c9$var$_react.default.createElement("circle", {
    cx: "8.5",
    cy: "9.5",
    r: "1.5"
}), $4c8c9a73a301a7c9$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
})), "SentimentVeryDissatisfied");
$4c8c9a73a301a7c9$exports.default = $4c8c9a73a301a7c9$var$_default;


var $626a038bb41b629a$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($626a038bb41b629a$exports, "__esModule", {
    value: true
});
$626a038bb41b629a$exports.default = void 0;

var $626a038bb41b629a$var$_react = $h59lg((parcelRequire("iluxG")));

var $626a038bb41b629a$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $626a038bb41b629a$var$_default = (0, $626a038bb41b629a$var$_createSvgIcon.default)($626a038bb41b629a$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
}), "MoodBad");
$626a038bb41b629a$exports.default = $626a038bb41b629a$var$_default;


var $6b55d572606f9875$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($6b55d572606f9875$exports, "__esModule", {
    value: true
});
$6b55d572606f9875$exports.default = void 0;

var $6b55d572606f9875$var$_react = $h59lg((parcelRequire("iluxG")));

var $6b55d572606f9875$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $6b55d572606f9875$var$_default = (0, $6b55d572606f9875$var$_createSvgIcon.default)($6b55d572606f9875$var$_react.default.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star");
$6b55d572606f9875$exports.default = $6b55d572606f9875$var$_default;


var $1d6a67789d0cb9dc$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($1d6a67789d0cb9dc$exports, "__esModule", {
    value: true
});
$1d6a67789d0cb9dc$exports.default = void 0;

var $1d6a67789d0cb9dc$var$_react = $h59lg((parcelRequire("iluxG")));

var $1d6a67789d0cb9dc$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $1d6a67789d0cb9dc$var$_default = (0, $1d6a67789d0cb9dc$var$_createSvgIcon.default)($1d6a67789d0cb9dc$var$_react.default.createElement("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
$1d6a67789d0cb9dc$exports.default = $1d6a67789d0cb9dc$var$_default;




const $894b3a5b994c6912$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        ratingDivOuter: {
            margin: "10px auto 10px auto",
            display: "flex",
            justifyContent: "center"
        },
        ratingDivInner: {
            display: "flex",
            width: 250,
            justifyContent: "space-between"
        },
        emojiIcon: {
            fontSize: "40px",
            cursor: "pointer",
            marginRight: 5,
            "&:hover": {
                fontSize: "45px",
                marginRight: 0
            }
        },
        starIcon: {
            fontSize: "40px",
            cursor: "pointer",
            fill: "gold"
        }
    }));
const $894b3a5b994c6912$var$Ratings = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($626a038bb41b629a$exports))),
        color: "#F0706F",
        value: 1
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4c8c9a73a301a7c9$exports))),
        color: "#eba21a",
        value: 2
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d9f100117f8b9be0$exports))),
        color: "#e8e825",
        value: 3
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49a5c4e7f682e3cd$exports))),
        color: "#59e3da",
        value: 4
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($16dd78c00cf8b7aa$exports))),
        color: "#1bd40b",
        value: 5
    }
];
function $894b3a5b994c6912$var$RatingComplete(props) {
    const classes = $894b3a5b994c6912$var$useStyles();
    const rating = props.rating;
    const ratingType = props.ratingType;
    if (ratingType === "emojis") {
        const r = $894b3a5b994c6912$var$Ratings.filter((r)=>r.value === rating)[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            style: {
                marginRight: 25,
                display: "flex",
                justifyContent: "flex-end"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement(r.icon, {
            style: {
                fill: r.color,
                fontSize: "50px"
            }
        }));
    } else if (ratingType === "five_stars") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivInner
    }, [
        1,
        2,
        3,
        4,
        5
    ].map((r)=>{
        if (r <= rating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6b55d572606f9875$exports))), {
            className: classes.starIcon,
            key: r
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1d6a67789d0cb9dc$exports))), {
            className: classes.starIcon,
            key: r
        });
    })));
}
function $894b3a5b994c6912$var$RatingDrop(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = $894b3a5b994c6912$var$useStyles();
    const [hover, setHover] = (0, $iluxG.useState)(0);
    const rating_event_id = props.event_id;
    const ratingType = props.ratingType;
    const completedRatings = props.completedRatings;
    const completeEvent = completedRatings[rating_event_id];
    if (completeEvent) {
        const rating = completeEvent.attributes.data.rating;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($894b3a5b994c6912$var$RatingComplete, {
            rating: rating,
            ratingType: ratingType
        });
    }
    if (ratingType === "emojis") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivInner
    }, $894b3a5b994c6912$var$Ratings.map((rating)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement(rating.icon, {
            className: classes.emojiIcon,
            style: {
                fill: rating.color
            },
            key: rating.value,
            onClick: ()=>(0, $8108230355f26483$export$22b2e2ebe09465e3)({
                    rating_event_id: rating_event_id,
                    rating: rating.value,
                    ratingType: ratingType,
                    token: token,
                    chatServiceUrl: chatServiceUrl
                })
        }))));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivOuter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.ratingDivInner,
        onMouseLeave: ()=>setHover(0)
    }, [
        1,
        2,
        3,
        4,
        5
    ].map((rating)=>{
        if (rating <= hover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6b55d572606f9875$exports))), {
            className: classes.starIcon,
            key: rating,
            onMouseEnter: ()=>setHover(rating),
            onClick: ()=>(0, $8108230355f26483$export$22b2e2ebe09465e3)({
                    rating_event_id: rating_event_id,
                    rating: rating,
                    ratingType: ratingType,
                    token: token,
                    chatServiceUrl: chatServiceUrl
                })
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1d6a67789d0cb9dc$exports))), {
            className: classes.starIcon,
            key: rating,
            onMouseEnter: ()=>setHover(rating),
            onClick: ()=>(0, $8108230355f26483$export$22b2e2ebe09465e3)({
                    rating_event_id: rating_event_id,
                    rating: rating,
                    ratingType: ratingType,
                    token: token,
                    chatServiceUrl: chatServiceUrl
                })
        });
    })));
}
var $894b3a5b994c6912$export$2e2bcd8739ae039 = $894b3a5b994c6912$var$RatingDrop;





var $iluxG = parcelRequire("iluxG");


const $effdc5579f914e76$var$useChatOptionsStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)(()=>({
        list: {
            display: "flex",
            justifyContent: "flex-end",
            marginLeft: "5px",
            marginRight: "5px",
            flexWrap: "wrap"
        },
        option: {
            border: "1px solid #ECECEC",
            borderRadius: "16px",
            padding: "3px 10px",
            fontFamily: "Open Sans, sans serif",
            fontSize: "16px",
            cursor: "pointer",
            textTransform: "none",
            alignSelf: "flex-start",
            margin: 5,
            minWidth: 0
        },
        optionClicked: {
            border: "1px solid",
            borderRadius: "16px",
            color: "#9852EA",
            padding: "8px",
            fontFamily: "Open Sans, sans serif",
            cursor: "pointer",
            backgroundColor: "#dbc7ed",
            borderColor: "#9852EA"
        }
    }));
function $effdc5579f914e76$var$ChatOptionsPicker(props) {
    const options = props.options;
    const chooseValue = props.chooseValue;
    const conversation_event = props.conversation_event;
    const promptsToClosedPromptEvents = props.promptsToClosedPromptEvents;
    const classes = $effdc5579f914e76$var$useChatOptionsStyles();
    const [clickedValue, setClickedValue] = (0, $iluxG.useState)(null);
    let is_complete = false;
    if (conversation_event) is_complete = promptsToClosedPromptEvents[conversation_event.id];
    if (clickedValue || is_complete) // Right now we only want to display the options if it hasn't been picked because
    // the picked option will be an event with a "chat" kind.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    // Only render a single item if it is selected.
    const render_options = options;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.list
    }, render_options.map((option)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
            key: option.value,
            id: "button",
            onClick: ()=>{
                setClickedValue(option.value);
                chooseValue(option.value, conversation_event, options);
            },
            color: "secondary",
            variant: "outlined",
            className: classes.option
        }, option.label);
    }));
}
var $effdc5579f914e76$export$2e2bcd8739ae039 = $effdc5579f914e76$var$ChatOptionsPicker;



var $iluxG = parcelRequire("iluxG");
var $63dbb2ef38e1d539$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($63dbb2ef38e1d539$exports, "__esModule", {
    value: true
});
$63dbb2ef38e1d539$exports.default = void 0;

var $63dbb2ef38e1d539$var$_react = $h59lg((parcelRequire("iluxG")));

var $63dbb2ef38e1d539$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $63dbb2ef38e1d539$var$_default = (0, $63dbb2ef38e1d539$var$_createSvgIcon.default)($63dbb2ef38e1d539$var$_react.default.createElement("path", {
    d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
}), "Wifi");
$63dbb2ef38e1d539$exports.default = $63dbb2ef38e1d539$var$_default;


function $456b89e92739672b$var$InternetConnectionWarning(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            border: "1px solid #F0706F",
            maxWidth: "85%",
            margin: "auto",
            marginTop: 10,
            marginBottom: 20,
            padding: 10,
            display: "grid",
            gridTemplateColumns: "35px auto",
            color: "#F53D3D",
            fontSize: ".85em"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63dbb2ef38e1d539$exports))), {
        style: {
            height: 30,
            width: 30,
            fill: "#F0706F"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginLeft: 10
        }
    }, "Your internet connection is too weak to send or receive messages. Please check your connection."));
}
var $456b89e92739672b$export$2e2bcd8739ae039 = $456b89e92739672b$var$InternetConnectionWarning;



var $iluxG = parcelRequire("iluxG");


var $7ZPk1 = parcelRequire("7ZPk1");

var $anj8u = parcelRequire("anj8u");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $9iccj = parcelRequire("9iccj");

var $kmV9n = parcelRequire("kmV9n");




var $ff30ca02b85cbd11$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: "none"
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: "underline"
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        "-moz-appearance": "none",
        // Reset
        "-webkit-appearance": "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        "&$focusVisible": {
            outline: "auto"
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $ff30ca02b85cbd11$var$Link = /*#__PURE__*/ $iluxG.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0, $anj8u.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $55e79ef0851280da$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $iluxG.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $iluxG.createElement((0, $53bb0af5ec193243$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, classes["underline".concat((0, $9iccj.default)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $ff30ca02b85cbd11$export$2e2bcd8739ae039 = (0, $kmV9n.default)($ff30ca02b85cbd11$export$9dd6ff9ea0189349, {
    name: "MuiLink"
})($ff30ca02b85cbd11$var$Link);






const $0faae980366a19f0$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        buttonText: {
            textTransform: "none"
        }
    }));
function $0faae980366a19f0$var$CTAButton(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = $0faae980366a19f0$var$useStyles();
    const conversationEvent = props.conversation_event;
    const target = conversationEvent.attributes.data.open_target || "_parent";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $f7ddf2a2c12dcd07$export$2e2bcd8739ae039), {
        component: (0, $ff30ca02b85cbd11$export$2e2bcd8739ae039),
        target: target,
        rel: "noopener",
        href: conversationEvent.attributes.data.url,
        style: {
            backgroundColor: conversationEvent.attributes.data.color,
            color: "white",
            width: "90%",
            marginTop: 10,
            marginBottom: 10,
            marginLeft: "auto",
            marginRight: "auto",
            display: "block",
            textAlign: "center",
            fontWeight: "bold"
        },
        variant: "outlined",
        onClick: ()=>{
            (0, $8108230355f26483$export$a8856a0509e3da2f)({
                token: token,
                chatServiceUrl: chatServiceUrl,
                conversationID: conversationEvent.relationships.conversation.data.id,
                buttonID: conversationEvent.relationships.conversation.data.id
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c9c83073ae40583e$export$2e2bcd8739ae039), {
        text: conversationEvent.attributes.data.label,
        className: classes.buttonText
    })));
}
var $0faae980366a19f0$export$2e2bcd8739ae039 = $0faae980366a19f0$var$CTAButton;



const $1297d0eda3980b3a$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        timeDiv: {
            display: "flex",
            justifyContent: "flex-end",
            fontFamily: "Open Sans, sans serif",
            fontSize: "12px",
            color: "#7C7C7C",
            paddingRight: 10,
            paddingTop: 5
        },
        messageText: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            padding: "4px 12px",
            borderRadius: 16,
            display: "inline-block",
            right: 10
        }
    }));
function $1297d0eda3980b3a$var$ClientMessageRender(props) {
    const classes = $1297d0eda3980b3a$var$useStyles();
    const row = props.message_event;
    let contents;
    if (row.attributes.kind === "chat") {
        let body = row.attributes.body;
        const parser = new DOMParser();
        const doc = parser.parseFromString(body, "text/html");
        body = doc.body.textContent || "";
        contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c9c83073ae40583e$export$2e2bcd8739ae039), {
            key: row.id,
            className: classes.messageText,
            text: body
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "visitor-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "message-list"
    }, contents));
}
function $1297d0eda3980b3a$var$MessageDisplay(props) {
    const { welcomePacket: welcomePacket } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const displayRef = (0, $iluxG.useRef)(null);
    const input_participants = props.participants;
    const participants = {};
    input_participants.reduce((result, item)=>{
        result[item.id] = item;
        return result;
    }, participants);
    const getConversationEvents = props.getConversationEvents;
    const events = props.events;
    const promptsToClosedPromptEvents = props.promptsToClosedPromptEvents;
    const sendChat = props.sendChat;
    const [, setRerender] = (0, $iluxG.useState)(false);
    function scrollToBottom(el) {
        el.scrollTop = el.scrollHeight - el.clientHeight;
    }
    const visitorID = Object.values(participants).filter((p)=>p.attributes.kind === "visitor").map((p)=>p.id)[0];
    const completedDrops = events.filter((event)=>{
        return event.attributes.kind === "drop_complete";
    }).reduce((map, event)=>{
        map[event.attributes.data.drop_id] = event;
        return map;
    }, {});
    const completedTextReminders = events.filter((event)=>{
        return event.attributes.kind === "text_reminder";
    }).reduce((map, event)=>{
        map[event.attributes.data.drop_id] = event;
        return map;
    }, {});
    const completedRatings = events.filter((event)=>{
        return event.attributes.kind === "rating_complete";
    }).reduce((map, event)=>{
        map[event.attributes.data.drop_id] = event;
        return map;
    }, {});
    const timeoutRef = (0, $iluxG.useRef)(null);
    (0, $iluxG.useEffect)(()=>{
        const agentEvents = events.filter((event)=>event.relationships.from_participant.data.id !== visitorID);
        if (agentEvents.length) {
            const lastAgentEvent = agentEvents[agentEvents.length - 1];
            if (lastAgentEvent.attributes.kind === "join" && lastAgentEvent.attributes.data.from === "route") {
                const remainingTime = welcomePacket.fallback_timer * 1000 - (new Date() - new Date(lastAgentEvent.attributes.created_timestamp));
                timeoutRef.current = setTimeout(()=>setRerender(true), remainingTime);
            }
        }
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    });
    function group_events(events, participants) {
        const output = [];
        let current_group = {
            messages: [],
            participant_name: "",
            participant_kind: "",
            participant_id: "",
            avatarUrl: ""
        };
        let current_timestamp = null;
        let last_from_id = null;
        let event = null;
        for(let i = 0; i < events.length; i++){
            event = events[i];
            const participant_id = event.relationships.from_participant.data.id;
            let participant = participants[participant_id];
            current_timestamp = event.attributes.created_timestamp;
            if (!participant) participant = {
                attributes: {
                    kind: "agent",
                    avatarUrl: ""
                }
            };
            if (event.attributes.kind === "option_prompt") {
                if (current_group.messages.length) {
                    output.push(current_group);
                    current_group = {
                        messages: [],
                        participant_name: "",
                        participant_kind: "",
                        participant_id: "",
                        avatarUrl: ""
                    };
                }
                last_from_id = null;
                output.push({
                    type: "option_prompt",
                    event_id: event.id,
                    timestamp: current_timestamp,
                    data: event
                });
                continue;
            }
            if (event.attributes.kind === "option_prompt_free") {
                if (current_group.messages.length) {
                    output.push(current_group);
                    current_group = {
                        messages: [],
                        participant_name: "",
                        participant_kind: "",
                        participant_id: "",
                        avatarUrl: ""
                    };
                }
                last_from_id = null;
                output.push({
                    type: "option_prompt_free",
                    event_id: event.id,
                    timestamp: current_timestamp,
                    data: event
                });
                continue;
            }
            if (event.attributes.kind === "cta_button") {
                if (current_group.messages.length) {
                    output.push(current_group);
                    current_group = {
                        messages: [],
                        participant_name: "",
                        participant_kind: "",
                        participant_id: "",
                        avatarUrl: ""
                    };
                }
                last_from_id = null;
                output.push({
                    type: "cta_button",
                    event_id: event.id,
                    timestamp: current_timestamp,
                    data: event
                });
                continue;
            }
            if (participant_id !== last_from_id || event.attributes.kind === "calendar_drop" || event.attributes.kind === "rating_drop") {
                if (current_group.messages.length) output.push(current_group);
                current_group = {
                    participant_name: event.attributes.participant_name,
                    participant_kind: participant.attributes.kind,
                    participant_id: participant_id,
                    messages: [],
                    timestamp: current_timestamp,
                    avatarUrl: participant.attributes.avatar_url,
                    typing: false
                };
                last_from_id = participant_id;
                if (event.attributes.kind === "calendar_drop") {
                    const calendar_drop_event = {
                        type: "calendar_drop",
                        event_id: event.id,
                        user_id: participant.attributes.user_id,
                        timestamp: current_timestamp,
                        data: event.attributes.data
                    };
                    output.push(calendar_drop_event);
                    last_from_id = null;
                    continue;
                } else if (event.attributes.kind === "rating_drop") {
                    const rating_drop_event = {
                        type: "rating_drop",
                        event_id: event.id,
                        user_id: participant.attributes.user_id,
                        timestamp: current_timestamp,
                        data: event.attributes.data
                    };
                    output.push(rating_drop_event);
                    last_from_id = null;
                    continue;
                } else if (event.attributes.kind === "fallback") {
                    const fallback_event = {
                        type: "fallback",
                        event_id: event.id,
                        timestamp: current_timestamp,
                        messages: [
                            event
                        ],
                        agent_name: event.attributes.participant_name
                    };
                    output.push(fallback_event);
                    last_from_id = null;
                    continue;
                }
            }
            if (event.attributes.kind === "type") current_group.typing = true;
            else {
                current_group.messages.push(event);
                current_group.timestamp = current_timestamp;
            }
        }
        if (current_group.messages.length || event && event.attributes.kind === "type") output.push(current_group);
        return output;
    }
    (0, $iluxG.useEffect)(()=>{
        if (displayRef.current && props.unconnected) scrollToBottom(displayRef.current);
    }, [
        props.unconnected
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (displayRef.current) scrollToBottom(displayRef.current);
    }, [
        events.length,
        props.currentTypingEvent
    ]);
    const missing_participant_id_count = events.reduce((a, event)=>{
        const participant = participants[event.relationships.from_participant.data.id];
        if (!participant) return a + 1;
        return a;
    }, 0);
    (0, $iluxG.useEffect)(()=>{
        if (missing_participant_id_count) getConversationEvents();
    // eslint-disable-next-line
    }, [
        events.length
    ]);
    if (missing_participant_id_count) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "messages",
        ref: displayRef,
        "data-missing": "yes"
    });
    let welcomeMessage = "";
    let agentName = "";
    function MsgTime(props) {
        const classes = $1297d0eda3980b3a$var$useStyles();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            className: classes.timeDiv
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($7a467367e3b7e49f$exports)))(props.timestamp, "h:MM TT")));
    }
    const filtered_events = events.filter((event)=>[
            "chat",
            "calendar_drop",
            "attachment",
            "option_prompt",
            "option_prompt_free",
            "rating_drop",
            "cta_button"
        ].includes(event.attributes.kind));
    if (props.currentTypingEvent) filtered_events.push(props.currentTypingEvent);
    const grouped_events = group_events(filtered_events, participants);
    let meta = null;
    let agent_name = null;
    if (props.activeConversation) {
        meta = props.activeConversation.attributes.meta;
        agent_name = meta.first_send_type === "user" ? meta.first_agent_name : meta.bot_name;
    }
    if (props.loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    if (props.activeConversation && meta.message_prompt) {
        welcomeMessage = meta.message_prompt;
        agentName = agent_name;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "messages",
        ref: displayRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, welcomeMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $73060cd1fe3c445d$export$2e2bcd8739ae039), {
        key: "prompt",
        messages: [
            {
                id: "prompt",
                attributes: {
                    body: welcomeMessage
                }
            }
        ],
        agent_name: agentName,
        bot: false,
        avatarUrl: props.botAvatar
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, grouped_events.map((group)=>{
        if (group.type === "calendar_drop") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $2822d2dfb27fd7b2$export$2e2bcd8739ae039), {
            event: group,
            key: group.event_id,
            completedDrops: completedDrops,
            completedTextReminders: completedTextReminders
        });
        if (group.type === "rating_drop") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $894b3a5b994c6912$export$2e2bcd8739ae039), {
            event_id: group.event_id,
            key: group.event_id,
            ratingType: group.data.rating_type,
            completedRatings: completedRatings
        });
        if (group.type === "fallback") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            style: {
                marginBottom: 7
            },
            key: group.event_id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $73060cd1fe3c445d$export$2e2bcd8739ae039), {
            messages: group.messages,
            agent_name: group.agent_name,
            avatarUrl: props.botAvatar,
            bot: false,
            typing: group.typing
        }));
        if (group.type === "cta_button") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $0faae980366a19f0$export$2e2bcd8739ae039), {
            key: group.event_id,
            conversation_event: group.data
        });
        if (group.type === "option_prompt" || group.type === "option_prompt_free") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $effdc5579f914e76$export$2e2bcd8739ae039), {
            key: group.event_id,
            conversation_event: group.data,
            options: group.data.attributes.data.options,
            completedDrops: completedDrops,
            promptsToClosedPromptEvents: promptsToClosedPromptEvents,
            chooseValue: (value, prompt, options)=>{
                sendChat(value, {
                    bot_response: {
                        flow_id: prompt.attributes.data.bot.flow_id,
                        node_id: prompt.attributes.data.bot.node_id,
                        consent_event_id: prompt.attributes.data.bot.consent_event_id,
                        response_to_event_id: prompt.id,
                        options: options
                    }
                });
            }
        });
        if ([
            "agent",
            "bot"
        ].includes(group.participant_kind)) {
            const key = group.messages.length ? group.messages[0].id : 0;
            const isCloudAgent = group.participant_id === props.botParticipantID && props.cloudAgentName && props.cloudAgentAvatar;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $73060cd1fe3c445d$export$2e2bcd8739ae039), {
                key: key,
                messages: group.messages,
                agent_name: isCloudAgent ? props.cloudAgentName : group.participant_name,
                avatarUrl: isCloudAgent ? props.cloudAgentAvatar : group.avatarUrl,
                typing: group.typing
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            key: group.messages[0].id,
            style: {
                padding: "5px 0px 0px 0px"
            }
        }, group.messages.map((row)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($1297d0eda3980b3a$var$ClientMessageRender, {
                key: row.id,
                message_event: row
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement(MsgTime, {
            timestamp: group.timestamp
        }));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            display: props.unconnected ? null : "none"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $456b89e92739672b$export$2e2bcd8739ae039), null)));
}
var $1297d0eda3980b3a$export$2e2bcd8739ae039 = $1297d0eda3980b3a$var$MessageDisplay;



var $iluxG = parcelRequire("iluxG");

function $bebb9dff539fa239$var$PromptMessageDisplay(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c9c83073ae40583e$export$2e2bcd8739ae039), {
        className: "prompt-message-display",
        text: props.message,
        rich: "true"
    });
}
var $bebb9dff539fa239$export$2e2bcd8739ae039 = $bebb9dff539fa239$var$PromptMessageDisplay;



var $iluxG = parcelRequire("iluxG");


var $2b1d76e1452b3180$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($2b1d76e1452b3180$exports, "__esModule", {
    value: true
});
$2b1d76e1452b3180$exports.default = void 0;

var $2b1d76e1452b3180$var$_react = $h59lg((parcelRequire("iluxG")));

var $2b1d76e1452b3180$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $2b1d76e1452b3180$var$_default = (0, $2b1d76e1452b3180$var$_createSvgIcon.default)($2b1d76e1452b3180$var$_react.default.createElement("path", {
    d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
}), "List");
$2b1d76e1452b3180$exports.default = $2b1d76e1452b3180$var$_default;





const $c5aee6293732106e$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        labelDiv: {
            marginLeft: 8,
            display: "flex",
            alignItems: "center"
        },
        button: {
            height: 35,
            width: 35,
            color: "#FFFFFF"
        },
        buttonRoot: {
            padding: 0
        },
        mobileChatHeader: {
            display: "grid",
            gridTemplateColumns: "8fr 1fr 1fr",
            gridGap: 10,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontSize: "16px",
            fontWeight: 600,
            padding: "10px 10px 10px 15px",
            alignItems: "center"
        }
    }));
function $c5aee6293732106e$var$MobileChatHeader(props) {
    const classes = $c5aee6293732106e$var$useStyles();
    const size = 35;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.mobileChatHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "mobile-chat-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        size: size,
        bot: props.bot
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.labelDiv
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $4d404e6faf648081$export$2e2bcd8739ae039), {
        conversationLabel: props.conversationLabel,
        phone: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: props.showConversationHistory,
        className: classes.button,
        classes: {
            root: classes.buttonRoot
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2b1d76e1452b3180$exports))), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: props.closeChat,
        className: classes.button,
        classes: {
            root: classes.buttonRoot
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($36d06990be6f9b9a$exports))), null)));
}
var $c5aee6293732106e$export$2e2bcd8739ae039 = $c5aee6293732106e$var$MobileChatHeader;



var $bcff0f12309f73ad$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($bcff0f12309f73ad$exports, "__esModule", {
    value: true
});
$bcff0f12309f73ad$exports.default = void 0;

var $bcff0f12309f73ad$var$_react = $h59lg((parcelRequire("iluxG")));

var $bcff0f12309f73ad$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $bcff0f12309f73ad$var$_default = (0, $bcff0f12309f73ad$var$_createSvgIcon.default)($bcff0f12309f73ad$var$_react.default.createElement("path", {
    d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
}), "Send");
$bcff0f12309f73ad$exports.default = $bcff0f12309f73ad$var$_default;


var $228104ee7ac7ff42$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($228104ee7ac7ff42$exports, "__esModule", {
    value: true
});
$228104ee7ac7ff42$exports.default = void 0;

var $228104ee7ac7ff42$var$_react = $h59lg((parcelRequire("iluxG")));

var $228104ee7ac7ff42$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $228104ee7ac7ff42$var$_default = (0, $228104ee7ac7ff42$var$_createSvgIcon.default)($228104ee7ac7ff42$var$_react.default.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
}), "Mood");
$228104ee7ac7ff42$exports.default = $228104ee7ac7ff42$var$_default;


var $4861156fedf43e4d$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($4861156fedf43e4d$exports, "__esModule", {
    value: true
});
$4861156fedf43e4d$exports.default = void 0;

var $4861156fedf43e4d$var$_react = $h59lg((parcelRequire("iluxG")));

var $4861156fedf43e4d$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $4861156fedf43e4d$var$_default = (0, $4861156fedf43e4d$var$_createSvgIcon.default)($4861156fedf43e4d$var$_react.default.createElement("path", {
    d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), "HighlightOff");
$4861156fedf43e4d$exports.default = $4861156fedf43e4d$var$_default;



var $iluxG = parcelRequire("iluxG");






function $4a0d445a81818c10$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $4a0d445a81818c10$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $4a0d445a81818c10$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
    var movedRef = $iluxG.useRef(false);
    var nodeRef = $iluxG.useRef(null);
    var mountedRef = $iluxG.useRef(false);
    var syntheticEventRef = $iluxG.useRef(false);
    $iluxG.useEffect(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $iluxG.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $9146dba4fa405fbb$exports.findDOMNode(instance);
    }, []);
    var handleRef = (0, $609081843146ef3d$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $5fc57e9807af8404$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!mountedRef.current || !nodeRef.current || $4a0d445a81818c10$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $iluxG.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $4a0d445a81818c10$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $iluxG.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $4a0d445a81818c10$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $5ea799cebb9a96c8$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $iluxG.createElement($iluxG.Fragment, null, /*#__PURE__*/ $iluxG.cloneElement(children, childrenProps));
}
var $4a0d445a81818c10$export$2e2bcd8739ae039 = $4a0d445a81818c10$var$ClickAwayListener;



var $iluxG = parcelRequire("iluxG");

const $b65dce88c1faafe8$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        emojiButton: {
            backgroundColor: "white",
            border: "none",
            padding: "2px",
            "&:hover": {
                backgroundColor: theme.palette.primary.main
            },
            borderRadius: "5px"
        }
    }));
const $b65dce88c1faafe8$var$EmojiPickerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).forwardRef(function EmojiPicker(props, ref) {
    const classes = $b65dce88c1faafe8$var$useStyles(props);
    const emojiList = [
        "\uD83D\uDE42",
        "\uD83D\uDE00",
        "\uD83D\uDE10",
        "\uD83E\uDD29",
        "\uD83D\uDC4D",
        "\uD83D\uDC4E",
        "\uD83E\uDD14",
        "\uD83D\uDE2C",
        "\uD83D\uDE2E",
        "❤️",
        "\uD83D\uDE41",
        "\uD83D\uDE20",
        "\uD83D\uDE4F",
        "\uD83D\uDE02",
        "\uD83D\uDC46",
        "\uD83D\uDC47"
    ];
    const myRef = (0, $iluxG.useRef)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        ref: ref,
        style: {
            display: "block",
            width: "0x",
            height: "0px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "cf-emoji-picker",
        ref: myRef,
        ...props
    }, emojiList.map((emoji, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("button", {
            className: classes.emojiButton,
            key: index,
            onClick: ()=>{
                props.onSelect({
                    native: emoji
                });
            }
        }, emoji);
    })));
});
var $b65dce88c1faafe8$export$2e2bcd8739ae039 = $b65dce88c1faafe8$var$EmojiPickerRef;




const $68ef3417c5409d08$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        mobileSendButton: {
            paddingTop: "12px",
            cursor: "pointer",
            "&:hover svg": {
                color: theme.palette.primary.main
            },
            position: "absolute",
            right: 16
        },
        mobileSendButtonReady: {
            paddingTop: "12px",
            cursor: "pointer",
            "&:hover svg": {
                color: theme.palette.primary.main
            }
        },
        mobileInput: {
            borderBottom: "none",
            borderLeft: "none",
            borderRight: "none",
            borderTop: "none",
            display: "block",
            "&:focus": {
                outline: "0px"
            },
            lineHeight: "normal",
            backgroundColor: "transparent",
            paddingLeft: 8
        },
        controlButton: {
            color: "#999999",
            cursor: "pointer",
            "&:hover": {
                color: theme.palette.primary.main
            }
        },
        controlButtonReady: {
            color: "#287cc2",
            cursor: "pointer",
            "&:hover": {
                color: theme.palette.primary.main
            }
        },
        mobileChatBody: {
            backgroundColor: "#FFFFFF",
            border: "1px solid #C5C5C5",
            fontFamily: "Open Sans",
            overflow: "scroll"
        },
        mobilePowered: {
            height: 40,
            width: "100%",
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#999999"
        },
        logo: {
            marginRight: 5
        },
        anchor: {
            marginLeft: 4,
            textDecoration: "none",
            color: "#999999"
        },
        mobilePoweredInner: {
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
        },
        ieInputBox: {
            width: "100%",
            paddingLeft: "10px",
            paddingRight: "10px",
            height: "2em"
        }
    }));
function $68ef3417c5409d08$var$ChatWindow(props) {
    const { token: token, chatServiceUrl: chatServiceUrl } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = $68ef3417c5409d08$var$useStyles();
    const [openEmojiPicker, setOpenEmojiPicker] = (0, $iluxG.useState)(false);
    const [contentHTML, setContentHTML] = (0, $iluxG.useState)("");
    const inputMessageRef = (0, $iluxG.useRef)(null);
    const rangeRef = (0, $iluxG.useRef)(null);
    const maxMessageLength = 4000;
    const [remainingChars, setRemainingChars] = (0, $iluxG.useState)(maxMessageLength);
    const openChatPrompt = props.openChatPrompt;
    const chatPromptState = props.chatPromptState;
    const sendChat = props.sendChat;
    const setDisplayState = props.setDisplayState;
    const promptsToClosedPromptEvents = props.promptsToClosedPromptEvents;
    const events = props.events.filter((i)=>i.attributes.kind !== "join");
    const participants = props.participants;
    const visitorParticipantId = participants.find((p)=>p.attributes.kind === "visitor")?.id;
    const getConversationEvents = props.getConversationEvents;
    const activeConversation = props.activeConversation;
    const sendChatOrCreateRef = props.sendChatOrCreateRef;
    const unconnected = props.unconnected;
    const [promptDisabled, setPromptDisabled] = (0, $iluxG.useState)(![
        "end",
        "chat",
        "option_free"
    ].includes(chatPromptState));
    const [promptPlaceholder, setPromptPlaceholder] = (0, $iluxG.useState)("Type your message...");
    const allowMultipleMessages = props.majorChatEvents.agentBeenRouted || props.majorChatEvents.agentHasChatted || props.majorChatEvents.botFlowEnded;
    (0, $iluxG.useEffect)(()=>{
        setPromptDisabled(![
            "end",
            "chat",
            "option_free"
        ].includes(chatPromptState));
        if (chatPromptState === "option") setPromptPlaceholder("Choose an option above...");
        else if (!promptDisabled) {
            if (events[events.length - 2] && events[events.length - 2].attributes.kind === "cta_button") {
                setPromptPlaceholder("Click the button link above...");
                setPromptDisabled(true);
            } else setPromptPlaceholder("Type your message...");
        }
    }, [
        chatPromptState
    ]);
    // We don't want to allow the user to send multiple messages in a row unless an Agent is involved in the chat.
    // This code watches the events, and disables the visitor from sending another message if they just sent one,
    // until the bot or agent responds.
    (0, $iluxG.useEffect)(()=>{
        if (!allowMultipleMessages) {
            if (events.length > 0 && events[events.length - 1].attributes.kind === "chat" && events[events.length - 1].relationships.from_participant.data.id !== visitorParticipantId) {
                setPromptDisabled(false);
                setPromptPlaceholder("Type your message...");
            } else if (events.length > 0 && [
                "chat",
                "option_prompt",
                "option_prompt_free"
            ].includes(events[events.length - 1].attributes.kind) && events[events.length - 1].relationships.from_participant.data.id === visitorParticipantId) {
                setPromptDisabled(true);
                setPromptPlaceholder("Please wait...");
            }
        }
    }, [
        events
    ]);
    // If an agent has joined the chat or the bot flow had ended, we want to allow the visitor to send multiple messages.
    (0, $iluxG.useEffect)(()=>{
        if (allowMultipleMessages) {
            setPromptDisabled(false);
            setPromptPlaceholder("Type your message...");
        }
    }, [
        props.majorChatEvents,
        allowMultipleMessages
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (chatPromptState === "chat" && inputMessageRef.current) inputMessageRef.current.focus();
    }, [
        inputMessageRef,
        chatPromptState,
        promptDisabled
    ]);
    const handlePaste = (event)=>{
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData).getData("text");
        const text = inputMessageRef.current.innerText;
        const newText = text + paste;
        if (newText.length > maxMessageLength) {
            const truncatedText = newText.substring(0, maxMessageLength);
            inputMessageRef.current.innerText = truncatedText;
            setRemainingChars(0);
        } else {
            inputMessageRef.current.innerText = newText;
            setRemainingChars(maxMessageLength - newText.length);
        }
        setContentHTML(inputMessageRef.current.innerHTML);
        placeCaretAtEnd(inputMessageRef.current);
    };
    const sendInputChat = function() {
        const emoji_imgs = inputMessageRef.current.querySelectorAll("img");
        for(let i = 0; i < emoji_imgs.length; i++){
            const el = emoji_imgs[i];
            const new_el = document.createTextNode(el.alt);
            el.parentNode.replaceChild(new_el, el);
        }
        const text = inputMessageRef.current.innerText;
        if (text.length && text !== "\n") {
            setContentHTML("");
            inputMessageRef.current.innerHTML = "";
            rangeRef.current = null;
            sendChatOrCreateRef.current(text);
            inputMessageRef.current.focus();
        }
    };
    const sendInputChatMobile = function(event) {
        event.preventDefault();
        const text = inputMessageRef.current.value;
        if (text !== "" && text !== "\n") {
            setContentHTML("");
            inputMessageRef.current.value = "";
            rangeRef.current = null;
            sendChatOrCreateRef.current(text);
            inputMessageRef.current.focus();
        }
    };
    function placeCaretAtEnd(el) {
        el.focus();
        if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange !== "undefined") {
            const textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    }
    function onEmojiSelect(stuff) {
        setOpenEmojiPicker(false);
        const el = createEmojiElement(stuff);
        inputMessageRef.current.appendChild(el);
        inputMessageRef.current.focus();
        inputMessageRef.current.innerHTML = inputMessageRef.current.innerHTML.replace("<br>", "");
        placeCaretAtEnd(inputMessageRef.current);
        setContentHTML(inputMessageRef.current.innerHTML);
    }
    function contentHTMLChanged(event) {
        if (activeConversation) {
            const oldText = contentHTML.replace("<br>", "").trim();
            const newText = event.target.value.replace("<br>", "").trim();
            setRemainingChars(maxMessageLength - newText.length);
            if (oldText === "" && newText === "") return;
            if (oldText === "") (0, $8108230355f26483$export$d27c9815c6b3753f)({
                conversationID: activeConversation.id,
                token: token,
                chatServiceUrl: chatServiceUrl
            });
            if (newText === "") (0, $8108230355f26483$export$2c28f69fbea80beb)({
                conversationID: activeConversation.id,
                token: token,
                chatServiceUrl: chatServiceUrl
            });
        }
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        rangeRef.current = range;
        setContentHTML(event.target.value);
    }
    const keyPressed = function(event) {
        const text = inputMessageRef.current.innerText;
        if (text.length >= maxMessageLength && event.key !== "Backspace" && event.key !== "Enter") {
            event.preventDefault();
            return;
        }
        if (event.key === "Enter") {
            event.preventDefault();
            const emoji_imgs = inputMessageRef.current.querySelectorAll("img");
            for(let i = 0; i < emoji_imgs.length; i++){
                const el = emoji_imgs[i];
                const new_el = document.createTextNode(el.alt);
                el.parentNode.replaceChild(new_el, el);
            }
            const text = inputMessageRef.current.innerText;
            if (text !== "" && text !== "\n") {
                setContentHTML("");
                inputMessageRef.current.innerHTML = "";
                rangeRef.current = null;
                sendChatOrCreateRef.current(text);
            }
            setRemainingChars(maxMessageLength);
        }
    };
    const keyPressedPhone = function(event) {
        const text = inputMessageRef.current.innerText;
        if (text.length >= maxMessageLength && event.key !== "Backspace" && event.key !== "Enter") {
            event.preventDefault();
            return;
        }
        if (event.key === "Enter") {
            event.preventDefault();
            const text = inputMessageRef.current.value;
            if (text !== "" && text !== "\n") {
                setContentHTML("");
                inputMessageRef.current.value = "";
                rangeRef.current = null;
                sendChatOrCreateRef.current(text);
            }
            setRemainingChars(maxMessageLength);
        }
    };
    function createEmojiElement(emoji) {
        const el = document.createElement("span");
        el.innerHTML = emoji.native;
        el.setAttribute("style", "width: 1.2em; height: 1.2em; margin: 0px 0.05em 0px 0.1em; vertical-align: -0.1em;");
        return el;
    }
    const loading = false;
    let message = "";
    if (events) {
        const chatEvents = events.filter((item)=>{
            return item.attributes.kind === "chat";
        });
        if (chatEvents.length) message = chatEvents[0].attributes.body;
    }
    if (props.phone && !props.bigPrompt) {
        let inputMode = "";
        if (openChatPrompt && openChatPrompt.attributes.kind === "email_prompt") inputMode = "email";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, props.mode === "landing-page" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c5aee6293732106e$export$2e2bcd8739ae039), {
            avatarUrl: props.avatarUrl,
            conversationLabel: props.conversationLabel,
            bot: props.bot,
            showConversationHistory: props.showConversationHistory,
            closeChat: props.closeChat
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            className: "chat-box-bottom-mobile",
            style: {
                height: props.mode === "landing-page" ? "100%" : undefined
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $1297d0eda3980b3a$export$2e2bcd8739ae039), {
            events: events,
            participants: participants,
            getConversationEvents: getConversationEvents,
            activeConversation: activeConversation,
            loading: loading,
            promptsToClosedPromptEvents: promptsToClosedPromptEvents,
            sendChat: sendChat,
            unconnected: unconnected,
            currentTypingEvent: props.currentTypingEvent,
            phone: props.phone,
            botParticipantID: props.botParticipantID,
            cloudAgentName: props.cloudAgentName,
            cloudAgentAvatar: props.cloudAgentAvatar
        }), !(chatPromptState === "option" && props.mode.startsWith("modal")) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            id: "controls-mobile"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("input", {
            className: classes.mobileInput,
            type: "text",
            placeholder: promptPlaceholder,
            inputMode: inputMode,
            value: contentHTML,
            onChange: (e)=>setContentHTML(e.target.value),
            onKeyDown: keyPressedPhone,
            disabled: promptDisabled,
            onFocus: ()=>{
                setDisplayState("open");
            },
            ref: inputMessageRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            className: classes.mobileSendButton,
            onClick: sendInputChatMobile
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcff0f12309f73ad$exports))), {
            className: contentHTML ? classes.controlButtonReady : classes.controlButton
        })))));
    }
    if (props.bigPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        onClick: ()=>setDisplayState("open"),
        style: {
            cursor: "pointer"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $6561d0442a30572e$export$2e2bcd8739ae039), {
        mode: props.mode,
        avatarUrl: props.avatarUrl,
        conversationLabel: props.conversationLabel,
        bot: props.bot,
        showConversationHistory: props.showConversationHistory,
        bigPrompt: props.bigPrompt
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "chat-box-bottom-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $bebb9dff539fa239$export$2e2bcd8739ae039), {
        message: message.replace(/<p>/g, "").replace(/<\/p>/g, "\n")
    })));
    const CharacterCounter = !(chatPromptState === "option" && props.mode.startsWith("modal")) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("hr", {
        style: {
            width: "100%",
            borderTop: ".5pt solid #cccccc",
            display: remainingChars < 500 ? "block" : "none"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            marginLeft: "10px",
            marginBottom: "10px",
            color: remainingChars < 100 ? "red" : "black"
        }
    }, remainingChars < 500 && `${remainingChars} characters remaining`));
    const textEntryComponent = !(chatPromptState === "option" && props.mode.startsWith("modal")) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "controls"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            position: "relative",
            wordWrap: "break-word",
            overflowY: "auto"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            zIndex: 1,
            paddingTop: 8,
            paddingLeft: 12,
            paddingBottom: 8,
            color: "#696969",
            position: "absolute",
            display: contentHTML ? "none" : "block"
        }
    }, promptPlaceholder), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ef6eeefd9028b3c7$exports))), {
        style: {
            zIndex: 2,
            background: "transparent 0 0 repeat scroll",
            width: "calc(100% - 90px)",
            position: "relative",
            paddingTop: 8,
            paddingLeft: 12,
            paddingBottom: 8
        },
        className: classes.mobileInput,
        innerRef: inputMessageRef,
        autoFocus: true,
        html: contentHTML,
        disabled: promptDisabled,
        onChange: contentHTMLChanged,
        onKeyDown: keyPressed,
        onPaste: handlePaste,
        onFocus: ()=>{
            setDisplayState("open");
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            paddingTop: "12px",
            display: promptDisabled ? "none" : "block",
            position: "absolute",
            right: 48
        }
    }, openEmojiPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        onMouseDown: (e)=>{
            e.preventDefault();
            setOpenEmojiPicker(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4861156fedf43e4d$exports))), {
        className: classes.controlButton
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $4a0d445a81818c10$export$2e2bcd8739ae039), {
        onClickAway: ()=>{
            setOpenEmojiPicker(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $b65dce88c1faafe8$export$2e2bcd8739ae039), {
        onSelect: onEmojiSelect,
        style: {
            position: "absolute",
            bottom: "45px",
            right: "50px",
            width: "120px",
            zIndex: 3
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        onMouseDown: (e)=>{
            e.preventDefault();
            setOpenEmojiPicker(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($228104ee7ac7ff42$exports))), {
        className: classes.controlButton
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.mobileSendButton,
        onClick: sendInputChat,
        style: {
            display: promptDisabled ? "none" : "block"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcff0f12309f73ad$exports))), {
        className: contentHTML ? classes.controlButtonReady : classes.controlButton
    })));
    const contentHeader = props.mode === "content-with-header" || props.mode.startsWith("modal");
    let className = props.fullScreen ? "fullscreen" : null;
    if (props.mode.startsWith("modal")) className = props.mode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, props.mode === "content" || props.mode === "landing-page" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $6561d0442a30572e$export$2e2bcd8739ae039), {
        avatarUrl: props.avatarUrl,
        conversationLabel: props.conversationLabel,
        showConversationHistory: props.showConversationHistory,
        bigPrompt: props.bigPrompt,
        fullScreen: props.fullScreen,
        closeChat: props.closeChat,
        contentHeader: contentHeader,
        mode: props.mode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "chat-box-bottom-normal",
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $1297d0eda3980b3a$export$2e2bcd8739ae039), {
        events: events,
        participants: participants,
        getConversationEvents: getConversationEvents,
        activeConversation: activeConversation,
        loading: loading,
        promptsToClosedPromptEvents: promptsToClosedPromptEvents,
        sendChat: sendChat,
        botAvatar: props.avatarUrl,
        unconnected: unconnected,
        currentTypingEvent: props.currentTypingEvent,
        botParticipantID: props.botParticipantID,
        cloudAgentName: props.cloudAgentName,
        cloudAgentAvatar: props.cloudAgentAvatar
    }), textEntryComponent, CharacterCounter));
}
var $68ef3417c5409d08$export$2e2bcd8739ae039 = $68ef3417c5409d08$var$ChatWindow;



var $iluxG = parcelRequire("iluxG");






function $8d27dae9dcc0a0ea$export$5713a33d0ba09e8d({ image: image, primary: primary, secondary: secondary }) {
    switch(image){
        case "new_conversation":
            return `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <defs><style>.cls-1{fill:${primary};}.cls-2{fill:${secondary};}</style></defs><title>Convo History_New Conversation_Rollover</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Chat_History" data-name="Chat History">
          <path class="cls-2" d="M22.5,9.05A1.5,1.5,0,0,0,21,7.55H9a1.51,1.51,0,0,0-1.5,1.5v9A1.5,1.5,0,0,0,9,19.55H19.5l3,3ZM18,14.3H15.75v2.25a.75.75,0,0,1-1.5,0V14.3H12a.75.75,0,0,1,0-1.5h2.25V10.55a.75.75,0,0,1,1.5,0V12.8H18a.75.75,0,0,1,0,1.5Z"/>
        </g>
      </g>
    </svg>
    `;
        case "prompt":
        default:
            return `
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 1000 1000" style="enable-background:new 0 0 1000 1000;" xml:space="preserve">
      <style type="text/css">
        .st0{fill:${secondary};}
      </style>
      <g>
        <g>
          <path class="st0" d="M835.54,576.73c-31.47-96.79-122.36-166.77-229.64-166.77h-73.79v-58.67c28-12.42,47.56-40.41,47.56-73.02
            c0-44.12-35.76-79.88-79.88-79.88s-79.88,35.76-79.88,79.88c0,32.6,19.56,60.6,47.56,73.02v58.67h-73.79
            c-107.28,0-198.17,69.98-229.64,166.77c-36.48,5.39-64.5,36.73-64.5,74.71c0,37.97,28.02,69.32,64.5,74.71
            c31.47,96.79,122.36,166.77,229.64,166.77h129.97l182.42,97.35c11.31,6.04,23.57-6.29,17.47-17.57l-48.63-89.85
            c75.94-22.62,136.19-81.57,160.62-156.71c36.48-5.39,64.5-36.73,64.5-74.71C900.04,613.46,872.02,582.12,835.54,576.73z
              M605.9,853.89H393.69c-111.63,0-202.45-90.82-202.45-202.45c0-111.63,90.82-202.45,202.45-202.45H605.9
            c111.63,0,202.45,90.82,202.45,202.45S717.53,853.89,605.9,853.89z"/>
          <circle class="st0" cx="342.95" cy="606.06" r="72.21"/>
          <circle class="st0" cx="577.11" cy="606.06" r="72.21"/>
        </g>
        <g>
          <path class="st0" d="M355.4,292.91H244.16c-8.08,0-14.64-6.55-14.64-14.64c0-8.08,6.55-14.64,14.64-14.64H355.4
            c8.08,0,14.64,6.55,14.64,14.64C370.03,286.35,363.48,292.91,355.4,292.91z"/>
          <path class="st0" d="M755.43,292.91H644.18c-8.08,0-14.64-6.55-14.64-14.64c0-8.08,6.55-14.64,14.64-14.64h111.24
            c8.08,0,14.64,6.55,14.64,14.64C770.06,286.35,763.51,292.91,755.43,292.91z"/>
        </g>
        <g>
          <path class="st0" d="M397.69,190.8c-3.74,0-7.49-1.43-10.35-4.29l-78.65-78.65c-5.72-5.71-5.72-14.98,0-20.7
            c5.72-5.72,14.98-5.72,20.7,0l78.65,78.65c5.72,5.71,5.72,14.98,0,20.7C405.18,189.37,401.43,190.8,397.69,190.8z"/>
        </g>
        <g>
          <path class="st0" d="M601.89,190.8c-3.74,0-7.49-1.43-10.35-4.29c-5.72-5.71-5.72-14.98,0-20.7l78.65-78.65
            c5.72-5.72,14.98-5.72,20.7,0c5.72,5.71,5.72,14.98,0,20.7l-78.65,78.65C609.38,189.37,605.64,190.8,601.89,190.8z"/>
        </g>
        <g>
          <path class="st0" d="M499.79,148.51c-8.08,0-14.64-6.55-14.64-14.64V22.64c0-8.08,6.55-14.64,14.64-14.64
            c8.08,0,14.64,6.55,14.64,14.64v111.24C514.43,141.96,507.88,148.51,499.79,148.51z"/>
        </g>
      </g>
    </svg>
    `;
    }
}



var $iluxG = parcelRequire("iluxG");

var $iluxG = parcelRequire("iluxG");
/* istanbul ignore next */ /** keep typescript happy */ var $482fcba22f95494c$var$noop = function() {};
function $482fcba22f95494c$export$f4b266cd2aae9cb1(callback, delay, immediate) {
    var savedCallback = (0, $iluxG.useRef)($482fcba22f95494c$var$noop);
    // Remember the latest callback.
    (0, $iluxG.useEffect)(function() {
        savedCallback.current = callback;
    });
    // Execute callback if immediate is set.
    (0, $iluxG.useEffect)(function() {
        if (!immediate) return;
        if (delay === null || delay === false) return;
        savedCallback.current();
    }, [
        immediate
    ]);
    // Set up the interval.
    (0, $iluxG.useEffect)(function() {
        if (delay === null || delay === false) return undefined;
        var tick = function() {
            return savedCallback.current();
        };
        var id = setInterval(tick, delay);
        return function() {
            return clearInterval(id);
        };
    }, [
        delay
    ]);
}
var $482fcba22f95494c$export$2e2bcd8739ae039 = $482fcba22f95494c$export$f4b266cd2aae9cb1;



const $a05b8fc20ddfe6da$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        time: {
            textAlign: "left",
            font: "normal normal normal 11px Open Sans",
            letterSpacing: 0,
            color: "#707070",
            opacity: 1
        }
    }));
function $a05b8fc20ddfe6da$export$2e2bcd8739ae039(props) {
    const classes = $a05b8fc20ddfe6da$var$useStyles();
    const [update, setUpdate] = (0, $iluxG.useState)(false);
    const now = new Date();
    const diffMs = now - new Date(props.time);
    const minutes = diffMs / 60000;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = days / 30;
    const years = days / 365;
    let displayTime = "";
    if (minutes < 0.5) displayTime = "Now";
    else if (minutes < 60) displayTime = Math.round(minutes) + " min";
    else if (days < 1) {
        const hrs = Math.round(hours);
        displayTime = hrs === 1 ? "1 hr" : hrs + " hrs";
    } else if (weeks < 1) {
        const dys = Math.round(days);
        displayTime = dys === 1 ? "1 day" : dys + " days";
    } else if (months < 1) {
        const wks = Math.round(weeks);
        displayTime = wks === 1 ? "1 week" : wks + " wks";
    } else if (years < 1) {
        const mon = Math.round(months);
        displayTime = mon + " mon";
    } else {
        const yrs = Math.round(years);
        displayTime = yrs === 1 ? "1 year" : yrs + " yrs";
    }
    (0, $482fcba22f95494c$export$2e2bcd8739ae039)(()=>{
        setUpdate(!update);
    }, 60000);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.time
    }, displayTime);
}


const $e51daa460753b088$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        historyHeader: {
            backgroundColor: theme.palette.primary.main,
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            color: theme.palette.primary.contrastText,
            fontSize: "20px",
            fontWeight: 600,
            display: "grid",
            gridTemplateColumns: "30px auto 48px",
            gridGap: 20,
            padding: 16,
            alignItems: "center",
            height: 48
        },
        ieTableClassHeader: {
            backgroundColor: theme.palette.primary.main,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
            alignItems: "center",
            padding: "15px 20px 15px 15px",
            fontSize: "20px",
            border: "none",
            width: "100%"
        },
        phoneHeader: {
            fontSize: 16,
            height: 48,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            display: "grid",
            gridTemplateColumns: "30px auto 48px",
            gridGap: 20,
            padding: "4px 16px",
            alignItems: "center"
        },
        phoneConvoList: {
            backgroundColor: "#FFFFFF",
            border: "1px solid #C5C5C5",
            height: "calc(100% - 56px)"
        },
        convoAvatar: {
            justifySelf: "center"
        },
        backButton: {
            height: 35,
            width: 35
        },
        convoButton: {
            height: 48,
            width: 48
        },
        icon: {
            fill: theme.palette.primary.contrastText
        },
        buttonRoot: {
            padding: 0
        },
        badge: {
            color: "white",
            backgroundColor: "red"
        }
    }));
function $e51daa460753b088$var$ConversationListItem(props) {
    const classes = $e51daa460753b088$var$useStyles();
    const convo = props.convo;
    const meta = convo.attributes.meta;
    let agent_name = meta.last_agent_name;
    let avatar = meta.last_agent_avatar;
    const lastMessage = meta.last_message;
    if (!agent_name) {
        if (meta.first_send_type === "user") agent_name = meta.first_agent_name;
        else agent_name = meta.bot_name;
    }
    if (!avatar) avatar = props.botAvatar;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        key: convo.id,
        className: "conversation-list-item",
        onClick: ()=>props.chooseConversation(convo)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: classes.convoAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $8e743497117b4ab9$export$2e2bcd8739ae039), {
        avatarUrl: avatar,
        size: 40
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, agent_name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $a05b8fc20ddfe6da$export$2e2bcd8739ae039), {
        time: lastMessage.timestamp
    }));
}
function $e51daa460753b088$var$ConversationHistory(props) {
    const setShowConversationHistory = props.setShowConversationHistory;
    const conversationList = [
        ...props.conversationList
    ].slice(0, Math.min(15, props.conversationList.length));
    const setActiveConversationId = props.setActiveConversationId;
    const startNewConvo = props.startNewConvo;
    const classes = $e51daa460753b088$var$useStyles();
    const disableNewConversation = props.disableNewConversation || "";
    function chooseConversation(convo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9146dba4fa405fbb$exports))).unstable_batchedUpdates(()=>{
            setActiveConversationId(convo.id);
            setTimeout(()=>setShowConversationHistory(false), 170);
        });
    }
    function clickNewConvo() {
        setActiveConversationId("");
        startNewConvo();
        setShowConversationHistory(false);
    }
    let headerClass = classes.historyHeader;
    let backClass = classes.backButton;
    let convoClass = classes.convoButton;
    let buttonRoot = classes.buttonRoot;
    if (props.phone) {
        headerClass = classes.phoneHeader;
        backClass = null;
        convoClass = null;
        buttonRoot = classes.buttonRoot;
    }
    const primary = props.primaryColor;
    const secondary = props.contrastColor;
    const image = "new_conversation";
    const coloredSVG = (0, $8d27dae9dcc0a0ea$export$5713a33d0ba09e8d)({
        image: image,
        primary: primary,
        secondary: secondary
    });
    const base64data = btoa(unescape(encodeURIComponent(coloredSVG)));
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: headerClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        className: backClass,
        onClick: ()=>setShowConversationHistory(false),
        classes: {
            root: buttonRoot
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daaeca3227173a2d$exports))), {
        className: classes.icon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", null, "Conversations"), disableNewConversation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $da7d31462064561f$export$2e2bcd8739ae039), {
        onClick: clickNewConvo,
        className: convoClass,
        classes: {
            root: buttonRoot
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("img", {
        src: `data:image/svg+xml;base64,${base64data}`,
        height: "40",
        width: "40"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, header, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: props.phone ? classes.phoneConvoList : "conversation-list-holder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "conversation-list"
    }, conversationList.map((convo)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement($e51daa460753b088$var$ConversationListItem, {
            key: convo.id,
            convo: convo,
            chooseConversation: chooseConversation,
            // read={props.readReceipts[convo.id]}
            read: true,
            botAvatar: props.botAvatar
        })))));
}
var $e51daa460753b088$export$2e2bcd8739ae039 = $e51daa460753b088$var$ConversationHistory;



var $iluxG = parcelRequire("iluxG");
const $2168e60feb01f6ab$export$efec460124b14570 = (initialState)=>{
    /** @type {React.Reducer<T, Partial<T>>} */ const reducer = (prevState, updates)=>({
            ...prevState,
            ...updates
        });
    const [state, dispatch] = (0, $iluxG.useReducer)(reducer, initialState);
    /**
   * @param {T} [state]
   * @returns {void}
   */ const reset = (state = initialState)=>dispatch(state);
    return [
        state,
        dispatch,
        reset
    ];
};





var $3LuJG = parcelRequire("3LuJG");
const $61ab0c61cb8221f0$var$theme = (0, $3LuJG.default)({
    palette: {
        primary: {
            main: "#975ce6",
            contrastText: "#FFFFFF"
        },
        secondary: {
            main: "#975ce6"
        }
    }
});
var $61ab0c61cb8221f0$export$2e2bcd8739ae039 = $61ab0c61cb8221f0$var$theme;



var $iluxG = parcelRequire("iluxG");


var $iluxG = parcelRequire("iluxG");
const $48ede9c6dc89e07d$var$useBasicWebsocket = ({ url: url, onMessage: onMessage, onOpen: onOpen, onError: onError, onClose: onClose, shouldReconnect: shouldReconnect, reconnectDelay: reconnectDelay, reconnectDelayBackoff: reconnectDelayBackoff, maxReconnectDelay: maxReconnectDelay, readyToConnect: readyToConnect })=>{
    const socket = (0, $iluxG.useRef)(null);
    const [state, setState] = (0, $iluxG.useState)({
        readyState: null
    });
    const isOpenDoneRef = (0, $iluxG.useRef)(false);
    const sendBuffer = (0, $iluxG.useRef)([]);
    const reconnectDelayRef = (0, $iluxG.useRef)(reconnectDelay || 1000);
    const actualReconnectDelayBackoff = reconnectDelayBackoff || 1;
    const actualMaxReconnectDelay = maxReconnectDelay || 10000;
    const getReconnectDelay = (0, $iluxG.useCallback)(()=>{
        const current = reconnectDelayRef.current;
        const floor = Math.floor(current * Math.max(actualReconnectDelayBackoff, 1));
        reconnectDelayRef.current = Math.min(floor, actualMaxReconnectDelay);
        return current;
    }, [
        actualMaxReconnectDelay,
        actualReconnectDelayBackoff
    ]);
    if (url && (!socket.current || url !== socket.current.url) && readyToConnect) {
        if (socket.current) socket.current.close();
        socket.current = new WebSocket(url);
    }
    if (!url && socket.current) {
        socket.current.close();
        socket.current = null;
    }
    const updateState = ()=>{
        setState((state)=>{
            return {
                ...state,
                readyState: socket.current.readyState
            };
        });
    };
    const drainBuffer = ()=>{
        if (!isOpenDoneRef.current) return;
        if (!socket.current || socket.current && socket.current.readyState !== WebSocket.OPEN) return;
        let msg;
        while((msg = sendBuffer.current.shift()) !== undefined)socket.current.send(msg);
    };
    if (socket.current) {
        socket.current.onmessage = (event)=>{
            onMessage && onMessage({
                event: event,
                socket: socket.current
            });
        };
        socket.current.onerror = (event)=>{
            updateState();
            onError && onError({
                event: event,
                socket: socket.current
            });
        };
        socket.current.onopen = (event)=>{
            reconnectDelayRef.current = reconnectDelay || 1000;
            updateState();
            onOpen && onOpen({
                event: event,
                socket: socket.current
            });
            isOpenDoneRef.current = true;
            drainBuffer();
        };
        socket.current.onclose = (event)=>{
            if (event.target !== socket.current) return;
            updateState();
            if (shouldReconnect && shouldReconnect()) setTimeout(()=>{
                reconnect();
            }, getReconnectDelay());
            isOpenDoneRef.current = false;
            onClose && onClose({
                event: event,
                socket: socket.current
            });
        };
    }
    (0, $iluxG.useEffect)(()=>{
        if (socket.current && socket.current.readyState !== state.readyState) setState((state)=>{
            return {
                ...state,
                readyState: socket.current.readyState
            };
        });
    }, [
        state.readyState
    ]);
    const reconnect = (0, $iluxG.useCallback)(()=>{
        if (socket.current.readyState === WebSocket.OPEN) socket.current.close();
        else {
            socket.current = new WebSocket(url);
            updateState();
        }
    }, [
        url
    ]);
    const sendMessage = (0, $iluxG.useCallback)((msg)=>{
        if (typeof msg !== "string") msg = JSON.stringify(msg);
        sendBuffer.current.push(msg);
        drainBuffer();
    }, []);
    const disconnect = (0, $iluxG.useCallback)(()=>{
        if (socket.current) socket.current.close();
    }, []);
    (0, $iluxG.useEffect)(()=>{
        return ()=>{
            if (socket.current) socket.current.close();
        };
    }, []);
    return {
        socket: socket,
        readyState: state.readyState,
        reconnect: reconnect,
        disconnect: disconnect,
        sendMessage: sendMessage
    };
};
var $48ede9c6dc89e07d$export$2e2bcd8739ae039 = $48ede9c6dc89e07d$var$useBasicWebsocket;


function $c343ace26dc2feb8$var$useChat(settings) {
    const worker = settings.worker;
    const chatServiceUrl = settings.chatServiceUrl || "localhost:8002/api/chat-service/a";
    const packet_code = settings.packet_code;
    const sessionID = settings.session_id;
    const preventCriteriaPrompts = settings.preventCriteriaPrompts;
    const pageLoadID = settings.page_load_id;
    const pageURL = settings.page_url;
    const referrer = settings.referrer;
    const pageTitle = settings.page_title;
    const storagePrefix = settings.storagePrefix;
    const messageCallback = settings.messageCallback;
    const messageCallbackRef = (0, $iluxG.useRef)(null);
    messageCallbackRef.current = messageCallback;
    const isReconnectRef = (0, $iluxG.useRef)(false);
    const { sendMessage: sendMessage, readyState: readyState, reconnect: reconnect } = (0, $48ede9c6dc89e07d$export$2e2bcd8739ae039)({
        url: settings.wsURL ? settings.wsURL : `wss://${chatServiceUrl}/ws`,
        onMessage: ({ event: event })=>{
            try {
                const parsed = JSON.parse(event.data);
                if (parsed.type === "ping") {
                    worker.postMessage("ping");
                    return;
                }
            } catch (e) {
                console.log("received invalid json:", event.data);
            }
            messageCallbackRef.current(event);
        },
        reconnectDelayBackoff: 1.25,
        maxReconnectDelay: 10000,
        shouldReconnect: ()=>{
            worker.postMessage("stop");
            isReconnectRef.current = true;
            return true;
        },
        readyToConnect: sessionID,
        onOpen: ({ event: event, socket: socket })=>{
            if (event.target !== socket) {
                event.target.close(3002, "targetting wrong socket");
                return;
            }
            worker.postMessage("start");
            if (sessionID) socket.send(JSON.stringify({
                type: "id",
                session_id: sessionID,
                support_bot: settings.supportBot,
                packet_code: packet_code,
                plid: pageLoadID,
                url: pageURL,
                referrer: referrer,
                page_title: pageTitle,
                visit_id: settings.visit_id,
                open: settings.displayState === "open",
                prevent_criteria_prompts: preventCriteriaPrompts,
                is_reconnect: isReconnectRef.current,
                active_conversation_id: (0, $8108230355f26483$export$fd98ba27f2ec095e)(`${storagePrefix}active-convo-id-${packet_code}`)
            }));
            if (settings.identity) socket.send(JSON.stringify({
                type: "identity",
                identity: settings.identity
            }));
        }
    });
    worker.onmessage = (event)=>{
        if (event.data === "presence") sendMessage({
            type: "presence"
        });
        else if (event.data === "reconnect") reconnect();
    };
    const connectionStatus = readyState;
    const subscribeToConversations = (0, $iluxG.useCallback)((conversationIDs)=>{
        setTimeout(()=>{
            sendMessage({
                type: "subscribe",
                conversation_ids: conversationIDs
            });
        }, 1000);
    }, [
        sendMessage
    ]);
    const lastPageLoadIdRef = (0, $iluxG.useRef)(pageLoadID);
    // This message is sent twice
    (0, $iluxG.useEffect)(()=>{
        if (storagePrefix !== "formbot" && pageLoadID && lastPageLoadIdRef.current !== pageLoadID) {
            lastPageLoadIdRef.current = pageLoadID;
            sendMessage({
                type: "page_change",
                visit_id: settings.visit_id,
                plid: pageLoadID,
                url: pageURL,
                page_title: pageTitle,
                referrer: referrer,
                check: true
            });
        }
    }, [
        sendMessage,
        pageLoadID,
        pageTitle,
        pageURL
    ]);
    const syncURLchange = (url, pageTitle, plid, referrer)=>{
        if (url && storagePrefix !== "formbot") sendMessage({
            type: "page_change",
            url: url,
            visit_id: settings.visit_id,
            plid: plid,
            page_title: pageTitle,
            referrer: referrer,
            active_conversation_id: (0, $8108230355f26483$export$fd98ba27f2ec095e)(`${storagePrefix}active-convo-id-${packet_code}`)
        });
    };
    const syncScrollPercent = (scroll_percent)=>{
        sendMessage({
            type: "scroll_percent",
            scroll_percent: scroll_percent
        });
    };
    const setDebug = (debug)=>{
        sendMessage({
            type: "debug",
            debug: debug
        });
    };
    const setIdentity = (0, $iluxG.useCallback)(()=>{
        if (settings.identity) sendMessage({
            type: "identity",
            identity: settings.identity
        });
    }, [
        sendMessage,
        settings.identity
    ]);
    const setMetaAttribute = (key, value)=>{
        sendMessage({
            type: "attribute",
            key: key,
            value: value
        });
    };
    const requestBot = ()=>{
        sendMessage({
            type: "bot_request"
        });
    };
    return {
        connectionStatus: connectionStatus,
        subscribeToConversations: subscribeToConversations,
        syncURLchange: syncURLchange,
        syncScrollPercent: syncScrollPercent,
        setDebug: setDebug,
        setIdentity: setIdentity,
        setMetaAttribute: setMetaAttribute,
        requestBot: requestBot
    };
}
var $c343ace26dc2feb8$export$2e2bcd8739ae039 = $c343ace26dc2feb8$var$useChat;




var $iluxG = parcelRequire("iluxG");


var $iluxG = parcelRequire("iluxG");

var $54a17949eaccc793$exports = {};
"use strict";

var $h59lg = parcelRequire("h59lg");
Object.defineProperty($54a17949eaccc793$exports, "__esModule", {
    value: true
});
$54a17949eaccc793$exports.default = void 0;

var $54a17949eaccc793$var$_react = $h59lg((parcelRequire("iluxG")));

var $54a17949eaccc793$var$_createSvgIcon = $h59lg((parcelRequire("bON8d")));
var $54a17949eaccc793$var$_default = (0, $54a17949eaccc793$var$_createSvgIcon.default)($54a17949eaccc793$var$_react.default.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
$54a17949eaccc793$exports.default = $54a17949eaccc793$var$_default;





const $640b65a3fd548348$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        cancelIcon: {
            backgroundColor: theme.palette.primary.main,
            height: 18,
            width: 18,
            color: "white",
            borderRadius: "50%"
        }
    }));
function $640b65a3fd548348$var$MiniPrompt(props) {
    const { welcomePacket: welcomePacket } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const classes = $640b65a3fd548348$var$useStyles();
    const openChat = props.openChat;
    const toggleOpenChat = props.toggleOpenChat;
    const packet_code = props.packet_code;
    const storage_miniPromptHasBeenDismissed = (0, $8108230355f26483$export$f92dfeb71e9bb569)(`mini-prompt-dismissed-${packet_code}`);
    const [miniPromptHasBeenDismissed, setMiniPromptHasBeenDismissed] = (0, $iluxG.useState)(storage_miniPromptHasBeenDismissed);
    const [displayPrompt, setDisplayPrompt] = (0, $iluxG.useState)(false);
    const setDisplayState = props.setDisplayState;
    const events = props.events;
    if (openChat || !welcomePacket) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    let promptText = "";
    let usingEventPrompt = false;
    if (events) {
        const chatEvents = events.filter((item)=>{
            return item.attributes.kind === "chat";
        });
        if (chatEvents.length) {
            promptText = chatEvents[0].attributes.body;
            if (!displayPrompt) setTimeout(()=>setDisplayPrompt(true), 500);
            usingEventPrompt = true;
        }
    }
    if (!welcomePacket.online && !usingEventPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    if (!displayPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    function dismissMiniPrompt(e) {
        e.stopPropagation();
        (0, $8108230355f26483$export$8a8216c44337cd5)(`mini-prompt-dismissed-${packet_code}`, "yes");
        setMiniPromptHasBeenDismissed(true);
        setDisplayState("icon");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, openChat || miniPromptHasBeenDismissed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        style: {
            position: "absolute",
            right: 20,
            bottom: 5,
            maxWidth: 260
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        onClick: toggleOpenChat,
        className: "mini-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "mini-prompt-close",
        onClick: dismissMiniPrompt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($54a17949eaccc793$exports))), {
        className: classes.cancelIcon
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c9c83073ae40583e$export$2e2bcd8739ae039), {
        text: promptText,
        rich: "true"
    }))));
}
var $640b65a3fd548348$export$2e2bcd8739ae039 = $640b65a3fd548348$var$MiniPrompt;



var $iluxG = parcelRequire("iluxG");

var $anj8u = parcelRequire("anj8u");

var $7ZPk1 = parcelRequire("7ZPk1");

var $iluxG = parcelRequire("iluxG");


var $ao43X = parcelRequire("ao43X");

var $kmV9n = parcelRequire("kmV9n");


var $9iccj = parcelRequire("9iccj");
var $7d15cb30f2b6951b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $7ZPk1.default)({}, theme.typography.button, {
            boxSizing: "border-box",
            minHeight: 36,
            transition: theme.transitions.create([
                "background-color",
                "box-shadow",
                "border"
            ], {
                duration: theme.transitions.duration.short
            }),
            borderRadius: "50%",
            padding: 0,
            minWidth: 0,
            width: 56,
            height: 56,
            boxShadow: theme.shadows[6],
            "&:active": {
                boxShadow: theme.shadows[12]
            },
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            "&:hover": {
                backgroundColor: theme.palette.grey.A100,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.grey[300]
                },
                "&$disabled": {
                    backgroundColor: theme.palette.action.disabledBackground
                },
                textDecoration: "none"
            },
            "&$focusVisible": {
                boxShadow: theme.shadows[6]
            },
            "&$disabled": {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: "100%",
            // assure the correct width for iOS Safari
            display: "inherit",
            alignItems: "inherit",
            justifyContent: "inherit"
        },
        /* Styles applied to the root element if `color="primary"`. */ primary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            "&:hover": {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ secondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            "&:hover": {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="extended"`. */ extended: {
            borderRadius: 24,
            padding: "0 16px",
            width: "auto",
            minHeight: "auto",
            minWidth: 48,
            height: 48,
            "&$sizeSmall": {
                width: "auto",
                padding: "0 8px",
                borderRadius: 17,
                minWidth: 34,
                height: 34
            },
            "&$sizeMedium": {
                width: "auto",
                padding: "0 16px",
                borderRadius: 20,
                minWidth: 40,
                height: 40
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: "inherit"
        },
        /* Styles applied to the root element if `size="small"``. */ sizeSmall: {
            width: 40,
            height: 40
        },
        /* Styles applied to the root element if `size="medium"``. */ sizeMedium: {
            width: 48,
            height: 48
        }
    };
};
var $7d15cb30f2b6951b$var$Fab = /*#__PURE__*/ $iluxG.forwardRef(function Fab(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, focusVisibleClassName = props.focusVisibleClassName, _props$size = props.size, size = _props$size === void 0 ? "large" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "round" : _props$variant, other = (0, $anj8u.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableFocusRipple",
        "focusVisibleClassName",
        "size",
        "variant"
    ]);
    return /*#__PURE__*/ $iluxG.createElement((0, $1d7527e68bc34418$export$2e2bcd8739ae039), (0, $7ZPk1.default)({
        className: (0, $ao43X.default)(classes.root, className, variant !== "round" && classes.extended, size !== "large" && classes["size".concat((0, $9iccj.default)(size))], disabled && classes.disabled, {
            "primary": classes.primary,
            "secondary": classes.secondary,
            "inherit": classes.colorInherit
        }[color]),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $ao43X.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref
    }, other), /*#__PURE__*/ $iluxG.createElement("span", {
        className: classes.label
    }, children));
});
var $7d15cb30f2b6951b$export$2e2bcd8739ae039 = (0, $kmV9n.default)($7d15cb30f2b6951b$export$9dd6ff9ea0189349, {
    name: "MuiFab"
})($7d15cb30f2b6951b$var$Fab);




const $336721a24e5cb9b3$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)((theme)=>({
        fab: {
            height: 60,
            width: 60
        },
        icon: {
            height: 30,
            width: 30,
            color: theme.palette.primary.contrastText
        }
    }));
function $336721a24e5cb9b3$var$CloseButton(props) {
    const classes = $336721a24e5cb9b3$var$useStyles();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $7d15cb30f2b6951b$export$2e2bcd8739ae039), {
        className: classes.fab,
        color: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($36d06990be6f9b9a$exports))), {
        className: classes.icon
    }));
}
var $336721a24e5cb9b3$export$2e2bcd8739ae039 = $336721a24e5cb9b3$var$CloseButton;



var $iluxG = parcelRequire("iluxG");


const $c75dd6ead532f819$var$getColoredSVG = ({ index: index, primaryColor: primaryColor })=>{
    switch(index){
        case 1:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="M 96,96 V 63.999999 C 96,46.327327 81.676796,32 64.001818,32 46.326839,32 32,46.327327 32,63.999999 32,81.672673 46.323204,96 63.998909,96 Z M 79.495598,64.34973 v 0 c 0,8.365182 -6.781345,15.146033 -15.145516,15.146033 v 0 c -8.506674,0 -15.689361,-6.705234 -15.842772,-15.20929 -0.1585,-8.784712 6.995104,-15.93856 15.777336,-15.777873 8.504493,0.151962 15.210952,7.336348 15.210952,15.84113 z"/>
      </svg>
    `;
        case 2:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="m 51.531178,25.922478 c -1.136958,-0.02561 -2.283014,-0.0082 -3.434889,0.05434 -9.214979,0.499608 -17.736353,3.817533 -24.005729,9.299334 -6.338771,5.558134 -9.60699,12.676946 -9.190651,20.070441 0.447566,8.267809 5.471053,15.720452 13.825598,20.518762 0.142251,4.371567 -1.647737,8.055365 -5.332342,10.945455 a 1.1935075,1.1935075 0 0 0 -0.391718,1.304216 1.2108552,1.2108552 0 0 0 1.102695,0.819666 h 1.181947 c 12.490186,0 18.187881,-4.218991 20.758779,-8.056253 l 0.692863,0.03396 c 6.13407,8.8264 18.352037,14.492582 32.046135,13.732761 a 45.499014,45.499014 0 0 0 5.035725,-0.568323 c 2.532732,2.997642 7.321711,6.029733 16.338929,6.029733 a 50.574889,50.574889 0 0 0 6.349,-0.436994 1.2073857,1.2073857 0 0 0 1.00534,-0.923827 1.1692213,1.1692213 0 0 0 -0.55022,-1.245348 c -3.96562,-2.477212 -6.14845,-5.949238 -6.47806,-10.306923 7.75779,-5.686503 11.94217,-13.638954 11.49115,-21.906758 C 111.20551,51.328937 97.31946,40.476494 80.162804,39.702797 A 28.796845,28.796845 0 0 0 72.976028,32.583946 C 67.00459,28.418816 59.489884,26.101783 51.531178,25.922478 Z m 30.16227,16.2778 c 15.199852,1.290651 27.235022,10.907994 27.911582,23.217766 0.42677,7.632892 -3.60101,14.999349 -11.02923,20.224408 a 1.1761604,1.1761604 0 0 0 -0.49814,1.01892 c 0.156122,4.444425 1.87236,8.128841 5.10592,10.970358 -8.552314,0.624514 -14.723399,-1.283587 -17.946561,-5.540652 a 1.1830991,1.1830991 0 0 0 -0.948728,-0.464173 1.1206482,1.1206482 0 0 0 -0.215106,0 40.59314,40.59314 0 0 1 -5.436495,0.663432 C 66.51774,92.9426 55.641578,88.333693 49.694858,80.964487 c 0.485733,0 0.947844,-0.03684 1.419696,-0.06113 9.218449,-0.496145 17.736353,-3.816625 24.005731,-9.288018 6.338769,-5.551196 9.606989,-12.688267 9.190648,-20.081765 a 22.284593,22.284593 0 0 0 -2.617485,-9.333295 z"/>
      </svg>
    `;
        case 3:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="M 26.302354,29.879486 A 5.623401,5.623401 0 0 0 20.68624,35.4956 v 33.620019 a 5.623401,5.623401 0 0 0 5.616114,5.616114 h 4.617268 v 14.573784 a 2.6675514,2.6675514 0 0 0 1.78046,2.534386 2.715073,2.715073 0 0 0 0.924306,0.166118 2.6738877,2.6738877 0 0 0 2.065844,-0.981807 L 49.152296,74.729602 h 8.078088 v 7.539266 a 5.623401,5.623401 0 0 0 5.616113,5.626765 H 88.590751 L 95.695553,98.4719 a 2.6707195,2.6707195 0 0 0 2.217057,1.194772 2.7404179,2.7404179 0 0 0 0.792252,-0.117126 2.6802238,2.6802238 0 0 0 1.899718,-2.57911 v -9.074803 h 3.15202 a 5.623401,5.623401 0 0 0 5.63741,-5.622504 V 54.497108 a 5.623401,5.623401 0 0 0 -5.61824,-5.616116 H 88.927249 V 35.4956 a 5.623401,5.623401 0 0 0 -5.616115,-5.616114 z m 0.01704,2.447067 H 83.31113 a 3.1681132,3.1681132 0 0 1 3.166919,3.169047 v 33.620019 a 3.1681132,3.1681132 0 0 1 -3.166919,3.15201 H 47.989458 L 33.790507,89.4546 a 0.20909546,0.20909546 0 0 1 -0.257698,0.07242 0.21226359,0.21226359 0 0 1 -0.149081,-0.217232 V 72.267629 h -7.081374 a 3.1681132,3.1681132 0 0 1 -3.152009,-3.15201 V 35.4956 a 3.1681132,3.1681132 0 0 1 3.169046,-3.169047 z"/>
      </svg>
    `;
        case 4:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="m 55.648101,23.03363 c -19.481219,0 -35.317972,14.612145 -35.317971,32.573462 0,10.210454 3.867545,18.191579 10.912065,22.565237 v 16.961863 a 3.9511154,3.9511154 0 0 0 3.945235,3.947444 c 0.495069,0 1.054628,1.3e-4 14.844103,-10.777931 1.403227,-0.06622 4.642564,-0.136345 5.601174,-0.136345 h 0.0154 l -0.01761,0.022 c 5.852563,5.064234 13.495449,7.853081 21.520651,7.853081 0.841939,0 3.658117,0.05979 4.919447,0.116554 12.244345,9.567175 12.723214,9.566195 13.227746,9.566195 A 3.645243,3.645243 0 0 0 98.9379,102.08565 V 87.10738 c 6.25303,-3.916423 9.68274,-11.034508 9.68274,-20.106612 0.003,-12.897084 -9.222064,-24.205455 -22.532235,-27.84754 C 79.952047,29.522984 68.601941,23.03363 55.648099,23.03363 Z m -0.0154,2.44323 c 18.118984,0 32.863747,13.518826 32.863747,30.136831 0,16.618002 -14.745137,30.117035 -32.848353,30.117035 -1.002757,0 -4.938834,0.09118 -6.146559,0.160536 l 0.0066,-0.0089 -0.373899,0.02417 -0.296884,0.230908 c -5.839856,4.566019 -12.470967,9.619899 -13.874196,10.47445 a 1.5104424,1.5104424 0 0 1 -1.26233,-1.48875 V 76.778026 l -0.631148,-0.35406 c -6.640895,-3.831287 -10.30071,-11.224237 -10.30071,-20.810334 0,-16.618004 14.744762,-30.136831 32.863746,-30.136831 z M 87.81252,42.267191 c 10.954638,3.966877 18.3605,13.722179 18.3605,24.733577 0.0126,8.466666 -3.21003,14.986452 -9.062597,18.360506 l -0.595956,0.343063 v 16.372513 a 1.2045698,1.2045698 0 0 1 -0.96322,1.17652 C 94.223698,102.4272 88.404558,97.994406 83.286718,93.992847 l -0.296882,-0.23311 -0.373852,-0.02199 C 81.543855,93.665207 78.043172,93.594806 77.16655,93.594806 A 30.625086,30.625086 0 0 1 59.331639,87.982633 C 77.072223,86.276687 90.946281,72.405497 90.946281,55.598295 A 30.237228,30.237228 0 0 0 87.812526,42.267191 Z m -46.489534,7.897063 a 4.1371615,4.1371615 0 1 0 -0.646544,8.224733 4.1466216,4.1466216 0 0 0 4.136557,-4.138755 4.1371615,4.1371615 0 0 0 -3.490013,-4.085978 z m 13.595,0 a 4.1371615,4.1371615 0 1 0 -0.646545,8.224733 4.1371615,4.1371615 0 0 0 4.136557,-4.138755 4.1371615,4.1371615 0 0 0 -3.490012,-4.085978 z m 13.573009,0 a 4.1371615,4.1371615 0 1 0 -0.628951,8.224733 4.1371615,4.1371615 0 0 0 4.123361,-4.138755 4.1371615,4.1371615 0 0 0 -3.49441,-4.085978 z"/>
      </svg>
    `;
        case 5:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="m 26.631945,23.6875 a 4.7148526,4.7148526 0 0 0 -4.706164,4.711392 v 30.509009 a 4.7148526,4.7148526 0 0 0 4.706164,4.711391 h 5.974212 v 7.757327 a 2.9292923,2.9292923 0 0 0 2.930893,2.925665 2.7376564,2.7376564 0 0 0 1.320341,-0.355578 1.0129328,1.0129328 0 0 0 0.303286,-0.138569 L 52.450478,63.619292 H 93.731369 A 4.7178945,4.7178945 0 0 0 98.44015,58.907901 V 28.398892 A 4.7178945,4.7178945 0 0 0 93.731369,23.6875 Z m 0,2.30079 h 67.099424 a 2.4091375,2.4091375 0 0 1 2.405377,2.410602 v 30.524696 a 2.4091375,2.4091375 0 0 1 -2.405377,2.407988 H 52.102745 a 1.1376482,1.1376482 0 0 0 -0.637948,0.196089 l -15.365621,10.21499 a 1.1619831,1.1619831 0 0 0 -0.258839,0.133339 0.56274047,0.56274047 0 0 1 -0.303287,0.125497 0.62966096,0.62966096 0 0 1 -0.630102,-0.627486 v -8.907723 a 1.1498157,1.1498157 0 0 0 -1.15301,-1.14778 H 26.631945 A 2.4060957,2.4060957 0 0 1 24.226572,58.907901 V 28.398892 a 2.4060957,2.4060957 0 0 1 2.405373,-2.410602 z m 6.243509,11.592848 v 2.303407 H 87.49832 v -2.303407 z m 0,8.905107 v 2.298177 h 26.17411 l 0.01308,-2.298177 z m 23.468065,20.273106 a 3.507242,3.507242 0 0 0 -3.498247,3.511321 v 25.855132 a 3.5042,3.5042 0 0 0 3.498247,3.500866 h 27.635637 l 9.992753,6.65922 a 1.1589412,1.1589412 0 0 0 0.250996,0.12549 2.1962088,2.1962088 0 0 0 1.03797,0.26146 2.3270079,2.3270079 0 0 0 2.32693,-2.31909 v -4.73493 h 6.023895 a 3.5042,3.5042 0 0 0 3.48517,-3.500852 V 70.262827 a 3.507242,3.507242 0 0 0 -3.49825,-3.503476 z m 5.840873,11.561472 h 17.737004 17.737008 v 1.171313 1.171313 H 79.921396 62.184392 v -1.171313 z m 0,7.362532 h 17.737004 17.737008 v 1.254978 1.254974 H 79.921396 62.184392 v -1.254974 z"/>
      </svg>
    `;
        case 6:
        default:
            return `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <defs>
          <style>
            .circle{
              fill:none;
              stroke-width:0;
            }
            .icon{
              fill:${primaryColor};
              fill-opacity:1;
            }
          </style>
        </defs>
        <circle class="circle" cx="64" cy="64" r="63.974892"/>
        <path class="icon" d="m 60.489242,18.697279 c -17.258082,0 -31.298807,13.278096 -31.298807,29.609228 v 9.450897 a 12.34331,12.34331 0 0 0 -7.624444,11.38057 v 4.368684 a 12.340091,12.340091 0 0 0 7.646881,11.39852 c 0.45704,9.13758 8.052507,16.186792 17.663216,16.186792 h 10.043263 a 3.8365645,3.8365645 0 0 0 3.830174,-3.832412 v -0.260279 a 3.8365645,3.8365645 0 0 0 -3.830174,-3.830177 h -3.565398 a 3.8365645,3.8365645 0 0 0 -3.834662,3.830177 v 0.260279 0.224377 h -2.643203 c -7.270796,0 -13.082264,-5.004907 -13.960943,-11.68348 0.321861,0.02576 0.642978,0.04488 0.964838,0.04488 h 3.592328 c 0.666248,2.49119 1.844341,4.38063 3.585599,5.771063 a 1.8032927,1.8032927 0 0 0 2.252777,-2.815974 C 42.07153,87.809098 40.413938,85.823743 40.413938,80.049592 V 65.897924 a 1.8893147,1.8893147 0 0 0 0.471198,-0.381449 c 1.609295,-1.87 3.427637,-3.133961 5.371665,-3.758368 4.077954,-1.30675 7.923672,0.508302 11.647584,2.252781 1.020291,0.482786 2.01419,0.949124 2.979769,1.341791 a 29.417952,29.417952 0 0 0 11.165162,2.082248 c 4.489936,0 9.333618,-0.867989 14.499461,-2.602812 a 2.4332573,2.4332573 0 0 0 1.081512,0.53627 v 12.749292 a 1.7670083,1.7670083 0 0 0 -0.320865,0.931177 C 86.279475,93.712751 76.17963,105.20038 64.312685,105.20038 a 17.084299,17.084299 0 0 1 -4.80847,-0.69558 1.8033983,1.8033983 0 1 0 -1.018689,3.45995 20.698781,20.698781 0 0 0 5.827159,0.83917 c 11.883037,0 22.207339,-9.67762 25.554674,-22.983266 h 4.303614 A 12.340091,12.340091 0 0 0 106.49843,73.493198 V 69.137974 A 12.34331,12.34331 0 0 0 98.867256,57.74843 v -9.441923 c 0,-16.321476 -14.040728,-29.609228 -31.298813,-29.609228 z m 0,3.614769 h 7.079201 c 15.268997,0 27.6818,11.662071 27.6818,25.994459 v 8.569082 c -0.363699,-0.03219 -0.729324,-0.05163 -1.099464,-0.05163 H 90.776102 A 21.867132,21.867132 0 0 0 90.019936,52.962396 C 86.263842,40.165278 77.705521,33.94392 63.852707,33.94392 c -7.821176,0 -14.079982,2.058942 -18.598887,6.114366 -4.879383,4.386939 -6.734569,9.900766 -7.294603,12.060443 a 25.648977,25.648977 0 0 0 -0.78982,4.696279 h -3.280439 c -0.366919,0 -0.73225,0.01943 -1.092732,0.05162 l 0.01348,-8.56011 c 0,-14.332386 12.423435,-25.994458 27.679556,-25.994458 z m 3.374682,15.233178 c 12.201679,0 19.41789,5.219159 22.707289,16.41342 a 18.471514,18.471514 0 0 1 0.65519,6.901939 1.873222,1.873222 0 0 0 -0.44876,0.10321 46.991477,46.991477 0 0 1 -11.560073,2.737442 1.7541339,1.7541339 0 0 0 -0.545246,-0.320864 c -0.06115,-0.02253 -6.086562,-2.336994 -8.104618,-8.082177 a 1.8027648,1.8027648 0 0 0 -3.401606,1.193702 16.41483,16.41483 0 0 0 5.046316,7.088174 24.619027,24.619027 0 0 1 -5.95281,-1.554959 C 61.355182,61.654976 60.420722,61.214703 59.461582,60.7641 56.500478,59.36401 52.993421,57.708036 49.131114,57.708036 a 12.945187,12.945187 0 0 0 -3.955827,0.614805 14.303434,14.303434 0 0 0 -4.391122,2.347019 22.337046,22.337046 0 0 1 0.659677,-7.62669 c 0.489227,-1.84747 2.07711,-6.554858 6.23553,-10.301299 3.891272,-3.498608 9.184113,-5.196647 16.184552,-5.196647 z M 53.353953,96.759192 h 3.565398 a 0.23173877,0.23173877 0 0 1 0.224383,0.226619 v 0.260283 a 0.23173877,0.23173877 0 0 1 -0.224383,0.224377 h -3.565398 a 0.22852019,0.22852019 0 0 1 -0.226628,-0.224377 v -0.260283 a 0.23173877,0.23173877 0 0 1 0.226628,-0.226619 z"/>
      </svg>
    `;
    }
};
const $c75dd6ead532f819$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)(()=>({
        fab: {
            height: 60,
            width: 60
        },
        svg: {
            width: "60px",
            height: "60px",
            minHeight: "100%",
            objectFit: "cover",
            borderRadius: "1000px",
            pointerEvents: "none"
        }
    }));
function $c75dd6ead532f819$var$ChatButton({ iconID: iconID, contrastColor: contrastColor, promptIconUrl: promptIconUrl }) {
    const classes = $c75dd6ead532f819$var$useStyles();
    let src;
    if (promptIconUrl) src = promptIconUrl;
    else {
        const coloredSVG = $c75dd6ead532f819$var$getColoredSVG({
            index: iconID,
            primaryColor: contrastColor
        });
        const base64data = btoa(unescape(encodeURIComponent(coloredSVG)));
        src = `data:image/svg+xml;base64,${base64data}`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $7d15cb30f2b6951b$export$2e2bcd8739ae039), {
        className: classes.fab,
        color: "primary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("img", {
        src: src,
        className: classes.svg
    }));
}
var $c75dd6ead532f819$export$2e2bcd8739ae039 = $c75dd6ead532f819$var$ChatButton;




var $iluxG = parcelRequire("iluxG");
var $09b534f990be5739$exports = {};

$09b534f990be5739$exports = new URL((parcelRequire("16ViG")).resolve("3Cxfo"), import.meta.url).toString();


function $d52f4f0bf2b44941$var$PoweredBy() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "powered-by",
        onClick: ()=>window.open("https://getsignals.ai/", "_blank")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($09b534f990be5739$exports))),
        height: 25,
        width: 25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("p", null, "Powered by Signals"));
}
var $d52f4f0bf2b44941$export$2e2bcd8739ae039 = $d52f4f0bf2b44941$var$PoweredBy;



const $220e7c852750c50a$var$useStyles = (0, $a9dded08a9281cc0$export$2e2bcd8739ae039)(()=>({
        badge: {
            color: "white",
            backgroundColor: "red"
        }
    }));
function $220e7c852750c50a$var$ChatPrompt(props) {
    const { welcomePacket: welcomePacket } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const toggleOpenChat = props.toggleOpenChat;
    const classes = $220e7c852750c50a$var$useStyles();
    const setDisplayState = props.setDisplayState;
    if (props.hidden) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    else if (props.phone && props.openChat && !props.bigPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    if (props.openChat) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "chat-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "inner-chat-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "chat-icon",
        onClick: toggleOpenChat
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $336721a24e5cb9b3$export$2e2bcd8739ae039), null)), welcomePacket.branding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $d52f4f0bf2b44941$export$2e2bcd8739ae039), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "chat-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        className: "inner-chat-prompt"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "chat-icon",
        onClick: toggleOpenChat
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $c75dd6ead532f819$export$2e2bcd8739ae039), {
        contrastColor: welcomePacket.contrast_color,
        iconID: welcomePacket.prompt_icon_id,
        promptIconUrl: welcomePacket.prompt_icon_url
    })), props.showMiniPrompt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $640b65a3fd548348$export$2e2bcd8739ae039), {
        openChat: props.openChat,
        toggleOpenChat: toggleOpenChat,
        packet_code: props.packet_code,
        events: props.events,
        setDisplayState: setDisplayState
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null)));
}
var $220e7c852750c50a$export$2e2bcd8739ae039 = $220e7c852750c50a$var$ChatPrompt;


function $3c4ca06cd385c990$var$App(props) {
    const { setToken: setToken, setChatURL: setChatURL, welcomePacket: welcomePacket, setWelcomePacket: setWelcomePacket, activeConversationId: activeConversationId, setActiveConversationId: setActiveConversationId } = (0, $iluxG.useContext)((0, $77aa80f10cd3ab0a$export$3285420c698bc605));
    const worker = props.worker;
    const packet_code = props.packet_code;
    const storagePrefix = props.storagePrefix;
    const session_id = props.session_id;
    const visit_id = props.visit_id;
    const chatServiceUrl = props.chatServiceUrl;
    const wsURL = props.wsURL;
    const preventCriteriaPrompts = props.preventCriteriaPrompts;
    const supportBot = props.supportBot;
    const [showConversationHistory, setShowConversationHistory] = (0, $iluxG.useState)(false);
    const token = `visitor_${session_id}_${packet_code}`;
    const [customTheme, setCustomTheme] = (0, $iluxG.useState)(null);
    const page_load_id = props.page_load_id;
    const page_url = props.page_url;
    const referrer = props.referrer;
    const page_title = props.page_title;
    const hide_mode = props.hide_mode;
    const identity = props.identity;
    const visualViewportSize = props.visualViewportSize;
    const autoLoadBotId = props.autoLoadBotId;
    const submissionID = props.submissionID;
    const hasAutoLoadedByIdRef = (0, $iluxG.useRef)(false);
    const metaAttributes = props.metaAttributes;
    const pageRendered = (0, $iluxG.useRef)(false);
    const [majorChatEvents, setMajorChatEvents, resetMajorChatEvents] = (0, $2168e60feb01f6ab$export$efec460124b14570)({
        /** If an agent has been routed to the conversation or attempted */ agentBeenRouted: false,
        /** If an agent has chatted at anytime during or after bot flow */ agentHasChatted: false,
        /** If the bot flow has ended */ botFlowEnded: false
    });
    const [readReceipts, setReadReceipts] = (0, $iluxG.useState)({});
    const [activeConversation, setActiveConversation] = (0, $iluxG.useState)(null);
    const [windowClosed, setWindowClosed] = (0, $iluxG.useState)(false);
    const chatBoxRef = (0, $iluxG.useRef)();
    const chatBoxWrapRef = (0, $iluxG.useRef)();
    let savedConversationId = null;
    if (props.mode !== "test-drive" && storagePrefix !== "formbot") savedConversationId = (0, $8108230355f26483$export$f92dfeb71e9bb569)(`${storagePrefix}active-convo-id-${packet_code}`);
    let startingDisplayState = "icon";
    let fullScreen = welcomePacket && welcomePacket.chat_size === "fullscreen";
    if ([
        "content",
        "content-with-header",
        "landing-page"
    ].includes(props.mode) || props.mode.startsWith("modal")) {
        fullScreen = true;
        startingDisplayState = "open";
    } else if (props.mode === "content-phone") startingDisplayState = "mini";
    else if (savedConversationId) startingDisplayState = "open";
    const [displayState, _setDisplayState] = (0, $iluxG.useState)(startingDisplayState);
    const [activeConversationMessageParticipants, setActiveConversationMessageParticipants] = (0, $iluxG.useState)([]);
    const [conversationList, setConversationList] = (0, $iluxG.useState)([]);
    const [activeConversationMessages, setActiveConversationMessages] = (0, $iluxG.useState)([]);
    const [botHasFired, setBotHasFired] = (0, $iluxG.useState)(false);
    const [botMessageQueue, setBotMessageQueue] = (0, $iluxG.useState)([]);
    const [botReady, setBotReady] = (0, $iluxG.useState)(true);
    const [unconnected, setUnconnected] = (0, $iluxG.useState)(false);
    const [currentTypingEvent, setCurrentTypingEvent] = (0, $iluxG.useState)(null);
    const [currentKind, setCurrentKind] = (0, $iluxG.useState)(null);
    const [botParticipantID, setBotParticipantID] = (0, $iluxG.useState)(null);
    const [activeBotID, setActiveBotID] = (0, $iluxG.useState)(null);
    const [cloudAgentName, setCloudAgentName] = (0, $iluxG.useState)(welcomePacket?.bot_name || "");
    const [cloudAgentAvatar, setCloudAgentAvatar] = (0, $iluxG.useState)(welcomePacket?.bot_avatar_url || "");
    const conversationSearchParamsRef = (0, $iluxG.useRef)({
        searchFilter: "mine_open",
        searchText: "",
        sortOrder: "newest"
    });
    var md = new (0, (/*@__PURE__*/$parcel$interopDefault($e2af0da5ccf1b3dc$exports)))(window.navigator.userAgent);
    const phone = !!md.phone();
    const pageSize = 5;
    (0, $iluxG.useEffect)(()=>{
        (0, $8108230355f26483$export$6efe264be9505de7)("appLoaded");
    }, []);
    (0, $iluxG.useEffect)(()=>{
        setToken(token);
        setChatURL(chatServiceUrl);
        setWelcomePacket(props.welcomePacket);
        setActiveConversationId(savedConversationId);
    }, []);
    (0, $iluxG.useEffect)(()=>{
        if (activeConversationId) resetMajorChatEvents();
    // eslint-disable-next-line
    }, [
        activeConversationId
    ]);
    function SendBotMessage() {
        const message = botMessageQueue[0];
        const kind = message.attributes.kind;
        let delay = 800;
        if (kind === "cta_button") delay = 100;
        const typingEvent = {
            type: "conversation_events",
            attributes: {
                body: "",
                kind: "type",
                created_timestamp: message.attributes.created_timestamp,
                data: {}
            },
            relationships: {
                from_participant: {
                    data: {
                        type: "participants",
                        id: botParticipantID
                    }
                }
            }
        };
        setBotReady(false);
        const newBotMessages = [
            ...botMessageQueue
        ];
        newBotMessages.splice(0, 1);
        setBotMessageQueue(newBotMessages);
        if (kind !== "email_prompt" && kind !== "cta_button" && kind !== "option_prompt" && kind !== "option_prompt_free") {
            if (kind === "chat" && currentKind !== "chat") {
                setCurrentTypingEvent(typingEvent);
                setCurrentKind(kind);
            }
        }
        if (kind === "chat" && (currentKind === "chat" || currentKind === "type")) {
            setCurrentKind(null);
            setCurrentTypingEvent(null);
            setActiveConversationMessages((prev)=>dedupeAppend(prev, message));
            setBotReady(true);
            return;
        }
        setTimeout(()=>{
            setCurrentKind(null);
            setCurrentTypingEvent(null);
            setActiveConversationMessages((prev)=>dedupeAppend(prev, message));
            setBotReady(true);
        }, delay);
    }
    (0, $iluxG.useEffect)(()=>{
        setTimeout(()=>{
            if (botReady && botMessageQueue.length) SendBotMessage();
        }, 400);
    }, [
        botMessageQueue,
        botReady
    ]);
    const performConversationSearch = (0, $iluxG.useCallback)(({ searchFilter: searchFilter, searchText: searchText, sortOrder: sortOrder })=>{
        const page = 1;
        (0, $8108230355f26483$export$bade1af6f5e96e0c)({
            chatServiceUrl: chatServiceUrl,
            token: token,
            searchText: searchText,
            searchFilter: searchFilter,
            sortOrder: sortOrder,
            page: page,
            pageSize: pageSize
        }).then((response)=>{
            const receipts = response.included;
            let receiptsDict = {};
            if (receipts) {
                receipts.map((receipt)=>receiptsDict = {
                        ...receiptsDict,
                        [receipt.id]: receipt.attributes.read === "True"
                    });
                if (activeConversationId) receiptsDict[activeConversationId] = true;
            }
            setConversationList(response.data);
            setReadReceipts(receiptsDict);
        });
    }, [
        token,
        chatServiceUrl,
        pageSize
    ]);
    const performConversationSearchWithCurrentParams = (0, $iluxG.useCallback)(()=>{
        performConversationSearch(conversationSearchParamsRef.current);
    }, [
        performConversationSearch
    ]);
    const loadConversationEvents = (0, $iluxG.useCallback)(()=>{
        if (activeConversationId) (0, $8108230355f26483$export$26dce2c43b43b8bd)({
            conversationID: activeConversationId,
            token: token,
            chatServiceUrl: chatServiceUrl
        }).then((result)=>{
            setActiveConversationMessages(result.data);
            setActiveConversationMessageParticipants(result.included);
        });
        else {
            setActiveConversationMessages([]);
            setActiveConversationMessageParticipants([]);
        }
    }, [
        activeConversationId,
        token,
        chatServiceUrl
    ]);
    (0, $iluxG.useEffect)(()=>{
        // This is a bandaid for a bug I've yet been able to track down. Archive360 has a bug where the conversation
        // events occassionally get reset for the visitor.
        if (activeConversationMessages.length === 0 && activeConversationId) setTimeout(()=>{
            loadConversationEvents();
        }, 1000);
    }, [
        activeConversationId,
        loadConversationEvents,
        activeConversationMessages
    ]);
    const loadConversation = (0, $iluxG.useCallback)(()=>{
        if (activeConversationId) (0, $8108230355f26483$export$a2ff1144002a6147)({
            conversationID: activeConversationId,
            chatServiceUrl: chatServiceUrl,
            token: token
        }).then((response)=>{
            const activeConversationParticipant = response.included.find((i)=>i.attributes && (i.attributes.kind === "person" || i.attributes.kind === "visitor"));
            const activeConversationParticipantId = activeConversationParticipant.id;
            const p = {
                participantID: activeConversationParticipantId,
                personID: null
            };
            if (response.data && response.data.relationships && response.data.relationships.for_person && response.data.relationships.for_person.data.id) p.personID = response.data.relationships.for_person.data.id;
            setActiveConversation(response.data);
        });
        else setActiveConversation(null);
    }, [
        activeConversationId,
        token,
        chatServiceUrl
    ]);
    (0, $iluxG.useEffect)(()=>{
        loadConversationEvents();
        loadConversation();
    }, [
        activeConversationId,
        loadConversationEvents,
        loadConversation
    ]);
    const dedupeAppend = (existing_array, new_item)=>{
        const match = existing_array.filter((i)=>{
            if (i.id === new_item.id) return true;
            return false;
        });
        if (!match.length) return existing_array.concat([
            new_item
        ]);
        return existing_array;
    };
    function handleConversationEvent(data) {
        const conversationID = data.relationships.conversation.data.id;
        const newChatMessage = {
            ...data
        };
        const messageType = newChatMessage.attributes.kind;
        if (messageType === "open") return;
        const sender = newChatMessage.relationships.from_participant.data.id;
        if (sender === botParticipantID) setBotHasFired(true);
        if (messageType === "chat") {
            newMessageRef.current();
            if (activeConversation && activeConversation.attributes.meta.last_agent_participant_id !== sender) {
                if (newChatMessage.attributes.participant_name !== "") loadConversation();
            }
        }
        if (conversationID === activeConversationId) {
            if (sender === botParticipantID && [
                "chat",
                "calendar_drop",
                "option_prompt",
                "option_prompt_free",
                "rating_drop",
                "email_prompt",
                "cta_button"
            ].includes(messageType)) setBotMessageQueue((prev)=>prev.concat(newChatMessage));
            else setActiveConversationMessages((prev)=>dedupeAppend(prev, newChatMessage));
            if (activeConversation) {
                if (sender !== activeConversation.relationships.for_participant.data.id) {
                    setCurrentKind(messageType);
                    if (messageType === "type") setCurrentTypingEvent(newChatMessage);
                    else if (messageType === "chat" || messageType === "halt") setCurrentTypingEvent(null);
                }
            }
        }
    }
    const messageCallback = (0, $iluxG.useCallback)((messageObject)=>{
        const data = JSON.parse(messageObject.data);
        switch(data.type){
            case "conversation_events":
                handleConversationEvent(data);
                break;
            case "blocked_participants":
                props.hideApp();
                (0, $8108230355f26483$export$6efe264be9505de7)("block_participant", data.attributes);
                break;
            case "hide_chat_window":
                props.hideApp();
                (0, $8108230355f26483$export$6efe264be9505de7)("page_is_blocked", data.attributes);
                break;
            case "unhide_chat_window":
                props.unhideApp();
                break;
            case "chat_notifications":
                break;
            case "route":
                performConversationSearchWithCurrentParams();
                break;
            case "prompt":
                if (!preventCriteriaPrompts) {
                    if (phone && data.mobile_style) data.style = data.mobile_style;
                    const storedConversationID = (0, $8108230355f26483$export$f92dfeb71e9bb569)(`${storagePrefix}active-convo-id-${packet_code}`);
                    if (displayState !== "open" || storedConversationID !== data.conversation_id) {
                        if (displayState !== "open") setDisplayState(data.style);
                        setActiveConversationId(data.conversation_id);
                        if (displayState === "open" || data.style === "open") (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}active-convo-id-${packet_code}`, data.conversation_id);
                    }
                    setActiveBotID(data.bot_id);
                    (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                        action: "Bot Prompt",
                        label: "prompt"
                    });
                }
                break;
            case "new_conversation":
                if (displayState !== "open") {
                    setDisplayState("big");
                    setActiveConversationId(data.conversation_id);
                }
                break;
            case "ping":
                break;
            default:
                break;
        }
    }, [
        activeConversationId,
        performConversationSearchWithCurrentParams,
        displayState,
        loadConversation,
        activeConversationMessages
    ]);
    function setDisplayState(size) {
        if (props.mode !== "landing-page") {
            if (size === "open" || size === "big") setTimeout(()=>_setDisplayState(size), 80);
            else _setDisplayState(size);
            changeFrameSize(size);
            if (size === "open" && activeConversationIdRef && activeConversationIdRef.current) (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}active-convo-id-${packet_code}`, activeConversationIdRef.current);
        }
    }
    (0, $iluxG.useEffect)(()=>{
        if (props.mode !== "landing-page") changeFrameSize(displayState);
    }, [
        displayState
    ]);
    const promptReceivedRef = (0, $iluxG.useRef)(null);
    const promptReceived = (command)=>{
        setDisplayState(command.style);
    };
    promptReceivedRef.current = promptReceived;
    const displayStateRef = (0, $iluxG.useRef)(null);
    displayStateRef.current = displayState;
    const newMessage = ()=>{
        (0, $8108230355f26483$export$6efe264be9505de7)("new_message", {
            displayState: displayState
        });
    };
    const newMessageRef = (0, $iluxG.useRef)(null);
    newMessageRef.current = newMessage;
    const botTriggerByFlowIdRef = props.botTriggerByFlowIdRef;
    const botTriggerByIdRef = props.botTriggerByIdRef;
    const startConversationWithUserIdRef = props.startConversationWithUserIdRef;
    const connectionStatusRef = (0, $iluxG.useRef)(null);
    const { subscribeToConversations: subscribeToConversations, syncScrollPercent: syncScrollPercent, syncURLchange: syncURLchange, setDebug: setDebug, connectionStatus: connectionStatus, setIdentity: setIdentity, setMetaAttribute: setMetaAttribute, requestBot: requestBot } = (0, $c343ace26dc2feb8$export$2e2bcd8739ae039)({
        activeConversationId: activeConversationId,
        chatServiceUrl: chatServiceUrl,
        displayState: displayState,
        identity: identity,
        messageCallback: messageCallback,
        newMessageRef: newMessageRef,
        packet_code: packet_code,
        page_load_id: page_load_id,
        page_title: page_title,
        page_url: page_url,
        wsURL: wsURL,
        preventCriteriaPrompts: preventCriteriaPrompts,
        promptReceivedRef: promptReceivedRef,
        referrer: referrer,
        session_id: session_id,
        storagePrefix: storagePrefix,
        supportBot: supportBot,
        visit_id: visit_id,
        worker: worker
    });
    (0, $iluxG.useEffect)(()=>{
        if (metaAttributes && connectionStatus === (0, $e6a6dd398dab2c16$exports.ReadyState).OPEN) for(const key in metaAttributes)setMetaAttribute(key, metaAttributes[key]);
    }, [
        metaAttributes,
        setMetaAttribute,
        connectionStatus
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (identity && connectionStatus === (0, $e6a6dd398dab2c16$exports.ReadyState).OPEN) setIdentity(identity);
    }, [
        identity,
        setIdentity,
        connectionStatus
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (connectionStatus === (0, $e6a6dd398dab2c16$exports.ReadyState).OPEN) {
            const conversationIDs = conversationList.map((i)=>i.id);
            conversationIDs.push(activeConversationId);
            subscribeToConversations(conversationIDs);
        }
    }, [
        activeConversationId,
        conversationList,
        subscribeToConversations,
        connectionStatus
    ]);
    connectionStatusRef.current = connectionStatus;
    (0, $iluxG.useEffect)(()=>{
        if (connectionStatus === (0, $e6a6dd398dab2c16$exports.ReadyState).OPEN) {
            if (props.debug !== undefined) setDebug(props.debug);
            window.setDebug = (debug)=>{
                setDebug(debug);
            };
        }
    }, [
        connectionStatus,
        props.debug
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (connectionStatusRef.current !== 1) setTimeout(()=>{
            if (connectionStatusRef.current !== 1) setUnconnected(true);
        }, 5000);
        else setUnconnected(false);
    }, [
        connectionStatus
    ]);
    const scrollCallbackRef = props.scrollCallbackRef;
    scrollCallbackRef.current = (scroll_percent)=>{
        syncScrollPercent(scroll_percent);
    };
    const urlHashCallbackRef = props.urlHashCallbackRef;
    urlHashCallbackRef.current = ({ url: url, page_title: page_title, plid: plid, referrer: referrer })=>{
        syncURLchange(url, page_title, plid, referrer);
    };
    botTriggerByFlowIdRef.current = (flow_id)=>{
        if (!activeConversationId) (0, $8108230355f26483$export$f9dce390e0985015)({
            flow_id: flow_id,
            token: token,
            chatServiceUrl: chatServiceUrl,
            page_url: page_url,
            referrer: referrer,
            page_title: page_title
        }).then((result)=>{
            setActiveConversationId(result.data.id);
            (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}active-convo-id-${packet_code}`, result.data.id);
            setDisplayState("open");
            (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                action: "Prompt Clicked",
                label: `FLow ID: ${flow_id}`
            });
        });
    };
    // TODO: Check if this causes multiple prompts
    botTriggerByIdRef.current = ({ botID: botID, preview: preview, promptState: promptState, submissionID: submissionID })=>{
        console.log("botTriggerByIdRef", {
            botID: botID,
            preview: preview,
            promptState: promptState
        });
        if (botID === activeBotID) {
            console.log(`bot ${botID} is already active`);
            (0, $8108230355f26483$export$fe2d9b4e03920b4c)(`${storagePrefix}closed-window-${packet_code}`);
            setWindowClosed(false);
            setDisplayState("open");
            return;
        }
        (0, $8108230355f26483$export$7a9befad52997cab)({
            botID: botID,
            token: token,
            chatServiceUrl: chatServiceUrl,
            page_url: page_url,
            page_title: page_title,
            referrer: referrer,
            preview: preview,
            submissionID: submissionID
        }).then((result)=>{
            console.log("requestByById", result);
            setActiveConversationId(result.data.id);
            (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}active-convo-id-${packet_code}`, result.data.id);
            (0, $8108230355f26483$export$fe2d9b4e03920b4c)(`${storagePrefix}closed-window-${packet_code}`);
            setWindowClosed(false);
            const state = promptState || "open";
            setDisplayState(state);
            setActiveBotID(botID);
            if (result.meta?.bot?.name) setCloudAgentName(result.meta.bot.name);
            if (result.meta?.bot?.avatar_url) setCloudAgentAvatar(result.meta.bot.avatar_url);
            (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                action: "Bot Prompt",
                label: `Bot ID: ${botID}`
            });
        });
    };
    startConversationWithUserIdRef.current = ({ userID: userID })=>{
        (0, $8108230355f26483$export$c7ff47b8a892cacd)({
            first_message: "",
            prompt: "",
            chatServiceUrl: chatServiceUrl,
            token: token,
            url: page_url,
            referrer: referrer,
            page_title: page_title,
            route_to_user_id: userID
        }).then((result)=>{
            setActiveConversationId(result.data.id);
            setDisplayState("open");
        });
    };
    (0, $iluxG.useEffect)(()=>{
        console.log("autoLoad", {
            autoLoadBotId: autoLoadBotId,
            hasAutoLoadedByIdRef: hasAutoLoadedByIdRef.current,
            submissionID: submissionID
        });
        if (autoLoadBotId && !hasAutoLoadedByIdRef.current) {
            hasAutoLoadedByIdRef.current = true;
            const promptState = props.mode === "content-phone" ? "mini" : "open";
            botTriggerByIdRef.current({
                botID: autoLoadBotId,
                promptState: promptState,
                submissionID: submissionID
            });
        }
    }, [
        autoLoadBotId,
        botTriggerByIdRef
    ]);
    const all_prompts = activeConversationMessages.filter((i)=>{
        if (i.attributes.data.bot && i.attributes.data.bot.prompt) return true;
    });
    const prompts_to_closed_prompt_events = activeConversationMessages.filter((i)=>{
        if (i.attributes.data.bot_response && i.attributes.data.bot_response.response_to_event_id) return true;
    }).reduce((result, item)=>{
        result[item.attributes.data.bot_response.response_to_event_id] = item;
        return result;
    }, {});
    const open_chat_prompts = all_prompts.filter((i)=>{
        const close_event = prompts_to_closed_prompt_events[i.id];
        if (close_event) return false;
        return true;
    });
    let open_chat_prompt;
    if (open_chat_prompts.length) open_chat_prompt = open_chat_prompts[open_chat_prompts.length - 1];
    const more_recent_chat_messages = activeConversationMessages.filter((i)=>{
        if (!open_chat_prompt) return false;
        let ts = i.attributes.created_timestamp;
        let prompt_ts = open_chat_prompt.attributes.created_timestamp;
        if (!ts || !prompt_ts) return false;
        ts = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(ts);
        prompt_ts = (0, $2e1451eb81732024$export$2e2bcd8739ae039)(prompt_ts);
        if (i.attributes.kind === "chat" && ts > prompt_ts) return true;
    });
    (0, $iluxG.useEffect)(()=>{
        // Only run if it hasn't happened yet
        if (!majorChatEvents.agentBeenRouted) {
            const agentBeenRouted = activeConversationMessages.some((i)=>{
                if (// Tests if an agent HAS been routed
                i.attributes.kind === "join" && i.attributes.data.from === "route" || // Tests if quick draw event has been created
                i.attributes.kind === "quick_draw") return true;
                return false;
            });
            setMajorChatEvents({
                agentBeenRouted: agentBeenRouted
            });
        }
        // Only run if it hasn't happened yet
        if (!majorChatEvents.agentHasChatted) {
            const agentHasChatted = activeConversationMessages.some((i)=>{
                if (i.attributes.kind === "chat" && i.attributes.participant_name) {
                    const metaData = i.attributes.data;
                    if (metaData && // Check if object is empty
                    Object.keys(metaData).length === 0 && Object.getPrototypeOf(metaData) === Object.prototype) {
                        (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                            action: "Agent Chatted",
                            label: `Agent: ${i.attributes.participant_name}`
                        });
                        if (displayState === "icon") toggleOpenChat();
                        else if (displayState === "big") setDisplayState("open");
                        return true;
                    }
                }
                return false;
            });
            setMajorChatEvents({
                agentHasChatted: agentHasChatted
            });
        }
        // Only run if it hasn't happened yet
        if (!majorChatEvents.botFlowEnded) {
            const botFlowEnded = activeConversationMessages.some((i)=>{
                if (i.attributes.kind === "bot_end") return true;
                return false;
            });
            setMajorChatEvents({
                botFlowEnded: botFlowEnded
            });
        }
    // eslint-disable-next-line
    }, [
        activeConversationMessages.length
    ]);
    /** What type of prompt to display */ let chatPromptState = "wait";
    if (majorChatEvents.agentHasChatted || majorChatEvents.agentBeenRouted) chatPromptState = "chat";
    else if (majorChatEvents.botFlowEnded) chatPromptState = "end";
    else if (open_chat_prompt) {
        if ([
            "option_prompt",
            "rating_drop",
            "calendar_drop"
        ].includes(open_chat_prompt.attributes.kind)) chatPromptState = "option";
        else if ([
            "option_prompt_free"
        ].includes(open_chat_prompt.attributes.kind)) chatPromptState = "option_free";
        else chatPromptState = "chat";
    }
    if (more_recent_chat_messages.length) {
        chatPromptState = "chat";
        open_chat_prompt = null;
    }
    const activeConversationIdRef = (0, $iluxG.useRef)(null);
    activeConversationIdRef.current = activeConversationId;
    const timeoutRef = (0, $iluxG.useRef)(null);
    const small = (0, $eb2ef6c9897259b9$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($d1a00881c4a408e9$exports)))({
        maxDeviceHeight: 800
    }));
    const big = (0, $eb2ef6c9897259b9$export$2e2bcd8739ae039)("(min-device-width:2000px)");
    function chooseConversation(conversationID) {
        setActiveConversationId(conversationID);
        (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}active-convo-id-${packet_code}`, conversationID);
    }
    function sendChatOrCreate(body) {
        if (activeConversationId) {
            if (open_chat_prompt) (0, $8108230355f26483$export$6cd74db52a94a51f)({
                conversationID: activeConversationId,
                body: body,
                data: {
                    bot_response: {
                        flow_id: open_chat_prompt.attributes.data.bot.flow_id,
                        node_id: open_chat_prompt.attributes.data.bot.node_id,
                        response_to_event_id: open_chat_prompt.id
                    }
                },
                token: token,
                chatServiceUrl: chatServiceUrl
            }).then(()=>{
                (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                    action: "Visitor Message Sent",
                    label: "message"
                });
                if (open_chat_prompt.attributes.kind === "email_prompt") (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                    action: "Email Captured",
                    label: "email"
                });
            });
            else (0, $8108230355f26483$export$6cd74db52a94a51f)({
                conversationID: activeConversationId,
                body: body,
                data: {},
                token: token,
                chatServiceUrl: chatServiceUrl
            }).then(()=>{
                (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                    action: "Visitor Message Sent",
                    label: "message"
                });
            });
        }
    }
    const sendChatOrCreateRef = (0, $iluxG.useRef)(null);
    sendChatOrCreateRef.current = sendChatOrCreate;
    const sendChatWrap = (0, $iluxG.useCallback)((body, data)=>{
        let pass_data = data;
        if (!data) pass_data = {};
        (0, $8108230355f26483$export$6cd74db52a94a51f)({
            conversationID: activeConversationId,
            body: body,
            data: pass_data,
            token: token,
            chatServiceUrl: chatServiceUrl
        }).then(()=>{
            (0, $8108230355f26483$export$6efe264be9505de7)("ga", {
                action: "Visitor Message Sent",
                label: "message"
            });
        });
    }, [
        activeConversationId
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (pageRendered.current) performConversationSearchWithCurrentParams();
        pageRendered.current = true;
    }, [
        showConversationHistory
    ]);
    function changeFrameSize(frameSize) {
        let x;
        let y;
        let minHeight;
        let maxWidth = "390px";
        let maxHeight = "700px";
        if (welcomePacket && welcomePacket.chat_size === "fullscreen") maxHeight = "100%";
        if (frameSize === "big") {
            x = "100%";
            y = "35%";
            minHeight = "262px";
            if (small) y = "55%";
            else if (big) y = "25%";
        } else if (frameSize === "open") {
            x = "100%";
            y = "100%";
            minHeight = "280px";
            if (phone) {
                maxWidth = "100%";
                maxHeight = "100%";
            }
        } else if (frameSize === "mini") {
            x = "342px";
            y = "130px";
            minHeight = "0px";
        } else if (frameSize === "icon" && !hide_mode) {
            x = "115px";
            y = "95px";
            minHeight = "0px";
        } else if (frameSize === "icon" && hide_mode) {
            x = "0px";
            y = "0px";
            minHeight = "0px";
        }
        (0, $8108230355f26483$export$6efe264be9505de7)("resize", {
            x: x,
            y: y,
            minHeight: minHeight,
            maxWidth: maxWidth,
            maxHeight: maxHeight
        });
    }
    (0, $iluxG.useEffect)(()=>{
        if (props.mode === "content-phone" || props.mode === "test-drive" || storagePrefix === "formbot") return;
        const storage_activeConversationID = (0, $8108230355f26483$export$f92dfeb71e9bb569)(`${storagePrefix}active-convo-id-${packet_code}`);
        if (storage_activeConversationID && storage_activeConversationID !== "null") {
            setActiveConversationId(parseInt(storage_activeConversationID));
            setDisplayState("open");
        }
    }, []);
    function dismissBigPrompt() {
        (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}big-prompt-dismissed-${packet_code}`, "yes");
    }
    function setClosedWindow() {
        (0, $8108230355f26483$export$8a8216c44337cd5)(`${storagePrefix}closed-window-${packet_code}`, "yes");
        setWindowClosed(true);
        // setMiniPromptHasBeenDismissed(true)
        setDisplayState("icon");
    }
    function toggleOpenChat() {
        // TODO: use their window size to decide if we need to fullscreen or not
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (displayState === "big") {
            dismissBigPrompt();
            setClosedWindow();
            setDisplayState("icon");
        } else if (displayState === "open") {
            setClosedWindow();
            setDisplayState("icon");
        } else {
            requestBot();
            (0, $8108230355f26483$export$fe2d9b4e03920b4c)(`closed-window-${packet_code}`);
            setWindowClosed(false);
            setDisplayState("open");
        }
    }
    (0, $iluxG.useEffect)(()=>{
        if ((0, $8108230355f26483$export$f92dfeb71e9bb569)(`${storagePrefix}closed-window-${packet_code}`) === "yes") {
            setWindowClosed(true);
            setDisplayState("icon");
        }
        if (windowClosed) setDisplayState("icon");
    }, [
        windowClosed,
        displayState
    ]);
    const toggleOpenChatRef = (0, $iluxG.useRef)(null);
    toggleOpenChatRef.current = toggleOpenChat;
    function toggleOpenChatPublic() {
        if (props.mode.startsWith("modal")) (0, $8108230355f26483$export$6efe264be9505de7)("signals-modal-close");
        else toggleOpenChatRef.current();
    }
    (0, $iluxG.useEffect)(()=>{
        if (welcomePacket) {
            const color = welcomePacket.primary_color;
            const contrast = welcomePacket.contrast_color;
            const button = welcomePacket.button_color || welcomePacket.primary_color;
            const customTheme = (0, $3LuJG.default)({
                palette: {
                    primary: {
                        main: color,
                        contrastText: contrast
                    },
                    secondary: {
                        main: button
                    }
                }
            });
            setCustomTheme(customTheme);
            setBotParticipantID(welcomePacket.bot_participant_id);
        }
    }, [
        welcomePacket
    ]);
    (0, $iluxG.useEffect)(()=>{
        if (!phone) return;
        switch(displayStateRef.current){
            case "open":
                if (chatBoxRef.current) chatBoxRef.current.style.height = visualViewportSize.height + "px";
                if (chatBoxWrapRef.current) chatBoxWrapRef.current.style.top = visualViewportSize.offsetTop + "px";
                break;
            default:
                if (chatBoxRef.current) chatBoxRef.current.style.height = "";
                if (chatBoxWrapRef.current) chatBoxWrapRef.current.style.top = "";
        }
    }, [
        visualViewportSize,
        phone
    ]);
    if (!welcomePacket || !customTheme) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    let bot = false;
    let conversationLabel = "";
    let avatarUrl = null;
    const meta = activeConversation?.attributes?.meta;
    if (meta?.last_agent_name && meta.last_agent_name !== meta.first_agent_name) conversationLabel = meta.last_agent_name;
    else if (cloudAgentName) conversationLabel = cloudAgentName;
    else if (meta?.first_agent_name) conversationLabel = meta.first_agent_name;
    else conversationLabel = meta?.bot_name;
    if (meta?.last_agent_avatar && meta.last_agent_avatar !== meta.first_agent_avatar) avatarUrl = meta.last_agent_avatar;
    else if (cloudAgentAvatar) avatarUrl = cloudAgentAvatar;
    else if (meta?.first_agent_avatar) avatarUrl = meta.first_agent_avatar;
    else {
        avatarUrl = welcomePacket.agent_avatar;
        bot = true;
    }
    if (!activeConversationMessages.length) {
        conversationLabel = cloudAgentName || welcomePacket.bot_name;
        avatarUrl = cloudAgentAvatar || welcomePacket.agent_avatar;
        bot = true;
    }
    // } else if (activeConversation && activeConversation.attributes.meta.last_agent_avatar === null) {
    //   const meta = activeConversation.attributes.meta
    //   if (meta.first_send_type === 'user') {
    //     conversationLabel = meta.first_agent_name
    //     avatarUrl = meta.first_agent_avatar
    //   } else {
    //     conversationLabel = meta.bot_name || welcomePacket.bot_name
    //     avatarUrl = welcomePacket.agent_avatar
    //     bot = true
    //   }
    // }
    function startNewConvo() {
        const botID = welcomePacket.default_bot_profile_id;
        botTriggerByIdRef.current({
            botID: botID
        });
    }
    function chatBoxWrapClasses() {
        if (phone) return [
            "max"
        ];
        // const screen = screenRef.current
        // if (screen.x < screen.y && screen.y < 1000) {
        //   return ['max']
        // }
        return [];
    }
    let outerClass = "chat-box-wrap";
    if (displayState === "big") outerClass = "chat-box-wrap-prompt";
    else if (phone) outerClass = "chat-box-wrap-mobile";
    else if (fullScreen) outerClass = "chat-box-wrap-fullscreen";
    const online = welcomePacket.online;
    const promptVisibility = welcomePacket.prompt_visibility;
    const hidden = promptVisibility === "available" && !online || promptVisibility === "bot";
    const shouldBeHidden = !activeConversationId && hidden && !botHasFired;
    if (shouldBeHidden || hide_mode && displayState === "icon") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    const chatBoxHeight = fullScreen && displayState === "open" ? "100%" : null;
    let chatBoxClass = fullScreen && displayState === "open" ? "fullscreen" : null;
    let chatBoxId = "chat-box-normal";
    if (phone && props.mode !== "landing-page") {
        chatBoxId = "chat-box-normal-phone";
        chatBoxClass = displayState === "open" ? "phone" : null;
    } else if (props.mode === "content") {
        chatBoxId = "chat-box-content-landing-page";
        chatBoxClass = "content-page";
    } else if (props.mode === "landing-page") {
        if (phone) outerClass = "chat-box-wrap-fullscreen";
        chatBoxId = "chat-box-landing-page";
        chatBoxClass = "landing-page";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $57f1b1ae77a561c1$export$2e2bcd8739ae039), {
            theme: customTheme || (0, $61ab0c61cb8221f0$export$2e2bcd8739ae039)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            id: outerClass,
            className: chatBoxWrapClasses(),
            ref: chatBoxWrapRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            id: "chat-box",
            className: chatBoxClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
            id: displayState === "big" ? "chat-box-prompt" : chatBoxId,
            style: {
                height: chatBoxHeight
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $68ef3417c5409d08$export$2e2bcd8739ae039), {
            mode: props.mode,
            visualViewportSize: visualViewportSize,
            openChatPrompt: open_chat_prompt,
            chatPromptState: chatPromptState,
            events: activeConversationMessages,
            participants: activeConversationMessageParticipants,
            getConversationEvents: loadConversationEvents,
            activeConversation: activeConversation,
            avatarUrl: avatarUrl,
            conversationLabel: conversationLabel,
            bot: bot,
            sendChat: sendChatWrap,
            sendChatOrCreateRef: sendChatOrCreateRef,
            showConversationHistory: ()=>setShowConversationHistory(true),
            bigPrompt: displayState === "big",
            promptsToClosedPromptEvents: prompts_to_closed_prompt_events,
            openChatPrompts: open_chat_prompt,
            phone: phone,
            closeChat: toggleOpenChatPublic,
            setDisplayState: setDisplayState,
            botParticipantID: botParticipantID,
            unconnected: unconnected,
            currentTypingEvent: currentTypingEvent,
            fullScreen: fullScreen,
            majorChatEvents: majorChatEvents,
            cloudAgentName: cloudAgentName,
            cloudAgentAvatar: cloudAgentAvatar
        }))))));
    }
    chatBoxClass += " " + props.mode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $57f1b1ae77a561c1$export$2e2bcd8739ae039), {
        theme: customTheme || (0, $61ab0c61cb8221f0$export$2e2bcd8739ae039)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null, displayState === "open" || displayState === "big" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: outerClass,
        className: chatBoxWrapClasses(),
        ref: chatBoxWrapRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: "chat-box",
        className: chatBoxClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement("div", {
        id: displayState === "big" ? "chat-box-prompt" : chatBoxId,
        ref: chatBoxRef,
        style: {
            height: chatBoxHeight
        }
    }, showConversationHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $e51daa460753b088$export$2e2bcd8739ae039), {
        setShowConversationHistory: setShowConversationHistory,
        conversationList: conversationList,
        setActiveConversationId: chooseConversation,
        loadConversations: performConversationSearchWithCurrentParams,
        phone: phone,
        startNewConvo: startNewConvo,
        readReceipts: readReceipts,
        botAvatar: avatarUrl,
        contrastColor: welcomePacket.contrast_color,
        primaryColor: welcomePacket.primary_color,
        disableNewConversation: welcomePacket.disable_new_conversation
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $68ef3417c5409d08$export$2e2bcd8739ae039), {
        mode: props.mode,
        visualViewportSize: visualViewportSize,
        openChatPrompt: open_chat_prompt,
        chatPromptState: chatPromptState,
        events: activeConversationMessages,
        participants: activeConversationMessageParticipants,
        getConversationEvents: loadConversationEvents,
        activeConversation: activeConversation,
        avatarUrl: avatarUrl,
        conversationLabel: conversationLabel,
        bot: bot,
        sendChat: sendChatWrap,
        sendChatOrCreateRef: sendChatOrCreateRef,
        showConversationHistory: ()=>setShowConversationHistory(true),
        bigPrompt: displayState === "big",
        promptsToClosedPromptEvents: prompts_to_closed_prompt_events,
        openChatPrompts: open_chat_prompt,
        phone: phone,
        closeChat: toggleOpenChatPublic,
        setDisplayState: setDisplayState,
        botParticipantID: botParticipantID,
        unconnected: unconnected,
        currentTypingEvent: currentTypingEvent,
        fullScreen: fullScreen,
        majorChatEvents: majorChatEvents,
        cloudAgentName: cloudAgentName,
        cloudAgentAvatar: cloudAgentAvatar
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $220e7c852750c50a$export$2e2bcd8739ae039), {
        toggleOpenChat: toggleOpenChatPublic,
        openChat: displayState === "open" || displayState === "big",
        welcomePacket: welcomePacket,
        packet_code: packet_code,
        showMiniPrompt: displayState === "mini",
        phone: phone,
        bigPrompt: displayState === "big",
        setDisplayState: setDisplayState,
        events: activeConversationMessages,
        hidden: fullScreen && displayState === "open"
    })));
}
var $3c4ca06cd385c990$export$2e2bcd8739ae039 = $3c4ca06cd385c990$var$App;




var $9a377d1a0480fe10$exports = {};
"use strict";
var $9a377d1a0480fe10$var$has = Object.prototype.hasOwnProperty, $9a377d1a0480fe10$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $9a377d1a0480fe10$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $9a377d1a0480fe10$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $9a377d1a0480fe10$var$Events().__proto__) $9a377d1a0480fe10$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $9a377d1a0480fe10$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $9a377d1a0480fe10$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $9a377d1a0480fe10$var$EE(fn, context || emitter, once), evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $9a377d1a0480fe10$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $9a377d1a0480fe10$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $9a377d1a0480fe10$var$EventEmitter() {
    this._events = new $9a377d1a0480fe10$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($9a377d1a0480fe10$var$has.call(events, name)) names.push($9a377d1a0480fe10$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $9a377d1a0480fe10$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $9a377d1a0480fe10$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $9a377d1a0480fe10$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $9a377d1a0480fe10$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $9a377d1a0480fe10$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $9a377d1a0480fe10$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $9a377d1a0480fe10$var$prefix ? $9a377d1a0480fe10$var$prefix + event : event;
        if (this._events[evt]) $9a377d1a0480fe10$var$clearEvent(this, evt);
    } else {
        this._events = new $9a377d1a0480fe10$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$9a377d1a0480fe10$var$EventEmitter.prototype.off = $9a377d1a0480fe10$var$EventEmitter.prototype.removeListener;
$9a377d1a0480fe10$var$EventEmitter.prototype.addListener = $9a377d1a0480fe10$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$9a377d1a0480fe10$var$EventEmitter.prefixed = $9a377d1a0480fe10$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$9a377d1a0480fe10$var$EventEmitter.EventEmitter = $9a377d1a0480fe10$var$EventEmitter;
$9a377d1a0480fe10$exports = $9a377d1a0480fe10$var$EventEmitter;



function $d84dc1a5e217b32f$var$_mergeNamespaces(n, m) {
    m.forEach(function(e) {
        e && typeof e !== "string" && !Array.isArray(e) && Object.keys(e).forEach(function(k) {
            if (k !== "default" && !(k in n)) {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
    });
    return Object.freeze(n);
}
var $d84dc1a5e217b32f$var$e = Object.defineProperty;
var $d84dc1a5e217b32f$var$h = (i, s, t)=>s in i ? $d84dc1a5e217b32f$var$e(i, s, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }) : i[s] = t;
var $d84dc1a5e217b32f$var$o = (i, s, t)=>$d84dc1a5e217b32f$var$h(i, typeof s != "symbol" ? s + "" : s, t);
class $d84dc1a5e217b32f$export$ca12f2943758ef55 {
    constructor(){
        $d84dc1a5e217b32f$var$o(this, "_locking");
        $d84dc1a5e217b32f$var$o(this, "_locks");
        this._locking = Promise.resolve(), this._locks = 0;
    }
    isLocked() {
        return this._locks > 0;
    }
    lock() {
        this._locks += 1;
        let s;
        const t = new Promise((l)=>s = ()=>{
                this._locks -= 1, l();
            }), c = this._locking.then(()=>s);
        return this._locking = this._locking.then(()=>t), c;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Assert that condition is truthy or throw error (with message)
 */ function $d84dc1a5e217b32f$var$assert(condition, msg) {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- we want the implicit conversion to boolean
    if (!condition) throw new Error(msg);
}
const $d84dc1a5e217b32f$var$FLOAT32_MAX = 3.4028234663852886e38, $d84dc1a5e217b32f$var$FLOAT32_MIN = -340282346638528860000000000000000000000, $d84dc1a5e217b32f$var$UINT32_MAX = 0xffffffff, $d84dc1a5e217b32f$var$INT32_MAX = 0x7fffffff, $d84dc1a5e217b32f$var$INT32_MIN = -2147483648;
/**
 * Assert a valid signed protobuf 32-bit integer.
 */ function $d84dc1a5e217b32f$var$assertInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid int 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $d84dc1a5e217b32f$var$INT32_MAX || arg < $d84dc1a5e217b32f$var$INT32_MIN) throw new Error("invalid int 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid unsigned protobuf 32-bit integer.
 */ function $d84dc1a5e217b32f$var$assertUInt32(arg) {
    if (typeof arg !== "number") throw new Error("invalid uint 32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $d84dc1a5e217b32f$var$UINT32_MAX || arg < 0) throw new Error("invalid uint 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
/**
 * Assert a valid protobuf float value.
 */ function $d84dc1a5e217b32f$var$assertFloat32(arg) {
    if (typeof arg !== "number") throw new Error("invalid float 32: " + typeof arg);
    if (!Number.isFinite(arg)) return;
    if (arg > $d84dc1a5e217b32f$var$FLOAT32_MAX || arg < $d84dc1a5e217b32f$var$FLOAT32_MIN) throw new Error("invalid float 32: " + arg); // eslint-disable-line @typescript-eslint/restrict-plus-operands -- we want the implicit conversion to string
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const $d84dc1a5e217b32f$var$enumTypeSymbol = Symbol("@bufbuild/protobuf/enum-type");
/**
 * Get reflection information from a generated enum.
 * If this function is called on something other than a generated
 * enum, it raises an error.
 */ function $d84dc1a5e217b32f$var$getEnumType(enumObject) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-explicit-any
    const t = enumObject[$d84dc1a5e217b32f$var$enumTypeSymbol];
    $d84dc1a5e217b32f$var$assert(t, "missing enum type on enum object");
    return t; // eslint-disable-line @typescript-eslint/no-unsafe-return
}
/**
 * Sets reflection information on a generated enum.
 */ function $d84dc1a5e217b32f$var$setEnumType(enumObject, typeName, values, opt) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    enumObject[$d84dc1a5e217b32f$var$enumTypeSymbol] = $d84dc1a5e217b32f$var$makeEnumType(typeName, values.map((v)=>({
            no: v.no,
            name: v.name,
            localName: enumObject[v.no]
        })));
}
/**
 * Create a new EnumType with the given values.
 */ function $d84dc1a5e217b32f$var$makeEnumType(typeName, values, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_opt) {
    const names = Object.create(null);
    const numbers = Object.create(null);
    const normalValues = [];
    for (const value of values){
        // We do not surface options at this time
        // const value: EnumValueInfo = {...v, options: v.options ?? emptyReadonlyObject};
        const n = $d84dc1a5e217b32f$var$normalizeEnumValue(value);
        normalValues.push(n);
        names[value.name] = n;
        numbers[value.no] = n;
    }
    return {
        typeName: typeName,
        values: normalValues,
        // We do not surface options at this time
        // options: opt?.options ?? Object.create(null),
        findName (name) {
            return names[name];
        },
        findNumber (no) {
            return numbers[no];
        }
    };
}
/**
 * Create a new enum object with the given values.
 * Sets reflection information.
 */ function $d84dc1a5e217b32f$var$makeEnum(typeName, values, opt) {
    const enumObject = {};
    for (const value of values){
        const n = $d84dc1a5e217b32f$var$normalizeEnumValue(value);
        enumObject[n.localName] = n.no;
        enumObject[n.no] = n.localName;
    }
    $d84dc1a5e217b32f$var$setEnumType(enumObject, typeName, values);
    return enumObject;
}
function $d84dc1a5e217b32f$var$normalizeEnumValue(value) {
    if ("localName" in value) return value;
    return Object.assign(Object.assign({}, value), {
        localName: value.name
    });
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Message is the base class of every message, generated, or created at
 * runtime.
 *
 * It is _not_ safe to extend this class. If you want to create a message at
 * run time, use proto3.makeMessageType().
 */ class $d84dc1a5e217b32f$var$Message {
    /**
   * Compare with a message of the same type.
   * Note that this function disregards extensions and unknown fields.
   */ equals(other) {
        return this.getType().runtime.util.equals(this.getType(), this, other);
    }
    /**
   * Create a deep copy.
   */ clone() {
        return this.getType().runtime.util.clone(this);
    }
    /**
   * Parse from binary data, merging fields.
   *
   * Repeated fields are appended. Map entries are added, overwriting
   * existing keys.
   *
   * If a message field is already present, it will be merged with the
   * new data.
   */ fromBinary(bytes, options) {
        const type = this.getType(), format = type.runtime.bin, opt = format.makeReadOptions(options);
        format.readMessage(this, opt.readerFactory(bytes), bytes.byteLength, opt);
        return this;
    }
    /**
   * Parse a message from a JSON value.
   */ fromJson(jsonValue, options) {
        const type = this.getType(), format = type.runtime.json, opt = format.makeReadOptions(options);
        format.readMessage(type, jsonValue, opt, this);
        return this;
    }
    /**
   * Parse a message from a JSON string.
   */ fromJsonString(jsonString, options) {
        let json;
        try {
            json = JSON.parse(jsonString);
        } catch (e) {
            throw new Error("cannot decode ".concat(this.getType().typeName, " from JSON: ").concat(e instanceof Error ? e.message : String(e)));
        }
        return this.fromJson(json, options);
    }
    /**
   * Serialize the message to binary data.
   */ toBinary(options) {
        const type = this.getType(), bin = type.runtime.bin, opt = bin.makeWriteOptions(options), writer = opt.writerFactory();
        bin.writeMessage(this, writer, opt);
        return writer.finish();
    }
    /**
   * Serialize the message to a JSON value, a JavaScript value that can be
   * passed to JSON.stringify().
   */ toJson(options) {
        const type = this.getType(), json = type.runtime.json, opt = json.makeWriteOptions(options);
        return json.writeMessage(this, opt);
    }
    /**
   * Serialize the message to a JSON string.
   */ toJsonString(options) {
        var _a;
        const value = this.toJson(options);
        return JSON.stringify(value, null, (_a = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a !== void 0 ? _a : 0);
    }
    /**
   * Override for serialization behavior. This will be invoked when calling
   * JSON.stringify on this message (i.e. JSON.stringify(msg)).
   *
   * Note that this will not serialize google.protobuf.Any with a packed
   * message because the protobuf JSON format specifies that it needs to be
   * unpacked, and this is only possible with a type registry to look up the
   * message type.  As a result, attempting to serialize a message with this
   * type will throw an Error.
   *
   * This method is protected because you should not need to invoke it
   * directly -- instead use JSON.stringify or toJsonString for
   * stringified JSON.  Alternatively, if actual JSON is desired, you should
   * use toJson.
   */ toJSON() {
        return this.toJson({
            emitDefaultValues: true
        });
    }
    /**
   * Retrieve the MessageType of this message - a singleton that represents
   * the protobuf message declaration and provides metadata for reflection-
   * based operations.
   */ getType() {
        // Any class that extends Message _must_ provide a complete static
        // implementation of MessageType.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
        return Object.getPrototypeOf(this).constructor;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new message type using the given runtime.
 */ function $d84dc1a5e217b32f$var$makeMessageType(runtime, typeName, fields, opt) {
    var _a;
    const localName = (_a = opt === null || opt === void 0 ? void 0 : opt.localName) !== null && _a !== void 0 ? _a : typeName.substring(typeName.lastIndexOf(".") + 1);
    const type = {
        [localName]: function(data) {
            runtime.util.initFields(this);
            runtime.util.initPartial(data, this);
        }
    }[localName];
    Object.setPrototypeOf(type.prototype, new $d84dc1a5e217b32f$var$Message());
    Object.assign(type, {
        runtime: runtime,
        typeName: typeName,
        fields: runtime.util.newFieldList(fields),
        fromBinary (bytes, options) {
            return new type().fromBinary(bytes, options);
        },
        fromJson (jsonValue, options) {
            return new type().fromJson(jsonValue, options);
        },
        fromJsonString (jsonString, options) {
            return new type().fromJsonString(jsonString, options);
        },
        equals (a, b) {
            return runtime.util.equals(type, a, b);
        }
    });
    return type;
}
// Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/* eslint-disable prefer-const,@typescript-eslint/restrict-plus-operands */ /**
 * Read a 64 bit varint as two JS numbers.
 *
 * Returns tuple:
 * [0]: low bits
 * [1]: high bits
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L175
 */ function $d84dc1a5e217b32f$var$varint64read() {
    let lowBits = 0;
    let highBits = 0;
    for(let shift = 0; shift < 28; shift += 7){
        let b = this.buf[this.pos++];
        lowBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    let middleByte = this.buf[this.pos++];
    // last four bits of the first 32 bit number
    lowBits |= (middleByte & 0x0f) << 28;
    // 3 upper bits are part of the next 32 bit number
    highBits = (middleByte & 0x70) >> 4;
    if ((middleByte & 0x80) == 0) {
        this.assertBounds();
        return [
            lowBits,
            highBits
        ];
    }
    for(let shift = 3; shift <= 31; shift += 7){
        let b = this.buf[this.pos++];
        highBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    throw new Error("invalid varint");
}
/**
 * Write a 64 bit varint, given as two JS numbers, to the given bytes array.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/writer.js#L344
 */ function $d84dc1a5e217b32f$var$varint64write(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    const splitBits = lo >>> 28 & 0x0f | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xff);
    if (!hasMoreBits) return;
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const $d84dc1a5e217b32f$var$TWO_PWR_32_DBL = 0x100000000;
/**
 * Parse decimal string of 64 bit integer value as two JS numbers.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $d84dc1a5e217b32f$var$int64FromString(dec) {
    // Check for minus sign.
    const minus = dec[0] === "-";
    if (minus) dec = dec.slice(1);
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to
        if (lowBits >= $d84dc1a5e217b32f$var$TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / $d84dc1a5e217b32f$var$TWO_PWR_32_DBL | 0);
            lowBits = lowBits % $d84dc1a5e217b32f$var$TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return minus ? $d84dc1a5e217b32f$var$negate(lowBits, highBits) : $d84dc1a5e217b32f$var$newBits(lowBits, highBits);
}
/**
 * Losslessly converts a 64-bit signed integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $d84dc1a5e217b32f$var$int64ToString(lo, hi) {
    let bits = $d84dc1a5e217b32f$var$newBits(lo, hi);
    // If we're treating the input as a signed value and the high bit is set, do
    // a manual two's complement conversion before the decimal conversion.
    const negative = bits.hi & 0x80000000;
    if (negative) bits = $d84dc1a5e217b32f$var$negate(bits.lo, bits.hi);
    const result = $d84dc1a5e217b32f$var$uInt64ToString(bits.lo, bits.hi);
    return negative ? "-" + result : result;
}
/**
 * Losslessly converts a 64-bit unsigned integer in 32:32 split representation
 * into a decimal string.
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf-javascript/blob/a428c58273abad07c66071d9753bc4d1289de426/experimental/runtime/int64.js#L10
 */ function $d84dc1a5e217b32f$var$uInt64ToString(lo, hi) {
    ({ lo: lo, hi: hi } = $d84dc1a5e217b32f$var$toUnsigned(lo, hi));
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    // Number.MAX_SAFE_INTEGER = 0x001FFFFF FFFFFFFF, thus any number with
    // highBits <= 0x1FFFFF can be safely expressed with a double and retain
    // integer precision.
    // Proven by: Number.isSafeInteger(0x1FFFFF * 2**32 + 0xFFFFFFFF) == true.
    if (hi <= 0x1FFFFF) return String($d84dc1a5e217b32f$var$TWO_PWR_32_DBL * hi + lo);
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    const low = lo & 0xFFFFFF;
    const mid = (lo >>> 24 | hi << 8) & 0xFFFFFF;
    const high = hi >> 16 & 0xFFFF;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    const base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // If digitC is 0, then we should have returned in the trivial code path
    // at the top for non-safe integers. Given this, we can assume both digitB
    // and digitA need leading zeros.
    return digitC.toString() + $d84dc1a5e217b32f$var$decimalFrom1e7WithLeadingZeros(digitB) + $d84dc1a5e217b32f$var$decimalFrom1e7WithLeadingZeros(digitA);
}
function $d84dc1a5e217b32f$var$toUnsigned(lo, hi) {
    return {
        lo: lo >>> 0,
        hi: hi >>> 0
    };
}
function $d84dc1a5e217b32f$var$newBits(lo, hi) {
    return {
        lo: lo | 0,
        hi: hi | 0
    };
}
/**
 * Returns two's compliment negation of input.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Signed_32-bit_integers
 */ function $d84dc1a5e217b32f$var$negate(lowBits, highBits) {
    highBits = ~highBits;
    if (lowBits) lowBits = ~lowBits + 1;
    else // If lowBits is 0, then bitwise-not is 0xFFFFFFFF,
    // adding 1 to that, results in 0x100000000, which leaves
    // the low bits 0x0 and simply adds one to the high bits.
    highBits += 1;
    return $d84dc1a5e217b32f$var$newBits(lowBits, highBits);
}
/**
 * Returns decimal representation of digit1e7 with leading zeros.
 */ const $d84dc1a5e217b32f$var$decimalFrom1e7WithLeadingZeros = (digit1e7)=>{
    const partial = String(digit1e7);
    return "0000000".slice(partial.length) + partial;
};
/**
 * Write a 32 bit varint, signed or unsigned. Same as `varint64write(0, value, bytes)`
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/1b18833f4f2a2f681f4e4a25cdf3b0a43115ec26/js/binary/encoder.js#L144
 */ function $d84dc1a5e217b32f$var$varint32write(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}
/**
 * Read an unsigned 32 bit varint.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L220
 */ function $d84dc1a5e217b32f$var$varint32read() {
    let b = this.buf[this.pos++];
    let result = b & 0x7f;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 7;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 14;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 21;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    // Extract only last 4 bits
    b = this.buf[this.pos++];
    result |= (b & 0x0f) << 28;
    for(let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)b = this.buf[this.pos++];
    if ((b & 0x80) != 0) throw new Error("invalid varint");
    this.assertBounds();
    // Result can have 32 bits, convert it to unsigned
    return result >>> 0;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $d84dc1a5e217b32f$var$makeInt64Support() {
    const dv = new DataView(new ArrayBuffer(8));
    // note that Safari 14 implements BigInt, but not the DataView methods
    const ok = typeof BigInt === "function" && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function" && (typeof $2cebfb351ff15596$exports != "object" || typeof $2cebfb351ff15596$exports.env != "object" || true);
    if (ok) {
        const MIN = BigInt("-9223372036854775808"), MAX = BigInt("9223372036854775807"), UMIN = BigInt("0"), UMAX = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > MAX || bi < MIN) throw new Error("int64 invalid: ".concat(value));
                return bi;
            },
            uParse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > UMAX || bi < UMIN) throw new Error("uint64 invalid: ".concat(value));
                return bi;
            },
            enc (value) {
                dv.setBigInt64(0, this.parse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            uEnc (value) {
                dv.setBigInt64(0, this.uParse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            dec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigInt64(0, true);
            },
            uDec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigUint64(0, true);
            }
        };
    }
    const assertInt64String = (value)=>$d84dc1a5e217b32f$var$assert(/^-?[0-9]+$/.test(value), "int64 invalid: ".concat(value));
    const assertUInt64String = (value)=>$d84dc1a5e217b32f$var$assert(/^[0-9]+$/.test(value), "uint64 invalid: ".concat(value));
    return {
        zero: "0",
        supported: false,
        parse (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return value;
        },
        uParse (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return value;
        },
        enc (value) {
            if (typeof value != "string") value = value.toString();
            assertInt64String(value);
            return $d84dc1a5e217b32f$var$int64FromString(value);
        },
        uEnc (value) {
            if (typeof value != "string") value = value.toString();
            assertUInt64String(value);
            return $d84dc1a5e217b32f$var$int64FromString(value);
        },
        dec (lo, hi) {
            return $d84dc1a5e217b32f$var$int64ToString(lo, hi);
        },
        uDec (lo, hi) {
            return $d84dc1a5e217b32f$var$uInt64ToString(lo, hi);
        }
    };
}
const $d84dc1a5e217b32f$var$protoInt64 = $d84dc1a5e217b32f$var$makeInt64Support();
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Scalar value types. This is a subset of field types declared by protobuf
 * enum google.protobuf.FieldDescriptorProto.Type The types GROUP and MESSAGE
 * are omitted, but the numerical values are identical.
 */ var $d84dc1a5e217b32f$var$ScalarType;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})($d84dc1a5e217b32f$var$ScalarType || ($d84dc1a5e217b32f$var$ScalarType = {}));
/**
 * JavaScript representation of fields with 64 bit integral types (int64, uint64,
 * sint64, fixed64, sfixed64).
 *
 * This is a subset of google.protobuf.FieldOptions.JSType, which defines JS_NORMAL,
 * JS_STRING, and JS_NUMBER. Protobuf-ES uses BigInt by default, but will use
 * String if `[jstype = JS_STRING]` is specified.
 *
 * ```protobuf
 * uint64 field_a = 1; // BigInt
 * uint64 field_b = 2 [jstype = JS_NORMAL]; // BigInt
 * uint64 field_b = 2 [jstype = JS_NUMBER]; // BigInt
 * uint64 field_b = 2 [jstype = JS_STRING]; // String
 * ```
 */ var $d84dc1a5e217b32f$var$LongType;
(function(LongType) {
    /**
   * Use JavaScript BigInt.
   */ LongType[LongType["BIGINT"] = 0] = "BIGINT";
    /**
   * Use JavaScript String.
   *
   * Field option `[jstype = JS_STRING]`.
   */ LongType[LongType["STRING"] = 1] = "STRING";
})($d84dc1a5e217b32f$var$LongType || ($d84dc1a5e217b32f$var$LongType = {}));
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if both scalar values are equal.
 */ function $d84dc1a5e217b32f$var$scalarEquals(type, a, b) {
    if (a === b) // This correctly matches equal values except BYTES and (possibly) 64-bit integers.
    return true;
    // Special case BYTES - we need to compare each byte individually
    if (type == $d84dc1a5e217b32f$var$ScalarType.BYTES) {
        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array)) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // Special case 64-bit integers - we support number, string and bigint representation.
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(type){
        case $d84dc1a5e217b32f$var$ScalarType.UINT64:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.INT64:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.SINT64:
            // Loose comparison will match between 0n, 0 and "0".
            return a == b;
    }
    // Anything that hasn't been caught by strict comparison or special cased
    // BYTES and 64-bit integers is not equal.
    return false;
}
/**
 * Returns the zero value for the given scalar type.
 */ function $d84dc1a5e217b32f$var$scalarZeroValue(type, longType) {
    switch(type){
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            return false;
        case $d84dc1a5e217b32f$var$ScalarType.UINT64:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.INT64:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.SINT64:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            return longType == 0 ? $d84dc1a5e217b32f$var$protoInt64.zero : "0";
        case $d84dc1a5e217b32f$var$ScalarType.DOUBLE:
        case $d84dc1a5e217b32f$var$ScalarType.FLOAT:
            return 0.0;
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
            return new Uint8Array(0);
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            return "";
        default:
            // Handles INT32, UINT32, SINT32, FIXED32, SFIXED32.
            // We do not use individual cases to save a few bytes code size.
            return 0;
    }
}
/**
 * Returns true for a zero-value. For example, an integer has the zero-value `0`,
 * a boolean is `false`, a string is `""`, and bytes is an empty Uint8Array.
 *
 * In proto3, zero-values are not written to the wire, unless the field is
 * optional or repeated.
 */ function $d84dc1a5e217b32f$var$isScalarZeroValue(type, value) {
    switch(type){
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            return value === false;
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            return value === "";
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
            return value instanceof Uint8Array && !value.byteLength;
        default:
            return value == 0;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/restrict-plus-operands */ /**
 * Protobuf binary format wire types.
 *
 * A wire type provides just enough information to find the length of the
 * following value.
 *
 * See https://developers.google.com/protocol-buffers/docs/encoding#structure
 */ var $d84dc1a5e217b32f$var$WireType;
(function(WireType) {
    /**
   * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
   */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
   * Used for fixed64, sfixed64, double.
   * Always 8 bytes with little-endian byte order.
   */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
   * Used for string, bytes, embedded messages, packed repeated fields
   *
   * Only repeated numeric types (types which use the varint, 32-bit,
   * or 64-bit wire types) can be packed. In proto3, such fields are
   * packed by default.
   */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
   * Start of a tag-delimited aggregate, such as a proto2 group, or a message
   * in editions with message_encoding = DELIMITED.
   */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
   * End of a tag-delimited aggregate.
   */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
   * Used for fixed32, sfixed32, float.
   * Always 4 bytes with little-endian byte order.
   */ WireType[WireType["Bit32"] = 5] = "Bit32";
})($d84dc1a5e217b32f$var$WireType || ($d84dc1a5e217b32f$var$WireType = {}));
class $d84dc1a5e217b32f$var$BinaryWriter {
    constructor(textEncoder){
        /**
     * Previous fork states.
     */ this.stack = [];
        this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
        this.chunks = [];
        this.buf = [];
    }
    /**
   * Return all bytes written and reset this writer.
   */ finish() {
        this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error("invalid state, fork stack empty");
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
   * Write a chunk of raw bytes.
   */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */ uint32(value) {
        $d84dc1a5e217b32f$var$assertUInt32(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
   * Write a `int32` value, a signed 32 bit varint.
   */ int32(value) {
        $d84dc1a5e217b32f$var$assertInt32(value);
        $d84dc1a5e217b32f$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `bool` value, a variant.
   */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */ string(value) {
        let chunk = this.textEncoder.encode(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
   * Write a `float` value, 32-bit floating point number.
   */ float(value) {
        $d84dc1a5e217b32f$var$assertFloat32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `double` value, a 64-bit floating point number.
   */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */ fixed32(value) {
        $d84dc1a5e217b32f$var$assertUInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */ sfixed32(value) {
        $d84dc1a5e217b32f$var$assertInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */ sint32(value) {
        $d84dc1a5e217b32f$var$assertInt32(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        $d84dc1a5e217b32f$var$varint32write(value, this.buf);
        return this;
    }
    /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */ sfixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $d84dc1a5e217b32f$var$protoInt64.enc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */ fixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = $d84dc1a5e217b32f$var$protoInt64.uEnc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
   * Write a `int64` value, a signed 64-bit varint.
   */ int64(value) {
        let tc = $d84dc1a5e217b32f$var$protoInt64.enc(value);
        $d84dc1a5e217b32f$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
    /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */ sint64(value) {
        let tc = $d84dc1a5e217b32f$var$protoInt64.enc(value), // zigzag encode
        sign = tc.hi >> 31, lo = tc.lo << 1 ^ sign, hi = (tc.hi << 1 | tc.lo >>> 31) ^ sign;
        $d84dc1a5e217b32f$var$varint64write(lo, hi, this.buf);
        return this;
    }
    /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */ uint64(value) {
        let tc = $d84dc1a5e217b32f$var$protoInt64.uEnc(value);
        $d84dc1a5e217b32f$var$varint64write(tc.lo, tc.hi, this.buf);
        return this;
    }
}
class $d84dc1a5e217b32f$var$BinaryReader {
    constructor(buf, textDecoder){
        this.varint64 = $d84dc1a5e217b32f$var$varint64read; // dirty cast for `this`
        /**
     * Read a `uint32` field, an unsigned 32 bit varint.
     */ this.uint32 = $d84dc1a5e217b32f$var$varint32read; // dirty cast for `this` and access to protected `buf`
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
        this.textDecoder = textDecoder !== null && textDecoder !== void 0 ? textDecoder : new TextDecoder();
    }
    /**
   * Reads a tag - field number and wire type.
   */ tag() {
        let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
        if (fieldNo <= 0 || wireType < 0 || wireType > 5) throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
        return [
            fieldNo,
            wireType
        ];
    }
    /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */ skip(wireType, fieldNo) {
        let start = this.pos;
        switch(wireType){
            case $d84dc1a5e217b32f$var$WireType.Varint:
                while(this.buf[this.pos++] & 0x80);
                break;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $d84dc1a5e217b32f$var$WireType.Bit64:
                this.pos += 4;
            // eslint-disable-next-line
            // @ts-ignore TS7029: Fallthrough case in switch
            case $d84dc1a5e217b32f$var$WireType.Bit32:
                this.pos += 4;
                break;
            case $d84dc1a5e217b32f$var$WireType.LengthDelimited:
                let len = this.uint32();
                this.pos += len;
                break;
            case $d84dc1a5e217b32f$var$WireType.StartGroup:
                for(;;){
                    const [fn, wt] = this.tag();
                    if (wt === $d84dc1a5e217b32f$var$WireType.EndGroup) {
                        if (fieldNo !== undefined && fn !== fieldNo) throw new Error("invalid end group tag");
                        break;
                    }
                    this.skip(wt, fn);
                }
                break;
            default:
                throw new Error("cant skip wire type " + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    /**
   * Throws error if position in byte array is out of range.
   */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
   * Read a `int32` field, a signed 32 bit varint.
   */ int32() {
        return this.uint32() | 0;
    }
    /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */ sint32() {
        let zze = this.uint32();
        // decode zigzag
        return zze >>> 1 ^ -(zze & 1);
    }
    /**
   * Read a `int64` field, a signed 64-bit varint.
   */ int64() {
        return $d84dc1a5e217b32f$var$protoInt64.dec(...this.varint64());
    }
    /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */ uint64() {
        return $d84dc1a5e217b32f$var$protoInt64.uDec(...this.varint64());
    }
    /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */ sint64() {
        let [lo, hi] = this.varint64();
        // decode zig zag
        let s = -(lo & 1);
        lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
        hi = hi >>> 1 ^ s;
        return $d84dc1a5e217b32f$var$protoInt64.dec(lo, hi);
    }
    /**
   * Read a `bool` field, a variant.
   */ bool() {
        let [lo, hi] = this.varint64();
        return lo !== 0 || hi !== 0;
    }
    /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */ fixed32() {
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */ sfixed32() {
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */ fixed64() {
        return $d84dc1a5e217b32f$var$protoInt64.uDec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */ sfixed64() {
        return $d84dc1a5e217b32f$var$protoInt64.dec(this.sfixed32(), this.sfixed32());
    }
    /**
   * Read a `float` field, 32-bit floating point number.
   */ float() {
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
   * Read a `double` field, a 64-bit floating point number.
   */ double() {
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */ bytes() {
        let len = this.uint32(), start = this.pos;
        this.pos += len;
        this.assertBounds();
        return this.buf.subarray(start, start + len);
    }
    /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */ string() {
        return this.textDecoder.decode(this.bytes());
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a new extension using the given runtime.
 */ function $d84dc1a5e217b32f$var$makeExtension(runtime, typeName, extendee, field) {
    let fi;
    return {
        typeName: typeName,
        extendee: extendee,
        get field () {
            if (!fi) {
                const i = typeof field == "function" ? field() : field;
                i.name = typeName.split(".").pop();
                i.jsonName = "[".concat(typeName, "]");
                fi = runtime.util.newFieldList([
                    i
                ]).list()[0];
            }
            return fi;
        },
        runtime: runtime
    };
}
/**
 * Create a container that allows us to read extension fields into it with the
 * same logic as regular fields.
 */ function $d84dc1a5e217b32f$var$createExtensionContainer(extension) {
    const localName = extension.field.localName;
    const container = Object.create(null);
    container[localName] = $d84dc1a5e217b32f$var$initExtensionField(extension);
    return [
        container,
        ()=>container[localName]
    ];
}
function $d84dc1a5e217b32f$var$initExtensionField(ext) {
    const field = ext.field;
    if (field.repeated) return [];
    if (field.default !== undefined) return field.default;
    switch(field.kind){
        case "enum":
            return field.T.values[0].no;
        case "scalar":
            return $d84dc1a5e217b32f$var$scalarZeroValue(field.T, field.L);
        case "message":
            // eslint-disable-next-line no-case-declarations
            const T = field.T, value = new T();
            return T.fieldWrapper ? T.fieldWrapper.unwrapField(value) : value;
        case "map":
            throw "map fields are not allowed to be extensions";
    }
}
/**
 * Helper to filter unknown fields, optimized based on field type.
 */ function $d84dc1a5e217b32f$var$filterUnknownFields(unknownFields, field) {
    if (!field.repeated && (field.kind == "enum" || field.kind == "scalar")) {
        // singular scalar fields do not merge, we pick the last
        for(let i = unknownFields.length - 1; i >= 0; --i){
            if (unknownFields[i].no == field.no) return [
                unknownFields[i]
            ];
        }
        return [];
    }
    return unknownFields.filter((uf)=>uf.no === field.no);
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unnecessary-condition, prefer-const */ // lookup table from base64 character to byte
let $d84dc1a5e217b32f$var$encTable = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
// lookup table from base64 character *code* to byte because lookup by number is fast
let $d84dc1a5e217b32f$var$decTable = [];
for(let i = 0; i < $d84dc1a5e217b32f$var$encTable.length; i++)$d84dc1a5e217b32f$var$decTable[$d84dc1a5e217b32f$var$encTable[i].charCodeAt(0)] = i;
// support base64url variants
$d84dc1a5e217b32f$var$decTable["-".charCodeAt(0)] = $d84dc1a5e217b32f$var$encTable.indexOf("+");
$d84dc1a5e217b32f$var$decTable["_".charCodeAt(0)] = $d84dc1a5e217b32f$var$encTable.indexOf("/");
const $d84dc1a5e217b32f$var$protoBase64 = {
    /**
   * Decodes a base64 string to a byte array.
   *
   * - ignores white-space, including line breaks and tabs
   * - allows inner padding (can decode concatenated base64 strings)
   * - does not require padding
   * - understands base64url encoding:
   *   "-" instead of "+",
   *   "_" instead of "/",
   *   no padding
   */ dec (base64Str) {
        // estimate byte size, not accounting for inner padding and whitespace
        let es = base64Str.length * 3 / 4;
        if (base64Str[base64Str.length - 2] == "=") es -= 2;
        else if (base64Str[base64Str.length - 1] == "=") es -= 1;
        let bytes = new Uint8Array(es), bytePos = 0, // position in byte array
        groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // previous byte
        for(let i = 0; i < base64Str.length; i++){
            b = $d84dc1a5e217b32f$var$decTable[base64Str.charCodeAt(i)];
            if (b === undefined) switch(base64Str[i]){
                // @ts-ignore TS7029: Fallthrough case in switch
                case "=":
                    groupPos = 0;
                // reset state when padding found
                // @ts-ignore TS7029: Fallthrough case in switch
                case "\n":
                case "\r":
                case "	":
                case " ":
                    continue;
                // skip white-space, and padding
                default:
                    throw Error("invalid base64 string.");
            }
            switch(groupPos){
                case 0:
                    p = b;
                    groupPos = 1;
                    break;
                case 1:
                    bytes[bytePos++] = p << 2 | (b & 48) >> 4;
                    p = b;
                    groupPos = 2;
                    break;
                case 2:
                    bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
                    p = b;
                    groupPos = 3;
                    break;
                case 3:
                    bytes[bytePos++] = (p & 3) << 6 | b;
                    groupPos = 0;
                    break;
            }
        }
        if (groupPos == 1) throw Error("invalid base64 string.");
        return bytes.subarray(0, bytePos);
    },
    /**
   * Encode a byte array to a base64 string.
   */ enc (bytes) {
        let base64 = "", groupPos = 0, // position in base64 group
        b, // current byte
        p = 0; // carry over from previous byte
        for(let i = 0; i < bytes.length; i++){
            b = bytes[i];
            switch(groupPos){
                case 0:
                    base64 += $d84dc1a5e217b32f$var$encTable[b >> 2];
                    p = (b & 3) << 4;
                    groupPos = 1;
                    break;
                case 1:
                    base64 += $d84dc1a5e217b32f$var$encTable[p | b >> 4];
                    p = (b & 15) << 2;
                    groupPos = 2;
                    break;
                case 2:
                    base64 += $d84dc1a5e217b32f$var$encTable[p | b >> 6];
                    base64 += $d84dc1a5e217b32f$var$encTable[b & 63];
                    groupPos = 0;
                    break;
            }
        }
        // add output padding
        if (groupPos) {
            base64 += $d84dc1a5e217b32f$var$encTable[p];
            base64 += "=";
            if (groupPos == 1) base64 += "=";
        }
        return base64;
    }
};
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Retrieve an extension value from a message.
 *
 * The function never returns undefined. Use hasExtension() to check whether an
 * extension is set. If the extension is not set, this function returns the
 * default value (if one was specified in the protobuf source), or the zero value
 * (for example `0` for numeric types, `[]` for repeated extension fields, and
 * an empty message instance for message fields).
 *
 * Extensions are stored as unknown fields on a message. To mutate an extension
 * value, make sure to store the new value with setExtension() after mutating.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $d84dc1a5e217b32f$var$getExtension(message, extension, options) {
    $d84dc1a5e217b32f$var$assertExtendee(extension, message);
    const opt = extension.runtime.bin.makeReadOptions(options);
    const ufs = $d84dc1a5e217b32f$var$filterUnknownFields(message.getType().runtime.bin.listUnknownFields(message), extension.field);
    const [container, get] = $d84dc1a5e217b32f$var$createExtensionContainer(extension);
    for (const uf of ufs)extension.runtime.bin.readField(container, opt.readerFactory(uf.data), extension.field, uf.wireType, opt);
    return get();
}
/**
 * Set an extension value on a message. If the message already has a value for
 * this extension, the value is replaced.
 *
 * If the extension does not extend the given message, an error is raised.
 */ function $d84dc1a5e217b32f$var$setExtension(message, extension, value, options) {
    $d84dc1a5e217b32f$var$assertExtendee(extension, message);
    const readOpt = extension.runtime.bin.makeReadOptions(options);
    const writeOpt = extension.runtime.bin.makeWriteOptions(options);
    if ($d84dc1a5e217b32f$var$hasExtension(message, extension)) {
        const ufs = message.getType().runtime.bin.listUnknownFields(message).filter((uf)=>uf.no != extension.field.no);
        message.getType().runtime.bin.discardUnknownFields(message);
        for (const uf of ufs)message.getType().runtime.bin.onUnknownField(message, uf.no, uf.wireType, uf.data);
    }
    const writer = writeOpt.writerFactory();
    let f = extension.field;
    // Implicit presence does not apply to extensions, see https://github.com/protocolbuffers/protobuf/issues/8234
    // We patch the field info to use explicit presence:
    if (!f.opt && !f.repeated && (f.kind == "enum" || f.kind == "scalar")) f = Object.assign(Object.assign({}, extension.field), {
        opt: true
    });
    extension.runtime.bin.writeField(f, value, writer, writeOpt);
    const reader = readOpt.readerFactory(writer.finish());
    while(reader.pos < reader.len){
        const [no, wireType] = reader.tag();
        const data = reader.skip(wireType, no);
        message.getType().runtime.bin.onUnknownField(message, no, wireType, data);
    }
}
/**
 * Check whether an extension is set on a message.
 */ function $d84dc1a5e217b32f$var$hasExtension(message, extension) {
    const messageType = message.getType();
    return extension.extendee.typeName === messageType.typeName && !!messageType.runtime.bin.listUnknownFields(message).find((uf)=>uf.no == extension.field.no);
}
function $d84dc1a5e217b32f$var$assertExtendee(extension, message) {
    $d84dc1a5e217b32f$var$assert(extension.extendee.typeName == message.getType().typeName, "extension ".concat(extension.typeName, " can only be applied to message ").concat(extension.extendee.typeName));
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns true if the field is set.
 */ function $d84dc1a5e217b32f$var$isFieldSet(field, target) {
    const localName = field.localName;
    if (field.repeated) return target[localName].length > 0;
    if (field.oneof) return target[field.oneof.localName].case === localName; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
    switch(field.kind){
        case "enum":
        case "scalar":
            if (field.opt || field.req) // explicit presence
            return target[localName] !== undefined;
            // implicit presence
            if (field.kind == "enum") return target[localName] !== field.T.values[0].no;
            return !$d84dc1a5e217b32f$var$isScalarZeroValue(field.T, target[localName]);
        case "message":
            return target[localName] !== undefined;
        case "map":
            return Object.keys(target[localName]).length > 0;
    }
}
/**
 * Resets the field, so that isFieldSet() will return false.
 */ function $d84dc1a5e217b32f$var$clearField(field, target) {
    const localName = field.localName;
    const implicitPresence = !field.opt && !field.req;
    if (field.repeated) target[localName] = [];
    else if (field.oneof) target[field.oneof.localName] = {
        case: undefined
    };
    else switch(field.kind){
        case "map":
            target[localName] = {};
            break;
        case "enum":
            target[localName] = implicitPresence ? field.T.values[0].no : undefined;
            break;
        case "scalar":
            target[localName] = implicitPresence ? $d84dc1a5e217b32f$var$scalarZeroValue(field.T, field.L) : undefined;
            break;
        case "message":
            target[localName] = undefined;
            break;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Check whether the given object is any subtype of Message or is a specific
 * Message by passing the type.
 *
 * Just like `instanceof`, `isMessage` narrows the type. The advantage of
 * `isMessage` is that it compares identity by the message type name, not by
 * class identity. This makes it robust against the dual package hazard and
 * similar situations, where the same message is duplicated.
 *
 * This function is _mostly_ equivalent to the `instanceof` operator. For
 * example, `isMessage(foo, MyMessage)` is the same as `foo instanceof MyMessage`,
 * and `isMessage(foo)` is the same as `foo instanceof Message`. In most cases,
 * `isMessage` should be preferred over `instanceof`.
 *
 * However, due to the fact that `isMessage` does not use class identity, there
 * are subtle differences between this function and `instanceof`. Notably,
 * calling `isMessage` on an explicit type of Message will return false.
 */ function $d84dc1a5e217b32f$var$isMessage(arg, type) {
    if (arg === null || typeof arg != "object") return false;
    if (!Object.getOwnPropertyNames($d84dc1a5e217b32f$var$Message.prototype).every((m)=>m in arg && typeof arg[m] == "function")) return false;
    const actualType = arg.getType();
    if (actualType === null || typeof actualType != "function" || !("typeName" in actualType) || typeof actualType.typeName != "string") return false;
    return type === undefined ? true : actualType.typeName == type.typeName;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Wrap a primitive message field value in its corresponding wrapper
 * message. This function is idempotent.
 */ function $d84dc1a5e217b32f$var$wrapField(type, value) {
    if ($d84dc1a5e217b32f$var$isMessage(value) || !type.fieldWrapper) return value;
    return type.fieldWrapper.wrapField(value);
}
$d84dc1a5e217b32f$var$ScalarType.DOUBLE, $d84dc1a5e217b32f$var$ScalarType.FLOAT, $d84dc1a5e217b32f$var$ScalarType.INT64, $d84dc1a5e217b32f$var$ScalarType.UINT64, $d84dc1a5e217b32f$var$ScalarType.INT32, $d84dc1a5e217b32f$var$ScalarType.UINT32, $d84dc1a5e217b32f$var$ScalarType.BOOL, $d84dc1a5e217b32f$var$ScalarType.STRING, $d84dc1a5e217b32f$var$ScalarType.BYTES;
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable no-case-declarations,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call */ // Default options for parsing JSON.
const $d84dc1a5e217b32f$var$jsonReadDefaults = {
    ignoreUnknownFields: false
};
// Default options for serializing to JSON.
const $d84dc1a5e217b32f$var$jsonWriteDefaults = {
    emitDefaultValues: false,
    enumAsInteger: false,
    useProtoFieldName: false,
    prettySpaces: 0
};
function $d84dc1a5e217b32f$var$makeReadOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$jsonReadDefaults), options) : $d84dc1a5e217b32f$var$jsonReadDefaults;
}
function $d84dc1a5e217b32f$var$makeWriteOptions$1(options) {
    return options ? Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$jsonWriteDefaults), options) : $d84dc1a5e217b32f$var$jsonWriteDefaults;
}
const $d84dc1a5e217b32f$var$tokenNull = Symbol();
const $d84dc1a5e217b32f$var$tokenIgnoredUnknownEnum = Symbol();
function $d84dc1a5e217b32f$var$makeJsonFormat() {
    return {
        makeReadOptions: $d84dc1a5e217b32f$var$makeReadOptions$1,
        makeWriteOptions: $d84dc1a5e217b32f$var$makeWriteOptions$1,
        readMessage (type, json, options, message) {
            if (json == null || Array.isArray(json) || typeof json != "object") throw new Error("cannot decode message ".concat(type.typeName, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(json)));
            message = message !== null && message !== void 0 ? message : new type();
            const oneofSeen = new Map();
            const registry = options.typeRegistry;
            for (const [jsonKey, jsonValue] of Object.entries(json)){
                const field = type.fields.findJsonName(jsonKey);
                if (field) {
                    if (field.oneof) {
                        if (jsonValue === null && field.kind == "scalar") continue;
                        const seen = oneofSeen.get(field.oneof);
                        if (seen !== undefined) throw new Error("cannot decode message ".concat(type.typeName, ' from JSON: multiple keys for oneof "').concat(field.oneof.name, '" present: "').concat(seen, '", "').concat(jsonKey, '"'));
                        oneofSeen.set(field.oneof, jsonKey);
                    }
                    $d84dc1a5e217b32f$var$readField$1(message, jsonValue, field, options, type);
                } else {
                    let found = false;
                    if ((registry === null || registry === void 0 ? void 0 : registry.findExtension) && jsonKey.startsWith("[") && jsonKey.endsWith("]")) {
                        const ext = registry.findExtension(jsonKey.substring(1, jsonKey.length - 1));
                        if (ext && ext.extendee.typeName == type.typeName) {
                            found = true;
                            const [container, get] = $d84dc1a5e217b32f$var$createExtensionContainer(ext);
                            $d84dc1a5e217b32f$var$readField$1(container, jsonValue, ext.field, options, ext);
                            // We pass on the options as BinaryReadOptions/BinaryWriteOptions,
                            // so that users can bring their own binary reader and writer factories
                            // if necessary.
                            $d84dc1a5e217b32f$var$setExtension(message, ext, get(), options);
                        }
                    }
                    if (!found && !options.ignoreUnknownFields) throw new Error("cannot decode message ".concat(type.typeName, ' from JSON: key "').concat(jsonKey, '" is unknown'));
                }
            }
            return message;
        },
        writeMessage (message, options) {
            const type = message.getType();
            const json = {};
            let field;
            try {
                for (field of type.fields.byNumber()){
                    if (!$d84dc1a5e217b32f$var$isFieldSet(field, message)) {
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        if (field.req) throw "required field not set";
                        if (!options.emitDefaultValues) continue;
                        if (!$d84dc1a5e217b32f$var$canEmitFieldDefaultValue(field)) continue;
                    }
                    const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                    const jsonValue = $d84dc1a5e217b32f$var$writeField$1(field, value, options);
                    if (jsonValue !== undefined) json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
                }
                const registry = options.typeRegistry;
                if (registry === null || registry === void 0 ? void 0 : registry.findExtensionFor) for (const uf of type.runtime.bin.listUnknownFields(message)){
                    const ext = registry.findExtensionFor(type.typeName, uf.no);
                    if (ext && $d84dc1a5e217b32f$var$hasExtension(message, ext)) {
                        // We pass on the options as BinaryReadOptions, so that users can bring their own
                        // binary reader factory if necessary.
                        const value = $d84dc1a5e217b32f$var$getExtension(message, ext, options);
                        const jsonValue = $d84dc1a5e217b32f$var$writeField$1(ext.field, value, options);
                        if (jsonValue !== undefined) json[ext.field.jsonName] = jsonValue;
                    }
                }
            } catch (e) {
                const m = field ? "cannot encode field ".concat(type.typeName, ".").concat(field.name, " to JSON") : "cannot encode message ".concat(type.typeName, " to JSON");
                const r = e instanceof Error ? e.message : String(e);
                throw new Error(m + (r.length > 0 ? ": ".concat(r) : ""));
            }
            return json;
        },
        readScalar (type, json, longType) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            return $d84dc1a5e217b32f$var$readScalar$1(type, json, longType !== null && longType !== void 0 ? longType : $d84dc1a5e217b32f$var$LongType.BIGINT, true);
        },
        writeScalar (type, value, emitDefaultValues) {
            // The signature of our internal function has changed. For backwards-
            // compatibility, we support the old form that is part of the public API
            // through the interface JsonFormat.
            if (value === undefined) return undefined;
            if (emitDefaultValues || $d84dc1a5e217b32f$var$isScalarZeroValue(type, value)) return $d84dc1a5e217b32f$var$writeScalar$1(type, value);
            return undefined;
        },
        debug: $d84dc1a5e217b32f$var$debugJsonValue
    };
}
function $d84dc1a5e217b32f$var$debugJsonValue(json) {
    if (json === null) return "null";
    switch(typeof json){
        case "object":
            return Array.isArray(json) ? "array" : "object";
        case "string":
            return json.length > 100 ? "string" : '"'.concat(json.split('"').join('\\"'), '"');
        default:
            return String(json);
    }
}
// Read a JSON value for a field.
// The "parentType" argument is only used to provide context in errors.
function $d84dc1a5e217b32f$var$readField$1(target, jsonValue, field, options, parentType) {
    let localName = field.localName;
    if (field.repeated) {
        $d84dc1a5e217b32f$var$assert(field.kind != "map");
        if (jsonValue === null) return;
        if (!Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonValue)));
        const targetArray = target[localName];
        for (const jsonItem of jsonValue){
            if (jsonItem === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonItem)));
            switch(field.kind){
                case "message":
                    targetArray.push(field.T.fromJson(jsonItem, options));
                    break;
                case "enum":
                    const enumValue = $d84dc1a5e217b32f$var$readEnum(field.T, jsonItem, options.ignoreUnknownFields, true);
                    if (enumValue !== $d84dc1a5e217b32f$var$tokenIgnoredUnknownEnum) targetArray.push(enumValue);
                    break;
                case "scalar":
                    try {
                        targetArray.push($d84dc1a5e217b32f$var$readScalar$1(field.T, jsonItem, field.L, true));
                    } catch (e) {
                        let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonItem));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else if (field.kind == "map") {
        if (jsonValue === null) return;
        if (typeof jsonValue != "object" || Array.isArray(jsonValue)) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonValue)));
        const targetMap = target[localName];
        for (const [jsonMapKey, jsonMapValue] of Object.entries(jsonValue)){
            if (jsonMapValue === null) throw new Error("cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: map value null"));
            let key;
            try {
                key = $d84dc1a5e217b32f$var$readMapKey(field.K, jsonMapKey);
            } catch (e) {
                let m = "cannot decode map key for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonValue));
                if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                throw new Error(m);
            }
            switch(field.V.kind){
                case "message":
                    targetMap[key] = field.V.T.fromJson(jsonMapValue, options);
                    break;
                case "enum":
                    const enumValue = $d84dc1a5e217b32f$var$readEnum(field.V.T, jsonMapValue, options.ignoreUnknownFields, true);
                    if (enumValue !== $d84dc1a5e217b32f$var$tokenIgnoredUnknownEnum) targetMap[key] = enumValue;
                    break;
                case "scalar":
                    try {
                        targetMap[key] = $d84dc1a5e217b32f$var$readScalar$1(field.V.T, jsonMapValue, $d84dc1a5e217b32f$var$LongType.BIGINT, true);
                    } catch (e) {
                        let m = "cannot decode map value for field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonValue));
                        if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                        throw new Error(m);
                    }
                    break;
            }
        }
    } else {
        if (field.oneof) {
            target = target[field.oneof.localName] = {
                case: localName
            };
            localName = "value";
        }
        switch(field.kind){
            case "message":
                const messageType = field.T;
                if (jsonValue === null && messageType.typeName != "google.protobuf.Value") return;
                let currentValue = target[localName];
                if ($d84dc1a5e217b32f$var$isMessage(currentValue)) currentValue.fromJson(jsonValue, options);
                else {
                    target[localName] = currentValue = messageType.fromJson(jsonValue, options);
                    if (messageType.fieldWrapper && !field.oneof) target[localName] = messageType.fieldWrapper.unwrapField(currentValue);
                }
                break;
            case "enum":
                const enumValue = $d84dc1a5e217b32f$var$readEnum(field.T, jsonValue, options.ignoreUnknownFields, false);
                switch(enumValue){
                    case $d84dc1a5e217b32f$var$tokenNull:
                        $d84dc1a5e217b32f$var$clearField(field, target);
                        break;
                    case $d84dc1a5e217b32f$var$tokenIgnoredUnknownEnum:
                        break;
                    default:
                        target[localName] = enumValue;
                        break;
                }
                break;
            case "scalar":
                try {
                    const scalarValue = $d84dc1a5e217b32f$var$readScalar$1(field.T, jsonValue, field.L, false);
                    switch(scalarValue){
                        case $d84dc1a5e217b32f$var$tokenNull:
                            $d84dc1a5e217b32f$var$clearField(field, target);
                            break;
                        default:
                            target[localName] = scalarValue;
                            break;
                    }
                } catch (e) {
                    let m = "cannot decode field ".concat(parentType.typeName, ".").concat(field.name, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(jsonValue));
                    if (e instanceof Error && e.message.length > 0) m += ": ".concat(e.message);
                    throw new Error(m);
                }
                break;
        }
    }
}
function $d84dc1a5e217b32f$var$readMapKey(type, json) {
    if (type === $d84dc1a5e217b32f$var$ScalarType.BOOL) // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(json){
        case "true":
            json = true;
            break;
        case "false":
            json = false;
            break;
    }
    return $d84dc1a5e217b32f$var$readScalar$1(type, json, $d84dc1a5e217b32f$var$LongType.BIGINT, true).toString();
}
function $d84dc1a5e217b32f$var$readScalar$1(type, json, longType, nullAsZeroValue) {
    if (json === null) {
        if (nullAsZeroValue) return $d84dc1a5e217b32f$var$scalarZeroValue(type, longType);
        return $d84dc1a5e217b32f$var$tokenNull;
    }
    // every valid case in the switch below returns, and every fall
    // through is regarded as a failure.
    switch(type){
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $d84dc1a5e217b32f$var$ScalarType.DOUBLE:
        case $d84dc1a5e217b32f$var$ScalarType.FLOAT:
            if (json === "NaN") return Number.NaN;
            if (json === "Infinity") return Number.POSITIVE_INFINITY;
            if (json === "-Infinity") return Number.NEGATIVE_INFINITY;
            if (json === "") break;
            if (typeof json == "string" && json.trim().length !== json.length) break;
            if (typeof json != "string" && typeof json != "number") break;
            const float = Number(json);
            if (Number.isNaN(float)) break;
            if (!Number.isFinite(float)) break;
            if (type == $d84dc1a5e217b32f$var$ScalarType.FLOAT) $d84dc1a5e217b32f$var$assertFloat32(float);
            return float;
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.INT32:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.SINT32:
        case $d84dc1a5e217b32f$var$ScalarType.UINT32:
            let int32;
            if (typeof json == "number") int32 = json;
            else if (typeof json == "string" && json.length > 0) {
                if (json.trim().length === json.length) int32 = Number(json);
            }
            if (int32 === undefined) break;
            if (type == $d84dc1a5e217b32f$var$ScalarType.UINT32 || type == $d84dc1a5e217b32f$var$ScalarType.FIXED32) $d84dc1a5e217b32f$var$assertUInt32(int32);
            else $d84dc1a5e217b32f$var$assertInt32(int32);
            return int32;
        // int64, fixed64, uint64: JSON value will be a decimal string. Either numbers or strings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.INT64:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.SINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const long = $d84dc1a5e217b32f$var$protoInt64.parse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? long.toString() : long;
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.UINT64:
            if (typeof json != "number" && typeof json != "string") break;
            const uLong = $d84dc1a5e217b32f$var$protoInt64.uParse(json);
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            return longType ? uLong.toString() : uLong;
        // bool:
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            if (typeof json !== "boolean") break;
            return json;
        // string:
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            if (typeof json !== "string") break;
            // A string must always contain UTF-8 encoded or 7-bit ASCII.
            // We validate with encodeURIComponent, which appears to be the fastest widely available option.
            try {
                encodeURIComponent(json);
            } catch (e) {
                throw new Error("invalid UTF8");
            }
            return json;
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
            if (json === "") return new Uint8Array(0);
            if (typeof json !== "string") break;
            return $d84dc1a5e217b32f$var$protoBase64.dec(json);
    }
    throw new Error();
}
function $d84dc1a5e217b32f$var$readEnum(type, json, ignoreUnknownFields, nullAsZeroValue) {
    if (json === null) {
        if (type.typeName == "google.protobuf.NullValue") return 0; // google.protobuf.NullValue.NULL_VALUE = 0
        return nullAsZeroValue ? type.values[0].no : $d84dc1a5e217b32f$var$tokenNull;
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(typeof json){
        case "number":
            if (Number.isInteger(json)) return json;
            break;
        case "string":
            const value = type.findName(json);
            if (value !== undefined) return value.no;
            if (ignoreUnknownFields) return $d84dc1a5e217b32f$var$tokenIgnoredUnknownEnum;
            break;
    }
    throw new Error("cannot decode enum ".concat(type.typeName, " from JSON: ").concat($d84dc1a5e217b32f$var$debugJsonValue(json)));
}
// Decide whether an unset field should be emitted with JSON write option `emitDefaultValues`
function $d84dc1a5e217b32f$var$canEmitFieldDefaultValue(field) {
    if (field.repeated || field.kind == "map") // maps are {}, repeated fields are []
    return true;
    if (field.oneof) // oneof fields are never emitted
    return false;
    if (field.kind == "message") // singular message field are allowed to emit JSON null, but we do not
    return false;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.opt || field.req) // the field uses explicit presence, so we cannot emit a zero value
    return false;
    return true;
}
function $d84dc1a5e217b32f$var$writeField$1(field, value, options) {
    if (field.kind == "map") {
        $d84dc1a5e217b32f$var$assert(typeof value == "object" && value != null);
        const jsonObj = {};
        const entries = Object.entries(value);
        switch(field.V.kind){
            case "scalar":
                for (const [entryKey, entryValue] of entries)jsonObj[entryKey.toString()] = $d84dc1a5e217b32f$var$writeScalar$1(field.V.T, entryValue); // JSON standard allows only (double quoted) string as property key
                break;
            case "message":
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = entryValue.toJson(options);
                break;
            case "enum":
                const enumType = field.V.T;
                for (const [entryKey, entryValue] of entries)// JSON standard allows only (double quoted) string as property key
                jsonObj[entryKey.toString()] = $d84dc1a5e217b32f$var$writeEnum(enumType, entryValue, options.enumAsInteger);
                break;
        }
        return options.emitDefaultValues || entries.length > 0 ? jsonObj : undefined;
    }
    if (field.repeated) {
        $d84dc1a5e217b32f$var$assert(Array.isArray(value));
        const jsonArr = [];
        switch(field.kind){
            case "scalar":
                for(let i = 0; i < value.length; i++)jsonArr.push($d84dc1a5e217b32f$var$writeScalar$1(field.T, value[i]));
                break;
            case "enum":
                for(let i = 0; i < value.length; i++)jsonArr.push($d84dc1a5e217b32f$var$writeEnum(field.T, value[i], options.enumAsInteger));
                break;
            case "message":
                for(let i = 0; i < value.length; i++)jsonArr.push(value[i].toJson(options));
                break;
        }
        return options.emitDefaultValues || jsonArr.length > 0 ? jsonArr : undefined;
    }
    switch(field.kind){
        case "scalar":
            return $d84dc1a5e217b32f$var$writeScalar$1(field.T, value);
        case "enum":
            return $d84dc1a5e217b32f$var$writeEnum(field.T, value, options.enumAsInteger);
        case "message":
            return $d84dc1a5e217b32f$var$wrapField(field.T, value).toJson(options);
    }
}
function $d84dc1a5e217b32f$var$writeEnum(type, value, enumAsInteger) {
    var _a;
    $d84dc1a5e217b32f$var$assert(typeof value == "number");
    if (type.typeName == "google.protobuf.NullValue") return null;
    if (enumAsInteger) return value;
    const val = type.findNumber(value);
    return (_a = val === null || val === void 0 ? void 0 : val.name) !== null && _a !== void 0 ? _a : value; // if we don't know the enum value, just return the number
}
function $d84dc1a5e217b32f$var$writeScalar$1(type, value) {
    switch(type){
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.INT32:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.SINT32:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.UINT32:
            $d84dc1a5e217b32f$var$assert(typeof value == "number");
            return value;
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case $d84dc1a5e217b32f$var$ScalarType.FLOAT:
        // assertFloat32(value);
        case $d84dc1a5e217b32f$var$ScalarType.DOUBLE:
            // eslint-disable-line no-fallthrough
            $d84dc1a5e217b32f$var$assert(typeof value == "number");
            if (Number.isNaN(value)) return "NaN";
            if (value === Number.POSITIVE_INFINITY) return "Infinity";
            if (value === Number.NEGATIVE_INFINITY) return "-Infinity";
            return value;
        // string:
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            $d84dc1a5e217b32f$var$assert(typeof value == "string");
            return value;
        // bool:
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            $d84dc1a5e217b32f$var$assert(typeof value == "boolean");
            return value;
        // JSON value will be a decimal string. Either numbers or strings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.UINT64:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.INT64:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.SINT64:
            $d84dc1a5e217b32f$var$assert(typeof value == "bigint" || typeof value == "string" || typeof value == "number");
            return value.toString();
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
            $d84dc1a5e217b32f$var$assert(value instanceof Uint8Array);
            return $d84dc1a5e217b32f$var$protoBase64.enc(value);
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable prefer-const,no-case-declarations,@typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-return */ const $d84dc1a5e217b32f$var$unknownFieldsSymbol = Symbol("@bufbuild/protobuf/unknown-fields");
// Default options for parsing binary data.
const $d84dc1a5e217b32f$var$readDefaults = {
    readUnknownFields: true,
    readerFactory: (bytes)=>new $d84dc1a5e217b32f$var$BinaryReader(bytes)
};
// Default options for serializing binary data.
const $d84dc1a5e217b32f$var$writeDefaults = {
    writeUnknownFields: true,
    writerFactory: ()=>new $d84dc1a5e217b32f$var$BinaryWriter()
};
function $d84dc1a5e217b32f$var$makeReadOptions(options) {
    return options ? Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$readDefaults), options) : $d84dc1a5e217b32f$var$readDefaults;
}
function $d84dc1a5e217b32f$var$makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$writeDefaults), options) : $d84dc1a5e217b32f$var$writeDefaults;
}
function $d84dc1a5e217b32f$var$makeBinaryFormat() {
    return {
        makeReadOptions: $d84dc1a5e217b32f$var$makeReadOptions,
        makeWriteOptions: $d84dc1a5e217b32f$var$makeWriteOptions,
        listUnknownFields (message) {
            var _a;
            return (_a = message[$d84dc1a5e217b32f$var$unknownFieldsSymbol]) !== null && _a !== void 0 ? _a : [];
        },
        discardUnknownFields (message) {
            delete message[$d84dc1a5e217b32f$var$unknownFieldsSymbol];
        },
        writeUnknownFields (message, writer) {
            const m = message;
            const c = m[$d84dc1a5e217b32f$var$unknownFieldsSymbol];
            if (c) for (const f of c)writer.tag(f.no, f.wireType).raw(f.data);
        },
        onUnknownField (message, no, wireType, data) {
            const m = message;
            if (!Array.isArray(m[$d84dc1a5e217b32f$var$unknownFieldsSymbol])) m[$d84dc1a5e217b32f$var$unknownFieldsSymbol] = [];
            m[$d84dc1a5e217b32f$var$unknownFieldsSymbol].push({
                no: no,
                wireType: wireType,
                data: data
            });
        },
        readMessage (message, reader, lengthOrEndTagFieldNo, options, delimitedMessageEncoding) {
            const type = message.getType();
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            const end = delimitedMessageEncoding ? reader.len : reader.pos + lengthOrEndTagFieldNo;
            let fieldNo, wireType;
            while(reader.pos < end){
                [fieldNo, wireType] = reader.tag();
                if (delimitedMessageEncoding === true && wireType == $d84dc1a5e217b32f$var$WireType.EndGroup) break;
                const field = type.fields.find(fieldNo);
                if (!field) {
                    const data = reader.skip(wireType, fieldNo);
                    if (options.readUnknownFields) this.onUnknownField(message, fieldNo, wireType, data);
                    continue;
                }
                $d84dc1a5e217b32f$var$readField(message, reader, field, wireType, options);
            }
            if (delimitedMessageEncoding && // eslint-disable-line @typescript-eslint/strict-boolean-expressions
            (wireType != $d84dc1a5e217b32f$var$WireType.EndGroup || fieldNo !== lengthOrEndTagFieldNo)) throw new Error("invalid end group tag");
        },
        readField: $d84dc1a5e217b32f$var$readField,
        writeMessage (message, writer, options) {
            const type = message.getType();
            for (const field of type.fields.byNumber()){
                if (!$d84dc1a5e217b32f$var$isFieldSet(field, message)) {
                    if (field.req) throw new Error("cannot encode field ".concat(type.typeName, ".").concat(field.name, " to binary: required field not set"));
                    continue;
                }
                const value = field.oneof ? message[field.oneof.localName].value : message[field.localName];
                $d84dc1a5e217b32f$var$writeField(field, value, writer, options);
            }
            if (options.writeUnknownFields) this.writeUnknownFields(message, writer);
            return writer;
        },
        writeField (field, value, writer, options) {
            // The behavior of our internal function has changed, it does no longer
            // accept `undefined` values for singular scalar and map.
            // For backwards-compatibility, we support the old form that is part of
            // the public API through the interface BinaryFormat.
            if (value === undefined) return undefined;
            $d84dc1a5e217b32f$var$writeField(field, value, writer, options);
        }
    };
}
function $d84dc1a5e217b32f$var$readField(target, // eslint-disable-line @typescript-eslint/no-explicit-any -- `any` is the best choice for dynamic access
reader, field, wireType, options) {
    let { repeated: repeated, localName: localName } = field;
    if (field.oneof) {
        target = target[field.oneof.localName];
        if (target.case != localName) delete target.value;
        target.case = localName;
        localName = "value";
    }
    switch(field.kind){
        case "scalar":
        case "enum":
            const scalarType = field.kind == "enum" ? $d84dc1a5e217b32f$var$ScalarType.INT32 : field.T;
            let read = $d84dc1a5e217b32f$var$readScalar;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison -- acceptable since it's covered by tests
            if (field.kind == "scalar" && field.L > 0) read = $d84dc1a5e217b32f$var$readScalarLTString;
            if (repeated) {
                let arr = target[localName]; // safe to assume presence of array, oneof cannot contain repeated values
                const isPacked = wireType == $d84dc1a5e217b32f$var$WireType.LengthDelimited && scalarType != $d84dc1a5e217b32f$var$ScalarType.STRING && scalarType != $d84dc1a5e217b32f$var$ScalarType.BYTES;
                if (isPacked) {
                    let e = reader.uint32() + reader.pos;
                    while(reader.pos < e)arr.push(read(reader, scalarType));
                } else arr.push(read(reader, scalarType));
            } else target[localName] = read(reader, scalarType);
            break;
        case "message":
            const messageType = field.T;
            if (repeated) // safe to assume presence of array, oneof cannot contain repeated values
            target[localName].push($d84dc1a5e217b32f$var$readMessageField(reader, new messageType(), options, field));
            else if ($d84dc1a5e217b32f$var$isMessage(target[localName])) $d84dc1a5e217b32f$var$readMessageField(reader, target[localName], options, field);
            else {
                target[localName] = $d84dc1a5e217b32f$var$readMessageField(reader, new messageType(), options, field);
                if (messageType.fieldWrapper && !field.oneof && !field.repeated) target[localName] = messageType.fieldWrapper.unwrapField(target[localName]);
            }
            break;
        case "map":
            let [mapKey, mapVal] = $d84dc1a5e217b32f$var$readMapEntry(field, reader, options);
            // safe to assume presence of map object, oneof cannot contain repeated values
            target[localName][mapKey] = mapVal;
            break;
    }
}
// Read a message, avoiding MessageType.fromBinary() to re-use the
// BinaryReadOptions and the IBinaryReader.
function $d84dc1a5e217b32f$var$readMessageField(reader, message, options, field) {
    const format = message.getType().runtime.bin;
    const delimited = field === null || field === void 0 ? void 0 : field.delimited;
    format.readMessage(message, reader, delimited ? field.no : reader.uint32(), // eslint-disable-line @typescript-eslint/strict-boolean-expressions
    options, delimited);
    return message;
}
// Read a map field, expecting key field = 1, value field = 2
function $d84dc1a5e217b32f$var$readMapEntry(field, reader, options) {
    const length = reader.uint32(), end = reader.pos + length;
    let key, val;
    while(reader.pos < end){
        const [fieldNo] = reader.tag();
        switch(fieldNo){
            case 1:
                key = $d84dc1a5e217b32f$var$readScalar(reader, field.K);
                break;
            case 2:
                switch(field.V.kind){
                    case "scalar":
                        val = $d84dc1a5e217b32f$var$readScalar(reader, field.V.T);
                        break;
                    case "enum":
                        val = reader.int32();
                        break;
                    case "message":
                        val = $d84dc1a5e217b32f$var$readMessageField(reader, new field.V.T(), options, undefined);
                        break;
                }
                break;
        }
    }
    if (key === undefined) key = $d84dc1a5e217b32f$var$scalarZeroValue(field.K, $d84dc1a5e217b32f$var$LongType.BIGINT);
    if (typeof key != "string" && typeof key != "number") key = key.toString();
    if (val === undefined) switch(field.V.kind){
        case "scalar":
            val = $d84dc1a5e217b32f$var$scalarZeroValue(field.V.T, $d84dc1a5e217b32f$var$LongType.BIGINT);
            break;
        case "enum":
            val = field.V.T.values[0].no;
            break;
        case "message":
            val = new field.V.T();
            break;
    }
    return [
        key,
        val
    ];
}
// Read a scalar value, but return 64 bit integral types (int64, uint64,
// sint64, fixed64, sfixed64) as string instead of bigint.
function $d84dc1a5e217b32f$var$readScalarLTString(reader, type) {
    const v = $d84dc1a5e217b32f$var$readScalar(reader, type);
    return typeof v == "bigint" ? v.toString() : v;
}
// Does not use scalarTypeInfo() for better performance.
function $d84dc1a5e217b32f$var$readScalar(reader, type) {
    switch(type){
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            return reader.string();
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            return reader.bool();
        case $d84dc1a5e217b32f$var$ScalarType.DOUBLE:
            return reader.double();
        case $d84dc1a5e217b32f$var$ScalarType.FLOAT:
            return reader.float();
        case $d84dc1a5e217b32f$var$ScalarType.INT32:
            return reader.int32();
        case $d84dc1a5e217b32f$var$ScalarType.INT64:
            return reader.int64();
        case $d84dc1a5e217b32f$var$ScalarType.UINT64:
            return reader.uint64();
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
            return reader.fixed64();
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
            return reader.bytes();
        case $d84dc1a5e217b32f$var$ScalarType.FIXED32:
            return reader.fixed32();
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED32:
            return reader.sfixed32();
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
            return reader.sfixed64();
        case $d84dc1a5e217b32f$var$ScalarType.SINT64:
            return reader.sint64();
        case $d84dc1a5e217b32f$var$ScalarType.UINT32:
            return reader.uint32();
        case $d84dc1a5e217b32f$var$ScalarType.SINT32:
            return reader.sint32();
    }
}
function $d84dc1a5e217b32f$var$writeField(field, value, writer, options) {
    $d84dc1a5e217b32f$var$assert(value !== undefined);
    const repeated = field.repeated;
    switch(field.kind){
        case "scalar":
        case "enum":
            let scalarType = field.kind == "enum" ? $d84dc1a5e217b32f$var$ScalarType.INT32 : field.T;
            if (repeated) {
                $d84dc1a5e217b32f$var$assert(Array.isArray(value));
                if (field.packed) $d84dc1a5e217b32f$var$writePacked(writer, scalarType, field.no, value);
                else for (const item of value)$d84dc1a5e217b32f$var$writeScalar(writer, scalarType, field.no, item);
            } else $d84dc1a5e217b32f$var$writeScalar(writer, scalarType, field.no, value);
            break;
        case "message":
            if (repeated) {
                $d84dc1a5e217b32f$var$assert(Array.isArray(value));
                for (const item of value)$d84dc1a5e217b32f$var$writeMessageField(writer, options, field, item);
            } else $d84dc1a5e217b32f$var$writeMessageField(writer, options, field, value);
            break;
        case "map":
            $d84dc1a5e217b32f$var$assert(typeof value == "object" && value != null);
            for (const [key, val] of Object.entries(value))$d84dc1a5e217b32f$var$writeMapEntry(writer, options, field, key, val);
            break;
    }
}
function $d84dc1a5e217b32f$var$writeMapEntry(writer, options, field, key, value) {
    writer.tag(field.no, $d84dc1a5e217b32f$var$WireType.LengthDelimited);
    writer.fork();
    // javascript only allows number or string for object properties
    // we convert from our representation to the protobuf type
    let keyValue = key;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- we deliberately handle just the special cases for map keys
    switch(field.K){
        case $d84dc1a5e217b32f$var$ScalarType.INT32:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.UINT32:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.SINT32:
            keyValue = Number.parseInt(key);
            break;
        case $d84dc1a5e217b32f$var$ScalarType.BOOL:
            $d84dc1a5e217b32f$var$assert(key == "true" || key == "false");
            keyValue = key == "true";
            break;
    }
    // write key, expecting key field number = 1
    $d84dc1a5e217b32f$var$writeScalar(writer, field.K, 1, keyValue);
    // write value, expecting value field number = 2
    switch(field.V.kind){
        case "scalar":
            $d84dc1a5e217b32f$var$writeScalar(writer, field.V.T, 2, value);
            break;
        case "enum":
            $d84dc1a5e217b32f$var$writeScalar(writer, $d84dc1a5e217b32f$var$ScalarType.INT32, 2, value);
            break;
        case "message":
            $d84dc1a5e217b32f$var$assert(value !== undefined);
            writer.tag(2, $d84dc1a5e217b32f$var$WireType.LengthDelimited).bytes(value.toBinary(options));
            break;
    }
    writer.join();
}
// Value must not be undefined
function $d84dc1a5e217b32f$var$writeMessageField(writer, options, field, value) {
    const message = $d84dc1a5e217b32f$var$wrapField(field.T, value);
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (field.delimited) writer.tag(field.no, $d84dc1a5e217b32f$var$WireType.StartGroup).raw(message.toBinary(options)).tag(field.no, $d84dc1a5e217b32f$var$WireType.EndGroup);
    else writer.tag(field.no, $d84dc1a5e217b32f$var$WireType.LengthDelimited).bytes(message.toBinary(options));
}
function $d84dc1a5e217b32f$var$writeScalar(writer, type, fieldNo, value) {
    $d84dc1a5e217b32f$var$assert(value !== undefined);
    let [wireType, method] = $d84dc1a5e217b32f$var$scalarTypeInfo(type);
    writer.tag(fieldNo, wireType)[method](value);
}
function $d84dc1a5e217b32f$var$writePacked(writer, type, fieldNo, value) {
    if (!value.length) return;
    writer.tag(fieldNo, $d84dc1a5e217b32f$var$WireType.LengthDelimited).fork();
    let [, method] = $d84dc1a5e217b32f$var$scalarTypeInfo(type);
    for(let i = 0; i < value.length; i++)writer[method](value[i]);
    writer.join();
}
/**
 * Get information for writing a scalar value.
 *
 * Returns tuple:
 * [0]: appropriate WireType
 * [1]: name of the appropriate method of IBinaryWriter
 * [2]: whether the given value is a default value for proto3 semantics
 *
 * If argument `value` is omitted, [2] is always false.
 */ // TODO replace call-sites writeScalar() and writePacked(), then remove
function $d84dc1a5e217b32f$var$scalarTypeInfo(type) {
    let wireType = $d84dc1a5e217b32f$var$WireType.Varint;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- INT32, UINT32, SINT32 are covered by the defaults
    switch(type){
        case $d84dc1a5e217b32f$var$ScalarType.BYTES:
        case $d84dc1a5e217b32f$var$ScalarType.STRING:
            wireType = $d84dc1a5e217b32f$var$WireType.LengthDelimited;
            break;
        case $d84dc1a5e217b32f$var$ScalarType.DOUBLE:
        case $d84dc1a5e217b32f$var$ScalarType.FIXED64:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED64:
            wireType = $d84dc1a5e217b32f$var$WireType.Bit64;
            break;
        case $d84dc1a5e217b32f$var$ScalarType.FIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.SFIXED32:
        case $d84dc1a5e217b32f$var$ScalarType.FLOAT:
            wireType = $d84dc1a5e217b32f$var$WireType.Bit32;
            break;
    }
    const method = $d84dc1a5e217b32f$var$ScalarType[type].toLowerCase();
    return [
        wireType,
        method
    ];
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-argument,no-case-declarations */ function $d84dc1a5e217b32f$var$makeUtilCommon() {
    return {
        setEnumType: $d84dc1a5e217b32f$var$setEnumType,
        initPartial (source, target) {
            if (source === undefined) return;
            const type = target.getType();
            for (const member of type.fields.byMember()){
                const localName = member.localName, t = target, s = source;
                if (s[localName] == null) continue;
                switch(member.kind){
                    case "oneof":
                        const sk = s[localName].case;
                        if (sk === undefined) continue;
                        const sourceField = member.findField(sk);
                        let val = s[localName].value;
                        if (sourceField && sourceField.kind == "message" && !$d84dc1a5e217b32f$var$isMessage(val, sourceField.T)) val = new sourceField.T(val);
                        else if (sourceField && sourceField.kind === "scalar" && sourceField.T === $d84dc1a5e217b32f$var$ScalarType.BYTES) val = $d84dc1a5e217b32f$var$toU8Arr(val);
                        t[localName] = {
                            case: sk,
                            value: val
                        };
                        break;
                    case "scalar":
                    case "enum":
                        let copy = s[localName];
                        if (member.T === $d84dc1a5e217b32f$var$ScalarType.BYTES) copy = member.repeated ? copy.map($d84dc1a5e217b32f$var$toU8Arr) : $d84dc1a5e217b32f$var$toU8Arr(copy);
                        t[localName] = copy;
                        break;
                    case "map":
                        switch(member.V.kind){
                            case "scalar":
                            case "enum":
                                if (member.V.T === $d84dc1a5e217b32f$var$ScalarType.BYTES) for (const [k, v] of Object.entries(s[localName]))t[localName][k] = $d84dc1a5e217b32f$var$toU8Arr(v);
                                else Object.assign(t[localName], s[localName]);
                                break;
                            case "message":
                                const messageType = member.V.T;
                                for (const k of Object.keys(s[localName])){
                                    let val = s[localName][k];
                                    if (!messageType.fieldWrapper) // We only take partial input for messages that are not a wrapper type.
                                    // For those messages, we recursively normalize the partial input.
                                    val = new messageType(val);
                                    t[localName][k] = val;
                                }
                                break;
                        }
                        break;
                    case "message":
                        const mt = member.T;
                        if (member.repeated) t[localName] = s[localName].map((val)=>$d84dc1a5e217b32f$var$isMessage(val, mt) ? val : new mt(val));
                        else {
                            const val = s[localName];
                            if (mt.fieldWrapper) {
                                if (// We can't use BytesValue.typeName as that will create a circular import
                                mt.typeName === "google.protobuf.BytesValue") t[localName] = $d84dc1a5e217b32f$var$toU8Arr(val);
                                else t[localName] = val;
                            } else t[localName] = $d84dc1a5e217b32f$var$isMessage(val, mt) ? val : new mt(val);
                        }
                        break;
                }
            }
        },
        // TODO use isFieldSet() here to support future field presence
        equals (type, a, b) {
            if (a === b) return true;
            if (!a || !b) return false;
            return type.fields.byMember().every((m)=>{
                const va = a[m.localName];
                const vb = b[m.localName];
                if (m.repeated) {
                    if (va.length !== vb.length) return false;
                    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- repeated fields are never "map"
                    switch(m.kind){
                        case "message":
                            return va.every((a, i)=>m.T.equals(a, vb[i]));
                        case "scalar":
                            return va.every((a, i)=>$d84dc1a5e217b32f$var$scalarEquals(m.T, a, vb[i]));
                        case "enum":
                            return va.every((a, i)=>$d84dc1a5e217b32f$var$scalarEquals($d84dc1a5e217b32f$var$ScalarType.INT32, a, vb[i]));
                    }
                    throw new Error("repeated cannot contain ".concat(m.kind));
                }
                switch(m.kind){
                    case "message":
                        return m.T.equals(va, vb);
                    case "enum":
                        return $d84dc1a5e217b32f$var$scalarEquals($d84dc1a5e217b32f$var$ScalarType.INT32, va, vb);
                    case "scalar":
                        return $d84dc1a5e217b32f$var$scalarEquals(m.T, va, vb);
                    case "oneof":
                        if (va.case !== vb.case) return false;
                        const s = m.findField(va.case);
                        if (s === undefined) return true;
                        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check -- oneof fields are never "map"
                        switch(s.kind){
                            case "message":
                                return s.T.equals(va.value, vb.value);
                            case "enum":
                                return $d84dc1a5e217b32f$var$scalarEquals($d84dc1a5e217b32f$var$ScalarType.INT32, va.value, vb.value);
                            case "scalar":
                                return $d84dc1a5e217b32f$var$scalarEquals(s.T, va.value, vb.value);
                        }
                        throw new Error("oneof cannot contain ".concat(s.kind));
                    case "map":
                        const keys = Object.keys(va).concat(Object.keys(vb));
                        switch(m.V.kind){
                            case "message":
                                const messageType = m.V.T;
                                return keys.every((k)=>messageType.equals(va[k], vb[k]));
                            case "enum":
                                return keys.every((k)=>$d84dc1a5e217b32f$var$scalarEquals($d84dc1a5e217b32f$var$ScalarType.INT32, va[k], vb[k]));
                            case "scalar":
                                const scalarType = m.V.T;
                                return keys.every((k)=>$d84dc1a5e217b32f$var$scalarEquals(scalarType, va[k], vb[k]));
                        }
                        break;
                }
            });
        },
        // TODO use isFieldSet() here to support future field presence
        clone (message) {
            const type = message.getType(), target = new type(), any = target;
            for (const member of type.fields.byMember()){
                const source = message[member.localName];
                let copy;
                if (member.repeated) copy = source.map($d84dc1a5e217b32f$var$cloneSingularField);
                else if (member.kind == "map") {
                    copy = any[member.localName];
                    for (const [key, v] of Object.entries(source))copy[key] = $d84dc1a5e217b32f$var$cloneSingularField(v);
                } else if (member.kind == "oneof") {
                    const f = member.findField(source.case);
                    copy = f ? {
                        case: source.case,
                        value: $d84dc1a5e217b32f$var$cloneSingularField(source.value)
                    } : {
                        case: undefined
                    };
                } else copy = $d84dc1a5e217b32f$var$cloneSingularField(source);
                any[member.localName] = copy;
            }
            for (const uf of type.runtime.bin.listUnknownFields(message))type.runtime.bin.onUnknownField(any, uf.no, uf.wireType, uf.data);
            return target;
        }
    };
}
// clone a single field value - i.e. the element type of repeated fields, the value type of maps
function $d84dc1a5e217b32f$var$cloneSingularField(value) {
    if (value === undefined) return value;
    if ($d84dc1a5e217b32f$var$isMessage(value)) return value.clone();
    if (value instanceof Uint8Array) {
        const c = new Uint8Array(value.byteLength);
        c.set(value);
        return c;
    }
    return value;
}
// converts any ArrayLike<number> to Uint8Array if necessary.
function $d84dc1a5e217b32f$var$toU8Arr(input) {
    return input instanceof Uint8Array ? input : new Uint8Array(input);
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $d84dc1a5e217b32f$var$makeProtoRuntime(syntax, newFieldList, initFields) {
    return {
        syntax: syntax,
        json: $d84dc1a5e217b32f$var$makeJsonFormat(),
        bin: $d84dc1a5e217b32f$var$makeBinaryFormat(),
        util: Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$makeUtilCommon()), {
            newFieldList: newFieldList,
            initFields: initFields
        }),
        makeMessageType (typeName, fields, opt) {
            return $d84dc1a5e217b32f$var$makeMessageType(this, typeName, fields, opt);
        },
        makeEnum: $d84dc1a5e217b32f$var$makeEnum,
        makeEnumType: $d84dc1a5e217b32f$var$makeEnumType,
        getEnumType: $d84dc1a5e217b32f$var$getEnumType,
        makeExtension (typeName, extendee, field) {
            return $d84dc1a5e217b32f$var$makeExtension(this, typeName, extendee, field);
        }
    };
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $d84dc1a5e217b32f$var$InternalFieldList {
    constructor(fields, normalizer){
        this._fields = fields;
        this._normalizer = normalizer;
    }
    findJsonName(jsonName) {
        if (!this.jsonNames) {
            const t = {};
            for (const f of this.list())t[f.jsonName] = t[f.name] = f;
            this.jsonNames = t;
        }
        return this.jsonNames[jsonName];
    }
    find(fieldNo) {
        if (!this.numbers) {
            const t = {};
            for (const f of this.list())t[f.no] = f;
            this.numbers = t;
        }
        return this.numbers[fieldNo];
    }
    list() {
        if (!this.all) this.all = this._normalizer(this._fields);
        return this.all;
    }
    byNumber() {
        if (!this.numbersAsc) this.numbersAsc = this.list().concat().sort((a, b)=>a.no - b.no);
        return this.numbersAsc;
    }
    byMember() {
        if (!this.members) {
            this.members = [];
            const a = this.members;
            let o;
            for (const f of this.list()){
                if (f.oneof) {
                    if (f.oneof !== o) {
                        o = f.oneof;
                        a.push(o);
                    }
                } else a.push(f);
            }
        }
        return this.members;
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Returns the name of a protobuf element in generated code.
 *
 * Field names - including oneofs - are converted to lowerCamelCase. For
 * messages, enumerations and services, the package name is stripped from
 * the type name. For nested messages and enumerations, the names are joined
 * with an underscore. For methods, the first character is made lowercase.
 */ /**
 * Returns the name of a field in generated code.
 */ function $d84dc1a5e217b32f$var$localFieldName(protoName, inOneof) {
    const name = $d84dc1a5e217b32f$var$protoCamelCase(protoName);
    if (inOneof) // oneof member names are not properties, but values of the `case` property.
    return name;
    return $d84dc1a5e217b32f$var$safeObjectProperty($d84dc1a5e217b32f$var$safeMessageProperty(name));
}
/**
 * Returns the name of a oneof group in generated code.
 */ function $d84dc1a5e217b32f$var$localOneofName(protoName) {
    return $d84dc1a5e217b32f$var$localFieldName(protoName, false);
}
/**
 * Returns the JSON name for a protobuf field, exactly like protoc does.
 */ const $d84dc1a5e217b32f$var$fieldJsonName = $d84dc1a5e217b32f$var$protoCamelCase;
/**
 * Converts snake_case to protoCamelCase according to the convention
 * used by protoc to convert a field name to a JSON name.
 */ function $d84dc1a5e217b32f$var$protoCamelCase(snakeCase) {
    let capNext = false;
    const b = [];
    for(let i = 0; i < snakeCase.length; i++){
        let c = snakeCase.charAt(i);
        switch(c){
            case "_":
                capNext = true;
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                b.push(c);
                capNext = false;
                break;
            default:
                if (capNext) {
                    capNext = false;
                    c = c.toUpperCase();
                }
                b.push(c);
                break;
        }
    }
    return b.join("");
}
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $d84dc1a5e217b32f$var$reservedObjectProperties = new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
]);
/**
 * Names that cannot be used for object properties because they are reserved
 * by the runtime.
 */ const $d84dc1a5e217b32f$var$reservedMessageProperties = new Set([
    // names reserved by the runtime
    "getType",
    "clone",
    "equals",
    "fromBinary",
    "fromJson",
    "fromJsonString",
    "toBinary",
    "toJson",
    "toJsonString",
    // names reserved by the runtime for the future
    "toObject"
]);
const $d84dc1a5e217b32f$var$fallback = (name)=>"".concat(name, "$");
/**
 * Will wrap names that are Object prototype properties or names reserved
 * for `Message`s.
 */ const $d84dc1a5e217b32f$var$safeMessageProperty = (name)=>{
    if ($d84dc1a5e217b32f$var$reservedMessageProperties.has(name)) return $d84dc1a5e217b32f$var$fallback(name);
    return name;
};
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $d84dc1a5e217b32f$var$safeObjectProperty = (name)=>{
    if ($d84dc1a5e217b32f$var$reservedObjectProperties.has(name)) return $d84dc1a5e217b32f$var$fallback(name);
    return name;
};
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class $d84dc1a5e217b32f$var$InternalOneofInfo {
    constructor(name){
        this.kind = "oneof";
        this.repeated = false;
        this.packed = false;
        this.opt = false;
        this.req = false;
        this.default = undefined;
        this.fields = [];
        this.name = name;
        this.localName = $d84dc1a5e217b32f$var$localOneofName(name);
    }
    addField(field) {
        $d84dc1a5e217b32f$var$assert(field.oneof === this, "field ".concat(field.name, " not one of ").concat(this.name));
        this.fields.push(field);
    }
    findField(localName) {
        if (!this._lookup) {
            this._lookup = Object.create(null);
            for(let i = 0; i < this.fields.length; i++)this._lookup[this.fields[i].localName] = this.fields[i];
        }
        return this._lookup[localName];
    }
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Convert a collection of field info to an array of normalized FieldInfo.
 *
 * The argument `packedByDefault` specifies whether fields that do not specify
 * `packed` should be packed (proto3) or unpacked (proto2).
 */ function $d84dc1a5e217b32f$var$normalizeFieldInfos(fieldInfos, packedByDefault) {
    var _a, _b, _c, _d, _e, _f;
    const r = [];
    let o;
    for (const field of typeof fieldInfos == "function" ? fieldInfos() : fieldInfos){
        const f = field;
        f.localName = $d84dc1a5e217b32f$var$localFieldName(field.name, field.oneof !== undefined);
        f.jsonName = (_a = field.jsonName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$var$fieldJsonName(field.name);
        f.repeated = (_b = field.repeated) !== null && _b !== void 0 ? _b : false;
        if (field.kind == "scalar") f.L = (_c = field.L) !== null && _c !== void 0 ? _c : $d84dc1a5e217b32f$var$LongType.BIGINT;
        f.delimited = (_d = field.delimited) !== null && _d !== void 0 ? _d : false;
        f.req = (_e = field.req) !== null && _e !== void 0 ? _e : false;
        f.opt = (_f = field.opt) !== null && _f !== void 0 ? _f : false;
        if (field.packed === undefined) f.packed = field.kind == "enum" || field.kind == "scalar" && field.T != $d84dc1a5e217b32f$var$ScalarType.BYTES && field.T != $d84dc1a5e217b32f$var$ScalarType.STRING;
        // We do not surface options at this time
        // f.options = field.options ?? emptyReadonlyObject;
        if (field.oneof !== undefined) {
            const ooname = typeof field.oneof == "string" ? field.oneof : field.oneof.name;
            if (!o || o.name != ooname) o = new $d84dc1a5e217b32f$var$InternalOneofInfo(ooname);
            f.oneof = o;
            o.addField(f);
        }
        r.push(f);
    }
    return r;
}
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Provides functionality for messages defined with the proto3 syntax.
 */ const $d84dc1a5e217b32f$var$proto3 = $d84dc1a5e217b32f$var$makeProtoRuntime("proto3", (fields)=>{
    return new $d84dc1a5e217b32f$var$InternalFieldList(fields, (source)=>$d84dc1a5e217b32f$var$normalizeFieldInfos(source));
}, // TODO merge with proto2 and initExtensionField, also see initPartial, equals, clone
(target)=>{
    for (const member of target.getType().fields.byMember()){
        if (member.opt) continue;
        const name = member.localName, t = target;
        if (member.repeated) {
            t[name] = [];
            continue;
        }
        switch(member.kind){
            case "oneof":
                t[name] = {
                    case: undefined
                };
                break;
            case "enum":
                t[name] = 0;
                break;
            case "map":
                t[name] = {};
                break;
            case "scalar":
                t[name] = $d84dc1a5e217b32f$var$scalarZeroValue(member.T, member.L);
                break;
        }
    }
});
// Copyright 2021-2024 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * A Timestamp represents a point in time independent of any time zone or local
 * calendar, encoded as a count of seconds and fractions of seconds at
 * nanosecond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the
 * Gregorian calendar backwards to year one.
 *
 * All minutes are 60 seconds long. Leap seconds are "smeared" so that no leap
 * second table is needed for interpretation, using a [24-hour linear
 * smear](https://developers.google.com/time/smear).
 *
 * The range is from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59.999999999Z. By
 * restricting to that range, we ensure that we can convert to and from [RFC
 * 3339](https://www.ietf.org/rfc/rfc3339.txt) date strings.
 *
 * # Examples
 *
 * Example 1: Compute Timestamp from POSIX `time()`.
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(time(NULL));
 *     timestamp.set_nanos(0);
 *
 * Example 2: Compute Timestamp from POSIX `gettimeofday()`.
 *
 *     struct timeval tv;
 *     gettimeofday(&tv, NULL);
 *
 *     Timestamp timestamp;
 *     timestamp.set_seconds(tv.tv_sec);
 *     timestamp.set_nanos(tv.tv_usec * 1000);
 *
 * Example 3: Compute Timestamp from Win32 `GetSystemTimeAsFileTime()`.
 *
 *     FILETIME ft;
 *     GetSystemTimeAsFileTime(&ft);
 *     UINT64 ticks = (((UINT64)ft.dwHighDateTime) << 32) | ft.dwLowDateTime;
 *
 *     // A Windows tick is 100 nanoseconds. Windows epoch 1601-01-01T00:00:00Z
 *     // is 11644473600 seconds before Unix epoch 1970-01-01T00:00:00Z.
 *     Timestamp timestamp;
 *     timestamp.set_seconds((INT64) ((ticks / 10000000) - 11644473600LL));
 *     timestamp.set_nanos((INT32) ((ticks % 10000000) * 100));
 *
 * Example 4: Compute Timestamp from Java `System.currentTimeMillis()`.
 *
 *     long millis = System.currentTimeMillis();
 *
 *     Timestamp timestamp = Timestamp.newBuilder().setSeconds(millis / 1000)
 *         .setNanos((int) ((millis % 1000) * 1000000)).build();
 *
 * Example 5: Compute Timestamp from Java `Instant.now()`.
 *
 *     Instant now = Instant.now();
 *
 *     Timestamp timestamp =
 *         Timestamp.newBuilder().setSeconds(now.getEpochSecond())
 *             .setNanos(now.getNano()).build();
 *
 * Example 6: Compute Timestamp from current time in Python.
 *
 *     timestamp = Timestamp()
 *     timestamp.GetCurrentTime()
 *
 * # JSON Mapping
 *
 * In JSON format, the Timestamp type is encoded as a string in the
 * [RFC 3339](https://www.ietf.org/rfc/rfc3339.txt) format. That is, the
 * format is "{year}-{month}-{day}T{hour}:{min}:{sec}[.{frac_sec}]Z"
 * where {year} is always expressed using four digits while {month}, {day},
 * {hour}, {min}, and {sec} are zero-padded to two digits each. The fractional
 * seconds, which can go up to 9 digits (i.e. up to 1 nanosecond resolution),
 * are optional. The "Z" suffix indicates the timezone ("UTC"); the timezone
 * is required. A proto3 JSON serializer should always use UTC (as indicated by
 * "Z") when printing the Timestamp type and a proto3 JSON parser should be
 * able to accept both UTC and other timezones (as indicated by an offset).
 *
 * For example, "2017-01-15T01:30:15.01Z" encodes 15.01 seconds past
 * 01:30 UTC on January 15, 2017.
 *
 * In JavaScript, one can convert a Date object to this format using the
 * standard
 * [toISOString()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString)
 * method. In Python, a standard `datetime.datetime` object can be converted
 * to this format using
 * [`strftime`](https://docs.python.org/2/library/time.html#time.strftime) with
 * the time format spec '%Y-%m-%dT%H:%M:%S.%fZ'. Likewise, in Java, one can use
 * the Joda Time's [`ISODateTimeFormat.dateTime()`](
 * http://joda-time.sourceforge.net/apidocs/org/joda/time/format/ISODateTimeFormat.html#dateTime()
 * ) to obtain a formatter capable of generating timestamps in this format.
 *
 *
 * @generated from message google.protobuf.Timestamp
 */ class $d84dc1a5e217b32f$var$Timestamp extends $d84dc1a5e217b32f$var$Message {
    constructor(data){
        super();
        /**
     * Represents seconds of UTC time since Unix epoch
     * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     * 9999-12-31T23:59:59Z inclusive.
     *
     * @generated from field: int64 seconds = 1;
     */ this.seconds = $d84dc1a5e217b32f$var$protoInt64.zero;
        /**
     * Non-negative fractions of a second at nanosecond resolution. Negative
     * second values with fractions must still have non-negative nanos values
     * that count forward in time. Must be from 0 to 999,999,999
     * inclusive.
     *
     * @generated from field: int32 nanos = 2;
     */ this.nanos = 0;
        $d84dc1a5e217b32f$var$proto3.util.initPartial(data, this);
    }
    fromJson(json, options) {
        if (typeof json !== "string") throw new Error("cannot decode google.protobuf.Timestamp from JSON: ".concat($d84dc1a5e217b32f$var$proto3.json.debug(json)));
        const matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
        if (!matches) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        const ms = Date.parse(matches[1] + "-" + matches[2] + "-" + matches[3] + "T" + matches[4] + ":" + matches[5] + ":" + matches[6] + (matches[8] ? matches[8] : "Z"));
        if (Number.isNaN(ms)) throw new Error("cannot decode google.protobuf.Timestamp from JSON: invalid RFC 3339 string");
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot decode message google.protobuf.Timestamp from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        this.seconds = $d84dc1a5e217b32f$var$protoInt64.parse(ms / 1000);
        this.nanos = 0;
        if (matches[7]) this.nanos = parseInt("1" + matches[7] + "0".repeat(9 - matches[7].length)) - 1000000000;
        return this;
    }
    toJson(options) {
        const ms = Number(this.seconds) * 1000;
        if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error("cannot encode google.protobuf.Timestamp to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive");
        if (this.nanos < 0) throw new Error("cannot encode google.protobuf.Timestamp to JSON: nanos must not be negative");
        let z = "Z";
        if (this.nanos > 0) {
            const nanosStr = (this.nanos + 1000000000).toString().substring(1);
            if (nanosStr.substring(3) === "000000") z = "." + nanosStr.substring(0, 3) + "Z";
            else if (nanosStr.substring(6) === "000") z = "." + nanosStr.substring(0, 6) + "Z";
            else z = "." + nanosStr + "Z";
        }
        return new Date(ms).toISOString().replace(".000Z", z);
    }
    toDate() {
        return new Date(Number(this.seconds) * 1000 + Math.ceil(this.nanos / 1000000));
    }
    static now() {
        return $d84dc1a5e217b32f$var$Timestamp.fromDate(new Date());
    }
    static fromDate(date) {
        const ms = date.getTime();
        return new $d84dc1a5e217b32f$var$Timestamp({
            seconds: $d84dc1a5e217b32f$var$protoInt64.parse(Math.floor(ms / 1000)),
            nanos: ms % 1000 * 1000000
        });
    }
    static fromBinary(bytes, options) {
        return new $d84dc1a5e217b32f$var$Timestamp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new $d84dc1a5e217b32f$var$Timestamp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new $d84dc1a5e217b32f$var$Timestamp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return $d84dc1a5e217b32f$var$proto3.util.equals($d84dc1a5e217b32f$var$Timestamp, a, b);
    }
}
$d84dc1a5e217b32f$var$Timestamp.runtime = $d84dc1a5e217b32f$var$proto3;
$d84dc1a5e217b32f$var$Timestamp.typeName = "google.protobuf.Timestamp";
$d84dc1a5e217b32f$var$Timestamp.fields = $d84dc1a5e217b32f$var$proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seconds",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "nanos",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]);
const $d84dc1a5e217b32f$var$MetricsBatch = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.MetricsBatch", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Timestamp
        },
        {
            no: 3,
            name: "str_data",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "time_series",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TimeSeriesMetric,
            repeated: true
        },
        {
            no: 5,
            name: "events",
            kind: "message",
            T: $d84dc1a5e217b32f$var$EventMetric,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$TimeSeriesMetric = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TimeSeriesMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "samples",
            kind: "message",
            T: $d84dc1a5e217b32f$var$MetricSample,
            repeated: true
        },
        {
            no: 5,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$MetricSample = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.MetricSample", ()=>[
        {
            no: 1,
            name: "timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "normalized_timestamp",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Timestamp
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 2
        }
    ]);
const $d84dc1a5e217b32f$var$EventMetric = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.EventMetric", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "participant_identity",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "track_sid",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "start_timestamp_ms",
            kind: "scalar",
            T: 3
        },
        {
            no: 5,
            name: "end_timestamp_ms",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 6,
            name: "normalized_start_timestamp",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Timestamp
        },
        {
            no: 7,
            name: "normalized_end_timestamp",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Timestamp,
            opt: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "rid",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$TrackType = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.TrackType", [
    {
        no: 0,
        name: "AUDIO"
    },
    {
        no: 1,
        name: "VIDEO"
    },
    {
        no: 2,
        name: "DATA"
    }
]);
const $d84dc1a5e217b32f$var$TrackSource = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.TrackSource", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "CAMERA"
    },
    {
        no: 2,
        name: "MICROPHONE"
    },
    {
        no: 3,
        name: "SCREEN_SHARE"
    },
    {
        no: 4,
        name: "SCREEN_SHARE_AUDIO"
    }
]);
const $d84dc1a5e217b32f$var$VideoQuality$1 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.VideoQuality", [
    {
        no: 0,
        name: "LOW"
    },
    {
        no: 1,
        name: "MEDIUM"
    },
    {
        no: 2,
        name: "HIGH"
    },
    {
        no: 3,
        name: "OFF"
    }
]);
const $d84dc1a5e217b32f$var$ConnectionQuality$1 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ConnectionQuality", [
    {
        no: 0,
        name: "POOR"
    },
    {
        no: 1,
        name: "GOOD"
    },
    {
        no: 2,
        name: "EXCELLENT"
    },
    {
        no: 3,
        name: "LOST"
    }
]);
const $d84dc1a5e217b32f$var$ClientConfigSetting = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ClientConfigSetting", [
    {
        no: 0,
        name: "UNSET"
    },
    {
        no: 1,
        name: "DISABLED"
    },
    {
        no: 2,
        name: "ENABLED"
    }
]);
const $d84dc1a5e217b32f$export$258d16488300d83f = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.DisconnectReason", [
    {
        no: 0,
        name: "UNKNOWN_REASON"
    },
    {
        no: 1,
        name: "CLIENT_INITIATED"
    },
    {
        no: 2,
        name: "DUPLICATE_IDENTITY"
    },
    {
        no: 3,
        name: "SERVER_SHUTDOWN"
    },
    {
        no: 4,
        name: "PARTICIPANT_REMOVED"
    },
    {
        no: 5,
        name: "ROOM_DELETED"
    },
    {
        no: 6,
        name: "STATE_MISMATCH"
    },
    {
        no: 7,
        name: "JOIN_FAILURE"
    },
    {
        no: 8,
        name: "MIGRATION"
    },
    {
        no: 9,
        name: "SIGNAL_CLOSE"
    },
    {
        no: 10,
        name: "ROOM_CLOSED"
    },
    {
        no: 11,
        name: "USER_UNAVAILABLE"
    },
    {
        no: 12,
        name: "USER_REJECTED"
    },
    {
        no: 13,
        name: "SIP_TRUNK_FAILURE"
    }
]);
const $d84dc1a5e217b32f$var$ReconnectReason = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ReconnectReason", [
    {
        no: 0,
        name: "RR_UNKNOWN"
    },
    {
        no: 1,
        name: "RR_SIGNAL_DISCONNECTED"
    },
    {
        no: 2,
        name: "RR_PUBLISHER_FAILED"
    },
    {
        no: 3,
        name: "RR_SUBSCRIBER_FAILED"
    },
    {
        no: 4,
        name: "RR_SWITCH_CANDIDATE"
    }
]);
const $d84dc1a5e217b32f$export$7882d1e2e5429abf = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.SubscriptionError", [
    {
        no: 0,
        name: "SE_UNKNOWN"
    },
    {
        no: 1,
        name: "SE_CODEC_UNSUPPORTED"
    },
    {
        no: 2,
        name: "SE_TRACK_NOTFOUND"
    }
]);
const $d84dc1a5e217b32f$var$AudioTrackFeature = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.AudioTrackFeature", [
    {
        no: 0,
        name: "TF_STEREO"
    },
    {
        no: 1,
        name: "TF_NO_DTX"
    },
    {
        no: 2,
        name: "TF_AUTO_GAIN_CONTROL"
    },
    {
        no: 3,
        name: "TF_ECHO_CANCELLATION"
    },
    {
        no: 4,
        name: "TF_NOISE_SUPPRESSION"
    },
    {
        no: 5,
        name: "TF_ENHANCED_NOISE_CANCELLATION"
    }
]);
const $d84dc1a5e217b32f$var$Room$1 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.Room", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "empty_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 14,
            name: "departure_timeout",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "max_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "creation_time",
            kind: "scalar",
            T: 3
        },
        {
            no: 6,
            name: "turn_password",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "enabled_codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Codec,
            repeated: true
        },
        {
            no: 8,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "num_participants",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "num_publishers",
            kind: "scalar",
            T: 13
        },
        {
            no: 10,
            name: "active_recording",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "version",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TimedVersion
        }
    ]);
const $d84dc1a5e217b32f$var$Codec = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.Codec", ()=>[
        {
            no: 1,
            name: "mime",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "fmtp_line",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$ParticipantPermission = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ParticipantPermission", ()=>[
        {
            no: 1,
            name: "can_subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "can_publish",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "can_publish_data",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "can_publish_sources",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$TrackSource),
            repeated: true
        },
        {
            no: 7,
            name: "hidden",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "recorder",
            kind: "scalar",
            T: 8
        },
        {
            no: 10,
            name: "can_update_metadata",
            kind: "scalar",
            T: 8
        },
        {
            no: 11,
            name: "agent",
            kind: "scalar",
            T: 8
        },
        {
            no: 12,
            name: "can_subscribe_metrics",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$ParticipantInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ParticipantInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ParticipantInfo_State)
        },
        {
            no: 4,
            name: "tracks",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackInfo,
            repeated: true
        },
        {
            no: 5,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "joined_at",
            kind: "scalar",
            T: 3
        },
        {
            no: 9,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "version",
            kind: "scalar",
            T: 13
        },
        {
            no: 11,
            name: "permission",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantPermission
        },
        {
            no: 12,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "is_publisher",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "kind",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$export$2079c0e1523aec29)
        },
        {
            no: 15,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 16,
            name: "disconnect_reason",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$export$258d16488300d83f)
        }
    ]);
const $d84dc1a5e217b32f$var$ParticipantInfo_State = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ParticipantInfo.State", [
    {
        no: 0,
        name: "JOINING"
    },
    {
        no: 1,
        name: "JOINED"
    },
    {
        no: 2,
        name: "ACTIVE"
    },
    {
        no: 3,
        name: "DISCONNECTED"
    }
]);
const $d84dc1a5e217b32f$export$2079c0e1523aec29 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ParticipantInfo.Kind", [
    {
        no: 0,
        name: "STANDARD"
    },
    {
        no: 1,
        name: "INGRESS"
    },
    {
        no: 2,
        name: "EGRESS"
    },
    {
        no: 3,
        name: "SIP"
    },
    {
        no: 4,
        name: "AGENT"
    }
]);
const $d84dc1a5e217b32f$var$Encryption_Type = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.Encryption.Type", [
    {
        no: 0,
        name: "NONE"
    },
    {
        no: 1,
        name: "GCM"
    },
    {
        no: 2,
        name: "CUSTOM"
    }
]);
const $d84dc1a5e217b32f$var$SimulcastCodecInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SimulcastCodecInfo", ()=>[
        {
            no: 1,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "layers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoLayer,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$TrackInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrackInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "type",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$TrackType)
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "simulcast",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 9,
            name: "source",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$TrackSource)
        },
        {
            no: 10,
            name: "layers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoLayer,
            repeated: true
        },
        {
            no: 11,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "mid",
            kind: "scalar",
            T: 9
        },
        {
            no: 13,
            name: "codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SimulcastCodecInfo,
            repeated: true
        },
        {
            no: 14,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 15,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 16,
            name: "encryption",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$Encryption_Type)
        },
        {
            no: 17,
            name: "stream",
            kind: "scalar",
            T: 9
        },
        {
            no: 18,
            name: "version",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TimedVersion
        },
        {
            no: 19,
            name: "audio_features",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$AudioTrackFeature),
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$VideoLayer = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.VideoLayer", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "bitrate",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "ssrc",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$DataPacket = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataPacket", ()=>[
        {
            no: 1,
            name: "kind",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$export$629a0ea4ceb9e4a6)
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "user",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UserPacket,
            oneof: "value"
        },
        {
            no: 3,
            name: "speaker",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ActiveSpeakerUpdate,
            oneof: "value"
        },
        {
            no: 6,
            name: "sip_dtmf",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SipDTMF,
            oneof: "value"
        },
        {
            no: 7,
            name: "transcription",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Transcription,
            oneof: "value"
        },
        {
            no: 8,
            name: "metrics",
            kind: "message",
            T: $d84dc1a5e217b32f$var$MetricsBatch,
            oneof: "value"
        },
        {
            no: 9,
            name: "chat_message",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ChatMessage,
            oneof: "value"
        },
        {
            no: 10,
            name: "rpc_request",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RpcRequest,
            oneof: "value"
        },
        {
            no: 11,
            name: "rpc_ack",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RpcAck,
            oneof: "value"
        },
        {
            no: 12,
            name: "rpc_response",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RpcResponse,
            oneof: "value"
        },
        {
            no: 13,
            name: "stream_header",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DataStream_Header,
            oneof: "value"
        },
        {
            no: 14,
            name: "stream_chunk",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DataStream_Chunk,
            oneof: "value"
        }
    ]);
const $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.DataPacket.Kind", [
    {
        no: 0,
        name: "RELIABLE"
    },
    {
        no: 1,
        name: "LOSSY"
    }
]);
const $d84dc1a5e217b32f$var$ActiveSpeakerUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ActiveSpeakerUpdate", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$SpeakerInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SpeakerInfo", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "level",
            kind: "scalar",
            T: 2
        },
        {
            no: 3,
            name: "active",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$UserPacket = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UserPacket", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 12
        },
        {
            no: 3,
            name: "destination_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 6,
            name: "destination_identities",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "topic",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 8,
            name: "id",
            kind: "scalar",
            T: 9,
            opt: true
        },
        {
            no: 9,
            name: "start_time",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 10,
            name: "end_time",
            kind: "scalar",
            T: 4,
            opt: true
        }
    ]);
const $d84dc1a5e217b32f$var$SipDTMF = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SipDTMF", ()=>[
        {
            no: 3,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 4,
            name: "digit",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$Transcription = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.Transcription", ()=>[
        {
            no: 2,
            name: "transcribed_participant_identity",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "track_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "segments",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TranscriptionSegment,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$TranscriptionSegment = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TranscriptionSegment", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "start_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 4,
            name: "end_time",
            kind: "scalar",
            T: 4
        },
        {
            no: 5,
            name: "final",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "language",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$ChatMessage = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ChatMessage", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "edit_timestamp",
            kind: "scalar",
            T: 3,
            opt: true
        },
        {
            no: 4,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "deleted",
            kind: "scalar",
            T: 8
        },
        {
            no: 6,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$RpcRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RpcRequest", ()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "method",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "payload",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "response_timeout_ms",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$RpcAck = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RpcAck", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$RpcResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RpcResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "payload",
            kind: "scalar",
            T: 9,
            oneof: "value"
        },
        {
            no: 3,
            name: "error",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RpcError$1,
            oneof: "value"
        }
    ]);
const $d84dc1a5e217b32f$var$RpcError$1 = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RpcError", ()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "data",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$ParticipantTracks = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ParticipantTracks", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$ServerInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ServerInfo", ()=>[
        {
            no: 1,
            name: "edition",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ServerInfo_Edition)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "node_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "debug_info",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "agent_protocol",
            kind: "scalar",
            T: 5
        }
    ]);
const $d84dc1a5e217b32f$var$ServerInfo_Edition = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ServerInfo.Edition", [
    {
        no: 0,
        name: "Standard"
    },
    {
        no: 1,
        name: "Cloud"
    }
]);
const $d84dc1a5e217b32f$var$ClientInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ClientInfo", ()=>[
        {
            no: 1,
            name: "sdk",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ClientInfo_SDK)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "protocol",
            kind: "scalar",
            T: 5
        },
        {
            no: 4,
            name: "os",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "os_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 6,
            name: "device_model",
            kind: "scalar",
            T: 9
        },
        {
            no: 7,
            name: "browser",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "browser_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 9,
            name: "address",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "network",
            kind: "scalar",
            T: 9
        },
        {
            no: 11,
            name: "other_sdks",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$ClientInfo_SDK = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.ClientInfo.SDK", [
    {
        no: 0,
        name: "UNKNOWN"
    },
    {
        no: 1,
        name: "JS"
    },
    {
        no: 2,
        name: "SWIFT"
    },
    {
        no: 3,
        name: "ANDROID"
    },
    {
        no: 4,
        name: "FLUTTER"
    },
    {
        no: 5,
        name: "GO"
    },
    {
        no: 6,
        name: "UNITY"
    },
    {
        no: 7,
        name: "REACT_NATIVE"
    },
    {
        no: 8,
        name: "RUST"
    },
    {
        no: 9,
        name: "PYTHON"
    },
    {
        no: 10,
        name: "CPP"
    },
    {
        no: 11,
        name: "UNITY_WEB"
    },
    {
        no: 12,
        name: "NODE"
    }
]);
const $d84dc1a5e217b32f$var$ClientConfiguration = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ClientConfiguration", ()=>[
        {
            no: 1,
            name: "video",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoConfiguration
        },
        {
            no: 2,
            name: "screen",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoConfiguration
        },
        {
            no: 3,
            name: "resume_connection",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ClientConfigSetting)
        },
        {
            no: 4,
            name: "disabled_codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DisabledCodecs
        },
        {
            no: 5,
            name: "force_relay",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ClientConfigSetting)
        }
    ]);
const $d84dc1a5e217b32f$var$VideoConfiguration = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.VideoConfiguration", ()=>[
        {
            no: 1,
            name: "hardware_encoder",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ClientConfigSetting)
        }
    ]);
const $d84dc1a5e217b32f$var$DisabledCodecs = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DisabledCodecs", ()=>[
        {
            no: 1,
            name: "codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Codec,
            repeated: true
        },
        {
            no: 2,
            name: "publish",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Codec,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$TimedVersion = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TimedVersion", ()=>[
        {
            no: 1,
            name: "unix_micro",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "ticks",
            kind: "scalar",
            T: 5
        }
    ]);
const $d84dc1a5e217b32f$var$DataStream_OperationType = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.DataStream.OperationType", [
    {
        no: 0,
        name: "CREATE"
    },
    {
        no: 1,
        name: "UPDATE"
    },
    {
        no: 2,
        name: "DELETE"
    },
    {
        no: 3,
        name: "REACTION"
    }
]);
const $d84dc1a5e217b32f$var$DataStream_TextHeader = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataStream.TextHeader", ()=>[
        {
            no: 1,
            name: "operation_type",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$DataStream_OperationType)
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 3,
            name: "reply_to_stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "attached_stream_ids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 5,
            name: "generated",
            kind: "scalar",
            T: 8
        }
    ], {
    localName: "DataStream_TextHeader"
});
const $d84dc1a5e217b32f$var$DataStream_FileHeader = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataStream.FileHeader", ()=>[
        {
            no: 1,
            name: "file_name",
            kind: "scalar",
            T: 9
        }
    ], {
    localName: "DataStream_FileHeader"
});
const $d84dc1a5e217b32f$var$DataStream_Header = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataStream.Header", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 3,
            name: "topic",
            kind: "scalar",
            T: 9
        },
        {
            no: 4,
            name: "mime_type",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "total_length",
            kind: "scalar",
            T: 4,
            opt: true
        },
        {
            no: 7,
            name: "encryption_type",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$Encryption_Type)
        },
        {
            no: 8,
            name: "extensions",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 9,
            name: "text_header",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DataStream_TextHeader,
            oneof: "content_header"
        },
        {
            no: 10,
            name: "file_header",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DataStream_FileHeader,
            oneof: "content_header"
        }
    ], {
    localName: "DataStream_Header"
});
const $d84dc1a5e217b32f$var$DataStream_Chunk = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataStream.Chunk", ()=>[
        {
            no: 1,
            name: "stream_id",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "chunk_index",
            kind: "scalar",
            T: 4
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12
        },
        {
            no: 4,
            name: "complete",
            kind: "scalar",
            T: 8
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 5
        },
        {
            no: 6,
            name: "iv",
            kind: "scalar",
            T: 12,
            opt: true
        }
    ], {
    localName: "DataStream_Chunk"
});
const $d84dc1a5e217b32f$var$SignalTarget = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.SignalTarget", [
    {
        no: 0,
        name: "PUBLISHER"
    },
    {
        no: 1,
        name: "SUBSCRIBER"
    }
]);
const $d84dc1a5e217b32f$var$StreamState = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.StreamState", [
    {
        no: 0,
        name: "ACTIVE"
    },
    {
        no: 1,
        name: "PAUSED"
    }
]);
const $d84dc1a5e217b32f$var$CandidateProtocol = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.CandidateProtocol", [
    {
        no: 0,
        name: "UDP"
    },
    {
        no: 1,
        name: "TCP"
    },
    {
        no: 2,
        name: "TLS"
    }
]);
const $d84dc1a5e217b32f$var$SignalRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SignalRequest", ()=>[
        {
            no: 1,
            name: "offer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "trickle",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 4,
            name: "add_track",
            kind: "message",
            T: $d84dc1a5e217b32f$var$AddTrackRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "mute",
            kind: "message",
            T: $d84dc1a5e217b32f$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 6,
            name: "subscription",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateSubscription,
            oneof: "message"
        },
        {
            no: 7,
            name: "track_setting",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateTrackSettings,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $d84dc1a5e217b32f$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "update_layers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateVideoLayers,
            oneof: "message"
        },
        {
            no: 11,
            name: "subscription_permission",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscriptionPermission,
            oneof: "message"
        },
        {
            no: 12,
            name: "sync_state",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SyncState,
            oneof: "message"
        },
        {
            no: 13,
            name: "simulate",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SimulateScenario,
            oneof: "message"
        },
        {
            no: 14,
            name: "ping",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 15,
            name: "update_metadata",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateParticipantMetadata,
            oneof: "message"
        },
        {
            no: 16,
            name: "ping_req",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Ping,
            oneof: "message"
        },
        {
            no: 17,
            name: "update_audio_track",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateLocalAudioTrack,
            oneof: "message"
        },
        {
            no: 18,
            name: "update_video_track",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateLocalVideoTrack,
            oneof: "message"
        }
    ]);
const $d84dc1a5e217b32f$var$SignalResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SignalResponse", ()=>[
        {
            no: 1,
            name: "join",
            kind: "message",
            T: $d84dc1a5e217b32f$var$JoinResponse,
            oneof: "message"
        },
        {
            no: 2,
            name: "answer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 3,
            name: "offer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription,
            oneof: "message"
        },
        {
            no: 4,
            name: "trickle",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrickleRequest,
            oneof: "message"
        },
        {
            no: 5,
            name: "update",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantUpdate,
            oneof: "message"
        },
        {
            no: 6,
            name: "track_published",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackPublishedResponse,
            oneof: "message"
        },
        {
            no: 8,
            name: "leave",
            kind: "message",
            T: $d84dc1a5e217b32f$var$LeaveRequest,
            oneof: "message"
        },
        {
            no: 9,
            name: "mute",
            kind: "message",
            T: $d84dc1a5e217b32f$var$MuteTrackRequest,
            oneof: "message"
        },
        {
            no: 10,
            name: "speakers_changed",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SpeakersChanged,
            oneof: "message"
        },
        {
            no: 11,
            name: "room_update",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RoomUpdate,
            oneof: "message"
        },
        {
            no: 12,
            name: "connection_quality",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ConnectionQualityUpdate,
            oneof: "message"
        },
        {
            no: 13,
            name: "stream_state_update",
            kind: "message",
            T: $d84dc1a5e217b32f$var$StreamStateUpdate,
            oneof: "message"
        },
        {
            no: 14,
            name: "subscribed_quality_update",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscribedQualityUpdate,
            oneof: "message"
        },
        {
            no: 15,
            name: "subscription_permission_update",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscriptionPermissionUpdate,
            oneof: "message"
        },
        {
            no: 16,
            name: "refresh_token",
            kind: "scalar",
            T: 9,
            oneof: "message"
        },
        {
            no: 17,
            name: "track_unpublished",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackUnpublishedResponse,
            oneof: "message"
        },
        {
            no: 18,
            name: "pong",
            kind: "scalar",
            T: 3,
            oneof: "message"
        },
        {
            no: 19,
            name: "reconnect",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ReconnectResponse,
            oneof: "message"
        },
        {
            no: 20,
            name: "pong_resp",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Pong,
            oneof: "message"
        },
        {
            no: 21,
            name: "subscription_response",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscriptionResponse,
            oneof: "message"
        },
        {
            no: 22,
            name: "request_response",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RequestResponse,
            oneof: "message"
        },
        {
            no: 23,
            name: "track_subscribed",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackSubscribed,
            oneof: "message"
        }
    ]);
const $d84dc1a5e217b32f$var$SimulcastCodec = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SimulcastCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "cid",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$AddTrackRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.AddTrackRequest", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "type",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$TrackType)
        },
        {
            no: 4,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 5,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "muted",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "disable_dtx",
            kind: "scalar",
            T: 8
        },
        {
            no: 8,
            name: "source",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$TrackSource)
        },
        {
            no: 9,
            name: "layers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoLayer,
            repeated: true
        },
        {
            no: 10,
            name: "simulcast_codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SimulcastCodec,
            repeated: true
        },
        {
            no: 11,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 12,
            name: "stereo",
            kind: "scalar",
            T: 8
        },
        {
            no: 13,
            name: "disable_red",
            kind: "scalar",
            T: 8
        },
        {
            no: 14,
            name: "encryption",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$Encryption_Type)
        },
        {
            no: 15,
            name: "stream",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$TrickleRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrickleRequest", ()=>[
        {
            no: 1,
            name: "candidateInit",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "target",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$SignalTarget)
        },
        {
            no: 3,
            name: "final",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$MuteTrackRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.MuteTrackRequest", ()=>[
        {
            no: 1,
            name: "sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "muted",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$JoinResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.JoinResponse", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Room$1
        },
        {
            no: 2,
            name: "participant",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantInfo
        },
        {
            no: 3,
            name: "other_participants",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantInfo,
            repeated: true
        },
        {
            no: 4,
            name: "server_version",
            kind: "scalar",
            T: 9
        },
        {
            no: 5,
            name: "ice_servers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ICEServer,
            repeated: true
        },
        {
            no: 6,
            name: "subscriber_primary",
            kind: "scalar",
            T: 8
        },
        {
            no: 7,
            name: "alternative_url",
            kind: "scalar",
            T: 9
        },
        {
            no: 8,
            name: "client_configuration",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ClientConfiguration
        },
        {
            no: 9,
            name: "server_region",
            kind: "scalar",
            T: 9
        },
        {
            no: 10,
            name: "ping_timeout",
            kind: "scalar",
            T: 5
        },
        {
            no: 11,
            name: "ping_interval",
            kind: "scalar",
            T: 5
        },
        {
            no: 12,
            name: "server_info",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ServerInfo
        },
        {
            no: 13,
            name: "sif_trailer",
            kind: "scalar",
            T: 12
        },
        {
            no: 14,
            name: "enabled_publish_codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Codec,
            repeated: true
        },
        {
            no: 15,
            name: "fast_publish",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$ReconnectResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ReconnectResponse", ()=>[
        {
            no: 1,
            name: "ice_servers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ICEServer,
            repeated: true
        },
        {
            no: 2,
            name: "client_configuration",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ClientConfiguration
        }
    ]);
const $d84dc1a5e217b32f$var$TrackPublishedResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrackPublishedResponse", ()=>[
        {
            no: 1,
            name: "cid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackInfo
        }
    ]);
const $d84dc1a5e217b32f$var$TrackUnpublishedResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrackUnpublishedResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$SessionDescription = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SessionDescription", ()=>[
        {
            no: 1,
            name: "type",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "sdp",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$ParticipantUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ParticipantUpdate", ()=>[
        {
            no: 1,
            name: "participants",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$UpdateSubscription = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateSubscription", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "subscribe",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "participant_tracks",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ParticipantTracks,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$UpdateTrackSettings = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateTrackSettings", ()=>[
        {
            no: 1,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 3,
            name: "disabled",
            kind: "scalar",
            T: 8
        },
        {
            no: 4,
            name: "quality",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$VideoQuality$1)
        },
        {
            no: 5,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 6,
            name: "height",
            kind: "scalar",
            T: 13
        },
        {
            no: 7,
            name: "fps",
            kind: "scalar",
            T: 13
        },
        {
            no: 8,
            name: "priority",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$UpdateLocalAudioTrack = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateLocalAudioTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "features",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$AudioTrackFeature),
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$UpdateLocalVideoTrack = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateLocalVideoTrack", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "width",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "height",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$LeaveRequest = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.LeaveRequest", ()=>[
        {
            no: 1,
            name: "can_reconnect",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$export$258d16488300d83f)
        },
        {
            no: 3,
            name: "action",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$LeaveRequest_Action)
        },
        {
            no: 4,
            name: "regions",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RegionSettings
        }
    ]);
const $d84dc1a5e217b32f$var$LeaveRequest_Action = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.LeaveRequest.Action", [
    {
        no: 0,
        name: "DISCONNECT"
    },
    {
        no: 1,
        name: "RESUME"
    },
    {
        no: 2,
        name: "RECONNECT"
    }
]);
const $d84dc1a5e217b32f$var$UpdateVideoLayers = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateVideoLayers", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "layers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$VideoLayer,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$UpdateParticipantMetadata = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.UpdateParticipantMetadata", ()=>[
        {
            no: 1,
            name: "metadata",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "attributes",
            kind: "map",
            K: 9,
            V: {
                kind: "scalar",
                T: 9
            }
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 13
        }
    ]);
const $d84dc1a5e217b32f$var$ICEServer = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ICEServer", ()=>[
        {
            no: 1,
            name: "urls",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 2,
            name: "username",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "credential",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$SpeakersChanged = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SpeakersChanged", ()=>[
        {
            no: 1,
            name: "speakers",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SpeakerInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$RoomUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RoomUpdate", ()=>[
        {
            no: 1,
            name: "room",
            kind: "message",
            T: $d84dc1a5e217b32f$var$Room$1
        }
    ]);
const $d84dc1a5e217b32f$var$ConnectionQualityInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ConnectionQualityInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "quality",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$ConnectionQuality$1)
        },
        {
            no: 3,
            name: "score",
            kind: "scalar",
            T: 2
        }
    ]);
const $d84dc1a5e217b32f$var$ConnectionQualityUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.ConnectionQualityUpdate", ()=>[
        {
            no: 1,
            name: "updates",
            kind: "message",
            T: $d84dc1a5e217b32f$var$ConnectionQualityInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$StreamStateInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.StreamStateInfo", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "state",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$StreamState)
        }
    ]);
const $d84dc1a5e217b32f$var$StreamStateUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.StreamStateUpdate", ()=>[
        {
            no: 1,
            name: "stream_states",
            kind: "message",
            T: $d84dc1a5e217b32f$var$StreamStateInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$SubscribedQuality = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscribedQuality", ()=>[
        {
            no: 1,
            name: "quality",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$VideoQuality$1)
        },
        {
            no: 2,
            name: "enabled",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$SubscribedCodec = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscribedCodec", ()=>[
        {
            no: 1,
            name: "codec",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "qualities",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscribedQuality,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$SubscribedQualityUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscribedQualityUpdate", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "subscribed_qualities",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscribedQuality,
            repeated: true
        },
        {
            no: 3,
            name: "subscribed_codecs",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SubscribedCodec,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$TrackPermission = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrackPermission", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "all_tracks",
            kind: "scalar",
            T: 8
        },
        {
            no: 3,
            name: "track_sids",
            kind: "scalar",
            T: 9,
            repeated: true
        },
        {
            no: 4,
            name: "participant_identity",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$SubscriptionPermission = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscriptionPermission", ()=>[
        {
            no: 1,
            name: "all_participants",
            kind: "scalar",
            T: 8
        },
        {
            no: 2,
            name: "track_permissions",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackPermission,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$SubscriptionPermissionUpdate = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscriptionPermissionUpdate", ()=>[
        {
            no: 1,
            name: "participant_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "allowed",
            kind: "scalar",
            T: 8
        }
    ]);
const $d84dc1a5e217b32f$var$SyncState = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SyncState", ()=>[
        {
            no: 1,
            name: "answer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription
        },
        {
            no: 2,
            name: "subscription",
            kind: "message",
            T: $d84dc1a5e217b32f$var$UpdateSubscription
        },
        {
            no: 3,
            name: "publish_tracks",
            kind: "message",
            T: $d84dc1a5e217b32f$var$TrackPublishedResponse,
            repeated: true
        },
        {
            no: 4,
            name: "data_channels",
            kind: "message",
            T: $d84dc1a5e217b32f$var$DataChannelInfo,
            repeated: true
        },
        {
            no: 5,
            name: "offer",
            kind: "message",
            T: $d84dc1a5e217b32f$var$SessionDescription
        },
        {
            no: 6,
            name: "track_sids_disabled",
            kind: "scalar",
            T: 9,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$DataChannelInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.DataChannelInfo", ()=>[
        {
            no: 1,
            name: "label",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 13
        },
        {
            no: 3,
            name: "target",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$SignalTarget)
        }
    ]);
const $d84dc1a5e217b32f$var$SimulateScenario = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SimulateScenario", ()=>[
        {
            no: 1,
            name: "speaker_update",
            kind: "scalar",
            T: 5,
            oneof: "scenario"
        },
        {
            no: 2,
            name: "node_failure",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 3,
            name: "migration",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 4,
            name: "server_leave",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 5,
            name: "switch_candidate_protocol",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$CandidateProtocol),
            oneof: "scenario"
        },
        {
            no: 6,
            name: "subscriber_bandwidth",
            kind: "scalar",
            T: 3,
            oneof: "scenario"
        },
        {
            no: 7,
            name: "disconnect_signal_on_resume",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 8,
            name: "disconnect_signal_on_resume_no_messages",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        },
        {
            no: 9,
            name: "leave_request_full_reconnect",
            kind: "scalar",
            T: 8,
            oneof: "scenario"
        }
    ]);
const $d84dc1a5e217b32f$var$Ping = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.Ping", ()=>[
        {
            no: 1,
            name: "timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "rtt",
            kind: "scalar",
            T: 3
        }
    ]);
const $d84dc1a5e217b32f$var$Pong = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.Pong", ()=>[
        {
            no: 1,
            name: "last_ping_timestamp",
            kind: "scalar",
            T: 3
        },
        {
            no: 2,
            name: "timestamp",
            kind: "scalar",
            T: 3
        }
    ]);
const $d84dc1a5e217b32f$var$RegionSettings = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RegionSettings", ()=>[
        {
            no: 1,
            name: "regions",
            kind: "message",
            T: $d84dc1a5e217b32f$var$RegionInfo,
            repeated: true
        }
    ]);
const $d84dc1a5e217b32f$var$RegionInfo = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RegionInfo", ()=>[
        {
            no: 1,
            name: "region",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9
        },
        {
            no: 3,
            name: "distance",
            kind: "scalar",
            T: 3
        }
    ]);
const $d84dc1a5e217b32f$var$SubscriptionResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.SubscriptionResponse", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        },
        {
            no: 2,
            name: "err",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$export$7882d1e2e5429abf)
        }
    ]);
const $d84dc1a5e217b32f$var$RequestResponse = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.RequestResponse", ()=>[
        {
            no: 1,
            name: "request_id",
            kind: "scalar",
            T: 13
        },
        {
            no: 2,
            name: "reason",
            kind: "enum",
            T: $d84dc1a5e217b32f$var$proto3.getEnumType($d84dc1a5e217b32f$var$RequestResponse_Reason)
        },
        {
            no: 3,
            name: "message",
            kind: "scalar",
            T: 9
        }
    ]);
const $d84dc1a5e217b32f$var$RequestResponse_Reason = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeEnum("livekit.RequestResponse.Reason", [
    {
        no: 0,
        name: "OK"
    },
    {
        no: 1,
        name: "NOT_FOUND"
    },
    {
        no: 2,
        name: "NOT_ALLOWED"
    },
    {
        no: 3,
        name: "LIMIT_EXCEEDED"
    }
]);
const $d84dc1a5e217b32f$var$TrackSubscribed = /* @__PURE__ */ $d84dc1a5e217b32f$var$proto3.makeMessageType("livekit.TrackSubscribed", ()=>[
        {
            no: 1,
            name: "track_sid",
            kind: "scalar",
            T: 9
        }
    ]);
function $d84dc1a5e217b32f$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $d84dc1a5e217b32f$var$loglevel$1 = {
    exports: {}
};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ var $d84dc1a5e217b32f$var$loglevel = $d84dc1a5e217b32f$var$loglevel$1.exports;
var $d84dc1a5e217b32f$var$hasRequiredLoglevel;
function $d84dc1a5e217b32f$var$requireLoglevel() {
    if ($d84dc1a5e217b32f$var$hasRequiredLoglevel) return $d84dc1a5e217b32f$var$loglevel$1.exports;
    $d84dc1a5e217b32f$var$hasRequiredLoglevel = 1;
    (function(module) {
        (function(root, definition) {
            if (module.exports) module.exports = definition();
            else root.log = definition();
        })($d84dc1a5e217b32f$var$loglevel, function() {
            // Slightly dubious tricks to cut down minimized file size
            var noop = function() {};
            var undefinedType = "undefined";
            var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
            var logMethods = [
                "trace",
                "debug",
                "info",
                "warn",
                "error"
            ];
            var _loggersByName = {};
            var defaultLogger = null;
            // Cross-browser bind equivalent that works at least back to IE6
            function bindMethod(obj, methodName) {
                var method = obj[methodName];
                if (typeof method.bind === "function") return method.bind(obj);
                else try {
                    return Function.prototype.bind.call(method, obj);
                } catch (e) {
                    // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                    return function() {
                        return Function.prototype.apply.apply(method, [
                            obj,
                            arguments
                        ]);
                    };
                }
            }
            // Trace() doesn't print the message in IE, so for that case we need to wrap it
            function traceForIE() {
                if (console.log) {
                    if (console.log.apply) console.log.apply(console, arguments);
                    else // In old IE, native console methods themselves don't have apply().
                    Function.prototype.apply.apply(console.log, [
                        console,
                        arguments
                    ]);
                }
                if (console.trace) console.trace();
            }
            // Build the best logging method possible for this env
            // Wherever possible we want to bind, not wrap, to preserve stack traces
            function realMethod(methodName) {
                if (methodName === "debug") methodName = "log";
                if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
                else if (methodName === "trace" && isIE) return traceForIE;
                else if (console[methodName] !== undefined) return bindMethod(console, methodName);
                else if (console.log !== undefined) return bindMethod(console, "log");
                else return noop;
            }
            // These private functions always need `this` to be set properly
            function replaceLoggingMethods() {
                /*jshint validthis:true */ var level = this.getLevel();
                // Replace the actual methods.
                for(var i = 0; i < logMethods.length; i++){
                    var methodName = logMethods[i];
                    this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
                }
                // Define log.log as an alias for log.debug
                this.log = this.debug;
                // Return any important warnings.
                if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
            }
            // In old IE versions, the console isn't present until you first open it.
            // We build realMethod() replacements here that regenerate logging methods
            function enableLoggingWhenConsoleArrives(methodName) {
                return function() {
                    if (typeof console !== undefinedType) {
                        replaceLoggingMethods.call(this);
                        this[methodName].apply(this, arguments);
                    }
                };
            }
            // By default, we use closely bound real methods wherever possible, and
            // otherwise we wait for a console to appear, and then try again.
            function defaultMethodFactory(methodName, _level, _loggerName) {
                /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
            }
            function Logger(name, factory) {
                // Private instance variables.
                var self = this;
                /**
         * The level inherited from a parent logger (or a global default). We
         * cache this here rather than delegating to the parent so that it stays
         * in sync with the actual logging methods that we have installed (the
         * parent could change levels but we might not have rebuilt the loggers
         * in this child yet).
         * @type {number}
         */ var inheritedLevel;
                /**
         * The default level for this logger, if any. If set, this overrides
         * `inheritedLevel`.
         * @type {number|null}
         */ var defaultLevel;
                /**
         * A user-specific level for this logger. If set, this overrides
         * `defaultLevel`.
         * @type {number|null}
         */ var userLevel;
                var storageKey = "loglevel";
                if (typeof name === "string") storageKey += ":" + name;
                else if (typeof name === "symbol") storageKey = undefined;
                function persistLevelIfPossible(levelNum) {
                    var levelName = (logMethods[levelNum] || "silent").toUpperCase();
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage[storageKey] = levelName;
                        return;
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
                    } catch (ignore) {}
                }
                function getPersistedLevel() {
                    var storedLevel;
                    if (typeof window === undefinedType || !storageKey) return;
                    try {
                        storedLevel = window.localStorage[storageKey];
                    } catch (ignore) {}
                    // Fallback to cookies if local storage gives us nothing
                    if (typeof storedLevel === undefinedType) try {
                        var cookie = window.document.cookie;
                        var cookieName = encodeURIComponent(storageKey);
                        var location = cookie.indexOf(cookieName + "=");
                        if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
                    } catch (ignore) {}
                    // If the stored level is not valid, treat it as if nothing was stored.
                    if (self.levels[storedLevel] === undefined) storedLevel = undefined;
                    return storedLevel;
                }
                function clearPersistedLevel() {
                    if (typeof window === undefinedType || !storageKey) return;
                    // Use localStorage if available
                    try {
                        window.localStorage.removeItem(storageKey);
                    } catch (ignore) {}
                    // Use session cookie as fallback
                    try {
                        window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    } catch (ignore) {}
                }
                function normalizeLevel(input) {
                    var level = input;
                    if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
                    if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
                    else throw new TypeError("log.setLevel() called with invalid level: " + input);
                }
                /*
         *
         * Public logger API - see https://github.com/pimterry/loglevel for details
         *
         */ self.name = name;
                self.levels = {
                    "TRACE": 0,
                    "DEBUG": 1,
                    "INFO": 2,
                    "WARN": 3,
                    "ERROR": 4,
                    "SILENT": 5
                };
                self.methodFactory = factory || defaultMethodFactory;
                self.getLevel = function() {
                    if (userLevel != null) return userLevel;
                    else if (defaultLevel != null) return defaultLevel;
                    else return inheritedLevel;
                };
                self.setLevel = function(level, persist) {
                    userLevel = normalizeLevel(level);
                    if (persist !== false) // defaults to true
                    persistLevelIfPossible(userLevel);
                    // NOTE: in v2, this should call rebuild(), which updates children.
                    return replaceLoggingMethods.call(self);
                };
                self.setDefaultLevel = function(level) {
                    defaultLevel = normalizeLevel(level);
                    if (!getPersistedLevel()) self.setLevel(level, false);
                };
                self.resetLevel = function() {
                    userLevel = null;
                    clearPersistedLevel();
                    replaceLoggingMethods.call(self);
                };
                self.enableAll = function(persist) {
                    self.setLevel(self.levels.TRACE, persist);
                };
                self.disableAll = function(persist) {
                    self.setLevel(self.levels.SILENT, persist);
                };
                self.rebuild = function() {
                    if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
                    replaceLoggingMethods.call(self);
                    if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
                };
                // Initialize all the internal levels.
                inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
                var initialLevel = getPersistedLevel();
                if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
                replaceLoggingMethods.call(self);
            }
            /*
       *
       * Top-level API
       *
       */ defaultLogger = new Logger();
            defaultLogger.getLogger = function getLogger(name) {
                if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
                var logger = _loggersByName[name];
                if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
                return logger;
            };
            // Grab the current global log variable in case of overwrite
            var _log = typeof window !== undefinedType ? window.log : undefined;
            defaultLogger.noConflict = function() {
                if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
                return defaultLogger;
            };
            defaultLogger.getLoggers = function getLoggers() {
                return _loggersByName;
            };
            // ES6 default export, for compatibility
            defaultLogger["default"] = defaultLogger;
            return defaultLogger;
        });
    })($d84dc1a5e217b32f$var$loglevel$1);
    return $d84dc1a5e217b32f$var$loglevel$1.exports;
}
var $d84dc1a5e217b32f$var$loglevelExports = $d84dc1a5e217b32f$var$requireLoglevel();
var $d84dc1a5e217b32f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["trace"] = 0] = "trace";
    LogLevel[LogLevel["debug"] = 1] = "debug";
    LogLevel[LogLevel["info"] = 2] = "info";
    LogLevel[LogLevel["warn"] = 3] = "warn";
    LogLevel[LogLevel["error"] = 4] = "error";
    LogLevel[LogLevel["silent"] = 5] = "silent";
})($d84dc1a5e217b32f$export$243e62d78d3b544d || ($d84dc1a5e217b32f$export$243e62d78d3b544d = {}));
var $d84dc1a5e217b32f$export$69ba24dd79f4da21;
(function(LoggerNames) {
    LoggerNames["Default"] = "livekit";
    LoggerNames["Room"] = "livekit-room";
    LoggerNames["Participant"] = "livekit-participant";
    LoggerNames["Track"] = "livekit-track";
    LoggerNames["Publication"] = "livekit-track-publication";
    LoggerNames["Engine"] = "livekit-engine";
    LoggerNames["Signal"] = "livekit-signal";
    LoggerNames["PCManager"] = "livekit-pc-manager";
    LoggerNames["PCTransport"] = "livekit-pc-transport";
    LoggerNames["E2EE"] = "lk-e2ee";
})($d84dc1a5e217b32f$export$69ba24dd79f4da21 || ($d84dc1a5e217b32f$export$69ba24dd79f4da21 = {}));
let $d84dc1a5e217b32f$var$livekitLogger = $d84dc1a5e217b32f$var$loglevelExports.getLogger("livekit");
const $d84dc1a5e217b32f$var$livekitLoggers = Object.values($d84dc1a5e217b32f$export$69ba24dd79f4da21).map((name)=>$d84dc1a5e217b32f$var$loglevelExports.getLogger(name));
$d84dc1a5e217b32f$var$livekitLogger.setDefaultLevel($d84dc1a5e217b32f$export$243e62d78d3b544d.info);
/**
 * @internal
 */ function $d84dc1a5e217b32f$export$2b1d391cd05230fd(name) {
    const logger = $d84dc1a5e217b32f$var$loglevelExports.getLogger(name);
    logger.setDefaultLevel($d84dc1a5e217b32f$var$livekitLogger.getLevel());
    return logger;
}
function $d84dc1a5e217b32f$export$c622e99c0ce7b1c9(level, loggerName) {
    if (loggerName) $d84dc1a5e217b32f$var$loglevelExports.getLogger(loggerName).setLevel(level);
    else for (const logger of $d84dc1a5e217b32f$var$livekitLoggers)logger.setLevel(level);
}
/**
 * use this to hook into the logging function to allow sending internal livekit logs to third party services
 * if set, the browser logs will lose their stacktrace information (see https://github.com/pimterry/loglevel#writing-plugins)
 */ function $d84dc1a5e217b32f$export$fd7435ba5a9de34b(extension, logger) {
    const loggers = logger ? [
        logger
    ] : $d84dc1a5e217b32f$var$livekitLoggers;
    loggers.forEach((logR)=>{
        const originalFactory = logR.methodFactory;
        logR.methodFactory = (methodName, configLevel, loggerName)=>{
            const rawMethod = originalFactory(methodName, configLevel, loggerName);
            const logLevel = $d84dc1a5e217b32f$export$243e62d78d3b544d[methodName];
            const needLog = logLevel >= configLevel && logLevel < $d84dc1a5e217b32f$export$243e62d78d3b544d.silent;
            return (msg, context)=>{
                if (context) rawMethod(msg, context);
                else rawMethod(msg);
                if (needLog) extension(logLevel, msg, context);
            };
        };
        logR.setLevel(logR.getLevel());
    });
}
const $d84dc1a5e217b32f$var$workerLogger = $d84dc1a5e217b32f$var$loglevelExports.getLogger("lk-e2ee");
const $d84dc1a5e217b32f$var$maxRetryDelay = 7000;
const $d84dc1a5e217b32f$var$DEFAULT_RETRY_DELAYS_IN_MS = [
    0,
    300,
    1200,
    2700,
    4800,
    $d84dc1a5e217b32f$var$maxRetryDelay,
    $d84dc1a5e217b32f$var$maxRetryDelay,
    $d84dc1a5e217b32f$var$maxRetryDelay,
    $d84dc1a5e217b32f$var$maxRetryDelay,
    $d84dc1a5e217b32f$var$maxRetryDelay
];
class $d84dc1a5e217b32f$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays
        ] : $d84dc1a5e217b32f$var$DEFAULT_RETRY_DELAYS_IN_MS;
    }
    nextRetryDelayInMs(context) {
        if (context.retryCount >= this._retryDelays.length) return null;
        const retryDelay = this._retryDelays[context.retryCount];
        if (context.retryCount <= 1) return retryDelay;
        return retryDelay + Math.random() * 1000;
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $d84dc1a5e217b32f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d84dc1a5e217b32f$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d84dc1a5e217b32f$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d84dc1a5e217b32f$var$__values === "function" ? $d84dc1a5e217b32f$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
var $d84dc1a5e217b32f$var$events = {
    exports: {}
};
var $d84dc1a5e217b32f$var$hasRequiredEvents;
function $d84dc1a5e217b32f$var$requireEvents() {
    if ($d84dc1a5e217b32f$var$hasRequiredEvents) return $d84dc1a5e217b32f$var$events.exports;
    $d84dc1a5e217b32f$var$hasRequiredEvents = 1;
    var R = typeof Reflect === "object" ? Reflect : null;
    var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var ReflectOwnKeys;
    if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
    else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    $d84dc1a5e217b32f$var$events.exports = EventEmitter;
    $d84dc1a5e217b32f$var$events.exports.once = once;
    // Backwards-compat with node 0.10.x
    EventEmitter.EventEmitter = EventEmitter;
    EventEmitter.prototype._events = undefined;
    EventEmitter.prototype._eventsCount = 0;
    EventEmitter.prototype._maxListeners = undefined;
    // By default EventEmitters will print a warning if more than 10 listeners are
    // added to it. This is a useful default which helps finding memory leaks.
    var defaultMaxListeners = 10;
    function checkListener(listener) {
        if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty(EventEmitter, "defaultMaxListeners", {
        enumerable: true,
        get: function() {
            return defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
            defaultMaxListeners = arg;
        }
    });
    EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
        this._maxListeners = n;
        return this;
    };
    function _getMaxListeners(that) {
        if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    };
    EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === "error";
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === "function") ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = arrayClone(handler, len);
            for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            // To avoid recursion in the case that type === "newListener"! Before
            // adding it to the listeners, first emit "newListener".
            if (events.newListener !== undefined) {
                target.emit("newListener", type, listener.listener ? listener.listener : listener);
                // Re-assign `events` because a newListener handler could have caused the
                // this._events to be assigned to a new object
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            // Optimize the case of one listener. Don't need the extra array object.
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === "function") // Adding the second element, need to change to array.
            existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            // Check for listener leak
            m = _getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                // No error code for this since it is a Warning
                // eslint-disable-next-line no-restricted-syntax
                var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
                w.name = "MaxListenersExceededWarning";
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                ProcessEmitWarning(w);
            }
        }
        return target;
    }
    EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
    };
    EventEmitter.prototype.on = EventEmitter.prototype.addListener;
    EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
    };
    function onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function _onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
    };
    EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        checkListener(listener);
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
    };
    // Emits a 'removeListener' event if and only if the listener was removed.
    EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
            }
        } else if (typeof list !== "function") {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
        }
        return this;
    };
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        // not listening for removeListener, no need to emit
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === "removeListener") continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners("removeListener");
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === "function") this.removeListener(type, listeners);
        else if (listeners !== undefined) // LIFO order
        for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function _listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === "function") return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
    }
    EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
    };
    EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
    };
    EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
        else return listenerCount.call(emitter, type);
    };
    EventEmitter.prototype.listenerCount = listenerCount;
    function listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === "function") return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
    };
    function arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
                resolve([].slice.call(arguments));
            }
            eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
    }
    function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === "function") {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
        // EventEmitters, we do not listen for `error` events here.
        emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
    return $d84dc1a5e217b32f$var$events.exports;
}
var $d84dc1a5e217b32f$var$eventsExports = $d84dc1a5e217b32f$var$requireEvents();
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ let $d84dc1a5e217b32f$var$logDisabled_ = true;
let $d84dc1a5e217b32f$var$deprecationWarnings_ = true;
/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */ function $d84dc1a5e217b32f$var$extractVersion(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $d84dc1a5e217b32f$var$disableLog(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $d84dc1a5e217b32f$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
/**
 * Disable or enable deprecation warnings
 * @param {!boolean} bool set to true to disable warnings.
 */ function $d84dc1a5e217b32f$var$disableWarnings(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $d84dc1a5e217b32f$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $d84dc1a5e217b32f$var$log() {
    if (typeof window === "object") {
        if ($d84dc1a5e217b32f$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
/**
 * Shows a deprecation warning suggesting the modern and spec-compatible API.
 */ function $d84dc1a5e217b32f$var$deprecated(oldMethod, newMethod) {
    if (!$d84dc1a5e217b32f$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
/**
 * Browser detector.
 *
 * @return {object} result containing browser and version
 *     properties.
 */ function $d84dc1a5e217b32f$var$detectBrowser(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator1 } = window1;
    // Prefer navigator.userAgentData.
    if (navigator1.userAgentData && navigator1.userAgentData.brands) {
        const chromium = navigator1.userAgentData.brands.find((brand)=>{
            return brand.brand === "Chromium";
        });
        if (chromium) return {
            browser: "chrome",
            version: parseInt(chromium.version, 10)
        };
    }
    if (navigator1.mozGetUserMedia) {
        // Firefox.
        result.browser = "firefox";
        result.version = $d84dc1a5e217b32f$var$extractVersion(navigator1.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator1.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $d84dc1a5e217b32f$var$extractVersion(navigator1.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator1.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        // Safari.
        result.browser = "safari";
        result.version = $d84dc1a5e217b32f$var$extractVersion(navigator1.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        // Default fallthrough: not supported.
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $d84dc1a5e217b32f$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
/**
 * Remove all empty objects and undefined values
 * from a nested object -- an enhanced and vanilla version
 * of Lodash's `compact`.
 */ function $d84dc1a5e217b32f$var$compactObject(data) {
    if (!$d84dc1a5e217b32f$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $d84dc1a5e217b32f$var$isObject(data[key]);
        const value = isObj ? $d84dc1a5e217b32f$var$compactObject(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
/* iterates the stats graph recursively. */ function $d84dc1a5e217b32f$var$walkStats(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $d84dc1a5e217b32f$var$walkStats(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $d84dc1a5e217b32f$var$walkStats(stats, stats.get(id), resultSet);
        });
    });
}
/* filter getStats for a sender/receiver track. */ function $d84dc1a5e217b32f$var$filterStats(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $d84dc1a5e217b32f$var$walkStats(result, stats, filteredResult);
        });
    });
    return filteredResult;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ const $d84dc1a5e217b32f$var$logging = $d84dc1a5e217b32f$var$log;
function $d84dc1a5e217b32f$var$shimGetUserMedia$2(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    if (!navigator1.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator1.mediaDevices.getSupportedConstraints && navigator1.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator1.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $d84dc1a5e217b32f$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $d84dc1a5e217b32f$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator1.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator1.getUserMedia = getUserMedia_.bind(navigator1);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator1.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $d84dc1a5e217b32f$var$shimMediaStream(window1) {
    window1.MediaStream = window1.MediaStream || window1.webkitMediaStream;
}
function $d84dc1a5e217b32f$var$shimOnTrack$1(window1) {
    if (typeof window1 === "object" && window1.RTCPeerConnection && !("ontrack" in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window1.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $d84dc1a5e217b32f$var$shimGetSendersWithDtmf(window1) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window1 === "object" && window1.RTCPeerConnection && !("getSenders" in window1.RTCPeerConnection.prototype) && "createDTMFSender" in window1.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window1.RTCPeerConnection.prototype.getSenders) {
            window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
            window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
            window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window1.RTCPeerConnection.prototype.addStream;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
        window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) // remove sender
                this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window1 === "object" && window1.RTCPeerConnection && "getSenders" in window1.RTCPeerConnection.prototype && "createDTMFSender" in window1.RTCPeerConnection.prototype && window1.RTCRtpSender && !("dtmf" in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window1.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $d84dc1a5e217b32f$var$shimSenderReceiverGetStats(window1) {
    if (!(typeof window1 === "object" && window1.RTCPeerConnection && window1.RTCRtpSender && window1.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window1.RTCRtpSender.prototype)) {
        const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window1.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
       *   send a track with the same id as sender.track as
       *   it is not possible to identify the RTCRtpSender.
       */ $d84dc1a5e217b32f$var$filterStats(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window1.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window1.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$d84dc1a5e217b32f$var$filterStats(result, receiver.track, false));
        };
    }
    if (!("getStats" in window1.RTCRtpSender.prototype && "getStats" in window1.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window1.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimAddTrackRemoveTrackWithNative(window1) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window1.RTCPeerConnection.prototype.removeTrack;
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimAddTrackRemoveTrack(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window1.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $d84dc1a5e217b32f$var$shimAddTrackRemoveTrackWithNative(window1);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window1.RTCPeerConnection.prototype.getLocalStreams;
    window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window1.RTCPeerConnection.prototype.addStream;
    window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window1.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window1.RTCPeerConnection.prototype.removeStream;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window1.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window1.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window1.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window1.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window1.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $d84dc1a5e217b32f$var$shimPeerConnection$1(window1, browserDetails) {
    if (!window1.RTCPeerConnection && window1.webkitRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.webkitRTCPeerConnection;
    if (!window1.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
// Attempt to fix ONN in plan-b mode.
function $d84dc1a5e217b32f$var$fixNegotiationNeeded(window1, browserDetails) {
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}
var $d84dc1a5e217b32f$var$chromeShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    fixNegotiationNeeded: $d84dc1a5e217b32f$var$fixNegotiationNeeded,
    shimAddTrackRemoveTrack: $d84dc1a5e217b32f$var$shimAddTrackRemoveTrack,
    shimAddTrackRemoveTrackWithNative: $d84dc1a5e217b32f$var$shimAddTrackRemoveTrackWithNative,
    shimGetSendersWithDtmf: $d84dc1a5e217b32f$var$shimGetSendersWithDtmf,
    shimGetUserMedia: $d84dc1a5e217b32f$var$shimGetUserMedia$2,
    shimMediaStream: $d84dc1a5e217b32f$var$shimMediaStream,
    shimOnTrack: $d84dc1a5e217b32f$var$shimOnTrack$1,
    shimPeerConnection: $d84dc1a5e217b32f$var$shimPeerConnection$1,
    shimSenderReceiverGetStats: $d84dc1a5e217b32f$var$shimSenderReceiverGetStats
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $d84dc1a5e217b32f$var$shimGetUserMedia$1(window1, browserDetails) {
    const navigator1 = window1 && window1.navigator;
    const MediaStreamTrack1 = window1 && window1.MediaStreamTrack;
    navigator1.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $d84dc1a5e217b32f$var$deprecated("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator1.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator1.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator1.mediaDevices.getUserMedia.bind(navigator1.mediaDevices);
        navigator1.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack1.prototype.getSettings;
            MediaStreamTrack1.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack1 && MediaStreamTrack1.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack1.prototype.applyConstraints;
            MediaStreamTrack1.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $d84dc1a5e217b32f$var$shimGetDisplayMedia(window1, preferredMediaSource) {
    if (window1.navigator.mediaDevices && "getDisplayMedia" in window1.navigator.mediaDevices) return;
    if (!window1.navigator.mediaDevices) return;
    window1.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window1.navigator.mediaDevices.getUserMedia(constraints);
    };
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $d84dc1a5e217b32f$var$shimOnTrack(window1) {
    if (typeof window1 === "object" && window1.RTCTrackEvent && "receiver" in window1.RTCTrackEvent.prototype && !("transceiver" in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $d84dc1a5e217b32f$var$shimPeerConnection(window1, browserDetails) {
    if (typeof window1 !== "object" || !(window1.RTCPeerConnection || window1.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window1.RTCPeerConnection && window1.mozRTCPeerConnection) // very basic support for old versions.
    window1.RTCPeerConnection = window1.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window1.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window1.RTCIceCandidate : window1.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window1.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window1.RTCPeerConnection.prototype.getStats;
    window1.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $d84dc1a5e217b32f$var$shimSenderGetStats(window1) {
    if (!(typeof window1 === "object" && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && "getStats" in window1.RTCRtpSender.prototype) return;
    const origGetSenders = window1.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window1.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window1.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window1.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window1.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $d84dc1a5e217b32f$var$shimReceiverGetStats(window1) {
    if (!(typeof window1 === "object" && window1.RTCPeerConnection && window1.RTCRtpSender)) return;
    if (window1.RTCRtpSender && "getStats" in window1.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window1.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window1.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window1.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $d84dc1a5e217b32f$var$shimRemoveStream(window1) {
    if (!window1.RTCPeerConnection || "removeStream" in window1.RTCPeerConnection.prototype) return;
    window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $d84dc1a5e217b32f$var$deprecated("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $d84dc1a5e217b32f$var$shimRTCDataChannel(window1) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window1.DataChannel && !window1.RTCDataChannel) window1.RTCDataChannel = window1.DataChannel;
}
function $d84dc1a5e217b32f$var$shimAddTransceiver(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === "object" && window1.RTCPeerConnection)) return;
    const origAddTransceiver = window1.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window1.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $d84dc1a5e217b32f$var$shimGetParameters(window1) {
    if (!(typeof window1 === "object" && window1.RTCRtpSender)) return;
    const origGetParameters = window1.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window1.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $d84dc1a5e217b32f$var$shimCreateOffer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === "object" && window1.RTCPeerConnection)) return;
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimCreateAnswer(window1) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window1 === "object" && window1.RTCPeerConnection)) return;
    const origCreateAnswer = window1.RTCPeerConnection.prototype.createAnswer;
    window1.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}
var $d84dc1a5e217b32f$var$firefoxShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAddTransceiver: $d84dc1a5e217b32f$var$shimAddTransceiver,
    shimCreateAnswer: $d84dc1a5e217b32f$var$shimCreateAnswer,
    shimCreateOffer: $d84dc1a5e217b32f$var$shimCreateOffer,
    shimGetDisplayMedia: $d84dc1a5e217b32f$var$shimGetDisplayMedia,
    shimGetParameters: $d84dc1a5e217b32f$var$shimGetParameters,
    shimGetUserMedia: $d84dc1a5e217b32f$var$shimGetUserMedia$1,
    shimOnTrack: $d84dc1a5e217b32f$var$shimOnTrack,
    shimPeerConnection: $d84dc1a5e217b32f$var$shimPeerConnection,
    shimRTCDataChannel: $d84dc1a5e217b32f$var$shimRTCDataChannel,
    shimReceiverGetStats: $d84dc1a5e217b32f$var$shimReceiverGetStats,
    shimRemoveStream: $d84dc1a5e217b32f$var$shimRemoveStream,
    shimSenderGetStats: $d84dc1a5e217b32f$var$shimSenderGetStats
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ function $d84dc1a5e217b32f$var$shimLocalStreamsAPI(window1) {
    if (typeof window1 !== "object" || !window1.RTCPeerConnection) return;
    if (!("getLocalStreams" in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window1.RTCPeerConnection.prototype)) {
        const _addTrack = window1.RTCPeerConnection.prototype.addTrack;
        window1.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window1.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
            for(var _len = arguments.length, streams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)streams[_key - 1] = arguments[_key];
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $d84dc1a5e217b32f$var$shimRemoteStreamsAPI(window1) {
    if (typeof window1 !== "object" || !window1.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window1.RTCPeerConnection.prototype)) window1.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window1.RTCPeerConnection.prototype)) {
        Object.defineProperty(window1.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
        window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $d84dc1a5e217b32f$var$shimCallbacksAPI(window1) {
    if (typeof window1 !== "object" || !window1.RTCPeerConnection) return;
    const prototype = window1.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $d84dc1a5e217b32f$var$shimGetUserMedia(window1) {
    const navigator1 = window1 && window1.navigator;
    if (navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator1.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator1.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($d84dc1a5e217b32f$var$shimConstraints(constraints));
        };
    }
    if (!navigator1.getUserMedia && navigator1.mediaDevices && navigator1.mediaDevices.getUserMedia) navigator1.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator1.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator1);
}
function $d84dc1a5e217b32f$var$shimConstraints(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $d84dc1a5e217b32f$var$compactObject(constraints.video)
    });
    return constraints;
}
function $d84dc1a5e217b32f$var$shimRTCIceServerUrls(window1) {
    if (!window1.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window1.RTCPeerConnection;
    window1.RTCPeerConnection = function RTCPeerConnection1(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $d84dc1a5e217b32f$var$deprecated("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window1.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window1.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $d84dc1a5e217b32f$var$shimTrackEventTransceiver(window1) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window1 === "object" && window1.RTCTrackEvent && "receiver" in window1.RTCTrackEvent.prototype && !("transceiver" in window1.RTCTrackEvent.prototype)) Object.defineProperty(window1.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $d84dc1a5e217b32f$var$shimCreateOfferLegacy(window1) {
    const origCreateOffer = window1.RTCPeerConnection.prototype.createOffer;
    window1.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio", {
                direction: "recvonly"
            });
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video", {
                direction: "recvonly"
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimAudioContext(window1) {
    if (typeof window1 !== "object" || window1.AudioContext) return;
    window1.AudioContext = window1.webkitAudioContext;
}
var $d84dc1a5e217b32f$var$safariShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    shimAudioContext: $d84dc1a5e217b32f$var$shimAudioContext,
    shimCallbacksAPI: $d84dc1a5e217b32f$var$shimCallbacksAPI,
    shimConstraints: $d84dc1a5e217b32f$var$shimConstraints,
    shimCreateOfferLegacy: $d84dc1a5e217b32f$var$shimCreateOfferLegacy,
    shimGetUserMedia: $d84dc1a5e217b32f$var$shimGetUserMedia,
    shimLocalStreamsAPI: $d84dc1a5e217b32f$var$shimLocalStreamsAPI,
    shimRTCIceServerUrls: $d84dc1a5e217b32f$var$shimRTCIceServerUrls,
    shimRemoteStreamsAPI: $d84dc1a5e217b32f$var$shimRemoteStreamsAPI,
    shimTrackEventTransceiver: $d84dc1a5e217b32f$var$shimTrackEventTransceiver
});
var $d84dc1a5e217b32f$var$sdp$1 = {
    exports: {}
};
/* eslint-env node */ var $d84dc1a5e217b32f$var$hasRequiredSdp;
function $d84dc1a5e217b32f$var$requireSdp() {
    if ($d84dc1a5e217b32f$var$hasRequiredSdp) return $d84dc1a5e217b32f$var$sdp$1.exports;
    $d84dc1a5e217b32f$var$hasRequiredSdp = 1;
    (function(module) {
        // SDP helpers.
        const SDPUtils = {};
        // Generate an alphanumeric identifier for cname or mids.
        // TODO: use UUIDs instead? https://gist.github.com/jed/982883
        SDPUtils.generateIdentifier = function() {
            return Math.random().toString(36).substring(2, 12);
        };
        // The RTCP CNAME used by all peerconnections from the same JS.
        SDPUtils.localCName = SDPUtils.generateIdentifier();
        // Splits SDP into lines, dealing with both CRLF and LF.
        SDPUtils.splitLines = function(blob) {
            return blob.trim().split("\n").map((line)=>line.trim());
        };
        // Splits SDP into sessionpart and mediasections. Ensures CRLF.
        SDPUtils.splitSections = function(blob) {
            const parts = blob.split("\nm=");
            return parts.map((part, index)=>(index > 0 ? "m=" + part : part).trim() + "\r\n");
        };
        // Returns the session description.
        SDPUtils.getDescription = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            return sections && sections[0];
        };
        // Returns the individual media sections.
        SDPUtils.getMediaSections = function(blob) {
            const sections = SDPUtils.splitSections(blob);
            sections.shift();
            return sections;
        };
        // Returns lines that start with a certain prefix.
        SDPUtils.matchPrefix = function(blob, prefix) {
            return SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
        };
        // Parses an ICE candidate line. Sample input:
        // candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
        // rport 55996"
        // Input can be prefixed with a=.
        SDPUtils.parseCandidate = function(line) {
            let parts;
            // Parse both variants.
            if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
            else parts = line.substring(10).split(" ");
            const candidate = {
                foundation: parts[0],
                component: {
                    1: "rtp",
                    2: "rtcp"
                }[parts[1]] || parts[1],
                protocol: parts[2].toLowerCase(),
                priority: parseInt(parts[3], 10),
                ip: parts[4],
                address: parts[4],
                // address is an alias for ip.
                port: parseInt(parts[5], 10),
                // skip parts[6] == 'typ'
                type: parts[7]
            };
            for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
                case "raddr":
                    candidate.relatedAddress = parts[i + 1];
                    break;
                case "rport":
                    candidate.relatedPort = parseInt(parts[i + 1], 10);
                    break;
                case "tcptype":
                    candidate.tcpType = parts[i + 1];
                    break;
                case "ufrag":
                    candidate.ufrag = parts[i + 1]; // for backward compatibility.
                    candidate.usernameFragment = parts[i + 1];
                    break;
                default:
                    // extension handling, in particular ufrag. Don't overwrite.
                    if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
                    break;
            }
            return candidate;
        };
        // Translates a candidate object into SDP candidate attribute.
        // This does not include the a= prefix!
        SDPUtils.writeCandidate = function(candidate) {
            const sdp = [];
            sdp.push(candidate.foundation);
            const component = candidate.component;
            if (component === "rtp") sdp.push(1);
            else if (component === "rtcp") sdp.push(2);
            else sdp.push(component);
            sdp.push(candidate.protocol.toUpperCase());
            sdp.push(candidate.priority);
            sdp.push(candidate.address || candidate.ip);
            sdp.push(candidate.port);
            const type = candidate.type;
            sdp.push("typ");
            sdp.push(type);
            if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
                sdp.push("raddr");
                sdp.push(candidate.relatedAddress);
                sdp.push("rport");
                sdp.push(candidate.relatedPort);
            }
            if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
                sdp.push("tcptype");
                sdp.push(candidate.tcpType);
            }
            if (candidate.usernameFragment || candidate.ufrag) {
                sdp.push("ufrag");
                sdp.push(candidate.usernameFragment || candidate.ufrag);
            }
            return "candidate:" + sdp.join(" ");
        };
        // Parses an ice-options line, returns an array of option tags.
        // Sample input:
        // a=ice-options:foo bar
        SDPUtils.parseIceOptions = function(line) {
            return line.substring(14).split(" ");
        };
        // Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
        // a=rtpmap:111 opus/48000/2
        SDPUtils.parseRtpMap = function(line) {
            let parts = line.substring(9).split(" ");
            const parsed = {
                payloadType: parseInt(parts.shift(), 10) // was: id
            };
            parts = parts[0].split("/");
            parsed.name = parts[0];
            parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
            parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
            // legacy alias, got renamed back to channels in ORTC.
            parsed.numChannels = parsed.channels;
            return parsed;
        };
        // Generates a rtpmap line from RTCRtpCodecCapability or
        // RTCRtpCodecParameters.
        SDPUtils.writeRtpMap = function(codec) {
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            const channels = codec.channels || codec.numChannels || 1;
            return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
        };
        // Parses a extmap line (headerextension from RFC 5285). Sample input:
        // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
        // a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
        SDPUtils.parseExtmap = function(line) {
            const parts = line.substring(9).split(" ");
            return {
                id: parseInt(parts[0], 10),
                direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
                uri: parts[1],
                attributes: parts.slice(2).join(" ")
            };
        };
        // Generates an extmap line from RTCRtpHeaderExtensionParameters or
        // RTCRtpHeaderExtension.
        SDPUtils.writeExtmap = function(headerExtension) {
            return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
        };
        // Parses a fmtp line, returns dictionary. Sample input:
        // a=fmtp:96 vbr=on;cng=on
        // Also deals with vbr=on; cng=on
        SDPUtils.parseFmtp = function(line) {
            const parsed = {};
            let kv;
            const parts = line.substring(line.indexOf(" ") + 1).split(";");
            for(let j = 0; j < parts.length; j++){
                kv = parts[j].trim().split("=");
                parsed[kv[0].trim()] = kv[1];
            }
            return parsed;
        };
        // Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeFmtp = function(codec) {
            let line = "";
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.parameters && Object.keys(codec.parameters).length) {
                const params = [];
                Object.keys(codec.parameters).forEach((param)=>{
                    if (codec.parameters[param] !== undefined) params.push(param + "=" + codec.parameters[param]);
                    else params.push(param);
                });
                line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
            }
            return line;
        };
        // Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
        // a=rtcp-fb:98 nack rpsi
        SDPUtils.parseRtcpFb = function(line) {
            const parts = line.substring(line.indexOf(" ") + 1).split(" ");
            return {
                type: parts.shift(),
                parameter: parts.join(" ")
            };
        };
        // Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
        SDPUtils.writeRtcpFb = function(codec) {
            let lines = "";
            let pt = codec.payloadType;
            if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
            if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
            codec.rtcpFeedback.forEach((fb)=>{
                lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
            });
            return lines;
        };
        // Parses a RFC 5576 ssrc media attribute. Sample input:
        // a=ssrc:3735928559 cname:something
        SDPUtils.parseSsrcMedia = function(line) {
            const sp = line.indexOf(" ");
            const parts = {
                ssrc: parseInt(line.substring(7, sp), 10)
            };
            const colon = line.indexOf(":", sp);
            if (colon > -1) {
                parts.attribute = line.substring(sp + 1, colon);
                parts.value = line.substring(colon + 1);
            } else parts.attribute = line.substring(sp + 1);
            return parts;
        };
        // Parse a ssrc-group line (see RFC 5576). Sample input:
        // a=ssrc-group:semantics 12 34
        SDPUtils.parseSsrcGroup = function(line) {
            const parts = line.substring(13).split(" ");
            return {
                semantics: parts.shift(),
                ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
            };
        };
        // Extracts the MID (RFC 5888) from a media section.
        // Returns the MID or undefined if no mid line was found.
        SDPUtils.getMid = function(mediaSection) {
            const mid = SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
            if (mid) return mid.substring(6);
        };
        // Parses a fingerprint line for DTLS-SRTP.
        SDPUtils.parseFingerprint = function(line) {
            const parts = line.substring(14).split(" ");
            return {
                algorithm: parts[0].toLowerCase(),
                // algorithm is case-sensitive in Edge.
                value: parts[1].toUpperCase() // the definition is upper-case in RFC 4572.
            };
        };
        // Extracts DTLS parameters from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the fingerprint line as input. See also getIceParameters.
        SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
            // Note: a=setup line is ignored since we use the 'auto' role in Edge.
            return {
                role: "auto",
                fingerprints: lines.map(SDPUtils.parseFingerprint)
            };
        };
        // Serializes DTLS parameters to SDP.
        SDPUtils.writeDtlsParameters = function(params, setupType) {
            let sdp = "a=setup:" + setupType + "\r\n";
            params.fingerprints.forEach((fp)=>{
                sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
            });
            return sdp;
        };
        // Parses a=crypto lines into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
        SDPUtils.parseCryptoLine = function(line) {
            const parts = line.substring(9).split(" ");
            return {
                tag: parseInt(parts[0], 10),
                cryptoSuite: parts[1],
                keyParams: parts[2],
                sessionParams: parts.slice(3)
            };
        };
        SDPUtils.writeCryptoLine = function(parameters) {
            return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
        };
        // Parses the crypto key parameters into
        //   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
        SDPUtils.parseCryptoKeyParams = function(keyParams) {
            if (keyParams.indexOf("inline:") !== 0) return null;
            const parts = keyParams.substring(7).split("|");
            return {
                keyMethod: "inline",
                keySalt: parts[0],
                lifeTime: parts[1],
                mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
                mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
            };
        };
        SDPUtils.writeCryptoKeyParams = function(keyParams) {
            return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
        };
        // Extracts all SDES parameters.
        SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
            const lines = SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
            return lines.map(SDPUtils.parseCryptoLine);
        };
        // Parses ICE information from SDP media section or sessionpart.
        // FIXME: for consistency with other functions this should only
        //   get the ice-ufrag and ice-pwd lines as input.
        SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
            const ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
            const pwd = SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
            if (!(ufrag && pwd)) return null;
            return {
                usernameFragment: ufrag.substring(12),
                password: pwd.substring(10)
            };
        };
        // Serializes ICE parameters to SDP.
        SDPUtils.writeIceParameters = function(params) {
            let sdp = "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
            if (params.iceLite) sdp += "a=ice-lite\r\n";
            return sdp;
        };
        // Parses the SDP media section and returns RTCRtpParameters.
        SDPUtils.parseRtpParameters = function(mediaSection) {
            const description = {
                codecs: [],
                headerExtensions: [],
                fecMechanisms: [],
                rtcp: []
            };
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(" ");
            description.profile = mline[2];
            for(let i = 3; i < mline.length; i++){
                // find all codecs from mline[3..]
                const pt = mline[i];
                const rtpmapline = SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
                if (rtpmapline) {
                    const codec = SDPUtils.parseRtpMap(rtpmapline);
                    const fmtps = SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
                    // Only the first a=fmtp:<pt> is considered.
                    codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
                    codec.rtcpFeedback = SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map(SDPUtils.parseRtcpFb);
                    description.codecs.push(codec);
                    // parse FEC mechanisms from rtpmap lines.
                    switch(codec.name.toUpperCase()){
                        case "RED":
                        case "ULPFEC":
                            description.fecMechanisms.push(codec.name.toUpperCase());
                            break;
                    }
                }
            }
            SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach((line)=>{
                description.headerExtensions.push(SDPUtils.parseExtmap(line));
            });
            const wildcardRtcpFb = SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:* ").map(SDPUtils.parseRtcpFb);
            description.codecs.forEach((codec)=>{
                wildcardRtcpFb.forEach((fb)=>{
                    const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                        return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
                    });
                    if (!duplicate) codec.rtcpFeedback.push(fb);
                });
            });
            // FIXME: parse rtcp.
            return description;
        };
        // Generates parts of the SDP media section describing the capabilities /
        // parameters.
        SDPUtils.writeRtpDescription = function(kind, caps) {
            let sdp = "";
            // Build the mline.
            sdp += "m=" + kind + " ";
            sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
            sdp += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
            sdp += caps.codecs.map((codec)=>{
                if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
                return codec.payloadType;
            }).join(" ") + "\r\n";
            sdp += "c=IN IP4 0.0.0.0\r\n";
            sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
            // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
            caps.codecs.forEach((codec)=>{
                sdp += SDPUtils.writeRtpMap(codec);
                sdp += SDPUtils.writeFmtp(codec);
                sdp += SDPUtils.writeRtcpFb(codec);
            });
            let maxptime = 0;
            caps.codecs.forEach((codec)=>{
                if (codec.maxptime > maxptime) maxptime = codec.maxptime;
            });
            if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
            if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
                sdp += SDPUtils.writeExtmap(extension);
            });
            // FIXME: write fecMechanisms.
            return sdp;
        };
        // Parses the SDP media section and returns an array of
        // RTCRtpEncodingParameters.
        SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
            const encodingParameters = [];
            const description = SDPUtils.parseRtpParameters(mediaSection);
            const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
            const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
            // filter a=ssrc:... cname:, ignore PlanB-msid
            const ssrcs = SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === "cname");
            const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
            let secondarySsrc;
            const flows = SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line)=>{
                const parts = line.substring(17).split(" ");
                return parts.map((part)=>parseInt(part, 10));
            });
            if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
            description.codecs.forEach((codec)=>{
                if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
                    let encParam = {
                        ssrc: primarySsrc,
                        codecPayloadType: parseInt(codec.parameters.apt, 10)
                    };
                    if (primarySsrc && secondarySsrc) encParam.rtx = {
                        ssrc: secondarySsrc
                    };
                    encodingParameters.push(encParam);
                    if (hasRed) {
                        encParam = JSON.parse(JSON.stringify(encParam));
                        encParam.fec = {
                            ssrc: primarySsrc,
                            mechanism: hasUlpfec ? "red+ulpfec" : "red"
                        };
                        encodingParameters.push(encParam);
                    }
                }
            });
            if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
                ssrc: primarySsrc
            });
            // we support both b=AS and b=TIAS but interpret AS as TIAS.
            let bandwidth = SDPUtils.matchPrefix(mediaSection, "b=");
            if (bandwidth.length) {
                if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
                else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
                bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
                else bandwidth = undefined;
                encodingParameters.forEach((params)=>{
                    params.maxBitrate = bandwidth;
                });
            }
            return encodingParameters;
        };
        // parses http://draft.ortc.org/#rtcrtcpparameters*
        SDPUtils.parseRtcpParameters = function(mediaSection) {
            const rtcpParameters = {};
            // Gets the first SSRC. Note that with RTX there might be multiple
            // SSRCs.
            const remoteSsrc = SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === "cname")[0];
            if (remoteSsrc) {
                rtcpParameters.cname = remoteSsrc.value;
                rtcpParameters.ssrc = remoteSsrc.ssrc;
            }
            // Edge uses the compound attribute instead of reducedSize
            // compound is !reducedSize
            const rsize = SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
            rtcpParameters.reducedSize = rsize.length > 0;
            rtcpParameters.compound = rsize.length === 0;
            // parses the rtcp-mux attrіbute.
            // Note that Edge does not support unmuxed RTCP.
            const mux = SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
            rtcpParameters.mux = mux.length > 0;
            return rtcpParameters;
        };
        SDPUtils.writeRtcpParameters = function(rtcpParameters) {
            let sdp = "";
            if (rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
            if (rtcpParameters.mux) sdp += "a=rtcp-mux\r\n";
            if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
            return sdp;
        };
        // parses either a=msid: or a=ssrc:... msid lines and returns
        // the id of the MediaStream and MediaStreamTrack.
        SDPUtils.parseMsid = function(mediaSection) {
            let parts;
            const spec = SDPUtils.matchPrefix(mediaSection, "a=msid:");
            if (spec.length === 1) {
                parts = spec[0].substring(7).split(" ");
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
            const planB = SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === "msid");
            if (planB.length > 0) {
                parts = planB[0].value.split(" ");
                return {
                    stream: parts[0],
                    track: parts[1]
                };
            }
        };
        // SCTP
        // parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
        // to draft-ietf-mmusic-sctp-sdp-05
        SDPUtils.parseSctpDescription = function(mediaSection) {
            const mline = SDPUtils.parseMLine(mediaSection);
            const maxSizeLine = SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
            let maxMessageSize;
            if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
            if (isNaN(maxMessageSize)) maxMessageSize = 65536;
            const sctpPort = SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
            if (sctpPort.length > 0) return {
                port: parseInt(sctpPort[0].substring(12), 10),
                protocol: mline.fmt,
                maxMessageSize: maxMessageSize
            };
            const sctpMapLines = SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
            if (sctpMapLines.length > 0) {
                const parts = sctpMapLines[0].substring(10).split(" ");
                return {
                    port: parseInt(parts[0], 10),
                    protocol: parts[1],
                    maxMessageSize: maxMessageSize
                };
            }
        };
        // SCTP
        // outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
        // support by now receiving in this format, unless we originally parsed
        // as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
        // protocol of DTLS/SCTP -- without UDP/ or TCP/)
        SDPUtils.writeSctpDescription = function(media, sctp) {
            let output = [];
            if (media.protocol !== "DTLS/SCTP") output = [
                "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
                "c=IN IP4 0.0.0.0\r\n",
                "a=sctp-port:" + sctp.port + "\r\n"
            ];
            else output = [
                "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
                "c=IN IP4 0.0.0.0\r\n",
                "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
            ];
            if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
            return output.join("");
        };
        // Generate a session ID for SDP.
        // https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
        // recommends using a cryptographically random +ve 64-bit value
        // but right now this should be acceptable and within the right range
        SDPUtils.generateSessionId = function() {
            return Math.random().toString().substr(2, 22);
        };
        // Write boiler plate for start of SDP
        // sessId argument is optional - if not supplied it will
        // be generated randomly
        // sessVersion is optional and defaults to 2
        // sessUser is optional and defaults to 'thisisadapterortc'
        SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
            let sessionId;
            const version = sessVer !== undefined ? sessVer : 2;
            if (sessId) sessionId = sessId;
            else sessionId = SDPUtils.generateSessionId();
            const user = sessUser || "thisisadapterortc";
            // FIXME: sess-id should be an NTP timestamp.
            return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
        };
        // Gets the direction from the mediaSection or the sessionpart.
        SDPUtils.getDirection = function(mediaSection, sessionpart) {
            // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
            const lines = SDPUtils.splitLines(mediaSection);
            for(let i = 0; i < lines.length; i++)switch(lines[i]){
                case "a=sendrecv":
                case "a=sendonly":
                case "a=recvonly":
                case "a=inactive":
                    return lines[i].substring(2);
            }
            if (sessionpart) return SDPUtils.getDirection(sessionpart);
            return "sendrecv";
        };
        SDPUtils.getKind = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const mline = lines[0].split(" ");
            return mline[0].substring(2);
        };
        SDPUtils.isRejected = function(mediaSection) {
            return mediaSection.split(" ", 2)[1] === "0";
        };
        SDPUtils.parseMLine = function(mediaSection) {
            const lines = SDPUtils.splitLines(mediaSection);
            const parts = lines[0].substring(2).split(" ");
            return {
                kind: parts[0],
                port: parseInt(parts[1], 10),
                protocol: parts[2],
                fmt: parts.slice(3).join(" ")
            };
        };
        SDPUtils.parseOLine = function(mediaSection) {
            const line = SDPUtils.matchPrefix(mediaSection, "o=")[0];
            const parts = line.substring(2).split(" ");
            return {
                username: parts[0],
                sessionId: parts[1],
                sessionVersion: parseInt(parts[2], 10),
                netType: parts[3],
                addressType: parts[4],
                address: parts[5]
            };
        };
        // a very naive interpretation of a valid SDP.
        SDPUtils.isValidSDP = function(blob) {
            if (typeof blob !== "string" || blob.length === 0) return false;
            const lines = SDPUtils.splitLines(blob);
            for(let i = 0; i < lines.length; i++){
                if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
            // TODO: check the modifier a bit more.
            }
            return true;
        };
        module.exports = SDPUtils;
    })($d84dc1a5e217b32f$var$sdp$1);
    return $d84dc1a5e217b32f$var$sdp$1.exports;
}
var $d84dc1a5e217b32f$var$sdpExports = $d84dc1a5e217b32f$var$requireSdp();
var $d84dc1a5e217b32f$var$SDPUtils = /*@__PURE__*/ $d84dc1a5e217b32f$var$getDefaultExportFromCjs($d84dc1a5e217b32f$var$sdpExports);
var $d84dc1a5e217b32f$var$sdp = /*#__PURE__*/ $d84dc1a5e217b32f$var$_mergeNamespaces({
    __proto__: null,
    default: $d84dc1a5e217b32f$var$SDPUtils
}, [
    $d84dc1a5e217b32f$var$sdpExports
]);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ function $d84dc1a5e217b32f$var$shimRTCIceCandidate(window1) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && "foundation" in window1.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window1.RTCIceCandidate;
    window1.RTCIceCandidate = function RTCIceCandidate1(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = $d84dc1a5e217b32f$var$SDPUtils.parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window1.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window1.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $d84dc1a5e217b32f$var$shimRTCIceCandidateRelayProtocol(window1) {
    if (!window1.RTCIceCandidate || window1.RTCIceCandidate && "relayProtocol" in window1.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "icecandidate", (e)=>{
        if (e.candidate) {
            const parsedCandidate = $d84dc1a5e217b32f$var$SDPUtils.parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === "relay") // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: "tls",
                1: "tcp",
                2: "udp"
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $d84dc1a5e217b32f$var$shimMaxMessageSize(window1, browserDetails) {
    if (!window1.RTCPeerConnection) return;
    if (!("sctp" in window1.RTCPeerConnection.prototype)) Object.defineProperty(window1.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = $d84dc1a5e217b32f$var$SDPUtils.splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = $d84dc1a5e217b32f$var$SDPUtils.parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = $d84dc1a5e217b32f$var$SDPUtils.matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimSendThrowTypeError(window1) {
    if (!(window1.RTCPeerConnection && "createDataChannel" in window1.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window1.RTCPeerConnection.prototype.createDataChannel;
    window1.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $d84dc1a5e217b32f$var$wrapPeerConnectionEvent(window1, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
/* shims RTCConnectionState by pretending it is the same as iceConnectionState.
 * See https://bugs.chromium.org/p/webrtc/issues/detail?id=6145#c12
 * for why this is a valid hack in Chrome. In Firefox it is slightly incorrect
 * since DTLS failures would be hidden. See
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1265827
 * for the Firefox tracking bug.
 */ function $d84dc1a5e217b32f$var$shimConnectionState(window1) {
    if (!window1.RTCPeerConnection || "connectionState" in window1.RTCPeerConnection.prototype) return;
    const proto = window1.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $d84dc1a5e217b32f$var$removeExtmapAllowMixed(window1, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window1.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window1.RTCPeerConnection.prototype.setRemoteDescription;
    window1.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window1.RTCSessionDescription && desc instanceof window1.RTCSessionDescription) arguments[0] = new window1.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $d84dc1a5e217b32f$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window1.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window1.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
// Note: Make sure to call this ahead of APIs that modify
// setLocalDescription.length
function $d84dc1a5e217b32f$var$shimParameterlessSetLocalDescription(window1, browserDetails) {
    if (!(window1.RTCPeerConnection && window1.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window1.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window1.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== "object" || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case "stable":
            case "have-local-offer":
            case "have-remote-pranswer":
                desc.type = "offer";
                break;
            default:
                desc.type = "answer";
                break;
        }
        if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}
var $d84dc1a5e217b32f$var$commonShim = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    removeExtmapAllowMixed: $d84dc1a5e217b32f$var$removeExtmapAllowMixed,
    shimAddIceCandidateNullOrEmpty: $d84dc1a5e217b32f$var$shimAddIceCandidateNullOrEmpty,
    shimConnectionState: $d84dc1a5e217b32f$var$shimConnectionState,
    shimMaxMessageSize: $d84dc1a5e217b32f$var$shimMaxMessageSize,
    shimParameterlessSetLocalDescription: $d84dc1a5e217b32f$var$shimParameterlessSetLocalDescription,
    shimRTCIceCandidate: $d84dc1a5e217b32f$var$shimRTCIceCandidate,
    shimRTCIceCandidateRelayProtocol: $d84dc1a5e217b32f$var$shimRTCIceCandidateRelayProtocol,
    shimSendThrowTypeError: $d84dc1a5e217b32f$var$shimSendThrowTypeError
});
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ // Shimming starts here.
function $d84dc1a5e217b32f$var$adapterFactory() {
    let { window: window1 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shimChrome: true,
        shimFirefox: true,
        shimSafari: true
    };
    // Utils.
    const logging = $d84dc1a5e217b32f$var$log;
    const browserDetails = $d84dc1a5e217b32f$var$detectBrowser(window1);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $d84dc1a5e217b32f$var$commonShim,
        extractVersion: $d84dc1a5e217b32f$var$extractVersion,
        disableLog: $d84dc1a5e217b32f$var$disableLog,
        disableWarnings: $d84dc1a5e217b32f$var$disableWarnings,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $d84dc1a5e217b32f$var$sdp
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$d84dc1a5e217b32f$var$chromeShim || !$d84dc1a5e217b32f$var$shimPeerConnection$1 || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $d84dc1a5e217b32f$var$chromeShim;
            // Must be called before shimPeerConnection.
            $d84dc1a5e217b32f$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimParameterlessSetLocalDescription(window1);
            $d84dc1a5e217b32f$var$shimGetUserMedia$2(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimMediaStream(window1);
            $d84dc1a5e217b32f$var$shimPeerConnection$1(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimOnTrack$1(window1);
            $d84dc1a5e217b32f$var$shimAddTrackRemoveTrack(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimGetSendersWithDtmf(window1);
            $d84dc1a5e217b32f$var$shimSenderReceiverGetStats(window1);
            $d84dc1a5e217b32f$var$fixNegotiationNeeded(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimRTCIceCandidate(window1);
            $d84dc1a5e217b32f$var$shimRTCIceCandidateRelayProtocol(window1);
            $d84dc1a5e217b32f$var$shimConnectionState(window1);
            $d84dc1a5e217b32f$var$shimMaxMessageSize(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimSendThrowTypeError(window1);
            $d84dc1a5e217b32f$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        case "firefox":
            if (!$d84dc1a5e217b32f$var$firefoxShim || !$d84dc1a5e217b32f$var$shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $d84dc1a5e217b32f$var$firefoxShim;
            // Must be called before shimPeerConnection.
            $d84dc1a5e217b32f$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimParameterlessSetLocalDescription(window1);
            $d84dc1a5e217b32f$var$shimGetUserMedia$1(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimPeerConnection(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimOnTrack(window1);
            $d84dc1a5e217b32f$var$shimRemoveStream(window1);
            $d84dc1a5e217b32f$var$shimSenderGetStats(window1);
            $d84dc1a5e217b32f$var$shimReceiverGetStats(window1);
            $d84dc1a5e217b32f$var$shimRTCDataChannel(window1);
            $d84dc1a5e217b32f$var$shimAddTransceiver(window1);
            $d84dc1a5e217b32f$var$shimGetParameters(window1);
            $d84dc1a5e217b32f$var$shimCreateOffer(window1);
            $d84dc1a5e217b32f$var$shimCreateAnswer(window1);
            $d84dc1a5e217b32f$var$shimRTCIceCandidate(window1);
            $d84dc1a5e217b32f$var$shimConnectionState(window1);
            $d84dc1a5e217b32f$var$shimMaxMessageSize(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimSendThrowTypeError(window1);
            break;
        case "safari":
            if (!$d84dc1a5e217b32f$var$safariShim || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $d84dc1a5e217b32f$var$safariShim;
            // Must be called before shimCallbackAPI.
            $d84dc1a5e217b32f$var$shimAddIceCandidateNullOrEmpty(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimParameterlessSetLocalDescription(window1);
            $d84dc1a5e217b32f$var$shimRTCIceServerUrls(window1);
            $d84dc1a5e217b32f$var$shimCreateOfferLegacy(window1);
            $d84dc1a5e217b32f$var$shimCallbacksAPI(window1);
            $d84dc1a5e217b32f$var$shimLocalStreamsAPI(window1);
            $d84dc1a5e217b32f$var$shimRemoteStreamsAPI(window1);
            $d84dc1a5e217b32f$var$shimTrackEventTransceiver(window1);
            $d84dc1a5e217b32f$var$shimGetUserMedia(window1);
            $d84dc1a5e217b32f$var$shimAudioContext(window1);
            $d84dc1a5e217b32f$var$shimRTCIceCandidate(window1);
            $d84dc1a5e217b32f$var$shimRTCIceCandidateRelayProtocol(window1);
            $d84dc1a5e217b32f$var$shimMaxMessageSize(window1, browserDetails);
            $d84dc1a5e217b32f$var$shimSendThrowTypeError(window1);
            $d84dc1a5e217b32f$var$removeExtmapAllowMixed(window1, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ $d84dc1a5e217b32f$var$adapterFactory({
    window: typeof window === "undefined" ? undefined : window
});
const $d84dc1a5e217b32f$var$ENCRYPTION_ALGORITHM = "AES-GCM";
// How many consecutive frames can fail decrypting before a particular key gets marked as invalid
const $d84dc1a5e217b32f$var$DECRYPTION_FAILURE_TOLERANCE = 10;
// flag set to indicate that e2ee has been setup for sender/receiver;
const $d84dc1a5e217b32f$var$E2EE_FLAG = "lk_e2ee";
const $d84dc1a5e217b32f$var$SALT = "LKFrameEncryptionKey";
const $d84dc1a5e217b32f$var$KEY_PROVIDER_DEFAULTS = {
    sharedKey: false,
    ratchetSalt: $d84dc1a5e217b32f$var$SALT,
    ratchetWindowSize: 8,
    failureTolerance: $d84dc1a5e217b32f$var$DECRYPTION_FAILURE_TOLERANCE,
    keyringSize: 16
};
var $d84dc1a5e217b32f$export$432ceae3bd7b5ad3;
(function(KeyProviderEvent) {
    KeyProviderEvent["SetKey"] = "setKey";
    KeyProviderEvent["RatchetRequest"] = "ratchetRequest";
    KeyProviderEvent["KeyRatcheted"] = "keyRatcheted";
})($d84dc1a5e217b32f$export$432ceae3bd7b5ad3 || ($d84dc1a5e217b32f$export$432ceae3bd7b5ad3 = {}));
var $d84dc1a5e217b32f$export$6da6bc56147fd1ba;
(function(KeyHandlerEvent) {
    KeyHandlerEvent["KeyRatcheted"] = "keyRatcheted";
})($d84dc1a5e217b32f$export$6da6bc56147fd1ba || ($d84dc1a5e217b32f$export$6da6bc56147fd1ba = {}));
var $d84dc1a5e217b32f$export$36ec54aef832f50f;
(function(EncryptionEvent) {
    EncryptionEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    EncryptionEvent["EncryptionError"] = "encryptionError";
})($d84dc1a5e217b32f$export$36ec54aef832f50f || ($d84dc1a5e217b32f$export$36ec54aef832f50f = {}));
var $d84dc1a5e217b32f$export$d8fa3f6f75909dd5;
(function(CryptorEvent) {
    CryptorEvent["Error"] = "cryptorError";
})($d84dc1a5e217b32f$export$d8fa3f6f75909dd5 || ($d84dc1a5e217b32f$export$d8fa3f6f75909dd5 = {}));
function $d84dc1a5e217b32f$export$2c53d20185b28316() {
    return $d84dc1a5e217b32f$export$426a96d741bc81b() || $d84dc1a5e217b32f$export$6bf50ac7ca24af81();
}
function $d84dc1a5e217b32f$export$6bf50ac7ca24af81() {
    // @ts-ignore
    return typeof window.RTCRtpScriptTransform !== "undefined";
}
function $d84dc1a5e217b32f$export$426a96d741bc81b() {
    return typeof window.RTCRtpSender !== "undefined" && // @ts-ignore
    typeof window.RTCRtpSender.prototype.createEncodedStreams !== "undefined";
}
function $d84dc1a5e217b32f$export$4fe547020d3f319b(frame) {
    return "type" in frame;
}
function $d84dc1a5e217b32f$export$16dc620a3833b13a(keyBytes_1) {
    return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(keyBytes) {
        let algorithm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            name: $d84dc1a5e217b32f$var$ENCRYPTION_ALGORITHM
        };
        let usage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "encrypt";
        return function*() {
            // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/importKey
            return crypto.subtle.importKey("raw", keyBytes, algorithm, false, usage === "derive" ? [
                "deriveBits",
                "deriveKey"
            ] : [
                "encrypt",
                "decrypt"
            ]);
        }();
    });
}
function $d84dc1a5e217b32f$export$cbc2841706abbbeb(password) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        let enc = new TextEncoder();
        const keyMaterial = yield crypto.subtle.importKey("raw", enc.encode(password), {
            name: "PBKDF2"
        }, false, [
            "deriveBits",
            "deriveKey"
        ]);
        return keyMaterial;
    });
}
function $d84dc1a5e217b32f$export$46032788f1602f4b(cryptoBuffer) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const keyMaterial = yield crypto.subtle.importKey("raw", cryptoBuffer, "HKDF", false, [
            "deriveBits",
            "deriveKey"
        ]);
        return keyMaterial;
    });
}
function $d84dc1a5e217b32f$var$getAlgoOptions(algorithmName, salt) {
    const textEncoder = new TextEncoder();
    const encodedSalt = textEncoder.encode(salt);
    switch(algorithmName){
        case "HKDF":
            return {
                name: "HKDF",
                salt: encodedSalt,
                hash: "SHA-256",
                info: new ArrayBuffer(128)
            };
        case "PBKDF2":
            return {
                name: "PBKDF2",
                salt: encodedSalt,
                hash: "SHA-256",
                iterations: 100000
            };
        default:
            throw new Error("algorithm ".concat(algorithmName, " is currently unsupported"));
    }
}
/**
 * Derives a set of keys from the master key.
 * See https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.1
 */ function $d84dc1a5e217b32f$export$463e47238031f308(material, salt) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $d84dc1a5e217b32f$var$getAlgoOptions(material.algorithm.name, salt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveKey#HKDF
        // https://developer.mozilla.org/en-US/docs/Web/API/HkdfParams
        const encryptionKey = yield crypto.subtle.deriveKey(algorithmOptions, material, {
            name: $d84dc1a5e217b32f$var$ENCRYPTION_ALGORITHM,
            length: 128
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        return {
            material: material,
            encryptionKey: encryptionKey
        };
    });
}
function $d84dc1a5e217b32f$export$5dfa89fd21efb3f9() {
    return window.crypto.getRandomValues(new Uint8Array(32));
}
/**
 * Ratchets a key. See
 * https://tools.ietf.org/html/draft-omara-sframe-00#section-4.3.5.1
 */ function $d84dc1a5e217b32f$export$90588bff5e15163b(material, salt) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const algorithmOptions = $d84dc1a5e217b32f$var$getAlgoOptions(material.algorithm.name, salt);
        // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/deriveBits
        return crypto.subtle.deriveBits(algorithmOptions, material, 256);
    });
}
function $d84dc1a5e217b32f$export$8e8c01dabc426c6(frameData) {
    for(var i = 0; i < frameData.length - 3; i++){
        if (frameData[i] == 0 && frameData[i + 1] == 0 && frameData[i + 2] == 3) return true;
    }
    return false;
}
function $d84dc1a5e217b32f$export$54fa041aa1c6dee7(stream) {
    const dataOut = [];
    var length = stream.length;
    for(var i = 0; i < stream.length;)// Be careful about over/underflow here. byte_length_ - 3 can underflow, and
    // i + 3 can overflow, but byte_length_ - i can't, because i < byte_length_
    // above, and that expression will produce the number of bytes left in
    // the stream including the byte at i.
    if (length - i >= 3 && !stream[i] && !stream[i + 1] && stream[i + 2] == 3) {
        // Two rbsp bytes.
        dataOut.push(stream[i++]);
        dataOut.push(stream[i++]);
        // Skip the emulation byte.
        i++;
    } else // Single rbsp byte.
    dataOut.push(stream[i++]);
    return new Uint8Array(dataOut);
}
const $d84dc1a5e217b32f$var$kZerosInStartSequence = 2;
const $d84dc1a5e217b32f$var$kEmulationByte = 3;
function $d84dc1a5e217b32f$export$ae76453e7ef39fac(data_in) {
    const dataOut = [];
    var numConsecutiveZeros = 0;
    for(var i = 0; i < data_in.length; ++i){
        var byte = data_in[i];
        if (byte <= $d84dc1a5e217b32f$var$kEmulationByte && numConsecutiveZeros >= $d84dc1a5e217b32f$var$kZerosInStartSequence) {
            // Need to escape.
            dataOut.push($d84dc1a5e217b32f$var$kEmulationByte);
            numConsecutiveZeros = 0;
        }
        dataOut.push(byte);
        if (byte == 0) ++numConsecutiveZeros;
        else numConsecutiveZeros = 0;
    }
    return new Uint8Array(dataOut);
}
/**
 * @experimental
 */ class $d84dc1a5e217b32f$export$c4dd488dad1b29ec extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super();
        /**
     * callback being invoked after a ratchet request has been performed on a participant
     * that surfaces the new key material.
     * @param material
     * @param keyIndex
     */ this.onKeyRatcheted = (material, keyIndex)=>{
            $d84dc1a5e217b32f$var$livekitLogger.debug("key ratcheted event received", {
                material: material,
                keyIndex: keyIndex
            });
        };
        this.keyInfoMap = new Map();
        this.options = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$KEY_PROVIDER_DEFAULTS), options);
        this.on($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.KeyRatcheted, this.onKeyRatcheted);
    }
    /**
   * callback to invoke once a key has been set for a participant
   * @param key
   * @param participantIdentity
   * @param keyIndex
   */ onSetEncryptionKey(key, participantIdentity, keyIndex) {
        const keyInfo = {
            key: key,
            participantIdentity: participantIdentity,
            keyIndex: keyIndex
        };
        if (!this.options.sharedKey && !participantIdentity) throw new Error("participant identity needs to be passed for encryption key if sharedKey option is false");
        this.keyInfoMap.set("".concat(participantIdentity !== null && participantIdentity !== void 0 ? participantIdentity : "shared", "-").concat(keyIndex !== null && keyIndex !== void 0 ? keyIndex : 0), keyInfo);
        this.emit($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.SetKey, keyInfo);
    }
    getKeys() {
        return Array.from(this.keyInfoMap.values());
    }
    getOptions() {
        return this.options;
    }
    ratchetKey(participantIdentity, keyIndex) {
        this.emit($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.RatchetRequest, participantIdentity, keyIndex);
    }
}
/**
 * A basic KeyProvider implementation intended for a single shared
 * passphrase between all participants
 * @experimental
 */ class $d84dc1a5e217b32f$export$e4a829d2658cfe97 extends $d84dc1a5e217b32f$export$c4dd488dad1b29ec {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const opts = Object.assign(Object.assign({}, options), {
            sharedKey: true,
            // for a shared key provider failing to decrypt for a specific participant
            // should not mark the key as invalid, so we accept wrong keys forever
            // and won't try to auto-ratchet
            ratchetWindowSize: 0,
            failureTolerance: -1
        });
        super(opts);
    }
    /**
   * Accepts a passphrase that's used to create the crypto keys.
   * When passing in a string, PBKDF2 is used.
   * When passing in an Array buffer of cryptographically random numbers, HKDF is being used. (recommended)
   * @param key
   */ setKey(key) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const derivedKey = typeof key === "string" ? yield $d84dc1a5e217b32f$export$cbc2841706abbbeb(key) : yield $d84dc1a5e217b32f$export$46032788f1602f4b(key);
            this.onSetEncryptionKey(derivedKey);
        });
    }
}
class $d84dc1a5e217b32f$export$d7a71bcd3a009497 extends Error {
    constructor(code, message){
        super(message || "an error has occured");
        this.code = code;
    }
}
var $d84dc1a5e217b32f$export$61182a0b21436b65;
(function(ConnectionErrorReason) {
    ConnectionErrorReason[ConnectionErrorReason["NotAllowed"] = 0] = "NotAllowed";
    ConnectionErrorReason[ConnectionErrorReason["ServerUnreachable"] = 1] = "ServerUnreachable";
    ConnectionErrorReason[ConnectionErrorReason["InternalError"] = 2] = "InternalError";
    ConnectionErrorReason[ConnectionErrorReason["Cancelled"] = 3] = "Cancelled";
    ConnectionErrorReason[ConnectionErrorReason["LeaveRequest"] = 4] = "LeaveRequest";
})($d84dc1a5e217b32f$export$61182a0b21436b65 || ($d84dc1a5e217b32f$export$61182a0b21436b65 = {}));
class $d84dc1a5e217b32f$export$a3747c6e46c7a8eb extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message, reason, status, context){
        super(1, message);
        this.status = status;
        this.reason = reason;
        this.context = context;
    }
}
class $d84dc1a5e217b32f$export$38c5ac268e2fa84 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(21, message !== null && message !== void 0 ? message : "device is unsupported");
    }
}
class $d84dc1a5e217b32f$export$4fbb9423b5747257 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(20, message !== null && message !== void 0 ? message : "track is invalid");
    }
}
class $d84dc1a5e217b32f$export$4d307571a351c50c extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(10, message !== null && message !== void 0 ? message : "unsupported server");
    }
}
class $d84dc1a5e217b32f$export$1f388e244efbf70b extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(12, message !== null && message !== void 0 ? message : "unexpected connection state");
    }
}
class $d84dc1a5e217b32f$export$18c2792bacf23e39 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(13, message !== null && message !== void 0 ? message : "unable to negotiate");
    }
}
class $d84dc1a5e217b32f$export$8f27e55a613eb208 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        super(13, message !== null && message !== void 0 ? message : "unable to publish data");
    }
}
class $d84dc1a5e217b32f$export$cb33ebbc4df8a708 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message, reason){
        super(15, message);
        this.reason = reason;
    }
}
var $d84dc1a5e217b32f$export$843d4665ca980897;
(function(MediaDeviceFailure) {
    // user rejected permissions
    MediaDeviceFailure["PermissionDenied"] = "PermissionDenied";
    // device is not available
    MediaDeviceFailure["NotFound"] = "NotFound";
    // device is in use. On Windows, only a single tab may get access to a device at a time.
    MediaDeviceFailure["DeviceInUse"] = "DeviceInUse";
    MediaDeviceFailure["Other"] = "Other";
})($d84dc1a5e217b32f$export$843d4665ca980897 || ($d84dc1a5e217b32f$export$843d4665ca980897 = {}));
(function(MediaDeviceFailure) {
    function getFailure(error) {
        if (error && "name" in error) {
            if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") return MediaDeviceFailure.NotFound;
            if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") return MediaDeviceFailure.PermissionDenied;
            if (error.name === "NotReadableError" || error.name === "TrackStartError") return MediaDeviceFailure.DeviceInUse;
            return MediaDeviceFailure.Other;
        }
    }
    MediaDeviceFailure.getFailure = getFailure;
})($d84dc1a5e217b32f$export$843d4665ca980897 || ($d84dc1a5e217b32f$export$843d4665ca980897 = {}));
var $d84dc1a5e217b32f$export$9ce65eca7a94c890;
(function(CryptorErrorReason) {
    CryptorErrorReason[CryptorErrorReason["InvalidKey"] = 0] = "InvalidKey";
    CryptorErrorReason[CryptorErrorReason["MissingKey"] = 1] = "MissingKey";
    CryptorErrorReason[CryptorErrorReason["InternalError"] = 2] = "InternalError";
})($d84dc1a5e217b32f$export$9ce65eca7a94c890 || ($d84dc1a5e217b32f$export$9ce65eca7a94c890 = {}));
class $d84dc1a5e217b32f$export$94d1ae2d97ba1565 extends $d84dc1a5e217b32f$export$d7a71bcd3a009497 {
    constructor(message){
        let reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d84dc1a5e217b32f$export$9ce65eca7a94c890.InternalError;
        let participantIdentity = arguments.length > 2 ? arguments[2] : undefined;
        super(40, message);
        this.reason = reason;
        this.participantIdentity = participantIdentity;
    }
}
/**
 * Events are the primary way LiveKit notifies your application of changes.
 *
 * The following are events emitted by [[Room]], listen to room events like
 *
 * ```typescript
 * room.on(RoomEvent.TrackPublished, (track, publication, participant) => {})
 * ```
 */ var $d84dc1a5e217b32f$export$3159c672e3b2293a;
(function(RoomEvent) {
    /**
   * When the connection to the server has been established
   */ RoomEvent["Connected"] = "connected";
    /**
   * When the connection to the server has been interrupted and it's attempting
   * to reconnect.
   */ RoomEvent["Reconnecting"] = "reconnecting";
    /**
   * When the signal connection to the server has been interrupted. This isn't noticeable to users most of the time.
   * It will resolve with a `RoomEvent.Reconnected` once the signal connection has been re-established.
   * If media fails additionally it an additional `RoomEvent.Reconnecting` will be emitted.
   */ RoomEvent["SignalReconnecting"] = "signalReconnecting";
    /**
   * Fires when a reconnection has been successful.
   */ RoomEvent["Reconnected"] = "reconnected";
    /**
   * When disconnected from room. This fires when room.disconnect() is called or
   * when an unrecoverable connection issue had occured.
   *
   * DisconnectReason can be used to determine why the participant was disconnected. Notable reasons are
   * - DUPLICATE_IDENTITY: another client with the same identity has joined the room
   * - PARTICIPANT_REMOVED: participant was removed by RemoveParticipant API
   * - ROOM_DELETED: the room has ended via DeleteRoom API
   *
   * args: ([[DisconnectReason]])
   */ RoomEvent["Disconnected"] = "disconnected";
    /**
   * Whenever the connection state of the room changes
   *
   * args: ([[ConnectionState]])
   */ RoomEvent["ConnectionStateChanged"] = "connectionStateChanged";
    /**
   * When input or output devices on the machine have changed.
   */ RoomEvent["MediaDevicesChanged"] = "mediaDevicesChanged";
    /**
   * When a [[RemoteParticipant]] joins *after* the local
   * participant. It will not emit events for participants that are already
   * in the room
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantConnected"] = "participantConnected";
    /**
   * When a [[RemoteParticipant]] leaves *after* the local
   * participant has joined.
   *
   * args: ([[RemoteParticipant]])
   */ RoomEvent["ParticipantDisconnected"] = "participantDisconnected";
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackPublished"] = "trackPublished";
    /**
   * The [[LocalParticipant]] has subscribed to a new track. This event will **always**
   * fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid, [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[Track]], [[RemoteTrackPublication]], [[RemoteParticipant]])
   */ RoomEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]], [[Participant]])
   */ RoomEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]], [[LocalParticipant]])
   */ RoomEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * When a local audio track is published the SDK checks whether there is complete silence
   * on that track and emits the LocalAudioSilenceDetected event in that case.
   * This allows for applications to show UI informing users that they might have to
   * reset their audio hardware or check for proper device connectivity.
   */ RoomEvent["LocalAudioSilenceDetected"] = "localAudioSilenceDetected";
    /**
   * Active speakers changed. List of speakers are ordered by their audio level.
   * loudest speakers first. This will include the LocalParticipant too.
   *
   * Speaker updates are sent only to the publishing participant and their subscribers.
   *
   * args: (Array<[[Participant]]>)
   */ RoomEvent["ActiveSpeakersChanged"] = "activeSpeakersChanged";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   *
   * args: (prevMetadata: string, [[Participant]])
   *
   */ RoomEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ RoomEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes and the participant
   * args: (changedAttributes: [[Record<string, string]], participant: [[Participant]])
   */ RoomEvent["ParticipantAttributesChanged"] = "participantAttributesChanged";
    /**
   * Room metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateRoomMetadata is called to change a room's state,
   * *all*  participants in the room will fire this event.
   *
   * args: (string)
   */ RoomEvent["RoomMetadataChanged"] = "roomMetadataChanged";
    /**
   * Data received from another participant.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, participant: [[Participant]], kind: [[DataPacket_Kind]], topic?: string)
   */ RoomEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from another participant.
   *
   * args: (participant: [[Participant]], dtmf: [[DataPacket_Kind]])
   */ RoomEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from a participant's track.
   * @beta
   */ RoomEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]], participant: [[Participant]])
   */ RoomEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed (remote) track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.PermissionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of subscribed tracks have changed its status for the current
   * participant.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]],
   *        participant: [[RemoteParticipant]])
   */ RoomEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    /**
   * LiveKit will attempt to autoplay all audio tracks when you attach them to
   * audio elements. However, if that fails, we'll notify you via AudioPlaybackStatusChanged.
   * `Room.canPlaybackAudio` will indicate if audio playback is permitted.
   */ RoomEvent["AudioPlaybackStatusChanged"] = "audioPlaybackChanged";
    /**
   * LiveKit will attempt to autoplay all video tracks when you attach them to
   * a video element. However, if that fails, we'll notify you via VideoPlaybackStatusChanged.
   * Calling `room.startVideo()` in a user gesture event handler will resume the video playback.
   */ RoomEvent["VideoPlaybackStatusChanged"] = "videoPlaybackChanged";
    /**
   * When we have encountered an error while attempting to create a track.
   * The errors take place in getUserMedia().
   * Use MediaDeviceFailure.getFailure(error) to get the reason of failure.
   * [[LocalParticipant.lastCameraError]] and [[LocalParticipant.lastMicrophoneError]]
   * will indicate if it had an error while creating the audio or video track respectively.
   *
   * args: (error: Error)
   */ RoomEvent["MediaDevicesError"] = "mediaDevicesError";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]], participant: [[Participant]])
   */ RoomEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /**
   * Signal connected, can publish tracks.
   */ RoomEvent["SignalConnected"] = "signalConnected";
    /**
   * Recording of a room has started/stopped. Room.isRecording will be updated too.
   * args: (isRecording: boolean)
   */ RoomEvent["RecordingStatusChanged"] = "recordingStatusChanged";
    RoomEvent["ParticipantEncryptionStatusChanged"] = "participantEncryptionStatusChanged";
    RoomEvent["EncryptionError"] = "encryptionError";
    /**
   * Emits whenever the current buffer status of a data channel changes
   * args: (isLow: boolean, kind: [[DataPacket_Kind]])
   */ RoomEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    /**
   * Triggered by a call to room.switchActiveDevice
   * args: (kind: MediaDeviceKind, deviceId: string)
   */ RoomEvent["ActiveDeviceChanged"] = "activeDeviceChanged";
    RoomEvent["ChatMessage"] = "chatMessage";
    /**
   * fired when the first remote participant has subscribed to the localParticipant's track
   */ RoomEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /**
   * fired when the client receives connection metrics from other participants
   */ RoomEvent["MetricsReceived"] = "metricsReceived";
})($d84dc1a5e217b32f$export$3159c672e3b2293a || ($d84dc1a5e217b32f$export$3159c672e3b2293a = {}));
var $d84dc1a5e217b32f$export$fcdfe2b7a6750691;
(function(ParticipantEvent) {
    /**
   * When a new track is published to room *after* the local
   * participant has joined. It will not fire for tracks that are already published.
   *
   * A track published doesn't mean the participant has subscribed to it. It's
   * simply reflecting the state of the room.
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackPublished"] = "trackPublished";
    /**
   * Successfully subscribed to the [[RemoteParticipant]]'s track.
   * This event will **always** fire as long as new tracks are ready for use.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackSubscribed"] = "trackSubscribed";
    /**
   * Could not subscribe to a track
   *
   * args: (track sid)
   */ ParticipantEvent["TrackSubscriptionFailed"] = "trackSubscriptionFailed";
    /**
   * A [[RemoteParticipant]] has unpublished a track
   *
   * args: ([[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnpublished"] = "trackUnpublished";
    /**
   * A subscribed track is no longer available. Clients should listen to this
   * event and ensure they detach tracks.
   *
   * args: ([[RemoteTrack]], [[RemoteTrackPublication]])
   */ ParticipantEvent["TrackUnsubscribed"] = "trackUnsubscribed";
    /**
   * A track that was muted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackMuted"] = "trackMuted";
    /**
   * A track that was unmuted, fires on both [[RemoteParticipant]]s and [[LocalParticipant]]
   *
   * args: ([[TrackPublication]])
   */ ParticipantEvent["TrackUnmuted"] = "trackUnmuted";
    /**
   * A local track was published successfully. This event is helpful to know
   * when to update your local UI with the newly published track.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackPublished"] = "localTrackPublished";
    /**
   * A local track was unpublished. This event is helpful to know when to remove
   * the local track from your UI.
   *
   * When a user stops sharing their screen by pressing "End" on the browser UI,
   * this event will also fire.
   *
   * args: ([[LocalTrackPublication]])
   */ ParticipantEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    /**
   * Participant metadata is a simple way for app-specific state to be pushed to
   * all users.
   * When RoomService.UpdateParticipantMetadata is called to change a participant's
   * state, *all*  participants in the room will fire this event.
   * To access the current metadata, see [[Participant.metadata]].
   *
   * args: (prevMetadata: string)
   *
   */ ParticipantEvent["ParticipantMetadataChanged"] = "participantMetadataChanged";
    /**
   * Participant's display name changed
   *
   * args: (name: string, [[Participant]])
   *
   */ ParticipantEvent["ParticipantNameChanged"] = "participantNameChanged";
    /**
   * Data received from this participant as sender.
   * Data packets provides the ability to use LiveKit to send/receive arbitrary payloads.
   * All participants in the room will receive the messages sent to the room.
   *
   * args: (payload: Uint8Array, kind: [[DataPacket_Kind]])
   */ ParticipantEvent["DataReceived"] = "dataReceived";
    /**
   * SIP DTMF tones received from this participant as sender.
   *
   * args: (dtmf: [[DataPacket_Kind]])
   */ ParticipantEvent["SipDTMFReceived"] = "sipDTMFReceived";
    /**
   * Transcription received from this participant as data source.
   * @beta
   */ ParticipantEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * Has speaking status changed for the current participant
   *
   * args: (speaking: boolean)
   */ ParticipantEvent["IsSpeakingChanged"] = "isSpeakingChanged";
    /**
   * Connection quality was changed for a Participant. It'll receive updates
   * from the local participant, as well as any [[RemoteParticipant]]s that we are
   * subscribed to.
   *
   * args: (connectionQuality: [[ConnectionQuality]])
   */ ParticipantEvent["ConnectionQualityChanged"] = "connectionQualityChanged";
    /**
   * StreamState indicates if a subscribed track has been paused by the SFU
   * (typically this happens because of subscriber's bandwidth constraints)
   *
   * When bandwidth conditions allow, the track will be resumed automatically.
   * TrackStreamStateChanged will also be emitted when that happens.
   *
   * args: (pub: [[RemoteTrackPublication]], streamState: [[Track.StreamState]])
   */ ParticipantEvent["TrackStreamStateChanged"] = "trackStreamStateChanged";
    /**
   * One of subscribed tracks have changed its permissions for the current
   * participant. If permission was revoked, then the track will no longer
   * be subscribed. If permission was granted, a TrackSubscribed event will
   * be emitted.
   *
   * args: (pub: [[RemoteTrackPublication]],
   *        status: [[TrackPublication.SubscriptionStatus]])
   */ ParticipantEvent["TrackSubscriptionPermissionChanged"] = "trackSubscriptionPermissionChanged";
    /**
   * One of the remote participants publications has changed its subscription status.
   *
   */ ParticipantEvent["TrackSubscriptionStatusChanged"] = "trackSubscriptionStatusChanged";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["MediaDevicesError"] = "mediaDevicesError";
    // fired only on LocalParticipant
    /** @internal */ ParticipantEvent["AudioStreamAcquired"] = "audioStreamAcquired";
    /**
   * A participant's permission has changed.
   * args: (prevPermissions: [[ParticipantPermission]])
   */ ParticipantEvent["ParticipantPermissionsChanged"] = "participantPermissionsChanged";
    /** @internal */ ParticipantEvent["PCTrackAdded"] = "pcTrackAdded";
    /**
   * Participant attributes is an app-specific key value state to be pushed to
   * all users.
   * When a participant's attributes changed, this event will be emitted with the changed attributes
   * args: (changedAttributes: [[Record<string, string]])
   */ ParticipantEvent["AttributesChanged"] = "attributesChanged";
    /**
   * fired on local participant only, when the first remote participant has subscribed to the track specified in the payload
   */ ParticipantEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    /** only emitted on local participant */ ParticipantEvent["ChatMessage"] = "chatMessage";
})($d84dc1a5e217b32f$export$fcdfe2b7a6750691 || ($d84dc1a5e217b32f$export$fcdfe2b7a6750691 = {}));
/** @internal */ var $d84dc1a5e217b32f$export$c09e63b8572f869;
(function(EngineEvent) {
    EngineEvent["TransportsCreated"] = "transportsCreated";
    EngineEvent["Connected"] = "connected";
    EngineEvent["Disconnected"] = "disconnected";
    EngineEvent["Resuming"] = "resuming";
    EngineEvent["Resumed"] = "resumed";
    EngineEvent["Restarting"] = "restarting";
    EngineEvent["Restarted"] = "restarted";
    EngineEvent["SignalResumed"] = "signalResumed";
    EngineEvent["SignalRestarted"] = "signalRestarted";
    EngineEvent["Closing"] = "closing";
    EngineEvent["MediaTrackAdded"] = "mediaTrackAdded";
    EngineEvent["ActiveSpeakersUpdate"] = "activeSpeakersUpdate";
    EngineEvent["DataPacketReceived"] = "dataPacketReceived";
    EngineEvent["RTPVideoMapUpdate"] = "rtpVideoMapUpdate";
    EngineEvent["DCBufferStatusChanged"] = "dcBufferStatusChanged";
    EngineEvent["ParticipantUpdate"] = "participantUpdate";
    EngineEvent["RoomUpdate"] = "roomUpdate";
    EngineEvent["SpeakersChanged"] = "speakersChanged";
    EngineEvent["StreamStateChanged"] = "streamStateChanged";
    EngineEvent["ConnectionQualityUpdate"] = "connectionQualityUpdate";
    EngineEvent["SubscriptionError"] = "subscriptionError";
    EngineEvent["SubscriptionPermissionUpdate"] = "subscriptionPermissionUpdate";
    EngineEvent["RemoteMute"] = "remoteMute";
    EngineEvent["SubscribedQualityUpdate"] = "subscribedQualityUpdate";
    EngineEvent["LocalTrackUnpublished"] = "localTrackUnpublished";
    EngineEvent["LocalTrackSubscribed"] = "localTrackSubscribed";
    EngineEvent["Offline"] = "offline";
    EngineEvent["SignalRequestResponse"] = "signalRequestResponse";
})($d84dc1a5e217b32f$export$c09e63b8572f869 || ($d84dc1a5e217b32f$export$c09e63b8572f869 = {}));
var $d84dc1a5e217b32f$export$2c8510d737cc09da;
(function(TrackEvent) {
    TrackEvent["Message"] = "message";
    TrackEvent["Muted"] = "muted";
    TrackEvent["Unmuted"] = "unmuted";
    /**
   * Only fires on LocalTracks
   */ TrackEvent["Restarted"] = "restarted";
    TrackEvent["Ended"] = "ended";
    TrackEvent["Subscribed"] = "subscribed";
    TrackEvent["Unsubscribed"] = "unsubscribed";
    /** @internal */ TrackEvent["UpdateSettings"] = "updateSettings";
    /** @internal */ TrackEvent["UpdateSubscription"] = "updateSubscription";
    /** @internal */ TrackEvent["AudioPlaybackStarted"] = "audioPlaybackStarted";
    /** @internal */ TrackEvent["AudioPlaybackFailed"] = "audioPlaybackFailed";
    /**
   * @internal
   * Only fires on LocalAudioTrack instances
   */ TrackEvent["AudioSilenceDetected"] = "audioSilenceDetected";
    /** @internal */ TrackEvent["VisibilityChanged"] = "visibilityChanged";
    /** @internal */ TrackEvent["VideoDimensionsChanged"] = "videoDimensionsChanged";
    /** @internal */ TrackEvent["VideoPlaybackStarted"] = "videoPlaybackStarted";
    /** @internal */ TrackEvent["VideoPlaybackFailed"] = "videoPlaybackFailed";
    /** @internal */ TrackEvent["ElementAttached"] = "elementAttached";
    /** @internal */ TrackEvent["ElementDetached"] = "elementDetached";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamPaused"] = "upstreamPaused";
    /**
   * @internal
   * Only fires on LocalTracks
   */ TrackEvent["UpstreamResumed"] = "upstreamResumed";
    /**
   * @internal
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionPermissionChanged"] = "subscriptionPermissionChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionStatusChanged"] = "subscriptionStatusChanged";
    /**
   * Fires on RemoteTrackPublication
   */ TrackEvent["SubscriptionFailed"] = "subscriptionFailed";
    /**
   * @internal
   */ TrackEvent["TrackProcessorUpdate"] = "trackProcessorUpdate";
    /**
   * @internal
   */ TrackEvent["AudioTrackFeatureUpdate"] = "audioTrackFeatureUpdate";
    /**
   * @beta
   */ TrackEvent["TranscriptionReceived"] = "transcriptionReceived";
    /**
   * @experimental
   */ TrackEvent["TimeSyncUpdate"] = "timeSyncUpdate";
})($d84dc1a5e217b32f$export$2c8510d737cc09da || ($d84dc1a5e217b32f$export$2c8510d737cc09da = {}));
function $d84dc1a5e217b32f$var$r(r, e, n) {
    var i, t, o;
    void 0 === e && (e = 50), void 0 === n && (n = {});
    var a = null != (i = n.isImmediate) && i, u = null != (t = n.callback) && t, c = n.maxWait, v = Date.now(), l = [];
    function f() {
        if (void 0 !== c) {
            var r = Date.now() - v;
            if (r + e >= c) return c - r;
        }
        return e;
    }
    var d = function() {
        var e = [].slice.call(arguments), n = this;
        return new Promise(function(i, t) {
            var c = a && void 0 === o;
            if (void 0 !== o && clearTimeout(o), o = setTimeout(function() {
                if (o = void 0, v = Date.now(), !a) {
                    var i = r.apply(n, e);
                    u && u(i), l.forEach(function(r) {
                        return (0, r.resolve)(i);
                    }), l = [];
                }
            }, f()), c) {
                var d = r.apply(n, e);
                return u && u(d), i(d);
            }
            l.push({
                resolve: i,
                reject: t
            });
        });
    };
    return d.cancel = function(r) {
        void 0 !== o && clearTimeout(o), l.forEach(function(e) {
            return (0, e.reject)(r);
        }), l = [];
    }, d;
}
// tiny, simplified version of https://github.com/lancedikson/bowser/blob/master/src/parser-browsers.js
// reduced to only differentiate Chrome(ium) based browsers / Firefox / Safari
const $d84dc1a5e217b32f$var$commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
let $d84dc1a5e217b32f$var$browserDetails;
/**
 * @internal
 */ function $d84dc1a5e217b32f$export$89e15fc796a4a429(userAgent) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (typeof userAgent === "undefined" && typeof navigator === "undefined") return;
    const ua = (userAgent !== null && userAgent !== void 0 ? userAgent : navigator.userAgent).toLowerCase();
    if ($d84dc1a5e217b32f$var$browserDetails === undefined || force) {
        const browser = $d84dc1a5e217b32f$var$browsersList.find((_ref)=>{
            let { test: test } = _ref;
            return test.test(ua);
        });
        $d84dc1a5e217b32f$var$browserDetails = browser === null || browser === void 0 ? void 0 : browser.describe(ua);
    }
    return $d84dc1a5e217b32f$var$browserDetails;
}
const $d84dc1a5e217b32f$var$browsersList = [
    {
        test: /firefox|iceweasel|fxios/i,
        describe (ua) {
            const browser = {
                name: "Firefox",
                version: $d84dc1a5e217b32f$var$getMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes("fxios") ? "iOS" : undefined,
                osVersion: $d84dc1a5e217b32f$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    {
        test: /chrom|crios|crmo/i,
        describe (ua) {
            const browser = {
                name: "Chrome",
                version: $d84dc1a5e217b32f$var$getMatch(/(?:chrome|chromium|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua),
                os: ua.toLowerCase().includes("crios") ? "iOS" : undefined,
                osVersion: $d84dc1a5e217b32f$var$getOSVersion(ua)
            };
            return browser;
        }
    },
    /* Safari */ {
        test: /safari|applewebkit/i,
        describe (ua) {
            const browser = {
                name: "Safari",
                version: $d84dc1a5e217b32f$var$getMatch($d84dc1a5e217b32f$var$commonVersionIdentifier, ua),
                os: ua.includes("mobile/") ? "iOS" : "macOS",
                osVersion: $d84dc1a5e217b32f$var$getOSVersion(ua)
            };
            return browser;
        }
    }
];
function $d84dc1a5e217b32f$var$getMatch(exp, ua) {
    let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    const match = ua.match(exp);
    return match && match.length >= id && match[id] || "";
}
function $d84dc1a5e217b32f$var$getOSVersion(ua) {
    return ua.includes("mac os") ? $d84dc1a5e217b32f$var$getMatch(/\(.+?(\d+_\d+(:?_\d+)?)/, ua, 1).replace(/_/g, ".") : undefined;
}
var $d84dc1a5e217b32f$var$version$1 = "2.8.1";
const $d84dc1a5e217b32f$export$83d89fbfd8236492 = $d84dc1a5e217b32f$var$version$1;
const $d84dc1a5e217b32f$export$94587fadffb515a1 = 15;
/**
 * Timers that can be overridden with platform specific implementations
 * that ensure that they are fired. These should be used when it is critical
 * that the timer fires on time.
 */ class $d84dc1a5e217b32f$export$22e737276454df96 {
}
$d84dc1a5e217b32f$export$22e737276454df96.setTimeout = function() {
    return setTimeout(...arguments);
};
$d84dc1a5e217b32f$export$22e737276454df96.setInterval = // eslint-disable-next-line @typescript-eslint/no-implied-eval
function() {
    return setInterval(...arguments);
};
$d84dc1a5e217b32f$export$22e737276454df96.clearTimeout = function() {
    return clearTimeout(...arguments);
};
$d84dc1a5e217b32f$export$22e737276454df96.clearInterval = function() {
    return clearInterval(...arguments);
};
class $d84dc1a5e217b32f$export$73e76f4fd970cdf1 {
    constructor(widthOrOptions, height, maxBitrate, maxFramerate, priority){
        if (typeof widthOrOptions === "object") {
            this.width = widthOrOptions.width;
            this.height = widthOrOptions.height;
            this.aspectRatio = widthOrOptions.aspectRatio;
            this.encoding = {
                maxBitrate: widthOrOptions.maxBitrate,
                maxFramerate: widthOrOptions.maxFramerate,
                priority: widthOrOptions.priority
            };
        } else if (height !== undefined && maxBitrate !== undefined) {
            this.width = widthOrOptions;
            this.height = height;
            this.aspectRatio = widthOrOptions / height;
            this.encoding = {
                maxBitrate: maxBitrate,
                maxFramerate: maxFramerate,
                priority: priority
            };
        } else throw new TypeError("Unsupported options: provide at least width, height and maxBitrate");
    }
    get resolution() {
        return {
            width: this.width,
            height: this.height,
            frameRate: this.encoding.maxFramerate,
            aspectRatio: this.aspectRatio
        };
    }
}
const $d84dc1a5e217b32f$var$backupCodecs = [
    "vp8",
    "h264"
];
const $d84dc1a5e217b32f$export$986dcb5e6a94a34c = [
    "vp8",
    "h264",
    "vp9",
    "av1"
];
function $d84dc1a5e217b32f$export$da37a49ee77f9d77(codec) {
    return !!$d84dc1a5e217b32f$var$backupCodecs.find((backup)=>backup === codec);
}
var $d84dc1a5e217b32f$export$5da93632511fdb1f;
(function(AudioPresets) {
    AudioPresets.telephone = {
        maxBitrate: 12000
    };
    AudioPresets.speech = {
        maxBitrate: 24000
    };
    AudioPresets.music = {
        maxBitrate: 48000
    };
    AudioPresets.musicStereo = {
        maxBitrate: 64000
    };
    AudioPresets.musicHighQuality = {
        maxBitrate: 96000
    };
    AudioPresets.musicHighQualityStereo = {
        maxBitrate: 128000
    };
})($d84dc1a5e217b32f$export$5da93632511fdb1f || ($d84dc1a5e217b32f$export$5da93632511fdb1f = {}));
/**
 * Sane presets for video resolution/encoding
 */ const $d84dc1a5e217b32f$export$79d56065dad1674c = {
    h90: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(160, 90, 90000, 20),
    h180: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(320, 180, 160000, 20),
    h216: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(384, 216, 180000, 20),
    h360: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(640, 360, 450000, 20),
    h540: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(960, 540, 800000, 25),
    h720: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1280, 720, 1700000, 30),
    h1080: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1920, 1080, 3000000, 30),
    h1440: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(2560, 1440, 5000000, 30),
    h2160: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(3840, 2160, 8000000, 30)
};
/**
 * Four by three presets
 */ const $d84dc1a5e217b32f$export$eb5fc43ecc8ee2c7 = {
    h120: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(160, 120, 70000, 20),
    h180: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(240, 180, 125000, 20),
    h240: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(320, 240, 140000, 20),
    h360: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(480, 360, 330000, 20),
    h480: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(640, 480, 500000, 20),
    h540: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(720, 540, 600000, 25),
    h720: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(960, 720, 1300000, 30),
    h1080: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1440, 1080, 2300000, 30),
    h1440: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1920, 1440, 3800000, 30)
};
const $d84dc1a5e217b32f$export$a6cdf9dcd3d32f2d = {
    h360fps3: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(640, 360, 200000, 3, "medium"),
    h360fps15: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(640, 360, 400000, 15, "medium"),
    h720fps5: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1280, 720, 800000, 5, "medium"),
    h720fps15: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1280, 720, 1500000, 15, "medium"),
    h720fps30: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1280, 720, 2000000, 30, "medium"),
    h1080fps15: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1920, 1080, 2500000, 15, "medium"),
    h1080fps30: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(1920, 1080, 5000000, 30, "medium"),
    // original resolution, without resizing
    original: new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(0, 0, 7000000, 30, "medium")
};
function $d84dc1a5e217b32f$var$cloneDeep(value) {
    if (typeof value === "undefined") return;
    if (typeof structuredClone === "function") return structuredClone(value);
    else return JSON.parse(JSON.stringify(value));
}
const $d84dc1a5e217b32f$var$BACKGROUND_REACTION_DELAY = 5000;
// keep old audio elements when detached, we would re-use them since on iOS
// Safari tracks which audio elements have been "blessed" by the user.
const $d84dc1a5e217b32f$var$recycledElements = [];
var $d84dc1a5e217b32f$export$a8f593954e806155;
(function(VideoQuality) {
    VideoQuality[VideoQuality["LOW"] = 0] = "LOW";
    VideoQuality[VideoQuality["MEDIUM"] = 1] = "MEDIUM";
    VideoQuality[VideoQuality["HIGH"] = 2] = "HIGH";
})($d84dc1a5e217b32f$export$a8f593954e806155 || ($d84dc1a5e217b32f$export$a8f593954e806155 = {}));
class $d84dc1a5e217b32f$export$13921ac0cc260818 extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(mediaTrack, kind){
        let loggerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _a;
        super();
        this.attachedElements = [];
        this.isMuted = false;
        /**
     * indicates current state of stream, it'll indicate `paused` if the track
     * has been paused by congestion controller
     */ this.streamState = $d84dc1a5e217b32f$export$13921ac0cc260818.StreamState.Active;
        this.isInBackground = false;
        this._currentBitrate = 0;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.appVisibilityChangedListener = ()=>{
            if (this.backgroundTimeout) clearTimeout(this.backgroundTimeout);
            // delay app visibility update if it goes to hidden
            // update immediately if it comes back to focus
            if (document.visibilityState === "hidden") this.backgroundTimeout = setTimeout(()=>this.handleAppVisibilityChanged(), $d84dc1a5e217b32f$var$BACKGROUND_REACTION_DELAY);
            else this.handleAppVisibilityChanged();
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Track);
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this._mediaStreamTrack = mediaTrack;
        this._mediaStreamID = mediaTrack.id;
        this.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Unknown;
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $d84dc1a5e217b32f$var$getLogContextFromTrack(this));
    }
    /** current receive bits per second */ get currentBitrate() {
        return this._currentBitrate;
    }
    get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /**
   * @internal
   * used for keep mediaStream's first id, since it's id might change
   * if we disable/enable a track
   */ get mediaStreamID() {
        return this._mediaStreamID;
    }
    attach(element) {
        let elementType = "audio";
        if (this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) elementType = "video";
        if (this.attachedElements.length === 0 && this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) this.addAppVisibilityListener();
        if (!element) {
            if (elementType === "audio") {
                $d84dc1a5e217b32f$var$recycledElements.forEach((e)=>{
                    if (e.parentElement === null && !element) element = e;
                });
                if (element) // remove it from pool
                $d84dc1a5e217b32f$var$recycledElements.splice($d84dc1a5e217b32f$var$recycledElements.indexOf(element), 1);
            }
            if (!element) element = document.createElement(elementType);
        }
        if (!this.attachedElements.includes(element)) this.attachedElements.push(element);
        // even if we believe it's already attached to the element, it's possible
        // the element's srcObject was set to something else out of band.
        // we'll want to re-attach it in that case
        $d84dc1a5e217b32f$export$b8f95ef2322890b8(this.mediaStreamTrack, element);
        // handle auto playback failures
        const allMediaStreamTracks = element.srcObject.getTracks();
        const hasAudio = allMediaStreamTracks.some((tr)=>tr.kind === "audio");
        // manually play media to detect auto playback status
        element.play().then(()=>{
            this.emit(hasAudio ? $d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackStarted : $d84dc1a5e217b32f$export$2c8510d737cc09da.VideoPlaybackStarted);
        }).catch((e)=>{
            if (e.name === "NotAllowedError") this.emit(hasAudio ? $d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackFailed : $d84dc1a5e217b32f$export$2c8510d737cc09da.VideoPlaybackFailed, e);
            else if (e.name === "AbortError") // commonly triggered by another `play` request, only log for debugging purposes
            $d84dc1a5e217b32f$var$livekitLogger.debug("".concat(hasAudio ? "audio" : "video", " playback aborted, likely due to new play request"));
            else $d84dc1a5e217b32f$var$livekitLogger.warn("could not playback ".concat(hasAudio ? "audio" : "video"), e);
            // If audio playback isn't allowed make sure we still play back the video
            if (hasAudio && element && allMediaStreamTracks.some((tr)=>tr.kind === "video") && e.name === "NotAllowedError") {
                element.muted = true;
                element.play().catch(()=>{
                // catch for Safari, exceeded options at this point to automatically play the media element
                });
            }
        });
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.ElementAttached, element);
        return element;
    }
    detach(element) {
        try {
            // detach from a single element
            if (element) {
                $d84dc1a5e217b32f$export$8ea68c6294970fa5(this.mediaStreamTrack, element);
                const idx = this.attachedElements.indexOf(element);
                if (idx >= 0) {
                    this.attachedElements.splice(idx, 1);
                    this.recycleElement(element);
                    this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.ElementDetached, element);
                }
                return element;
            }
            const detached = [];
            this.attachedElements.forEach((elm)=>{
                $d84dc1a5e217b32f$export$8ea68c6294970fa5(this.mediaStreamTrack, elm);
                detached.push(elm);
                this.recycleElement(elm);
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.ElementDetached, elm);
            });
            // remove all tracks
            this.attachedElements = [];
            return detached;
        } finally{
            if (this.attachedElements.length === 0) this.removeAppVisibilityListener();
        }
    }
    stop() {
        this.stopMonitor();
        this._mediaStreamTrack.stop();
    }
    enable() {
        this._mediaStreamTrack.enabled = true;
    }
    disable() {
        this._mediaStreamTrack.enabled = false;
    }
    /* @internal */ stopMonitor() {
        if (this.monitorInterval) clearInterval(this.monitorInterval);
        if (this.timeSyncHandle) cancelAnimationFrame(this.timeSyncHandle);
    }
    /** @internal */ updateLoggerOptions(loggerOptions) {
        if (loggerOptions.loggerName) this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd(loggerOptions.loggerName);
        if (loggerOptions.loggerContextCb) this.loggerContextCb = loggerOptions.loggerContextCb;
    }
    recycleElement(element) {
        if (element instanceof HTMLAudioElement) {
            // we only need to re-use a single element
            let shouldCache = true;
            element.pause();
            $d84dc1a5e217b32f$var$recycledElements.forEach((e)=>{
                if (!e.parentElement) shouldCache = false;
            });
            if (shouldCache) $d84dc1a5e217b32f$var$recycledElements.push(element);
        }
    }
    handleAppVisibilityChanged() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.isInBackground = document.visibilityState === "hidden";
            if (!this.isInBackground && this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) setTimeout(()=>this.attachedElements.forEach((el)=>el.play().catch(()=>{
                    /** catch clause necessary for Safari */ })), 0);
        });
    }
    addAppVisibilityListener() {
        if ($d84dc1a5e217b32f$var$isWeb()) {
            this.isInBackground = document.visibilityState === "hidden";
            document.addEventListener("visibilitychange", this.appVisibilityChangedListener);
        } else this.isInBackground = false;
    }
    removeAppVisibilityListener() {
        if ($d84dc1a5e217b32f$var$isWeb()) document.removeEventListener("visibilitychange", this.appVisibilityChangedListener);
    }
}
function $d84dc1a5e217b32f$export$b8f95ef2322890b8(track, element) {
    let mediaStream;
    if (element.srcObject instanceof MediaStream) mediaStream = element.srcObject;
    else mediaStream = new MediaStream();
    // check if track matches existing track
    let existingTracks;
    if (track.kind === "audio") existingTracks = mediaStream.getAudioTracks();
    else existingTracks = mediaStream.getVideoTracks();
    if (!existingTracks.includes(track)) {
        existingTracks.forEach((et)=>{
            mediaStream.removeTrack(et);
        });
        mediaStream.addTrack(track);
    }
    if (!$d84dc1a5e217b32f$var$isSafari() || !(element instanceof HTMLVideoElement)) // when in low power mode (applies to both macOS and iOS), Safari will show a play/pause overlay
    // when a video starts that has the `autoplay` attribute is set.
    // we work around this by _not_ setting the autoplay attribute on safari and instead call `setTimeout(() => el.play(),0)` further down
    element.autoplay = true;
    // In case there are no audio tracks present on the mediastream, we set the element as muted to ensure autoplay works
    element.muted = mediaStream.getAudioTracks().length === 0;
    if (element instanceof HTMLVideoElement) element.playsInline = true;
    // avoid flicker
    if (element.srcObject !== mediaStream) {
        element.srcObject = mediaStream;
        if (($d84dc1a5e217b32f$var$isSafari() || $d84dc1a5e217b32f$var$isFireFox()) && element instanceof HTMLVideoElement) // Firefox also has a timing issue where video doesn't actually get attached unless
        // performed out-of-band
        // Safari 15 has a bug where in certain layouts, video element renders
        // black until the page is resized or other changes take place.
        // Resetting the src triggers it to render.
        // https://developer.apple.com/forums/thread/690523
        setTimeout(()=>{
            element.srcObject = mediaStream;
            // Safari 15 sometimes fails to start a video
            // when the window is backgrounded before the first frame is drawn
            // manually calling play here seems to fix that
            element.play().catch(()=>{
            /** do nothing */ });
        }, 0);
    }
}
/** @internal */ function $d84dc1a5e217b32f$export$8ea68c6294970fa5(track, element) {
    if (element.srcObject instanceof MediaStream) {
        const mediaStream = element.srcObject;
        mediaStream.removeTrack(track);
        if (mediaStream.getTracks().length > 0) element.srcObject = mediaStream;
        else element.srcObject = null;
    }
}
(function(Track) {
    let Kind;
    (function(Kind) {
        Kind["Audio"] = "audio";
        Kind["Video"] = "video";
        Kind["Unknown"] = "unknown";
    })(Kind = Track.Kind || (Track.Kind = {}));
    let Source;
    (function(Source) {
        Source["Camera"] = "camera";
        Source["Microphone"] = "microphone";
        Source["ScreenShare"] = "screen_share";
        Source["ScreenShareAudio"] = "screen_share_audio";
        Source["Unknown"] = "unknown";
    })(Source = Track.Source || (Track.Source = {}));
    let StreamState$1;
    (function(StreamState) {
        StreamState["Active"] = "active";
        StreamState["Paused"] = "paused";
        StreamState["Unknown"] = "unknown";
    })(StreamState$1 = Track.StreamState || (Track.StreamState = {}));
    /** @internal */ function kindToProto(k) {
        switch(k){
            case Kind.Audio:
                return $d84dc1a5e217b32f$var$TrackType.AUDIO;
            case Kind.Video:
                return $d84dc1a5e217b32f$var$TrackType.VIDEO;
            default:
                // FIXME this was UNRECOGNIZED before
                return $d84dc1a5e217b32f$var$TrackType.DATA;
        }
    }
    Track.kindToProto = kindToProto;
    /** @internal */ function kindFromProto(t) {
        switch(t){
            case $d84dc1a5e217b32f$var$TrackType.AUDIO:
                return Kind.Audio;
            case $d84dc1a5e217b32f$var$TrackType.VIDEO:
                return Kind.Video;
            default:
                return Kind.Unknown;
        }
    }
    Track.kindFromProto = kindFromProto;
    /** @internal */ function sourceToProto(s) {
        switch(s){
            case Source.Camera:
                return $d84dc1a5e217b32f$var$TrackSource.CAMERA;
            case Source.Microphone:
                return $d84dc1a5e217b32f$var$TrackSource.MICROPHONE;
            case Source.ScreenShare:
                return $d84dc1a5e217b32f$var$TrackSource.SCREEN_SHARE;
            case Source.ScreenShareAudio:
                return $d84dc1a5e217b32f$var$TrackSource.SCREEN_SHARE_AUDIO;
            default:
                return $d84dc1a5e217b32f$var$TrackSource.UNKNOWN;
        }
    }
    Track.sourceToProto = sourceToProto;
    /** @internal */ function sourceFromProto(s) {
        switch(s){
            case $d84dc1a5e217b32f$var$TrackSource.CAMERA:
                return Source.Camera;
            case $d84dc1a5e217b32f$var$TrackSource.MICROPHONE:
                return Source.Microphone;
            case $d84dc1a5e217b32f$var$TrackSource.SCREEN_SHARE:
                return Source.ScreenShare;
            case $d84dc1a5e217b32f$var$TrackSource.SCREEN_SHARE_AUDIO:
                return Source.ScreenShareAudio;
            default:
                return Source.Unknown;
        }
    }
    Track.sourceFromProto = sourceFromProto;
    /** @internal */ function streamStateFromProto(s) {
        switch(s){
            case $d84dc1a5e217b32f$var$StreamState.ACTIVE:
                return StreamState$1.Active;
            case $d84dc1a5e217b32f$var$StreamState.PAUSED:
                return StreamState$1.Paused;
            default:
                return StreamState$1.Unknown;
        }
    }
    Track.streamStateFromProto = streamStateFromProto;
})($d84dc1a5e217b32f$export$13921ac0cc260818);
function $d84dc1a5e217b32f$var$mergeDefaultOptions(options, audioDefaults, videoDefaults) {
    var _a, _b, _c;
    var _d, _e;
    const { optionsWithoutProcessor: optionsWithoutProcessor, audioProcessor: audioProcessor, videoProcessor: videoProcessor } = $d84dc1a5e217b32f$var$extractProcessorsFromOptions(options !== null && options !== void 0 ? options : {});
    const clonedOptions = (_a = $d84dc1a5e217b32f$var$cloneDeep(optionsWithoutProcessor)) !== null && _a !== void 0 ? _a : {};
    if (clonedOptions.audio === true) clonedOptions.audio = {};
    if (clonedOptions.video === true) clonedOptions.video = {};
    // use defaults
    if (clonedOptions.audio) {
        $d84dc1a5e217b32f$var$mergeObjectWithoutOverwriting(clonedOptions.audio, audioDefaults);
        (_b = (_d = clonedOptions.audio).deviceId) !== null && _b !== void 0 ? _b : _d.deviceId = "default";
        if (audioProcessor) clonedOptions.audio.processor = audioProcessor;
    }
    if (clonedOptions.video) {
        $d84dc1a5e217b32f$var$mergeObjectWithoutOverwriting(clonedOptions.video, videoDefaults);
        (_c = (_e = clonedOptions.video).deviceId) !== null && _c !== void 0 ? _c : _e.deviceId = "default";
        if (videoProcessor) clonedOptions.video.processor = videoProcessor;
    }
    return clonedOptions;
}
function $d84dc1a5e217b32f$var$mergeObjectWithoutOverwriting(mainObject, objectToMerge) {
    Object.keys(objectToMerge).forEach((key)=>{
        if (mainObject[key] === undefined) mainObject[key] = objectToMerge[key];
    });
    return mainObject;
}
function $d84dc1a5e217b32f$var$constraintsForOptions(options) {
    var _a, _b;
    var _c, _d;
    const constraints = {};
    if (options.video) {
        // default video options
        if (typeof options.video === "object") {
            const videoOptions = {};
            const target = videoOptions;
            const source = options.video;
            Object.keys(source).forEach((key)=>{
                switch(key){
                    case "resolution":
                        // flatten VideoResolution fields
                        $d84dc1a5e217b32f$var$mergeObjectWithoutOverwriting(target, source.resolution);
                        break;
                    default:
                        target[key] = source[key];
                }
            });
            constraints.video = videoOptions;
            (_a = (_c = constraints.video).deviceId) !== null && _a !== void 0 ? _a : _c.deviceId = "default";
        } else constraints.video = options.video ? {
            deviceId: "default"
        } : false;
    } else constraints.video = false;
    if (options.audio) {
        if (typeof options.audio === "object") {
            constraints.audio = options.audio;
            (_b = (_d = constraints.audio).deviceId) !== null && _b !== void 0 ? _b : _d.deviceId = "default";
        } else constraints.audio = {
            deviceId: "default"
        };
    } else constraints.audio = false;
    return constraints;
}
/**
 * This function detects silence on a given [[Track]] instance.
 * Returns true if the track seems to be entirely silent.
 */ function $d84dc1a5e217b32f$var$detectSilence(track_1) {
    return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(track) {
        let timeOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
        return function*() {
            const ctx = $d84dc1a5e217b32f$var$getNewAudioContext();
            if (ctx) {
                const analyser = ctx.createAnalyser();
                analyser.fftSize = 2048;
                const bufferLength = analyser.frequencyBinCount;
                const dataArray = new Uint8Array(bufferLength);
                const source = ctx.createMediaStreamSource(new MediaStream([
                    track.mediaStreamTrack
                ]));
                source.connect(analyser);
                yield $d84dc1a5e217b32f$var$sleep(timeOffset);
                analyser.getByteTimeDomainData(dataArray);
                const someNoise = dataArray.some((sample)=>sample !== 128 && sample !== 0);
                ctx.close();
                return !someNoise;
            }
            return false;
        }();
    });
}
/**
 * @internal
 */ function $d84dc1a5e217b32f$var$getNewAudioContext() {
    const AudioContext1 = // @ts-ignore
    typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
    if (AudioContext1) return new AudioContext1({
        latencyHint: "interactive"
    });
}
/**
 * @internal
 */ function $d84dc1a5e217b32f$var$sourceToKind(source) {
    if (source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone) return "audioinput";
    else if (source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera) return "videoinput";
    else return undefined;
}
/**
 * @internal
 */ function $d84dc1a5e217b32f$var$screenCaptureToDisplayMediaStreamOptions(options) {
    var _a, _b;
    let videoConstraints = (_a = options.video) !== null && _a !== void 0 ? _a : true;
    // treat 0 as uncapped
    if (options.resolution && options.resolution.width > 0 && options.resolution.height > 0) {
        videoConstraints = typeof videoConstraints === "boolean" ? {} : videoConstraints;
        if ($d84dc1a5e217b32f$var$isSafari()) videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                max: options.resolution.width
            },
            height: {
                max: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
        else videoConstraints = Object.assign(Object.assign({}, videoConstraints), {
            width: {
                ideal: options.resolution.width
            },
            height: {
                ideal: options.resolution.height
            },
            frameRate: options.resolution.frameRate
        });
    }
    return {
        audio: (_b = options.audio) !== null && _b !== void 0 ? _b : false,
        video: videoConstraints,
        // @ts-expect-error support for experimental display media features
        controller: options.controller,
        selfBrowserSurface: options.selfBrowserSurface,
        surfaceSwitching: options.surfaceSwitching,
        systemAudio: options.systemAudio,
        preferCurrentTab: options.preferCurrentTab
    };
}
function $d84dc1a5e217b32f$var$mimeTypeToVideoCodecString(mimeType) {
    return mimeType.split("/")[1].toLowerCase();
}
function $d84dc1a5e217b32f$var$getTrackPublicationInfo(tracks) {
    const infos = [];
    tracks.forEach((track)=>{
        if (track.track !== undefined) infos.push(new $d84dc1a5e217b32f$var$TrackPublishedResponse({
            cid: track.track.mediaStreamID,
            track: track.trackInfo
        }));
    });
    return infos;
}
function $d84dc1a5e217b32f$var$getLogContextFromTrack(track) {
    if (track instanceof $d84dc1a5e217b32f$export$13921ac0cc260818) return {
        trackID: track.sid,
        source: track.source,
        muted: track.isMuted,
        enabled: track.mediaStreamTrack.enabled,
        kind: track.kind,
        streamID: track.mediaStreamID,
        streamTrackID: track.mediaStreamTrack.id
    };
    else return {
        trackID: track.trackSid,
        enabled: track.isEnabled,
        muted: track.isMuted,
        trackInfo: Object.assign({
            mimeType: track.mimeType,
            name: track.trackName,
            encrypted: track.isEncrypted,
            kind: track.kind,
            source: track.source
        }, track.track ? $d84dc1a5e217b32f$var$getLogContextFromTrack(track.track) : {})
    };
}
function $d84dc1a5e217b32f$var$supportsSynchronizationSources() {
    return typeof RTCRtpReceiver !== "undefined" && "getSynchronizationSources" in RTCRtpReceiver;
}
function $d84dc1a5e217b32f$var$diffAttributes(oldValues, newValues) {
    var _a;
    if (oldValues === undefined) oldValues = {};
    if (newValues === undefined) newValues = {};
    const allKeys = [
        ...Object.keys(newValues),
        ...Object.keys(oldValues)
    ];
    const diff = {};
    for (const key of allKeys)if (oldValues[key] !== newValues[key]) diff[key] = (_a = newValues[key]) !== null && _a !== void 0 ? _a : "";
    return diff;
}
/** @internal */ function $d84dc1a5e217b32f$var$extractProcessorsFromOptions(options) {
    const newOptions = Object.assign({}, options);
    let audioProcessor;
    let videoProcessor;
    if (typeof newOptions.audio === "object" && newOptions.audio.processor) {
        audioProcessor = newOptions.audio.processor;
        newOptions.audio = Object.assign(Object.assign({}, newOptions.audio), {
            processor: undefined
        });
    }
    if (typeof newOptions.video === "object" && newOptions.video.processor) {
        videoProcessor = newOptions.video.processor;
        newOptions.video = Object.assign(Object.assign({}, newOptions.video), {
            processor: undefined
        });
    }
    return {
        audioProcessor: audioProcessor,
        videoProcessor: videoProcessor,
        optionsWithoutProcessor: newOptions
    };
}
const $d84dc1a5e217b32f$var$separator = "|";
const $d84dc1a5e217b32f$var$ddExtensionURI = "https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension";
function $d84dc1a5e217b32f$var$unpackStreamId(packed) {
    const parts = packed.split($d84dc1a5e217b32f$var$separator);
    if (parts.length > 1) return [
        parts[0],
        packed.substr(parts[0].length + 1)
    ];
    return [
        packed,
        ""
    ];
}
function $d84dc1a5e217b32f$var$sleep(duration) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve)=>$d84dc1a5e217b32f$export$22e737276454df96.setTimeout(resolve, duration));
    });
}
/** @internal */ function $d84dc1a5e217b32f$var$supportsTransceiver() {
    return "addTransceiver" in RTCPeerConnection.prototype;
}
/** @internal */ function $d84dc1a5e217b32f$var$supportsAddTrack() {
    return "addTrack" in RTCPeerConnection.prototype;
}
function $d84dc1a5e217b32f$export$5d441b0d5c2caf15() {
    return ResizeObserver, IntersectionObserver, true;
}
function $d84dc1a5e217b32f$export$54d539ea1a521c7e() {
    return $d84dc1a5e217b32f$var$supportsTransceiver();
}
function $d84dc1a5e217b32f$export$f157b33fe3596be1() {
    if (!("getCapabilities" in RTCRtpSender)) return false;
    if ($d84dc1a5e217b32f$var$isSafari()) // Safari 17 on iPhone14 reports AV1 capability, but does not actually support it
    return false;
    const capabilities = RTCRtpSender.getCapabilities("video");
    let hasAV1 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType === "video/AV1") {
            hasAV1 = true;
            break;
        }
    }
    return hasAV1;
}
function $d84dc1a5e217b32f$export$7c4c0f8271043129() {
    if (!("getCapabilities" in RTCRtpSender)) return false;
    if ($d84dc1a5e217b32f$var$isFireFox()) // technically speaking FireFox supports VP9, but SVC publishing is broken
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1633876
    return false;
    if ($d84dc1a5e217b32f$var$isSafari()) {
        const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
        if ((browser === null || browser === void 0 ? void 0 : browser.version) && $d84dc1a5e217b32f$export$66e1c0999abad646(browser.version, "16") < 0) // Safari 16 and below does not support VP9
        return false;
    }
    const capabilities = RTCRtpSender.getCapabilities("video");
    let hasVP9 = false;
    if (capabilities) {
        for (const codec of capabilities.codecs)if (codec.mimeType === "video/VP9") {
            hasVP9 = true;
            break;
        }
    }
    return hasVP9;
}
function $d84dc1a5e217b32f$var$isSVCCodec(codec) {
    return codec === "av1" || codec === "vp9";
}
function $d84dc1a5e217b32f$var$supportsSetSinkId(elm) {
    if (!document) return false;
    if (!elm) elm = document.createElement("audio");
    return "setSinkId" in elm;
}
function $d84dc1a5e217b32f$export$3fe402ec04821f17() {
    if (typeof RTCPeerConnection === "undefined") return false;
    return $d84dc1a5e217b32f$var$supportsTransceiver() || $d84dc1a5e217b32f$var$supportsAddTrack();
}
function $d84dc1a5e217b32f$var$isFireFox() {
    var _a;
    return ((_a = $d84dc1a5e217b32f$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === "Firefox";
}
function $d84dc1a5e217b32f$var$isSafari() {
    var _a;
    return ((_a = $d84dc1a5e217b32f$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.name) === "Safari";
}
function $d84dc1a5e217b32f$var$isSafari17() {
    const b = $d84dc1a5e217b32f$export$89e15fc796a4a429();
    return (b === null || b === void 0 ? void 0 : b.name) === "Safari" && b.version.startsWith("17.");
}
function $d84dc1a5e217b32f$var$isMobile() {
    var _a, _b;
    if (!$d84dc1a5e217b32f$var$isWeb()) return false;
    return(// @ts-expect-error `userAgentData` is not yet part of typescript
    (_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) !== null && _b !== void 0 ? _b : /Tablet|iPad|Mobile|Android|BlackBerry/.test(navigator.userAgent));
}
function $d84dc1a5e217b32f$var$isE2EESimulcastSupported() {
    const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
    const supportedSafariVersion = "17.2"; // see https://bugs.webkit.org/show_bug.cgi?id=257803
    if (browser) {
        if (browser.name !== "Safari" && browser.os !== "iOS") return true;
        else if (browser.os === "iOS" && browser.osVersion && $d84dc1a5e217b32f$export$66e1c0999abad646(supportedSafariVersion, browser.osVersion) >= 0) return true;
        else if (browser.name === "Safari" && $d84dc1a5e217b32f$export$66e1c0999abad646(supportedSafariVersion, browser.version) >= 0) return true;
        else return false;
    }
}
function $d84dc1a5e217b32f$var$isWeb() {
    return typeof document !== "undefined";
}
function $d84dc1a5e217b32f$var$isReactNative() {
    // navigator.product is deprecated on browsers, but will be set appropriately for react-native.
    return navigator.product == "ReactNative";
}
function $d84dc1a5e217b32f$var$isCloud(serverUrl) {
    return serverUrl.hostname.endsWith(".livekit.cloud") || serverUrl.hostname.endsWith(".livekit.run");
}
function $d84dc1a5e217b32f$var$getLKReactNativeInfo() {
    // global defined only for ReactNative.
    // @ts-ignore
    if ($parcel$global && $parcel$global.LiveKitReactNativeGlobal) // @ts-ignore
    return $parcel$global.LiveKitReactNativeGlobal;
    return undefined;
}
function $d84dc1a5e217b32f$var$getReactNativeOs() {
    if (!$d84dc1a5e217b32f$var$isReactNative()) return undefined;
    let info = $d84dc1a5e217b32f$var$getLKReactNativeInfo();
    if (info) return info.platform;
    return undefined;
}
function $d84dc1a5e217b32f$var$getDevicePixelRatio() {
    if ($d84dc1a5e217b32f$var$isWeb()) return window.devicePixelRatio;
    if ($d84dc1a5e217b32f$var$isReactNative()) {
        let info = $d84dc1a5e217b32f$var$getLKReactNativeInfo();
        if (info) return info.devicePixelRatio;
    }
    return 1;
}
function $d84dc1a5e217b32f$export$66e1c0999abad646(v1, v2) {
    const parts1 = v1.split(".");
    const parts2 = v2.split(".");
    const k = Math.min(parts1.length, parts2.length);
    for(let i = 0; i < k; ++i){
        const p1 = parseInt(parts1[i], 10);
        const p2 = parseInt(parts2[i], 10);
        if (p1 > p2) return 1;
        if (p1 < p2) return -1;
        if (i === k - 1 && p1 === p2) return 0;
    }
    if (v1 === "" && v2 !== "") return -1;
    else if (v2 === "") return 1;
    return parts1.length == parts2.length ? 0 : parts1.length < parts2.length ? -1 : 1;
}
function $d84dc1a5e217b32f$var$roDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleResize(entry);
}
function $d84dc1a5e217b32f$var$ioDispatchCallback(entries) {
    for (const entry of entries)entry.target.handleVisibilityChanged(entry);
}
let $d84dc1a5e217b32f$var$resizeObserver = null;
const $d84dc1a5e217b32f$var$getResizeObserver = ()=>{
    if (!$d84dc1a5e217b32f$var$resizeObserver) $d84dc1a5e217b32f$var$resizeObserver = new ResizeObserver($d84dc1a5e217b32f$var$roDispatchCallback);
    return $d84dc1a5e217b32f$var$resizeObserver;
};
let $d84dc1a5e217b32f$var$intersectionObserver = null;
const $d84dc1a5e217b32f$var$getIntersectionObserver = ()=>{
    if (!$d84dc1a5e217b32f$var$intersectionObserver) $d84dc1a5e217b32f$var$intersectionObserver = new IntersectionObserver($d84dc1a5e217b32f$var$ioDispatchCallback, {
        root: null,
        rootMargin: "0px"
    });
    return $d84dc1a5e217b32f$var$intersectionObserver;
};
function $d84dc1a5e217b32f$var$getClientInfo() {
    var _a;
    const info = new $d84dc1a5e217b32f$var$ClientInfo({
        sdk: $d84dc1a5e217b32f$var$ClientInfo_SDK.JS,
        protocol: $d84dc1a5e217b32f$export$94587fadffb515a1,
        version: $d84dc1a5e217b32f$export$83d89fbfd8236492
    });
    if ($d84dc1a5e217b32f$var$isReactNative()) info.os = (_a = $d84dc1a5e217b32f$var$getReactNativeOs()) !== null && _a !== void 0 ? _a : "";
    return info;
}
let $d84dc1a5e217b32f$var$emptyVideoStreamTrack;
function $d84dc1a5e217b32f$export$47f608edbac1bdf7() {
    if (!$d84dc1a5e217b32f$var$emptyVideoStreamTrack) $d84dc1a5e217b32f$var$emptyVideoStreamTrack = $d84dc1a5e217b32f$var$createDummyVideoStreamTrack();
    return $d84dc1a5e217b32f$var$emptyVideoStreamTrack.clone();
}
function $d84dc1a5e217b32f$var$createDummyVideoStreamTrack() {
    let width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
    let height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let paintContent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const canvas = document.createElement("canvas");
    // the canvas size is set to 16 by default, because electron apps seem to fail with smaller values
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx === null || ctx === void 0 || ctx.fillRect(0, 0, canvas.width, canvas.height);
    if (paintContent && ctx) {
        ctx.beginPath();
        ctx.arc(width / 2, height / 2, 50, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fillStyle = "grey";
        ctx.fill();
    }
    // @ts-ignore
    const dummyStream = canvas.captureStream();
    const [dummyTrack] = dummyStream.getTracks();
    if (!dummyTrack) throw Error("Could not get empty media stream video track");
    dummyTrack.enabled = enabled;
    return dummyTrack;
}
let $d84dc1a5e217b32f$var$emptyAudioStreamTrack;
function $d84dc1a5e217b32f$export$59e276d6841f735c() {
    if (!$d84dc1a5e217b32f$var$emptyAudioStreamTrack) {
        // implementation adapted from https://blog.mozilla.org/webrtc/warm-up-with-replacetrack/
        const ctx = new AudioContext();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        gain.gain.setValueAtTime(0, 0);
        const dst = ctx.createMediaStreamDestination();
        oscillator.connect(gain);
        gain.connect(dst);
        oscillator.start();
        [$d84dc1a5e217b32f$var$emptyAudioStreamTrack] = dst.stream.getAudioTracks();
        if (!$d84dc1a5e217b32f$var$emptyAudioStreamTrack) throw Error("Could not get empty media stream audio track");
        $d84dc1a5e217b32f$var$emptyAudioStreamTrack.enabled = false;
    }
    return $d84dc1a5e217b32f$var$emptyAudioStreamTrack.clone();
}
class $d84dc1a5e217b32f$var$Future {
    constructor(futureBase, onFinally){
        this.onFinally = onFinally;
        this.promise = new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.resolve = resolve;
                this.reject = reject;
                if (futureBase) yield futureBase(resolve, reject);
            })).finally(()=>{
            var _a;
            return (_a = this.onFinally) === null || _a === void 0 ? void 0 : _a.call(this);
        });
    }
}
/**
 * Creates and returns an analyser web audio node that is attached to the provided track.
 * Additionally returns a convenience method `calculateVolume` to perform instant volume readings on that track.
 * Call the returned `cleanup` function to close the audioContext that has been created for the instance of this helper
 */ function $d84dc1a5e217b32f$export$c3a30182235995eb(track, options) {
    const opts = Object.assign({
        cloneTrack: false,
        fftSize: 2048,
        smoothingTimeConstant: 0.8,
        minDecibels: -100,
        maxDecibels: -80
    }, options);
    const audioContext = $d84dc1a5e217b32f$var$getNewAudioContext();
    if (!audioContext) throw new Error("Audio Context not supported on this browser");
    const streamTrack = opts.cloneTrack ? track.mediaStreamTrack.clone() : track.mediaStreamTrack;
    const mediaStreamSource = audioContext.createMediaStreamSource(new MediaStream([
        streamTrack
    ]));
    const analyser = audioContext.createAnalyser();
    analyser.minDecibels = opts.minDecibels;
    analyser.maxDecibels = opts.maxDecibels;
    analyser.fftSize = opts.fftSize;
    analyser.smoothingTimeConstant = opts.smoothingTimeConstant;
    mediaStreamSource.connect(analyser);
    const dataArray = new Uint8Array(analyser.frequencyBinCount);
    /**
   * Calculates the current volume of the track in the range from 0 to 1
   */ const calculateVolume = ()=>{
        analyser.getByteFrequencyData(dataArray);
        let sum = 0;
        for (const amplitude of dataArray)sum += Math.pow(amplitude / 255, 2);
        const volume = Math.sqrt(sum / dataArray.length);
        return volume;
    };
    const cleanup = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield audioContext.close();
            if (opts.cloneTrack) streamTrack.stop();
        });
    return {
        calculateVolume: calculateVolume,
        analyser: analyser,
        cleanup: cleanup
    };
}
function $d84dc1a5e217b32f$var$isVideoCodec(maybeCodec) {
    return $d84dc1a5e217b32f$export$986dcb5e6a94a34c.includes(maybeCodec);
}
function $d84dc1a5e217b32f$var$unwrapConstraint(constraint) {
    if (typeof constraint === "string" || typeof constraint === "number") return constraint;
    if (Array.isArray(constraint)) return constraint[0];
    if (constraint.exact) {
        if (Array.isArray(constraint.exact)) return constraint.exact[0];
        return constraint.exact;
    }
    if (constraint.ideal) {
        if (Array.isArray(constraint.ideal)) return constraint.ideal[0];
        return constraint.ideal;
    }
    throw Error("could not unwrap constraint");
}
function $d84dc1a5e217b32f$var$toWebsocketUrl(url) {
    if (url.startsWith("http")) return url.replace(/^(http)/, "ws");
    return url;
}
function $d84dc1a5e217b32f$var$toHttpUrl(url) {
    if (url.startsWith("ws")) return url.replace(/^(ws)/, "http");
    return url;
}
function $d84dc1a5e217b32f$var$extractTranscriptionSegments(transcription, firstReceivedTimesMap) {
    return transcription.segments.map((_ref)=>{
        let { id: id, text: text, language: language, startTime: startTime, endTime: endTime, final: final } = _ref;
        var _a;
        const firstReceivedTime = (_a = firstReceivedTimesMap.get(id)) !== null && _a !== void 0 ? _a : Date.now();
        const lastReceivedTime = Date.now();
        if (final) firstReceivedTimesMap.delete(id);
        else firstReceivedTimesMap.set(id, firstReceivedTime);
        return {
            id: id,
            text: text,
            startTime: Number.parseInt(startTime.toString()),
            endTime: Number.parseInt(endTime.toString()),
            final: final,
            language: language,
            firstReceivedTime: firstReceivedTime,
            lastReceivedTime: lastReceivedTime
        };
    });
}
function $d84dc1a5e217b32f$var$extractChatMessage(msg) {
    const { id: id, timestamp: timestamp, message: message, editTimestamp: editTimestamp } = msg;
    return {
        id: id,
        timestamp: Number.parseInt(timestamp.toString()),
        editTimestamp: editTimestamp ? Number.parseInt(editTimestamp.toString()) : undefined,
        message: message
    };
}
function $d84dc1a5e217b32f$var$getDisconnectReasonFromConnectionError(e) {
    switch(e.reason){
        case $d84dc1a5e217b32f$export$61182a0b21436b65.LeaveRequest:
            return e.context;
        case $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled:
            return $d84dc1a5e217b32f$export$258d16488300d83f.CLIENT_INITIATED;
        case $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed:
            return $d84dc1a5e217b32f$export$258d16488300d83f.USER_REJECTED;
        case $d84dc1a5e217b32f$export$61182a0b21436b65.ServerUnreachable:
            return $d84dc1a5e217b32f$export$258d16488300d83f.JOIN_FAILURE;
        default:
            return $d84dc1a5e217b32f$export$258d16488300d83f.UNKNOWN_REASON;
    }
}
const $d84dc1a5e217b32f$var$defaultId = "default";
class $d84dc1a5e217b32f$var$DeviceManager {
    constructor(){
        this._previousDevices = [];
    }
    static getInstance() {
        if (this.instance === undefined) this.instance = new $d84dc1a5e217b32f$var$DeviceManager();
        return this.instance;
    }
    get previousDevices() {
        return this._previousDevices;
    }
    getDevices(kind_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this = this;
            let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                if (((_a = $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap) === null || _a === void 0 ? void 0 : _a.size) > 0) {
                    $d84dc1a5e217b32f$var$livekitLogger.debug("awaiting getUserMedia promise");
                    try {
                        if (kind) yield $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.get(kind);
                        else yield Promise.all($d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.values());
                    } catch (e) {
                        $d84dc1a5e217b32f$var$livekitLogger.warn("error waiting for media permissons");
                    }
                }
                let devices = yield navigator.mediaDevices.enumerateDevices();
                if (requestPermissions && // for safari we need to skip this check, as otherwise it will re-acquire user media and fail on iOS https://bugs.webkit.org/show_bug.cgi?id=179363
                !($d84dc1a5e217b32f$var$isSafari() && _this.hasDeviceInUse(kind))) {
                    const isDummyDeviceOrEmpty = devices.filter((d)=>d.kind === kind).length === 0 || devices.some((device)=>{
                        const noLabel = device.label === "";
                        const isRelevant = kind ? device.kind === kind : true;
                        return noLabel && isRelevant;
                    });
                    if (isDummyDeviceOrEmpty) {
                        const permissionsToAcquire = {
                            video: kind !== "audioinput" && kind !== "audiooutput",
                            audio: kind !== "videoinput" && {
                                deviceId: "default"
                            }
                        };
                        const stream = yield navigator.mediaDevices.getUserMedia(permissionsToAcquire);
                        devices = yield navigator.mediaDevices.enumerateDevices();
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                    }
                }
                _this._previousDevices = devices;
                if (kind) devices = devices.filter((device)=>device.kind === kind);
                return devices;
            }();
        });
    }
    normalizeDeviceId(kind, deviceId, groupId) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (deviceId !== $d84dc1a5e217b32f$var$defaultId) return deviceId;
            // resolve actual device id if it's 'default': Chrome returns it when no
            // device has been chosen
            const devices = yield this.getDevices(kind);
            const defaultDevice = devices.find((d)=>d.deviceId === $d84dc1a5e217b32f$var$defaultId);
            if (!defaultDevice) {
                $d84dc1a5e217b32f$var$livekitLogger.warn("could not reliably determine default device");
                return undefined;
            }
            const device = devices.find((d)=>d.deviceId !== $d84dc1a5e217b32f$var$defaultId && d.groupId === (groupId !== null && groupId !== void 0 ? groupId : defaultDevice.groupId));
            if (!device) {
                $d84dc1a5e217b32f$var$livekitLogger.warn("could not reliably determine default device");
                return undefined;
            }
            return device === null || device === void 0 ? void 0 : device.deviceId;
        });
    }
    hasDeviceInUse(kind) {
        return kind ? $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.has(kind) : $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.size > 0;
    }
}
$d84dc1a5e217b32f$var$DeviceManager.mediaDeviceKinds = [
    "audioinput",
    "audiooutput",
    "videoinput"
];
$d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap = new Map();
const $d84dc1a5e217b32f$var$defaultDimensionsTimeout = 1000;
class $d84dc1a5e217b32f$export$3e041ce3f33f04dd extends $d84dc1a5e217b32f$export$13921ac0cc260818 {
    /** @internal */ get sender() {
        return this._sender;
    }
    /** @internal */ set sender(sender) {
        this._sender = sender;
    }
    get constraints() {
        return this._constraints;
    }
    /**
   *
   * @param mediaTrack
   * @param kind
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, kind, constraints){
        let userProvidedTrack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, kind, loggerOptions);
        this.manuallyStopped = false;
        this._isUpstreamPaused = false;
        this.handleTrackMuteEvent = ()=>this.debouncedTrackMuteHandler().catch(()=>this.log.debug("track mute bounce got cancelled by an unmute event", this.logContext));
        this.debouncedTrackMuteHandler = $d84dc1a5e217b32f$var$r(()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pauseUpstream();
            }), 5000);
        this.handleTrackUnmuteEvent = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.debouncedTrackMuteHandler.cancel("unmute");
                yield this.resumeUpstream();
            });
        this.handleEnded = ()=>{
            if (this.isInBackground) this.reacquireTrack = true;
            this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent);
            this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent);
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this);
        };
        this.reacquireTrack = false;
        this.providedByUser = userProvidedTrack;
        this.muteLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.pauseUpstreamLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.processorLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.restartLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.setMediaStreamTrack(mediaTrack, true);
        // added to satisfy TS compiler, constraints are synced with MediaStreamTrack
        this._constraints = mediaTrack.getConstraints();
        if (constraints) this._constraints = constraints;
    }
    get id() {
        return this._mediaStreamTrack.id;
    }
    get dimensions() {
        if (this.kind !== $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) return undefined;
        const { width: width, height: height } = this._mediaStreamTrack.getSettings();
        if (width && height) return {
            width: width,
            height: height
        };
        return undefined;
    }
    get isUpstreamPaused() {
        return this._isUpstreamPaused;
    }
    get isUserProvided() {
        return this.providedByUser;
    }
    get mediaStreamTrack() {
        var _a, _b;
        return (_b = (_a = this.processor) === null || _a === void 0 ? void 0 : _a.processedTrack) !== null && _b !== void 0 ? _b : this._mediaStreamTrack;
    }
    /**
   * @internal
   * returns mediaStreamTrack settings of the capturing mediastreamtrack source - ignoring processors
   */ getSourceTrackSettings() {
        return this._mediaStreamTrack.getSettings();
    }
    setMediaStreamTrack(newTrack, force) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (newTrack === this._mediaStreamTrack && !force) return;
            if (this._mediaStreamTrack) {
                // detach
                this.attachedElements.forEach((el)=>{
                    $d84dc1a5e217b32f$export$8ea68c6294970fa5(this._mediaStreamTrack, el);
                });
                this.debouncedTrackMuteHandler.cancel("new-track");
                this._mediaStreamTrack.removeEventListener("ended", this.handleEnded);
                this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent);
                this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent);
            }
            this.mediaStream = new MediaStream([
                newTrack
            ]);
            if (newTrack) {
                newTrack.addEventListener("ended", this.handleEnded);
                // when underlying track emits mute, it indicates that the device is unable
                // to produce media. In this case we'll need to signal with remote that
                // the track is "muted"
                // note this is different from LocalTrack.mute because we do not want to
                // touch MediaStreamTrack.enabled
                newTrack.addEventListener("mute", this.handleTrackMuteEvent);
                newTrack.addEventListener("unmute", this.handleTrackUnmuteEvent);
                this._constraints = newTrack.getConstraints();
            }
            let processedTrack;
            if (this.processor && newTrack) {
                const unlock = yield this.processorLock.lock();
                try {
                    this.log.debug("restarting processor", this.logContext);
                    if (this.kind === "unknown") throw TypeError("cannot set processor on track of unknown kind");
                    if (this.processorElement) {
                        $d84dc1a5e217b32f$export$b8f95ef2322890b8(newTrack, this.processorElement);
                        // ensure the processorElement itself stays muted
                        this.processorElement.muted = true;
                    }
                    yield this.processor.restart({
                        track: newTrack,
                        kind: this.kind,
                        element: this.processorElement
                    });
                    processedTrack = this.processor.processedTrack;
                } finally{
                    unlock();
                }
            }
            if (this.sender) yield this.sender.replaceTrack(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack);
            // if `newTrack` is different from the existing track, stop the
            // older track just before replacing it
            if (!this.providedByUser && this._mediaStreamTrack !== newTrack) this._mediaStreamTrack.stop();
            this._mediaStreamTrack = newTrack;
            if (newTrack) {
                // sync muted state with the enabled state of the newly provided track
                this._mediaStreamTrack.enabled = !this.isMuted;
                // when a valid track is replace, we'd want to start producing
                yield this.resumeUpstream();
                this.attachedElements.forEach((el)=>{
                    $d84dc1a5e217b32f$export$b8f95ef2322890b8(processedTrack !== null && processedTrack !== void 0 ? processedTrack : newTrack, el);
                });
            }
        });
    }
    waitForDimensions() {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d84dc1a5e217b32f$var$defaultDimensionsTimeout;
            return function*() {
                var _a;
                if (_this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) throw new Error("cannot get dimensions for audio tracks");
                if (((_a = $d84dc1a5e217b32f$export$89e15fc796a4a429()) === null || _a === void 0 ? void 0 : _a.os) === "iOS") // browsers report wrong initial resolution on iOS.
                // when slightly delaying the call to .getSettings(), the correct resolution is being reported
                yield $d84dc1a5e217b32f$var$sleep(10);
                const started = Date.now();
                while(Date.now() - started < timeout){
                    const dims = _this.dimensions;
                    if (dims) return dims;
                    yield $d84dc1a5e217b32f$var$sleep(50);
                }
                throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("unable to get track dimensions after timeout");
            }();
        });
    }
    setDeviceId(deviceId) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this._constraints.deviceId === deviceId && this._mediaStreamTrack.getSettings().deviceId === $d84dc1a5e217b32f$var$unwrapConstraint(deviceId)) return true;
            this._constraints.deviceId = deviceId;
            // when track is muted, underlying media stream track is stopped and
            // will be restarted later
            if (this.isMuted) return true;
            yield this.restartTrack();
            return $d84dc1a5e217b32f$var$unwrapConstraint(deviceId) === this._mediaStreamTrack.getSettings().deviceId;
        });
    }
    /**
   * @returns DeviceID of the device that is currently being used for this track
   */ getDeviceId() {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function() {
            var _this2 = this;
            let normalize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                // screen share doesn't have a usable device id
                if (_this2.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare) return;
                const { deviceId: deviceId, groupId: groupId } = _this2._mediaStreamTrack.getSettings();
                const kind = _this2.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio ? "audioinput" : "videoinput";
                return normalize ? $d84dc1a5e217b32f$var$DeviceManager.getInstance().normalizeDeviceId(kind, deviceId, groupId) : deviceId;
            }();
        });
    }
    mute() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(true);
            return this;
        });
    }
    unmute() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.setTrackMuted(false);
            return this;
        });
    }
    replaceTrack(track, userProvidedOrOptions) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.sender) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("unable to replace an unpublished track");
            let userProvidedTrack;
            let stopProcessor;
            if (typeof userProvidedOrOptions === "boolean") userProvidedTrack = userProvidedOrOptions;
            else if (userProvidedOrOptions !== undefined) {
                userProvidedTrack = userProvidedOrOptions.userProvidedTrack;
                stopProcessor = userProvidedOrOptions.stopProcessor;
            }
            this.providedByUser = userProvidedTrack !== null && userProvidedTrack !== void 0 ? userProvidedTrack : true;
            this.log.debug("replace MediaStreamTrack", this.logContext);
            yield this.setMediaStreamTrack(track);
            // this must be synced *after* setting mediaStreamTrack above, since it relies
            // on the previous state in order to cleanup
            if (stopProcessor && this.processor) yield this.stopProcessor();
            return this;
        });
    }
    restart(constraints) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.manuallyStopped = false;
            const unlock = yield this.restartLock.lock();
            try {
                if (!constraints) constraints = this._constraints;
                this.log.debug("restarting track with constraints", Object.assign(Object.assign({}, this.logContext), {
                    constraints: constraints
                }));
                const streamConstraints = {
                    audio: false,
                    video: false
                };
                if (this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) streamConstraints.video = constraints;
                else streamConstraints.audio = constraints;
                // these steps are duplicated from setMediaStreamTrack because we must stop
                // the previous tracks before new tracks can be acquired
                this.attachedElements.forEach((el)=>{
                    $d84dc1a5e217b32f$export$8ea68c6294970fa5(this.mediaStreamTrack, el);
                });
                this._mediaStreamTrack.removeEventListener("ended", this.handleEnded);
                // on Safari, the old audio track must be stopped before attempting to acquire
                // the new track, otherwise the new track will stop with
                // 'A MediaStreamTrack ended due to a capture failure`
                this._mediaStreamTrack.stop();
                // create new track and attach
                const mediaStream = yield navigator.mediaDevices.getUserMedia(streamConstraints);
                const newTrack = mediaStream.getTracks()[0];
                newTrack.addEventListener("ended", this.handleEnded);
                this.log.debug("re-acquired MediaStreamTrack", this.logContext);
                yield this.setMediaStreamTrack(newTrack);
                this._constraints = constraints;
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Restarted, this);
                if (this.manuallyStopped) {
                    this.log.warn("track was stopped during a restart, stopping restarted track", this.logContext);
                    this.stop();
                }
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        this.log.debug("setting ".concat(this.kind, " track ").concat(muted ? "muted" : "unmuted"), this.logContext);
        if (this.isMuted === muted && this._mediaStreamTrack.enabled !== muted) return;
        this.isMuted = muted;
        this._mediaStreamTrack.enabled = !muted;
        this.emit(muted ? $d84dc1a5e217b32f$export$2c8510d737cc09da.Muted : $d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this);
    }
    get needsReAcquisition() {
        return this._mediaStreamTrack.readyState !== "live" || this._mediaStreamTrack.muted || !this._mediaStreamTrack.enabled || this.reacquireTrack;
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$d84dc1a5e217b32f$var$isMobile()) return;
            this.log.debug("visibility changed, is in Background: ".concat(this.isInBackground), this.logContext);
            if (!this.isInBackground && this.needsReAcquisition && !this.isUserProvided && !this.isMuted) {
                this.log.debug("track needs to be reacquired, restarting ".concat(this.source), this.logContext);
                yield this.restart();
                this.reacquireTrack = false;
            }
        });
    }
    stop() {
        var _a;
        this.manuallyStopped = true;
        super.stop();
        this._mediaStreamTrack.removeEventListener("ended", this.handleEnded);
        this._mediaStreamTrack.removeEventListener("mute", this.handleTrackMuteEvent);
        this._mediaStreamTrack.removeEventListener("unmute", this.handleTrackUnmuteEvent);
        (_a = this.processor) === null || _a === void 0 || _a.destroy();
        this.processor = undefined;
    }
    /**
   * pauses publishing to the server without disabling the local MediaStreamTrack
   * this is used to display a user's own video locally while pausing publishing to
   * the server.
   * this API is unsupported on Safari < 12 due to a bug
   **/ pauseUpstream() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === true) return;
                if (!this.sender) {
                    this.log.warn("unable to pause upstream for an unpublished track", this.logContext);
                    return;
                }
                this._isUpstreamPaused = true;
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamPaused, this);
                const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
                if ((browser === null || browser === void 0 ? void 0 : browser.name) === "Safari" && $d84dc1a5e217b32f$export$66e1c0999abad646(browser.version, "12.0") < 0) // https://bugs.webkit.org/show_bug.cgi?id=184911
                throw new $d84dc1a5e217b32f$export$38c5ac268e2fa84("pauseUpstream is not supported on Safari < 12.");
                yield this.sender.replaceTrack(null);
            } finally{
                unlock();
            }
        });
    }
    resumeUpstream() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.pauseUpstreamLock.lock();
            try {
                if (this._isUpstreamPaused === false) return;
                if (!this.sender) {
                    this.log.warn("unable to resume upstream for an unpublished track", this.logContext);
                    return;
                }
                this._isUpstreamPaused = false;
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamResumed, this);
                // this operation is noop if mediastreamtrack is already being sent
                yield this.sender.replaceTrack(this.mediaStreamTrack);
            } finally{
                unlock();
            }
        });
    }
    /**
   * Gets the RTCStatsReport for the LocalTrack's underlying RTCRtpSender
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.sender.getStats();
            return statsReport;
        });
    }
    /**
   * Sets a processor on this track.
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   *
   * @param processor
   * @param showProcessedStreamLocally
   * @returns
   */ setProcessor(processor_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this3 = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a;
                const unlock = yield _this3.processorLock.lock();
                try {
                    _this3.log.debug("setting up processor", _this3.logContext);
                    const processorElement = document.createElement(_this3.kind);
                    const processorOptions = {
                        kind: _this3.kind,
                        track: _this3._mediaStreamTrack,
                        element: processorElement,
                        audioContext: _this3.audioContext
                    };
                    yield processor.init(processorOptions);
                    _this3.log.debug("processor initialized", _this3.logContext);
                    if (_this3.processor) yield _this3.stopProcessor();
                    if (_this3.kind === "unknown") throw TypeError("cannot set processor on track of unknown kind");
                    $d84dc1a5e217b32f$export$b8f95ef2322890b8(_this3._mediaStreamTrack, processorElement);
                    processorElement.muted = true;
                    processorElement.play().catch((error)=>_this3.log.error("failed to play processor element", Object.assign(Object.assign({}, _this3.logContext), {
                            error: error
                        })));
                    _this3.processor = processor;
                    _this3.processorElement = processorElement;
                    if (_this3.processor.processedTrack) {
                        for (const el of _this3.attachedElements)if (el !== _this3.processorElement && showProcessedStreamLocally) {
                            $d84dc1a5e217b32f$export$8ea68c6294970fa5(_this3._mediaStreamTrack, el);
                            $d84dc1a5e217b32f$export$b8f95ef2322890b8(_this3.processor.processedTrack, el);
                        }
                        yield (_a = _this3.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(_this3.processor.processedTrack);
                    }
                    _this3.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.TrackProcessorUpdate, _this3.processor);
                } finally{
                    unlock();
                }
            }();
        });
    }
    getProcessor() {
        return this.processor;
    }
    /**
   * Stops the track processor
   * See https://github.com/livekit/track-processors-js for example usage
   *
   * @experimental
   * @returns
   */ stopProcessor() {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function() {
            var _this4 = this;
            let keepElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                var _a, _b;
                if (!_this4.processor) return;
                _this4.log.debug("stopping processor", _this4.logContext);
                (_a = _this4.processor.processedTrack) === null || _a === void 0 || _a.stop();
                yield _this4.processor.destroy();
                _this4.processor = undefined;
                if (!keepElement) {
                    (_b = _this4.processorElement) === null || _b === void 0 || _b.remove();
                    _this4.processorElement = undefined;
                }
                // apply original track constraints in case the processor changed them
                yield _this4._mediaStreamTrack.applyConstraints(_this4._constraints);
                // force re-setting of the mediaStreamTrack on the sender
                yield _this4.setMediaStreamTrack(_this4._mediaStreamTrack, true);
                _this4.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.TrackProcessorUpdate);
            }();
        });
    }
}
/**
 * @experimental
 */ class $d84dc1a5e217b32f$var$E2EEManager extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(options){
        super();
        this.onWorkerMessage = (ev)=>{
            var _a, _b;
            const { kind: kind, data: data } = ev.data;
            switch(kind){
                case "error":
                    $d84dc1a5e217b32f$var$livekitLogger.error(data.error.message);
                    this.emit($d84dc1a5e217b32f$export$36ec54aef832f50f.EncryptionError, data.error);
                    break;
                case "initAck":
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo);
                    });
                    break;
                case "enable":
                    if (data.enabled) this.keyProvider.getKeys().forEach((keyInfo)=>{
                        this.postKey(keyInfo);
                    });
                    if (this.encryptionEnabled !== data.enabled && data.participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) {
                        this.emit($d84dc1a5e217b32f$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, this.room.localParticipant);
                        this.encryptionEnabled = data.enabled;
                    } else if (data.participantIdentity) {
                        const participant = (_b = this.room) === null || _b === void 0 ? void 0 : _b.getParticipantByIdentity(data.participantIdentity);
                        if (!participant) throw TypeError("couldn't set encryption status, participant not found".concat(data.participantIdentity));
                        this.emit($d84dc1a5e217b32f$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, data.enabled, participant);
                    }
                    break;
                case "ratchetKey":
                    this.keyProvider.emit($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.KeyRatcheted, data.material, data.keyIndex);
                    break;
            }
        };
        this.onWorkerError = (ev)=>{
            $d84dc1a5e217b32f$var$livekitLogger.error("e2ee worker encountered an error:", {
                error: ev.error
            });
            this.emit($d84dc1a5e217b32f$export$36ec54aef832f50f.EncryptionError, ev.error);
        };
        this.keyProvider = options.keyProvider;
        this.worker = options.worker;
        this.encryptionEnabled = false;
    }
    /**
   * @internal
   */ setup(room) {
        if (!$d84dc1a5e217b32f$export$2c53d20185b28316()) throw new $d84dc1a5e217b32f$export$38c5ac268e2fa84("tried to setup end-to-end encryption on an unsupported browser");
        $d84dc1a5e217b32f$var$livekitLogger.info("setting up e2ee");
        if (room !== this.room) {
            this.room = room;
            this.setupEventListeners(room, this.keyProvider);
            // this.worker = new Worker('');
            const msg = {
                kind: "init",
                data: {
                    keyProviderOptions: this.keyProvider.getOptions(),
                    loglevel: $d84dc1a5e217b32f$var$workerLogger.getLevel()
                }
            };
            if (this.worker) {
                $d84dc1a5e217b32f$var$livekitLogger.info("initializing worker", {
                    worker: this.worker
                });
                this.worker.onmessage = this.onWorkerMessage;
                this.worker.onerror = this.onWorkerError;
                this.worker.postMessage(msg);
            }
        }
    }
    /**
   * @internal
   */ setParticipantCryptorEnabled(enabled, participantIdentity) {
        $d84dc1a5e217b32f$var$livekitLogger.debug("set e2ee to ".concat(enabled, " for participant ").concat(participantIdentity));
        this.postEnable(enabled, participantIdentity);
    }
    /**
   * @internal
   */ setSifTrailer(trailer) {
        if (!trailer || trailer.length === 0) $d84dc1a5e217b32f$var$livekitLogger.warn("ignoring server sent trailer as it's empty");
        else this.postSifTrailer(trailer);
    }
    setupEngine(engine) {
        engine.on($d84dc1a5e217b32f$export$c09e63b8572f869.RTPVideoMapUpdate, (rtpMap)=>{
            this.postRTPMap(rtpMap);
        });
    }
    setupEventListeners(room, keyProvider) {
        room.on($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackPublished, (pub, participant)=>this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $d84dc1a5e217b32f$var$Encryption_Type.NONE, participant.identity));
        room.on($d84dc1a5e217b32f$export$3159c672e3b2293a.ConnectionStateChanged, (state)=>{
            if (state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected) room.remoteParticipants.forEach((participant)=>{
                participant.trackPublications.forEach((pub)=>{
                    this.setParticipantCryptorEnabled(pub.trackInfo.encryption !== $d84dc1a5e217b32f$var$Encryption_Type.NONE, participant.identity);
                });
            });
        }).on($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackUnsubscribed, (track, _, participant)=>{
            var _a;
            const msg = {
                kind: "removeTransform",
                data: {
                    participantIdentity: participant.identity,
                    trackId: track.mediaStreamID
                }
            };
            (_a = this.worker) === null || _a === void 0 || _a.postMessage(msg);
        }).on($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscribed, (track, pub, participant)=>{
            this.setupE2EEReceiver(track, participant.identity, pub.trackInfo);
        }).on($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalConnected, ()=>{
            if (!this.room) throw new TypeError("expected room to be present on signal connect");
            keyProvider.getKeys().forEach((keyInfo)=>{
                this.postKey(keyInfo);
            });
            this.setParticipantCryptorEnabled(this.room.localParticipant.isE2EEEnabled, this.room.localParticipant.identity);
        });
        room.localParticipant.on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, (publication)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.setupE2EESender(publication.track, publication.track.sender);
            }));
        keyProvider.on($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.SetKey, (keyInfo)=>this.postKey(keyInfo)).on($d84dc1a5e217b32f$export$432ceae3bd7b5ad3.RatchetRequest, (participantId, keyIndex)=>this.postRatchetRequest(participantId, keyIndex));
    }
    postRatchetRequest(participantIdentity, keyIndex) {
        if (!this.worker) throw Error("could not ratchet key, worker is missing");
        const msg = {
            kind: "ratchetRequest",
            data: {
                participantIdentity: participantIdentity,
                keyIndex: keyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postKey(_ref) {
        let { key: key, participantIdentity: participantIdentity, keyIndex: keyIndex } = _ref;
        var _a;
        if (!this.worker) throw Error("could not set key, worker is missing");
        const msg = {
            kind: "setKey",
            data: {
                participantIdentity: participantIdentity,
                isPublisher: participantIdentity === ((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity),
                key: key,
                keyIndex: keyIndex
            }
        };
        this.worker.postMessage(msg);
    }
    postEnable(enabled, participantIdentity) {
        if (this.worker) {
            const enableMsg = {
                kind: "enable",
                data: {
                    enabled: enabled,
                    participantIdentity: participantIdentity
                }
            };
            this.worker.postMessage(enableMsg);
        } else throw new ReferenceError("failed to enable e2ee, worker is not ready");
    }
    postRTPMap(map) {
        var _a;
        if (!this.worker) throw TypeError("could not post rtp map, worker is missing");
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity)) throw TypeError("could not post rtp map, local participant identity is missing");
        const msg = {
            kind: "setRTPMap",
            data: {
                map: map,
                participantIdentity: this.room.localParticipant.identity
            }
        };
        this.worker.postMessage(msg);
    }
    postSifTrailer(trailer) {
        if (!this.worker) throw Error("could not post SIF trailer, worker is missing");
        const msg = {
            kind: "setSifTrailer",
            data: {
                trailer: trailer
            }
        };
        this.worker.postMessage(msg);
    }
    setupE2EEReceiver(track, remoteId, trackInfo) {
        if (!track.receiver) return;
        if (!(trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.mimeType) || trackInfo.mimeType === "") throw new TypeError("MimeType missing from trackInfo, cannot set up E2EE cryptor");
        this.handleReceiver(track.receiver, track.mediaStreamID, remoteId, track.kind === "video" ? $d84dc1a5e217b32f$var$mimeTypeToVideoCodecString(trackInfo.mimeType) : undefined);
    }
    setupE2EESender(track, sender) {
        if (!(track instanceof $d84dc1a5e217b32f$export$3e041ce3f33f04dd) || !sender) {
            if (!sender) $d84dc1a5e217b32f$var$livekitLogger.warn("early return because sender is not ready");
            return;
        }
        this.handleSender(sender, track.mediaStreamID, undefined);
    }
    /**
   * Handles the given {@code RTCRtpReceiver} by creating a {@code TransformStream} which will inject
   * a frame decoder.
   *
   */ handleReceiver(receiver, trackId, participantIdentity, codec) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.worker) return;
            if ($d84dc1a5e217b32f$export$6bf50ac7ca24af81()) {
                const options = {
                    kind: "decode",
                    participantIdentity: participantIdentity,
                    trackId: trackId,
                    codec: codec
                };
                // @ts-ignore
                receiver.transform = new RTCRtpScriptTransform(this.worker, options);
            } else {
                if ($d84dc1a5e217b32f$var$E2EE_FLAG in receiver && codec) {
                    // only update codec
                    const msg = {
                        kind: "updateCodec",
                        data: {
                            trackId: trackId,
                            codec: codec,
                            participantIdentity: participantIdentity
                        }
                    };
                    this.worker.postMessage(msg);
                    return;
                }
                // @ts-ignore
                let writable = receiver.writableStream;
                // @ts-ignore
                let readable = receiver.readableStream;
                if (!writable || !readable) {
                    // @ts-ignore
                    const receiverStreams = receiver.createEncodedStreams();
                    // @ts-ignore
                    receiver.writableStream = receiverStreams.writable;
                    writable = receiverStreams.writable;
                    // @ts-ignore
                    receiver.readableStream = receiverStreams.readable;
                    readable = receiverStreams.readable;
                }
                const msg = {
                    kind: "decode",
                    data: {
                        readableStream: readable,
                        writableStream: writable,
                        trackId: trackId,
                        codec: codec,
                        participantIdentity: participantIdentity
                    }
                };
                this.worker.postMessage(msg, [
                    readable,
                    writable
                ]);
            }
            // @ts-ignore
            receiver[$d84dc1a5e217b32f$var$E2EE_FLAG] = true;
        });
    }
    /**
   * Handles the given {@code RTCRtpSender} by creating a {@code TransformStream} which will inject
   * a frame encoder.
   *
   */ handleSender(sender, trackId, codec) {
        var _a;
        if ($d84dc1a5e217b32f$var$E2EE_FLAG in sender || !this.worker) return;
        if (!((_a = this.room) === null || _a === void 0 ? void 0 : _a.localParticipant.identity) || this.room.localParticipant.identity === "") throw TypeError("local identity needs to be known in order to set up encrypted sender");
        if ($d84dc1a5e217b32f$export$6bf50ac7ca24af81()) {
            $d84dc1a5e217b32f$var$livekitLogger.info("initialize script transform");
            const options = {
                kind: "encode",
                participantIdentity: this.room.localParticipant.identity,
                trackId: trackId,
                codec: codec
            };
            // @ts-ignore
            sender.transform = new RTCRtpScriptTransform(this.worker, options);
        } else {
            $d84dc1a5e217b32f$var$livekitLogger.info("initialize encoded streams");
            // @ts-ignore
            const senderStreams = sender.createEncodedStreams();
            const msg = {
                kind: "encode",
                data: {
                    readableStream: senderStreams.readable,
                    writableStream: senderStreams.writable,
                    codec: codec,
                    trackId: trackId,
                    participantIdentity: this.room.localParticipant.identity
                }
            };
            this.worker.postMessage(msg, [
                senderStreams.readable,
                senderStreams.writable
            ]);
        }
        // @ts-ignore
        sender[$d84dc1a5e217b32f$var$E2EE_FLAG] = true;
    }
}
var $d84dc1a5e217b32f$var$QueueTaskStatus;
(function(QueueTaskStatus) {
    QueueTaskStatus[QueueTaskStatus["WAITING"] = 0] = "WAITING";
    QueueTaskStatus[QueueTaskStatus["RUNNING"] = 1] = "RUNNING";
    QueueTaskStatus[QueueTaskStatus["COMPLETED"] = 2] = "COMPLETED";
})($d84dc1a5e217b32f$var$QueueTaskStatus || ($d84dc1a5e217b32f$var$QueueTaskStatus = {}));
class $d84dc1a5e217b32f$var$AsyncQueue {
    constructor(){
        this.pendingTasks = new Map();
        this.taskMutex = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.nextTaskIndex = 0;
    }
    run(task) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const taskInfo = {
                id: this.nextTaskIndex++,
                enqueuedAt: Date.now(),
                status: $d84dc1a5e217b32f$var$QueueTaskStatus.WAITING
            };
            this.pendingTasks.set(taskInfo.id, taskInfo);
            const unlock = yield this.taskMutex.lock();
            try {
                taskInfo.executedAt = Date.now();
                taskInfo.status = $d84dc1a5e217b32f$var$QueueTaskStatus.RUNNING;
                return yield task();
            } finally{
                taskInfo.status = $d84dc1a5e217b32f$var$QueueTaskStatus.COMPLETED;
                this.pendingTasks.delete(taskInfo.id);
                unlock();
            }
        });
    }
    flush() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.run(()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {}));
        });
    }
    snapshot() {
        return Array.from(this.pendingTasks.values());
    }
}
const $d84dc1a5e217b32f$var$passThroughQueueSignals = [
    "syncState",
    "trickle",
    "offer",
    "answer",
    "simulate",
    "leave"
];
function $d84dc1a5e217b32f$var$canPassThroughQueue(req) {
    const canPass = $d84dc1a5e217b32f$var$passThroughQueueSignals.indexOf(req.case) >= 0;
    $d84dc1a5e217b32f$var$livekitLogger.trace("request allowed to bypass queue:", {
        canPass: canPass,
        req: req
    });
    return canPass;
}
var $d84dc1a5e217b32f$var$SignalConnectionState;
(function(SignalConnectionState) {
    SignalConnectionState[SignalConnectionState["CONNECTING"] = 0] = "CONNECTING";
    SignalConnectionState[SignalConnectionState["CONNECTED"] = 1] = "CONNECTED";
    SignalConnectionState[SignalConnectionState["RECONNECTING"] = 2] = "RECONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTING"] = 3] = "DISCONNECTING";
    SignalConnectionState[SignalConnectionState["DISCONNECTED"] = 4] = "DISCONNECTED";
})($d84dc1a5e217b32f$var$SignalConnectionState || ($d84dc1a5e217b32f$var$SignalConnectionState = {}));
/** @internal */ class $d84dc1a5e217b32f$var$SignalClient {
    get currentState() {
        return this.state;
    }
    get isDisconnected() {
        return this.state === $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTING || this.state === $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED;
    }
    get isEstablishingConnection() {
        return this.state === $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTING || this.state === $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING;
    }
    getNextRequestId() {
        this._requestId += 1;
        return this._requestId;
    }
    constructor(){
        let useJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        /** signal rtt in milliseconds */ this.rtt = 0;
        this.state = $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this._requestId = 0;
        /** @internal */ this.resetCallbacks = ()=>{
            this.onAnswer = undefined;
            this.onLeave = undefined;
            this.onLocalTrackPublished = undefined;
            this.onLocalTrackUnpublished = undefined;
            this.onNegotiateRequested = undefined;
            this.onOffer = undefined;
            this.onRemoteMuteChanged = undefined;
            this.onSubscribedQualityUpdate = undefined;
            this.onTokenRefresh = undefined;
            this.onTrickle = undefined;
            this.onClose = undefined;
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Signal);
        this.loggerContextCb = loggerOptions.loggerContextCb;
        this.useJSON = useJSON;
        this.requestQueue = new $d84dc1a5e217b32f$var$AsyncQueue();
        this.queuedRequests = [];
        this.closingLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.connectionLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.state = $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED;
    }
    get logContext() {
        var _a, _b;
        return (_b = (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : {};
    }
    join(url, token, opts, abortSignal) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            // during a full reconnect, we'd want to start the sequence even if currently
            // connected
            this.state = $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTING;
            this.options = opts;
            const res = yield this.connect(url, token, opts, abortSignal);
            return res;
        });
    }
    reconnect(url, token, sid, reason) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.options) {
                this.log.warn("attempted to reconnect without signal options being set, ignoring", this.logContext);
                return;
            }
            this.state = $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING;
            // clear ping interval and restart it once reconnected
            this.clearPingInterval();
            const res = yield this.connect(url, token, Object.assign(Object.assign({}, this.options), {
                reconnect: true,
                sid: sid,
                reconnectReason: reason
            }));
            return res;
        });
    }
    connect(url, token, opts, abortSignal) {
        this.connectOptions = opts;
        url = $d84dc1a5e217b32f$var$toWebsocketUrl(url);
        // strip trailing slash
        url = url.replace(/\/$/, "");
        url += "/rtc";
        const clientInfo = $d84dc1a5e217b32f$var$getClientInfo();
        const params = $d84dc1a5e217b32f$var$createConnectionParams(token, clientInfo, opts);
        return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                const unlock = yield this.connectionLock.lock();
                try {
                    const abortHandler = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            this.close();
                            clearTimeout(wsTimeout);
                            reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("room connection has been cancelled (signal)", $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled));
                        });
                    const wsTimeout = setTimeout(()=>{
                        this.close();
                        reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("room connection has timed out (signal)", $d84dc1a5e217b32f$export$61182a0b21436b65.ServerUnreachable));
                    }, opts.websocketTimeout);
                    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) abortHandler();
                    abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", abortHandler);
                    this.log.debug("connecting to ".concat(url + params), this.logContext);
                    if (this.ws) yield this.close(false);
                    this.ws = new WebSocket(url + params);
                    this.ws.binaryType = "arraybuffer";
                    this.ws.onopen = ()=>{
                        clearTimeout(wsTimeout);
                    };
                    this.ws.onerror = (ev)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            if (this.state !== $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED) {
                                this.state = $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED;
                                clearTimeout(wsTimeout);
                                try {
                                    const resp = yield fetch("http".concat(url.substring(2), "/validate").concat(params));
                                    if (resp.status.toFixed(0).startsWith("4")) {
                                        const msg = yield resp.text();
                                        reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb(msg, $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed, resp.status));
                                    } else reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Internal error", $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError, resp.status));
                                } catch (e) {
                                    reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("server was not reachable", $d84dc1a5e217b32f$export$61182a0b21436b65.ServerUnreachable));
                                }
                                return;
                            }
                            // other errors, handle
                            this.handleWSError(ev);
                        });
                    this.ws.onmessage = (ev)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            var _a, _b, _c;
                            // not considered connected until JoinResponse is received
                            let resp;
                            if (typeof ev.data === "string") {
                                const json = JSON.parse(ev.data);
                                resp = $d84dc1a5e217b32f$var$SignalResponse.fromJson(json, {
                                    ignoreUnknownFields: true
                                });
                            } else if (ev.data instanceof ArrayBuffer) resp = $d84dc1a5e217b32f$var$SignalResponse.fromBinary(new Uint8Array(ev.data));
                            else {
                                this.log.error("could not decode websocket message: ".concat(typeof ev.data), this.logContext);
                                return;
                            }
                            if (this.state !== $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED) {
                                let shouldProcessMessage = false;
                                // handle join message only
                                if (((_a = resp.message) === null || _a === void 0 ? void 0 : _a.case) === "join") {
                                    this.state = $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED;
                                    abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", abortHandler);
                                    this.pingTimeoutDuration = resp.message.value.pingTimeout;
                                    this.pingIntervalDuration = resp.message.value.pingInterval;
                                    if (this.pingTimeoutDuration && this.pingTimeoutDuration > 0) {
                                        this.log.debug("ping config", Object.assign(Object.assign({}, this.logContext), {
                                            timeout: this.pingTimeoutDuration,
                                            interval: this.pingIntervalDuration
                                        }));
                                        this.startPingInterval();
                                    }
                                    resolve(resp.message.value);
                                } else if (this.state === $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING && resp.message.case !== "leave") {
                                    // in reconnecting, any message received means signal reconnected
                                    this.state = $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED;
                                    abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", abortHandler);
                                    this.startPingInterval();
                                    if (((_b = resp.message) === null || _b === void 0 ? void 0 : _b.case) === "reconnect") resolve(resp.message.value);
                                    else {
                                        this.log.debug("declaring signal reconnected without reconnect response received", this.logContext);
                                        resolve(undefined);
                                        shouldProcessMessage = true;
                                    }
                                } else if (this.isEstablishingConnection && resp.message.case === "leave") reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Received leave request while trying to (re)connect", $d84dc1a5e217b32f$export$61182a0b21436b65.LeaveRequest, undefined, resp.message.value.reason));
                                else if (!opts.reconnect) // non-reconnect case, should receive join response first
                                reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("did not receive join response, got ".concat((_c = resp.message) === null || _c === void 0 ? void 0 : _c.case, " instead"), $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError));
                                if (!shouldProcessMessage) return;
                            }
                            if (this.signalLatency) yield $d84dc1a5e217b32f$var$sleep(this.signalLatency);
                            this.handleSignalResponse(resp);
                        });
                    this.ws.onclose = (ev)=>{
                        if (this.isEstablishingConnection) reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Websocket got closed during a (re)connection attempt", $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError));
                        this.log.warn("websocket closed", Object.assign(Object.assign({}, this.logContext), {
                            reason: ev.reason,
                            code: ev.code,
                            wasClean: ev.wasClean,
                            state: this.state
                        }));
                        this.handleOnClose(ev.reason);
                    };
                } finally{
                    unlock();
                }
            }));
    }
    close() {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function() {
            var _this = this;
            let updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            return function*() {
                const unlock = yield _this.closingLock.lock();
                try {
                    _this.clearPingInterval();
                    if (updateState) _this.state = $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTING;
                    if (_this.ws) {
                        _this.ws.onmessage = null;
                        _this.ws.onopen = null;
                        _this.ws.onclose = null;
                        // calling `ws.close()` only starts the closing handshake (CLOSING state), prefer to wait until state is actually CLOSED
                        const closePromise = new Promise((resolve)=>{
                            if (_this.ws) _this.ws.onclose = ()=>{
                                resolve();
                            };
                            else resolve();
                        });
                        if (_this.ws.readyState < _this.ws.CLOSING) {
                            _this.ws.close();
                            // 250ms grace period for ws to close gracefully
                            yield Promise.race([
                                closePromise,
                                $d84dc1a5e217b32f$var$sleep(250)
                            ]);
                        }
                        _this.ws = undefined;
                    }
                } finally{
                    if (updateState) _this.state = $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED;
                    unlock();
                }
            }();
        });
    }
    // initial offer after joining
    sendOffer(offer) {
        this.log.debug("sending offer", Object.assign(Object.assign({}, this.logContext), {
            offerSdp: offer.sdp
        }));
        this.sendRequest({
            case: "offer",
            value: $d84dc1a5e217b32f$var$toProtoSessionDescription(offer)
        });
    }
    // answer a server-initiated offer
    sendAnswer(answer) {
        this.log.debug("sending answer", Object.assign(Object.assign({}, this.logContext), {
            answerSdp: answer.sdp
        }));
        return this.sendRequest({
            case: "answer",
            value: $d84dc1a5e217b32f$var$toProtoSessionDescription(answer)
        });
    }
    sendIceCandidate(candidate, target) {
        this.log.trace("sending ice candidate", Object.assign(Object.assign({}, this.logContext), {
            candidate: candidate
        }));
        return this.sendRequest({
            case: "trickle",
            value: new $d84dc1a5e217b32f$var$TrickleRequest({
                candidateInit: JSON.stringify(candidate),
                target: target
            })
        });
    }
    sendMuteTrack(trackSid, muted) {
        return this.sendRequest({
            case: "mute",
            value: new $d84dc1a5e217b32f$var$MuteTrackRequest({
                sid: trackSid,
                muted: muted
            })
        });
    }
    sendAddTrack(req) {
        return this.sendRequest({
            case: "addTrack",
            value: req
        });
    }
    sendUpdateLocalMetadata(metadata_1, name_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(metadata, name) {
            var _this2 = this;
            let attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return function*() {
                const requestId = _this2.getNextRequestId();
                yield _this2.sendRequest({
                    case: "updateMetadata",
                    value: new $d84dc1a5e217b32f$var$UpdateParticipantMetadata({
                        requestId: requestId,
                        metadata: metadata,
                        name: name,
                        attributes: attributes
                    })
                });
                return requestId;
            }();
        });
    }
    sendUpdateTrackSettings(settings) {
        this.sendRequest({
            case: "trackSetting",
            value: settings
        });
    }
    sendUpdateSubscription(sub) {
        return this.sendRequest({
            case: "subscription",
            value: sub
        });
    }
    sendSyncState(sync) {
        return this.sendRequest({
            case: "syncState",
            value: sync
        });
    }
    sendUpdateVideoLayers(trackSid, layers) {
        return this.sendRequest({
            case: "updateLayers",
            value: new $d84dc1a5e217b32f$var$UpdateVideoLayers({
                trackSid: trackSid,
                layers: layers
            })
        });
    }
    sendUpdateSubscriptionPermissions(allParticipants, trackPermissions) {
        return this.sendRequest({
            case: "subscriptionPermission",
            value: new $d84dc1a5e217b32f$var$SubscriptionPermission({
                allParticipants: allParticipants,
                trackPermissions: trackPermissions
            })
        });
    }
    sendSimulateScenario(scenario) {
        return this.sendRequest({
            case: "simulate",
            value: scenario
        });
    }
    sendPing() {
        /** send both of ping and pingReq for compatibility to old and new server */ return Promise.all([
            this.sendRequest({
                case: "ping",
                value: $d84dc1a5e217b32f$var$protoInt64.parse(Date.now())
            }),
            this.sendRequest({
                case: "pingReq",
                value: new $d84dc1a5e217b32f$var$Ping({
                    timestamp: $d84dc1a5e217b32f$var$protoInt64.parse(Date.now()),
                    rtt: $d84dc1a5e217b32f$var$protoInt64.parse(this.rtt)
                })
            })
        ]);
    }
    sendUpdateLocalAudioTrack(trackSid, features) {
        return this.sendRequest({
            case: "updateAudioTrack",
            value: new $d84dc1a5e217b32f$var$UpdateLocalAudioTrack({
                trackSid: trackSid,
                features: features
            })
        });
    }
    sendLeave() {
        return this.sendRequest({
            case: "leave",
            value: new $d84dc1a5e217b32f$var$LeaveRequest({
                reason: $d84dc1a5e217b32f$export$258d16488300d83f.CLIENT_INITIATED,
                // server doesn't process this field, keeping it here to indicate the intent of a full disconnect
                action: $d84dc1a5e217b32f$var$LeaveRequest_Action.DISCONNECT
            })
        });
    }
    sendRequest(message_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(message) {
            var _this3 = this;
            let fromQueue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function*() {
                // capture all requests while reconnecting and put them in a queue
                // unless the request originates from the queue, then don't enqueue again
                const canQueue = !fromQueue && !$d84dc1a5e217b32f$var$canPassThroughQueue(message);
                if (canQueue && _this3.state === $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING) {
                    _this3.queuedRequests.push(()=>$d84dc1a5e217b32f$var$__awaiter(_this3, void 0, void 0, function*() {
                            yield this.sendRequest(message, true);
                        }));
                    return;
                }
                // make sure previously queued requests are being sent first
                if (!fromQueue) yield _this3.requestQueue.flush();
                if (_this3.signalLatency) yield $d84dc1a5e217b32f$var$sleep(_this3.signalLatency);
                if (!_this3.ws || _this3.ws.readyState !== _this3.ws.OPEN) {
                    _this3.log.error("cannot send signal request before connected, type: ".concat(message === null || message === void 0 ? void 0 : message.case), _this3.logContext);
                    return;
                }
                const req = new $d84dc1a5e217b32f$var$SignalRequest({
                    message: message
                });
                try {
                    if (_this3.useJSON) _this3.ws.send(req.toJsonString());
                    else _this3.ws.send(req.toBinary());
                } catch (e) {
                    _this3.log.error("error sending signal message", Object.assign(Object.assign({}, _this3.logContext), {
                        error: e
                    }));
                }
            }();
        });
    }
    handleSignalResponse(res) {
        var _a, _b;
        const msg = res.message;
        if (msg == undefined) {
            this.log.debug("received unsupported message", this.logContext);
            return;
        }
        let pingHandled = false;
        if (msg.case === "answer") {
            const sd = $d84dc1a5e217b32f$var$fromProtoSessionDescription(msg.value);
            if (this.onAnswer) this.onAnswer(sd);
        } else if (msg.case === "offer") {
            const sd = $d84dc1a5e217b32f$var$fromProtoSessionDescription(msg.value);
            if (this.onOffer) this.onOffer(sd);
        } else if (msg.case === "trickle") {
            const candidate = JSON.parse(msg.value.candidateInit);
            if (this.onTrickle) this.onTrickle(candidate, msg.value.target);
        } else if (msg.case === "update") {
            if (this.onParticipantUpdate) this.onParticipantUpdate((_a = msg.value.participants) !== null && _a !== void 0 ? _a : []);
        } else if (msg.case === "trackPublished") {
            if (this.onLocalTrackPublished) this.onLocalTrackPublished(msg.value);
        } else if (msg.case === "speakersChanged") {
            if (this.onSpeakersChanged) this.onSpeakersChanged((_b = msg.value.speakers) !== null && _b !== void 0 ? _b : []);
        } else if (msg.case === "leave") {
            if (this.onLeave) this.onLeave(msg.value);
        } else if (msg.case === "mute") {
            if (this.onRemoteMuteChanged) this.onRemoteMuteChanged(msg.value.sid, msg.value.muted);
        } else if (msg.case === "roomUpdate") {
            if (this.onRoomUpdate && msg.value.room) this.onRoomUpdate(msg.value.room);
        } else if (msg.case === "connectionQuality") {
            if (this.onConnectionQuality) this.onConnectionQuality(msg.value);
        } else if (msg.case === "streamStateUpdate") {
            if (this.onStreamStateUpdate) this.onStreamStateUpdate(msg.value);
        } else if (msg.case === "subscribedQualityUpdate") {
            if (this.onSubscribedQualityUpdate) this.onSubscribedQualityUpdate(msg.value);
        } else if (msg.case === "subscriptionPermissionUpdate") {
            if (this.onSubscriptionPermissionUpdate) this.onSubscriptionPermissionUpdate(msg.value);
        } else if (msg.case === "refreshToken") {
            if (this.onTokenRefresh) this.onTokenRefresh(msg.value);
        } else if (msg.case === "trackUnpublished") {
            if (this.onLocalTrackUnpublished) this.onLocalTrackUnpublished(msg.value);
        } else if (msg.case === "subscriptionResponse") {
            if (this.onSubscriptionError) this.onSubscriptionError(msg.value);
        } else if (msg.case === "pong") ;
        else if (msg.case === "pongResp") {
            this.rtt = Date.now() - Number.parseInt(msg.value.lastPingTimestamp.toString());
            this.resetPingTimeout();
            pingHandled = true;
        } else if (msg.case === "requestResponse") {
            if (this.onRequestResponse) this.onRequestResponse(msg.value);
        } else if (msg.case === "trackSubscribed") {
            if (this.onLocalTrackSubscribed) this.onLocalTrackSubscribed(msg.value.trackSid);
        } else this.log.debug("unsupported message", Object.assign(Object.assign({}, this.logContext), {
            msgCase: msg.case
        }));
        if (!pingHandled) this.resetPingTimeout();
    }
    setReconnected() {
        while(this.queuedRequests.length > 0){
            const req = this.queuedRequests.shift();
            if (req) this.requestQueue.run(req);
        }
    }
    handleOnClose(reason) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state === $d84dc1a5e217b32f$var$SignalConnectionState.DISCONNECTED) return;
            const onCloseCallback = this.onClose;
            yield this.close();
            this.log.debug("websocket connection closed: ".concat(reason), Object.assign(Object.assign({}, this.logContext), {
                reason: reason
            }));
            if (onCloseCallback) onCloseCallback(reason);
        });
    }
    handleWSError(ev) {
        this.log.error("websocket error", Object.assign(Object.assign({}, this.logContext), {
            error: ev
        }));
    }
    /**
   * Resets the ping timeout and starts a new timeout.
   * Call this after receiving a pong message
   */ resetPingTimeout() {
        this.clearPingTimeout();
        if (!this.pingTimeoutDuration) {
            this.log.warn("ping timeout duration not set", this.logContext);
            return;
        }
        this.pingTimeout = $d84dc1a5e217b32f$export$22e737276454df96.setTimeout(()=>{
            this.log.warn("ping timeout triggered. last pong received at: ".concat(new Date(Date.now() - this.pingTimeoutDuration * 1000).toUTCString()), this.logContext);
            this.handleOnClose("ping timeout");
        }, this.pingTimeoutDuration * 1000);
    }
    /**
   * Clears ping timeout (does not start a new timeout)
   */ clearPingTimeout() {
        if (this.pingTimeout) $d84dc1a5e217b32f$export$22e737276454df96.clearTimeout(this.pingTimeout);
    }
    startPingInterval() {
        this.clearPingInterval();
        this.resetPingTimeout();
        if (!this.pingIntervalDuration) {
            this.log.warn("ping interval duration not set", this.logContext);
            return;
        }
        this.log.debug("start ping interval", this.logContext);
        this.pingInterval = $d84dc1a5e217b32f$export$22e737276454df96.setInterval(()=>{
            this.sendPing();
        }, this.pingIntervalDuration * 1000);
    }
    clearPingInterval() {
        this.log.debug("clearing ping interval", this.logContext);
        this.clearPingTimeout();
        if (this.pingInterval) $d84dc1a5e217b32f$export$22e737276454df96.clearInterval(this.pingInterval);
    }
}
function $d84dc1a5e217b32f$var$fromProtoSessionDescription(sd) {
    const rsd = {
        type: "offer",
        sdp: sd.sdp
    };
    switch(sd.type){
        case "answer":
        case "offer":
        case "pranswer":
        case "rollback":
            rsd.type = sd.type;
            break;
    }
    return rsd;
}
function $d84dc1a5e217b32f$var$toProtoSessionDescription(rsd) {
    const sd = new $d84dc1a5e217b32f$var$SessionDescription({
        sdp: rsd.sdp,
        type: rsd.type
    });
    return sd;
}
function $d84dc1a5e217b32f$var$createConnectionParams(token, info, opts) {
    var _a;
    const params = new URLSearchParams();
    params.set("access_token", token);
    // opts
    if (opts.reconnect) {
        params.set("reconnect", "1");
        if (opts.sid) params.set("sid", opts.sid);
    }
    params.set("auto_subscribe", opts.autoSubscribe ? "1" : "0");
    // ClientInfo
    params.set("sdk", $d84dc1a5e217b32f$var$isReactNative() ? "reactnative" : "js");
    params.set("version", info.version);
    params.set("protocol", info.protocol.toString());
    if (info.deviceModel) params.set("device_model", info.deviceModel);
    if (info.os) params.set("os", info.os);
    if (info.osVersion) params.set("os_version", info.osVersion);
    if (info.browser) params.set("browser", info.browser);
    if (info.browserVersion) params.set("browser_version", info.browserVersion);
    if (opts.adaptiveStream) params.set("adaptive_stream", "1");
    if (opts.reconnectReason) params.set("reconnect_reason", opts.reconnectReason.toString());
    // @ts-ignore
    if ((_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.type) // @ts-ignore
    params.set("network", navigator.connection.type);
    return "?".concat(params.toString());
}
var $d84dc1a5e217b32f$var$lib = {};
var $d84dc1a5e217b32f$var$parser = {};
var $d84dc1a5e217b32f$var$grammar = {
    exports: {}
};
var $d84dc1a5e217b32f$var$hasRequiredGrammar;
function $d84dc1a5e217b32f$var$requireGrammar() {
    if ($d84dc1a5e217b32f$var$hasRequiredGrammar) return $d84dc1a5e217b32f$var$grammar.exports;
    $d84dc1a5e217b32f$var$hasRequiredGrammar = 1;
    var grammar$1 = $d84dc1a5e217b32f$var$grammar.exports = {
        v: [
            {
                name: "version",
                reg: /^(\d*)$/
            }
        ],
        o: [
            {
                // o=- 20518 0 IN IP4 203.0.113.1
                // NB: sessionId will be a String in most cases because it is huge
                name: "origin",
                reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
                names: [
                    "username",
                    "sessionId",
                    "sessionVersion",
                    "netType",
                    "ipVer",
                    "address"
                ],
                format: "%s %s %d %s IP%d %s"
            }
        ],
        // default parsing of these only (though some of these feel outdated)
        s: [
            {
                name: "name"
            }
        ],
        i: [
            {
                name: "description"
            }
        ],
        u: [
            {
                name: "uri"
            }
        ],
        e: [
            {
                name: "email"
            }
        ],
        p: [
            {
                name: "phone"
            }
        ],
        z: [
            {
                name: "timezones"
            }
        ],
        // TODO: this one can actually be parsed properly...
        r: [
            {
                name: "repeats"
            }
        ],
        // TODO: this one can also be parsed properly
        // k: [{}], // outdated thing ignored
        t: [
            {
                // t=0 0
                name: "timing",
                reg: /^(\d*) (\d*)/,
                names: [
                    "start",
                    "stop"
                ],
                format: "%d %d"
            }
        ],
        c: [
            {
                // c=IN IP4 10.47.197.26
                name: "connection",
                reg: /^IN IP(\d) (\S*)/,
                names: [
                    "version",
                    "ip"
                ],
                format: "IN IP%d %s"
            }
        ],
        b: [
            {
                // b=AS:4000
                push: "bandwidth",
                reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
                names: [
                    "type",
                    "limit"
                ],
                format: "%s:%s"
            }
        ],
        m: [
            {
                // m=video 51744 RTP/AVP 126 97 98 34 31
                // NB: special - pushes to session
                // TODO: rtp/fmtp should be filtered by the payloads found here?
                reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
                names: [
                    "type",
                    "port",
                    "protocol",
                    "payloads"
                ],
                format: "%s %d %s %s"
            }
        ],
        a: [
            {
                // a=rtpmap:110 opus/48000/2
                push: "rtp",
                reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
                names: [
                    "payload",
                    "codec",
                    "rate",
                    "encoding"
                ],
                format: function(o) {
                    return o.encoding ? "rtpmap:%d %s/%s/%s" : o.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
                }
            },
            {
                // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
                // a=fmtp:111 minptime=10; useinbandfec=1
                push: "fmtp",
                reg: /^fmtp:(\d*) ([\S| ]*)/,
                names: [
                    "payload",
                    "config"
                ],
                format: "fmtp:%d %s"
            },
            {
                // a=control:streamid=0
                name: "control",
                reg: /^control:(.*)/,
                format: "control:%s"
            },
            {
                // a=rtcp:65179 IN IP4 193.84.77.194
                name: "rtcp",
                reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
                names: [
                    "port",
                    "netType",
                    "ipVer",
                    "address"
                ],
                format: function(o) {
                    return o.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
                }
            },
            {
                // a=rtcp-fb:98 trr-int 100
                push: "rtcpFbTrrInt",
                reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
                names: [
                    "payload",
                    "value"
                ],
                format: "rtcp-fb:%s trr-int %d"
            },
            {
                // a=rtcp-fb:98 nack rpsi
                push: "rtcpFb",
                reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
                names: [
                    "payload",
                    "type",
                    "subtype"
                ],
                format: function(o) {
                    return o.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
                }
            },
            {
                // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
                // a=extmap:1/recvonly URI-gps-string
                // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
                push: "ext",
                reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
                names: [
                    "value",
                    "direction",
                    "encrypt-uri",
                    "uri",
                    "config"
                ],
                format: function(o) {
                    return "extmap:%d" + (o.direction ? "/%s" : "%v") + (o["encrypt-uri"] ? " %s" : "%v") + " %s" + (o.config ? " %s" : "");
                }
            },
            {
                // a=extmap-allow-mixed
                name: "extmapAllowMixed",
                reg: /^(extmap-allow-mixed)/
            },
            {
                // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
                push: "crypto",
                reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
                names: [
                    "id",
                    "suite",
                    "config",
                    "sessionConfig"
                ],
                format: function(o) {
                    return o.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
                }
            },
            {
                // a=setup:actpass
                name: "setup",
                reg: /^setup:(\w*)/,
                format: "setup:%s"
            },
            {
                // a=connection:new
                name: "connectionType",
                reg: /^connection:(new|existing)/,
                format: "connection:%s"
            },
            {
                // a=mid:1
                name: "mid",
                reg: /^mid:([^\s]*)/,
                format: "mid:%s"
            },
            {
                // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
                name: "msid",
                reg: /^msid:(.*)/,
                format: "msid:%s"
            },
            {
                // a=ptime:20
                name: "ptime",
                reg: /^ptime:(\d*(?:\.\d*)*)/,
                format: "ptime:%d"
            },
            {
                // a=maxptime:60
                name: "maxptime",
                reg: /^maxptime:(\d*(?:\.\d*)*)/,
                format: "maxptime:%d"
            },
            {
                // a=sendrecv
                name: "direction",
                reg: /^(sendrecv|recvonly|sendonly|inactive)/
            },
            {
                // a=ice-lite
                name: "icelite",
                reg: /^(ice-lite)/
            },
            {
                // a=ice-ufrag:F7gI
                name: "iceUfrag",
                reg: /^ice-ufrag:(\S*)/,
                format: "ice-ufrag:%s"
            },
            {
                // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
                name: "icePwd",
                reg: /^ice-pwd:(\S*)/,
                format: "ice-pwd:%s"
            },
            {
                // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
                name: "fingerprint",
                reg: /^fingerprint:(\S*) (\S*)/,
                names: [
                    "type",
                    "hash"
                ],
                format: "fingerprint:%s %s"
            },
            {
                // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
                // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
                // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
                // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
                push: "candidates",
                reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
                names: [
                    "foundation",
                    "component",
                    "transport",
                    "priority",
                    "ip",
                    "port",
                    "type",
                    "raddr",
                    "rport",
                    "tcptype",
                    "generation",
                    "network-id",
                    "network-cost"
                ],
                format: function(o) {
                    var str = "candidate:%s %d %s %d %s %d typ %s";
                    str += o.raddr != null ? " raddr %s rport %d" : "%v%v";
                    // NB: candidate has three optional chunks, so %void middles one if it's missing
                    str += o.tcptype != null ? " tcptype %s" : "%v";
                    if (o.generation != null) str += " generation %d";
                    str += o["network-id"] != null ? " network-id %d" : "%v";
                    str += o["network-cost"] != null ? " network-cost %d" : "%v";
                    return str;
                }
            },
            {
                // a=end-of-candidates (keep after the candidates line for readability)
                name: "endOfCandidates",
                reg: /^(end-of-candidates)/
            },
            {
                // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
                name: "remoteCandidates",
                reg: /^remote-candidates:(.*)/,
                format: "remote-candidates:%s"
            },
            {
                // a=ice-options:google-ice
                name: "iceOptions",
                reg: /^ice-options:(\S*)/,
                format: "ice-options:%s"
            },
            {
                // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
                push: "ssrcs",
                reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
                names: [
                    "id",
                    "attribute",
                    "value"
                ],
                format: function(o) {
                    var str = "ssrc:%d";
                    if (o.attribute != null) {
                        str += " %s";
                        if (o.value != null) str += ":%s";
                    }
                    return str;
                }
            },
            {
                // a=ssrc-group:FEC 1 2
                // a=ssrc-group:FEC-FR 3004364195 1080772241
                push: "ssrcGroups",
                // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
                reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
                names: [
                    "semantics",
                    "ssrcs"
                ],
                format: "ssrc-group:%s %s"
            },
            {
                // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
                name: "msidSemantic",
                reg: /^msid-semantic:\s?(\w*) (\S*)/,
                names: [
                    "semantic",
                    "token"
                ],
                format: "msid-semantic: %s %s" // space after ':' is not accidental
            },
            {
                // a=group:BUNDLE audio video
                push: "groups",
                reg: /^group:(\w*) (.*)/,
                names: [
                    "type",
                    "mids"
                ],
                format: "group:%s %s"
            },
            {
                // a=rtcp-mux
                name: "rtcpMux",
                reg: /^(rtcp-mux)/
            },
            {
                // a=rtcp-rsize
                name: "rtcpRsize",
                reg: /^(rtcp-rsize)/
            },
            {
                // a=sctpmap:5000 webrtc-datachannel 1024
                name: "sctpmap",
                reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
                names: [
                    "sctpmapNumber",
                    "app",
                    "maxMessageSize"
                ],
                format: function(o) {
                    return o.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
                }
            },
            {
                // a=x-google-flag:conference
                name: "xGoogleFlag",
                reg: /^x-google-flag:([^\s]*)/,
                format: "x-google-flag:%s"
            },
            {
                // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
                push: "rids",
                reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
                names: [
                    "id",
                    "direction",
                    "params"
                ],
                format: function(o) {
                    return o.params ? "rid:%s %s %s" : "rid:%s %s";
                }
            },
            {
                // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
                // a=imageattr:* send [x=800,y=640] recv *
                // a=imageattr:100 recv [x=320,y=240]
                push: "imageattrs",
                reg: new RegExp(// a=imageattr:97
                "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
                names: [
                    "pt",
                    "dir1",
                    "attrs1",
                    "dir2",
                    "attrs2"
                ],
                format: function(o) {
                    return "imageattr:%s %s %s" + (o.dir2 ? " %s %s" : "");
                }
            },
            {
                // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
                // a=simulcast:recv 1;4,5 send 6;7
                name: "simulcast",
                reg: new RegExp(// a=simulcast:
                "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
                names: [
                    "dir1",
                    "list1",
                    "dir2",
                    "list2"
                ],
                format: function(o) {
                    return "simulcast:%s %s" + (o.dir2 ? " %s %s" : "");
                }
            },
            {
                // old simulcast draft 03 (implemented by Firefox)
                //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
                // a=simulcast: recv pt=97;98 send pt=97
                // a=simulcast: send rid=5;6;7 paused=6,7
                name: "simulcast_03",
                reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
                names: [
                    "value"
                ],
                format: "simulcast: %s"
            },
            {
                // a=framerate:25
                // a=framerate:29.97
                name: "framerate",
                reg: /^framerate:(\d+(?:$|\.\d+))/,
                format: "framerate:%s"
            },
            {
                // RFC4570
                // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
                name: "sourceFilter",
                reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
                names: [
                    "filterMode",
                    "netType",
                    "addressTypes",
                    "destAddress",
                    "srcList"
                ],
                format: "source-filter: %s %s %s %s %s"
            },
            {
                // a=bundle-only
                name: "bundleOnly",
                reg: /^(bundle-only)/
            },
            {
                // a=label:1
                name: "label",
                reg: /^label:(.+)/,
                format: "label:%s"
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
                name: "sctpPort",
                reg: /^sctp-port:(\d+)$/,
                format: "sctp-port:%s"
            },
            {
                // RFC version 26 for SCTP over DTLS
                // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
                name: "maxMessageSize",
                reg: /^max-message-size:(\d+)$/,
                format: "max-message-size:%s"
            },
            {
                // RFC7273
                // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
                push: "tsRefClocks",
                reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
                names: [
                    "clksrc",
                    "clksrcExt"
                ],
                format: function(o) {
                    return "ts-refclk:%s" + (o.clksrcExt != null ? "=%s" : "");
                }
            },
            {
                // RFC7273
                // a=mediaclk:direct=963214424
                name: "mediaClk",
                reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
                names: [
                    "id",
                    "mediaClockName",
                    "mediaClockValue",
                    "rateNumerator",
                    "rateDenominator"
                ],
                format: function(o) {
                    var str = "mediaclk:";
                    str += o.id != null ? "id=%s %s" : "%v%s";
                    str += o.mediaClockValue != null ? "=%s" : "";
                    str += o.rateNumerator != null ? " rate=%s" : "";
                    str += o.rateDenominator != null ? "/%s" : "";
                    return str;
                }
            },
            {
                // a=keywds:keywords
                name: "keywords",
                reg: /^keywds:(.+)$/,
                format: "keywds:%s"
            },
            {
                // a=content:main
                name: "content",
                reg: /^content:(.+)/,
                format: "content:%s"
            },
            // BFCP https://tools.ietf.org/html/rfc4583
            {
                // a=floorctrl:c-s
                name: "bfcpFloorCtrl",
                reg: /^floorctrl:(c-only|s-only|c-s)/,
                format: "floorctrl:%s"
            },
            {
                // a=confid:1
                name: "bfcpConfId",
                reg: /^confid:(\d+)/,
                format: "confid:%s"
            },
            {
                // a=userid:1
                name: "bfcpUserId",
                reg: /^userid:(\d+)/,
                format: "userid:%s"
            },
            {
                // a=floorid:1
                name: "bfcpFloorId",
                reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
                names: [
                    "id",
                    "mStream"
                ],
                format: "floorid:%s mstrm:%s"
            },
            {
                // any a= that we don't understand is kept verbatim on media.invalid
                push: "invalid",
                names: [
                    "value"
                ]
            }
        ]
    };
    // set sensible defaults to avoid polluting the grammar with boring details
    Object.keys(grammar$1).forEach(function(key) {
        var objs = grammar$1[key];
        objs.forEach(function(obj) {
            if (!obj.reg) obj.reg = /(.*)/;
            if (!obj.format) obj.format = "%s";
        });
    });
    return $d84dc1a5e217b32f$var$grammar.exports;
}
var $d84dc1a5e217b32f$var$hasRequiredParser;
function $d84dc1a5e217b32f$var$requireParser() {
    if ($d84dc1a5e217b32f$var$hasRequiredParser) return $d84dc1a5e217b32f$var$parser;
    $d84dc1a5e217b32f$var$hasRequiredParser = 1;
    (function(exports) {
        var toIntIfInt = function(v) {
            return String(Number(v)) === v ? Number(v) : v;
        };
        var attachProperties = function(match, location, names, rawName) {
            if (rawName && !names) location[rawName] = toIntIfInt(match[1]);
            else {
                for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = toIntIfInt(match[i + 1]);
            }
        };
        var parseReg = function(obj, location, content) {
            var needsBlank = obj.name && obj.names;
            if (obj.push && !location[obj.push]) location[obj.push] = [];
            else if (needsBlank && !location[obj.name]) location[obj.name] = {};
            var keyLocation = obj.push ? {} : // blank object that will be pushed
            needsBlank ? location[obj.name] : location; // otherwise, named location or root
            attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
            if (obj.push) location[obj.push].push(keyLocation);
        };
        var grammar = $d84dc1a5e217b32f$var$requireGrammar();
        var validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
        exports.parse = function(sdp) {
            var session = {}, media = [], location = session; // points at where properties go under (one of the above)
            // parse lines we understand
            sdp.split(/(\r\n|\r|\n)/).filter(validLine).forEach(function(l) {
                var type = l[0];
                var content = l.slice(2);
                if (type === "m") {
                    media.push({
                        rtp: [],
                        fmtp: []
                    });
                    location = media[media.length - 1]; // point at latest media line
                }
                for(var j = 0; j < (grammar[type] || []).length; j += 1){
                    var obj = grammar[type][j];
                    if (obj.reg.test(content)) return parseReg(obj, location, content);
                }
            });
            session.media = media; // link it up
            return session;
        };
        var paramReducer = function(acc, expr) {
            var s = expr.split(/=(.+)/, 2);
            if (s.length === 2) acc[s[0]] = toIntIfInt(s[1]);
            else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
            return acc;
        };
        exports.parseParams = function(str) {
            return str.split(/;\s?/).reduce(paramReducer, {});
        };
        // For backward compatibility - alias will be removed in 3.0.0
        exports.parseFmtpConfig = exports.parseParams;
        exports.parsePayloads = function(str) {
            return str.toString().split(" ").map(Number);
        };
        exports.parseRemoteCandidates = function(str) {
            var candidates = [];
            var parts = str.split(" ").map(toIntIfInt);
            for(var i = 0; i < parts.length; i += 3)candidates.push({
                component: parts[i],
                ip: parts[i + 1],
                port: parts[i + 2]
            });
            return candidates;
        };
        exports.parseImageAttributes = function(str) {
            return str.split(" ").map(function(item) {
                return item.substring(1, item.length - 1).split(",").reduce(paramReducer, {});
            });
        };
        exports.parseSimulcastStreamList = function(str) {
            return str.split(";").map(function(stream) {
                return stream.split(",").map(function(format) {
                    var scid, paused = false;
                    if (format[0] !== "~") scid = toIntIfInt(format);
                    else {
                        scid = toIntIfInt(format.substring(1, format.length));
                        paused = true;
                    }
                    return {
                        scid: scid,
                        paused: paused
                    };
                });
            });
        };
    })($d84dc1a5e217b32f$var$parser);
    return $d84dc1a5e217b32f$var$parser;
}
var $d84dc1a5e217b32f$var$writer;
var $d84dc1a5e217b32f$var$hasRequiredWriter;
function $d84dc1a5e217b32f$var$requireWriter() {
    if ($d84dc1a5e217b32f$var$hasRequiredWriter) return $d84dc1a5e217b32f$var$writer;
    $d84dc1a5e217b32f$var$hasRequiredWriter = 1;
    var grammar = $d84dc1a5e217b32f$var$requireGrammar();
    // customized util.format - discards excess arguments and can void middle ones
    var formatRegExp = /%[sdv%]/g;
    var format = function(formatStr) {
        var i = 1;
        var args = arguments;
        var len = args.length;
        return formatStr.replace(formatRegExp, function(x) {
            if (i >= len) return x; // missing argument
            var arg = args[i];
            i += 1;
            switch(x){
                case "%%":
                    return "%";
                case "%s":
                    return String(arg);
                case "%d":
                    return Number(arg);
                case "%v":
                    return "";
            }
        });
    // NB: we discard excess arguments - they are typically undefined from makeLine
    };
    var makeLine = function(type, obj, location) {
        var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
        var args = [
            type + "=" + str
        ];
        if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
            var n = obj.names[i];
            if (obj.name) args.push(location[obj.name][n]);
            else // for mLine and push attributes
            args.push(location[obj.names[i]]);
        }
        else args.push(location[obj.name]);
        return format.apply(null, args);
    };
    // RFC specified order
    // TODO: extend this with all the rest
    var defaultOuterOrder = [
        "v",
        "o",
        "s",
        "i",
        "u",
        "e",
        "p",
        "c",
        "b",
        "t",
        "r",
        "z",
        "a"
    ];
    var defaultInnerOrder = [
        "i",
        "c",
        "b",
        "a"
    ];
    $d84dc1a5e217b32f$var$writer = function(session, opts) {
        opts = opts || {};
        // ensure certain properties exist
        if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
        if (session.name == null) session.name = " "; // 's= ' must be there if no meaningful name set
        session.media.forEach(function(mLine) {
            if (mLine.payloads == null) mLine.payloads = "";
        });
        var outerOrder = opts.outerOrder || defaultOuterOrder;
        var innerOrder = opts.innerOrder || defaultInnerOrder;
        var sdp = [];
        // loop through outerOrder for matching properties on session
        outerOrder.forEach(function(type) {
            grammar[type].forEach(function(obj) {
                if (obj.name in session && session[obj.name] != null) sdp.push(makeLine(type, obj, session));
                else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                    sdp.push(makeLine(type, obj, el));
                });
            });
        });
        // then for each media line, follow the innerOrder
        session.media.forEach(function(mLine) {
            sdp.push(makeLine("m", grammar.m[0], mLine));
            innerOrder.forEach(function(type) {
                grammar[type].forEach(function(obj) {
                    if (obj.name in mLine && mLine[obj.name] != null) sdp.push(makeLine(type, obj, mLine));
                    else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                        sdp.push(makeLine(type, obj, el));
                    });
                });
            });
        });
        return sdp.join("\r\n") + "\r\n";
    };
    return $d84dc1a5e217b32f$var$writer;
}
var $d84dc1a5e217b32f$var$hasRequiredLib;
function $d84dc1a5e217b32f$var$requireLib() {
    if ($d84dc1a5e217b32f$var$hasRequiredLib) return $d84dc1a5e217b32f$var$lib;
    $d84dc1a5e217b32f$var$hasRequiredLib = 1;
    var parser = $d84dc1a5e217b32f$var$requireParser();
    var writer = $d84dc1a5e217b32f$var$requireWriter();
    var grammar = $d84dc1a5e217b32f$var$requireGrammar();
    $d84dc1a5e217b32f$var$lib.grammar = grammar;
    $d84dc1a5e217b32f$var$lib.write = writer;
    $d84dc1a5e217b32f$var$lib.parse = parser.parse;
    $d84dc1a5e217b32f$var$lib.parseParams = parser.parseParams;
    $d84dc1a5e217b32f$var$lib.parseFmtpConfig = parser.parseFmtpConfig; // Alias of parseParams().
    $d84dc1a5e217b32f$var$lib.parsePayloads = parser.parsePayloads;
    $d84dc1a5e217b32f$var$lib.parseRemoteCandidates = parser.parseRemoteCandidates;
    $d84dc1a5e217b32f$var$lib.parseImageAttributes = parser.parseImageAttributes;
    $d84dc1a5e217b32f$var$lib.parseSimulcastStreamList = parser.parseSimulcastStreamList;
    return $d84dc1a5e217b32f$var$lib;
}
var $d84dc1a5e217b32f$var$libExports = $d84dc1a5e217b32f$var$requireLib();
/* The svc codec (av1/vp9) would use a very low bitrate at the begining and
increase slowly by the bandwidth estimator until it reach the target bitrate. The
process commonly cost more than 10 seconds cause subscriber will get blur video at
the first few seconds. So we use a 70% of target bitrate here as the start bitrate to
eliminate this issue.
*/ const $d84dc1a5e217b32f$var$startBitrateForSVC = 0.7;
const $d84dc1a5e217b32f$var$debounceInterval = 20;
const $d84dc1a5e217b32f$var$PCEvents = {
    NegotiationStarted: "negotiationStarted",
    NegotiationComplete: "negotiationComplete",
    RTPVideoPayloadTypes: "rtpVideoPayloadTypes"
};
/** @internal */ class $d84dc1a5e217b32f$var$PCTransport extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    get pc() {
        if (!this._pc) this._pc = this.createPC();
        return this._pc;
    }
    constructor(config){
        let loggerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _a;
        super();
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.ddExtID = 0;
        this.pendingCandidates = [];
        this.restartingIce = false;
        this.renegotiate = false;
        this.trackBitrates = [];
        this.remoteStereoMids = [];
        this.remoteNackMids = [];
        // debounced negotiate interface
        this.negotiate = $d84dc1a5e217b32f$var$r((onError)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.emit($d84dc1a5e217b32f$var$PCEvents.NegotiationStarted);
                try {
                    yield this.createAndSendOffer();
                } catch (e) {
                    if (onError) onError(e);
                    else throw e;
                }
            }), $d84dc1a5e217b32f$var$debounceInterval);
        this.close = ()=>{
            if (!this._pc) return;
            this._pc.close();
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc.onicegatheringstatechange = null;
            this._pc.ondatachannel = null;
            this._pc.onnegotiationneeded = null;
            this._pc.onsignalingstatechange = null;
            this._pc.onicecandidate = null;
            this._pc.ondatachannel = null;
            this._pc.ontrack = null;
            this._pc.onconnectionstatechange = null;
            this._pc.oniceconnectionstatechange = null;
            this._pc = null;
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.PCTransport);
        this.loggerOptions = loggerOptions;
        this.config = config;
        this._pc = this.createPC();
    }
    createPC() {
        const pc = new RTCPeerConnection(this.config);
        pc.onicecandidate = (ev)=>{
            var _a;
            if (!ev.candidate) return;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, ev.candidate);
        };
        pc.onicecandidateerror = (ev)=>{
            var _a;
            (_a = this.onIceCandidateError) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.oniceconnectionstatechange = ()=>{
            var _a;
            (_a = this.onIceConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.iceConnectionState);
        };
        pc.onsignalingstatechange = ()=>{
            var _a;
            (_a = this.onSignalingStatechange) === null || _a === void 0 || _a.call(this, pc.signalingState);
        };
        pc.onconnectionstatechange = ()=>{
            var _a;
            (_a = this.onConnectionStateChange) === null || _a === void 0 || _a.call(this, pc.connectionState);
        };
        pc.ondatachannel = (ev)=>{
            var _a;
            (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
        };
        pc.ontrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        return pc;
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isICEConnected() {
        return this._pc !== null && (this.pc.iceConnectionState === "connected" || this.pc.iceConnectionState === "completed");
    }
    addIceCandidate(candidate) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pc.remoteDescription && !this.restartingIce) return this.pc.addIceCandidate(candidate);
            this.pendingCandidates.push(candidate);
        });
    }
    setRemoteDescription(sd) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            let mungedSDP = undefined;
            if (sd.type === "offer") {
                let { stereoMids: stereoMids, nackMids: nackMids } = $d84dc1a5e217b32f$var$extractStereoAndNackAudioFromOffer(sd);
                this.remoteStereoMids = stereoMids;
                this.remoteNackMids = nackMids;
            } else if (sd.type === "answer") {
                const sdpParsed = $d84dc1a5e217b32f$var$libExports.parse((_a = sd.sdp) !== null && _a !== void 0 ? _a : "");
                sdpParsed.media.forEach((media)=>{
                    if (media.type === "audio") // mung sdp for opus bitrate settings
                    this.trackBitrates.some((trackbr)=>{
                        if (!trackbr.transceiver || media.mid != trackbr.transceiver.mid) return false;
                        let codecPayload = 0;
                        media.rtp.some((rtp)=>{
                            if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                                codecPayload = rtp.payload;
                                return true;
                            }
                            return false;
                        });
                        if (codecPayload === 0) return true;
                        let fmtpFound = false;
                        for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                            fmtp.config = fmtp.config.split(";").filter((attr)=>!attr.includes("maxaveragebitrate")).join(";");
                            if (trackbr.maxbr > 0) fmtp.config += ";maxaveragebitrate=".concat(trackbr.maxbr * 1000);
                            fmtpFound = true;
                            break;
                        }
                        if (!fmtpFound) {
                            if (trackbr.maxbr > 0) media.fmtp.push({
                                payload: codecPayload,
                                config: "maxaveragebitrate=".concat(trackbr.maxbr * 1000)
                            });
                        }
                        return true;
                    });
                });
                mungedSDP = $d84dc1a5e217b32f$var$libExports.write(sdpParsed);
            }
            yield this.setMungedSDP(sd, mungedSDP, true);
            this.pendingCandidates.forEach((candidate)=>{
                this.pc.addIceCandidate(candidate);
            });
            this.pendingCandidates = [];
            this.restartingIce = false;
            if (this.renegotiate) {
                this.renegotiate = false;
                yield this.createAndSendOffer();
            } else if (sd.type === "answer") {
                this.emit($d84dc1a5e217b32f$var$PCEvents.NegotiationComplete);
                if (sd.sdp) {
                    const sdpParsed = $d84dc1a5e217b32f$var$libExports.parse(sd.sdp);
                    sdpParsed.media.forEach((media)=>{
                        if (media.type === "video") this.emit($d84dc1a5e217b32f$var$PCEvents.RTPVideoPayloadTypes, media.rtp);
                    });
                }
            }
        });
    }
    createAndSendOffer(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (this.onOffer === undefined) return;
            if (options === null || options === void 0 ? void 0 : options.iceRestart) {
                this.log.debug("restarting ICE", this.logContext);
                this.restartingIce = true;
            }
            if (this._pc && this._pc.signalingState === "have-local-offer") {
                // we're waiting for the peer to accept our offer, so we'll just wait
                // the only exception to this is when ICE restart is needed
                const currentSD = this._pc.remoteDescription;
                if ((options === null || options === void 0 ? void 0 : options.iceRestart) && currentSD) // TODO: handle when ICE restart is needed but we don't have a remote description
                // the best thing to do is to recreate the peerconnection
                yield this._pc.setRemoteDescription(currentSD);
                else {
                    this.renegotiate = true;
                    return;
                }
            } else if (!this._pc || this._pc.signalingState === "closed") {
                this.log.warn("could not createOffer with closed peer connection", this.logContext);
                return;
            }
            // actually negotiate
            this.log.debug("starting to negotiate", this.logContext);
            const offer = yield this.pc.createOffer(options);
            this.log.debug("original offer", Object.assign({
                sdp: offer.sdp
            }, this.logContext));
            const sdpParsed = $d84dc1a5e217b32f$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : "");
            sdpParsed.media.forEach((media)=>{
                $d84dc1a5e217b32f$var$ensureIPAddrMatchVersion(media);
                if (media.type === "audio") $d84dc1a5e217b32f$var$ensureAudioNackAndStereo(media, [], []);
                else if (media.type === "video") this.trackBitrates.some((trackbr)=>{
                    if (!media.msid || !trackbr.cid || !media.msid.includes(trackbr.cid)) return false;
                    let codecPayload = 0;
                    media.rtp.some((rtp)=>{
                        if (rtp.codec.toUpperCase() === trackbr.codec.toUpperCase()) {
                            codecPayload = rtp.payload;
                            return true;
                        }
                        return false;
                    });
                    if (codecPayload === 0) return true;
                    if ($d84dc1a5e217b32f$var$isSVCCodec(trackbr.codec)) this.ensureVideoDDExtensionForSVC(media, sdpParsed);
                    // TODO: av1 slow starting issue already fixed in chrome 124, clean this after some versions
                    // mung sdp for av1 bitrate setting that can't apply by sendEncoding
                    if (trackbr.codec !== "av1") return true;
                    const startBitrate = Math.round(trackbr.maxbr * $d84dc1a5e217b32f$var$startBitrateForSVC);
                    for (const fmtp of media.fmtp)if (fmtp.payload === codecPayload) {
                        // if another track's fmtp already is set, we cannot override the bitrate
                        // this has the unfortunate consequence of being forced to use the
                        // initial track's bitrate for all tracks
                        if (!fmtp.config.includes("x-google-start-bitrate")) fmtp.config += ";x-google-start-bitrate=".concat(startBitrate);
                        break;
                    }
                    return true;
                });
            });
            yield this.setMungedSDP(offer, $d84dc1a5e217b32f$var$libExports.write(sdpParsed));
            this.onOffer(offer);
        });
    }
    createAndSetAnswer() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const answer = yield this.pc.createAnswer();
            const sdpParsed = $d84dc1a5e217b32f$var$libExports.parse((_a = answer.sdp) !== null && _a !== void 0 ? _a : "");
            sdpParsed.media.forEach((media)=>{
                $d84dc1a5e217b32f$var$ensureIPAddrMatchVersion(media);
                if (media.type === "audio") $d84dc1a5e217b32f$var$ensureAudioNackAndStereo(media, this.remoteStereoMids, this.remoteNackMids);
            });
            yield this.setMungedSDP(answer, $d84dc1a5e217b32f$var$libExports.write(sdpParsed));
            return answer;
        });
    }
    createDataChannel(label, dataChannelDict) {
        return this.pc.createDataChannel(label, dataChannelDict);
    }
    addTransceiver(mediaStreamTrack, transceiverInit) {
        return this.pc.addTransceiver(mediaStreamTrack, transceiverInit);
    }
    addTrack(track) {
        if (!this._pc) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("PC closed, cannot add track");
        return this._pc.addTrack(track);
    }
    setTrackCodecBitrate(info) {
        this.trackBitrates.push(info);
    }
    setConfiguration(rtcConfig) {
        var _a;
        if (!this._pc) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("PC closed, cannot configure");
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.setConfiguration(rtcConfig);
    }
    canRemoveTrack() {
        var _a;
        return !!((_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack);
    }
    removeTrack(sender) {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.removeTrack(sender);
    }
    getConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.connectionState) !== null && _b !== void 0 ? _b : "closed";
    }
    getICEConnectionState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.iceConnectionState) !== null && _b !== void 0 ? _b : "closed";
    }
    getSignallingState() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.signalingState) !== null && _b !== void 0 ? _b : "closed";
    }
    getTransceivers() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getTransceivers()) !== null && _b !== void 0 ? _b : [];
    }
    getSenders() {
        var _a, _b;
        return (_b = (_a = this._pc) === null || _a === void 0 ? void 0 : _a.getSenders()) !== null && _b !== void 0 ? _b : [];
    }
    getLocalDescription() {
        var _a;
        return (_a = this._pc) === null || _a === void 0 ? void 0 : _a.localDescription;
    }
    getRemoteDescription() {
        var _a;
        return (_a = this.pc) === null || _a === void 0 ? void 0 : _a.remoteDescription;
    }
    getStats() {
        return this.pc.getStats();
    }
    getConnectedAddress() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this._pc) return;
            let selectedCandidatePairId = "";
            const candidatePairs = new Map();
            // id -> candidate ip
            const candidates = new Map();
            const stats = yield this._pc.getStats();
            stats.forEach((v)=>{
                switch(v.type){
                    case "transport":
                        selectedCandidatePairId = v.selectedCandidatePairId;
                        break;
                    case "candidate-pair":
                        if (selectedCandidatePairId === "" && v.selected) selectedCandidatePairId = v.id;
                        candidatePairs.set(v.id, v);
                        break;
                    case "remote-candidate":
                        candidates.set(v.id, "".concat(v.address, ":").concat(v.port));
                        break;
                }
            });
            if (selectedCandidatePairId === "") return undefined;
            const selectedID = (_a = candidatePairs.get(selectedCandidatePairId)) === null || _a === void 0 ? void 0 : _a.remoteCandidateId;
            if (selectedID === undefined) return undefined;
            return candidates.get(selectedID);
        });
    }
    setMungedSDP(sd, munged, remote) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (munged) {
                const originalSdp = sd.sdp;
                sd.sdp = munged;
                try {
                    this.log.debug("setting munged ".concat(remote ? "remote" : "local", " description"), this.logContext);
                    if (remote) yield this.pc.setRemoteDescription(sd);
                    else yield this.pc.setLocalDescription(sd);
                    return;
                } catch (e) {
                    this.log.warn("not able to set ".concat(sd.type, ", falling back to unmodified sdp"), Object.assign(Object.assign({}, this.logContext), {
                        error: e,
                        sdp: munged
                    }));
                    sd.sdp = originalSdp;
                }
            }
            try {
                if (remote) yield this.pc.setRemoteDescription(sd);
                else yield this.pc.setLocalDescription(sd);
            } catch (e) {
                let msg = "unknown error";
                if (e instanceof Error) msg = e.message;
                else if (typeof e === "string") msg = e;
                const fields = {
                    error: msg,
                    sdp: sd.sdp
                };
                if (!remote && this.pc.remoteDescription) fields.remoteSdp = this.pc.remoteDescription;
                this.log.error("unable to set ".concat(sd.type), Object.assign(Object.assign({}, this.logContext), {
                    fields: fields
                }));
                throw new $d84dc1a5e217b32f$export$18c2792bacf23e39(msg);
            }
        });
    }
    ensureVideoDDExtensionForSVC(media, sdp) {
        var _a, _b;
        const ddFound = (_a = media.ext) === null || _a === void 0 ? void 0 : _a.some((ext)=>{
            if (ext.uri === $d84dc1a5e217b32f$var$ddExtensionURI) return true;
            return false;
        });
        if (!ddFound) {
            if (this.ddExtID === 0) {
                let maxID = 0;
                sdp.media.forEach((m)=>{
                    var _a;
                    if (m.type !== "video") return;
                    (_a = m.ext) === null || _a === void 0 || _a.forEach((ext)=>{
                        if (ext.value > maxID) maxID = ext.value;
                    });
                });
                this.ddExtID = maxID + 1;
            }
            (_b = media.ext) === null || _b === void 0 || _b.push({
                value: this.ddExtID,
                uri: $d84dc1a5e217b32f$var$ddExtensionURI
            });
        }
    }
}
function $d84dc1a5e217b32f$var$ensureAudioNackAndStereo(media, stereoMids, nackMids) {
    // found opus codec to add nack fb
    let opusPayload = 0;
    media.rtp.some((rtp)=>{
        if (rtp.codec === "opus") {
            opusPayload = rtp.payload;
            return true;
        }
        return false;
    });
    // add nack rtcpfb if not exist
    if (opusPayload > 0) {
        if (!media.rtcpFb) media.rtcpFb = [];
        if (nackMids.includes(media.mid) && !media.rtcpFb.some((fb)=>fb.payload === opusPayload && fb.type === "nack")) media.rtcpFb.push({
            payload: opusPayload,
            type: "nack"
        });
        if (stereoMids.includes(media.mid)) media.fmtp.some((fmtp)=>{
            if (fmtp.payload === opusPayload) {
                if (!fmtp.config.includes("stereo=1")) fmtp.config += ";stereo=1";
                return true;
            }
            return false;
        });
    }
}
function $d84dc1a5e217b32f$var$extractStereoAndNackAudioFromOffer(offer) {
    var _a;
    const stereoMids = [];
    const nackMids = [];
    const sdpParsed = $d84dc1a5e217b32f$var$libExports.parse((_a = offer.sdp) !== null && _a !== void 0 ? _a : "");
    let opusPayload = 0;
    sdpParsed.media.forEach((media)=>{
        var _a;
        if (media.type === "audio") {
            media.rtp.some((rtp)=>{
                if (rtp.codec === "opus") {
                    opusPayload = rtp.payload;
                    return true;
                }
                return false;
            });
            if ((_a = media.rtcpFb) === null || _a === void 0 ? void 0 : _a.some((fb)=>fb.payload === opusPayload && fb.type === "nack")) nackMids.push(media.mid);
            media.fmtp.some((fmtp)=>{
                if (fmtp.payload === opusPayload) {
                    if (fmtp.config.includes("sprop-stereo=1")) stereoMids.push(media.mid);
                    return true;
                }
                return false;
            });
        }
    });
    return {
        stereoMids: stereoMids,
        nackMids: nackMids
    };
}
function $d84dc1a5e217b32f$var$ensureIPAddrMatchVersion(media) {
    // Chrome could generate sdp with c = IN IP4 <ipv6 addr>
    // in edge case and return error when set sdp.This is not a
    // sdk error but correct it if the issue detected.
    if (media.connection) {
        const isV6 = media.connection.ip.indexOf(":") >= 0;
        if (media.connection.version === 4 && isV6 || media.connection.version === 6 && !isV6) {
            // fallback to dummy address
            media.connection.ip = "0.0.0.0";
            media.connection.version = 4;
        }
    }
}
const $d84dc1a5e217b32f$var$defaultVideoCodec = "vp8";
const $d84dc1a5e217b32f$var$publishDefaults = {
    audioPreset: $d84dc1a5e217b32f$export$5da93632511fdb1f.music,
    dtx: true,
    red: true,
    forceStereo: false,
    simulcast: true,
    screenShareEncoding: $d84dc1a5e217b32f$export$a6cdf9dcd3d32f2d.h1080fps15.encoding,
    stopMicTrackOnMute: false,
    videoCodec: $d84dc1a5e217b32f$var$defaultVideoCodec,
    backupCodec: true
};
const $d84dc1a5e217b32f$var$audioDefaults = {
    deviceId: "default",
    autoGainControl: true,
    echoCancellation: true,
    noiseSuppression: true,
    voiceIsolation: true
};
const $d84dc1a5e217b32f$var$videoDefaults = {
    deviceId: "default",
    resolution: $d84dc1a5e217b32f$export$79d56065dad1674c.h720.resolution
};
const $d84dc1a5e217b32f$var$roomOptionDefaults = {
    adaptiveStream: false,
    dynacast: false,
    stopLocalTrackOnUnpublish: true,
    reconnectPolicy: new $d84dc1a5e217b32f$export$97bc471d6a059e6e(),
    disconnectOnPageLeave: true,
    webAudioMix: false
};
const $d84dc1a5e217b32f$var$roomConnectOptionDefaults = {
    autoSubscribe: true,
    maxRetries: 1,
    peerConnectionTimeout: 15000,
    websocketTimeout: 15000
};
var $d84dc1a5e217b32f$var$PCTransportState;
(function(PCTransportState) {
    PCTransportState[PCTransportState["NEW"] = 0] = "NEW";
    PCTransportState[PCTransportState["CONNECTING"] = 1] = "CONNECTING";
    PCTransportState[PCTransportState["CONNECTED"] = 2] = "CONNECTED";
    PCTransportState[PCTransportState["FAILED"] = 3] = "FAILED";
    PCTransportState[PCTransportState["CLOSING"] = 4] = "CLOSING";
    PCTransportState[PCTransportState["CLOSED"] = 5] = "CLOSED";
})($d84dc1a5e217b32f$var$PCTransportState || ($d84dc1a5e217b32f$var$PCTransportState = {}));
class $d84dc1a5e217b32f$var$PCTransportManager {
    get needsPublisher() {
        return this.isPublisherConnectionRequired;
    }
    get needsSubscriber() {
        return this.isSubscriberConnectionRequired;
    }
    get currentState() {
        return this.state;
    }
    constructor(rtcConfig, subscriberPrimary, loggerOptions){
        var _a;
        this.peerConnectionTimeout = $d84dc1a5e217b32f$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.updateState = ()=>{
            var _a;
            const previousState = this.state;
            const connectionStates = this.requiredTransports.map((tr)=>tr.getConnectionState());
            if (connectionStates.every((st)=>st === "connected")) this.state = $d84dc1a5e217b32f$var$PCTransportState.CONNECTED;
            else if (connectionStates.some((st)=>st === "failed")) this.state = $d84dc1a5e217b32f$var$PCTransportState.FAILED;
            else if (connectionStates.some((st)=>st === "connecting")) this.state = $d84dc1a5e217b32f$var$PCTransportState.CONNECTING;
            else if (connectionStates.every((st)=>st === "closed")) this.state = $d84dc1a5e217b32f$var$PCTransportState.CLOSED;
            else if (connectionStates.some((st)=>st === "closed")) this.state = $d84dc1a5e217b32f$var$PCTransportState.CLOSING;
            else if (connectionStates.every((st)=>st === "new")) this.state = $d84dc1a5e217b32f$var$PCTransportState.NEW;
            if (previousState !== this.state) {
                this.log.debug("pc state change: from ".concat($d84dc1a5e217b32f$var$PCTransportState[previousState], " to ").concat($d84dc1a5e217b32f$var$PCTransportState[this.state]), this.logContext);
                (_a = this.onStateChange) === null || _a === void 0 || _a.call(this, this.state, this.publisher.getConnectionState(), this.subscriber.getConnectionState());
            }
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.PCManager);
        this.loggerOptions = loggerOptions;
        this.isPublisherConnectionRequired = !subscriberPrimary;
        this.isSubscriberConnectionRequired = subscriberPrimary;
        this.publisher = new $d84dc1a5e217b32f$var$PCTransport(rtcConfig, loggerOptions);
        this.subscriber = new $d84dc1a5e217b32f$var$PCTransport(rtcConfig, loggerOptions);
        this.publisher.onConnectionStateChange = this.updateState;
        this.subscriber.onConnectionStateChange = this.updateState;
        this.publisher.onIceConnectionStateChange = this.updateState;
        this.subscriber.onIceConnectionStateChange = this.updateState;
        this.publisher.onSignalingStatechange = this.updateState;
        this.subscriber.onSignalingStatechange = this.updateState;
        this.publisher.onIceCandidate = (candidate)=>{
            var _a;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $d84dc1a5e217b32f$var$SignalTarget.PUBLISHER);
        };
        this.subscriber.onIceCandidate = (candidate)=>{
            var _a;
            (_a = this.onIceCandidate) === null || _a === void 0 || _a.call(this, candidate, $d84dc1a5e217b32f$var$SignalTarget.SUBSCRIBER);
        };
        // in subscriber primary mode, server side opens sub data channels.
        this.subscriber.onDataChannel = (ev)=>{
            var _a;
            (_a = this.onDataChannel) === null || _a === void 0 || _a.call(this, ev);
        };
        this.subscriber.onTrack = (ev)=>{
            var _a;
            (_a = this.onTrack) === null || _a === void 0 || _a.call(this, ev);
        };
        this.publisher.onOffer = (offer)=>{
            var _a;
            (_a = this.onPublisherOffer) === null || _a === void 0 || _a.call(this, offer);
        };
        this.state = $d84dc1a5e217b32f$var$PCTransportState.NEW;
        this.connectionLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.remoteOfferLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
    }
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions).loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    requirePublisher() {
        let require = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.isPublisherConnectionRequired = require;
        this.updateState();
    }
    requireSubscriber() {
        let require = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.isSubscriberConnectionRequired = require;
        this.updateState();
    }
    createAndSendPublisherOffer(options) {
        return this.publisher.createAndSendOffer(options);
    }
    setPublisherAnswer(sd) {
        return this.publisher.setRemoteDescription(sd);
    }
    removeTrack(sender) {
        return this.publisher.removeTrack(sender);
    }
    close() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.publisher && this.publisher.getSignallingState() !== "closed") {
                const publisher = this.publisher;
                for (const sender of publisher.getSenders())try {
                    // TODO: react-native-webrtc doesn't have removeTrack yet.
                    if (publisher.canRemoveTrack()) publisher.removeTrack(sender);
                } catch (e) {
                    this.log.warn("could not removeTrack", Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                }
            }
            yield Promise.all([
                this.publisher.close(),
                this.subscriber.close()
            ]);
            this.updateState();
        });
    }
    triggerIceRestart() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.subscriber.restartingIce = true;
            // only restart publisher if it's needed
            if (this.needsPublisher) yield this.createAndSendPublisherOffer({
                iceRestart: true
            });
        });
    }
    addIceCandidate(candidate, target) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (target === $d84dc1a5e217b32f$var$SignalTarget.PUBLISHER) yield this.publisher.addIceCandidate(candidate);
            else yield this.subscriber.addIceCandidate(candidate);
        });
    }
    createSubscriberAnswerFromOffer(sd) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.log.debug("received server offer", Object.assign(Object.assign({}, this.logContext), {
                RTCSdpType: sd.type,
                sdp: sd.sdp,
                signalingState: this.subscriber.getSignallingState().toString()
            }));
            const unlock = yield this.remoteOfferLock.lock();
            try {
                yield this.subscriber.setRemoteDescription(sd);
                // answer the offer
                const answer = yield this.subscriber.createAndSetAnswer();
                return answer;
            } finally{
                unlock();
            }
        });
    }
    updateConfiguration(config, iceRestart) {
        this.publisher.setConfiguration(config);
        this.subscriber.setConfiguration(config);
        if (iceRestart) this.triggerIceRestart();
    }
    ensurePCTransportConnection(abortController, timeout) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.connectionLock.lock();
            try {
                if (this.isPublisherConnectionRequired && this.publisher.getConnectionState() !== "connected" && this.publisher.getConnectionState() !== "connecting") {
                    this.log.debug("negotiation required, start negotiating", this.logContext);
                    this.publisher.negotiate();
                }
                yield Promise.all((_a = this.requiredTransports) === null || _a === void 0 ? void 0 : _a.map((transport)=>this.ensureTransportConnected(transport, abortController, timeout)));
            } finally{
                unlock();
            }
        });
    }
    negotiate(abortController) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    const negotiationTimeout = setTimeout(()=>{
                        reject("negotiation timed out");
                    }, this.peerConnectionTimeout);
                    const abortHandler = ()=>{
                        clearTimeout(negotiationTimeout);
                        reject("negotiation aborted");
                    };
                    abortController.signal.addEventListener("abort", abortHandler);
                    this.publisher.once($d84dc1a5e217b32f$var$PCEvents.NegotiationStarted, ()=>{
                        if (abortController.signal.aborted) return;
                        this.publisher.once($d84dc1a5e217b32f$var$PCEvents.NegotiationComplete, ()=>{
                            clearTimeout(negotiationTimeout);
                            resolve();
                        });
                    });
                    yield this.publisher.negotiate((e)=>{
                        clearTimeout(negotiationTimeout);
                        reject(e);
                    });
                }));
        });
    }
    addPublisherTransceiver(track, transceiverInit) {
        return this.publisher.addTransceiver(track, transceiverInit);
    }
    addPublisherTrack(track) {
        return this.publisher.addTrack(track);
    }
    createPublisherDataChannel(label, dataChannelDict) {
        return this.publisher.createDataChannel(label, dataChannelDict);
    }
    /**
   * Returns the first required transport's address if no explicit target is specified
   */ getConnectedAddress(target) {
        if (target === $d84dc1a5e217b32f$var$SignalTarget.PUBLISHER) return this.publisher.getConnectedAddress();
        else if (target === $d84dc1a5e217b32f$var$SignalTarget.SUBSCRIBER) return this.publisher.getConnectedAddress();
        return this.requiredTransports[0].getConnectedAddress();
    }
    get requiredTransports() {
        const transports = [];
        if (this.isPublisherConnectionRequired) transports.push(this.publisher);
        if (this.isSubscriberConnectionRequired) transports.push(this.subscriber);
        return transports;
    }
    ensureTransportConnected(pcTransport_1, abortController_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(pcTransport, abortController) {
            var _this = this;
            let timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.peerConnectionTimeout;
            return function*() {
                const connectionState = pcTransport.getConnectionState();
                if (connectionState === "connected") return;
                return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(_this, void 0, void 0, function*() {
                        const abortHandler = ()=>{
                            this.log.warn("abort transport connection", this.logContext);
                            $d84dc1a5e217b32f$export$22e737276454df96.clearTimeout(connectTimeout);
                            reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("room connection has been cancelled", $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled));
                        };
                        if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) abortHandler();
                        abortController === null || abortController === void 0 || abortController.signal.addEventListener("abort", abortHandler);
                        const connectTimeout = $d84dc1a5e217b32f$export$22e737276454df96.setTimeout(()=>{
                            abortController === null || abortController === void 0 || abortController.signal.removeEventListener("abort", abortHandler);
                            reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("could not establish pc connection", $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError));
                        }, timeout);
                        while(this.state !== $d84dc1a5e217b32f$var$PCTransportState.CONNECTED){
                            yield $d84dc1a5e217b32f$var$sleep(50); // FIXME we shouldn't rely on `sleep` in the connection paths, as it invokes `setTimeout` which can be drastically throttled by browser implementations
                            if (abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted) {
                                reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("room connection has been cancelled", $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled));
                                return;
                            }
                        }
                        $d84dc1a5e217b32f$export$22e737276454df96.clearTimeout(connectTimeout);
                        abortController === null || abortController === void 0 || abortController.signal.removeEventListener("abort", abortHandler);
                        resolve();
                    }));
            }();
        });
    }
}
const $d84dc1a5e217b32f$var$monitorFrequency = 2000;
function $d84dc1a5e217b32f$var$computeBitrate(currentStats, prevStats) {
    if (!prevStats) return 0;
    let bytesNow;
    let bytesPrev;
    if ("bytesReceived" in currentStats) {
        bytesNow = currentStats.bytesReceived;
        bytesPrev = prevStats.bytesReceived;
    } else if ("bytesSent" in currentStats) {
        bytesNow = currentStats.bytesSent;
        bytesPrev = prevStats.bytesSent;
    }
    if (bytesNow === undefined || bytesPrev === undefined || currentStats.timestamp === undefined || prevStats.timestamp === undefined) return 0;
    return (bytesNow - bytesPrev) * 8000 / (currentStats.timestamp - prevStats.timestamp);
}
class $d84dc1a5e217b32f$export$b287427b771ca237 extends $d84dc1a5e217b32f$export$3e041ce3f33f04dd {
    /**
   * boolean indicating whether enhanced noise cancellation is currently being used on this track
   */ get enhancedNoiseCancellation() {
        return this.isKrispNoiseFilterEnabled;
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let audioContext = arguments.length > 3 ? arguments[3] : undefined;
        let loggerOptions = arguments.length > 4 ? arguments[4] : undefined;
        super(mediaTrack, $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio, constraints, userProvidedTrack, loggerOptions);
        /** @internal */ this.stopOnMute = false;
        this.isKrispNoiseFilterEnabled = false;
        this.monitorSender = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error("could not get audio sender stats", Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                if (stats && this.prevStats) this._currentBitrate = $d84dc1a5e217b32f$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.handleKrispNoiseFilterEnable = ()=>{
            this.isKrispNoiseFilterEnabled = true;
            this.log.debug("Krisp noise filter enabled", this.logContext);
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $d84dc1a5e217b32f$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, true);
        };
        this.handleKrispNoiseFilterDisable = ()=>{
            this.isKrispNoiseFilterEnabled = false;
            this.log.debug("Krisp noise filter disabled", this.logContext);
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this, $d84dc1a5e217b32f$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION, false);
        };
        this.audioContext = audioContext;
        this.checkForSilence();
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug("Track already muted", this.logContext);
                    return this;
                }
                // disabled special handling as it will cause BT headsets to switch communication modes
                if (this.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone && this.stopOnMute && !this.isUserProvided) {
                    this.log.debug("stopping mic track", this.logContext);
                    // also stop the track, so that microphone indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug("Track already unmuted", this.logContext);
                    return this;
                }
                const deviceHasChanged = this._constraints.deviceId && this._mediaStreamTrack.getSettings().deviceId !== $d84dc1a5e217b32f$var$unwrapConstraint(this._constraints.deviceId);
                if (this.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone && (this.stopOnMute || this._mediaStreamTrack.readyState === "ended" || deviceHasChanged) && !this.isUserProvided) {
                    this.log.debug("reacquiring mic track", this.logContext);
                    yield this.restartTrack();
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    restartTrack(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            let constraints;
            if (options) {
                const streamConstraints = $d84dc1a5e217b32f$var$constraintsForOptions({
                    audio: options
                });
                if (typeof streamConstraints.audio !== "boolean") constraints = streamConstraints.audio;
            }
            yield this.restart(constraints);
        });
    }
    restart(constraints) {
        const _super = Object.create(null, {
            restart: {
                get: ()=>super.restart
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const track = yield _super.restart.call(this, constraints);
            this.checkForSilence();
            return track;
        });
    }
    /* @internal */ startMonitor() {
        if (!$d84dc1a5e217b32f$var$isWeb()) return;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $d84dc1a5e217b32f$var$monitorFrequency);
    }
    setProcessor(processor) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const unlock = yield this.processorLock.lock();
            try {
                if (!this.audioContext) throw Error("Audio context needs to be set on LocalAudioTrack in order to enable processors");
                if (this.processor) yield this.stopProcessor();
                const processorOptions = {
                    kind: this.kind,
                    track: this._mediaStreamTrack,
                    audioContext: this.audioContext
                };
                this.log.debug("setting up audio processor ".concat(processor.name), this.logContext);
                yield processor.init(processorOptions);
                this.processor = processor;
                if (this.processor.processedTrack) {
                    yield (_a = this.sender) === null || _a === void 0 ? void 0 : _a.replaceTrack(this.processor.processedTrack);
                    this.processor.processedTrack.addEventListener("enable-lk-krisp-noise-filter", this.handleKrispNoiseFilterEnable);
                    this.processor.processedTrack.addEventListener("disable-lk-krisp-noise-filter", this.handleKrispNoiseFilterDisable);
                }
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.TrackProcessorUpdate, this.processor);
            } finally{
                unlock();
            }
        });
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
    }
    getSenderStats() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return undefined;
            const stats = yield this.sender.getStats();
            let audioStats;
            stats.forEach((v)=>{
                if (v.type === "outbound-rtp") audioStats = {
                    type: "audio",
                    streamId: v.id,
                    packetsSent: v.packetsSent,
                    packetsLost: v.packetsLost,
                    bytesSent: v.bytesSent,
                    timestamp: v.timestamp,
                    roundTripTime: v.roundTripTime,
                    jitter: v.jitter
                };
            });
            return audioStats;
        });
    }
    checkForSilence() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const trackIsSilent = yield $d84dc1a5e217b32f$var$detectSilence(this);
            if (trackIsSilent) {
                if (!this.isMuted) this.log.warn("silence detected on local audio track", this.logContext);
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioSilenceDetected);
            }
            return trackIsSilent;
        });
    }
}
/** @internal */ function $d84dc1a5e217b32f$var$mediaTrackToLocalTrack(mediaStreamTrack, constraints, loggerOptions) {
    switch(mediaStreamTrack.kind){
        case "audio":
            return new $d84dc1a5e217b32f$export$b287427b771ca237(mediaStreamTrack, constraints, false, undefined, loggerOptions);
        case "video":
            return new $d84dc1a5e217b32f$export$d5ffd2c62c538bdc(mediaStreamTrack, constraints, false, loggerOptions);
        default:
            throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("unsupported track type: ".concat(mediaStreamTrack.kind));
    }
}
/* @internal */ const $d84dc1a5e217b32f$var$presets169 = Object.values($d84dc1a5e217b32f$export$79d56065dad1674c);
/* @internal */ const $d84dc1a5e217b32f$var$presets43 = Object.values($d84dc1a5e217b32f$export$eb5fc43ecc8ee2c7);
/* @internal */ const $d84dc1a5e217b32f$var$presetsScreenShare = Object.values($d84dc1a5e217b32f$export$a6cdf9dcd3d32f2d);
/* @internal */ const $d84dc1a5e217b32f$var$defaultSimulcastPresets169 = [
    $d84dc1a5e217b32f$export$79d56065dad1674c.h180,
    $d84dc1a5e217b32f$export$79d56065dad1674c.h360
];
/* @internal */ const $d84dc1a5e217b32f$var$defaultSimulcastPresets43 = [
    $d84dc1a5e217b32f$export$eb5fc43ecc8ee2c7.h180,
    $d84dc1a5e217b32f$export$eb5fc43ecc8ee2c7.h360
];
/* @internal */ const $d84dc1a5e217b32f$var$computeDefaultScreenShareSimulcastPresets = (fromPreset)=>{
    const layers = [
        {
            scaleResolutionDownBy: 2,
            fps: fromPreset.encoding.maxFramerate
        }
    ];
    return layers.map((t)=>{
        var _a, _b;
        return new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(Math.floor(fromPreset.width / t.scaleResolutionDownBy), Math.floor(fromPreset.height / t.scaleResolutionDownBy), Math.max(150000, Math.floor(fromPreset.encoding.maxBitrate / (Math.pow(t.scaleResolutionDownBy, 2) * (((_a = fromPreset.encoding.maxFramerate) !== null && _a !== void 0 ? _a : 30) / ((_b = t.fps) !== null && _b !== void 0 ? _b : 30))))), t.fps, fromPreset.encoding.priority);
    });
};
// /**
//  *
//  * @internal
//  * @experimental
//  */
// const computeDefaultMultiCodecSimulcastEncodings = (width: number, height: number) => {
//   // use vp8 as a default
//   const vp8 = determineAppropriateEncoding(false, width, height);
//   const vp9 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.9 };
//   const h264 = { ...vp8, maxBitrate: vp8.maxBitrate * 1.1 };
//   const av1 = { ...vp8, maxBitrate: vp8.maxBitrate * 0.7 };
//   return {
//     vp8,
//     vp9,
//     h264,
//     av1,
//   };
// };
const $d84dc1a5e217b32f$var$videoRids = [
    "q",
    "h",
    "f"
];
/* @internal */ function $d84dc1a5e217b32f$var$computeVideoEncodings(isScreenShare, width, height, options) {
    var _a, _b;
    let videoEncoding = options === null || options === void 0 ? void 0 : options.videoEncoding;
    if (isScreenShare) videoEncoding = options === null || options === void 0 ? void 0 : options.screenShareEncoding;
    const useSimulcast = options === null || options === void 0 ? void 0 : options.simulcast;
    const scalabilityMode = options === null || options === void 0 ? void 0 : options.scalabilityMode;
    const videoCodec = options === null || options === void 0 ? void 0 : options.videoCodec;
    if (!videoEncoding && !useSimulcast && !scalabilityMode || !width || !height) // when we aren't simulcasting or svc, will need to return a single encoding without
    // capping bandwidth. we always require a encoding for dynacast
    return [
        {}
    ];
    if (!videoEncoding) {
        // find the right encoding based on width/height
        videoEncoding = $d84dc1a5e217b32f$var$determineAppropriateEncoding(isScreenShare, width, height, videoCodec);
        $d84dc1a5e217b32f$var$livekitLogger.debug("using video encoding", videoEncoding);
    }
    const sourceFramerate = videoEncoding.maxFramerate;
    const original = new $d84dc1a5e217b32f$export$73e76f4fd970cdf1(width, height, videoEncoding.maxBitrate, videoEncoding.maxFramerate, videoEncoding.priority);
    if (scalabilityMode && $d84dc1a5e217b32f$var$isSVCCodec(videoCodec)) {
        const sm = new $d84dc1a5e217b32f$var$ScalabilityMode(scalabilityMode);
        const encodings = [];
        if (sm.spatial > 3) throw new Error("unsupported scalabilityMode: ".concat(scalabilityMode));
        // Before M113 in Chrome, defining multiple encodings with an SVC codec indicated
        // that SVC mode should be used. Safari still works this way.
        // This is a bit confusing but is due to how libwebrtc interpreted the encodings field
        // before M113.
        // Announced here: https://groups.google.com/g/discuss-webrtc/c/-QQ3pxrl-fw?pli=1
        const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
        if ($d84dc1a5e217b32f$var$isSafari() || // Even tho RN runs M114, it does not produce SVC layers when a single encoding
        // is provided. So we'll use the legacy SVC specification for now.
        // TODO: when we upstream libwebrtc, this will need additional verification
        $d84dc1a5e217b32f$var$isReactNative() || (browser === null || browser === void 0 ? void 0 : browser.name) === "Chrome" && $d84dc1a5e217b32f$export$66e1c0999abad646(browser === null || browser === void 0 ? void 0 : browser.version, "113") < 0) {
            const bitratesRatio = sm.suffix == "h" ? 2 : 3;
            for(let i = 0; i < sm.spatial; i += 1)// in legacy SVC, scaleResolutionDownBy cannot be set
            encodings.push({
                rid: $d84dc1a5e217b32f$var$videoRids[2 - i],
                maxBitrate: videoEncoding.maxBitrate / Math.pow(bitratesRatio, i),
                maxFramerate: original.encoding.maxFramerate
            });
            // legacy SVC, scalabilityMode is set only on the first encoding
            /* @ts-ignore */ encodings[0].scalabilityMode = scalabilityMode;
        } else encodings.push({
            maxBitrate: videoEncoding.maxBitrate,
            maxFramerate: original.encoding.maxFramerate,
            /* @ts-ignore */ scalabilityMode: scalabilityMode
        });
        if (original.encoding.priority) {
            encodings[0].priority = original.encoding.priority;
            encodings[0].networkPriority = original.encoding.priority;
        }
        $d84dc1a5e217b32f$var$livekitLogger.debug("using svc encoding", {
            encodings: encodings
        });
        return encodings;
    }
    if (!useSimulcast) return [
        videoEncoding
    ];
    let presets = [];
    if (isScreenShare) presets = (_a = $d84dc1a5e217b32f$var$sortPresets(options === null || options === void 0 ? void 0 : options.screenShareSimulcastLayers)) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$var$defaultSimulcastLayers(isScreenShare, original);
    else presets = (_b = $d84dc1a5e217b32f$var$sortPresets(options === null || options === void 0 ? void 0 : options.videoSimulcastLayers)) !== null && _b !== void 0 ? _b : $d84dc1a5e217b32f$var$defaultSimulcastLayers(isScreenShare, original);
    let midPreset;
    if (presets.length > 0) {
        const lowPreset = presets[0];
        if (presets.length > 1) [, midPreset] = presets;
        // NOTE:
        //   1. Ordering of these encodings is important. Chrome seems
        //      to use the index into encodings to decide which layer
        //      to disable when CPU constrained.
        //      So encodings should be ordered in increasing spatial
        //      resolution order.
        //   2. livekit-server translates rids into layers. So, all encodings
        //      should have the base layer `q` and then more added
        //      based on other conditions.
        const size = Math.max(width, height);
        if (size >= 960 && midPreset) return $d84dc1a5e217b32f$var$encodingsFromPresets(width, height, [
            lowPreset,
            midPreset,
            original
        ], sourceFramerate);
        if (size >= 480) return $d84dc1a5e217b32f$var$encodingsFromPresets(width, height, [
            lowPreset,
            original
        ], sourceFramerate);
    }
    return $d84dc1a5e217b32f$var$encodingsFromPresets(width, height, [
        original
    ]);
}
function $d84dc1a5e217b32f$var$computeTrackBackupEncodings(track, videoCodec, opts) {
    var _a, _b, _c, _d;
    // backupCodec should not be true anymore, default codec is set in LocalParticipant.publish
    if (!opts.backupCodec || opts.backupCodec === true || opts.backupCodec.codec === opts.videoCodec) // backup codec publishing is disabled
    return;
    if (videoCodec !== opts.backupCodec.codec) $d84dc1a5e217b32f$var$livekitLogger.warn("requested a different codec than specified as backup", {
        serverRequested: videoCodec,
        backup: opts.backupCodec.codec
    });
    opts.videoCodec = videoCodec;
    // use backup encoding setting as videoEncoding for backup codec publishing
    opts.videoEncoding = opts.backupCodec.encoding;
    const settings = track.mediaStreamTrack.getSettings();
    const width = (_a = settings.width) !== null && _a !== void 0 ? _a : (_b = track.dimensions) === null || _b === void 0 ? void 0 : _b.width;
    const height = (_c = settings.height) !== null && _c !== void 0 ? _c : (_d = track.dimensions) === null || _d === void 0 ? void 0 : _d.height;
    const encodings = $d84dc1a5e217b32f$var$computeVideoEncodings(track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare, width, height, opts);
    return encodings;
}
/* @internal */ function $d84dc1a5e217b32f$var$determineAppropriateEncoding(isScreenShare, width, height, codec) {
    const presets = $d84dc1a5e217b32f$var$presetsForResolution(isScreenShare, width, height);
    let { encoding: encoding } = presets[0];
    // handle portrait by swapping dimensions
    const size = Math.max(width, height);
    for(let i = 0; i < presets.length; i += 1){
        const preset = presets[i];
        encoding = preset.encoding;
        if (preset.width >= size) break;
    }
    // presets are based on the assumption of vp8 as a codec
    // for other codecs we adjust the maxBitrate if no specific videoEncoding has been provided
    // users should override these with ones that are optimized for their use case
    // NOTE: SVC codec bitrates are inclusive of all scalability layers. while
    // bitrate for non-SVC codecs does not include other simulcast layers.
    if (codec) switch(codec){
        case "av1":
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.7;
            break;
        case "vp9":
            encoding = Object.assign({}, encoding);
            encoding.maxBitrate = encoding.maxBitrate * 0.85;
            break;
    }
    return encoding;
}
/* @internal */ function $d84dc1a5e217b32f$var$presetsForResolution(isScreenShare, width, height) {
    if (isScreenShare) return $d84dc1a5e217b32f$var$presetsScreenShare;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $d84dc1a5e217b32f$var$presets169;
    return $d84dc1a5e217b32f$var$presets43;
}
/* @internal */ function $d84dc1a5e217b32f$var$defaultSimulcastLayers(isScreenShare, original) {
    if (isScreenShare) return $d84dc1a5e217b32f$var$computeDefaultScreenShareSimulcastPresets(original);
    const { width: width, height: height } = original;
    const aspect = width > height ? width / height : height / width;
    if (Math.abs(aspect - 16.0 / 9) < Math.abs(aspect - 4.0 / 3)) return $d84dc1a5e217b32f$var$defaultSimulcastPresets169;
    return $d84dc1a5e217b32f$var$defaultSimulcastPresets43;
}
// presets should be ordered by low, medium, high
function $d84dc1a5e217b32f$var$encodingsFromPresets(width, height, presets, sourceFramerate) {
    const encodings = [];
    presets.forEach((preset, idx)=>{
        if (idx >= $d84dc1a5e217b32f$var$videoRids.length) return;
        const size = Math.min(width, height);
        const rid = $d84dc1a5e217b32f$var$videoRids[idx];
        const encoding = {
            rid: rid,
            scaleResolutionDownBy: Math.max(1, size / Math.min(preset.width, preset.height)),
            maxBitrate: preset.encoding.maxBitrate
        };
        // ensure that the sourceFramerate is the highest framerate applied across all layers so that the
        // original encoding doesn't get bumped unintentionally by any of the other layers
        const maxFramerate = sourceFramerate && preset.encoding.maxFramerate ? Math.min(sourceFramerate, preset.encoding.maxFramerate) : preset.encoding.maxFramerate;
        if (maxFramerate) encoding.maxFramerate = maxFramerate;
        const canSetPriority = $d84dc1a5e217b32f$var$isFireFox() || idx === 0;
        if (preset.encoding.priority && canSetPriority) {
            encoding.priority = preset.encoding.priority;
            encoding.networkPriority = preset.encoding.priority;
        }
        encodings.push(encoding);
    });
    // RN ios simulcast requires all same framerates.
    if ($d84dc1a5e217b32f$var$isReactNative() && $d84dc1a5e217b32f$var$getReactNativeOs() === "ios") {
        let topFramerate = undefined;
        encodings.forEach((encoding)=>{
            if (!topFramerate) topFramerate = encoding.maxFramerate;
            else if (encoding.maxFramerate && encoding.maxFramerate > topFramerate) topFramerate = encoding.maxFramerate;
        });
        let notifyOnce = true;
        encodings.forEach((encoding)=>{
            var _a;
            if (encoding.maxFramerate != topFramerate) {
                if (notifyOnce) {
                    notifyOnce = false;
                    $d84dc1a5e217b32f$var$livekitLogger.info("Simulcast on iOS React-Native requires all encodings to share the same framerate.");
                }
                $d84dc1a5e217b32f$var$livekitLogger.info('Setting framerate of encoding "'.concat((_a = encoding.rid) !== null && _a !== void 0 ? _a : "", '" to ').concat(topFramerate));
                encoding.maxFramerate = topFramerate;
            }
        });
    }
    return encodings;
}
/** @internal */ function $d84dc1a5e217b32f$var$sortPresets(presets) {
    if (!presets) return;
    return presets.sort((a, b)=>{
        const { encoding: aEnc } = a;
        const { encoding: bEnc } = b;
        if (aEnc.maxBitrate > bEnc.maxBitrate) return 1;
        if (aEnc.maxBitrate < bEnc.maxBitrate) return -1;
        if (aEnc.maxBitrate === bEnc.maxBitrate && aEnc.maxFramerate && bEnc.maxFramerate) return aEnc.maxFramerate > bEnc.maxFramerate ? 1 : -1;
        return 0;
    });
}
/** @internal */ class $d84dc1a5e217b32f$var$ScalabilityMode {
    constructor(scalabilityMode){
        const results = scalabilityMode.match(/^L(\d)T(\d)(h|_KEY|_KEY_SHIFT){0,1}$/);
        if (!results) throw new Error("invalid scalability mode");
        this.spatial = parseInt(results[1]);
        this.temporal = parseInt(results[2]);
        if (results.length > 3) switch(results[3]){
            case "h":
            case "_KEY":
            case "_KEY_SHIFT":
                this.suffix = results[3];
        }
    }
    toString() {
        var _a;
        return "L".concat(this.spatial, "T").concat(this.temporal).concat((_a = this.suffix) !== null && _a !== void 0 ? _a : "");
    }
}
function $d84dc1a5e217b32f$var$getDefaultDegradationPreference(track) {
    // a few of reasons we have different default paths:
    // 1. without this, Chrome seems to aggressively resize the SVC video stating `quality-limitation: bandwidth` even when BW isn't an issue
    // 2. since we are overriding contentHint to motion (to workaround L1T3 publishing), it overrides the default degradationPreference to `balanced`
    if (track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare || track.constraints.height && $d84dc1a5e217b32f$var$unwrapConstraint(track.constraints.height) >= 1080) return "maintain-resolution";
    else return "balanced";
}
const $d84dc1a5e217b32f$var$refreshSubscribedCodecAfterNewCodec = 5000;
class $d84dc1a5e217b32f$export$d5ffd2c62c538bdc extends $d84dc1a5e217b32f$export$3e041ce3f33f04dd {
    get sender() {
        return this._sender;
    }
    set sender(sender) {
        this._sender = sender;
        if (this.degradationPreference) this.setDegradationPreference(this.degradationPreference);
    }
    /**
   *
   * @param mediaTrack
   * @param constraints MediaTrackConstraints that are being used when restarting or reacquiring tracks
   * @param userProvidedTrack Signals to the SDK whether or not the mediaTrack should be managed (i.e. released and reacquired) internally by the SDK
   */ constructor(mediaTrack, constraints){
        let userProvidedTrack = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        let loggerOptions = arguments.length > 3 ? arguments[3] : undefined;
        super(mediaTrack, $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video, constraints, userProvidedTrack, loggerOptions);
        /* @internal */ this.simulcastCodecs = new Map();
        this.degradationPreference = "balanced";
        this.monitorSender = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.sender) {
                    this._currentBitrate = 0;
                    return;
                }
                let stats;
                try {
                    stats = yield this.getSenderStats();
                } catch (e) {
                    this.log.error("could not get audio sender stats", Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    return;
                }
                const statsMap = new Map(stats.map((s)=>[
                        s.rid,
                        s
                    ]));
                if (this.prevStats) {
                    let totalBitrate = 0;
                    statsMap.forEach((s, key)=>{
                        var _a;
                        const prev = (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.get(key);
                        totalBitrate += $d84dc1a5e217b32f$var$computeBitrate(s, prev);
                    });
                    this._currentBitrate = totalBitrate;
                }
                this.prevStats = statsMap;
            });
        this.senderLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
    }
    get isSimulcast() {
        if (this.sender && this.sender.getParameters().encodings.length > 1) return true;
        return false;
    }
    /* @internal */ startMonitor(signalClient) {
        var _a;
        this.signalClient = signalClient;
        if (!$d84dc1a5e217b32f$var$isWeb()) return;
        // save original encodings
        // TODO : merge simulcast tracks stats
        const params = (_a = this.sender) === null || _a === void 0 ? void 0 : _a.getParameters();
        if (params) this.encodings = params.encodings;
        if (this.monitorInterval) return;
        this.monitorInterval = setInterval(()=>{
            this.monitorSender();
        }, $d84dc1a5e217b32f$var$monitorFrequency);
    }
    stop() {
        this._mediaStreamTrack.getConstraints();
        this.simulcastCodecs.forEach((trackInfo)=>{
            trackInfo.mediaStreamTrack.stop();
        });
        super.stop();
    }
    pauseUpstream() {
        const _super = Object.create(null, {
            pauseUpstream: {
                get: ()=>super.pauseUpstream
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_1, _b, _c;
            var _d;
            yield _super.pauseUpstream.call(this);
            try {
                for(var _e = true, _f = $d84dc1a5e217b32f$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(null);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    }
    resumeUpstream() {
        const _super = Object.create(null, {
            resumeUpstream: {
                get: ()=>super.resumeUpstream
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_2, _b, _c;
            var _d;
            yield _super.resumeUpstream.call(this);
            try {
                for(var _e = true, _f = $d84dc1a5e217b32f$var$__asyncValues(this.simulcastCodecs.values()), _g; _g = yield _f.next(), _a = _g.done, !_a; _e = true){
                    _c = _g.value;
                    _e = false;
                    const sc = _c;
                    yield (_d = sc.sender) === null || _d === void 0 ? void 0 : _d.replaceTrack(sc.mediaStreamTrack);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (!_e && !_a && (_b = _f.return)) yield _b.call(_f);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        });
    }
    mute() {
        const _super = Object.create(null, {
            mute: {
                get: ()=>super.mute
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (this.isMuted) {
                    this.log.debug("Track already muted", this.logContext);
                    return this;
                }
                if (this.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug("stopping camera track", this.logContext);
                    // also stop the track, so that camera indicator is turned off
                    this._mediaStreamTrack.stop();
                }
                yield _super.mute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    unmute() {
        const _super = Object.create(null, {
            unmute: {
                get: ()=>super.unmute
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.muteLock.lock();
            try {
                if (!this.isMuted) {
                    this.log.debug("Track already unmuted", this.logContext);
                    return this;
                }
                if (this.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera && !this.isUserProvided) {
                    this.log.debug("reacquiring camera track", this.logContext);
                    yield this.restartTrack();
                }
                yield _super.unmute.call(this);
                return this;
            } finally{
                unlock();
            }
        });
    }
    setTrackMuted(muted) {
        super.setTrackMuted(muted);
        for (const sc of this.simulcastCodecs.values())sc.mediaStreamTrack.enabled = !muted;
    }
    getSenderStats() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.sender) === null || _a === void 0 ? void 0 : _a.getStats)) return [];
            const items = [];
            const stats = yield this.sender.getStats();
            stats.forEach((v)=>{
                var _a;
                if (v.type === "outbound-rtp") {
                    const vs = {
                        type: "video",
                        streamId: v.id,
                        frameHeight: v.frameHeight,
                        frameWidth: v.frameWidth,
                        framesPerSecond: v.framesPerSecond,
                        framesSent: v.framesSent,
                        firCount: v.firCount,
                        pliCount: v.pliCount,
                        nackCount: v.nackCount,
                        packetsSent: v.packetsSent,
                        bytesSent: v.bytesSent,
                        qualityLimitationReason: v.qualityLimitationReason,
                        qualityLimitationDurations: v.qualityLimitationDurations,
                        qualityLimitationResolutionChanges: v.qualityLimitationResolutionChanges,
                        rid: (_a = v.rid) !== null && _a !== void 0 ? _a : v.id,
                        retransmittedPacketsSent: v.retransmittedPacketsSent,
                        targetBitrate: v.targetBitrate,
                        timestamp: v.timestamp
                    };
                    // locate the appropriate remote-inbound-rtp item
                    const r = stats.get(v.remoteId);
                    if (r) {
                        vs.jitter = r.jitter;
                        vs.packetsLost = r.packetsLost;
                        vs.roundTripTime = r.roundTripTime;
                    }
                    items.push(vs);
                }
            });
            // make sure highest res layer is always first
            items.sort((a, b)=>{
                var _a, _b;
                return ((_a = b.frameWidth) !== null && _a !== void 0 ? _a : 0) - ((_b = a.frameWidth) !== null && _b !== void 0 ? _b : 0);
            });
            return items;
        });
    }
    setPublishingQuality(maxQuality) {
        const qualities = [];
        for(let q = $d84dc1a5e217b32f$export$a8f593954e806155.LOW; q <= $d84dc1a5e217b32f$export$a8f593954e806155.HIGH; q += 1)qualities.push(new $d84dc1a5e217b32f$var$SubscribedQuality({
            quality: q,
            enabled: q <= maxQuality
        }));
        this.log.debug("setting publishing quality. max quality ".concat(maxQuality), this.logContext);
        this.setPublishingLayers(qualities);
    }
    restartTrack(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, e_3, _b, _c;
            let constraints;
            if (options) {
                const streamConstraints = $d84dc1a5e217b32f$var$constraintsForOptions({
                    video: options
                });
                if (typeof streamConstraints.video !== "boolean") constraints = streamConstraints.video;
            }
            yield this.restart(constraints);
            try {
                for(var _d = true, _e = $d84dc1a5e217b32f$var$__asyncValues(this.simulcastCodecs.values()), _f; _f = yield _e.next(), _a = _f.done, !_a; _d = true){
                    _c = _f.value;
                    _d = false;
                    const sc = _c;
                    if (sc.sender) {
                        sc.mediaStreamTrack = this.mediaStreamTrack.clone();
                        yield sc.sender.replaceTrack(sc.mediaStreamTrack);
                    }
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = _e.return)) yield _b.call(_e);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        });
    }
    setProcessor(processor_1) {
        const _super = Object.create(null, {
            setProcessor: {
                get: ()=>super.setProcessor
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(processor) {
            var _this = this;
            let showProcessedStreamLocally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                var _a, e_4, _b, _c;
                var _d, _e;
                yield _super.setProcessor.call(_this, processor, showProcessedStreamLocally);
                if ((_d = _this.processor) === null || _d === void 0 ? void 0 : _d.processedTrack) try {
                    for(var _f = true, _g = $d84dc1a5e217b32f$var$__asyncValues(_this.simulcastCodecs.values()), _h; _h = yield _g.next(), _a = _h.done, !_a; _f = true){
                        _c = _h.value;
                        _f = false;
                        const sc = _c;
                        yield (_e = sc.sender) === null || _e === void 0 ? void 0 : _e.replaceTrack(_this.processor.processedTrack);
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (!_f && !_a && (_b = _g.return)) yield _b.call(_g);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }();
        });
    }
    setDegradationPreference(preference) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.degradationPreference = preference;
            if (this.sender) try {
                this.log.debug("setting degradationPreference to ".concat(preference), this.logContext);
                const params = this.sender.getParameters();
                params.degradationPreference = preference;
                this.sender.setParameters(params);
            } catch (e) {
                this.log.warn("failed to set degradationPreference", Object.assign({
                    error: e
                }, this.logContext));
            }
        });
    }
    addSimulcastTrack(codec, encodings) {
        if (this.simulcastCodecs.has(codec)) {
            this.log.error("".concat(codec, " already added, skipping adding simulcast codec"), this.logContext);
            return;
        }
        const simulcastCodecInfo = {
            codec: codec,
            mediaStreamTrack: this.mediaStreamTrack.clone(),
            sender: undefined,
            encodings: encodings
        };
        this.simulcastCodecs.set(codec, simulcastCodecInfo);
        return simulcastCodecInfo;
    }
    setSimulcastTrackSender(codec, sender) {
        const simulcastCodecInfo = this.simulcastCodecs.get(codec);
        if (!simulcastCodecInfo) return;
        simulcastCodecInfo.sender = sender;
        // browser will reenable disabled codec/layers after new codec has been published,
        // so refresh subscribedCodecs after publish a new codec
        setTimeout(()=>{
            if (this.subscribedCodecs) this.setPublishingCodecs(this.subscribedCodecs);
        }, $d84dc1a5e217b32f$var$refreshSubscribedCodecAfterNewCodec);
    }
    /**
   * @internal
   * Sets codecs that should be publishing, returns new codecs that have not yet
   * been published
   */ setPublishingCodecs(codecs) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, codecs_1, codecs_1_1;
            var _b, e_5, _c, _d;
            this.log.debug("setting publishing codecs", Object.assign(Object.assign({}, this.logContext), {
                codecs: codecs,
                currentCodec: this.codec
            }));
            // only enable simulcast codec for preference codec setted
            if (!this.codec && codecs.length > 0) {
                yield this.setPublishingLayers(codecs[0].qualities);
                return [];
            }
            this.subscribedCodecs = codecs;
            const newCodecs = [];
            try {
                for(_a = true, codecs_1 = $d84dc1a5e217b32f$var$__asyncValues(codecs); codecs_1_1 = yield codecs_1.next(), _b = codecs_1_1.done, !_b; _a = true){
                    _d = codecs_1_1.value;
                    _a = false;
                    const codec = _d;
                    if (!this.codec || this.codec === codec.codec) yield this.setPublishingLayers(codec.qualities);
                    else {
                        const simulcastCodecInfo = this.simulcastCodecs.get(codec.codec);
                        this.log.debug("try setPublishingCodec for ".concat(codec.codec), Object.assign(Object.assign({}, this.logContext), {
                            simulcastCodecInfo: simulcastCodecInfo
                        }));
                        if (!simulcastCodecInfo || !simulcastCodecInfo.sender) {
                            for (const q of codec.qualities)if (q.enabled) {
                                newCodecs.push(codec.codec);
                                break;
                            }
                        } else if (simulcastCodecInfo.encodings) {
                            this.log.debug("try setPublishingLayersForSender ".concat(codec.codec), this.logContext);
                            yield $d84dc1a5e217b32f$var$setPublishingLayersForSender(simulcastCodecInfo.sender, simulcastCodecInfo.encodings, codec.qualities, this.senderLock, this.log, this.logContext);
                        }
                    }
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (!_a && !_b && (_c = codecs_1.return)) yield _c.call(codecs_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            return newCodecs;
        });
    }
    /**
   * @internal
   * Sets layers that should be publishing
   */ setPublishingLayers(qualities) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.log.debug("setting publishing layers", Object.assign(Object.assign({}, this.logContext), {
                qualities: qualities
            }));
            if (!this.sender || !this.encodings) return;
            yield $d84dc1a5e217b32f$var$setPublishingLayersForSender(this.sender, this.encodings, qualities, this.senderLock, this.log, this.logContext);
        });
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!$d84dc1a5e217b32f$var$isMobile()) return;
            if (this.isInBackground && this.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera) this._mediaStreamTrack.enabled = false;
        });
    }
}
function $d84dc1a5e217b32f$var$setPublishingLayersForSender(sender, senderEncodings, qualities, senderLock, log, logContext) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const unlock = yield senderLock.lock();
        log.debug("setPublishingLayersForSender", Object.assign(Object.assign({}, logContext), {
            sender: sender,
            qualities: qualities,
            senderEncodings: senderEncodings
        }));
        try {
            const params = sender.getParameters();
            const { encodings: encodings } = params;
            if (!encodings) return;
            if (encodings.length !== senderEncodings.length) {
                log.warn("cannot set publishing layers, encodings mismatch", Object.assign(Object.assign({}, logContext), {
                    encodings: encodings,
                    senderEncodings: senderEncodings
                }));
                return;
            }
            let hasChanged = false;
            /* disable closable spatial layer as it has video blur / frozen issue with current server / client
      1. chrome 113: when switching to up layer with scalability Mode change, it will generate a
            low resolution frame and recover very quickly, but noticable
      2. livekit sfu: additional pli request cause video frozen for a few frames, also noticable */ const closableSpatial = false;
            /* @ts-ignore */ if (closableSpatial && encodings[0].scalabilityMode) ;
            else // simulcast dynacast encodings
            encodings.forEach((encoding, idx)=>{
                var _a;
                let rid = (_a = encoding.rid) !== null && _a !== void 0 ? _a : "";
                if (rid === "") rid = "q";
                const quality = $d84dc1a5e217b32f$var$videoQualityForRid(rid);
                const subscribedQuality = qualities.find((q)=>q.quality === quality);
                if (!subscribedQuality) return;
                if (encoding.active !== subscribedQuality.enabled) {
                    hasChanged = true;
                    encoding.active = subscribedQuality.enabled;
                    log.debug("setting layer ".concat(subscribedQuality.quality, " to ").concat(encoding.active ? "enabled" : "disabled"), logContext);
                    // FireFox does not support setting encoding.active to false, so we
                    // have a workaround of lowering its bitrate and resolution to the min.
                    if ($d84dc1a5e217b32f$var$isFireFox()) {
                        if (subscribedQuality.enabled) {
                            encoding.scaleResolutionDownBy = senderEncodings[idx].scaleResolutionDownBy;
                            encoding.maxBitrate = senderEncodings[idx].maxBitrate;
                            /* @ts-ignore */ encoding.maxFrameRate = senderEncodings[idx].maxFrameRate;
                        } else {
                            encoding.scaleResolutionDownBy = 4;
                            encoding.maxBitrate = 10;
                            /* @ts-ignore */ encoding.maxFrameRate = 2;
                        }
                    }
                }
            });
            if (hasChanged) {
                params.encodings = encodings;
                log.debug("setting encodings", Object.assign(Object.assign({}, logContext), {
                    encodings: params.encodings
                }));
                yield sender.setParameters(params);
            }
        } finally{
            unlock();
        }
    });
}
function $d84dc1a5e217b32f$var$videoQualityForRid(rid) {
    switch(rid){
        case "f":
            return $d84dc1a5e217b32f$export$a8f593954e806155.HIGH;
        case "h":
            return $d84dc1a5e217b32f$export$a8f593954e806155.MEDIUM;
        case "q":
            return $d84dc1a5e217b32f$export$a8f593954e806155.LOW;
        default:
            return $d84dc1a5e217b32f$export$a8f593954e806155.HIGH;
    }
}
function $d84dc1a5e217b32f$var$videoLayersFromEncodings(width, height, encodings, svc) {
    // default to a single layer, HQ
    if (!encodings) return [
        new $d84dc1a5e217b32f$var$VideoLayer({
            quality: $d84dc1a5e217b32f$export$a8f593954e806155.HIGH,
            width: width,
            height: height,
            bitrate: 0,
            ssrc: 0
        })
    ];
    if (svc) {
        // svc layers
        /* @ts-ignore */ const encodingSM = encodings[0].scalabilityMode;
        const sm = new $d84dc1a5e217b32f$var$ScalabilityMode(encodingSM);
        const layers = [];
        const resRatio = sm.suffix == "h" ? 1.5 : 2;
        const bitratesRatio = sm.suffix == "h" ? 2 : 3;
        for(let i = 0; i < sm.spatial; i += 1)layers.push(new $d84dc1a5e217b32f$var$VideoLayer({
            quality: Math.min($d84dc1a5e217b32f$export$a8f593954e806155.HIGH, sm.spatial - 1) - i,
            width: Math.ceil(width / Math.pow(resRatio, i)),
            height: Math.ceil(height / Math.pow(resRatio, i)),
            bitrate: encodings[0].maxBitrate ? Math.ceil(encodings[0].maxBitrate / Math.pow(bitratesRatio, i)) : 0,
            ssrc: 0
        }));
        return layers;
    }
    return encodings.map((encoding)=>{
        var _a, _b, _c;
        const scale = (_a = encoding.scaleResolutionDownBy) !== null && _a !== void 0 ? _a : 1;
        let quality = $d84dc1a5e217b32f$var$videoQualityForRid((_b = encoding.rid) !== null && _b !== void 0 ? _b : "");
        return new $d84dc1a5e217b32f$var$VideoLayer({
            quality: quality,
            width: Math.ceil(width / scale),
            height: Math.ceil(height / scale),
            bitrate: (_c = encoding.maxBitrate) !== null && _c !== void 0 ? _c : 0,
            ssrc: 0
        });
    });
}
const $d84dc1a5e217b32f$var$lossyDataChannel = "_lossy";
const $d84dc1a5e217b32f$var$reliableDataChannel = "_reliable";
const $d84dc1a5e217b32f$var$minReconnectWait = 2000;
const $d84dc1a5e217b32f$var$leaveReconnect = "leave-reconnect";
var $d84dc1a5e217b32f$var$PCState;
(function(PCState) {
    PCState[PCState["New"] = 0] = "New";
    PCState[PCState["Connected"] = 1] = "Connected";
    PCState[PCState["Disconnected"] = 2] = "Disconnected";
    PCState[PCState["Reconnecting"] = 3] = "Reconnecting";
    PCState[PCState["Closed"] = 4] = "Closed";
})($d84dc1a5e217b32f$var$PCState || ($d84dc1a5e217b32f$var$PCState = {}));
/** @internal */ class $d84dc1a5e217b32f$var$RTCEngine extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    get isClosed() {
        return this._isClosed;
    }
    get pendingReconnect() {
        return !!this.reconnectTimeout;
    }
    constructor(options){
        var _a;
        super();
        this.options = options;
        this.rtcConfig = {};
        this.peerConnectionTimeout = $d84dc1a5e217b32f$var$roomConnectOptionDefaults.peerConnectionTimeout;
        this.fullReconnectOnNext = false;
        this.subscriberPrimary = false;
        this.pcState = $d84dc1a5e217b32f$var$PCState.New;
        this._isClosed = true;
        this.pendingTrackResolvers = {};
        this.reconnectAttempts = 0;
        this.reconnectStart = 0;
        this.attemptingReconnect = false;
        /** keeps track of how often an initial join connection has been tried */ this.joinAttempts = 0;
        /** specifies how often an initial join connection is allowed to retry */ this.maxJoinAttempts = 1;
        this.shouldFailNext = false;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.handleDataChannel = (_a)=>$d84dc1a5e217b32f$var$__awaiter(this, [
                _a
            ], void 0, function(_ref) {
                var _this = this;
                let { channel: channel } = _ref;
                return function*() {
                    if (!channel) return;
                    if (channel.label === $d84dc1a5e217b32f$var$reliableDataChannel) _this.reliableDCSub = channel;
                    else if (channel.label === $d84dc1a5e217b32f$var$lossyDataChannel) _this.lossyDCSub = channel;
                    else return;
                    _this.log.debug("on data channel ".concat(channel.id, ", ").concat(channel.label), _this.logContext);
                    channel.onmessage = _this.handleDataMessage;
                }();
            });
        this.handleDataMessage = (message)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                // make sure to respect incoming data message order by processing message events one after the other
                const unlock = yield this.dataProcessLock.lock();
                try {
                    // decode
                    let buffer;
                    if (message.data instanceof ArrayBuffer) buffer = message.data;
                    else if (message.data instanceof Blob) buffer = yield message.data.arrayBuffer();
                    else {
                        this.log.error("unsupported data type", Object.assign(Object.assign({}, this.logContext), {
                            data: message.data
                        }));
                        return;
                    }
                    const dp = $d84dc1a5e217b32f$var$DataPacket.fromBinary(new Uint8Array(buffer));
                    if (((_a = dp.value) === null || _a === void 0 ? void 0 : _a.case) === "speaker") // dispatch speaker updates
                    this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.ActiveSpeakersUpdate, dp.value.value.speakers);
                    else {
                        if (((_b = dp.value) === null || _b === void 0 ? void 0 : _b.case) === "user") // compatibility
                        $d84dc1a5e217b32f$var$applyUserDataCompat(dp, dp.value.value);
                        this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.DataPacketReceived, dp);
                    }
                } finally{
                    unlock();
                }
            });
        this.handleDataError = (event)=>{
            const channel = event.currentTarget;
            const channelKind = channel.maxRetransmits === 0 ? "lossy" : "reliable";
            if (event instanceof ErrorEvent && event.error) {
                const { error: error } = event.error;
                this.log.error("DataChannel error on ".concat(channelKind, ": ").concat(event.message), Object.assign(Object.assign({}, this.logContext), {
                    error: error
                }));
            } else this.log.error("Unknown DataChannel error on ".concat(channelKind), Object.assign(Object.assign({}, this.logContext), {
                event: event
            }));
        };
        this.handleBufferedAmountLow = (event)=>{
            const channel = event.currentTarget;
            const channelKind = channel.maxRetransmits === 0 ? $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY : $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE;
            this.updateAndEmitDCBufferStatus(channelKind);
        };
        // websocket reconnect behavior. if websocket is interrupted, and the PeerConnection
        // continues to work, we can reconnect to websocket to continue the session
        // after a number of retries, we'll close and give up permanently
        this.handleDisconnect = (connection, disconnectReason)=>{
            if (this._isClosed) return;
            this.log.warn("".concat(connection, " disconnected"), this.logContext);
            if (this.reconnectAttempts === 0) // only reset start time on the first try
            this.reconnectStart = Date.now();
            const disconnect = (duration)=>{
                this.log.warn("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(duration, "ms. giving up"), this.logContext);
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected);
                this.close();
            };
            const duration = Date.now() - this.reconnectStart;
            let delay = this.getNextRetryDelay({
                elapsedMs: duration,
                retryCount: this.reconnectAttempts
            });
            if (delay === null) {
                disconnect(duration);
                return;
            }
            if (connection === $d84dc1a5e217b32f$var$leaveReconnect) delay = 0;
            this.log.debug("reconnecting in ".concat(delay, "ms"), this.logContext);
            this.clearReconnectTimeout();
            if (this.token && this.regionUrlProvider) // token may have been refreshed, we do not want to recreate the regionUrlProvider
            // since the current engine may have inherited a regional url
            this.regionUrlProvider.updateToken(this.token);
            this.reconnectTimeout = $d84dc1a5e217b32f$export$22e737276454df96.setTimeout(()=>this.attemptReconnect(disconnectReason).finally(()=>this.reconnectTimeout = undefined), delay);
        };
        this.waitForRestarted = ()=>{
            return new Promise((resolve, reject)=>{
                if (this.pcState === $d84dc1a5e217b32f$var$PCState.Connected) resolve();
                const onRestarted = ()=>{
                    this.off($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected, onDisconnected);
                    resolve();
                };
                const onDisconnected = ()=>{
                    this.off($d84dc1a5e217b32f$export$c09e63b8572f869.Restarted, onRestarted);
                    reject();
                };
                this.once($d84dc1a5e217b32f$export$c09e63b8572f869.Restarted, onRestarted);
                this.once($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected, onDisconnected);
            });
        };
        this.updateAndEmitDCBufferStatus = (kind)=>{
            const status = this.isBufferStatusLow(kind);
            if (typeof status !== "undefined" && status !== this.dcBufferStatus.get(kind)) {
                this.dcBufferStatus.set(kind, status);
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.DCBufferStatusChanged, status, kind);
            }
        };
        this.isBufferStatusLow = (kind)=>{
            const dc = this.dataChannelForKind(kind);
            if (dc) return dc.bufferedAmount <= dc.bufferedAmountLowThreshold;
        };
        this.handleBrowserOnLine = ()=>{
            // in case the engine is currently reconnecting, attempt a reconnect immediately after the browser state has changed to 'onLine'
            if (this.client.currentState === $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING) {
                this.clearReconnectTimeout();
                this.attemptReconnect($d84dc1a5e217b32f$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
            }
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = options.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Engine);
        this.loggerOptions = {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.logContext
        };
        this.client = new $d84dc1a5e217b32f$var$SignalClient(undefined, this.loggerOptions);
        this.client.signalLatency = this.options.expSignalLatency;
        this.reconnectPolicy = this.options.reconnectPolicy;
        this.registerOnLineListener();
        this.closingLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.dataProcessLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.dcBufferStatus = new Map([
            [
                $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY,
                true
            ],
            [
                $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE,
                true
            ]
        ]);
        this.client.onParticipantUpdate = (updates)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.ParticipantUpdate, updates);
        this.client.onConnectionQuality = (update)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.ConnectionQualityUpdate, update);
        this.client.onRoomUpdate = (update)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.RoomUpdate, update);
        this.client.onSubscriptionError = (resp)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SubscriptionError, resp);
        this.client.onSubscriptionPermissionUpdate = (update)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SubscriptionPermissionUpdate, update);
        this.client.onSpeakersChanged = (update)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SpeakersChanged, update);
        this.client.onStreamStateUpdate = (update)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.StreamStateChanged, update);
        this.client.onRequestResponse = (response)=>this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SignalRequestResponse, response);
    }
    /** @internal */ get logContext() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return {
            room: (_b = (_a = this.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.name,
            roomID: (_d = (_c = this.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.room) === null || _d === void 0 ? void 0 : _d.sid,
            participant: (_f = (_e = this.latestJoinResponse) === null || _e === void 0 ? void 0 : _e.participant) === null || _f === void 0 ? void 0 : _f.identity,
            pID: (_h = (_g = this.latestJoinResponse) === null || _g === void 0 ? void 0 : _g.participant) === null || _h === void 0 ? void 0 : _h.sid
        };
    }
    join(url, token, opts, abortSignal) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.url = url;
            this.token = token;
            this.signalOpts = opts;
            this.maxJoinAttempts = opts.maxRetries;
            try {
                this.joinAttempts += 1;
                this.setupSignalClientCallbacks();
                const joinResponse = yield this.client.join(url, token, opts, abortSignal);
                this._isClosed = false;
                this.latestJoinResponse = joinResponse;
                this.subscriberPrimary = joinResponse.subscriberPrimary;
                if (!this.pcManager) yield this.configure(joinResponse);
                // create offer
                if (!this.subscriberPrimary || joinResponse.fastPublish) this.negotiate();
                this.clientConfiguration = joinResponse.clientConfiguration;
                return joinResponse;
            } catch (e) {
                if (e instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb) {
                    if (e.reason === $d84dc1a5e217b32f$export$61182a0b21436b65.ServerUnreachable) {
                        this.log.warn("Couldn't connect to server, attempt ".concat(this.joinAttempts, " of ").concat(this.maxJoinAttempts), this.logContext);
                        if (this.joinAttempts < this.maxJoinAttempts) return this.join(url, token, opts, abortSignal);
                    }
                }
                throw e;
            }
        });
    }
    close() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.closingLock.lock();
            if (this.isClosed) {
                unlock();
                return;
            }
            try {
                this._isClosed = true;
                this.joinAttempts = 0;
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Closing);
                this.removeAllListeners();
                this.deregisterOnLineListener();
                this.clearPendingReconnect();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
            } finally{
                unlock();
            }
        });
    }
    cleanupPeerConnections() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.close();
            this.pcManager = undefined;
            const dcCleanup = (dc)=>{
                if (!dc) return;
                dc.close();
                dc.onbufferedamountlow = null;
                dc.onclose = null;
                dc.onclosing = null;
                dc.onerror = null;
                dc.onmessage = null;
                dc.onopen = null;
            };
            dcCleanup(this.lossyDC);
            dcCleanup(this.lossyDCSub);
            dcCleanup(this.reliableDC);
            dcCleanup(this.reliableDCSub);
            this.lossyDC = undefined;
            this.lossyDCSub = undefined;
            this.reliableDC = undefined;
            this.reliableDCSub = undefined;
        });
    }
    cleanupClient() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.client.close();
            this.client.resetCallbacks();
        });
    }
    addTrack(req) {
        if (this.pendingTrackResolvers[req.cid]) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("a track with the same ID has already been published");
        return new Promise((resolve, reject)=>{
            const publicationTimeout = setTimeout(()=>{
                delete this.pendingTrackResolvers[req.cid];
                reject(new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("publication of local track timed out, no response from server", $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError));
            }, 10000);
            this.pendingTrackResolvers[req.cid] = {
                resolve: (info)=>{
                    clearTimeout(publicationTimeout);
                    resolve(info);
                },
                reject: ()=>{
                    clearTimeout(publicationTimeout);
                    reject(new Error("Cancelled publication by calling unpublish"));
                }
            };
            this.client.sendAddTrack(req);
        });
    }
    /**
   * Removes sender from PeerConnection, returning true if it was removed successfully
   * and a negotiation is necessary
   * @param sender
   * @returns
   */ removeTrack(sender) {
        if (sender.track && this.pendingTrackResolvers[sender.track.id]) {
            const { reject: reject } = this.pendingTrackResolvers[sender.track.id];
            if (reject) reject();
            delete this.pendingTrackResolvers[sender.track.id];
        }
        try {
            this.pcManager.removeTrack(sender);
            return true;
        } catch (e) {
            this.log.warn("failed to remove track", Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
        }
        return false;
    }
    updateMuteStatus(trackSid, muted) {
        this.client.sendMuteTrack(trackSid, muted);
    }
    get dataSubscriberReadyState() {
        var _a;
        return (_a = this.reliableDCSub) === null || _a === void 0 ? void 0 : _a.readyState;
    }
    getConnectedServerAddress() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.pcManager) === null || _a === void 0 ? void 0 : _a.getConnectedAddress();
        });
    }
    /* @internal */ setRegionUrlProvider(provider) {
        this.regionUrlProvider = provider;
    }
    configure(joinResponse) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            // already configured
            if (this.pcManager && this.pcManager.currentState !== $d84dc1a5e217b32f$var$PCTransportState.NEW) return;
            this.participantSid = (_a = joinResponse.participant) === null || _a === void 0 ? void 0 : _a.sid;
            const rtcConfig = this.makeRTCConfiguration(joinResponse);
            this.pcManager = new $d84dc1a5e217b32f$var$PCTransportManager(rtcConfig, joinResponse.subscriberPrimary, this.loggerOptions);
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.TransportsCreated, this.pcManager.publisher, this.pcManager.subscriber);
            this.pcManager.onIceCandidate = (candidate, target)=>{
                this.client.sendIceCandidate(candidate, target);
            };
            this.pcManager.onPublisherOffer = (offer)=>{
                this.client.sendOffer(offer);
            };
            this.pcManager.onDataChannel = this.handleDataChannel;
            this.pcManager.onStateChange = (connectionState, publisherState, subscriberState)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    this.log.debug("primary PC state changed ".concat(connectionState), this.logContext);
                    if ([
                        "closed",
                        "disconnected",
                        "failed"
                    ].includes(publisherState)) // reset publisher connection promise
                    this.publisherConnectionPromise = undefined;
                    if (connectionState === $d84dc1a5e217b32f$var$PCTransportState.CONNECTED) {
                        const shouldEmit = this.pcState === $d84dc1a5e217b32f$var$PCState.New;
                        this.pcState = $d84dc1a5e217b32f$var$PCState.Connected;
                        if (shouldEmit) this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Connected, joinResponse);
                    } else if (connectionState === $d84dc1a5e217b32f$var$PCTransportState.FAILED) // on Safari, PeerConnection will switch to 'disconnected' during renegotiation
                    {
                        if (this.pcState === $d84dc1a5e217b32f$var$PCState.Connected) {
                            this.pcState = $d84dc1a5e217b32f$var$PCState.Disconnected;
                            this.handleDisconnect("peerconnection failed", subscriberState === "failed" ? $d84dc1a5e217b32f$var$ReconnectReason.RR_SUBSCRIBER_FAILED : $d84dc1a5e217b32f$var$ReconnectReason.RR_PUBLISHER_FAILED);
                        }
                    }
                    // detect cases where both signal client and peer connection are severed and assume that user has lost network connection
                    const isSignalSevered = this.client.isDisconnected || this.client.currentState === $d84dc1a5e217b32f$var$SignalConnectionState.RECONNECTING;
                    const isPCSevered = [
                        $d84dc1a5e217b32f$var$PCTransportState.FAILED,
                        $d84dc1a5e217b32f$var$PCTransportState.CLOSING,
                        $d84dc1a5e217b32f$var$PCTransportState.CLOSED
                    ].includes(connectionState);
                    if (isSignalSevered && isPCSevered && !this._isClosed) this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Offline);
                });
            this.pcManager.onTrack = (ev)=>{
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.MediaTrackAdded, ev.track, ev.streams[0], ev.receiver);
            };
            if (!$d84dc1a5e217b32f$var$supportOptionalDatachannel((_b = joinResponse.serverInfo) === null || _b === void 0 ? void 0 : _b.protocol)) this.createDataChannels();
        });
    }
    setupSignalClientCallbacks() {
        // configure signaling client
        this.client.onAnswer = (sd)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.pcManager) return;
                this.log.debug("received server answer", Object.assign(Object.assign({}, this.logContext), {
                    RTCSdpType: sd.type
                }));
                yield this.pcManager.setPublisherAnswer(sd);
            });
        // add candidate on trickle
        this.client.onTrickle = (candidate, target)=>{
            if (!this.pcManager) return;
            this.log.trace("got ICE candidate from peer", Object.assign(Object.assign({}, this.logContext), {
                candidate: candidate,
                target: target
            }));
            this.pcManager.addIceCandidate(candidate, target);
        };
        // when server creates an offer for the client
        this.client.onOffer = (sd)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.pcManager) return;
                const answer = yield this.pcManager.createSubscriberAnswerFromOffer(sd);
                this.client.sendAnswer(answer);
            });
        this.client.onLocalTrackPublished = (res)=>{
            var _a;
            this.log.debug("received trackPublishedResponse", Object.assign(Object.assign({}, this.logContext), {
                cid: res.cid,
                track: (_a = res.track) === null || _a === void 0 ? void 0 : _a.sid
            }));
            if (!this.pendingTrackResolvers[res.cid]) {
                this.log.error("missing track resolver for ".concat(res.cid), Object.assign(Object.assign({}, this.logContext), {
                    cid: res.cid
                }));
                return;
            }
            const { resolve: resolve } = this.pendingTrackResolvers[res.cid];
            delete this.pendingTrackResolvers[res.cid];
            resolve(res.track);
        };
        this.client.onLocalTrackUnpublished = (response)=>{
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.LocalTrackUnpublished, response);
        };
        this.client.onLocalTrackSubscribed = (trackSid)=>{
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.LocalTrackSubscribed, trackSid);
        };
        this.client.onTokenRefresh = (token)=>{
            this.token = token;
        };
        this.client.onRemoteMuteChanged = (trackSid, muted)=>{
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.RemoteMute, trackSid, muted);
        };
        this.client.onSubscribedQualityUpdate = (update)=>{
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SubscribedQualityUpdate, update);
        };
        this.client.onClose = ()=>{
            this.handleDisconnect("signal", $d84dc1a5e217b32f$var$ReconnectReason.RR_SIGNAL_DISCONNECTED);
        };
        this.client.onLeave = (leave)=>{
            this.log.debug("client leave request", Object.assign(Object.assign({}, this.logContext), {
                reason: leave === null || leave === void 0 ? void 0 : leave.reason
            }));
            if (leave.regions && this.regionUrlProvider) {
                this.log.debug("updating regions", this.logContext);
                this.regionUrlProvider.setServerReportedRegions(leave.regions);
            }
            switch(leave.action){
                case $d84dc1a5e217b32f$var$LeaveRequest_Action.DISCONNECT:
                    this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected, leave === null || leave === void 0 ? void 0 : leave.reason);
                    this.close();
                    break;
                case $d84dc1a5e217b32f$var$LeaveRequest_Action.RECONNECT:
                    this.fullReconnectOnNext = true;
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($d84dc1a5e217b32f$var$leaveReconnect);
                    break;
                case $d84dc1a5e217b32f$var$LeaveRequest_Action.RESUME:
                    // reconnect immediately instead of waiting for next attempt
                    this.handleDisconnect($d84dc1a5e217b32f$var$leaveReconnect);
            }
        };
    }
    makeRTCConfiguration(serverResponse) {
        var _a;
        const rtcConfig = Object.assign({}, this.rtcConfig);
        if ((_a = this.signalOpts) === null || _a === void 0 ? void 0 : _a.e2eeEnabled) {
            this.log.debug("E2EE - setting up transports with insertable streams", this.logContext);
            //  this makes sure that no data is sent before the transforms are ready
            // @ts-ignore
            rtcConfig.encodedInsertableStreams = true;
        }
        // update ICE servers before creating PeerConnection
        if (serverResponse.iceServers && !rtcConfig.iceServers) {
            const rtcIceServers = [];
            serverResponse.iceServers.forEach((iceServer)=>{
                const rtcIceServer = {
                    urls: iceServer.urls
                };
                if (iceServer.username) rtcIceServer.username = iceServer.username;
                if (iceServer.credential) rtcIceServer.credential = iceServer.credential;
                rtcIceServers.push(rtcIceServer);
            });
            rtcConfig.iceServers = rtcIceServers;
        }
        if (serverResponse.clientConfiguration && serverResponse.clientConfiguration.forceRelay === $d84dc1a5e217b32f$var$ClientConfigSetting.ENABLED) rtcConfig.iceTransportPolicy = "relay";
        // @ts-ignore
        rtcConfig.sdpSemantics = "unified-plan";
        // @ts-ignore
        rtcConfig.continualGatheringPolicy = "gather_continually";
        return rtcConfig;
    }
    createDataChannels() {
        if (!this.pcManager) return;
        // clear old data channel callbacks if recreate
        if (this.lossyDC) {
            this.lossyDC.onmessage = null;
            this.lossyDC.onerror = null;
        }
        if (this.reliableDC) {
            this.reliableDC.onmessage = null;
            this.reliableDC.onerror = null;
        }
        // create data channels
        this.lossyDC = this.pcManager.createPublisherDataChannel($d84dc1a5e217b32f$var$lossyDataChannel, {
            // will drop older packets that arrive
            ordered: true,
            maxRetransmits: 0
        });
        this.reliableDC = this.pcManager.createPublisherDataChannel($d84dc1a5e217b32f$var$reliableDataChannel, {
            ordered: true
        });
        // also handle messages over the pub channel, for backwards compatibility
        this.lossyDC.onmessage = this.handleDataMessage;
        this.reliableDC.onmessage = this.handleDataMessage;
        // handle datachannel errors
        this.lossyDC.onerror = this.handleDataError;
        this.reliableDC.onerror = this.handleDataError;
        // set up dc buffer threshold, set to 64kB (otherwise 0 by default)
        this.lossyDC.bufferedAmountLowThreshold = 65535;
        this.reliableDC.bufferedAmountLowThreshold = 65535;
        // handle buffer amount low events
        this.lossyDC.onbufferedamountlow = this.handleBufferedAmountLow;
        this.reliableDC.onbufferedamountlow = this.handleBufferedAmountLow;
    }
    createSender(track, opts, encodings) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if ($d84dc1a5e217b32f$var$supportsTransceiver()) {
                const sender = yield this.createTransceiverRTCRtpSender(track, opts, encodings);
                return sender;
            }
            if ($d84dc1a5e217b32f$var$supportsAddTrack()) {
                this.log.warn("using add-track fallback", this.logContext);
                const sender = yield this.createRTCRtpSender(track.mediaStreamTrack);
                return sender;
            }
            throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("Required webRTC APIs not supported on this device");
        });
    }
    createSimulcastSender(track, simulcastTrack, opts, encodings) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            // store RTCRtpSender
            if ($d84dc1a5e217b32f$var$supportsTransceiver()) return this.createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings);
            if ($d84dc1a5e217b32f$var$supportsAddTrack()) {
                this.log.debug("using add-track fallback", this.logContext);
                return this.createRTCRtpSender(track.mediaStreamTrack);
            }
            throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("Cannot stream on this device");
        });
    }
    createTransceiverRTCRtpSender(track, opts, encodings) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("publisher is closed");
            const streams = [];
            if (track.mediaStream) streams.push(track.mediaStream);
            if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) track.codec = opts.videoCodec;
            const transceiverInit = {
                direction: "sendonly",
                streams: streams
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(track.mediaStreamTrack, transceiverInit);
            return transceiver.sender;
        });
    }
    createSimulcastTransceiverSender(track, simulcastTrack, opts, encodings) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("publisher is closed");
            const transceiverInit = {
                direction: "sendonly"
            };
            if (encodings) transceiverInit.sendEncodings = encodings;
            // addTransceiver for react-native is async. web is synchronous, but await won't effect it.
            const transceiver = yield this.pcManager.addPublisherTransceiver(simulcastTrack.mediaStreamTrack, transceiverInit);
            if (!opts.videoCodec) return;
            track.setSimulcastTrackSender(opts.videoCodec, transceiver.sender);
            return transceiver.sender;
        });
    }
    createRTCRtpSender(track) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("publisher is closed");
            return this.pcManager.addPublisherTrack(track);
        });
    }
    attemptReconnect(reason) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this._isClosed) return;
            // guard for attempting reconnection multiple times while one attempt is still not finished
            if (this.attemptingReconnect) {
                $d84dc1a5e217b32f$var$livekitLogger.warn("already attempting reconnect, returning early", this.logContext);
                return;
            }
            if (((_a = this.clientConfiguration) === null || _a === void 0 ? void 0 : _a.resumeConnection) === $d84dc1a5e217b32f$var$ClientConfigSetting.DISABLED || // signaling state could change to closed due to hardware sleep
            // those connections cannot be resumed
            ((_c = (_b = this.pcManager) === null || _b === void 0 ? void 0 : _b.currentState) !== null && _c !== void 0 ? _c : $d84dc1a5e217b32f$var$PCTransportState.NEW) === $d84dc1a5e217b32f$var$PCTransportState.NEW) this.fullReconnectOnNext = true;
            try {
                this.attemptingReconnect = true;
                if (this.fullReconnectOnNext) yield this.restartConnection();
                else yield this.resumeConnection(reason);
                this.clearPendingReconnect();
                this.fullReconnectOnNext = false;
            } catch (e) {
                this.reconnectAttempts += 1;
                let recoverable = true;
                if (e instanceof $d84dc1a5e217b32f$export$1f388e244efbf70b) {
                    this.log.debug("received unrecoverable error", Object.assign(Object.assign({}, this.logContext), {
                        error: e
                    }));
                    // unrecoverable
                    recoverable = false;
                } else if (!(e instanceof $d84dc1a5e217b32f$var$SignalReconnectError)) // cannot resume
                this.fullReconnectOnNext = true;
                if (recoverable) this.handleDisconnect("reconnect", $d84dc1a5e217b32f$var$ReconnectReason.RR_UNKNOWN);
                else {
                    this.log.info("could not recover connection after ".concat(this.reconnectAttempts, " attempts, ").concat(Date.now() - this.reconnectStart, "ms. giving up"), this.logContext);
                    this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected);
                    yield this.close();
                }
            } finally{
                this.attemptingReconnect = false;
            }
        });
    }
    getNextRetryDelay(context) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMs(context);
        } catch (e) {
            this.log.warn("encountered error in reconnect policy", Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
        }
        // error in user code with provided reconnect policy, stop reconnecting
        return null;
    }
    restartConnection(regionUrl) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            try {
                if (!this.url || !this.token) // permanent failure, don't attempt reconnection
                throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("could not reconnect, url or token not saved");
                this.log.info("reconnecting, attempt: ".concat(this.reconnectAttempts), this.logContext);
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Restarting);
                if (!this.client.isDisconnected) yield this.client.sendLeave();
                yield this.cleanupPeerConnections();
                yield this.cleanupClient();
                let joinResponse;
                try {
                    if (!this.signalOpts) {
                        this.log.warn("attempted connection restart, without signal options present", this.logContext);
                        throw new $d84dc1a5e217b32f$var$SignalReconnectError();
                    }
                    // in case a regionUrl is passed, the region URL takes precedence
                    joinResponse = yield this.join(regionUrl !== null && regionUrl !== void 0 ? regionUrl : this.url, this.token, this.signalOpts);
                } catch (e) {
                    if (e instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb && e.reason === $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("could not reconnect, token might be expired");
                    throw new $d84dc1a5e217b32f$var$SignalReconnectError();
                }
                if (this.shouldFailNext) {
                    this.shouldFailNext = false;
                    throw new Error("simulated failure");
                }
                this.client.setReconnected();
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SignalRestarted, joinResponse);
                yield this.waitForPCReconnected();
                // re-check signal connection state before setting engine as resumed
                if (this.client.currentState !== $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED) throw new $d84dc1a5e217b32f$var$SignalReconnectError("Signal connection got severed during reconnect");
                (_a = this.regionUrlProvider) === null || _a === void 0 || _a.resetAttempts();
                // reconnect success
                this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Restarted);
            } catch (error) {
                const nextRegionUrl = yield (_b = this.regionUrlProvider) === null || _b === void 0 ? void 0 : _b.getNextBestRegionUrl();
                if (nextRegionUrl) {
                    yield this.restartConnection(nextRegionUrl);
                    return;
                } else {
                    // no more regions to try (or we're not on cloud)
                    (_c = this.regionUrlProvider) === null || _c === void 0 || _c.resetAttempts();
                    throw error;
                }
            }
        });
    }
    resumeConnection(reason) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.url || !this.token) // permanent failure, don't attempt reconnection
            throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("could not reconnect, url or token not saved");
            // trigger publisher reconnect
            if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("publisher and subscriber connections unset");
            this.log.info("resuming signal connection, attempt ".concat(this.reconnectAttempts), this.logContext);
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Resuming);
            let res;
            try {
                this.setupSignalClientCallbacks();
                res = yield this.client.reconnect(this.url, this.token, this.participantSid, reason);
            } catch (error) {
                let message = "";
                if (error instanceof Error) {
                    message = error.message;
                    this.log.error(error.message, Object.assign(Object.assign({}, this.logContext), {
                        error: error
                    }));
                }
                if (error instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb && error.reason === $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("could not reconnect, token might be expired");
                if (error instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb && error.reason === $d84dc1a5e217b32f$export$61182a0b21436b65.LeaveRequest) throw error;
                throw new $d84dc1a5e217b32f$var$SignalReconnectError(message);
            }
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.SignalResumed);
            if (res) {
                const rtcConfig = this.makeRTCConfiguration(res);
                this.pcManager.updateConfiguration(rtcConfig);
            } else this.log.warn("Did not receive reconnect response", this.logContext);
            if (this.shouldFailNext) {
                this.shouldFailNext = false;
                throw new Error("simulated failure");
            }
            yield this.pcManager.triggerIceRestart();
            yield this.waitForPCReconnected();
            // re-check signal connection state before setting engine as resumed
            if (this.client.currentState !== $d84dc1a5e217b32f$var$SignalConnectionState.CONNECTED) throw new $d84dc1a5e217b32f$var$SignalReconnectError("Signal connection got severed during reconnect");
            this.client.setReconnected();
            // recreate publish datachannel if it's id is null
            // (for safari https://bugs.webkit.org/show_bug.cgi?id=184688)
            if (((_a = this.reliableDC) === null || _a === void 0 ? void 0 : _a.readyState) === "open" && this.reliableDC.id === null) this.createDataChannels();
            // resume success
            this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.Resumed);
        });
    }
    waitForPCInitialConnection(timeout, abortController) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("PC manager is closed");
            yield this.pcManager.ensurePCTransportConnection(abortController, timeout);
        });
    }
    waitForPCReconnected() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.pcState = $d84dc1a5e217b32f$var$PCState.Reconnecting;
            this.log.debug("waiting for peer connection to reconnect", this.logContext);
            try {
                yield $d84dc1a5e217b32f$var$sleep($d84dc1a5e217b32f$var$minReconnectWait); // FIXME setTimeout again not ideal for a connection critical path
                if (!this.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("PC manager is closed");
                yield this.pcManager.ensurePCTransportConnection(undefined, this.peerConnectionTimeout);
                this.pcState = $d84dc1a5e217b32f$var$PCState.Connected;
            } catch (e) {
                // TODO do we need a `failed` state here for the PC?
                this.pcState = $d84dc1a5e217b32f$var$PCState.Disconnected;
                throw new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("could not establish PC connection, ".concat(e.message), $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError);
            }
        });
    }
    /* @internal */ sendDataPacket(packet, kind) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const msg = packet.toBinary();
            // make sure we do have a data connection
            yield this.ensurePublisherConnected(kind);
            const dc = this.dataChannelForKind(kind);
            if (dc) dc.send(msg);
            this.updateAndEmitDCBufferStatus(kind);
        });
    }
    /**
   * @internal
   */ ensureDataTransportConnected(kind_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(kind) {
            var _this2 = this;
            let subscriber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.subscriberPrimary;
            return function*() {
                var _a;
                if (!_this2.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("PC manager is closed");
                const transport = subscriber ? _this2.pcManager.subscriber : _this2.pcManager.publisher;
                const transportName = subscriber ? "Subscriber" : "Publisher";
                if (!transport) throw new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("".concat(transportName, " connection not set"), $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError);
                let needNegotiation = false;
                if (!subscriber && !_this2.dataChannelForKind(kind, subscriber)) {
                    _this2.createDataChannels();
                    needNegotiation = true;
                }
                if (!needNegotiation && !subscriber && !_this2.pcManager.publisher.isICEConnected && _this2.pcManager.publisher.getICEConnectionState() !== "checking") needNegotiation = true;
                if (needNegotiation) // start negotiation
                _this2.negotiate();
                const targetChannel = _this2.dataChannelForKind(kind, subscriber);
                if ((targetChannel === null || targetChannel === void 0 ? void 0 : targetChannel.readyState) === "open") return;
                // wait until ICE connected
                const endTime = new Date().getTime() + _this2.peerConnectionTimeout;
                while(new Date().getTime() < endTime){
                    if (transport.isICEConnected && ((_a = _this2.dataChannelForKind(kind, subscriber)) === null || _a === void 0 ? void 0 : _a.readyState) === "open") return;
                    yield $d84dc1a5e217b32f$var$sleep(50);
                }
                throw new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("could not establish ".concat(transportName, " connection, state: ").concat(transport.getICEConnectionState()), $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError);
            }();
        });
    }
    ensurePublisherConnected(kind) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.publisherConnectionPromise) this.publisherConnectionPromise = this.ensureDataTransportConnected(kind, false);
            yield this.publisherConnectionPromise;
        });
    }
    /* @internal */ verifyTransport() {
        if (!this.pcManager) return false;
        // primary connection
        if (this.pcManager.currentState !== $d84dc1a5e217b32f$var$PCTransportState.CONNECTED) return false;
        // ensure signal is connected
        if (!this.client.ws || this.client.ws.readyState === WebSocket.CLOSED) return false;
        return true;
    }
    /** @internal */ negotiate() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            // observe signal state
            return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    if (!this.pcManager) {
                        reject(new $d84dc1a5e217b32f$export$18c2792bacf23e39("PC manager is closed"));
                        return;
                    }
                    this.pcManager.requirePublisher();
                    // don't negotiate without any transceivers or data channel, it will generate sdp without ice frag then negotiate failed
                    if (this.pcManager.publisher.getTransceivers().length == 0 && !this.lossyDC && !this.reliableDC) this.createDataChannels();
                    const abortController = new AbortController();
                    const handleClosed = ()=>{
                        abortController.abort();
                        this.log.debug("engine disconnected while negotiation was ongoing", this.logContext);
                        resolve();
                        return;
                    };
                    if (this.isClosed) reject("cannot negotiate on closed engine");
                    this.on($d84dc1a5e217b32f$export$c09e63b8572f869.Closing, handleClosed);
                    this.pcManager.publisher.once($d84dc1a5e217b32f$var$PCEvents.RTPVideoPayloadTypes, (rtpTypes)=>{
                        const rtpMap = new Map();
                        rtpTypes.forEach((rtp)=>{
                            const codec = rtp.codec.toLowerCase();
                            if ($d84dc1a5e217b32f$var$isVideoCodec(codec)) rtpMap.set(rtp.payload, codec);
                        });
                        this.emit($d84dc1a5e217b32f$export$c09e63b8572f869.RTPVideoMapUpdate, rtpMap);
                    });
                    try {
                        yield this.pcManager.negotiate(abortController);
                        resolve();
                    } catch (e) {
                        if (e instanceof $d84dc1a5e217b32f$export$18c2792bacf23e39) this.fullReconnectOnNext = true;
                        this.handleDisconnect("negotiation", $d84dc1a5e217b32f$var$ReconnectReason.RR_UNKNOWN);
                        reject(e);
                    } finally{
                        this.off($d84dc1a5e217b32f$export$c09e63b8572f869.Closing, handleClosed);
                    }
                }));
        });
    }
    dataChannelForKind(kind, sub) {
        if (!sub) {
            if (kind === $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY) return this.lossyDC;
            if (kind === $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE) return this.reliableDC;
        } else {
            if (kind === $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY) return this.lossyDCSub;
            if (kind === $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE) return this.reliableDCSub;
        }
    }
    /** @internal */ sendSyncState(remoteTracks, localTracks) {
        var _a, _b;
        if (!this.pcManager) {
            this.log.warn("sync state cannot be sent without peer connection setup", this.logContext);
            return;
        }
        const previousAnswer = this.pcManager.subscriber.getLocalDescription();
        const previousOffer = this.pcManager.subscriber.getRemoteDescription();
        /* 1. autosubscribe on, so subscribed tracks = all tracks - unsub tracks,
          in this case, we send unsub tracks, so server add all tracks to this
          subscribe pc and unsub special tracks from it.
       2. autosubscribe off, we send subscribed tracks.
    */ const autoSubscribe = (_b = (_a = this.signalOpts) === null || _a === void 0 ? void 0 : _a.autoSubscribe) !== null && _b !== void 0 ? _b : true;
        const trackSids = new Array();
        const trackSidsDisabled = new Array();
        remoteTracks.forEach((track)=>{
            if (track.isDesired !== autoSubscribe) trackSids.push(track.trackSid);
            if (!track.isEnabled) trackSidsDisabled.push(track.trackSid);
        });
        this.client.sendSyncState(new $d84dc1a5e217b32f$var$SyncState({
            answer: previousAnswer ? $d84dc1a5e217b32f$var$toProtoSessionDescription({
                sdp: previousAnswer.sdp,
                type: previousAnswer.type
            }) : undefined,
            offer: previousOffer ? $d84dc1a5e217b32f$var$toProtoSessionDescription({
                sdp: previousOffer.sdp,
                type: previousOffer.type
            }) : undefined,
            subscription: new $d84dc1a5e217b32f$var$UpdateSubscription({
                trackSids: trackSids,
                subscribe: !autoSubscribe,
                participantTracks: []
            }),
            publishTracks: $d84dc1a5e217b32f$var$getTrackPublicationInfo(localTracks),
            dataChannels: this.dataChannelsInfo(),
            trackSidsDisabled: trackSidsDisabled
        }));
    }
    /* @internal */ failNext() {
        // debugging method to fail the next reconnect/resume attempt
        this.shouldFailNext = true;
    }
    dataChannelsInfo() {
        const infos = [];
        const getInfo = (dc, target)=>{
            if ((dc === null || dc === void 0 ? void 0 : dc.id) !== undefined && dc.id !== null) infos.push(new $d84dc1a5e217b32f$var$DataChannelInfo({
                label: dc.label,
                id: dc.id,
                target: target
            }));
        };
        getInfo(this.dataChannelForKind($d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY), $d84dc1a5e217b32f$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE), $d84dc1a5e217b32f$var$SignalTarget.PUBLISHER);
        getInfo(this.dataChannelForKind($d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY, true), $d84dc1a5e217b32f$var$SignalTarget.SUBSCRIBER);
        getInfo(this.dataChannelForKind($d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE, true), $d84dc1a5e217b32f$var$SignalTarget.SUBSCRIBER);
        return infos;
    }
    clearReconnectTimeout() {
        if (this.reconnectTimeout) $d84dc1a5e217b32f$export$22e737276454df96.clearTimeout(this.reconnectTimeout);
    }
    clearPendingReconnect() {
        this.clearReconnectTimeout();
        this.reconnectAttempts = 0;
    }
    registerOnLineListener() {
        if ($d84dc1a5e217b32f$var$isWeb()) window.addEventListener("online", this.handleBrowserOnLine);
    }
    deregisterOnLineListener() {
        if ($d84dc1a5e217b32f$var$isWeb()) window.removeEventListener("online", this.handleBrowserOnLine);
    }
}
class $d84dc1a5e217b32f$var$SignalReconnectError extends Error {
}
function $d84dc1a5e217b32f$var$supportOptionalDatachannel(protocol) {
    return protocol !== undefined && protocol > 13;
}
function $d84dc1a5e217b32f$var$applyUserDataCompat(newObj, oldObj) {
    const participantIdentity = newObj.participantIdentity ? newObj.participantIdentity : oldObj.participantIdentity;
    newObj.participantIdentity = participantIdentity;
    oldObj.participantIdentity = participantIdentity;
    const destinationIdentities = newObj.destinationIdentities.length !== 0 ? newObj.destinationIdentities : oldObj.destinationIdentities;
    newObj.destinationIdentities = destinationIdentities;
    oldObj.destinationIdentities = destinationIdentities;
}
class $d84dc1a5e217b32f$var$RegionUrlProvider {
    constructor(url, token){
        this.lastUpdateAt = 0;
        this.settingsCacheTime = 3000;
        this.attemptedRegions = [];
        this.serverUrl = new URL(url);
        this.token = token;
    }
    updateToken(token) {
        this.token = token;
    }
    isCloud() {
        return $d84dc1a5e217b32f$var$isCloud(this.serverUrl);
    }
    getServerUrl() {
        return this.serverUrl;
    }
    getNextBestRegionUrl(abortSignal) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isCloud()) throw Error("region availability is only supported for LiveKit Cloud domains");
            if (!this.regionSettings || Date.now() - this.lastUpdateAt > this.settingsCacheTime) this.regionSettings = yield this.fetchRegionSettings(abortSignal);
            const regionsLeft = this.regionSettings.regions.filter((region)=>!this.attemptedRegions.find((attempted)=>attempted.url === region.url));
            if (regionsLeft.length > 0) {
                const nextRegion = regionsLeft[0];
                this.attemptedRegions.push(nextRegion);
                $d84dc1a5e217b32f$var$livekitLogger.debug("next region: ".concat(nextRegion.region));
                return nextRegion.url;
            } else return null;
        });
    }
    resetAttempts() {
        this.attemptedRegions = [];
    }
    /* @internal */ fetchRegionSettings(signal) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const regionSettingsResponse = yield fetch("".concat($d84dc1a5e217b32f$var$getCloudConfigUrl(this.serverUrl), "/regions"), {
                headers: {
                    authorization: "Bearer ".concat(this.token)
                },
                signal: signal
            });
            if (regionSettingsResponse.ok) {
                const regionSettings = yield regionSettingsResponse.json();
                this.lastUpdateAt = Date.now();
                return regionSettings;
            } else throw new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Could not fetch region settings: ".concat(regionSettingsResponse.statusText), regionSettingsResponse.status === 401 ? $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed : $d84dc1a5e217b32f$export$61182a0b21436b65.InternalError, regionSettingsResponse.status);
        });
    }
    setServerReportedRegions(regions) {
        this.regionSettings = regions;
        this.lastUpdateAt = Date.now();
    }
}
function $d84dc1a5e217b32f$var$getCloudConfigUrl(serverUrl) {
    return "".concat(serverUrl.protocol.replace("ws", "http"), "//").concat(serverUrl.host, "/settings");
}
// SPDX-FileCopyrightText: 2024 LiveKit, Inc.
//
// SPDX-License-Identifier: Apache-2.0
/**
 * Specialized error handling for RPC methods.
 *
 * Instances of this type, when thrown in a method handler, will have their `message`
 * serialized and sent across the wire. The sender will receive an equivalent error on the other side.
 *
 * Built-in types are included but developers may use any string, with a max length of 256 bytes.
 */ class $d84dc1a5e217b32f$export$5460eff990f31920 extends Error {
    /**
   * Creates an error object with the given code and message, plus an optional data payload.
   *
   * If thrown in an RPC method handler, the error will be sent back to the caller.
   *
   * Error codes 1001-1999 are reserved for built-in errors (see RpcError.ErrorCode for their meanings).
   */ constructor(code, message, data){
        super(message);
        this.code = code;
        this.message = $d84dc1a5e217b32f$var$truncateBytes(message, $d84dc1a5e217b32f$export$5460eff990f31920.MAX_MESSAGE_BYTES);
        this.data = data ? $d84dc1a5e217b32f$var$truncateBytes(data, $d84dc1a5e217b32f$export$5460eff990f31920.MAX_DATA_BYTES) : undefined;
    }
    /**
   * @internal
   */ static fromProto(proto) {
        return new $d84dc1a5e217b32f$export$5460eff990f31920(proto.code, proto.message, proto.data);
    }
    /**
   * @internal
   */ toProto() {
        return new $d84dc1a5e217b32f$var$RpcError$1({
            code: this.code,
            message: this.message,
            data: this.data
        });
    }
    /**
   * Creates an error object from the code, with an auto-populated message.
   *
   * @internal
   */ static builtIn(key, data) {
        return new $d84dc1a5e217b32f$export$5460eff990f31920($d84dc1a5e217b32f$export$5460eff990f31920.ErrorCode[key], $d84dc1a5e217b32f$export$5460eff990f31920.ErrorMessage[key], data);
    }
}
$d84dc1a5e217b32f$export$5460eff990f31920.MAX_MESSAGE_BYTES = 256;
$d84dc1a5e217b32f$export$5460eff990f31920.MAX_DATA_BYTES = 15360; // 15 KB
$d84dc1a5e217b32f$export$5460eff990f31920.ErrorCode = {
    APPLICATION_ERROR: 1500,
    CONNECTION_TIMEOUT: 1501,
    RESPONSE_TIMEOUT: 1502,
    RECIPIENT_DISCONNECTED: 1503,
    RESPONSE_PAYLOAD_TOO_LARGE: 1504,
    SEND_FAILED: 1505,
    UNSUPPORTED_METHOD: 1400,
    RECIPIENT_NOT_FOUND: 1401,
    REQUEST_PAYLOAD_TOO_LARGE: 1402,
    UNSUPPORTED_SERVER: 1403,
    UNSUPPORTED_VERSION: 1404
};
/**
 * @internal
 */ $d84dc1a5e217b32f$export$5460eff990f31920.ErrorMessage = {
    APPLICATION_ERROR: "Application error in method handler",
    CONNECTION_TIMEOUT: "Connection timeout",
    RESPONSE_TIMEOUT: "Response timeout",
    RECIPIENT_DISCONNECTED: "Recipient disconnected",
    RESPONSE_PAYLOAD_TOO_LARGE: "Response payload too large",
    SEND_FAILED: "Failed to send",
    UNSUPPORTED_METHOD: "Method not supported at destination",
    RECIPIENT_NOT_FOUND: "Recipient not found",
    REQUEST_PAYLOAD_TOO_LARGE: "Request payload too large",
    UNSUPPORTED_SERVER: "RPC not supported by server",
    UNSUPPORTED_VERSION: "Unsupported RPC version"
};
/*
 * Maximum payload size for RPC requests and responses. If a payload exceeds this size,
 * the RPC call will fail with a REQUEST_PAYLOAD_TOO_LARGE(1402) or RESPONSE_PAYLOAD_TOO_LARGE(1504) error.
 */ const $d84dc1a5e217b32f$var$MAX_PAYLOAD_BYTES = 15360; // 15 KB
/**
 * @internal
 */ function $d84dc1a5e217b32f$var$byteLength(str) {
    const encoder = new TextEncoder();
    return encoder.encode(str).length;
}
/**
 * @internal
 */ function $d84dc1a5e217b32f$var$truncateBytes(str, maxBytes) {
    if ($d84dc1a5e217b32f$var$byteLength(str) <= maxBytes) return str;
    let low = 0;
    let high = str.length;
    const encoder = new TextEncoder();
    while(low < high){
        const mid = Math.floor((low + high + 1) / 2);
        if (encoder.encode(str.slice(0, mid)).length <= maxBytes) low = mid;
        else high = mid - 1;
    }
    return str.slice(0, low);
}
class $d84dc1a5e217b32f$export$e3d2a545a239ada4 extends $d84dc1a5e217b32f$export$13921ac0cc260818 {
    constructor(mediaTrack, sid, kind, receiver, loggerOptions){
        super(mediaTrack, kind, loggerOptions);
        this.sid = sid;
        this.receiver = receiver;
    }
    /** @internal */ setMuted(muted) {
        if (this.isMuted !== muted) {
            this.isMuted = muted;
            this._mediaStreamTrack.enabled = !muted;
            this.emit(muted ? $d84dc1a5e217b32f$export$2c8510d737cc09da.Muted : $d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this);
        }
    }
    /** @internal */ setMediaStream(stream) {
        // this is needed to determine when the track is finished
        this.mediaStream = stream;
        const onRemoveTrack = (event)=>{
            if (event.track === this._mediaStreamTrack) {
                stream.removeEventListener("removetrack", onRemoveTrack);
                if (this.receiver && "playoutDelayHint" in this.receiver) this.receiver.playoutDelayHint = undefined;
                this.receiver = undefined;
                this._currentBitrate = 0;
                this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this);
            }
        };
        stream.addEventListener("removetrack", onRemoveTrack);
    }
    start() {
        this.startMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.enable();
    }
    stop() {
        this.stopMonitor();
        // use `enabled` of track to enable re-use of transceiver
        super.disable();
    }
    /**
   * Gets the RTCStatsReport for the RemoteTrack's underlying RTCRtpReceiver
   * See https://developer.mozilla.org/en-US/docs/Web/API/RTCStatsReport
   *
   * @returns Promise<RTCStatsReport> | undefined
   */ getRTCStatsReport() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!((_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getStats)) return;
            const statsReport = yield this.receiver.getStats();
            return statsReport;
        });
    }
    /**
   * Allows to set a playout delay (in seconds) for this track.
   * A higher value allows for more buffering of the track in the browser
   * and will result in a delay of media being played back of `delayInSeconds`
   */ setPlayoutDelay(delayInSeconds) {
        if (this.receiver) {
            if ("playoutDelayHint" in this.receiver) this.receiver.playoutDelayHint = delayInSeconds;
            else this.log.warn("Playout delay not supported in this browser");
        } else this.log.warn("Cannot set playout delay, track already ended");
    }
    /**
   * Returns the current playout delay (in seconds) of this track.
   */ getPlayoutDelay() {
        if (this.receiver) {
            if ("playoutDelayHint" in this.receiver) return this.receiver.playoutDelayHint;
            else this.log.warn("Playout delay not supported in this browser");
        } else this.log.warn("Cannot get playout delay, track already ended");
        return 0;
    }
    /* @internal */ startMonitor() {
        if (!this.monitorInterval) this.monitorInterval = setInterval(()=>this.monitorReceiver(), $d84dc1a5e217b32f$var$monitorFrequency);
        if ($d84dc1a5e217b32f$var$supportsSynchronizationSources()) this.registerTimeSyncUpdate();
    }
    registerTimeSyncUpdate() {
        const loop = ()=>{
            var _a;
            this.timeSyncHandle = requestAnimationFrame(()=>loop());
            const sources = (_a = this.receiver) === null || _a === void 0 ? void 0 : _a.getSynchronizationSources()[0];
            if (sources) {
                const { timestamp: timestamp, rtpTimestamp: rtpTimestamp } = sources;
                if (rtpTimestamp && this.rtpTimestamp !== rtpTimestamp) {
                    this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.TimeSyncUpdate, {
                        timestamp: timestamp,
                        rtpTimestamp: rtpTimestamp
                    });
                    this.rtpTimestamp = rtpTimestamp;
                }
            }
        };
        loop();
    }
}
class $d84dc1a5e217b32f$export$fd37b116bd840ced extends $d84dc1a5e217b32f$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, audioContext, audioOutput, loggerOptions){
        super(mediaTrack, sid, $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio, receiver, loggerOptions);
        this.monitorReceiver = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $d84dc1a5e217b32f$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.audioContext = audioContext;
        this.webAudioPluginNodes = [];
        if (audioOutput) this.sinkId = audioOutput.deviceId;
    }
    /**
   * sets the volume for all attached audio elements
   */ setVolume(volume) {
        var _a;
        for (const el of this.attachedElements)if (this.audioContext) (_a = this.gainNode) === null || _a === void 0 || _a.gain.setTargetAtTime(volume, 0, 0.1);
        else el.volume = volume;
        if ($d84dc1a5e217b32f$var$isReactNative()) // @ts-ignore
        this._mediaStreamTrack._setVolume(volume);
        this.elementVolume = volume;
    }
    /**
   * gets the volume of attached audio elements (loudest)
   */ getVolume() {
        if (this.elementVolume) return this.elementVolume;
        if ($d84dc1a5e217b32f$var$isReactNative()) // RN volume value defaults to 1.0 if hasn't been changed.
        return 1.0;
        let highestVolume = 0;
        this.attachedElements.forEach((element)=>{
            if (element.volume > highestVolume) highestVolume = element.volume;
        });
        return highestVolume;
    }
    /**
   * calls setSinkId on all attached elements, if supported
   * @param deviceId audio output device
   */ setSinkId(deviceId) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.sinkId = deviceId;
            yield Promise.all(this.attachedElements.map((elm)=>{
                if (!$d84dc1a5e217b32f$var$supportsSetSinkId(elm)) return;
                /* @ts-ignore */ return elm.setSinkId(deviceId);
            }));
        });
    }
    attach(element) {
        const needsNewWebAudioConnection = this.attachedElements.length === 0;
        if (!element) element = super.attach();
        else super.attach(element);
        if (this.sinkId && $d84dc1a5e217b32f$var$supportsSetSinkId(element)) /* @ts-ignore */ element.setSinkId(this.sinkId);
        if (this.audioContext && needsNewWebAudioConnection) {
            this.log.debug("using audio context mapping", this.logContext);
            this.connectWebAudio(this.audioContext, element);
            element.volume = 0;
            element.muted = true;
        }
        if (this.elementVolume) // make sure volume setting is being applied to the newly attached element
        this.setVolume(this.elementVolume);
        return element;
    }
    detach(element) {
        let detached;
        if (!element) {
            detached = super.detach();
            this.disconnectWebAudio();
        } else {
            detached = super.detach(element);
            // if there are still any attached elements after detaching, connect webaudio to the first element that's left
            // disconnect webaudio otherwise
            if (this.audioContext) {
                if (this.attachedElements.length > 0) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
                else this.disconnectWebAudio();
            }
        }
        return detached;
    }
    /**
   * @internal
   * @experimental
   */ setAudioContext(audioContext) {
        this.audioContext = audioContext;
        if (audioContext && this.attachedElements.length > 0) this.connectWebAudio(audioContext, this.attachedElements[0]);
        else if (!audioContext) this.disconnectWebAudio();
    }
    /**
   * @internal
   * @experimental
   * @param {AudioNode[]} nodes - An array of WebAudio nodes. These nodes should not be connected to each other when passed, as the sdk will take care of connecting them in the order of the array.
   */ setWebAudioPlugins(nodes) {
        this.webAudioPluginNodes = nodes;
        if (this.attachedElements.length > 0 && this.audioContext) this.connectWebAudio(this.audioContext, this.attachedElements[0]);
    }
    connectWebAudio(context, element) {
        this.disconnectWebAudio();
        // @ts-ignore attached elements always have a srcObject set
        this.sourceNode = context.createMediaStreamSource(element.srcObject);
        let lastNode = this.sourceNode;
        this.webAudioPluginNodes.forEach((node)=>{
            lastNode.connect(node);
            lastNode = node;
        });
        this.gainNode = context.createGain();
        lastNode.connect(this.gainNode);
        this.gainNode.connect(context.destination);
        if (this.elementVolume) this.gainNode.gain.setTargetAtTime(this.elementVolume, 0, 0.1);
        // try to resume the context if it isn't running already
        if (context.state !== "running") context.resume().then(()=>{
            if (context.state !== "running") this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackFailed, new Error("Audio Context couldn't be started automatically"));
        }).catch((e)=>{
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackFailed, e);
        });
    }
    disconnectWebAudio() {
        var _a, _b;
        (_a = this.gainNode) === null || _a === void 0 || _a.disconnect();
        (_b = this.sourceNode) === null || _b === void 0 || _b.disconnect();
        this.gainNode = undefined;
        this.sourceNode = undefined;
    }
    getReceiverStats() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            stats.forEach((v)=>{
                if (v.type === "inbound-rtp") receiverStats = {
                    type: "audio",
                    streamId: v.id,
                    timestamp: v.timestamp,
                    jitter: v.jitter,
                    bytesReceived: v.bytesReceived,
                    concealedSamples: v.concealedSamples,
                    concealmentEvents: v.concealmentEvents,
                    silentConcealedSamples: v.silentConcealedSamples,
                    silentConcealmentEvents: v.silentConcealmentEvents,
                    totalAudioEnergy: v.totalAudioEnergy,
                    totalSamplesDuration: v.totalSamplesDuration
                };
            });
            return receiverStats;
        });
    }
}
const $d84dc1a5e217b32f$var$REACTION_DELAY = 100;
class $d84dc1a5e217b32f$export$1db0c0ebd3ae1523 extends $d84dc1a5e217b32f$export$e3d2a545a239ada4 {
    constructor(mediaTrack, sid, receiver, adaptiveStreamSettings, loggerOptions){
        super(mediaTrack, sid, $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video, receiver, loggerOptions);
        this.elementInfos = [];
        this.monitorReceiver = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.receiver) {
                    this._currentBitrate = 0;
                    return;
                }
                const stats = yield this.getReceiverStats();
                if (stats && this.prevStats && this.receiver) this._currentBitrate = $d84dc1a5e217b32f$var$computeBitrate(stats, this.prevStats);
                this.prevStats = stats;
            });
        this.debouncedHandleResize = $d84dc1a5e217b32f$var$r(()=>{
            this.updateDimensions();
        }, $d84dc1a5e217b32f$var$REACTION_DELAY);
        this.adaptiveStreamSettings = adaptiveStreamSettings;
    }
    get isAdaptiveStream() {
        return this.adaptiveStreamSettings !== undefined;
    }
    /**
   * Note: When using adaptiveStream, you need to use remoteVideoTrack.attach() to add the track to a HTMLVideoElement, otherwise your video tracks might never start
   */ get mediaStreamTrack() {
        return this._mediaStreamTrack;
    }
    /** @internal */ setMuted(muted) {
        super.setMuted(muted);
        this.attachedElements.forEach((element)=>{
            // detach or attach
            if (muted) $d84dc1a5e217b32f$export$8ea68c6294970fa5(this._mediaStreamTrack, element);
            else $d84dc1a5e217b32f$export$b8f95ef2322890b8(this._mediaStreamTrack, element);
        });
    }
    attach(element) {
        if (!element) element = super.attach();
        else super.attach(element);
        // It's possible attach is called multiple times on an element. When that's
        // the case, we'd want to avoid adding duplicate elementInfos
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info.element === element) === undefined) {
            const elementInfo = new $d84dc1a5e217b32f$var$HTMLElementInfo(element);
            this.observeElementInfo(elementInfo);
        }
        return element;
    }
    /**
   * Observe an ElementInfo for changes when adaptive streaming.
   * @param elementInfo
   * @internal
   */ observeElementInfo(elementInfo) {
        if (this.adaptiveStreamSettings && this.elementInfos.find((info)=>info === elementInfo) === undefined) {
            elementInfo.handleResize = ()=>{
                this.debouncedHandleResize();
            };
            elementInfo.handleVisibilityChanged = ()=>{
                this.updateVisibility();
            };
            this.elementInfos.push(elementInfo);
            elementInfo.observe();
            // trigger the first resize update cycle
            // if the tab is backgrounded, the initial resize event does not fire until
            // the tab comes into focus for the first time.
            this.debouncedHandleResize();
            this.updateVisibility();
        } else this.log.warn("visibility resize observer not triggered", this.logContext);
    }
    /**
   * Stop observing an ElementInfo for changes.
   * @param elementInfo
   * @internal
   */ stopObservingElementInfo(elementInfo) {
        if (!this.isAdaptiveStream) {
            this.log.warn("stopObservingElementInfo ignored", this.logContext);
            return;
        }
        const stopElementInfos = this.elementInfos.filter((info)=>info === elementInfo);
        for (const info of stopElementInfos)info.stopObserving();
        this.elementInfos = this.elementInfos.filter((info)=>info !== elementInfo);
        this.updateVisibility();
        this.debouncedHandleResize();
    }
    detach(element) {
        let detachedElements = [];
        if (element) {
            this.stopObservingElement(element);
            return super.detach(element);
        }
        detachedElements = super.detach();
        for (const e of detachedElements)this.stopObservingElement(e);
        return detachedElements;
    }
    /** @internal */ getDecoderImplementation() {
        var _a;
        return (_a = this.prevStats) === null || _a === void 0 ? void 0 : _a.decoderImplementation;
    }
    getReceiverStats() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.receiver || !this.receiver.getStats) return;
            const stats = yield this.receiver.getStats();
            let receiverStats;
            let codecID = "";
            let codecs = new Map();
            stats.forEach((v)=>{
                if (v.type === "inbound-rtp") {
                    codecID = v.codecId;
                    receiverStats = {
                        type: "video",
                        streamId: v.id,
                        framesDecoded: v.framesDecoded,
                        framesDropped: v.framesDropped,
                        framesReceived: v.framesReceived,
                        packetsReceived: v.packetsReceived,
                        packetsLost: v.packetsLost,
                        frameWidth: v.frameWidth,
                        frameHeight: v.frameHeight,
                        pliCount: v.pliCount,
                        firCount: v.firCount,
                        nackCount: v.nackCount,
                        jitter: v.jitter,
                        timestamp: v.timestamp,
                        bytesReceived: v.bytesReceived,
                        decoderImplementation: v.decoderImplementation
                    };
                } else if (v.type === "codec") codecs.set(v.id, v);
            });
            if (receiverStats && codecID !== "" && codecs.get(codecID)) receiverStats.mimeType = codecs.get(codecID).mimeType;
            return receiverStats;
        });
    }
    stopObservingElement(element) {
        const stopElementInfos = this.elementInfos.filter((info)=>info.element === element);
        for (const info of stopElementInfos)this.stopObservingElementInfo(info);
    }
    handleAppVisibilityChanged() {
        const _super = Object.create(null, {
            handleAppVisibilityChanged: {
                get: ()=>super.handleAppVisibilityChanged
            }
        });
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.handleAppVisibilityChanged.call(this);
            if (!this.isAdaptiveStream) return;
            this.updateVisibility();
        });
    }
    updateVisibility() {
        var _a, _b;
        const lastVisibilityChange = this.elementInfos.reduce((prev, info)=>Math.max(prev, info.visibilityChangedAt || 0), 0);
        const backgroundPause = ((_b = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pauseVideoInBackground) !== null && _b !== void 0 ? _b : true // default to true
        ) ? this.isInBackground : false;
        const isPiPMode = this.elementInfos.some((info)=>info.pictureInPicture);
        const isVisible = this.elementInfos.some((info)=>info.visible) && !backgroundPause || isPiPMode;
        if (this.lastVisible === isVisible) return;
        if (!isVisible && Date.now() - lastVisibilityChange < $d84dc1a5e217b32f$var$REACTION_DELAY) {
            // delay hidden events
            $d84dc1a5e217b32f$export$22e737276454df96.setTimeout(()=>{
                this.updateVisibility();
            }, $d84dc1a5e217b32f$var$REACTION_DELAY);
            return;
        }
        this.lastVisible = isVisible;
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.VisibilityChanged, isVisible, this);
    }
    updateDimensions() {
        var _a, _b;
        let maxWidth = 0;
        let maxHeight = 0;
        const pixelDensity = this.getPixelDensity();
        for (const info of this.elementInfos){
            const currentElementWidth = info.width() * pixelDensity;
            const currentElementHeight = info.height() * pixelDensity;
            if (currentElementWidth + currentElementHeight > maxWidth + maxHeight) {
                maxWidth = currentElementWidth;
                maxHeight = currentElementHeight;
            }
        }
        if (((_a = this.lastDimensions) === null || _a === void 0 ? void 0 : _a.width) === maxWidth && ((_b = this.lastDimensions) === null || _b === void 0 ? void 0 : _b.height) === maxHeight) return;
        this.lastDimensions = {
            width: maxWidth,
            height: maxHeight
        };
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.VideoDimensionsChanged, this.lastDimensions, this);
    }
    getPixelDensity() {
        var _a;
        const pixelDensity = (_a = this.adaptiveStreamSettings) === null || _a === void 0 ? void 0 : _a.pixelDensity;
        if (pixelDensity === "screen") return $d84dc1a5e217b32f$var$getDevicePixelRatio();
        else if (!pixelDensity) {
            // when unset, we'll pick a sane default here.
            // for higher pixel density devices (mobile phones, etc), we'll use 2
            // otherwise it defaults to 1
            const devicePixelRatio = $d84dc1a5e217b32f$var$getDevicePixelRatio();
            if (devicePixelRatio > 2) return 2;
            else return 1;
        }
        return pixelDensity;
    }
}
class $d84dc1a5e217b32f$var$HTMLElementInfo {
    get visible() {
        return this.isPiP || this.isIntersecting;
    }
    get pictureInPicture() {
        return this.isPiP;
    }
    constructor(element, visible){
        this.onVisibilityChanged = (entry)=>{
            var _a;
            const { target: target, isIntersecting: isIntersecting } = entry;
            if (target === this.element) {
                this.isIntersecting = isIntersecting;
                this.isPiP = $d84dc1a5e217b32f$var$isElementInPiP(this.element);
                this.visibilityChangedAt = Date.now();
                (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
            }
        };
        this.onEnterPiP = ()=>{
            var _a, _b, _c;
            (_b = (_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 || _b.addEventListener("pagehide", this.onLeavePiP);
            this.isPiP = $d84dc1a5e217b32f$var$isElementInPiP(this.element);
            (_c = this.handleVisibilityChanged) === null || _c === void 0 || _c.call(this);
        };
        this.onLeavePiP = ()=>{
            var _a;
            this.isPiP = $d84dc1a5e217b32f$var$isElementInPiP(this.element);
            (_a = this.handleVisibilityChanged) === null || _a === void 0 || _a.call(this);
        };
        this.element = element;
        this.isIntersecting = visible !== null && visible !== void 0 ? visible : $d84dc1a5e217b32f$var$isElementInViewport(element);
        this.isPiP = $d84dc1a5e217b32f$var$isWeb() && $d84dc1a5e217b32f$var$isElementInPiP(element);
        this.visibilityChangedAt = 0;
    }
    width() {
        return this.element.clientWidth;
    }
    height() {
        return this.element.clientHeight;
    }
    observe() {
        var _a, _b, _c;
        // make sure we update the current visible state once we start to observe
        this.isIntersecting = $d84dc1a5e217b32f$var$isElementInViewport(this.element);
        this.isPiP = $d84dc1a5e217b32f$var$isElementInPiP(this.element);
        this.element.handleResize = ()=>{
            var _a;
            (_a = this.handleResize) === null || _a === void 0 || _a.call(this);
        };
        this.element.handleVisibilityChanged = this.onVisibilityChanged;
        $d84dc1a5e217b32f$var$getIntersectionObserver().observe(this.element);
        $d84dc1a5e217b32f$var$getResizeObserver().observe(this.element);
        this.element.addEventListener("enterpictureinpicture", this.onEnterPiP);
        this.element.addEventListener("leavepictureinpicture", this.onLeavePiP);
        (_a = window.documentPictureInPicture) === null || _a === void 0 || _a.addEventListener("enter", this.onEnterPiP);
        (_c = (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window) === null || _c === void 0 || _c.addEventListener("pagehide", this.onLeavePiP);
    }
    stopObserving() {
        var _a, _b, _c, _d, _e;
        (_a = $d84dc1a5e217b32f$var$getIntersectionObserver()) === null || _a === void 0 || _a.unobserve(this.element);
        (_b = $d84dc1a5e217b32f$var$getResizeObserver()) === null || _b === void 0 || _b.unobserve(this.element);
        this.element.removeEventListener("enterpictureinpicture", this.onEnterPiP);
        this.element.removeEventListener("leavepictureinpicture", this.onLeavePiP);
        (_c = window.documentPictureInPicture) === null || _c === void 0 || _c.removeEventListener("enter", this.onEnterPiP);
        (_e = (_d = window.documentPictureInPicture) === null || _d === void 0 ? void 0 : _d.window) === null || _e === void 0 || _e.removeEventListener("pagehide", this.onLeavePiP);
    }
}
function $d84dc1a5e217b32f$var$isElementInPiP(el) {
    var _a, _b;
    // Simple video PiP
    if (document.pictureInPictureElement === el) return true;
    // Document PiP
    if ((_a = window.documentPictureInPicture) === null || _a === void 0 ? void 0 : _a.window) return $d84dc1a5e217b32f$var$isElementInViewport(el, (_b = window.documentPictureInPicture) === null || _b === void 0 ? void 0 : _b.window);
    return false;
}
// does not account for occlusion by other elements or opacity property
function $d84dc1a5e217b32f$var$isElementInViewport(el, win) {
    const viewportWindow = win || window;
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const { hidden: hidden } = el;
    const { display: display } = getComputedStyle(el);
    while(el.offsetParent){
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }
    return top < viewportWindow.pageYOffset + viewportWindow.innerHeight && left < viewportWindow.pageXOffset + viewportWindow.innerWidth && top + height > viewportWindow.pageYOffset && left + width > viewportWindow.pageXOffset && !hidden && display !== "none";
}
class $d84dc1a5e217b32f$export$7c531331788c3797 extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(kind, id, name, loggerOptions){
        var _a;
        super();
        this.metadataMuted = false;
        this.encryption = $d84dc1a5e217b32f$var$Encryption_Type.NONE;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.handleMuted = ()=>{
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted);
        };
        this.handleUnmuted = ()=>{
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted);
        };
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Publication);
        this.loggerContextCb = this.loggerContextCb;
        this.setMaxListeners(100);
        this.kind = kind;
        this.trackSid = id;
        this.trackName = name;
        this.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Unknown;
    }
    /** @internal */ setTrack(track) {
        if (this.track) {
            this.track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted, this.handleMuted);
            this.track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
        this.track = track;
        if (track) {
            // forward events
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted, this.handleMuted);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this.handleUnmuted);
        }
    }
    get logContext() {
        var _a;
        return Object.assign(Object.assign({}, (_a = this.loggerContextCb) === null || _a === void 0 ? void 0 : _a.call(this)), $d84dc1a5e217b32f$var$getLogContextFromTrack(this));
    }
    get isMuted() {
        return this.metadataMuted;
    }
    get isEnabled() {
        return true;
    }
    get isSubscribed() {
        return this.track !== undefined;
    }
    get isEncrypted() {
        return this.encryption !== $d84dc1a5e217b32f$var$Encryption_Type.NONE;
    }
    /**
   * an [AudioTrack] if this publication holds an audio track
   */ get audioTrack() {
        if (this.track instanceof $d84dc1a5e217b32f$export$b287427b771ca237 || this.track instanceof $d84dc1a5e217b32f$export$fd37b116bd840ced) return this.track;
    }
    /**
   * an [VideoTrack] if this publication holds a video track
   */ get videoTrack() {
        if (this.track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc || this.track instanceof $d84dc1a5e217b32f$export$1db0c0ebd3ae1523) return this.track;
    }
    /** @internal */ updateInfo(info) {
        this.trackSid = info.sid;
        this.trackName = info.name;
        this.source = $d84dc1a5e217b32f$export$13921ac0cc260818.sourceFromProto(info.source);
        this.mimeType = info.mimeType;
        if (this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video && info.width > 0) {
            this.dimensions = {
                width: info.width,
                height: info.height
            };
            this.simulcasted = info.simulcast;
        }
        this.encryption = info.encryption;
        this.trackInfo = info;
        this.log.debug("update publication info", Object.assign(Object.assign({}, this.logContext), {
            info: info
        }));
    }
}
(function(TrackPublication) {
    (function(SubscriptionStatus) {
        SubscriptionStatus["Desired"] = "desired";
        SubscriptionStatus["Subscribed"] = "subscribed";
        SubscriptionStatus["Unsubscribed"] = "unsubscribed";
    })(TrackPublication.SubscriptionStatus || (TrackPublication.SubscriptionStatus = {}));
    (function(PermissionStatus) {
        PermissionStatus["Allowed"] = "allowed";
        PermissionStatus["NotAllowed"] = "not_allowed";
    })(TrackPublication.PermissionStatus || (TrackPublication.PermissionStatus = {}));
})($d84dc1a5e217b32f$export$7c531331788c3797);
class $d84dc1a5e217b32f$export$885a52c769210b3f extends $d84dc1a5e217b32f$export$7c531331788c3797 {
    get isUpstreamPaused() {
        var _a;
        return (_a = this.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused;
    }
    constructor(kind, ti, track, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        this.handleTrackEnded = ()=>{
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended);
        };
        this.updateInfo(ti);
        this.setTrack(track);
    }
    setTrack(track) {
        if (this.track) this.track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
        super.setTrack(track);
        if (track) track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
    }
    get isMuted() {
        if (this.track) return this.track.isMuted;
        return super.isMuted;
    }
    get audioTrack() {
        return super.audioTrack;
    }
    get videoTrack() {
        return super.videoTrack;
    }
    /**
   * Mute the track associated with this publication
   */ mute() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.mute();
        });
    }
    /**
   * Unmute track associated with this publication
   */ unmute() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            return (_a = this.track) === null || _a === void 0 ? void 0 : _a.unmute();
        });
    }
    /**
   * Pauses the media stream track associated with this publication from being sent to the server
   * and signals "muted" event to other participants
   * Useful if you want to pause the stream without pausing the local media stream track
   */ pauseUpstream() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.pauseUpstream();
        });
    }
    /**
   * Resumes sending the media stream track associated with this publication to the server after a call to [[pauseUpstream()]]
   * and signals "unmuted" event to other participants (unless the track is explicitly muted)
   */ resumeUpstream() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.track) === null || _a === void 0 ? void 0 : _a.resumeUpstream();
        });
    }
    getTrackFeatures() {
        var _a;
        if (this.track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) {
            const settings = this.track.getSourceTrackSettings();
            const features = new Set();
            if (settings.autoGainControl) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_AUTO_GAIN_CONTROL);
            if (settings.echoCancellation) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_ECHO_CANCELLATION);
            if (settings.noiseSuppression) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_NOISE_SUPPRESSION);
            if (settings.channelCount && settings.channelCount > 1) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_STEREO);
            if (!((_a = this.options) === null || _a === void 0 ? void 0 : _a.dtx)) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_NO_DTX);
            if (this.track.enhancedNoiseCancellation) features.add($d84dc1a5e217b32f$var$AudioTrackFeature.TF_ENHANCED_NOISE_CANCELLATION);
            return Array.from(features.values());
        } else return [];
    }
}
var $d84dc1a5e217b32f$export$16148de7856f4643;
(function(ConnectionQuality) {
    ConnectionQuality["Excellent"] = "excellent";
    ConnectionQuality["Good"] = "good";
    ConnectionQuality["Poor"] = "poor";
    /**
   * Indicates that a participant has temporarily (or permanently) lost connection to LiveKit.
   * For permanent disconnection a `ParticipantDisconnected` event will be emitted after a timeout
   */ ConnectionQuality["Lost"] = "lost";
    ConnectionQuality["Unknown"] = "unknown";
})($d84dc1a5e217b32f$export$16148de7856f4643 || ($d84dc1a5e217b32f$export$16148de7856f4643 = {}));
function $d84dc1a5e217b32f$var$qualityFromProto(q) {
    switch(q){
        case $d84dc1a5e217b32f$var$ConnectionQuality$1.EXCELLENT:
            return $d84dc1a5e217b32f$export$16148de7856f4643.Excellent;
        case $d84dc1a5e217b32f$var$ConnectionQuality$1.GOOD:
            return $d84dc1a5e217b32f$export$16148de7856f4643.Good;
        case $d84dc1a5e217b32f$var$ConnectionQuality$1.POOR:
            return $d84dc1a5e217b32f$export$16148de7856f4643.Poor;
        case $d84dc1a5e217b32f$var$ConnectionQuality$1.LOST:
            return $d84dc1a5e217b32f$export$16148de7856f4643.Lost;
        default:
            return $d84dc1a5e217b32f$export$16148de7856f4643.Unknown;
    }
}
class $d84dc1a5e217b32f$export$aada361ed1a6c65 extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    get logContext() {
        var _a, _b;
        return Object.assign({}, (_b = (_a = this.loggerOptions) === null || _a === void 0 ? void 0 : _a.loggerContextCb) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    get isEncrypted() {
        return this.trackPublications.size > 0 && Array.from(this.trackPublications.values()).every((tr)=>tr.isEncrypted);
    }
    get isAgent() {
        var _a;
        return ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.agent) || this.kind === $d84dc1a5e217b32f$export$2079c0e1523aec29.AGENT;
    }
    get kind() {
        return this._kind;
    }
    /** participant attributes, similar to metadata, but as a key/value map */ get attributes() {
        return Object.freeze(Object.assign({}, this._attributes));
    }
    /** @internal */ constructor(sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : $d84dc1a5e217b32f$export$2079c0e1523aec29.STANDARD;
        var _a;
        super();
        /** audio level between 0-1.0, 1 being loudest, 0 being softest */ this.audioLevel = 0;
        /** if participant is currently speaking */ this.isSpeaking = false;
        this._connectionQuality = $d84dc1a5e217b32f$export$16148de7856f4643.Unknown;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = loggerOptions === null || loggerOptions === void 0 ? void 0 : loggerOptions.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Participant);
        this.loggerOptions = loggerOptions;
        this.setMaxListeners(100);
        this.sid = sid;
        this.identity = identity;
        this.name = name;
        this.metadata = metadata;
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this._kind = kind;
        this._attributes = attributes !== null && attributes !== void 0 ? attributes : {};
    }
    getTrackPublications() {
        return Array.from(this.trackPublications.values());
    }
    /**
   * Finds the first track that matches the source filter, for example, getting
   * the user's camera track with getTrackBySource(Track.Source.Camera).
   */ getTrackPublication(source) {
        for (const [, pub] of this.trackPublications){
            if (pub.source === source) return pub;
        }
    }
    /**
   * Finds the first track that matches the track's name.
   */ getTrackPublicationByName(name) {
        for (const [, pub] of this.trackPublications){
            if (pub.trackName === name) return pub;
        }
    }
    get connectionQuality() {
        return this._connectionQuality;
    }
    get isCameraEnabled() {
        var _a;
        const track = this.getTrackPublication($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isMicrophoneEnabled() {
        var _a;
        const track = this.getTrackPublication($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone);
        return !((_a = track === null || track === void 0 ? void 0 : track.isMuted) !== null && _a !== void 0 ? _a : true);
    }
    get isScreenShareEnabled() {
        const track = this.getTrackPublication($d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare);
        return !!track;
    }
    get isLocal() {
        return false;
    }
    /** when participant joined the room */ get joinedAt() {
        if (this.participantInfo) return new Date(Number.parseInt(this.participantInfo.joinedAt.toString()) * 1000);
        return new Date();
    }
    /** @internal */ updateInfo(info) {
        // it's possible the update could be applied out of order due to await
        // during reconnect sequences. when that happens, it's possible for server
        // to have sent more recent version of participant info while JS is waiting
        // to process the existing payload.
        // when the participant sid remains the same, and we already have a later version
        // of the payload, they can be safely skipped
        if (this.participantInfo && this.participantInfo.sid === info.sid && this.participantInfo.version > info.version) return false;
        this.identity = info.identity;
        this.sid = info.sid;
        this._setName(info.name);
        this._setMetadata(info.metadata);
        this._setAttributes(info.attributes);
        if (info.permission) this.setPermissions(info.permission);
        // set this last so setMetadata can detect changes
        this.participantInfo = info;
        this.log.trace("update participant info", Object.assign(Object.assign({}, this.logContext), {
            info: info
        }));
        return true;
    }
    /**
   * Updates metadata from server
   **/ _setMetadata(md) {
        const changed = this.metadata !== md;
        const prevMetadata = this.metadata;
        this.metadata = md;
        if (changed) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantMetadataChanged, prevMetadata);
    }
    _setName(name) {
        const changed = this.name !== name;
        this.name = name;
        if (changed) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantNameChanged, name);
    }
    /**
   * Updates metadata from server
   **/ _setAttributes(attributes) {
        const diff = $d84dc1a5e217b32f$var$diffAttributes(this.attributes, attributes);
        this._attributes = attributes;
        if (Object.keys(diff).length > 0) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AttributesChanged, diff);
    }
    /** @internal */ setPermissions(permissions) {
        var _a, _b, _c, _d, _e, _f;
        const prevPermissions = this.permissions;
        const changed = permissions.canPublish !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublish) || permissions.canSubscribe !== ((_b = this.permissions) === null || _b === void 0 ? void 0 : _b.canSubscribe) || permissions.canPublishData !== ((_c = this.permissions) === null || _c === void 0 ? void 0 : _c.canPublishData) || permissions.hidden !== ((_d = this.permissions) === null || _d === void 0 ? void 0 : _d.hidden) || permissions.recorder !== ((_e = this.permissions) === null || _e === void 0 ? void 0 : _e.recorder) || permissions.canPublishSources.length !== this.permissions.canPublishSources.length || permissions.canPublishSources.some((value, index)=>{
            var _a;
            return value !== ((_a = this.permissions) === null || _a === void 0 ? void 0 : _a.canPublishSources[index]);
        }) || permissions.canSubscribeMetrics !== ((_f = this.permissions) === null || _f === void 0 ? void 0 : _f.canSubscribeMetrics);
        this.permissions = permissions;
        if (changed) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, prevPermissions);
        return changed;
    }
    /** @internal */ setIsSpeaking(speaking) {
        if (speaking === this.isSpeaking) return;
        this.isSpeaking = speaking;
        if (speaking) this.lastSpokeAt = new Date();
        this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.IsSpeakingChanged, speaking);
    }
    /** @internal */ setConnectionQuality(q) {
        const prevQuality = this._connectionQuality;
        this._connectionQuality = $d84dc1a5e217b32f$var$qualityFromProto(q);
        if (prevQuality !== this._connectionQuality) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ConnectionQualityChanged, this._connectionQuality);
    }
    /**
   * @internal
   */ setAudioContext(ctx) {
        this.audioContext = ctx;
        this.audioTrackPublications.forEach((track)=>(track.track instanceof $d84dc1a5e217b32f$export$fd37b116bd840ced || track.track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) && track.track.setAudioContext(ctx));
    }
    addTrackPublication(publication) {
        // forward publication driven events
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted, ()=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackMuted, publication);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, ()=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnmuted, publication);
        });
        const pub = publication;
        if (pub.track) pub.track.sid = publication.trackSid;
        this.trackPublications.set(publication.trackSid, publication);
        switch(publication.kind){
            case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.set(publication.trackSid, publication);
                break;
            case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.set(publication.trackSid, publication);
                break;
        }
    }
}
function $d84dc1a5e217b32f$var$trackPermissionToProto(perms) {
    var _a, _b, _c;
    if (!perms.participantSid && !perms.participantIdentity) throw new Error("Invalid track permission, must provide at least one of participantIdentity and participantSid");
    return new $d84dc1a5e217b32f$var$TrackPermission({
        participantIdentity: (_a = perms.participantIdentity) !== null && _a !== void 0 ? _a : "",
        participantSid: (_b = perms.participantSid) !== null && _b !== void 0 ? _b : "",
        allTracks: (_c = perms.allowAll) !== null && _c !== void 0 ? _c : false,
        trackSids: perms.allowedTrackSids || []
    });
}
class $d84dc1a5e217b32f$export$ed007fa30041dd89 extends $d84dc1a5e217b32f$export$aada361ed1a6c65 {
    /** @internal */ constructor(sid, identity, engine, options){
        super(sid, identity, undefined, undefined, undefined, {
            loggerName: options.loggerName,
            loggerContextCb: ()=>this.engine.logContext
        });
        this.pendingPublishing = new Set();
        this.pendingPublishPromises = new Map();
        this.participantTrackPermissions = [];
        this.allParticipantsAllowedToSubscribe = true;
        this.encryptionType = $d84dc1a5e217b32f$var$Encryption_Type.NONE;
        this.enabledPublishVideoCodecs = [];
        this.rpcHandlers = new Map();
        this.pendingAcks = new Map();
        this.pendingResponses = new Map();
        this.handleReconnecting = ()=>{
            if (!this.reconnectFuture) this.reconnectFuture = new $d84dc1a5e217b32f$var$Future();
        };
        this.handleReconnected = ()=>{
            var _a, _b;
            (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.resolve) === null || _b === void 0 || _b.call(_a);
            this.reconnectFuture = undefined;
            this.updateTrackSubscriptionPermissions();
        };
        this.handleDisconnected = ()=>{
            var _a, _b;
            if (this.reconnectFuture) {
                this.reconnectFuture.promise.catch((e)=>this.log.warn(e.message, this.logContext));
                (_b = (_a = this.reconnectFuture) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 || _b.call(_a, "Got disconnected during reconnection attempt");
                this.reconnectFuture = undefined;
            }
        };
        this.handleSignalRequestResponse = (response)=>{
            const { requestId: requestId, reason: reason, message: message } = response;
            const targetRequest = this.pendingSignalRequests.get(requestId);
            if (targetRequest) {
                if (reason !== $d84dc1a5e217b32f$var$RequestResponse_Reason.OK) targetRequest.reject(new $d84dc1a5e217b32f$export$cb33ebbc4df8a708(message, reason));
                this.pendingSignalRequests.delete(requestId);
            }
        };
        this.handleDataPacket = (packet)=>{
            switch(packet.value.case){
                case "rpcRequest":
                    let rpcRequest = packet.value.value;
                    this.handleIncomingRpcRequest(packet.participantIdentity, rpcRequest.id, rpcRequest.method, rpcRequest.payload, rpcRequest.responseTimeoutMs, rpcRequest.version);
                    break;
                case "rpcResponse":
                    let rpcResponse = packet.value.value;
                    let payload = null;
                    let error = null;
                    if (rpcResponse.value.case === "payload") payload = rpcResponse.value.value;
                    else if (rpcResponse.value.case === "error") error = $d84dc1a5e217b32f$export$5460eff990f31920.fromProto(rpcResponse.value.value);
                    this.handleIncomingRpcResponse(rpcResponse.requestId, payload, error);
                    break;
                case "rpcAck":
                    let rpcAck = packet.value.value;
                    this.handleIncomingRpcAck(rpcAck.requestId);
                    break;
            }
        };
        this.updateTrackSubscriptionPermissions = ()=>{
            this.log.debug("updating track subscription permissions", Object.assign(Object.assign({}, this.logContext), {
                allParticipantsAllowed: this.allParticipantsAllowedToSubscribe,
                participantTrackPermissions: this.participantTrackPermissions
            }));
            this.engine.client.sendUpdateSubscriptionPermissions(this.allParticipantsAllowedToSubscribe, this.participantTrackPermissions.map((p)=>$d84dc1a5e217b32f$var$trackPermissionToProto(p)));
        };
        /** @internal */ this.onTrackUnmuted = (track)=>{
            this.onTrackMuted(track, track.isUpstreamPaused);
        };
        // when the local track changes in mute status, we'll notify server as such
        /** @internal */ this.onTrackMuted = (track, muted)=>{
            if (muted === undefined) muted = true;
            if (!track.sid) {
                this.log.error("could not update mute status for unpublished track", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                return;
            }
            this.engine.updateMuteStatus(track.sid, muted);
        };
        this.onTrackUpstreamPaused = (track)=>{
            this.log.debug("upstream paused", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
            this.onTrackMuted(track, true);
        };
        this.onTrackUpstreamResumed = (track)=>{
            this.log.debug("upstream resumed", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
            this.onTrackMuted(track, track.isMuted);
        };
        this.onTrackFeatureUpdate = (track)=>{
            const pub = this.audioTrackPublications.get(track.sid);
            if (!pub) {
                this.log.warn("Could not update local audio track settings, missing publication for track ".concat(track.sid), this.logContext);
                return;
            }
            this.engine.client.sendUpdateLocalAudioTrack(pub.trackSid, pub.getTrackFeatures());
        };
        this.handleSubscribedQualityUpdate = (update)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, e_1, _b, _c;
                var _d, _e;
                if (!((_d = this.roomOptions) === null || _d === void 0 ? void 0 : _d.dynacast)) return;
                const pub = this.videoTrackPublications.get(update.trackSid);
                if (!pub) {
                    this.log.warn("received subscribed quality update for unknown track", Object.assign(Object.assign({}, this.logContext), {
                        trackSid: update.trackSid
                    }));
                    return;
                }
                if (update.subscribedCodecs.length > 0) {
                    if (!pub.videoTrack) return;
                    const newCodecs = yield pub.videoTrack.setPublishingCodecs(update.subscribedCodecs);
                    try {
                        for(var _f = true, newCodecs_1 = $d84dc1a5e217b32f$var$__asyncValues(newCodecs), newCodecs_1_1; newCodecs_1_1 = yield newCodecs_1.next(), _a = newCodecs_1_1.done, !_a; _f = true){
                            _c = newCodecs_1_1.value;
                            _f = false;
                            const codec = _c;
                            if ($d84dc1a5e217b32f$export$da37a49ee77f9d77(codec)) {
                                this.log.debug("publish ".concat(codec, " for ").concat(pub.videoTrack.sid), Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(pub)));
                                yield this.publishAdditionalCodecForTrack(pub.videoTrack, codec, pub.options);
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_a && (_b = newCodecs_1.return)) yield _b.call(newCodecs_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                } else if (update.subscribedQualities.length > 0) yield (_e = pub.videoTrack) === null || _e === void 0 ? void 0 : _e.setPublishingLayers(update.subscribedQualities);
            });
        this.handleLocalTrackUnpublished = (unpublished)=>{
            const track = this.trackPublications.get(unpublished.trackSid);
            if (!track) {
                this.log.warn("received unpublished event for unknown track", Object.assign(Object.assign({}, this.logContext), {
                    trackSid: unpublished.trackSid
                }));
                return;
            }
            this.unpublishTrack(track.track);
        };
        this.handleTrackEnded = (track)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                if (track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare || track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShareAudio) {
                    this.log.debug("unpublishing local track due to TrackEnded", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                    this.unpublishTrack(track);
                } else if (track.isUserProvided) yield track.mute();
                else if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237 || track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) try {
                    if ($d84dc1a5e217b32f$var$isWeb()) try {
                        const currentPermissions = yield navigator === null || navigator === void 0 ? void 0 : navigator.permissions.query({
                            // the permission query for camera and microphone currently not supported in Safari and Firefox
                            // @ts-ignore
                            name: track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera ? "camera" : "microphone"
                        });
                        if (currentPermissions && currentPermissions.state === "denied") {
                            this.log.warn("user has revoked access to ".concat(track.source), Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                            // detect granted change after permissions were denied to try and resume then
                            currentPermissions.onchange = ()=>{
                                if (currentPermissions.state !== "denied") {
                                    if (!track.isMuted) track.restartTrack();
                                    currentPermissions.onchange = null;
                                }
                            };
                            throw new Error("GetUserMedia Permission denied");
                        }
                    } catch (e) {
                    // permissions query fails for firefox, we continue and try to restart the track
                    }
                    if (!track.isMuted) {
                        this.log.debug("track ended, attempting to use a different device", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                        if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) // fall back to default device if available
                        yield track.restartTrack({
                            deviceId: "default"
                        });
                        else yield track.restartTrack();
                    }
                } catch (e) {
                    this.log.warn("could not restart track, muting instead", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                    yield track.mute();
                }
            });
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.trackPublications = new Map();
        this.engine = engine;
        this.roomOptions = options;
        this.setupEngine(engine);
        this.activeDeviceMap = new Map([
            [
                "audioinput",
                "default"
            ],
            [
                "videoinput",
                "default"
            ],
            [
                "audiooutput",
                "default"
            ]
        ]);
        this.pendingSignalRequests = new Map();
    }
    get lastCameraError() {
        return this.cameraError;
    }
    get lastMicrophoneError() {
        return this.microphoneError;
    }
    get isE2EEEnabled() {
        return this.encryptionType !== $d84dc1a5e217b32f$var$Encryption_Type.NONE;
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * @internal
   */ setupEngine(engine) {
        this.engine = engine;
        this.engine.on($d84dc1a5e217b32f$export$c09e63b8572f869.RemoteMute, (trackSid, muted)=>{
            const pub = this.trackPublications.get(trackSid);
            if (!pub || !pub.track) return;
            if (muted) pub.mute();
            else pub.unmute();
        });
        this.engine.on($d84dc1a5e217b32f$export$c09e63b8572f869.Connected, this.handleReconnected).on($d84dc1a5e217b32f$export$c09e63b8572f869.SignalRestarted, this.handleReconnected).on($d84dc1a5e217b32f$export$c09e63b8572f869.SignalResumed, this.handleReconnected).on($d84dc1a5e217b32f$export$c09e63b8572f869.Restarting, this.handleReconnecting).on($d84dc1a5e217b32f$export$c09e63b8572f869.Resuming, this.handleReconnecting).on($d84dc1a5e217b32f$export$c09e63b8572f869.LocalTrackUnpublished, this.handleLocalTrackUnpublished).on($d84dc1a5e217b32f$export$c09e63b8572f869.SubscribedQualityUpdate, this.handleSubscribedQualityUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected, this.handleDisconnected).on($d84dc1a5e217b32f$export$c09e63b8572f869.SignalRequestResponse, this.handleSignalRequestResponse).on($d84dc1a5e217b32f$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket);
    }
    /**
   * Sets and updates the metadata of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setMetadata(metadata) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                metadata: metadata
            });
        });
    }
    /**
   * Sets and updates the name of the local participant.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * method will throw if the user doesn't have the required permissions
   * @param metadata
   */ setName(name) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                name: name
            });
        });
    }
    /**
   * Set or update participant attributes. It will make updates only to keys that
   * are present in `attributes`, and will not override others.
   * Note: this requires `canUpdateOwnMetadata` permission.
   * @param attributes attributes to update
   */ setAttributes(attributes) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.requestMetadataUpdate({
                attributes: attributes
            });
        });
    }
    requestMetadataUpdate(_a) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(_ref) {
            var _this = this;
            let { metadata: metadata, name: name, attributes: attributes } = _ref;
            return function*() {
                return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(_this, void 0, void 0, function*() {
                        var _a, _b;
                        try {
                            let isRejected = false;
                            const requestId = yield this.engine.client.sendUpdateLocalMetadata((_a = metadata !== null && metadata !== void 0 ? metadata : this.metadata) !== null && _a !== void 0 ? _a : "", (_b = name !== null && name !== void 0 ? name : this.name) !== null && _b !== void 0 ? _b : "", attributes);
                            const startTime = performance.now();
                            this.pendingSignalRequests.set(requestId, {
                                resolve: resolve,
                                reject: (error)=>{
                                    reject(error);
                                    isRejected = true;
                                },
                                values: {
                                    name: name,
                                    metadata: metadata,
                                    attributes: attributes
                                }
                            });
                            while(performance.now() - startTime < 5000 && !isRejected){
                                if ((!name || this.name === name) && (!metadata || this.metadata === metadata) && (!attributes || Object.entries(attributes).every((_ref2)=>{
                                    let [key, value] = _ref2;
                                    return this.attributes[key] === value || value === "" && !this.attributes[key];
                                }))) {
                                    this.pendingSignalRequests.delete(requestId);
                                    resolve();
                                    return;
                                }
                                yield $d84dc1a5e217b32f$var$sleep(50);
                            }
                            reject(new $d84dc1a5e217b32f$export$cb33ebbc4df8a708("Request to update local metadata timed out", "TimeoutError"));
                        } catch (e) {
                            if (e instanceof Error) reject(e);
                        }
                    }));
            }();
        });
    }
    /**
   * Enable or disable a participant's camera track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setCameraEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera, enabled, options, publishOptions);
    }
    /**
   * Enable or disable a participant's microphone track.
   *
   * If a track has already published, it'll mute or unmute the track.
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setMicrophoneEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone, enabled, options, publishOptions);
    }
    /**
   * Start or stop sharing a participant's screen
   * Resolves with a `LocalTrackPublication` instance if successful and `undefined` otherwise
   */ setScreenShareEnabled(enabled, options, publishOptions) {
        return this.setTrackEnabled($d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare, enabled, options, publishOptions);
    }
    /** @internal */ setPermissions(permissions) {
        const prevPermissions = this.permissions;
        const changed = super.setPermissions(permissions);
        if (changed && prevPermissions) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, prevPermissions);
        return changed;
    }
    /** @internal */ setE2EEEnabled(enabled) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.encryptionType = enabled ? $d84dc1a5e217b32f$var$Encryption_Type.GCM : $d84dc1a5e217b32f$var$Encryption_Type.NONE;
            yield this.republishAllTracks(undefined, false);
        });
    }
    setTrackEnabled(source, enabled, options, publishOptions) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            this.log.debug("setTrackEnabled", Object.assign(Object.assign({}, this.logContext), {
                source: source,
                enabled: enabled
            }));
            if (this.republishPromise) yield this.republishPromise;
            let track = this.getTrackPublication(source);
            if (enabled) {
                if (track) yield track.unmute();
                else {
                    let localTracks;
                    if (this.pendingPublishing.has(source)) {
                        const pendingTrack = yield this.waitForPendingPublicationOfSource(source);
                        if (!pendingTrack) this.log.info("waiting for pending publication promise timed out", Object.assign(Object.assign({}, this.logContext), {
                            source: source
                        }));
                        yield pendingTrack === null || pendingTrack === void 0 ? void 0 : pendingTrack.unmute();
                        return pendingTrack;
                    }
                    this.pendingPublishing.add(source);
                    try {
                        switch(source){
                            case $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera:
                                localTracks = yield this.createTracks({
                                    video: (_a = options) !== null && _a !== void 0 ? _a : true
                                });
                                break;
                            case $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone:
                                localTracks = yield this.createTracks({
                                    audio: (_b = options) !== null && _b !== void 0 ? _b : true
                                });
                                break;
                            case $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare:
                                localTracks = yield this.createScreenTracks(Object.assign({}, options));
                                break;
                            default:
                                throw new $d84dc1a5e217b32f$export$4fbb9423b5747257(source);
                        }
                    } catch (e) {
                        localTracks === null || localTracks === void 0 || localTracks.forEach((tr)=>{
                            tr.stop();
                        });
                        if (e instanceof Error) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.MediaDevicesError, e);
                        throw e;
                    }
                    try {
                        const publishPromises = [];
                        for (const localTrack of localTracks){
                            this.log.info("publishing track", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(localTrack)));
                            publishPromises.push(this.publishTrack(localTrack, publishOptions));
                        }
                        const publishedTracks = yield Promise.all(publishPromises);
                        // for screen share publications including audio, this will only return the screen share publication, not the screen share audio one
                        // revisit if we want to return an array of tracks instead for v2
                        [track] = publishedTracks;
                    } catch (e) {
                        localTracks === null || localTracks === void 0 || localTracks.forEach((tr)=>{
                            tr.stop();
                        });
                        throw e;
                    } finally{
                        this.pendingPublishing.delete(source);
                    }
                }
            } else {
                if (!(track === null || track === void 0 ? void 0 : track.track) && this.pendingPublishing.has(source)) {
                    // if there's no track available yet first wait for pending publishing promises of that source to see if it becomes available
                    track = yield this.waitForPendingPublicationOfSource(source);
                    if (!track) this.log.info("waiting for pending publication promise timed out", Object.assign(Object.assign({}, this.logContext), {
                        source: source
                    }));
                }
                if (track && track.track) {
                    // screenshare cannot be muted, unpublish instead
                    if (source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare) {
                        track = yield this.unpublishTrack(track.track);
                        const screenAudioTrack = this.getTrackPublication($d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShareAudio);
                        if (screenAudioTrack && screenAudioTrack.track) this.unpublishTrack(screenAudioTrack.track);
                    } else yield track.mute();
                }
            }
            return track;
        });
    }
    /**
   * Publish both camera and microphone at the same time. This is useful for
   * displaying a single Permission Dialog box to the end user.
   */ enableCameraAndMicrophone() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.pendingPublishing.has($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera) || this.pendingPublishing.has($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone)) // no-op it's already been requested
            return;
            this.pendingPublishing.add($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera);
            this.pendingPublishing.add($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone);
            try {
                const tracks = yield this.createTracks({
                    audio: true,
                    video: true
                });
                yield Promise.all(tracks.map((track)=>this.publishTrack(track)));
            } finally{
                this.pendingPublishing.delete($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera);
                this.pendingPublishing.delete($d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone);
            }
        });
    }
    /**
   * Create local camera and/or microphone tracks
   * @param options
   * @returns
   */ createTracks(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            options !== null && options !== void 0 ? options : options = {};
            const { audioProcessor: audioProcessor, videoProcessor: videoProcessor, optionsWithoutProcessor: optionsWithoutProcessor } = $d84dc1a5e217b32f$var$extractProcessorsFromOptions(options);
            const mergedOptions = $d84dc1a5e217b32f$var$mergeDefaultOptions(optionsWithoutProcessor, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.audioCaptureDefaults, (_b = this.roomOptions) === null || _b === void 0 ? void 0 : _b.videoCaptureDefaults);
            const constraints = $d84dc1a5e217b32f$var$constraintsForOptions(mergedOptions);
            let stream;
            try {
                stream = yield navigator.mediaDevices.getUserMedia(constraints);
            } catch (err) {
                if (err instanceof Error) {
                    if (constraints.audio) this.microphoneError = err;
                    if (constraints.video) this.cameraError = err;
                }
                throw err;
            }
            if (constraints.audio) {
                this.microphoneError = undefined;
                this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AudioStreamAcquired);
            }
            if (constraints.video) this.cameraError = undefined;
            return Promise.all(stream.getTracks().map((mediaStreamTrack)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    const isAudio = mediaStreamTrack.kind === "audio";
                    isAudio ? mergedOptions.audio : mergedOptions.video;
                    let trackConstraints;
                    const conOrBool = isAudio ? constraints.audio : constraints.video;
                    if (typeof conOrBool !== "boolean") trackConstraints = conOrBool;
                    const track = $d84dc1a5e217b32f$var$mediaTrackToLocalTrack(mediaStreamTrack, trackConstraints, {
                        loggerName: this.roomOptions.loggerName,
                        loggerContextCb: ()=>this.logContext
                    });
                    if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) track.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera;
                    else if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) {
                        track.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone;
                        track.setAudioContext(this.audioContext);
                    }
                    track.mediaStream = stream;
                    if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237 && audioProcessor) yield track.setProcessor(audioProcessor);
                    else if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc && videoProcessor) yield track.setProcessor(videoProcessor);
                    return track;
                })));
        });
    }
    /**
   * Creates a screen capture tracks with getDisplayMedia().
   * A LocalVideoTrack is always created and returned.
   * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
   */ createScreenTracks(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (options === undefined) options = {};
            if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $d84dc1a5e217b32f$export$38c5ac268e2fa84("getDisplayMedia not supported");
            if (options.resolution === undefined && !$d84dc1a5e217b32f$var$isSafari17()) // we need to constrain the dimensions, otherwise it could lead to low bitrate
            // due to encoding a huge video. Encoding such large surfaces is really expensive
            // unfortunately Safari 17 has a but and cannot be constrained by default
            options.resolution = $d84dc1a5e217b32f$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
            const constraints = $d84dc1a5e217b32f$var$screenCaptureToDisplayMediaStreamOptions(options);
            const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
            const tracks = stream.getVideoTracks();
            if (tracks.length === 0) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("no video track found");
            const screenVideo = new $d84dc1a5e217b32f$export$d5ffd2c62c538bdc(tracks[0], undefined, false, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            screenVideo.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare;
            if (options.contentHint) screenVideo.mediaStreamTrack.contentHint = options.contentHint;
            const localTracks = [
                screenVideo
            ];
            if (stream.getAudioTracks().length > 0) {
                this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AudioStreamAcquired);
                const screenAudio = new $d84dc1a5e217b32f$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false, this.audioContext, {
                    loggerName: this.roomOptions.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                screenAudio.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShareAudio;
                localTracks.push(screenAudio);
            }
            return localTracks;
        });
    }
    /**
   * Publish a new track to the room
   * @param track
   * @param options
   */ publishTrack(track, options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.publishOrRepublishTrack(track, options);
        });
    }
    publishOrRepublishTrack(track_1, options_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(track, options) {
            var _this2 = this;
            let isRepublish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            return function*() {
                var _a, _b, _c, _d;
                if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) track.setAudioContext(_this2.audioContext);
                yield (_a = _this2.reconnectFuture) === null || _a === void 0 ? void 0 : _a.promise;
                if (_this2.republishPromise && !isRepublish) yield _this2.republishPromise;
                if (track instanceof $d84dc1a5e217b32f$export$3e041ce3f33f04dd && _this2.pendingPublishPromises.has(track)) yield _this2.pendingPublishPromises.get(track);
                let defaultConstraints;
                if (track instanceof MediaStreamTrack) defaultConstraints = track.getConstraints();
                else {
                    // we want to access constraints directly as `track.mediaStreamTrack`
                    // might be pointing to a non-device track (e.g. processed track) already
                    defaultConstraints = track.constraints;
                    let deviceKind = undefined;
                    switch(track.source){
                        case $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone:
                            deviceKind = "audioinput";
                            break;
                        case $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera:
                            deviceKind = "videoinput";
                    }
                    if (deviceKind && _this2.activeDeviceMap.has(deviceKind)) defaultConstraints = Object.assign(Object.assign({}, defaultConstraints), {
                        deviceId: _this2.activeDeviceMap.get(deviceKind)
                    });
                }
                // convert raw media track into audio or video track
                if (track instanceof MediaStreamTrack) switch(track.kind){
                    case "audio":
                        track = new $d84dc1a5e217b32f$export$b287427b771ca237(track, defaultConstraints, true, _this2.audioContext, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    case "video":
                        track = new $d84dc1a5e217b32f$export$d5ffd2c62c538bdc(track, defaultConstraints, true, {
                            loggerName: _this2.roomOptions.loggerName,
                            loggerContextCb: ()=>_this2.logContext
                        });
                        break;
                    default:
                        throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("unsupported MediaStreamTrack kind ".concat(track.kind));
                }
                else track.updateLoggerOptions({
                    loggerName: _this2.roomOptions.loggerName,
                    loggerContextCb: ()=>_this2.logContext
                });
                // is it already published? if so skip
                let existingPublication;
                _this2.trackPublications.forEach((publication)=>{
                    if (!publication.track) return;
                    if (publication.track === track) existingPublication = publication;
                });
                if (existingPublication) {
                    _this2.log.warn("track has already been published, skipping", Object.assign(Object.assign({}, _this2.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(existingPublication)));
                    return existingPublication;
                }
                const isStereoInput = "channelCount" in track.mediaStreamTrack.getSettings() && // @ts-ignore `channelCount` on getSettings() is currently only available for Safari, but is generally the best way to determine a stereo track https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackSettings/channelCount
                track.mediaStreamTrack.getSettings().channelCount === 2 || track.mediaStreamTrack.getConstraints().channelCount === 2;
                const isStereo = (_b = options === null || options === void 0 ? void 0 : options.forceStereo) !== null && _b !== void 0 ? _b : isStereoInput;
                // disable dtx for stereo track if not enabled explicitly
                if (isStereo) {
                    if (!options) options = {};
                    if (options.dtx === undefined) _this2.log.info("Opus DTX will be disabled for stereo tracks by default. Enable them explicitly to make it work.", Object.assign(Object.assign({}, _this2.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                    if (options.red === undefined) _this2.log.info("Opus RED will be disabled for stereo tracks by default. Enable them explicitly to make it work.");
                    (_c = options.dtx) !== null && _c !== void 0 ? _c : options.dtx = false;
                    (_d = options.red) !== null && _d !== void 0 ? _d : options.red = false;
                }
                const opts = Object.assign(Object.assign({}, _this2.roomOptions.publishDefaults), options);
                if (!$d84dc1a5e217b32f$var$isE2EESimulcastSupported() && _this2.roomOptions.e2ee) {
                    _this2.log.info("End-to-end encryption is set up, simulcast publishing will be disabled on Safari versions and iOS browsers running iOS < v17.2", Object.assign({}, _this2.logContext));
                    opts.simulcast = false;
                }
                if (opts.source) track.source = opts.source;
                const publishPromise = _this2.publish(track, opts, isStereo);
                _this2.pendingPublishPromises.set(track, publishPromise);
                try {
                    const publication = yield publishPromise;
                    return publication;
                } catch (e) {
                    throw e;
                } finally{
                    _this2.pendingPublishPromises.delete(track);
                }
            }();
        });
    }
    publish(track, opts, isStereo) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>track instanceof $d84dc1a5e217b32f$export$3e041ce3f33f04dd && publishedTrack.source === track.source);
            if (existingTrackOfSource && track.source !== $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Unknown) this.log.info("publishing a second track with the same source: ".concat(track.source), Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
            if (opts.stopMicTrackOnMute && track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) track.stopOnMute = true;
            if (track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare && $d84dc1a5e217b32f$var$isFireFox()) // Firefox does not work well with simulcasted screen share
            // we frequently get no data on layer 0 when enabled
            opts.simulcast = false;
            // require full AV1/VP9 SVC support prior to using it
            if (opts.videoCodec === "av1" && !$d84dc1a5e217b32f$export$f157b33fe3596be1()) opts.videoCodec = undefined;
            if (opts.videoCodec === "vp9" && !$d84dc1a5e217b32f$export$7c4c0f8271043129()) opts.videoCodec = undefined;
            if (opts.videoCodec === undefined) opts.videoCodec = $d84dc1a5e217b32f$var$defaultVideoCodec;
            if (this.enabledPublishVideoCodecs.length > 0) // fallback to a supported codec if it is not supported
            {
                if (!this.enabledPublishVideoCodecs.some((c)=>opts.videoCodec === $d84dc1a5e217b32f$var$mimeTypeToVideoCodecString(c.mime))) opts.videoCodec = $d84dc1a5e217b32f$var$mimeTypeToVideoCodecString(this.enabledPublishVideoCodecs[0].mime);
            }
            const videoCodec = opts.videoCodec;
            // handle track actions
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            // create track publication from track
            const req = new $d84dc1a5e217b32f$var$AddTrackRequest({
                // get local track id for use during publishing
                cid: track.mediaStreamTrack.id,
                name: opts.name,
                type: $d84dc1a5e217b32f$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $d84dc1a5e217b32f$export$13921ac0cc260818.sourceToProto(track.source),
                disableDtx: !((_a = opts.dtx) !== null && _a !== void 0 ? _a : true),
                encryption: this.encryptionType,
                stereo: isStereo,
                disableRed: this.isE2EEEnabled || !((_b = opts.red) !== null && _b !== void 0 ? _b : true),
                stream: opts === null || opts === void 0 ? void 0 : opts.stream
            });
            // compute encodings and layers for video
            let encodings;
            if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) {
                let dims = {
                    width: 0,
                    height: 0
                };
                try {
                    dims = yield track.waitForDimensions();
                } catch (e) {
                    // use defaults, it's quite painful for congestion control without simulcast
                    // so using default dims according to publish settings
                    const defaultRes = (_d = (_c = this.roomOptions.videoCaptureDefaults) === null || _c === void 0 ? void 0 : _c.resolution) !== null && _d !== void 0 ? _d : $d84dc1a5e217b32f$export$79d56065dad1674c.h720.resolution;
                    dims = {
                        width: defaultRes.width,
                        height: defaultRes.height
                    };
                    // log failure
                    this.log.error("could not determine track dimensions, using defaults", Object.assign(Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)), {
                        dims: dims
                    }));
                }
                // width and height should be defined for video
                req.width = dims.width;
                req.height = dims.height;
                // for svc codecs, disable simulcast and use vp8 for backup codec
                if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) {
                    if ($d84dc1a5e217b32f$var$isSVCCodec(videoCodec)) {
                        if (track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare) {
                            // vp9 svc with screenshare cannot encode multiple spatial layers
                            // doing so reduces publish resolution to minimal resolution
                            opts.scalabilityMode = "L1T3";
                            // Chrome does not allow more than 5 fps with L1T3, and it has encoding bugs with L3T3
                            // It has a different path for screenshare handling and it seems to be untested/buggy
                            // As a workaround, we are setting contentHint to force it to go through the same
                            // path as regular camera video. While this is not optimal, it delivers the performance
                            // that we need
                            if ("contentHint" in track.mediaStreamTrack) {
                                track.mediaStreamTrack.contentHint = "motion";
                                this.log.info("forcing contentHint to motion for screenshare with SVC codecs", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                            }
                        }
                        // set scalabilityMode to 'L3T3_KEY' by default
                        opts.scalabilityMode = (_e = opts.scalabilityMode) !== null && _e !== void 0 ? _e : "L3T3_KEY";
                    }
                    req.simulcastCodecs = [
                        new $d84dc1a5e217b32f$var$SimulcastCodec({
                            codec: videoCodec,
                            cid: track.mediaStreamTrack.id
                        })
                    ];
                    // set up backup
                    if (opts.backupCodec === true) opts.backupCodec = {
                        codec: $d84dc1a5e217b32f$var$defaultVideoCodec
                    };
                    if (opts.backupCodec && videoCodec !== opts.backupCodec.codec && // TODO remove this once e2ee is supported for backup codecs
                    req.encryption === $d84dc1a5e217b32f$var$Encryption_Type.NONE) {
                        // multi-codec simulcast requires dynacast
                        if (!this.roomOptions.dynacast) this.roomOptions.dynacast = true;
                        req.simulcastCodecs.push(new $d84dc1a5e217b32f$var$SimulcastCodec({
                            codec: opts.backupCodec.codec,
                            cid: ""
                        }));
                    }
                }
                encodings = $d84dc1a5e217b32f$var$computeVideoEncodings(track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                req.layers = $d84dc1a5e217b32f$var$videoLayersFromEncodings(req.width, req.height, encodings, $d84dc1a5e217b32f$var$isSVCCodec(opts.videoCodec));
            } else if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) encodings = [
                {
                    maxBitrate: (_f = opts.audioPreset) === null || _f === void 0 ? void 0 : _f.maxBitrate,
                    priority: (_h = (_g = opts.audioPreset) === null || _g === void 0 ? void 0 : _g.priority) !== null && _h !== void 0 ? _h : "high",
                    networkPriority: (_k = (_j = opts.audioPreset) === null || _j === void 0 ? void 0 : _j.priority) !== null && _k !== void 0 ? _k : "high"
                }
            ];
            if (!this.engine || this.engine.isClosed) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("cannot publish track when not connected");
            const negotiate = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c;
                    if (!this.engine.pcManager) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("pcManager is not ready");
                    track.sender = yield this.engine.createSender(track, opts, encodings);
                    if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) {
                        (_a = opts.degradationPreference) !== null && _a !== void 0 ? _a : opts.degradationPreference = $d84dc1a5e217b32f$var$getDefaultDegradationPreference(track);
                        track.setDegradationPreference(opts.degradationPreference);
                    }
                    if (encodings) {
                        if ($d84dc1a5e217b32f$var$isFireFox() && track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) {
                            /* Refer to RFC https://datatracker.ietf.org/doc/html/rfc7587#section-6.1,
               livekit-server uses maxaveragebitrate=510000 in the answer sdp to permit client to
               publish high quality audio track. But firefox always uses this value as the actual
               bitrates, causing the audio bitrates to rise to 510Kbps in any stereo case unexpectedly.
               So the client need to modify maxaverragebitrates in answer sdp to user provided value to
               fix the issue.
             */ let trackTransceiver = undefined;
                            for (const transceiver of this.engine.pcManager.publisher.getTransceivers())if (transceiver.sender === track.sender) {
                                trackTransceiver = transceiver;
                                break;
                            }
                            if (trackTransceiver) this.engine.pcManager.publisher.setTrackCodecBitrate({
                                transceiver: trackTransceiver,
                                codec: "opus",
                                maxbr: ((_b = encodings[0]) === null || _b === void 0 ? void 0 : _b.maxBitrate) ? encodings[0].maxBitrate / 1000 : 0
                            });
                        } else if (track.codec && $d84dc1a5e217b32f$var$isSVCCodec(track.codec) && ((_c = encodings[0]) === null || _c === void 0 ? void 0 : _c.maxBitrate)) this.engine.pcManager.publisher.setTrackCodecBitrate({
                            cid: req.cid,
                            codec: track.codec,
                            maxbr: encodings[0].maxBitrate / 1000
                        });
                    }
                    yield this.engine.negotiate();
                });
            let ti;
            if (this.enabledPublishVideoCodecs.length > 0) {
                const rets = yield Promise.all([
                    this.engine.addTrack(req),
                    negotiate()
                ]);
                ti = rets[0];
            } else {
                ti = yield this.engine.addTrack(req);
                // server might not support the codec the client has requested, in that case, fallback
                // to a supported codec
                let primaryCodecMime;
                ti.codecs.forEach((codec)=>{
                    if (primaryCodecMime === undefined) primaryCodecMime = codec.mimeType;
                });
                if (primaryCodecMime && track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) {
                    const updatedCodec = $d84dc1a5e217b32f$var$mimeTypeToVideoCodecString(primaryCodecMime);
                    if (updatedCodec !== videoCodec) {
                        this.log.debug("falling back to server selected codec", Object.assign(Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)), {
                            codec: updatedCodec
                        }));
                        opts.videoCodec = updatedCodec;
                        // recompute encodings since bitrates/etc could have changed
                        encodings = $d84dc1a5e217b32f$var$computeVideoEncodings(track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare, req.width, req.height, opts);
                    }
                }
                yield negotiate();
            }
            const publication = new $d84dc1a5e217b32f$export$885a52c769210b3f(track.kind, ti, track, {
                loggerName: this.roomOptions.loggerName,
                loggerContextCb: ()=>this.logContext
            });
            // save options for when it needs to be republished again
            publication.options = opts;
            track.sid = ti.sid;
            this.log.debug("publishing ".concat(track.kind, " with encodings"), Object.assign(Object.assign({}, this.logContext), {
                encodings: encodings,
                trackInfo: ti
            }));
            if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) track.startMonitor(this.engine.client);
            else if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) track.startMonitor();
            this.addTrackPublication(publication);
            // send event for publication
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, publication);
            return publication;
        });
    }
    get isLocal() {
        return true;
    }
    /** @internal
   * publish additional codec to existing track
   */ publishAdditionalCodecForTrack(track, videoCodec, options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // TODO remove once e2ee is supported for backup tracks
            if (this.encryptionType !== $d84dc1a5e217b32f$var$Encryption_Type.NONE) return;
            // is it not published? if so skip
            let existingPublication;
            this.trackPublications.forEach((publication)=>{
                if (!publication.track) return;
                if (publication.track === track) existingPublication = publication;
            });
            if (!existingPublication) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("track is not published");
            if (!(track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc)) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("track is not a video track");
            const opts = Object.assign(Object.assign({}, (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.publishDefaults), options);
            const encodings = $d84dc1a5e217b32f$var$computeTrackBackupEncodings(track, videoCodec, opts);
            if (!encodings) {
                this.log.info("backup codec has been disabled, ignoring request to add additional codec for track", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                return;
            }
            const simulcastTrack = track.addSimulcastTrack(videoCodec, encodings);
            if (!simulcastTrack) return;
            const req = new $d84dc1a5e217b32f$var$AddTrackRequest({
                cid: simulcastTrack.mediaStreamTrack.id,
                type: $d84dc1a5e217b32f$export$13921ac0cc260818.kindToProto(track.kind),
                muted: track.isMuted,
                source: $d84dc1a5e217b32f$export$13921ac0cc260818.sourceToProto(track.source),
                sid: track.sid,
                simulcastCodecs: [
                    {
                        codec: opts.videoCodec,
                        cid: simulcastTrack.mediaStreamTrack.id
                    }
                ]
            });
            req.layers = $d84dc1a5e217b32f$var$videoLayersFromEncodings(req.width, req.height, encodings);
            if (!this.engine || this.engine.isClosed) throw new $d84dc1a5e217b32f$export$1f388e244efbf70b("cannot publish track when not connected");
            const negotiate = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                    yield this.engine.createSimulcastSender(track, simulcastTrack, opts, encodings);
                    yield this.engine.negotiate();
                });
            const rets = yield Promise.all([
                this.engine.addTrack(req),
                negotiate()
            ]);
            const ti = rets[0];
            this.log.debug("published ".concat(videoCodec, " for track ").concat(track.sid), Object.assign(Object.assign({}, this.logContext), {
                encodings: encodings,
                trackInfo: ti
            }));
        });
    }
    unpublishTrack(track, stopOnUnpublish) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (track instanceof $d84dc1a5e217b32f$export$3e041ce3f33f04dd) {
                const publishPromise = this.pendingPublishPromises.get(track);
                if (publishPromise) {
                    this.log.info("awaiting publish promise before attempting to unpublish", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(track)));
                    yield publishPromise;
                }
            }
            // look through all published tracks to find the right ones
            const publication = this.getPublicationForTrack(track);
            const pubLogContext = publication ? $d84dc1a5e217b32f$var$getLogContextFromTrack(publication) : undefined;
            this.log.debug("unpublishing track", Object.assign(Object.assign({}, this.logContext), pubLogContext));
            if (!publication || !publication.track) {
                this.log.warn("track was not unpublished because no publication was found", Object.assign(Object.assign({}, this.logContext), pubLogContext));
                return undefined;
            }
            track = publication.track;
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Muted, this.onTrackMuted);
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted, this.onTrackUnmuted);
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleTrackEnded);
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamPaused, this.onTrackUpstreamPaused);
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.UpstreamResumed, this.onTrackUpstreamResumed);
            track.off($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioTrackFeatureUpdate, this.onTrackFeatureUpdate);
            if (stopOnUnpublish === undefined) stopOnUnpublish = (_b = (_a = this.roomOptions) === null || _a === void 0 ? void 0 : _a.stopLocalTrackOnUnpublish) !== null && _b !== void 0 ? _b : true;
            if (stopOnUnpublish) track.stop();
            else track.stopMonitor();
            let negotiationNeeded = false;
            const trackSender = track.sender;
            track.sender = undefined;
            if (this.engine.pcManager && this.engine.pcManager.currentState < $d84dc1a5e217b32f$var$PCTransportState.FAILED && trackSender) try {
                for (const transceiver of this.engine.pcManager.publisher.getTransceivers())// if sender is not currently sending (after replaceTrack(null))
                // removeTrack would have no effect.
                // to ensure we end up successfully removing the track, manually set
                // the transceiver to inactive
                if (transceiver.sender === trackSender) {
                    transceiver.direction = "inactive";
                    negotiationNeeded = true;
                }
                if (this.engine.removeTrack(trackSender)) negotiationNeeded = true;
                if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) {
                    for (const [, trackInfo] of track.simulcastCodecs)if (trackInfo.sender) {
                        if (this.engine.removeTrack(trackInfo.sender)) negotiationNeeded = true;
                        trackInfo.sender = undefined;
                    }
                    track.simulcastCodecs.clear();
                }
            } catch (e) {
                this.log.warn("failed to unpublish track", Object.assign(Object.assign(Object.assign({}, this.logContext), pubLogContext), {
                    error: e
                }));
            }
            // remove from our maps
            this.trackPublications.delete(publication.trackSid);
            switch(publication.kind){
                case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio:
                    this.audioTrackPublications.delete(publication.trackSid);
                    break;
                case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video:
                    this.videoTrackPublications.delete(publication.trackSid);
                    break;
            }
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackUnpublished, publication);
            publication.setTrack(undefined);
            if (negotiationNeeded) yield this.engine.negotiate();
            return publication;
        });
    }
    unpublishTracks(tracks) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const results = yield Promise.all(tracks.map((track)=>this.unpublishTrack(track)));
            return results.filter((track)=>track instanceof $d84dc1a5e217b32f$export$885a52c769210b3f);
        });
    }
    republishAllTracks(options_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(options) {
            var _this3 = this;
            let restartTracks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            return function*() {
                if (_this3.republishPromise) yield _this3.republishPromise;
                _this3.republishPromise = new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(_this3, void 0, void 0, function*() {
                        try {
                            const localPubs = [];
                            this.trackPublications.forEach((pub)=>{
                                if (pub.track) {
                                    if (options) pub.options = Object.assign(Object.assign({}, pub.options), options);
                                    localPubs.push(pub);
                                }
                            });
                            yield Promise.all(localPubs.map((pub)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                                    const track = pub.track;
                                    yield this.unpublishTrack(track, false);
                                    if (restartTracks && !track.isMuted && track.source !== $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare && track.source !== $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShareAudio && (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237 || track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) && !track.isUserProvided) {
                                        // generally we need to restart the track before publishing, often a full reconnect
                                        // is necessary because computer had gone to sleep.
                                        this.log.debug("restarting existing track", Object.assign(Object.assign({}, this.logContext), {
                                            track: pub.trackSid
                                        }));
                                        yield track.restartTrack();
                                    }
                                    yield this.publishOrRepublishTrack(track, pub.options, true);
                                })));
                            resolve();
                        } catch (error) {
                            reject(error);
                        } finally{
                            this.republishPromise = undefined;
                        }
                    }));
                yield _this3.republishPromise;
            }();
        });
    }
    /**
   * Publish a new data payload to the room. Data will be forwarded to each
   * participant in the room if the destination field in publishOptions is empty
   *
   * @param data Uint8Array of the payload. To send string data, use TextEncoder.encode
   * @param options optionally specify a `reliable`, `topic` and `destination`
   */ publishData(data_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(data) {
            var _this4 = this;
            let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return function*() {
                const kind = options.reliable ? $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE : $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.LOSSY;
                const destinationIdentities = options.destinationIdentities;
                const topic = options.topic;
                const packet = new $d84dc1a5e217b32f$var$DataPacket({
                    kind: kind,
                    value: {
                        case: "user",
                        value: new $d84dc1a5e217b32f$var$UserPacket({
                            participantIdentity: _this4.identity,
                            payload: data,
                            destinationIdentities: destinationIdentities,
                            topic: topic
                        })
                    }
                });
                yield _this4.engine.sendDataPacket(packet, kind);
            }();
        });
    }
    /**
   * Publish SIP DTMF message to the room.
   *
   * @param code DTMF code
   * @param digit DTMF digit
   */ publishDtmf(code, digit) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                kind: $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: "sipDtmf",
                    value: new $d84dc1a5e217b32f$var$SipDTMF({
                        code: code,
                        digit: digit
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    sendChatMessage(text) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const msg = {
                id: crypto.randomUUID(),
                message: text,
                timestamp: Date.now()
            };
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                value: {
                    case: "chatMessage",
                    value: new $d84dc1a5e217b32f$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $d84dc1a5e217b32f$var$protoInt64.parse(msg.timestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    editChatMessage(editText, originalMessage) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const msg = Object.assign(Object.assign({}, originalMessage), {
                message: editText,
                editTimestamp: Date.now()
            });
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                value: {
                    case: "chatMessage",
                    value: new $d84dc1a5e217b32f$var$ChatMessage(Object.assign(Object.assign({}, msg), {
                        timestamp: $d84dc1a5e217b32f$var$protoInt64.parse(msg.timestamp),
                        editTimestamp: $d84dc1a5e217b32f$var$protoInt64.parse(msg.editTimestamp)
                    }))
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ChatMessage, msg);
            return msg;
        });
    }
    /**
   * Initiate an RPC call to a remote participant
   * @param params - Parameters for initiating the RPC call, see {@link PerformRpcParams}
   * @returns A promise that resolves with the response payload or rejects with an error.
   * @throws Error on failure. Details in `message`.
   */ performRpc(_a) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(_ref3) {
            var _this5 = this;
            let { destinationIdentity: destinationIdentity, method: method, payload: payload, responseTimeout: responseTimeout = 10000 } = _ref3;
            return function*() {
                const maxRoundTripLatency = 2000;
                return new Promise((resolve, reject)=>$d84dc1a5e217b32f$var$__awaiter(_this5, void 0, void 0, function*() {
                        var _a, _b, _c, _d;
                        if ($d84dc1a5e217b32f$var$byteLength(payload) > $d84dc1a5e217b32f$var$MAX_PAYLOAD_BYTES) {
                            reject($d84dc1a5e217b32f$export$5460eff990f31920.builtIn("REQUEST_PAYLOAD_TOO_LARGE"));
                            return;
                        }
                        if (((_b = (_a = this.engine.latestJoinResponse) === null || _a === void 0 ? void 0 : _a.serverInfo) === null || _b === void 0 ? void 0 : _b.version) && $d84dc1a5e217b32f$export$66e1c0999abad646((_d = (_c = this.engine.latestJoinResponse) === null || _c === void 0 ? void 0 : _c.serverInfo) === null || _d === void 0 ? void 0 : _d.version, "1.8.0") < 0) {
                            reject($d84dc1a5e217b32f$export$5460eff990f31920.builtIn("UNSUPPORTED_SERVER"));
                            return;
                        }
                        const id = crypto.randomUUID();
                        yield this.publishRpcRequest(destinationIdentity, id, method, payload, responseTimeout - maxRoundTripLatency);
                        const ackTimeoutId = setTimeout(()=>{
                            this.pendingAcks.delete(id);
                            reject($d84dc1a5e217b32f$export$5460eff990f31920.builtIn("CONNECTION_TIMEOUT"));
                            this.pendingResponses.delete(id);
                            clearTimeout(responseTimeoutId);
                        }, maxRoundTripLatency);
                        this.pendingAcks.set(id, {
                            resolve: ()=>{
                                clearTimeout(ackTimeoutId);
                            },
                            participantIdentity: destinationIdentity
                        });
                        const responseTimeoutId = setTimeout(()=>{
                            this.pendingResponses.delete(id);
                            reject($d84dc1a5e217b32f$export$5460eff990f31920.builtIn("RESPONSE_TIMEOUT"));
                        }, responseTimeout);
                        this.pendingResponses.set(id, {
                            resolve: (responsePayload, responseError)=>{
                                clearTimeout(responseTimeoutId);
                                if (this.pendingAcks.has(id)) {
                                    console.warn("RPC response received before ack", id);
                                    this.pendingAcks.delete(id);
                                    clearTimeout(ackTimeoutId);
                                }
                                if (responseError) reject(responseError);
                                else resolve(responsePayload !== null && responsePayload !== void 0 ? responsePayload : "");
                            },
                            participantIdentity: destinationIdentity
                        });
                    }));
            }();
        });
    }
    /**
   * Establishes the participant as a receiver for calls of the specified RPC method.
   * Will overwrite any existing callback for the same method.
   *
   * @param method - The name of the indicated RPC method
   * @param handler - Will be invoked when an RPC request for this method is received
   * @returns A promise that resolves when the method is successfully registered
   *
   * @example
   * ```typescript
   * room.localParticipant?.registerRpcMethod(
   *   'greet',
   *   async (data: RpcInvocationData) => {
   *     console.log(`Received greeting from ${data.callerIdentity}: ${data.payload}`);
   *     return `Hello, ${data.callerIdentity}!`;
   *   }
   * );
   * ```
   *
   * The handler should return a Promise that resolves to a string.
   * If unable to respond within `responseTimeout`, the request will result in an error on the caller's side.
   *
   * You may throw errors of type `RpcError` with a string `message` in the handler,
   * and they will be received on the caller's side with the message intact.
   * Other errors thrown in your handler will not be transmitted as-is, and will instead arrive to the caller as `1500` ("Application Error").
   */ registerRpcMethod(method, handler) {
        this.rpcHandlers.set(method, handler);
    }
    /**
   * Unregisters a previously registered RPC method.
   *
   * @param method - The name of the RPC method to unregister
   */ unregisterRpcMethod(method) {
        this.rpcHandlers.delete(method);
    }
    /**
   * Control who can subscribe to LocalParticipant's published tracks.
   *
   * By default, all participants can subscribe. This allows fine-grained control over
   * who is able to subscribe at a participant and track level.
   *
   * Note: if access is given at a track-level (i.e. both [allParticipantsAllowed] and
   * [ParticipantTrackPermission.allTracksAllowed] are false), any newer published tracks
   * will not grant permissions to any participants and will require a subsequent
   * permissions update to allow subscription.
   *
   * @param allParticipantsAllowed Allows all participants to subscribe all tracks.
   *  Takes precedence over [[participantTrackPermissions]] if set to true.
   *  By default this is set to true.
   * @param participantTrackPermissions Full list of individual permissions per
   *  participant/track. Any omitted participants will not receive any permissions.
   */ setTrackSubscriptionPermissions(allParticipantsAllowed) {
        let participantTrackPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        this.participantTrackPermissions = participantTrackPermissions;
        this.allParticipantsAllowedToSubscribe = allParticipantsAllowed;
        if (!this.engine.client.isDisconnected) this.updateTrackSubscriptionPermissions();
    }
    handleIncomingRpcAck(requestId) {
        const handler = this.pendingAcks.get(requestId);
        if (handler) {
            handler.resolve();
            this.pendingAcks.delete(requestId);
        } else console.error("Ack received for unexpected RPC request", requestId);
    }
    handleIncomingRpcResponse(requestId, payload, error) {
        const handler = this.pendingResponses.get(requestId);
        if (handler) {
            handler.resolve(payload, error);
            this.pendingResponses.delete(requestId);
        } else console.error("Response received for unexpected RPC request", requestId);
    }
    handleIncomingRpcRequest(callerIdentity, requestId, method, payload, responseTimeout, version) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            yield this.publishRpcAck(callerIdentity, requestId);
            if (version !== 1) {
                yield this.publishRpcResponse(callerIdentity, requestId, null, $d84dc1a5e217b32f$export$5460eff990f31920.builtIn("UNSUPPORTED_VERSION"));
                return;
            }
            const handler = this.rpcHandlers.get(method);
            if (!handler) {
                yield this.publishRpcResponse(callerIdentity, requestId, null, $d84dc1a5e217b32f$export$5460eff990f31920.builtIn("UNSUPPORTED_METHOD"));
                return;
            }
            let responseError = null;
            let responsePayload = null;
            try {
                const response = yield handler({
                    requestId: requestId,
                    callerIdentity: callerIdentity,
                    payload: payload,
                    responseTimeout: responseTimeout
                });
                if ($d84dc1a5e217b32f$var$byteLength(response) > $d84dc1a5e217b32f$var$MAX_PAYLOAD_BYTES) {
                    responseError = $d84dc1a5e217b32f$export$5460eff990f31920.builtIn("RESPONSE_PAYLOAD_TOO_LARGE");
                    console.warn("RPC Response payload too large for ".concat(method));
                } else responsePayload = response;
            } catch (error) {
                if (error instanceof $d84dc1a5e217b32f$export$5460eff990f31920) responseError = error;
                else {
                    console.warn("Uncaught error returned by RPC handler for ".concat(method, ". Returning APPLICATION_ERROR instead."), error);
                    responseError = $d84dc1a5e217b32f$export$5460eff990f31920.builtIn("APPLICATION_ERROR");
                }
            }
            yield this.publishRpcResponse(callerIdentity, requestId, responsePayload, responseError);
        });
    }
    /** @internal */ publishRpcRequest(destinationIdentity, requestId, method, payload, responseTimeout) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: "rpcRequest",
                    value: new $d84dc1a5e217b32f$var$RpcRequest({
                        id: requestId,
                        method: method,
                        payload: payload,
                        responseTimeoutMs: responseTimeout,
                        version: 1
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ publishRpcResponse(destinationIdentity, requestId, payload, error) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: "rpcResponse",
                    value: new $d84dc1a5e217b32f$var$RpcResponse({
                        requestId: requestId,
                        value: error ? {
                            case: "error",
                            value: error.toProto()
                        } : {
                            case: "payload",
                            value: payload !== null && payload !== void 0 ? payload : ""
                        }
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ publishRpcAck(destinationIdentity, requestId) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const packet = new $d84dc1a5e217b32f$var$DataPacket({
                destinationIdentities: [
                    destinationIdentity
                ],
                kind: $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE,
                value: {
                    case: "rpcAck",
                    value: new $d84dc1a5e217b32f$var$RpcAck({
                        requestId: requestId
                    })
                }
            });
            yield this.engine.sendDataPacket(packet, $d84dc1a5e217b32f$export$629a0ea4ceb9e4a6.RELIABLE);
        });
    }
    /** @internal */ handleParticipantDisconnected(participantIdentity) {
        for (const [id, { participantIdentity: pendingIdentity }] of this.pendingAcks)if (pendingIdentity === participantIdentity) this.pendingAcks.delete(id);
        for (const [id, { participantIdentity: pendingIdentity, resolve: resolve }] of this.pendingResponses)if (pendingIdentity === participantIdentity) {
            resolve(null, $d84dc1a5e217b32f$export$5460eff990f31920.builtIn("RECIPIENT_DISCONNECTED"));
            this.pendingResponses.delete(id);
        }
    }
    /** @internal */ setEnabledPublishCodecs(codecs) {
        this.enabledPublishVideoCodecs = codecs.filter((c)=>c.mime.split("/")[0].toLowerCase() === "video");
    }
    /** @internal */ updateInfo(info) {
        if (info.sid !== this.sid) // drop updates that specify a wrong sid.
        // the sid for local participant is only explicitly set on join and full reconnect
        return false;
        if (!super.updateInfo(info)) return false;
        // reconcile track mute status.
        // if server's track mute status doesn't match actual, we'll have to update
        // the server's copy
        info.tracks.forEach((ti)=>{
            var _a, _b;
            const pub = this.trackPublications.get(ti.sid);
            if (pub) {
                const mutedOnServer = pub.isMuted || ((_b = (_a = pub.track) === null || _a === void 0 ? void 0 : _a.isUpstreamPaused) !== null && _b !== void 0 ? _b : false);
                if (mutedOnServer !== ti.muted) {
                    this.log.debug("updating server mute state after reconcile", Object.assign(Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(pub)), {
                        mutedOnServer: mutedOnServer
                    }));
                    this.engine.client.sendMuteTrack(ti.sid, mutedOnServer);
                }
            }
        });
        return true;
    }
    getPublicationForTrack(track) {
        let publication;
        this.trackPublications.forEach((pub)=>{
            const localTrack = pub.track;
            if (!localTrack) return;
            // this looks overly complicated due to this object tree
            if (track instanceof MediaStreamTrack) {
                if (localTrack instanceof $d84dc1a5e217b32f$export$b287427b771ca237 || localTrack instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc) {
                    if (localTrack.mediaStreamTrack === track) publication = pub;
                }
            } else if (track === localTrack) publication = pub;
        });
        return publication;
    }
    waitForPendingPublicationOfSource(source) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const waitForPendingTimeout = 10000;
            const startTime = Date.now();
            while(Date.now() < startTime + waitForPendingTimeout){
                const publishPromiseEntry = Array.from(this.pendingPublishPromises.entries()).find((_ref4)=>{
                    let [pendingTrack] = _ref4;
                    return pendingTrack.source === source;
                });
                if (publishPromiseEntry) return publishPromiseEntry[1];
                yield $d84dc1a5e217b32f$var$sleep(20);
            }
        });
    }
}
class $d84dc1a5e217b32f$export$c89ab28402142c29 extends $d84dc1a5e217b32f$export$7c531331788c3797 {
    constructor(kind, ti, autoSubscribe, loggerOptions){
        super(kind, ti.sid, ti.name, loggerOptions);
        this.track = undefined;
        /** @internal */ this.allowed = true;
        this.disabled = false;
        this.currentVideoQuality = $d84dc1a5e217b32f$export$a8f593954e806155.HIGH;
        this.handleEnded = (track)=>{
            this.setTrack(undefined);
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, track);
        };
        this.handleVisibilityChange = (visible)=>{
            this.log.debug("adaptivestream video visibility ".concat(this.trackSid, ", visible=").concat(visible), this.logContext);
            this.disabled = !visible;
            this.emitTrackUpdate();
        };
        this.handleVideoDimensionsChange = (dimensions)=>{
            this.log.debug("adaptivestream video dimensions ".concat(dimensions.width, "x").concat(dimensions.height), this.logContext);
            this.videoDimensions = dimensions;
            this.emitTrackUpdate();
        };
        this.subscribed = autoSubscribe;
        this.updateInfo(ti);
    }
    /**
   * Subscribe or unsubscribe to this remote track
   * @param subscribed true to subscribe to a track, false to unsubscribe
   */ setSubscribed(subscribed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.subscribed = subscribed;
        // reset allowed status when desired subscription state changes
        // server will notify client via signal message if it's not allowed
        if (subscribed) this.allowed = true;
        const sub = new $d84dc1a5e217b32f$var$UpdateSubscription({
            trackSids: [
                this.trackSid
            ],
            subscribe: this.subscribed,
            participantTracks: [
                new $d84dc1a5e217b32f$var$ParticipantTracks({
                    // sending an empty participant id since TrackPublication doesn't keep it
                    // this is filled in by the participant that receives this message
                    participantSid: "",
                    trackSids: [
                        this.trackSid
                    ]
                })
            ]
        });
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.UpdateSubscription, sub);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
        this.emitPermissionUpdateIfChanged(prevPermission);
    }
    get subscriptionStatus() {
        if (this.subscribed === false) return $d84dc1a5e217b32f$export$7c531331788c3797.SubscriptionStatus.Unsubscribed;
        if (!super.isSubscribed) return $d84dc1a5e217b32f$export$7c531331788c3797.SubscriptionStatus.Desired;
        return $d84dc1a5e217b32f$export$7c531331788c3797.SubscriptionStatus.Subscribed;
    }
    get permissionStatus() {
        return this.allowed ? $d84dc1a5e217b32f$export$7c531331788c3797.PermissionStatus.Allowed : $d84dc1a5e217b32f$export$7c531331788c3797.PermissionStatus.NotAllowed;
    }
    /**
   * Returns true if track is subscribed, and ready for playback
   */ get isSubscribed() {
        if (this.subscribed === false) return false;
        return super.isSubscribed;
    }
    // returns client's desire to subscribe to a track, also true if autoSubscribe is enabled
    get isDesired() {
        return this.subscribed !== false;
    }
    get isEnabled() {
        return !this.disabled;
    }
    /**
   * disable server from sending down data for this track. this is useful when
   * the participant is off screen, you may disable streaming down their video
   * to reduce bandwidth requirements
   * @param enabled
   */ setEnabled(enabled) {
        if (!this.isManualOperationAllowed() || this.disabled === !enabled) return;
        this.disabled = !enabled;
        this.emitTrackUpdate();
    }
    /**
   * for tracks that support simulcasting, adjust subscribed quality
   *
   * This indicates the highest quality the client can accept. if network
   * bandwidth does not allow, server will automatically reduce quality to
   * optimize for uninterrupted video
   */ setVideoQuality(quality) {
        if (!this.isManualOperationAllowed() || this.currentVideoQuality === quality) return;
        this.currentVideoQuality = quality;
        this.videoDimensions = undefined;
        this.emitTrackUpdate();
    }
    setVideoDimensions(dimensions) {
        var _a, _b;
        if (!this.isManualOperationAllowed()) return;
        if (((_a = this.videoDimensions) === null || _a === void 0 ? void 0 : _a.width) === dimensions.width && ((_b = this.videoDimensions) === null || _b === void 0 ? void 0 : _b.height) === dimensions.height) return;
        if (this.track instanceof $d84dc1a5e217b32f$export$1db0c0ebd3ae1523) this.videoDimensions = dimensions;
        this.currentVideoQuality = undefined;
        this.emitTrackUpdate();
    }
    setVideoFPS(fps) {
        if (!this.isManualOperationAllowed()) return;
        if (!(this.track instanceof $d84dc1a5e217b32f$export$1db0c0ebd3ae1523)) return;
        if (this.fps === fps) return;
        this.fps = fps;
        this.emitTrackUpdate();
    }
    get videoQuality() {
        return this.currentVideoQuality;
    }
    /** @internal */ setTrack(track) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        const prevTrack = this.track;
        if (prevTrack === track) return;
        if (prevTrack) {
            // unregister listener
            prevTrack.off($d84dc1a5e217b32f$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            prevTrack.off($d84dc1a5e217b32f$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            prevTrack.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleEnded);
            prevTrack.detach();
            prevTrack.stopMonitor();
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Unsubscribed, prevTrack);
        }
        super.setTrack(track);
        if (track) {
            track.sid = this.trackSid;
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.VideoDimensionsChanged, this.handleVideoDimensionsChange);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.VisibilityChanged, this.handleVisibilityChange);
            track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Ended, this.handleEnded);
            this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.Subscribed, track);
        }
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setAllowed(allowed) {
        const prevStatus = this.subscriptionStatus;
        const prevPermission = this.permissionStatus;
        this.allowed = allowed;
        this.emitPermissionUpdateIfChanged(prevPermission);
        this.emitSubscriptionUpdateIfChanged(prevStatus);
    }
    /** @internal */ setSubscriptionError(error) {
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionFailed, error);
    }
    /** @internal */ updateInfo(info) {
        super.updateInfo(info);
        const prevMetadataMuted = this.metadataMuted;
        this.metadataMuted = info.muted;
        if (this.track) this.track.setMuted(info.muted);
        else if (prevMetadataMuted !== info.muted) this.emit(info.muted ? $d84dc1a5e217b32f$export$2c8510d737cc09da.Muted : $d84dc1a5e217b32f$export$2c8510d737cc09da.Unmuted);
    }
    emitSubscriptionUpdateIfChanged(previousStatus) {
        const currentStatus = this.subscriptionStatus;
        if (previousStatus === currentStatus) return;
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionStatusChanged, currentStatus, previousStatus);
    }
    emitPermissionUpdateIfChanged(previousPermissionStatus) {
        const currentPermissionStatus = this.permissionStatus;
        if (currentPermissionStatus !== previousPermissionStatus) this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionPermissionChanged, this.permissionStatus, previousPermissionStatus);
    }
    isManualOperationAllowed() {
        if (this.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video && this.isAdaptiveStream) {
            this.log.warn("adaptive stream is enabled, cannot change video track settings", this.logContext);
            return false;
        }
        if (!this.isDesired) {
            this.log.warn("cannot update track settings when not subscribed", this.logContext);
            return false;
        }
        return true;
    }
    get isAdaptiveStream() {
        return this.track instanceof $d84dc1a5e217b32f$export$1db0c0ebd3ae1523 && this.track.isAdaptiveStream;
    }
    /* @internal */ emitTrackUpdate() {
        const settings = new $d84dc1a5e217b32f$var$UpdateTrackSettings({
            trackSids: [
                this.trackSid
            ],
            disabled: this.disabled,
            fps: this.fps
        });
        if (this.videoDimensions) {
            settings.width = Math.ceil(this.videoDimensions.width);
            settings.height = Math.ceil(this.videoDimensions.height);
        } else if (this.currentVideoQuality !== undefined) settings.quality = this.currentVideoQuality;
        else // defaults to high quality
        settings.quality = $d84dc1a5e217b32f$export$a8f593954e806155.HIGH;
        this.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.UpdateSettings, settings);
    }
}
class $d84dc1a5e217b32f$export$bf85b9e4f33346fe extends $d84dc1a5e217b32f$export$aada361ed1a6c65 {
    /** @internal */ static fromParticipantInfo(signalClient, pi, loggerOptions) {
        return new $d84dc1a5e217b32f$export$bf85b9e4f33346fe(signalClient, pi.sid, pi.identity, pi.name, pi.metadata, pi.attributes, loggerOptions, pi.kind);
    }
    get logContext() {
        return Object.assign(Object.assign({}, super.logContext), {
            rpID: this.sid,
            remoteParticipant: this.identity
        });
    }
    /** @internal */ constructor(signalClient, sid, identity, name, metadata, attributes, loggerOptions){
        let kind = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : $d84dc1a5e217b32f$export$2079c0e1523aec29.STANDARD;
        super(sid, identity || "", name, metadata, attributes, loggerOptions, kind);
        this.signalClient = signalClient;
        this.trackPublications = new Map();
        this.audioTrackPublications = new Map();
        this.videoTrackPublications = new Map();
        this.volumeMap = new Map();
    }
    addTrackPublication(publication) {
        super.addTrackPublication(publication);
        // register action events
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.UpdateSettings, (settings)=>{
            this.log.debug("send update settings", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(publication)));
            this.signalClient.sendUpdateTrackSettings(settings);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.UpdateSubscription, (sub)=>{
            sub.participantTracks.forEach((pt)=>{
                pt.participantSid = this.sid;
            });
            this.signalClient.sendUpdateSubscription(sub);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionPermissionChanged, (status)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, publication, status);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionStatusChanged, (status)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, publication, status);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Subscribed, (track)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscribed, track, publication);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Unsubscribed, (previousTrack)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnsubscribed, previousTrack, publication);
        });
        publication.on($d84dc1a5e217b32f$export$2c8510d737cc09da.SubscriptionFailed, (error)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionFailed, publication.trackSid, error);
        });
    }
    getTrackPublication(source) {
        const track = super.getTrackPublication(source);
        if (track) return track;
    }
    getTrackPublicationByName(name) {
        const track = super.getTrackPublicationByName(name);
        if (track) return track;
    }
    /**
   * sets the volume on the participant's audio track
   * by default, this affects the microphone publication
   * a different source can be passed in as a second argument
   * if no track exists the volume will be applied when the microphone track is added
   */ setVolume(volume) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone;
        this.volumeMap.set(source, volume);
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) audioPublication.track.setVolume(volume);
    }
    /**
   * gets the volume on the participant's microphone track
   */ getVolume() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone;
        const audioPublication = this.getTrackPublication(source);
        if (audioPublication && audioPublication.track) return audioPublication.track.getVolume();
        return this.volumeMap.get(source);
    }
    /** @internal */ addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft) {
        // find the track publication
        // it's possible for the media track to arrive before participant info
        let publication = this.getTrackPublicationBySid(sid);
        // it's also possible that the browser didn't honor our original track id
        // FireFox would use its own local uuid instead of server track id
        if (!publication) {
            if (!sid.startsWith("TR")) // find the first track that matches type
            this.trackPublications.forEach((p)=>{
                if (!publication && mediaTrack.kind === p.kind.toString()) publication = p;
            });
        }
        // when we couldn't locate the track, it's possible that the metadata hasn't
        // yet arrived. Wait a bit longer for it to arrive, or fire an error
        if (!publication) {
            if (triesLeft === 0) {
                this.log.error("could not find published track", Object.assign(Object.assign({}, this.logContext), {
                    trackSid: sid
                }));
                this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
                return;
            }
            if (triesLeft === undefined) triesLeft = 20;
            setTimeout(()=>{
                this.addSubscribedMediaTrack(mediaTrack, sid, mediaStream, receiver, adaptiveStreamSettings, triesLeft - 1);
            }, 150);
            return;
        }
        if (mediaTrack.readyState === "ended") {
            this.log.error("unable to subscribe because MediaStreamTrack is ended. Do not call MediaStreamTrack.stop()", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(publication)));
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionFailed, sid);
            return;
        }
        const isVideo = mediaTrack.kind === "video";
        let track;
        if (isVideo) track = new $d84dc1a5e217b32f$export$1db0c0ebd3ae1523(mediaTrack, sid, receiver, adaptiveStreamSettings);
        else track = new $d84dc1a5e217b32f$export$fd37b116bd840ced(mediaTrack, sid, receiver, this.audioContext, this.audioOutput);
        // set track info
        track.source = publication.source;
        // keep publication's muted status
        track.isMuted = publication.isMuted;
        track.setMediaStream(mediaStream);
        track.start();
        publication.setTrack(track);
        // set participant volumes on new audio tracks
        if (this.volumeMap.has(publication.source) && track instanceof $d84dc1a5e217b32f$export$fd37b116bd840ced) track.setVolume(this.volumeMap.get(publication.source));
        return publication;
    }
    /** @internal */ get hasMetadata() {
        return !!this.participantInfo;
    }
    /**
   * @internal
   */ getTrackPublicationBySid(sid) {
        return this.trackPublications.get(sid);
    }
    /** @internal */ updateInfo(info) {
        if (!super.updateInfo(info)) return false;
        // we are getting a list of all available tracks, reconcile in here
        // and send out events for changes
        // reconcile track publications, publish events only if metadata is already there
        // i.e. changes since the local participant has joined
        const validTracks = new Map();
        const newTracks = new Map();
        info.tracks.forEach((ti)=>{
            var _a, _b;
            let publication = this.getTrackPublicationBySid(ti.sid);
            if (!publication) {
                // new publication
                const kind = $d84dc1a5e217b32f$export$13921ac0cc260818.kindFromProto(ti.type);
                if (!kind) return;
                publication = new $d84dc1a5e217b32f$export$c89ab28402142c29(kind, ti, (_a = this.signalClient.connectOptions) === null || _a === void 0 ? void 0 : _a.autoSubscribe, {
                    loggerContextCb: ()=>this.logContext,
                    loggerName: (_b = this.loggerOptions) === null || _b === void 0 ? void 0 : _b.loggerName
                });
                publication.updateInfo(ti);
                newTracks.set(ti.sid, publication);
                const existingTrackOfSource = Array.from(this.trackPublications.values()).find((publishedTrack)=>publishedTrack.source === (publication === null || publication === void 0 ? void 0 : publication.source));
                if (existingTrackOfSource && publication.source !== $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Unknown) this.log.debug("received a second track publication for ".concat(this.identity, " with the same source: ").concat(publication.source), Object.assign(Object.assign({}, this.logContext), {
                    oldTrack: $d84dc1a5e217b32f$var$getLogContextFromTrack(existingTrackOfSource),
                    newTrack: $d84dc1a5e217b32f$var$getLogContextFromTrack(publication)
                }));
                this.addTrackPublication(publication);
            } else publication.updateInfo(ti);
            validTracks.set(ti.sid, publication);
        });
        // detect removed tracks
        this.trackPublications.forEach((publication)=>{
            if (!validTracks.has(publication.trackSid)) {
                this.log.trace("detected removed track on remote participant, unpublishing", Object.assign(Object.assign({}, this.logContext), $d84dc1a5e217b32f$var$getLogContextFromTrack(publication)));
                this.unpublishTrack(publication.trackSid, true);
            }
        });
        // always emit events for new publications, Room will not forward them unless it's ready
        newTracks.forEach((publication)=>{
            this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackPublished, publication);
        });
        return true;
    }
    /** @internal */ unpublishTrack(sid, sendUnpublish) {
        const publication = this.trackPublications.get(sid);
        if (!publication) return;
        // also send unsubscribe, if track is actively subscribed
        const { track: track } = publication;
        if (track) {
            track.stop();
            publication.setTrack(undefined);
        }
        // remove track from maps only after unsubscribed has been fired
        this.trackPublications.delete(sid);
        // remove from the right type map
        switch(publication.kind){
            case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio:
                this.audioTrackPublications.delete(sid);
                break;
            case $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video:
                this.videoTrackPublications.delete(sid);
                break;
        }
        if (sendUnpublish) this.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnpublished, publication);
    }
    /**
   * @internal
   */ setAudioOutput(output) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            this.audioOutput = output;
            const promises = [];
            this.audioTrackPublications.forEach((pub)=>{
                var _a;
                if (pub.track instanceof $d84dc1a5e217b32f$export$fd37b116bd840ced) promises.push(pub.track.setSinkId((_a = output.deviceId) !== null && _a !== void 0 ? _a : "default"));
            });
            yield Promise.all(promises);
        });
    }
    /** @internal */ emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.log.trace("participant event", Object.assign(Object.assign({}, this.logContext), {
            event: event,
            args: args
        }));
        return super.emit(event, ...args);
    }
}
var $d84dc1a5e217b32f$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState["Disconnected"] = "disconnected";
    ConnectionState["Connecting"] = "connecting";
    ConnectionState["Connected"] = "connected";
    ConnectionState["Reconnecting"] = "reconnecting";
    ConnectionState["SignalReconnecting"] = "signalReconnecting";
})($d84dc1a5e217b32f$export$cd9c3c6bf535afc9 || ($d84dc1a5e217b32f$export$cd9c3c6bf535afc9 = {}));
const $d84dc1a5e217b32f$var$connectionReconcileFrequency = 4000;
/**
 * In LiveKit, a room is the logical grouping for a list of participants.
 * Participants in a room can publish tracks, and subscribe to others' tracks.
 *
 * a Room fires [[RoomEvent | RoomEvents]].
 *
 * @noInheritDoc
 */ class $d84dc1a5e217b32f$export$525628e68e798fb4 extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    /**
   * Creates a new Room, the primary construct for a LiveKit session.
   * @param options
   */ constructor(options){
        var _this;
        var _a, _b, _c;
        super();
        _this = this;
        this.state = $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected;
        /**
     * list of participants that are actively speaking. when this changes
     * a [[RoomEvent.ActiveSpeakersChanged]] event is fired
     */ this.activeSpeakers = [];
        /** reflects the sender encryption status of the local participant */ this.isE2EEEnabled = false;
        this.audioEnabled = true;
        this.isVideoPlaybackBlocked = false;
        this.log = $d84dc1a5e217b32f$var$livekitLogger;
        this.bufferedEvents = [];
        this.isResuming = false;
        this.connect = (url, token, opts)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (!$d84dc1a5e217b32f$export$3fe402ec04821f17()) {
                    if ($d84dc1a5e217b32f$var$isReactNative()) throw Error("WebRTC isn't detected, have you called registerGlobals?");
                    else throw Error("LiveKit doesn't seem to be supported on this browser. Try to update your browser and make sure no browser extensions are disabling webRTC.");
                }
                // In case a disconnect called happened right before the connect call, make sure the disconnect is completed first by awaiting its lock
                const unlockDisconnect = yield this.disconnectLock.lock();
                if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected) {
                    // when the state is reconnecting or connected, this function returns immediately
                    this.log.info("already connected to room ".concat(this.name), this.logContext);
                    unlockDisconnect();
                    return Promise.resolve();
                }
                if (this.connectFuture) {
                    unlockDisconnect();
                    return this.connectFuture.promise;
                }
                this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connecting);
                if (((_a = this.regionUrlProvider) === null || _a === void 0 ? void 0 : _a.getServerUrl().toString()) !== url) {
                    this.regionUrl = undefined;
                    this.regionUrlProvider = undefined;
                }
                if ($d84dc1a5e217b32f$var$isCloud(new URL(url))) {
                    if (this.regionUrlProvider === undefined) this.regionUrlProvider = new $d84dc1a5e217b32f$var$RegionUrlProvider(url, token);
                    else this.regionUrlProvider.updateToken(token);
                    // trigger the first fetch without waiting for a response
                    // if initial connection fails, this will speed up picking regional url
                    // on subsequent runs
                    this.regionUrlProvider.fetchRegionSettings().then((settings)=>{
                        var _a;
                        (_a = this.regionUrlProvider) === null || _a === void 0 || _a.setServerReportedRegions(settings);
                    }).catch((e)=>{
                        this.log.warn("could not fetch region settings", Object.assign(Object.assign({}, this.logContext), {
                            error: e
                        }));
                    });
                }
                const connectFn = (resolve, reject, regionUrl)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                        var _a, _b;
                        if (this.abortController) this.abortController.abort();
                        // explicit creation as local var needed to satisfy TS compiler when passing it to `attemptConnection` further down
                        const abortController = new AbortController();
                        this.abortController = abortController;
                        // at this point the intention to connect has been signalled so we can allow cancelling of the connection via disconnect() again
                        unlockDisconnect === null || unlockDisconnect === void 0 || unlockDisconnect();
                        try {
                            yield this.attemptConnection(regionUrl !== null && regionUrl !== void 0 ? regionUrl : url, token, opts, abortController);
                            this.abortController = undefined;
                            resolve();
                        } catch (e) {
                            if (this.regionUrlProvider && e instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb && e.reason !== $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled && e.reason !== $d84dc1a5e217b32f$export$61182a0b21436b65.NotAllowed) {
                                let nextUrl = null;
                                try {
                                    nextUrl = yield this.regionUrlProvider.getNextBestRegionUrl((_a = this.abortController) === null || _a === void 0 ? void 0 : _a.signal);
                                } catch (error) {
                                    if (error instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb && (error.status === 401 || error.reason === $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled)) {
                                        this.handleDisconnect(this.options.stopLocalTrackOnUnpublish);
                                        reject(error);
                                        return;
                                    }
                                }
                                if (nextUrl && !((_b = this.abortController) === null || _b === void 0 ? void 0 : _b.signal.aborted)) {
                                    this.log.info("Initial connection failed with ConnectionError: ".concat(e.message, ". Retrying with another region: ").concat(nextUrl), this.logContext);
                                    this.recreateEngine();
                                    yield connectFn(resolve, reject, nextUrl);
                                } else {
                                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $d84dc1a5e217b32f$var$getDisconnectReasonFromConnectionError(e));
                                    reject(e);
                                }
                            } else {
                                let disconnectReason = $d84dc1a5e217b32f$export$258d16488300d83f.UNKNOWN_REASON;
                                if (e instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb) disconnectReason = $d84dc1a5e217b32f$var$getDisconnectReasonFromConnectionError(e);
                                this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, disconnectReason);
                                reject(e);
                            }
                        }
                    });
                const regionUrl = this.regionUrl;
                this.regionUrl = undefined;
                this.connectFuture = new $d84dc1a5e217b32f$var$Future((resolve, reject)=>{
                    connectFn(resolve, reject, regionUrl);
                }, ()=>{
                    this.clearConnectionFutures();
                });
                return this.connectFuture.promise;
            });
        this.connectSignal = (url, token, engine, connectOptions, roomOptions, abortController)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c;
                const joinResponse = yield engine.join(url, token, {
                    autoSubscribe: connectOptions.autoSubscribe,
                    adaptiveStream: typeof roomOptions.adaptiveStream === "object" ? true : roomOptions.adaptiveStream,
                    maxRetries: connectOptions.maxRetries,
                    e2eeEnabled: !!this.e2eeManager,
                    websocketTimeout: connectOptions.websocketTimeout
                }, abortController.signal);
                let serverInfo = joinResponse.serverInfo;
                if (!serverInfo) serverInfo = {
                    version: joinResponse.serverVersion,
                    region: joinResponse.serverRegion
                };
                this.serverInfo = serverInfo;
                this.log.debug("connected to Livekit Server ".concat(Object.entries(serverInfo).map((_ref)=>{
                    let [key, value] = _ref;
                    return "".concat(key, ": ").concat(value);
                }).join(", ")), {
                    room: (_a = joinResponse.room) === null || _a === void 0 ? void 0 : _a.name,
                    roomSid: (_b = joinResponse.room) === null || _b === void 0 ? void 0 : _b.sid,
                    identity: (_c = joinResponse.participant) === null || _c === void 0 ? void 0 : _c.identity
                });
                if (!serverInfo.version) throw new $d84dc1a5e217b32f$export$4d307571a351c50c("unknown server version");
                if (serverInfo.version === "0.15.1" && this.options.dynacast) {
                    this.log.debug("disabling dynacast due to server version", this.logContext);
                    // dynacast has a bug in 0.15.1, so we cannot use it then
                    roomOptions.dynacast = false;
                }
                return joinResponse;
            });
        this.applyJoinResponse = (joinResponse)=>{
            const pi = joinResponse.participant;
            this.localParticipant.sid = pi.sid;
            this.localParticipant.identity = pi.identity;
            this.localParticipant.setEnabledPublishCodecs(joinResponse.enabledPublishCodecs);
            if (this.options.e2ee && this.e2eeManager) try {
                this.e2eeManager.setSifTrailer(joinResponse.sifTrailer);
            } catch (e) {
                this.log.error(e instanceof Error ? e.message : "Could not set SifTrailer", Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
            // populate remote participants, these should not trigger new events
            this.handleParticipantUpdates([
                pi,
                ...joinResponse.otherParticipants
            ]);
            if (joinResponse.room) this.handleRoomUpdate(joinResponse.room);
        };
        this.attemptConnection = (url, token, opts, abortController)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || ((_a = this.engine) === null || _a === void 0 ? void 0 : _a.pendingReconnect)) {
                    this.log.info("Reconnection attempt replaced by new connection attempt", this.logContext);
                    // make sure we close and recreate the existing engine in order to get rid of any potentially ongoing reconnection attempts
                    this.recreateEngine();
                } else // create engine if previously disconnected
                this.maybeCreateEngine();
                if ((_b = this.regionUrlProvider) === null || _b === void 0 ? void 0 : _b.isCloud()) this.engine.setRegionUrlProvider(this.regionUrlProvider);
                this.acquireAudioContext();
                this.connOptions = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$roomConnectOptionDefaults), opts);
                if (this.connOptions.rtcConfig) this.engine.rtcConfig = this.connOptions.rtcConfig;
                if (this.connOptions.peerConnectionTimeout) this.engine.peerConnectionTimeout = this.connOptions.peerConnectionTimeout;
                try {
                    const joinResponse = yield this.connectSignal(url, token, this.engine, this.connOptions, this.options, abortController);
                    this.applyJoinResponse(joinResponse);
                    // forward metadata changed for the local participant
                    this.setupLocalParticipantEvents();
                    this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalConnected);
                } catch (err) {
                    yield this.engine.close();
                    this.recreateEngine();
                    const resultingError = new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("could not establish signal connection", $d84dc1a5e217b32f$export$61182a0b21436b65.ServerUnreachable);
                    if (err instanceof Error) resultingError.message = "".concat(resultingError.message, ": ").concat(err.message);
                    if (err instanceof $d84dc1a5e217b32f$export$a3747c6e46c7a8eb) {
                        resultingError.reason = err.reason;
                        resultingError.status = err.status;
                    }
                    this.log.debug("error trying to establish signal connection", Object.assign(Object.assign({}, this.logContext), {
                        error: err
                    }));
                    throw resultingError;
                }
                if (abortController.signal.aborted) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Connection attempt aborted", $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled);
                }
                try {
                    yield this.engine.waitForPCInitialConnection(this.connOptions.peerConnectionTimeout, abortController);
                } catch (e) {
                    yield this.engine.close();
                    this.recreateEngine();
                    throw e;
                }
                // also hook unload event
                if ($d84dc1a5e217b32f$var$isWeb() && this.options.disconnectOnPageLeave) {
                    // capturing both 'pagehide' and 'beforeunload' to capture broadest set of browser behaviors
                    window.addEventListener("pagehide", this.onPageLeave);
                    window.addEventListener("beforeunload", this.onPageLeave);
                }
                if ($d84dc1a5e217b32f$var$isWeb()) document.addEventListener("freeze", this.onPageLeave);
                this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected);
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Connected);
                this.registerConnectionReconcile();
            });
        /**
     * disconnects the room, emits [[RoomEvent.Disconnected]]
     */ this.disconnect = function() {
            for(var _len = arguments.length, args_1 = new Array(_len), _key = 0; _key < _len; _key++)args_1[_key] = arguments[_key];
            return $d84dc1a5e217b32f$var$__awaiter(_this, [
                ...args_1
            ], void 0, function() {
                var _this2 = this;
                let stopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                return function*() {
                    var _a, _b, _c, _d;
                    const unlock = yield _this2.disconnectLock.lock();
                    try {
                        if (_this2.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) {
                            _this2.log.debug("already disconnected", _this2.logContext);
                            return;
                        }
                        _this2.log.info("disconnect from room", Object.assign({}, _this2.logContext));
                        if (_this2.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connecting || _this2.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting || _this2.isResuming) {
                            // try aborting pending connection attempt
                            _this2.log.warn("abort connection attempt", _this2.logContext);
                            (_a = _this2.abortController) === null || _a === void 0 || _a.abort();
                            // in case the abort controller didn't manage to cancel the connection attempt, reject the connect promise explicitly
                            (_c = (_b = _this2.connectFuture) === null || _b === void 0 ? void 0 : _b.reject) === null || _c === void 0 || _c.call(_b, new $d84dc1a5e217b32f$export$a3747c6e46c7a8eb("Client initiated disconnect", $d84dc1a5e217b32f$export$61182a0b21436b65.Cancelled));
                            _this2.connectFuture = undefined;
                        }
                        // send leave
                        if (!((_d = _this2.engine) === null || _d === void 0 ? void 0 : _d.client.isDisconnected)) yield _this2.engine.client.sendLeave();
                        // close engine (also closes client)
                        if (_this2.engine) yield _this2.engine.close();
                        _this2.handleDisconnect(stopTracks, $d84dc1a5e217b32f$export$258d16488300d83f.CLIENT_INITIATED);
                        /* @ts-ignore */ _this2.engine = undefined;
                    } finally{
                        unlock();
                    }
                }();
            });
        };
        this.onPageLeave = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.log.info("Page leave detected, disconnecting", this.logContext);
                yield this.disconnect();
            });
        /**
     * Browsers have different policies regarding audio playback. Most requiring
     * some form of user interaction (click/tap/etc).
     * In those cases, audio will be silent until a click/tap triggering one of the following
     * - `startAudio`
     * - `getUserMedia`
     */ this.startAudio = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
                if (browser && browser.os === "iOS") {
                    /**
         * iOS blocks audio element playback if
         * - user is not publishing audio themselves and
         * - no other audio source is playing
         *
         * as a workaround, we create an audio element with an empty track, so that
         * silent audio is always playing
         */ const audioId = "livekit-dummy-audio-el";
                    let dummyAudioEl = document.getElementById(audioId);
                    if (!dummyAudioEl) {
                        dummyAudioEl = document.createElement("audio");
                        dummyAudioEl.id = audioId;
                        dummyAudioEl.autoplay = true;
                        dummyAudioEl.hidden = true;
                        const track = $d84dc1a5e217b32f$export$59e276d6841f735c();
                        track.enabled = true;
                        const stream = new MediaStream([
                            track
                        ]);
                        dummyAudioEl.srcObject = stream;
                        document.addEventListener("visibilitychange", ()=>{
                            if (!dummyAudioEl) return;
                            // set the srcObject to null on page hide in order to prevent lock screen controls to show up for it
                            dummyAudioEl.srcObject = document.hidden ? null : stream;
                            if (!document.hidden) {
                                this.log.debug("page visible again, triggering startAudio to resume playback and update playback status", this.logContext);
                                this.startAudio();
                            }
                        });
                        document.body.append(dummyAudioEl);
                        this.once($d84dc1a5e217b32f$export$3159c672e3b2293a.Disconnected, ()=>{
                            dummyAudioEl === null || dummyAudioEl === void 0 || dummyAudioEl.remove();
                            dummyAudioEl = null;
                        });
                    }
                    elements.push(dummyAudioEl);
                }
                this.remoteParticipants.forEach((p)=>{
                    p.audioTrackPublications.forEach((t)=>{
                        if (t.track) t.track.attachedElements.forEach((e)=>{
                            elements.push(e);
                        });
                    });
                });
                try {
                    yield Promise.all([
                        this.acquireAudioContext(),
                        ...elements.map((e)=>{
                            e.muted = false;
                            return e.play();
                        })
                    ]);
                    this.handleAudioPlaybackStarted();
                } catch (err) {
                    this.handleAudioPlaybackFailed(err);
                    throw err;
                }
            });
        this.startVideo = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                const elements = [];
                for (const p of this.remoteParticipants.values())p.videoTrackPublications.forEach((tr)=>{
                    var _a;
                    (_a = tr.track) === null || _a === void 0 || _a.attachedElements.forEach((el)=>{
                        if (!elements.includes(el)) elements.push(el);
                    });
                });
                yield Promise.all(elements.map((el)=>el.play())).then(()=>{
                    this.handleVideoPlaybackStarted();
                }).catch((e)=>{
                    if (e.name === "NotAllowedError") this.handleVideoPlaybackFailed();
                    else this.log.warn("Resuming video playback failed, make sure you call `startVideo` directly in a user gesture handler", this.logContext);
                });
            });
        this.handleRestarting = ()=>{
            this.clearConnectionReconcile();
            // in case we went from resuming to full-reconnect, make sure to reflect it on the isResuming flag
            this.isResuming = false;
            // also unwind existing participants & existing subscriptions
            for (const p of this.remoteParticipants.values())this.handleParticipantDisconnected(p.identity, p);
            if (this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnecting);
        };
        this.handleSignalRestarted = (joinResponse)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                this.log.debug("signal reconnected to server, region ".concat(joinResponse.serverRegion), Object.assign(Object.assign({}, this.logContext), {
                    region: joinResponse.serverRegion
                }));
                this.bufferedEvents = [];
                this.applyJoinResponse(joinResponse);
                try {
                    // unpublish & republish tracks
                    yield this.localParticipant.republishAllTracks(undefined, true);
                } catch (error) {
                    this.log.error("error trying to re-publish tracks after reconnection", Object.assign(Object.assign({}, this.logContext), {
                        error: error
                    }));
                }
                try {
                    yield this.engine.waitForRestarted();
                    this.log.debug("fully reconnected to server", Object.assign(Object.assign({}, this.logContext), {
                        region: joinResponse.serverRegion
                    }));
                } catch (_a) {
                    // reconnection failed, handleDisconnect is being invoked already, just return here
                    return;
                }
                this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected);
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnected);
                this.registerConnectionReconcile();
                this.emitBufferedEvents();
            });
        this.handleParticipantUpdates = (participantInfos)=>{
            // handle changes to participant state, and send events
            participantInfos.forEach((info)=>{
                var _a;
                if (info.identity === this.localParticipant.identity) {
                    this.localParticipant.updateInfo(info);
                    return;
                }
                // LiveKit server doesn't send identity info prior to version 1.5.2 in disconnect updates
                // so we try to map an empty identity to an already known sID manually
                if (info.identity === "") info.identity = (_a = this.sidToIdentity.get(info.sid)) !== null && _a !== void 0 ? _a : "";
                let remoteParticipant = this.remoteParticipants.get(info.identity);
                // when it's disconnected, send updates
                if (info.state === $d84dc1a5e217b32f$var$ParticipantInfo_State.DISCONNECTED) this.handleParticipantDisconnected(info.identity, remoteParticipant);
                else // create participant if doesn't exist
                remoteParticipant = this.getOrCreateParticipant(info.identity, info);
            });
        };
        // updates are sent only when there's a change to speaker ordering
        this.handleActiveSpeakersUpdate = (speakers)=>{
            const activeSpeakers = [];
            const seenSids = {};
            speakers.forEach((speaker)=>{
                seenSids[speaker.sid] = true;
                if (speaker.sid === this.localParticipant.sid) {
                    this.localParticipant.audioLevel = speaker.level;
                    this.localParticipant.setIsSpeaking(true);
                    activeSpeakers.push(this.localParticipant);
                } else {
                    const p = this.getRemoteParticipantBySid(speaker.sid);
                    if (p) {
                        p.audioLevel = speaker.level;
                        p.setIsSpeaking(true);
                        activeSpeakers.push(p);
                    }
                }
            });
            if (!seenSids[this.localParticipant.sid]) {
                this.localParticipant.audioLevel = 0;
                this.localParticipant.setIsSpeaking(false);
            }
            this.remoteParticipants.forEach((p)=>{
                if (!seenSids[p.sid]) {
                    p.audioLevel = 0;
                    p.setIsSpeaking(false);
                }
            });
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        // process list of changed speakers
        this.handleSpeakersChanged = (speakerUpdates)=>{
            const lastSpeakers = new Map();
            this.activeSpeakers.forEach((p)=>{
                const remoteParticipant = this.remoteParticipants.get(p.identity);
                if (remoteParticipant && remoteParticipant.sid !== p.sid) return;
                lastSpeakers.set(p.sid, p);
            });
            speakerUpdates.forEach((speaker)=>{
                let p = this.getRemoteParticipantBySid(speaker.sid);
                if (speaker.sid === this.localParticipant.sid) p = this.localParticipant;
                if (!p) return;
                p.audioLevel = speaker.level;
                p.setIsSpeaking(speaker.active);
                if (speaker.active) lastSpeakers.set(speaker.sid, p);
                else lastSpeakers.delete(speaker.sid);
            });
            const activeSpeakers = Array.from(lastSpeakers.values());
            activeSpeakers.sort((a, b)=>b.audioLevel - a.audioLevel);
            this.activeSpeakers = activeSpeakers;
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveSpeakersChanged, activeSpeakers);
        };
        this.handleStreamStateUpdate = (streamStateUpdate)=>{
            streamStateUpdate.streamStates.forEach((streamState)=>{
                const participant = this.getRemoteParticipantBySid(streamState.participantSid);
                if (!participant) return;
                const pub = participant.getTrackPublicationBySid(streamState.trackSid);
                if (!pub || !pub.track) return;
                const newStreamState = $d84dc1a5e217b32f$export$13921ac0cc260818.streamStateFromProto(streamState.state);
                if (newStreamState !== pub.track.streamState) {
                    pub.track.streamState = newStreamState;
                    participant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackStreamStateChanged, pub, pub.track.streamState);
                    this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackStreamStateChanged, pub, pub.track.streamState, participant);
                }
            });
        };
        this.handleSubscriptionPermissionUpdate = (update)=>{
            const participant = this.getRemoteParticipantBySid(update.participantSid);
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setAllowed(update.allowed);
        };
        this.handleSubscriptionError = (update)=>{
            const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.trackPublications.has(update.trackSid));
            if (!participant) return;
            const pub = participant.getTrackPublicationBySid(update.trackSid);
            if (!pub) return;
            pub.setSubscriptionError(update.err);
        };
        this.handleDataPacket = (packet)=>{
            // find the participant
            const participant = this.remoteParticipants.get(packet.participantIdentity);
            if (packet.value.case === "user") this.handleUserPacket(participant, packet.value.value, packet.kind);
            else if (packet.value.case === "transcription") this.handleTranscription(participant, packet.value.value);
            else if (packet.value.case === "sipDtmf") this.handleSipDtmf(participant, packet.value.value);
            else if (packet.value.case === "chatMessage") this.handleChatMessage(participant, packet.value.value);
            else if (packet.value.case === "metrics") this.handleMetrics(packet.value.value, participant);
        };
        this.handleUserPacket = (participant, userPacket, kind)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.DataReceived, userPacket.payload, participant, kind, userPacket.topic);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.DataReceived, userPacket.payload, kind);
        };
        this.handleSipDtmf = (participant, dtmf)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.SipDTMFReceived, dtmf, participant);
            // also emit on the participant
            participant === null || participant === void 0 || participant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.SipDTMFReceived, dtmf);
        };
        this.bufferedSegments = new Map();
        this.handleTranscription = (_remoteParticipant, transcription)=>{
            // find the participant
            const participant = transcription.transcribedParticipantIdentity === this.localParticipant.identity ? this.localParticipant : this.getParticipantByIdentity(transcription.transcribedParticipantIdentity);
            const publication = participant === null || participant === void 0 ? void 0 : participant.trackPublications.get(transcription.trackId);
            const segments = $d84dc1a5e217b32f$var$extractTranscriptionSegments(transcription, this.transcriptionReceivedTimes);
            publication === null || publication === void 0 || publication.emit($d84dc1a5e217b32f$export$2c8510d737cc09da.TranscriptionReceived, segments);
            participant === null || participant === void 0 || participant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TranscriptionReceived, segments, publication);
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TranscriptionReceived, segments, participant, publication);
        };
        this.handleChatMessage = (participant, chatMessage)=>{
            const msg = $d84dc1a5e217b32f$var$extractChatMessage(chatMessage);
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ChatMessage, msg, participant);
        };
        this.handleMetrics = (metrics, participant)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.MetricsReceived, metrics, participant);
        };
        this.handleAudioPlaybackStarted = ()=>{
            if (this.canPlaybackAudio) return;
            this.audioEnabled = true;
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.AudioPlaybackStatusChanged, true);
        };
        this.handleAudioPlaybackFailed = (e)=>{
            this.log.warn("could not playback audio", Object.assign(Object.assign({}, this.logContext), {
                error: e
            }));
            if (!this.canPlaybackAudio) return;
            this.audioEnabled = false;
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.AudioPlaybackStatusChanged, false);
        };
        this.handleVideoPlaybackStarted = ()=>{
            if (this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = false;
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.VideoPlaybackStatusChanged, true);
            }
        };
        this.handleVideoPlaybackFailed = ()=>{
            if (!this.isVideoPlaybackBlocked) {
                this.isVideoPlaybackBlocked = true;
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.VideoPlaybackStatusChanged, false);
            }
        };
        this.handleDeviceChange = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                const previousDevices = $d84dc1a5e217b32f$var$DeviceManager.getInstance().previousDevices;
                // check for available devices, but don't request permissions in order to avoid prompts for kinds that haven't been used before
                const availableDevices = yield $d84dc1a5e217b32f$var$DeviceManager.getInstance().getDevices(undefined, false);
                const browser = $d84dc1a5e217b32f$export$89e15fc796a4a429();
                if ((browser === null || browser === void 0 ? void 0 : browser.name) === "Chrome" && browser.os !== "iOS") for (let availableDevice of availableDevices){
                    const previousDevice = previousDevices.find((info)=>info.deviceId === availableDevice.deviceId);
                    if (previousDevice && previousDevice.label !== "" && previousDevice.kind === availableDevice.kind && previousDevice.label !== availableDevice.label) // label has changed on device the same deviceId, indicating that the default device has changed on the OS level
                    {
                        if (this.getActiveDevice(availableDevice.kind) === "default") // emit an active device change event only if the selected output device is actually on `default`
                        this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveDeviceChanged, availableDevice.kind, availableDevice.deviceId);
                    }
                }
                // inputs are automatically handled via TrackEvent.Ended causing a TrackEvent.Restarted. Here we only need to worry about audiooutputs changing
                const kinds = [
                    "audiooutput",
                    "audioinput",
                    "videoinput"
                ];
                for (let kind of kinds){
                    const devicesOfKind = availableDevices.filter((d)=>d.kind === kind);
                    const activeDevice = this.getActiveDevice(kind);
                    if (activeDevice === ((_a = previousDevices.filter((info)=>info.kind === kind)[0]) === null || _a === void 0 ? void 0 : _a.deviceId)) // in  Safari the first device is always the default, so we assume a user on the default device would like to switch to the default once it changes
                    // FF doesn't emit an event when the default device changes, so we perform the same best effort and switch to the new device once connected and if it's the first in the array
                    {
                        if (devicesOfKind.length > 0 && ((_b = devicesOfKind[0]) === null || _b === void 0 ? void 0 : _b.deviceId) !== activeDevice) {
                            yield this.switchActiveDevice(kind, devicesOfKind[0].deviceId);
                            continue;
                        }
                    }
                    if (kind === "audioinput" && !$d84dc1a5e217b32f$var$isSafari() || kind === "videoinput") continue;
                    // switch to first available device if previously active device is not available any more
                    if (devicesOfKind.length > 0 && !devicesOfKind.find((deviceInfo)=>deviceInfo.deviceId === this.getActiveDevice(kind))) yield this.switchActiveDevice(kind, devicesOfKind[0].deviceId);
                }
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.MediaDevicesChanged);
            });
        this.handleRoomUpdate = (room)=>{
            const oldRoom = this.roomInfo;
            this.roomInfo = room;
            if (oldRoom && oldRoom.metadata !== room.metadata) this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.RoomMetadataChanged, room.metadata);
            if ((oldRoom === null || oldRoom === void 0 ? void 0 : oldRoom.activeRecording) !== room.activeRecording) this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.RecordingStatusChanged, room.activeRecording);
        };
        this.handleConnectionQualityUpdate = (update)=>{
            update.updates.forEach((info)=>{
                if (info.participantSid === this.localParticipant.sid) {
                    this.localParticipant.setConnectionQuality(info.quality);
                    return;
                }
                const participant = this.getRemoteParticipantBySid(info.participantSid);
                if (participant) participant.setConnectionQuality(info.quality);
            });
        };
        this.onLocalParticipantMetadataChanged = (metadata)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, this.localParticipant);
        };
        this.onLocalParticipantNameChanged = (name)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantNameChanged, name, this.localParticipant);
        };
        this.onLocalAttributesChanged = (changedAttributes)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, this.localParticipant);
        };
        this.onLocalTrackMuted = (pub)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackMuted, pub, this.localParticipant);
        };
        this.onLocalTrackUnmuted = (pub)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackUnmuted, pub, this.localParticipant);
        };
        this.onTrackProcessorUpdate = (processor)=>{
            var _a;
            (_a = processor === null || processor === void 0 ? void 0 : processor.onPublish) === null || _a === void 0 || _a.call(processor, this);
        };
        this.onLocalTrackPublished = (pub)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c, _d, _e, _f;
                (_a = pub.track) === null || _a === void 0 || _a.on($d84dc1a5e217b32f$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
                (_b = pub.track) === null || _b === void 0 || _b.on($d84dc1a5e217b32f$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
                (_e = (_d = (_c = pub.track) === null || _c === void 0 ? void 0 : _c.getProcessor()) === null || _d === void 0 ? void 0 : _d.onPublish) === null || _e === void 0 || _e.call(_d, this);
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.LocalTrackPublished, pub, this.localParticipant);
                if (pub.track instanceof $d84dc1a5e217b32f$export$b287427b771ca237) {
                    const trackIsSilent = yield pub.track.checkForSilence();
                    if (trackIsSilent) this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.LocalAudioSilenceDetected, pub);
                }
                const deviceId = yield (_f = pub.track) === null || _f === void 0 ? void 0 : _f.getDeviceId(false);
                const deviceKind = $d84dc1a5e217b32f$var$sourceToKind(pub.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalTrackUnpublished = (pub)=>{
            var _a, _b;
            (_a = pub.track) === null || _a === void 0 || _a.off($d84dc1a5e217b32f$export$2c8510d737cc09da.TrackProcessorUpdate, this.onTrackProcessorUpdate);
            (_b = pub.track) === null || _b === void 0 || _b.off($d84dc1a5e217b32f$export$2c8510d737cc09da.Restarted, this.onLocalTrackRestarted);
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.LocalTrackUnpublished, pub, this.localParticipant);
        };
        this.onLocalTrackRestarted = (track)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                const deviceId = yield track.getDeviceId(false);
                const deviceKind = $d84dc1a5e217b32f$var$sourceToKind(track.source);
                if (deviceKind && deviceId && deviceId !== this.localParticipant.activeDeviceMap.get(deviceKind)) {
                    this.log.debug("local track restarted, setting ".concat(deviceKind, " ").concat(deviceId, " active"), this.logContext);
                    this.localParticipant.activeDeviceMap.set(deviceKind, deviceId);
                    this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveDeviceChanged, deviceKind, deviceId);
                }
            });
        this.onLocalConnectionQualityChanged = (quality)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ConnectionQualityChanged, quality, this.localParticipant);
        };
        this.onMediaDevicesError = (e)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.MediaDevicesError, e);
        };
        this.onLocalParticipantPermissionsChanged = (prevPermissions)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, this.localParticipant);
        };
        this.onLocalChatMessageSent = (msg)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ChatMessage, msg, this.localParticipant);
        };
        this.setMaxListeners(100);
        this.remoteParticipants = new Map();
        this.sidToIdentity = new Map();
        this.options = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$roomOptionDefaults), options);
        this.log = $d84dc1a5e217b32f$export$2b1d391cd05230fd((_a = this.options.loggerName) !== null && _a !== void 0 ? _a : $d84dc1a5e217b32f$export$69ba24dd79f4da21.Room);
        this.transcriptionReceivedTimes = new Map();
        this.options.audioCaptureDefaults = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$audioDefaults), options === null || options === void 0 ? void 0 : options.audioCaptureDefaults);
        this.options.videoCaptureDefaults = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$videoDefaults), options === null || options === void 0 ? void 0 : options.videoCaptureDefaults);
        this.options.publishDefaults = Object.assign(Object.assign({}, $d84dc1a5e217b32f$var$publishDefaults), options === null || options === void 0 ? void 0 : options.publishDefaults);
        this.maybeCreateEngine();
        this.disconnectLock = new $d84dc1a5e217b32f$export$ca12f2943758ef55();
        this.localParticipant = new $d84dc1a5e217b32f$export$ed007fa30041dd89("", "", this.engine, this.options);
        if (this.options.videoCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set("videoinput", $d84dc1a5e217b32f$var$unwrapConstraint(this.options.videoCaptureDefaults.deviceId));
        if (this.options.audioCaptureDefaults.deviceId) this.localParticipant.activeDeviceMap.set("audioinput", $d84dc1a5e217b32f$var$unwrapConstraint(this.options.audioCaptureDefaults.deviceId));
        if ((_b = this.options.audioOutput) === null || _b === void 0 ? void 0 : _b.deviceId) this.switchActiveDevice("audiooutput", $d84dc1a5e217b32f$var$unwrapConstraint(this.options.audioOutput.deviceId)).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message), this.logContext));
        if (this.options.e2ee) this.setupE2EE();
        if ($d84dc1a5e217b32f$var$isWeb()) {
            const abortController = new AbortController();
            // in order to catch device changes prior to room connection we need to register the event in the constructor
            (_c = navigator.mediaDevices) === null || _c === void 0 || _c.addEventListener("devicechange", this.handleDeviceChange, {
                signal: abortController.signal
            });
            if ($d84dc1a5e217b32f$export$525628e68e798fb4.cleanupRegistry) $d84dc1a5e217b32f$export$525628e68e798fb4.cleanupRegistry.register(this, ()=>{
                abortController.abort();
            });
        }
    }
    /**
   * @experimental
   */ setE2EEEnabled(enabled) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.e2eeManager) {
                yield Promise.all([
                    this.localParticipant.setE2EEEnabled(enabled)
                ]);
                if (this.localParticipant.identity !== "") this.e2eeManager.setParticipantCryptorEnabled(enabled, this.localParticipant.identity);
            } else throw Error("e2ee not configured, please set e2ee settings within the room options");
        });
    }
    setupE2EE() {
        var _a;
        if (this.options.e2ee) {
            if ("e2eeManager" in this.options.e2ee) this.e2eeManager = this.options.e2ee.e2eeManager;
            else this.e2eeManager = new $d84dc1a5e217b32f$var$E2EEManager(this.options.e2ee);
            this.e2eeManager.on($d84dc1a5e217b32f$export$36ec54aef832f50f.ParticipantEncryptionStatusChanged, (enabled, participant)=>{
                if (participant instanceof $d84dc1a5e217b32f$export$ed007fa30041dd89) this.isE2EEEnabled = enabled;
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantEncryptionStatusChanged, enabled, participant);
            });
            this.e2eeManager.on($d84dc1a5e217b32f$export$36ec54aef832f50f.EncryptionError, (error)=>this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.EncryptionError, error));
            (_a = this.e2eeManager) === null || _a === void 0 || _a.setup(this);
        }
    }
    get logContext() {
        var _a;
        return {
            room: this.name,
            roomID: (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.sid,
            participant: this.localParticipant.identity,
            pID: this.localParticipant.sid
        };
    }
    /**
   * if the current room has a participant with `recorder: true` in its JWT grant
   **/ get isRecording() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.activeRecording) !== null && _b !== void 0 ? _b : false;
    }
    /**
   * server assigned unique room id.
   * returns once a sid has been issued by the server.
   */ getSid() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) return "";
            if (this.roomInfo && this.roomInfo.sid !== "") return this.roomInfo.sid;
            return new Promise((resolve, reject)=>{
                const handleRoomUpdate = (roomInfo)=>{
                    if (roomInfo.sid !== "") {
                        this.engine.off($d84dc1a5e217b32f$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                        resolve(roomInfo.sid);
                    }
                };
                this.engine.on($d84dc1a5e217b32f$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                this.once($d84dc1a5e217b32f$export$3159c672e3b2293a.Disconnected, ()=>{
                    this.engine.off($d84dc1a5e217b32f$export$c09e63b8572f869.RoomUpdate, handleRoomUpdate);
                    reject("Room disconnected before room server id was available");
                });
            });
        });
    }
    /** user assigned name, derived from JWT token */ get name() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
    }
    /** room metadata */ get metadata() {
        var _a;
        return (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.metadata;
    }
    get numParticipants() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numParticipants) !== null && _b !== void 0 ? _b : 0;
    }
    get numPublishers() {
        var _a, _b;
        return (_b = (_a = this.roomInfo) === null || _a === void 0 ? void 0 : _a.numPublishers) !== null && _b !== void 0 ? _b : 0;
    }
    maybeCreateEngine() {
        if (this.engine && !this.engine.isClosed) return;
        this.engine = new $d84dc1a5e217b32f$var$RTCEngine(this.options);
        this.engine.on($d84dc1a5e217b32f$export$c09e63b8572f869.ParticipantUpdate, this.handleParticipantUpdates).on($d84dc1a5e217b32f$export$c09e63b8572f869.RoomUpdate, this.handleRoomUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.SpeakersChanged, this.handleSpeakersChanged).on($d84dc1a5e217b32f$export$c09e63b8572f869.StreamStateChanged, this.handleStreamStateUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.ConnectionQualityUpdate, this.handleConnectionQualityUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.SubscriptionError, this.handleSubscriptionError).on($d84dc1a5e217b32f$export$c09e63b8572f869.SubscriptionPermissionUpdate, this.handleSubscriptionPermissionUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.MediaTrackAdded, (mediaTrack, stream, receiver)=>{
            this.onTrackAdded(mediaTrack, stream, receiver);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.Disconnected, (reason)=>{
            this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, reason);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.ActiveSpeakersUpdate, this.handleActiveSpeakersUpdate).on($d84dc1a5e217b32f$export$c09e63b8572f869.DataPacketReceived, this.handleDataPacket).on($d84dc1a5e217b32f$export$c09e63b8572f869.Resuming, ()=>{
            this.clearConnectionReconcile();
            this.isResuming = true;
            this.log.info("Resuming signal connection", this.logContext);
            if (this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.SignalReconnecting)) this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalReconnecting);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.Resumed, ()=>{
            this.registerConnectionReconcile();
            this.isResuming = false;
            this.log.info("Resumed signal connection", this.logContext);
            this.updateSubscriptions();
            this.emitBufferedEvents();
            if (this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected)) this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnected);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.SignalResumed, ()=>{
            this.bufferedEvents = [];
            if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming) this.sendSyncState();
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.Restarting, this.handleRestarting).on($d84dc1a5e217b32f$export$c09e63b8572f869.SignalRestarted, this.handleSignalRestarted).on($d84dc1a5e217b32f$export$c09e63b8572f869.Offline, ()=>{
            if (this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting)) this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnecting);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.DCBufferStatusChanged, (status, kind)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.DCBufferStatusChanged, status, kind);
        }).on($d84dc1a5e217b32f$export$c09e63b8572f869.LocalTrackSubscribed, (subscribedSid)=>{
            const trackPublication = this.localParticipant.getTrackPublications().find((_ref2)=>{
                let { trackSid: trackSid } = _ref2;
                return trackSid === subscribedSid;
            });
            if (!trackPublication) {
                this.log.warn("could not find local track subscription for subscribed event", this.logContext);
                return;
            }
            this.localParticipant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackSubscribed, trackPublication);
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.LocalTrackSubscribed, trackPublication, this.localParticipant);
        });
        if (this.localParticipant) this.localParticipant.setupEngine(this.engine);
        if (this.e2eeManager) this.e2eeManager.setupEngine(this.engine);
    }
    /**
   * getLocalDevices abstracts navigator.mediaDevices.enumerateDevices.
   * In particular, it requests device permissions by default if needed
   * and makes sure the returned device does not consist of dummy devices
   * @param kind
   * @returns a list of available local devices
   */ static getLocalDevices(kind) {
        let requestPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return $d84dc1a5e217b32f$var$DeviceManager.getInstance().getDevices(kind, requestPermissions);
    }
    /**
   * prepareConnection should be called as soon as the page is loaded, in order
   * to speed up the connection attempt. This function will
   * - perform DNS resolution and pre-warm the DNS cache
   * - establish TLS connection and cache TLS keys
   *
   * With LiveKit Cloud, it will also determine the best edge data center for
   * the current client to connect to if a token is provided.
   */ prepareConnection(url, token) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.state !== $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) return;
            this.log.debug("prepareConnection to ".concat(url), this.logContext);
            try {
                if ($d84dc1a5e217b32f$var$isCloud(new URL(url)) && token) {
                    this.regionUrlProvider = new $d84dc1a5e217b32f$var$RegionUrlProvider(url, token);
                    const regionUrl = yield this.regionUrlProvider.getNextBestRegionUrl();
                    // we will not replace the regionUrl if an attempt had already started
                    // to avoid overriding regionUrl after a new connection attempt had started
                    if (regionUrl && this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) {
                        this.regionUrl = regionUrl;
                        yield fetch($d84dc1a5e217b32f$var$toHttpUrl(regionUrl), {
                            method: "HEAD"
                        });
                        this.log.debug("prepared connection to ".concat(regionUrl), this.logContext);
                    }
                } else yield fetch($d84dc1a5e217b32f$var$toHttpUrl(url), {
                    method: "HEAD"
                });
            } catch (e) {
                this.log.warn("could not prepare connection", Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
        });
    }
    /**
   * retrieves a participant by identity
   * @param identity
   * @returns
   */ getParticipantByIdentity(identity) {
        if (this.localParticipant.identity === identity) return this.localParticipant;
        return this.remoteParticipants.get(identity);
    }
    clearConnectionFutures() {
        this.connectFuture = undefined;
    }
    /**
   * @internal for testing
   */ simulateScenario(scenario, arg) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            let postAction = ()=>{};
            let req;
            switch(scenario){
                case "signal-reconnect":
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose("simulate disconnect");
                    break;
                case "speaker":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "speakerUpdate",
                            value: 3
                        }
                    });
                    break;
                case "node-failure":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "nodeFailure",
                            value: true
                        }
                    });
                    break;
                case "server-leave":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "serverLeave",
                            value: true
                        }
                    });
                    break;
                case "migration":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "migration",
                            value: true
                        }
                    });
                    break;
                case "resume-reconnect":
                    this.engine.failNext();
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose("simulate resume-disconnect");
                    break;
                case "disconnect-signal-on-resume":
                    postAction = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose("simulate resume-disconnect");
                        });
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "disconnectSignalOnResume",
                            value: true
                        }
                    });
                    break;
                case "disconnect-signal-on-resume-no-messages":
                    postAction = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            // @ts-expect-error function is private
                            yield this.engine.client.handleOnClose("simulate resume-disconnect");
                        });
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "disconnectSignalOnResumeNoMessages",
                            value: true
                        }
                    });
                    break;
                case "full-reconnect":
                    this.engine.fullReconnectOnNext = true;
                    // @ts-expect-error function is private
                    yield this.engine.client.handleOnClose("simulate full-reconnect");
                    break;
                case "force-tcp":
                case "force-tls":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "switchCandidateProtocol",
                            value: scenario === "force-tls" ? 2 : 1
                        }
                    });
                    postAction = ()=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                            const onLeave = this.engine.client.onLeave;
                            if (onLeave) onLeave(new $d84dc1a5e217b32f$var$LeaveRequest({
                                reason: $d84dc1a5e217b32f$export$258d16488300d83f.CLIENT_INITIATED,
                                action: $d84dc1a5e217b32f$var$LeaveRequest_Action.RECONNECT
                            }));
                        });
                    break;
                case "subscriber-bandwidth":
                    if (arg === undefined || typeof arg !== "number") throw new Error("subscriber-bandwidth requires a number as argument");
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "subscriberBandwidth",
                            value: BigInt(arg)
                        }
                    });
                    break;
                case "leave-full-reconnect":
                    req = new $d84dc1a5e217b32f$var$SimulateScenario({
                        scenario: {
                            case: "leaveRequestFullReconnect",
                            value: true
                        }
                    });
            }
            if (req) {
                yield this.engine.client.sendSimulateScenario(req);
                yield postAction();
            }
        });
    }
    /**
   * Returns true if audio playback is enabled
   */ get canPlaybackAudio() {
        return this.audioEnabled;
    }
    /**
   * Returns true if video playback is enabled
   */ get canPlaybackVideo() {
        return !this.isVideoPlaybackBlocked;
    }
    getActiveDevice(kind) {
        return this.localParticipant.activeDeviceMap.get(kind);
    }
    /**
   * Switches all active devices used in this room to the given device.
   *
   * Note: setting AudioOutput is not supported on some browsers. See [setSinkId](https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId#browser_compatibility)
   *
   * @param kind use `videoinput` for camera track,
   *  `audioinput` for microphone track,
   *  `audiooutput` to set speaker for all incoming audio tracks
   * @param deviceId
   */ switchActiveDevice(kind_1, deviceId_1) {
        return $d84dc1a5e217b32f$var$__awaiter(this, arguments, void 0, function(kind, deviceId) {
            var _this3 = this;
            let exact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            return function*() {
                var _a, _b, _c, _d, _e, _f, _g;
                var _h;
                let success = true;
                let needsUpdateWithoutTracks = false;
                const deviceConstraint = exact ? {
                    exact: deviceId
                } : deviceId;
                if (kind === "audioinput") {
                    needsUpdateWithoutTracks = _this3.localParticipant.audioTrackPublications.size === 0;
                    const prevDeviceId = (_a = _this3.getActiveDevice(kind)) !== null && _a !== void 0 ? _a : _this3.options.audioCaptureDefaults.deviceId;
                    _this3.options.audioCaptureDefaults.deviceId = deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.audioTrackPublications.values()).filter((track)=>track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.audioTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.audioCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                } else if (kind === "videoinput") {
                    needsUpdateWithoutTracks = _this3.localParticipant.videoTrackPublications.size === 0;
                    const prevDeviceId = (_b = _this3.getActiveDevice(kind)) !== null && _b !== void 0 ? _b : _this3.options.videoCaptureDefaults.deviceId;
                    _this3.options.videoCaptureDefaults.deviceId = deviceConstraint;
                    const tracks = Array.from(_this3.localParticipant.videoTrackPublications.values()).filter((track)=>track.source === $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera);
                    try {
                        success = (yield Promise.all(tracks.map((t)=>{
                            var _a;
                            return (_a = t.videoTrack) === null || _a === void 0 ? void 0 : _a.setDeviceId(deviceConstraint);
                        }))).every((val)=>val === true);
                    } catch (e) {
                        _this3.options.videoCaptureDefaults.deviceId = prevDeviceId;
                        throw e;
                    }
                } else if (kind === "audiooutput") {
                    if (!$d84dc1a5e217b32f$var$supportsSetSinkId() && !_this3.options.webAudioMix || _this3.options.webAudioMix && _this3.audioContext && !("setSinkId" in _this3.audioContext)) throw new Error("cannot switch audio output, setSinkId not supported");
                    if (_this3.options.webAudioMix) // setting `default` for web audio output doesn't work, so we need to normalize the id before
                    deviceId = (_c = yield $d84dc1a5e217b32f$var$DeviceManager.getInstance().normalizeDeviceId("audiooutput", deviceId)) !== null && _c !== void 0 ? _c : "";
                    (_d = (_h = _this3.options).audioOutput) !== null && _d !== void 0 ? _d : _h.audioOutput = {};
                    const prevDeviceId = (_e = _this3.getActiveDevice(kind)) !== null && _e !== void 0 ? _e : _this3.options.audioOutput.deviceId;
                    _this3.options.audioOutput.deviceId = deviceId;
                    try {
                        if (_this3.options.webAudioMix) // @ts-expect-error setSinkId is not yet in the typescript type of AudioContext
                        (_f = _this3.audioContext) === null || _f === void 0 || _f.setSinkId(deviceId);
                        // also set audio output on all audio elements, even if webAudioMix is enabled in order to workaround echo cancellation not working on chrome with non-default output devices
                        // see https://issues.chromium.org/issues/40252911#comment7
                        yield Promise.all(Array.from(_this3.remoteParticipants.values()).map((p)=>p.setAudioOutput({
                                deviceId: deviceId
                            })));
                    } catch (e) {
                        _this3.options.audioOutput.deviceId = prevDeviceId;
                        throw e;
                    }
                }
                if (needsUpdateWithoutTracks || kind === "audiooutput") {
                    // if there are not active tracks yet or we're switching audiooutput, we need to manually update the active device map here as changing audio output won't result in a track restart
                    _this3.localParticipant.activeDeviceMap.set(kind, kind === "audiooutput" && ((_g = _this3.options.audioOutput) === null || _g === void 0 ? void 0 : _g.deviceId) || deviceId);
                    _this3.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveDeviceChanged, kind, deviceId);
                }
                return success;
            }();
        });
    }
    setupLocalParticipantEvents() {
        this.localParticipant.on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
    }
    recreateEngine() {
        var _a;
        (_a = this.engine) === null || _a === void 0 || _a.close();
        /* @ts-ignore */ this.engine = undefined;
        this.isResuming = false;
        // clear out existing remote participants, since they may have attached
        // the old engine
        this.remoteParticipants.clear();
        this.sidToIdentity.clear();
        this.bufferedEvents = [];
        this.maybeCreateEngine();
    }
    onTrackAdded(mediaTrack, stream, receiver) {
        // don't fire onSubscribed when connecting
        // WebRTC fires onTrack as soon as setRemoteDescription is called on the offer
        // at that time, ICE connectivity has not been established so the track is not
        // technically subscribed.
        // We'll defer these events until when the room is connected or eventually disconnected.
        if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connecting || this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting) {
            const reconnectedHandler = ()=>{
                this.onTrackAdded(mediaTrack, stream, receiver);
                cleanup();
            };
            const cleanup = ()=>{
                this.off($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
                this.off($d84dc1a5e217b32f$export$3159c672e3b2293a.Connected, reconnectedHandler);
                this.off($d84dc1a5e217b32f$export$3159c672e3b2293a.Disconnected, cleanup);
            };
            this.once($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnected, reconnectedHandler);
            this.once($d84dc1a5e217b32f$export$3159c672e3b2293a.Connected, reconnectedHandler);
            this.once($d84dc1a5e217b32f$export$3159c672e3b2293a.Disconnected, cleanup);
            return;
        }
        if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) {
            this.log.warn("skipping incoming track after Room disconnected", this.logContext);
            return;
        }
        const parts = $d84dc1a5e217b32f$var$unpackStreamId(stream.id);
        const participantSid = parts[0];
        let streamId = parts[1];
        let trackId = mediaTrack.id;
        // firefox will get streamId (pID|trackId) instead of (pID|streamId) as it doesn't support sync tracks by stream
        // and generates its own track id instead of infer from sdp track id.
        if (streamId && streamId.startsWith("TR")) trackId = streamId;
        if (participantSid === this.localParticipant.sid) {
            this.log.warn("tried to create RemoteParticipant for local participant", this.logContext);
            return;
        }
        const participant = Array.from(this.remoteParticipants.values()).find((p)=>p.sid === participantSid);
        if (!participant) {
            this.log.error("Tried to add a track for a participant, that's not present. Sid: ".concat(participantSid), this.logContext);
            return;
        }
        let adaptiveStreamSettings;
        if (this.options.adaptiveStream) {
            if (typeof this.options.adaptiveStream === "object") adaptiveStreamSettings = this.options.adaptiveStream;
            else adaptiveStreamSettings = {};
        }
        participant.addSubscribedMediaTrack(mediaTrack, trackId, stream, receiver, adaptiveStreamSettings);
    }
    handleDisconnect() {
        let shouldStopTracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        let reason = arguments.length > 1 ? arguments[1] : undefined;
        var _a;
        this.clearConnectionReconcile();
        this.isResuming = false;
        this.bufferedEvents = [];
        this.transcriptionReceivedTimes.clear();
        if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) return;
        this.regionUrl = undefined;
        try {
            this.remoteParticipants.forEach((p)=>{
                p.trackPublications.forEach((pub)=>{
                    p.unpublishTrack(pub.trackSid);
                });
            });
            this.localParticipant.trackPublications.forEach((pub)=>{
                var _a, _b, _c;
                if (pub.track) this.localParticipant.unpublishTrack(pub.track, shouldStopTracks);
                if (shouldStopTracks) {
                    (_a = pub.track) === null || _a === void 0 || _a.detach();
                    (_b = pub.track) === null || _b === void 0 || _b.stop();
                } else (_c = pub.track) === null || _c === void 0 || _c.stopMonitor();
            });
            this.localParticipant.off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantMetadataChanged, this.onLocalParticipantMetadataChanged).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantNameChanged, this.onLocalParticipantNameChanged).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AttributesChanged, this.onLocalAttributesChanged).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackMuted, this.onLocalTrackMuted).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnmuted, this.onLocalTrackUnmuted).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, this.onLocalTrackPublished).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackUnpublished, this.onLocalTrackUnpublished).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ConnectionQualityChanged, this.onLocalConnectionQualityChanged).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.MediaDevicesError, this.onMediaDevicesError).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AudioStreamAcquired, this.startAudio).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ChatMessage, this.onLocalChatMessageSent).off($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, this.onLocalParticipantPermissionsChanged);
            this.localParticipant.trackPublications.clear();
            this.localParticipant.videoTrackPublications.clear();
            this.localParticipant.audioTrackPublications.clear();
            this.remoteParticipants.clear();
            this.sidToIdentity.clear();
            this.activeSpeakers = [];
            if (this.audioContext && typeof this.options.webAudioMix === "boolean") {
                this.audioContext.close();
                this.audioContext = undefined;
            }
            if ($d84dc1a5e217b32f$var$isWeb()) {
                window.removeEventListener("beforeunload", this.onPageLeave);
                window.removeEventListener("pagehide", this.onPageLeave);
                window.removeEventListener("freeze", this.onPageLeave);
                (_a = navigator.mediaDevices) === null || _a === void 0 || _a.removeEventListener("devicechange", this.handleDeviceChange);
            }
        } finally{
            this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected);
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Disconnected, reason);
        }
    }
    handleParticipantDisconnected(identity, participant) {
        var _a;
        // remove and send event
        this.remoteParticipants.delete(identity);
        if (!participant) return;
        participant.trackPublications.forEach((publication)=>{
            participant.unpublishTrack(publication.trackSid, true);
        });
        this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantDisconnected, participant);
        (_a = this.localParticipant) === null || _a === void 0 || _a.handleParticipantDisconnected(participant.identity);
    }
    acquireAudioContext() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (typeof this.options.webAudioMix !== "boolean" && this.options.webAudioMix.audioContext) // override audio context with custom audio context if supplied by user
            this.audioContext = this.options.webAudioMix.audioContext;
            else if (!this.audioContext || this.audioContext.state === "closed") // by using an AudioContext, it reduces lag on audio elements
            // https://stackoverflow.com/questions/9811429/html5-audio-tag-on-safari-has-a-delay/54119854#54119854
            this.audioContext = (_a = $d84dc1a5e217b32f$var$getNewAudioContext()) !== null && _a !== void 0 ? _a : undefined;
            if (this.audioContext && this.audioContext.state === "suspended") // for iOS a newly created AudioContext is always in `suspended` state.
            // we try our best to resume the context here, if that doesn't work, we just continue with regular processing
            try {
                yield this.audioContext.resume();
            } catch (e) {
                this.log.warn("Could not resume audio context", Object.assign(Object.assign({}, this.logContext), {
                    error: e
                }));
            }
            if (this.options.webAudioMix) this.remoteParticipants.forEach((participant)=>participant.setAudioContext(this.audioContext));
            this.localParticipant.setAudioContext(this.audioContext);
            const newContextIsRunning = ((_b = this.audioContext) === null || _b === void 0 ? void 0 : _b.state) === "running";
            if (newContextIsRunning !== this.canPlaybackAudio) {
                this.audioEnabled = newContextIsRunning;
                this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.AudioPlaybackStatusChanged, newContextIsRunning);
            }
        });
    }
    createParticipant(identity, info) {
        var _a;
        let participant;
        if (info) participant = $d84dc1a5e217b32f$export$bf85b9e4f33346fe.fromParticipantInfo(this.engine.client, info, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        });
        else participant = new $d84dc1a5e217b32f$export$bf85b9e4f33346fe(this.engine.client, "", identity, undefined, undefined, undefined, {
            loggerContextCb: ()=>this.logContext,
            loggerName: this.options.loggerName
        });
        if (this.options.webAudioMix) participant.setAudioContext(this.audioContext);
        if ((_a = this.options.audioOutput) === null || _a === void 0 ? void 0 : _a.deviceId) participant.setAudioOutput(this.options.audioOutput).catch((e)=>this.log.warn("Could not set audio output: ".concat(e.message), this.logContext));
        return participant;
    }
    getOrCreateParticipant(identity, info) {
        if (this.remoteParticipants.has(identity)) {
            const existingParticipant = this.remoteParticipants.get(identity);
            if (info) {
                const wasUpdated = existingParticipant.updateInfo(info);
                if (wasUpdated) this.sidToIdentity.set(info.sid, info.identity);
            }
            return existingParticipant;
        }
        const participant = this.createParticipant(identity, info);
        this.remoteParticipants.set(identity, participant);
        this.sidToIdentity.set(info.sid, info.identity);
        // if we have valid info and the participant wasn't in the map before, we can assume the participant is new
        // firing here to make sure that `ParticipantConnected` fires before the initial track events
        this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantConnected, participant);
        // also forward events
        // trackPublished is only fired for tracks added after both local participant
        // and remote participant joined the room
        participant.on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackPublished, (trackPublication)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackPublished, trackPublication, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscribed, (track, publication)=>{
            // monitor playback status
            if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) {
                track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackStarted, this.handleAudioPlaybackStarted);
                track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.AudioPlaybackFailed, this.handleAudioPlaybackFailed);
            } else if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) {
                track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.VideoPlaybackFailed, this.handleVideoPlaybackFailed);
                track.on($d84dc1a5e217b32f$export$2c8510d737cc09da.VideoPlaybackStarted, this.handleVideoPlaybackStarted);
            }
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscribed, track, publication, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnpublished, (publication)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackUnpublished, publication, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnsubscribed, (track, publication)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackUnsubscribed, track, publication, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionFailed, (sid)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscriptionFailed, sid, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackMuted, (pub)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackMuted, pub, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackUnmuted, (pub)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackUnmuted, pub, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantMetadataChanged, (metadata)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantMetadataChanged, metadata, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantNameChanged, (name)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantNameChanged, name, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.AttributesChanged, (changedAttributes)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantAttributesChanged, changedAttributes, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ConnectionQualityChanged, (quality)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ConnectionQualityChanged, quality, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.ParticipantPermissionsChanged, (prevPermissions)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.ParticipantPermissionsChanged, prevPermissions, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionStatusChanged, (pub, status)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscriptionStatusChanged, pub, status, participant);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionFailed, (trackSid, error)=>{
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscriptionFailed, trackSid, participant, error);
        }).on($d84dc1a5e217b32f$export$fcdfe2b7a6750691.TrackSubscriptionPermissionChanged, (pub, status)=>{
            this.emitWhenConnected($d84dc1a5e217b32f$export$3159c672e3b2293a.TrackSubscriptionPermissionChanged, pub, status, participant);
        });
        // update info at the end after callbacks have been set up
        if (info) participant.updateInfo(info);
        return participant;
    }
    sendSyncState() {
        const remoteTracks = Array.from(this.remoteParticipants.values()).reduce((acc, participant)=>{
            acc.push(...participant.getTrackPublications()); // FIXME would be nice to have this return RemoteTrackPublications directly instead of the type cast
            return acc;
        }, []);
        const localTracks = this.localParticipant.getTrackPublications(); // FIXME would be nice to have this return LocalTrackPublications directly instead of the type cast
        this.engine.sendSyncState(remoteTracks, localTracks);
    }
    /**
   * After resuming, we'll need to notify the server of the current
   * subscription settings.
   */ updateSubscriptions() {
        for (const p of this.remoteParticipants.values()){
            for (const pub of p.videoTrackPublications.values())if (pub.isSubscribed && pub instanceof $d84dc1a5e217b32f$export$c89ab28402142c29) pub.emitTrackUpdate();
        }
    }
    getRemoteParticipantBySid(sid) {
        const identity = this.sidToIdentity.get(sid);
        if (identity) return this.remoteParticipants.get(identity);
    }
    registerConnectionReconcile() {
        this.clearConnectionReconcile();
        let consecutiveFailures = 0;
        this.connectionReconcileInterval = $d84dc1a5e217b32f$export$22e737276454df96.setInterval(()=>{
            if (// ensure we didn't tear it down
            !this.engine || // engine detected close, but Room missed it
            this.engine.isClosed || // transports failed without notifying engine
            !this.engine.verifyTransport()) {
                consecutiveFailures++;
                this.log.warn("detected connection state mismatch", Object.assign(Object.assign({}, this.logContext), {
                    numFailures: consecutiveFailures,
                    engine: this.engine ? {
                        closed: this.engine.isClosed,
                        transportsConnected: this.engine.verifyTransport()
                    } : undefined
                }));
                if (consecutiveFailures >= 3) {
                    this.recreateEngine();
                    this.handleDisconnect(this.options.stopLocalTrackOnUnpublish, $d84dc1a5e217b32f$export$258d16488300d83f.STATE_MISMATCH);
                }
            } else consecutiveFailures = 0;
        }, $d84dc1a5e217b32f$var$connectionReconcileFrequency);
    }
    clearConnectionReconcile() {
        if (this.connectionReconcileInterval) $d84dc1a5e217b32f$export$22e737276454df96.clearInterval(this.connectionReconcileInterval);
    }
    setAndEmitConnectionState(state) {
        if (state === this.state) // unchanged
        return false;
        this.state = state;
        this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.ConnectionStateChanged, this.state);
        return true;
    }
    emitBufferedEvents() {
        this.bufferedEvents.forEach((_ref3)=>{
            let [ev, args] = _ref3;
            this.emit(ev, ...args);
        });
        this.bufferedEvents = [];
    }
    emitWhenConnected(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Reconnecting || this.isResuming || !this.engine || this.engine.pendingReconnect) // in case the room is reconnecting, buffer the events by firing them later after emitting RoomEvent.Reconnected
        this.bufferedEvents.push([
            event,
            args
        ]);
        else if (this.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected) return this.emit(event, ...args);
        return false;
    }
    /**
   * Allows to populate a room with simulated participants.
   * No actual connection to a server will be established, all state is
   * @experimental
   */ simulateParticipants(options) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const publishOptions = Object.assign({
                audio: true,
                video: true,
                useRealTracks: false
            }, options.publish);
            const participantOptions = Object.assign({
                count: 9,
                audio: false,
                video: true,
                aspectRatios: [
                    1.66,
                    1.7,
                    1.3
                ]
            }, options.participants);
            this.handleDisconnect();
            this.roomInfo = new $d84dc1a5e217b32f$var$Room$1({
                sid: "RM_SIMULATED",
                name: "simulated-room",
                emptyTimeout: 0,
                maxParticipants: 0,
                creationTime: $d84dc1a5e217b32f$var$protoInt64.parse(new Date().getTime()),
                metadata: "",
                numParticipants: 1,
                numPublishers: 1,
                turnPassword: "",
                enabledCodecs: [],
                activeRecording: false
            });
            this.localParticipant.updateInfo(new $d84dc1a5e217b32f$var$ParticipantInfo({
                identity: "simulated-local",
                name: "local-name"
            }));
            this.setupLocalParticipantEvents();
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalConnected);
            this.emit($d84dc1a5e217b32f$export$3159c672e3b2293a.Connected);
            this.setAndEmitConnectionState($d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected);
            if (publishOptions.video) {
                const camPub = new $d84dc1a5e217b32f$export$885a52c769210b3f($d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video, new $d84dc1a5e217b32f$var$TrackInfo({
                    source: $d84dc1a5e217b32f$var$TrackSource.CAMERA,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $d84dc1a5e217b32f$var$TrackType.AUDIO,
                    name: "video-dummy"
                }), new $d84dc1a5e217b32f$export$d5ffd2c62c538bdc(publishOptions.useRealTracks ? (yield window.navigator.mediaDevices.getUserMedia({
                    video: true
                })).getVideoTracks()[0] : $d84dc1a5e217b32f$var$createDummyVideoStreamTrack(160 * ((_a = participantOptions.aspectRatios[0]) !== null && _a !== void 0 ? _a : 1), 160, true, true), undefined, false, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(camPub);
                this.localParticipant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, camPub);
            }
            if (publishOptions.audio) {
                const audioPub = new $d84dc1a5e217b32f$export$885a52c769210b3f($d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio, new $d84dc1a5e217b32f$var$TrackInfo({
                    source: $d84dc1a5e217b32f$var$TrackSource.MICROPHONE,
                    sid: Math.floor(Math.random() * 10000).toString(),
                    type: $d84dc1a5e217b32f$var$TrackType.AUDIO
                }), new $d84dc1a5e217b32f$export$b287427b771ca237(publishOptions.useRealTracks ? (yield navigator.mediaDevices.getUserMedia({
                    audio: true
                })).getAudioTracks()[0] : $d84dc1a5e217b32f$export$59e276d6841f735c(), undefined, false, this.audioContext, {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                }), {
                    loggerName: this.options.loggerName,
                    loggerContextCb: ()=>this.logContext
                });
                // @ts-ignore
                this.localParticipant.addTrackPublication(audioPub);
                this.localParticipant.emit($d84dc1a5e217b32f$export$fcdfe2b7a6750691.LocalTrackPublished, audioPub);
            }
            for(let i = 0; i < participantOptions.count - 1; i += 1){
                let info = new $d84dc1a5e217b32f$var$ParticipantInfo({
                    sid: Math.floor(Math.random() * 10000).toString(),
                    identity: "simulated-".concat(i),
                    state: $d84dc1a5e217b32f$var$ParticipantInfo_State.ACTIVE,
                    tracks: [],
                    joinedAt: $d84dc1a5e217b32f$var$protoInt64.parse(Date.now())
                });
                const p = this.getOrCreateParticipant(info.identity, info);
                if (participantOptions.video) {
                    const dummyVideo = $d84dc1a5e217b32f$var$createDummyVideoStreamTrack(160 * ((_b = participantOptions.aspectRatios[i % participantOptions.aspectRatios.length]) !== null && _b !== void 0 ? _b : 1), 160, false, true);
                    const videoTrack = new $d84dc1a5e217b32f$var$TrackInfo({
                        source: $d84dc1a5e217b32f$var$TrackSource.CAMERA,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $d84dc1a5e217b32f$var$TrackType.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyVideo, videoTrack.sid, new MediaStream([
                        dummyVideo
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        videoTrack
                    ];
                }
                if (participantOptions.audio) {
                    const dummyTrack = $d84dc1a5e217b32f$export$59e276d6841f735c();
                    const audioTrack = new $d84dc1a5e217b32f$var$TrackInfo({
                        source: $d84dc1a5e217b32f$var$TrackSource.MICROPHONE,
                        sid: Math.floor(Math.random() * 10000).toString(),
                        type: $d84dc1a5e217b32f$var$TrackType.AUDIO
                    });
                    p.addSubscribedMediaTrack(dummyTrack, audioTrack.sid, new MediaStream([
                        dummyTrack
                    ]), new RTCRtpReceiver());
                    info.tracks = [
                        ...info.tracks,
                        audioTrack
                    ];
                }
                p.updateInfo(info);
            }
        });
    }
    // /** @internal */
    emit(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        // active speaker updates are too spammy
        if (event !== $d84dc1a5e217b32f$export$3159c672e3b2293a.ActiveSpeakersChanged) {
            // only extract logContext from arguments in order to avoid logging the whole object tree
            const minimizedArgs = $d84dc1a5e217b32f$var$mapArgs(args).filter((arg)=>arg !== undefined);
            this.log.debug("room event ".concat(event), Object.assign(Object.assign({}, this.logContext), {
                event: event,
                args: minimizedArgs
            }));
        }
        return super.emit(event, ...args);
    }
}
$d84dc1a5e217b32f$export$525628e68e798fb4.cleanupRegistry = typeof FinalizationRegistry !== "undefined" && new FinalizationRegistry((cleanup)=>{
    cleanup();
});
function $d84dc1a5e217b32f$var$mapArgs(args) {
    return args.map((arg)=>{
        if (!arg) return;
        if (Array.isArray(arg)) return $d84dc1a5e217b32f$var$mapArgs(arg);
        if (typeof arg === "object") return "logContext" in arg && arg.logContext;
        return arg;
    });
}
var $d84dc1a5e217b32f$export$180e7b9f22912c82;
(function(CheckStatus) {
    CheckStatus[CheckStatus["IDLE"] = 0] = "IDLE";
    CheckStatus[CheckStatus["RUNNING"] = 1] = "RUNNING";
    CheckStatus[CheckStatus["SKIPPED"] = 2] = "SKIPPED";
    CheckStatus[CheckStatus["SUCCESS"] = 3] = "SUCCESS";
    CheckStatus[CheckStatus["FAILED"] = 4] = "FAILED";
})($d84dc1a5e217b32f$export$180e7b9f22912c82 || ($d84dc1a5e217b32f$export$180e7b9f22912c82 = {}));
class $d84dc1a5e217b32f$export$8ecd240bc8faaeeb extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.status = $d84dc1a5e217b32f$export$180e7b9f22912c82.IDLE;
        this.logs = [];
        this.errorsAsWarnings = false;
        this.url = url;
        this.token = token;
        this.name = this.constructor.name;
        this.room = new $d84dc1a5e217b32f$export$525628e68e798fb4(options.roomOptions);
        this.connectOptions = options.connectOptions;
        if (options.errorsAsWarnings) this.errorsAsWarnings = options.errorsAsWarnings;
    }
    run(onComplete) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.status !== $d84dc1a5e217b32f$export$180e7b9f22912c82.IDLE) throw Error("check is running already");
            this.setStatus($d84dc1a5e217b32f$export$180e7b9f22912c82.RUNNING);
            try {
                yield this.perform();
            } catch (err) {
                if (err instanceof Error) {
                    if (this.errorsAsWarnings) this.appendWarning(err.message);
                    else this.appendError(err.message);
                }
            }
            yield this.disconnect();
            // sleep for a bit to ensure disconnect
            yield new Promise((resolve)=>setTimeout(resolve, 500));
            // @ts-ignore
            if (this.status !== $d84dc1a5e217b32f$export$180e7b9f22912c82.SKIPPED) this.setStatus(this.isSuccess() ? $d84dc1a5e217b32f$export$180e7b9f22912c82.SUCCESS : $d84dc1a5e217b32f$export$180e7b9f22912c82.FAILED);
            if (onComplete) onComplete();
            return this.getInfo();
        });
    }
    isSuccess() {
        return !this.logs.some((l)=>l.level === "error");
    }
    connect() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room.state === $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected) return this.room;
            yield this.room.connect(this.url, this.token, this.connectOptions);
            return this.room;
        });
    }
    disconnect() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            if (this.room && this.room.state !== $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Disconnected) {
                yield this.room.disconnect();
                // wait for it to go through
                yield new Promise((resolve)=>setTimeout(resolve, 500));
            }
        });
    }
    skip() {
        this.setStatus($d84dc1a5e217b32f$export$180e7b9f22912c82.SKIPPED);
    }
    appendMessage(message) {
        this.logs.push({
            level: "info",
            message: message
        });
        this.emit("update", this.getInfo());
    }
    appendWarning(message) {
        this.logs.push({
            level: "warning",
            message: message
        });
        this.emit("update", this.getInfo());
    }
    appendError(message) {
        this.logs.push({
            level: "error",
            message: message
        });
        this.emit("update", this.getInfo());
    }
    setStatus(status) {
        this.status = status;
        this.emit("update", this.getInfo());
    }
    get engine() {
        var _a;
        return (_a = this.room) === null || _a === void 0 ? void 0 : _a.engine;
    }
    getInfo() {
        return {
            logs: this.logs,
            name: this.name,
            status: this.status,
            description: this.description
        };
    }
}
/**
 * Creates a local video and audio track at the same time. When acquiring both
 * audio and video tracks together, it'll display a single permission prompt to
 * the user instead of two separate ones.
 * @param options
 */ function $d84dc1a5e217b32f$export$61cce20000b22feb(options) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        var _a, _b;
        // set default options to true
        options !== null && options !== void 0 ? options : options = {};
        (_a = options.audio) !== null && _a !== void 0 ? _a : options.audio = {
            deviceId: "default"
        };
        (_b = options.video) !== null && _b !== void 0 ? _b : options.video = {
            deviceId: "default"
        };
        const { audioProcessor: audioProcessor, videoProcessor: videoProcessor } = $d84dc1a5e217b32f$var$extractProcessorsFromOptions(options);
        const opts = $d84dc1a5e217b32f$var$mergeDefaultOptions(options, $d84dc1a5e217b32f$var$audioDefaults, $d84dc1a5e217b32f$var$videoDefaults);
        const constraints = $d84dc1a5e217b32f$var$constraintsForOptions(opts);
        // Keep a reference to the promise on DeviceManager and await it in getLocalDevices()
        // works around iOS Safari Bug https://bugs.webkit.org/show_bug.cgi?id=179363
        const mediaPromise = navigator.mediaDevices.getUserMedia(constraints);
        if (options.audio) {
            $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.set("audioinput", mediaPromise);
            mediaPromise.catch(()=>$d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.delete("audioinput"));
        }
        if (options.video) {
            $d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.set("videoinput", mediaPromise);
            mediaPromise.catch(()=>$d84dc1a5e217b32f$var$DeviceManager.userMediaPromiseMap.delete("videoinput"));
        }
        const stream = yield mediaPromise;
        return Promise.all(stream.getTracks().map((mediaStreamTrack)=>$d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
                const isAudio = mediaStreamTrack.kind === "audio";
                isAudio ? opts.audio : opts.video;
                let trackConstraints;
                const conOrBool = isAudio ? constraints.audio : constraints.video;
                if (typeof conOrBool !== "boolean") trackConstraints = conOrBool;
                // update the constraints with the device id the user gave permissions to in the permission prompt
                // otherwise each track restart (e.g. mute - unmute) will try to initialize the device again -> causing additional permission prompts
                if (trackConstraints) trackConstraints.deviceId = mediaStreamTrack.getSettings().deviceId;
                else trackConstraints = {
                    deviceId: mediaStreamTrack.getSettings().deviceId
                };
                const track = $d84dc1a5e217b32f$var$mediaTrackToLocalTrack(mediaStreamTrack, trackConstraints);
                if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Video) track.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Camera;
                else if (track.kind === $d84dc1a5e217b32f$export$13921ac0cc260818.Kind.Audio) track.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.Microphone;
                track.mediaStream = stream;
                if (track instanceof $d84dc1a5e217b32f$export$b287427b771ca237 && audioProcessor) yield track.setProcessor(audioProcessor);
                else if (track instanceof $d84dc1a5e217b32f$export$d5ffd2c62c538bdc && videoProcessor) yield track.setProcessor(videoProcessor);
                return track;
            })));
    });
}
/**
 * Creates a [[LocalVideoTrack]] with getUserMedia()
 * @param options
 */ function $d84dc1a5e217b32f$export$449d1fd97929ebe7(options) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $d84dc1a5e217b32f$export$61cce20000b22feb({
            audio: false,
            video: options
        });
        return tracks[0];
    });
}
function $d84dc1a5e217b32f$export$6e84c4c7abc03d43(options) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        const tracks = yield $d84dc1a5e217b32f$export$61cce20000b22feb({
            audio: options,
            video: false
        });
        return tracks[0];
    });
}
/**
 * Creates a screen capture tracks with getDisplayMedia().
 * A LocalVideoTrack is always created and returned.
 * If { audio: true }, and the browser supports audio capture, a LocalAudioTrack is also created.
 */ function $d84dc1a5e217b32f$export$39e3aa92383c771(options) {
    return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
        if (options === undefined) options = {};
        if (options.resolution === undefined && !$d84dc1a5e217b32f$var$isSafari17()) options.resolution = $d84dc1a5e217b32f$export$a6cdf9dcd3d32f2d.h1080fps30.resolution;
        if (navigator.mediaDevices.getDisplayMedia === undefined) throw new $d84dc1a5e217b32f$export$38c5ac268e2fa84("getDisplayMedia not supported");
        const constraints = $d84dc1a5e217b32f$var$screenCaptureToDisplayMediaStreamOptions(options);
        const stream = yield navigator.mediaDevices.getDisplayMedia(constraints);
        const tracks = stream.getVideoTracks();
        if (tracks.length === 0) throw new $d84dc1a5e217b32f$export$4fbb9423b5747257("no video track found");
        const screenVideo = new $d84dc1a5e217b32f$export$d5ffd2c62c538bdc(tracks[0], undefined, false);
        screenVideo.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShare;
        const localTracks = [
            screenVideo
        ];
        if (stream.getAudioTracks().length > 0) {
            const screenAudio = new $d84dc1a5e217b32f$export$b287427b771ca237(stream.getAudioTracks()[0], undefined, false);
            screenAudio.source = $d84dc1a5e217b32f$export$13921ac0cc260818.Source.ScreenShareAudio;
            localTracks.push(screenAudio);
        }
        return localTracks;
    });
}
class $d84dc1a5e217b32f$var$PublishAudioCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Can publish audio";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $d84dc1a5e217b32f$export$6e84c4c7abc03d43();
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 3000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error("Could not get RTCStats");
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === "outbound-rtp" && (stat.kind === "audio" || !stat.kind && stat.mediaType === "audio")) numPackets = stat.packetsSent;
            });
            if (numPackets === 0) throw new Error("Could not determine packets are sent");
            this.appendMessage("published ".concat(numPackets, " audio packets"));
        });
    }
}
class $d84dc1a5e217b32f$var$PublishVideoCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Can publish video";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            const track = yield $d84dc1a5e217b32f$export$449d1fd97929ebe7();
            room.localParticipant.publishTrack(track);
            // wait for a few seconds to publish
            yield new Promise((resolve)=>setTimeout(resolve, 5000));
            // verify RTC stats that it's publishing
            const stats = yield (_a = track.sender) === null || _a === void 0 ? void 0 : _a.getStats();
            if (!stats) throw new Error("Could not get RTCStats");
            let numPackets = 0;
            stats.forEach((stat)=>{
                if (stat.type === "outbound-rtp" && (stat.kind === "video" || !stat.kind && stat.mediaType === "video")) numPackets += stat.packetsSent;
            });
            if (numPackets === 0) throw new Error("Could not determine packets are sent");
            this.appendMessage("published ".concat(numPackets, " video packets"));
        });
    }
}
class $d84dc1a5e217b32f$var$ReconnectCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Resuming connection after interruption";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const room = yield this.connect();
            let reconnectingTriggered = false;
            let reconnected = false;
            let reconnectResolver;
            const reconnectTimeout = new Promise((resolve)=>{
                setTimeout(resolve, 5000);
                reconnectResolver = resolve;
            });
            const handleReconnecting = ()=>{
                reconnectingTriggered = true;
            };
            room.on($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalReconnecting, handleReconnecting).on($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnecting, handleReconnecting).on($d84dc1a5e217b32f$export$3159c672e3b2293a.Reconnected, ()=>{
                reconnected = true;
                reconnectResolver(true);
            });
            (_a = room.engine.client.ws) === null || _a === void 0 || _a.close();
            const onClose = room.engine.client.onClose;
            if (onClose) onClose("");
            yield reconnectTimeout;
            if (!reconnectingTriggered) throw new Error("Did not attempt to reconnect");
            else if (!reconnected || room.state !== $d84dc1a5e217b32f$export$cd9c3c6bf535afc9.Connected) {
                this.appendWarning("reconnection is only possible in Redis-based configurations");
                throw new Error("Not able to reconnect");
            }
        });
    }
}
class $d84dc1a5e217b32f$var$TURNCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Can connect via TURN";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const signalClient = new $d84dc1a5e217b32f$var$SignalClient();
            const joinRes = yield signalClient.join(this.url, this.token, {
                autoSubscribe: true,
                maxRetries: 0,
                e2eeEnabled: false,
                websocketTimeout: 15000
            });
            let hasTLS = false;
            let hasTURN = false;
            let hasSTUN = false;
            for (let iceServer of joinRes.iceServers)for (let url of iceServer.urls){
                if (url.startsWith("turn:")) {
                    hasTURN = true;
                    hasSTUN = true;
                } else if (url.startsWith("turns:")) {
                    hasTURN = true;
                    hasSTUN = true;
                    hasTLS = true;
                }
                if (url.startsWith("stun:")) hasSTUN = true;
            }
            if (!hasSTUN) this.appendWarning("No STUN servers configured on server side.");
            else if (hasTURN && !hasTLS) this.appendWarning("TURN is configured server side, but TURN/TLS is unavailable.");
            yield signalClient.close();
            if (((_b = (_a = this.connectOptions) === null || _a === void 0 ? void 0 : _a.rtcConfig) === null || _b === void 0 ? void 0 : _b.iceServers) || hasTURN) yield this.room.connect(this.url, this.token, {
                rtcConfig: {
                    iceTransportPolicy: "relay"
                }
            });
            else {
                this.appendWarning("No TURN servers configured.");
                this.skip();
                yield new Promise((resolve)=>setTimeout(resolve, 0));
            }
        });
    }
}
class $d84dc1a5e217b32f$var$WebRTCCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Establishing WebRTC connection";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            let hasTcp = false;
            let hasIpv4Udp = false;
            this.room.on($d84dc1a5e217b32f$export$3159c672e3b2293a.SignalConnected, ()=>{
                const prevTrickle = this.room.engine.client.onTrickle;
                this.room.engine.client.onTrickle = (sd, target)=>{
                    if (sd.candidate) {
                        const candidate = new RTCIceCandidate(sd);
                        let str = "".concat(candidate.protocol, " ").concat(candidate.address, ":").concat(candidate.port, " ").concat(candidate.type);
                        if (candidate.address) {
                            if ($d84dc1a5e217b32f$var$isIPPrivate(candidate.address)) str += " (private)";
                            else {
                                if (candidate.protocol === "tcp" && candidate.tcpType === "passive") {
                                    hasTcp = true;
                                    str += " (passive)";
                                } else if (candidate.protocol === "udp") hasIpv4Udp = true;
                            }
                        }
                        this.appendMessage(str);
                    }
                    if (prevTrickle) prevTrickle(sd, target);
                };
                if (this.room.engine.pcManager) this.room.engine.pcManager.subscriber.onIceCandidateError = (ev)=>{
                    if (ev instanceof RTCPeerConnectionIceErrorEvent) this.appendWarning("error with ICE candidate: ".concat(ev.errorCode, " ").concat(ev.errorText, " ").concat(ev.url));
                };
            });
            try {
                yield this.connect();
                $d84dc1a5e217b32f$var$livekitLogger.info("now the room is connected");
            } catch (err) {
                this.appendWarning("ports need to be open on firewall in order to connect.");
                throw err;
            }
            if (!hasTcp) this.appendWarning("Server is not configured for ICE/TCP");
            if (!hasIpv4Udp) this.appendWarning("No public IPv4 UDP candidates were found. Your server is likely not configured correctly");
        });
    }
}
function $d84dc1a5e217b32f$var$isIPPrivate(address) {
    const parts = address.split(".");
    if (parts.length === 4) {
        if (parts[0] === "10") return true;
        else if (parts[0] === "192" && parts[1] === "168") return true;
        else if (parts[0] === "172") {
            const second = parseInt(parts[1], 10);
            if (second >= 16 && second <= 31) return true;
        }
    }
    return false;
}
class $d84dc1a5e217b32f$var$WebSocketCheck extends $d84dc1a5e217b32f$export$8ecd240bc8faaeeb {
    get description() {
        return "Connecting to signal connection via WebSocket";
    }
    perform() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            if (this.url.startsWith("ws:") || this.url.startsWith("http:")) this.appendWarning("Server is insecure, clients may block connections to it");
            let signalClient = new $d84dc1a5e217b32f$var$SignalClient();
            const joinRes = yield signalClient.join(this.url, this.token, {
                autoSubscribe: true,
                maxRetries: 0,
                e2eeEnabled: false,
                websocketTimeout: 15000
            });
            this.appendMessage("Connected to server, version ".concat(joinRes.serverVersion, "."));
            if (((_a = joinRes.serverInfo) === null || _a === void 0 ? void 0 : _a.edition) === $d84dc1a5e217b32f$var$ServerInfo_Edition.Cloud && ((_b = joinRes.serverInfo) === null || _b === void 0 ? void 0 : _b.region)) this.appendMessage("LiveKit Cloud: ".concat((_c = joinRes.serverInfo) === null || _c === void 0 ? void 0 : _c.region));
            yield signalClient.close();
        });
    }
}
class $d84dc1a5e217b32f$export$987f59e088b53559 extends $d84dc1a5e217b32f$var$eventsExports.EventEmitter {
    constructor(url, token){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        super();
        this.options = {};
        this.checkResults = new Map();
        this.url = url;
        this.token = token;
        this.options = options;
    }
    getNextCheckId() {
        const nextId = this.checkResults.size;
        this.checkResults.set(nextId, {
            logs: [],
            status: $d84dc1a5e217b32f$export$180e7b9f22912c82.IDLE,
            name: "",
            description: ""
        });
        return nextId;
    }
    updateCheck(checkId, info) {
        this.checkResults.set(checkId, info);
        this.emit("checkUpdate", checkId, info);
    }
    isSuccess() {
        return Array.from(this.checkResults.values()).every((r)=>r.status !== $d84dc1a5e217b32f$export$180e7b9f22912c82.FAILED);
    }
    getResults() {
        return Array.from(this.checkResults.values());
    }
    createAndRunCheck(check) {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            const checkId = this.getNextCheckId();
            const test = new check(this.url, this.token, this.options);
            const handleUpdate = (info)=>{
                this.updateCheck(checkId, info);
            };
            test.on("update", handleUpdate);
            const result = yield test.run();
            test.off("update", handleUpdate);
            return result;
        });
    }
    checkWebsocket() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$WebSocketCheck);
        });
    }
    checkWebRTC() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$WebRTCCheck);
        });
    }
    checkTURN() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$TURNCheck);
        });
    }
    checkReconnect() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$ReconnectCheck);
        });
    }
    checkPublishAudio() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$PublishAudioCheck);
        });
    }
    checkPublishVideo() {
        return $d84dc1a5e217b32f$var$__awaiter(this, void 0, void 0, function*() {
            return this.createAndRunCheck($d84dc1a5e217b32f$var$PublishVideoCheck);
        });
    }
}
/**
 * Try to analyze the local track to determine the facing mode of a track.
 *
 * @remarks
 * There is no property supported by all browsers to detect whether a video track originated from a user- or environment-facing camera device.
 * For this reason, we use the `facingMode` property when available, but will fall back on a string-based analysis of the device label to determine the facing mode.
 * If both methods fail, the default facing mode will be used.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode | MDN docs on facingMode}
 * @experimental
 */ function $d84dc1a5e217b32f$export$87170f5cedaf6982(localTrack) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _a;
    const track = localTrack instanceof $d84dc1a5e217b32f$export$3e041ce3f33f04dd ? localTrack.mediaStreamTrack : localTrack;
    const trackSettings = track.getSettings();
    let result = {
        facingMode: (_a = options.defaultFacingMode) !== null && _a !== void 0 ? _a : "user",
        confidence: "low"
    };
    // 1. Try to get facingMode from track settings.
    if ("facingMode" in trackSettings) {
        const rawFacingMode = trackSettings.facingMode;
        $d84dc1a5e217b32f$var$livekitLogger.trace("rawFacingMode", {
            rawFacingMode: rawFacingMode
        });
        if (rawFacingMode && typeof rawFacingMode === "string" && $d84dc1a5e217b32f$var$isFacingModeValue(rawFacingMode)) result = {
            facingMode: rawFacingMode,
            confidence: "high"
        };
    }
    // 2. If we don't have a high confidence we try to get the facing mode from the device label.
    if ([
        "low",
        "medium"
    ].includes(result.confidence)) {
        $d84dc1a5e217b32f$var$livekitLogger.trace("Try to get facing mode from device label: (".concat(track.label, ")"));
        const labelAnalysisResult = $d84dc1a5e217b32f$export$db3659edbf169d37(track.label);
        if (labelAnalysisResult !== undefined) result = labelAnalysisResult;
    }
    return result;
}
const $d84dc1a5e217b32f$var$knownDeviceLabels = new Map([
    [
        "obs virtual camera",
        {
            facingMode: "environment",
            confidence: "medium"
        }
    ]
]);
const $d84dc1a5e217b32f$var$knownDeviceLabelSections = new Map([
    [
        "iphone",
        {
            facingMode: "environment",
            confidence: "medium"
        }
    ],
    [
        "ipad",
        {
            facingMode: "environment",
            confidence: "medium"
        }
    ]
]);
/**
 * Attempt to analyze the device label to determine the facing mode.
 *
 * @experimental
 */ function $d84dc1a5e217b32f$export$db3659edbf169d37(deviceLabel) {
    var _a;
    const label = deviceLabel.trim().toLowerCase();
    // Empty string is a valid device label but we can't infer anything from it.
    if (label === "") return undefined;
    // Can we match against widely known device labels.
    if ($d84dc1a5e217b32f$var$knownDeviceLabels.has(label)) return $d84dc1a5e217b32f$var$knownDeviceLabels.get(label);
    // Can we match against sections of the device label.
    return (_a = Array.from($d84dc1a5e217b32f$var$knownDeviceLabelSections.entries()).find((_ref)=>{
        let [section] = _ref;
        return label.includes(section);
    })) === null || _a === void 0 ? void 0 : _a[1];
}
function $d84dc1a5e217b32f$var$isFacingModeValue(item) {
    const allowedValues = [
        "user",
        "environment",
        "left",
        "right"
    ];
    return item === undefined || allowedValues.includes(item);
}


function $b3bcb471bacfec8d$var$r(t, e) {
    return $b3bcb471bacfec8d$var$r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b3bcb471bacfec8d$var$r(t, e);
}
var $b3bcb471bacfec8d$var$c = new TextDecoder, $b3bcb471bacfec8d$export$ed56c86053868bb0 = /*#__PURE__*/ function(t) {
    var s, l;
    function u() {
        var e;
        return (e = t.call(this) || this).room = void 0, e.connected = !1, e.isAgentTalking = !1, e.analyzerComponent = void 0, e.captureAudioFrame = void 0, e;
    }
    l = t, (s = u).prototype = Object.create(l.prototype), s.prototype.constructor = s, $b3bcb471bacfec8d$var$r(s, l);
    var d = u.prototype;
    return d.startCall = function(t) {
        try {
            var n = this, o = function(o, i) {
                try {
                    var a = (n.room = new (0, $d84dc1a5e217b32f$export$525628e68e798fb4)({
                        audioCaptureDefaults: {
                            autoGainControl: !0,
                            echoCancellation: !0,
                            noiseSuppression: !0,
                            channelCount: 1,
                            deviceId: t.captureDeviceId,
                            sampleRate: t.sampleRate
                        },
                        audioOutput: {
                            deviceId: t.playbackDeviceId
                        }
                    }), n.handleRoomEvents(), n.handleAudioEvents(t), n.handleDataEvents(), Promise.resolve(n.room.connect("wss://retell-ai-4ihahnq7.livekit.cloud", t.accessToken)).then(function() {
                        console.log("connected to room", n.room.name), n.room.localParticipant.setMicrophoneEnabled(!0), n.connected = !0, n.emit("call_started");
                    }));
                } catch (t) {
                    return i(t);
                }
                return a && a.then ? a.then(void 0, i) : a;
            }(0, function(t) {
                n.emit("error", "Error starting call"), console.error("Error starting call", t), n.stopCall();
            });
            return Promise.resolve(o && o.then ? o.then(function() {}) : void 0);
        } catch (t) {
            return Promise.reject(t);
        }
    }, d.startAudioPlayback = function() {
        try {
            return Promise.resolve(this.room.startAudio()).then(function() {});
        } catch (t) {
            return Promise.reject(t);
        }
    }, d.stopCall = function() {
        var t;
        this.connected && (this.connected = !1, this.emit("call_ended"), null == (t = this.room) || t.disconnect()), this.isAgentTalking = !1, delete this.room, this.analyzerComponent && (this.analyzerComponent.cleanup(), delete this.analyzerComponent), this.captureAudioFrame && (window.cancelAnimationFrame(this.captureAudioFrame), delete this.captureAudioFrame);
    }, d.mute = function() {
        this.connected && this.room.localParticipant.setMicrophoneEnabled(!1);
    }, d.unmute = function() {
        this.connected && this.room.localParticipant.setMicrophoneEnabled(!0);
    }, d.captureAudioSamples = function() {
        var t = this;
        if (this.connected && this.analyzerComponent) {
            var e = new Float32Array(this.analyzerComponent.analyser.fftSize);
            this.analyzerComponent.analyser.getFloatTimeDomainData(e), this.emit("audio", e), this.captureAudioFrame = window.requestAnimationFrame(function() {
                return t.captureAudioSamples();
            });
        }
    }, d.handleRoomEvents = function() {
        var t = this;
        this.room.on((0, $d84dc1a5e217b32f$export$3159c672e3b2293a).ParticipantDisconnected, function(e) {
            "server" === (null == e ? void 0 : e.identity) && t.stopCall();
        }), this.room.on((0, $d84dc1a5e217b32f$export$3159c672e3b2293a).Disconnected, function() {
            t.connected && t.stopCall();
        });
    }, d.handleAudioEvents = function(t) {
        var e = this;
        this.room.on((0, $d84dc1a5e217b32f$export$3159c672e3b2293a).TrackSubscribed, function(n, r, c) {
            n.kind === (0, $d84dc1a5e217b32f$export$13921ac0cc260818).Kind.Audio && ("agent_audio" === r.trackName && n instanceof (0, $d84dc1a5e217b32f$export$fd37b116bd840ced) && t.emitRawAudioSamples && (e.analyzerComponent = (0, $d84dc1a5e217b32f$export$c3a30182235995eb)(n), e.captureAudioFrame = window.requestAnimationFrame(function() {
                return e.captureAudioSamples();
            })), n.attach());
        });
    }, d.handleDataEvents = function() {
        var t = this;
        this.room.on((0, $d84dc1a5e217b32f$export$3159c672e3b2293a).DataReceived, function(e, n, o, i) {
            try {
                if ("server" !== (null == n ? void 0 : n.identity)) return;
                var a = $b3bcb471bacfec8d$var$c.decode(e), r = JSON.parse(a);
                "update" === r.event_type ? t.emit("update", r) : "metadata" === r.event_type ? t.emit("metadata", r) : "agent_start_talking" === r.event_type ? (t.isAgentTalking = !0, t.emit("agent_start_talking")) : "agent_stop_talking" === r.event_type ? (t.isAgentTalking = !1, t.emit("agent_stop_talking")) : "node_transition" === r.event_type && t.emit("node_transition", r);
            } catch (t) {
                console.error("Error decoding data received", t);
            }
        });
    }, u;
}((0, $9a377d1a0480fe10$exports.EventEmitter));


var $45fcee20a9e5417b$exports = {};
var $bc54a042e7b1a806$exports = {};
"use strict";
$bc54a042e7b1a806$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};



let $45fcee20a9e5417b$var$url = new URL((parcelRequire("16ViG")).resolve("k5fzK"), import.meta.url);
$45fcee20a9e5417b$exports = $bc54a042e7b1a806$exports($45fcee20a9e5417b$var$url.toString(), $45fcee20a9e5417b$var$url.origin, true);


const $b858484a41fbde5f$var$worker = new Worker($45fcee20a9e5417b$exports);
const $b858484a41fbde5f$var$retellWebClient = new (0, $b3bcb471bacfec8d$export$ed56c86053868bb0)();
$b858484a41fbde5f$var$retellWebClient.on("call_ended", ()=>{
    console.log("webcall:call_ended");
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:call_ended");
});
// When agent starts talking for the utterance
// useful for animation
$b858484a41fbde5f$var$retellWebClient.on("agent_start_talking", ()=>{
    console.log("webcall:agent_start_talking");
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:agent_start_talking");
});
// When agent is done talking for the utterance
// useful for animation
$b858484a41fbde5f$var$retellWebClient.on("agent_stop_talking", ()=>{
    console.log("webcall:agent_stop_talking");
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:agent_stop_talking");
});
// Real time pcm audio bytes being played back, in format of Float32Array
// only available when emitRawAudioSamples is true
$b858484a41fbde5f$var$retellWebClient.on("audio", (audio)=>{
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:audio", audio);
});
// Update message such as transcript
// You can get transcrit with update.transcript
// Please note that transcript only contains last 5 sentences to avoid the payload being too large
$b858484a41fbde5f$var$retellWebClient.on("update", (update)=>{
    console.log("webcall:update", update);
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:update", update);
});
$b858484a41fbde5f$var$retellWebClient.on("metadata", (metadata)=>{
    console.log("retell:metadata", metadata);
    (0, $8108230355f26483$export$6efe264be9505de7)("webcall:metadata", metadata);
});
$b858484a41fbde5f$var$retellWebClient.on("error", (error)=>{
    console.error("An error occurred:", error);
    // Stop the call
    $b858484a41fbde5f$var$retellWebClient.stopCall();
});
window.retell_on_call = false;
function $b858484a41fbde5f$var$is_referrer_in_domains(domains) {
    let hostname = window.location.hostname;
    const referrer = window.document.referrer;
    if (referrer) try {
        hostname = new URL(referrer).hostname;
    } catch  {
        hostname = window.location.hostname;
        console.log("Error parsing referrer (", referrer, ") as URL, using window location instead");
    }
    hostname = hostname.startsWith("www.") ? hostname.substring(4) : hostname;
    const whiteListedUrls = [
        "beta.chatfunnels.com",
        "beta.getsignals.ai",
        "app.chatfunnels.com",
        "app.getsignals.ai",
        "local.chatfunnels.dev",
        "mychatfunnels.com"
    ];
    if (whiteListedUrls.includes(hostname) || hostname.indexOf(".chatfunnels.chat") !== -1 || !domains || domains.length === 0 || domains.includes(hostname) || domains.includes("www." + hostname)) return true;
    console.log("Current domain not allowed to run Signals script", " allowed: ", domains, " current: ", hostname);
    return false;
}
function $b858484a41fbde5f$var$Loader() {
    const [myId, setMyId] = (0, $iluxG.useState)(null);
    const [welcomePacket, setWelcomePacket] = (0, $iluxG.useState)();
    const [hideApp, setHideApp] = (0, $iluxG.useState)(false);
    const [visitID, setVisitID] = (0, $iluxG.useState)((0, $8108230355f26483$export$30c606e92a482586)(myId?.packet_code) || "");
    const myIdRef = (0, $iluxG.useRef)(null);
    myIdRef.current = myId;
    const token = `visitor_${myIdRef.current?.id}_${myIdRef.current?.packet_code}`;
    const botTriggerByFlowIdRef = (0, $iluxG.useRef)(null);
    const botTriggerByIdRef = (0, $iluxG.useRef)(null);
    const startConversationWithUserIdRef = (0, $iluxG.useRef)(null);
    const screenRef = (0, $iluxG.useRef)(null);
    const scrollCallbackRef = (0, $iluxG.useRef)(null);
    const urlChangeCallbackRef = (0, $iluxG.useRef)(null);
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($74ddcc225f04703a$exports))).getParser(window.navigator.userAgent);
    const isBadIE = browser.satisfies({
        "internet explorer": "<12"
    });
    const [visualViewportSize, setVisualViewportSize] = (0, $iluxG.useState)(null);
    const masterToggle = welcomePacket ? true : false;
    (0, $iluxG.useEffect)(()=>{
        window.addEventListener("message", (message)=>{
            if (message.source !== window.parent) return;
            const data = message.data;
            switch(data.type){
                case "id":
                    if (!visitID) setVisitID((0, $8108230355f26483$export$30c606e92a482586)(data.packet_code));
                    setMyId({
                        ...data,
                        visit_id: (0, $8108230355f26483$export$30c606e92a482586)(data.packet_code)
                    });
                    screenRef.current = data.screen;
                    break;
                case "page_change":
                    urlChangeCallbackRef.current({
                        url: data.url,
                        page_title: data.page_title,
                        plid: data.plid,
                        referrer: data.referrer
                    });
                    setMyId({
                        ...myIdRef.current,
                        visit_id: (0, $8108230355f26483$export$30c606e92a482586)(data.packet_code),
                        page_url: data.url,
                        page_title: data.page_title,
                        plid: data.plid,
                        referrer: data.referrer
                    });
                    break;
                case "cf_events":
                    if (myIdRef.current.supportBot) return;
                    if (scrollCallbackRef.current && data.attributes.kind === "scroll") scrollCallbackRef.current(data.attributes.props.sp);
                    break;
                case "conversation_by_user_id":
                    startConversationWithUserIdRef.current({
                        userID: data.userID
                    });
                    break;
                case "bot_trigger":
                    botTriggerByFlowIdRef.current(data.flow_id);
                    break;
                case "start_voice_call":
                    console.log("start_voice_call", {
                        data: data,
                        woncall: window.retell_on_call
                    });
                    if (window.retell_on_call) {
                        $b858484a41fbde5f$var$retellWebClient.stopCall();
                        window.retell_on_call = false;
                    } else {
                        window.retell_on_call = true;
                        (0, $8108230355f26483$export$20a8a3976e8c41f)({
                            token: token,
                            chatServiceUrl: myIdRef.current.chatServiceUrl,
                            agentID: data.agentID.agentID,
                            direct: data.direct,
                            variables: data.variables
                        }).then((res)=>{
                            $b858484a41fbde5f$var$retellWebClient.startCall({
                                sampleRate: 16000,
                                accessToken: res.data.attributes.access_token,
                                emitRawAudioSamples: true
                            }).then((call)=>{
                                console.log("start call response", call);
                            });
                        });
                    }
                    break;
                case "bot_trigger_id":
                    console.log("triggering " + data.botID);
                    botTriggerByIdRef.current({
                        botID: data.botID,
                        preview: data.preview || false,
                        submissionID: data?.submissionID
                    });
                    break;
                case "play_sound":
                    try {
                        var snd = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($7713d7a73e00e438$exports))));
                        snd.play();
                    } catch (e) {
                        console.log("failed to play alert sound");
                    }
                    break;
                case "visualviewport_size":
                    setVisualViewportSize({
                        height: data.height,
                        offsetTop: data.offsetTop
                    });
                    break;
                case "unwanted_emails":
                    (0, $8108230355f26483$export$6853a7e3417d845d)({
                        chatServiceUrl: myIdRef.current.chatServiceUrl,
                        token: `visitor_${myIdRef.current.id}_${myIdRef.current.packet_code}`
                    });
                    break;
                case "form_fill":
                    (0, $8108230355f26483$export$897f1ec3b6f3514a)({
                        chatServiceUrl: myIdRef.current.chatServiceUrl,
                        token: `visitor_${myIdRef.current.id}_${myIdRef.current.packet_code}`,
                        form_id: data.form_id,
                        pageURL: myIdRef.current.page_url,
                        pageTitle: myIdRef.current.page_title,
                        visitID: myIdRef.current.visit_id
                    });
                    break;
            }
        });
        (0, $8108230355f26483$export$6efe264be9505de7)("activate");
        (0, $8108230355f26483$export$6efe264be9505de7)("show");
    }, []);
    (0, $iluxG.useEffect)(()=>{
        if (myId && !isBadIE) (0, $8108230355f26483$export$21f305c035a18ae3)({
            chatServiceUrl: myId.chatServiceUrl,
            token: token,
            pageURL: myId.page_url,
            packetCode: myId.packet_code,
            referrer: window.document.referrer
        }).then((packet)=>{
            if (!packet) {
                console.log("failed to load welcome packet, aborting");
                return;
            }
            //Sentry.setUser({ id: welcome_packet.data.id })
            if (packet.page_blocked) return;
            if (!$b858484a41fbde5f$var$is_referrer_in_domains(packet.domains)) return;
            if (packet.mobile_disabled) {
                var md = new (0, (/*@__PURE__*/$parcel$interopDefault($e2af0da5ccf1b3dc$exports)))(window.navigator.userAgent);
                const phone = !!md.phone();
                if (phone) return;
            }
            setWelcomePacket(packet);
            if (packet.triggers) (0, $8108230355f26483$export$6efe264be9505de7)("set_triggers", packet.triggers);
            if (packet.ga_setup) (0, $8108230355f26483$export$6efe264be9505de7)("ga_setup", packet.ga_setup);
            (0, $8108230355f26483$export$6efe264be9505de7)("welcome_packet", {
                countryCode: packet.country_code,
                recaptchaV3Key: packet.recaptcha_v3_key,
                recaptchaV2Key: packet.recaptcha_v2_key
            });
        });
    }, [
        myId,
        isBadIE
    ]);
    if (hideApp) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    const showApp = myId && welcomePacket && (masterToggle || myId.mode === "test-drive");
    if (!showApp) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).Fragment, null);
    const storagePrefix = myId?.prefix || "";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $77aa80f10cd3ab0a$export$d053b53cdff1ea07), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $20e2cef96e93dea6$export$2d00a038b309a8fa).Provider, {
        value: browser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $e824f947a4d4ff44$exports.ErrorBoundary), {
        FallbackComponent: (0, $b48bb517e724a338$export$2e2bcd8739ae039),
        onReset: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $3c4ca06cd385c990$export$2e2bcd8739ae039), {
        session_id: myId.id,
        storagePrefix: storagePrefix,
        visit_id: myId.visit_id,
        metaAttributes: myId.meta,
        packet_code: myId.packet_code,
        chatServiceUrl: myId.chatServiceUrl,
        wsURL: welcomePacket?.ws_url,
        preventCriteriaPrompts: myId.preventCriteriaPrompts,
        supportBot: myId.supportBot,
        identity: myId.identity,
        page_load_id: myId.plid,
        page_url: myId.page_url,
        referrer: myId.referrer,
        page_title: myId.page_title,
        screenRef: screenRef,
        botTriggerByFlowIdRef: botTriggerByFlowIdRef,
        botTriggerByIdRef: botTriggerByIdRef,
        startConversationWithUserIdRef: startConversationWithUserIdRef,
        scrollCallbackRef: scrollCallbackRef,
        urlHashCallbackRef: urlChangeCallbackRef,
        autoLoadBotId: myId.auto_load_bot_id,
        submissionID: myId.submissionID,
        debug: myId.debug,
        hide_mode: myId.hide_mode,
        welcomePacket: welcomePacket,
        hideApp: ()=>setHideApp(true),
        unhideApp: ()=>setHideApp(false),
        visualViewportSize: visualViewportSize,
        mode: myId.mode,
        worker: $b858484a41fbde5f$var$worker
    }))));
}
var $b858484a41fbde5f$export$2e2bcd8739ae039 = $b858484a41fbde5f$var$Loader;


/*
import * as Sentry from '@sentry/browser'
let env = 'dev'
if (window.location.hostname === 'beta.chatfunnels.com') {
    env = 'beta'
} else if (window.location.hostname === 'app.chatfunnels.com') {
    env = 'prod'
}

Sentry.init({
    dsn: 'https://583456986bf54409aa75b2535277bfa9@o265885.ingest.sentry.io/5219986',
    environment: env,
    release: 'v1.4.11'
})
*/ (0, (/*@__PURE__*/$parcel$interopDefault($9146dba4fa405fbb$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iluxG))).createElement((0, $b858484a41fbde5f$export$2e2bcd8739ae039), null), document.getElementById("root")) // eslint-disable-line
;


//# sourceMappingURL=index.2f3612ce.js.map
